var D6 = Object.defineProperty;
var j6 = (e, t, n) => t in e ? D6(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ua = (e, t, n) => j6(e, typeof t != "symbol" ? t + "" : t, n);
import * as d from "react";
import He, { isValidElement as wl, cloneElement as Sl, Children as F6, createElement as Cr, useState as So, useMemo as No, useCallback as ns, useLayoutEffect as Y5, useEffect as Rn, useRef as Fs, memo as Jl, forwardRef as Ns, useContext as V6, Component as $6 } from "react";
import xe from "clsx";
import { Global as L6, ThemeContext as Z5, keyframes as si, css as ki, useTheme as A6 } from "@emotion/react";
import { setLightness as Vu, transparentize as Jn, darken as Kr, lighten as Gr } from "polished";
import { darken as Az, lighten as Nz, setLightness as Bz, transparentize as _z } from "polished";
import yo from "@emotion/styled";
import * as N6 from "react-dom";
import Zc, { createPortal as B6 } from "react-dom";
import { useTranslation as ec } from "react-i18next";
import _6, { isEqual as b0 } from "lodash";
import { DateFormat as z6, iconAnalyses as H6, AnalysisTypes as Xo } from "@prometheus/enums";
import { Status as Zs } from "@prometheus/types";
import { t as M1 } from "i18next";
import { formatDate as W6 } from "@prometheus/utils";
var q5 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function G6(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var C0 = { exports: {} }, Ya = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var r2;
function U6() {
  if (r2) return Ya;
  r2 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, i, s) {
    var a = null;
    if (s !== void 0 && (a = "" + s), i.key !== void 0 && (a = "" + i.key), "key" in i) {
      s = {};
      for (var l in i)
        l !== "key" && (s[l] = i[l]);
    } else s = i;
    return i = s.ref, {
      $$typeof: e,
      type: r,
      key: a,
      ref: i !== void 0 ? i : null,
      props: s
    };
  }
  return Ya.Fragment = t, Ya.jsx = n, Ya.jsxs = n, Ya;
}
var Za = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var i2;
function Y6() {
  return i2 || (i2 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(A) {
      if (A == null) return null;
      if (typeof A == "function")
        return A.$$typeof === R ? null : A.displayName || A.name || null;
      if (typeof A == "string") return A;
      switch (A) {
        case m:
          return "Fragment";
        case C:
          return "Profiler";
        case b:
          return "StrictMode";
        case T:
          return "Suspense";
        case P:
          return "SuspenseList";
        case L:
          return "Activity";
      }
      if (typeof A == "object")
        switch (typeof A.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), A.$$typeof) {
          case v:
            return "Portal";
          case S:
            return (A.displayName || "Context") + ".Provider";
          case E:
            return (A._context.displayName || "Context") + ".Consumer";
          case k:
            var Y = A.render;
            return A = A.displayName, A || (A = Y.displayName || Y.name || "", A = A !== "" ? "ForwardRef(" + A + ")" : "ForwardRef"), A;
          case F:
            return Y = A.displayName || null, Y !== null ? Y : e(A.type) || "Memo";
          case j:
            Y = A._payload, A = A._init;
            try {
              return e(A(Y));
            } catch {
            }
        }
      return null;
    }
    function t(A) {
      return "" + A;
    }
    function n(A) {
      try {
        t(A);
        var Y = !1;
      } catch {
        Y = !0;
      }
      if (Y) {
        Y = console;
        var pe = Y.error, Ce = typeof Symbol == "function" && Symbol.toStringTag && A[Symbol.toStringTag] || A.constructor.name || "Object";
        return pe.call(
          Y,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          Ce
        ), t(A);
      }
    }
    function r(A) {
      if (A === m) return "<>";
      if (typeof A == "object" && A !== null && A.$$typeof === j)
        return "<...>";
      try {
        var Y = e(A);
        return Y ? "<" + Y + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var A = V.A;
      return A === null ? null : A.getOwner();
    }
    function s() {
      return Error("react-stack-top-frame");
    }
    function a(A) {
      if (B.call(A, "key")) {
        var Y = Object.getOwnPropertyDescriptor(A, "key").get;
        if (Y && Y.isReactWarning) return !1;
      }
      return A.key !== void 0;
    }
    function l(A, Y) {
      function pe() {
        G || (G = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          Y
        ));
      }
      pe.isReactWarning = !0, Object.defineProperty(A, "key", {
        get: pe,
        configurable: !0
      });
    }
    function c() {
      var A = e(this.type);
      return H[A] || (H[A] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), A = this.props.ref, A !== void 0 ? A : null;
    }
    function u(A, Y, pe, Ce, fe, ee, te, ue) {
      return pe = ee.ref, A = {
        $$typeof: y,
        type: A,
        key: Y,
        props: ee,
        _owner: fe
      }, (pe !== void 0 ? pe : null) !== null ? Object.defineProperty(A, "ref", {
        enumerable: !1,
        get: c
      }) : Object.defineProperty(A, "ref", { enumerable: !1, value: null }), A._store = {}, Object.defineProperty(A._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(A, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(A, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: te
      }), Object.defineProperty(A, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ue
      }), Object.freeze && (Object.freeze(A.props), Object.freeze(A)), A;
    }
    function f(A, Y, pe, Ce, fe, ee, te, ue) {
      var K = Y.children;
      if (K !== void 0)
        if (Ce)
          if (W(K)) {
            for (Ce = 0; Ce < K.length; Ce++)
              g(K[Ce]);
            Object.freeze && Object.freeze(K);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else g(K);
      if (B.call(Y, "key")) {
        K = e(A);
        var oe = Object.keys(Y).filter(function(ve) {
          return ve !== "key";
        });
        Ce = 0 < oe.length ? "{key: someKey, " + oe.join(": ..., ") + ": ...}" : "{key: someKey}", re[K + Ce] || (oe = 0 < oe.length ? "{" + oe.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          Ce,
          K,
          oe,
          K
        ), re[K + Ce] = !0);
      }
      if (K = null, pe !== void 0 && (n(pe), K = "" + pe), a(Y) && (n(Y.key), K = "" + Y.key), "key" in Y) {
        pe = {};
        for (var de in Y)
          de !== "key" && (pe[de] = Y[de]);
      } else pe = Y;
      return K && l(
        pe,
        typeof A == "function" ? A.displayName || A.name || "Unknown" : A
      ), u(
        A,
        K,
        ee,
        fe,
        i(),
        pe,
        te,
        ue
      );
    }
    function g(A) {
      typeof A == "object" && A !== null && A.$$typeof === y && A._store && (A._store.validated = 1);
    }
    var h = He, y = Symbol.for("react.transitional.element"), v = Symbol.for("react.portal"), m = Symbol.for("react.fragment"), b = Symbol.for("react.strict_mode"), C = Symbol.for("react.profiler"), E = Symbol.for("react.consumer"), S = Symbol.for("react.context"), k = Symbol.for("react.forward_ref"), T = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), F = Symbol.for("react.memo"), j = Symbol.for("react.lazy"), L = Symbol.for("react.activity"), R = Symbol.for("react.client.reference"), V = h.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, B = Object.prototype.hasOwnProperty, W = Array.isArray, z = console.createTask ? console.createTask : function() {
      return null;
    };
    h = {
      react_stack_bottom_frame: function(A) {
        return A();
      }
    };
    var G, H = {}, ie = h.react_stack_bottom_frame.bind(
      h,
      s
    )(), ce = z(r(s)), re = {};
    Za.Fragment = m, Za.jsx = function(A, Y, pe, Ce, fe) {
      var ee = 1e4 > V.recentlyCreatedOwnerStacks++;
      return f(
        A,
        Y,
        pe,
        !1,
        Ce,
        fe,
        ee ? Error("react-stack-top-frame") : ie,
        ee ? z(r(A)) : ce
      );
    }, Za.jsxs = function(A, Y, pe, Ce, fe) {
      var ee = 1e4 > V.recentlyCreatedOwnerStacks++;
      return f(
        A,
        Y,
        pe,
        !0,
        Ce,
        fe,
        ee ? Error("react-stack-top-frame") : ie,
        ee ? z(r(A)) : ce
      );
    };
  }()), Za;
}
process.env.NODE_ENV === "production" ? C0.exports = U6() : C0.exports = Y6();
var p = C0.exports;
const Ll = {
  black: "#000",
  white: "#fff"
}, qs = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Ks = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, Xs = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, Qs = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, Js = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
}, qa = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, Z6 = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function ei(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
const Sr = "$$material";
function q6(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var K6 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function X6(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Q6 = /[A-Z]|^ms/g, J6 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, K5 = function(t) {
  return t.charCodeAt(1) === 45;
}, s2 = function(t) {
  return t != null && typeof t != "boolean";
}, k1 = /* @__PURE__ */ X6(function(e) {
  return K5(e) ? e : e.replace(Q6, "-$&").toLowerCase();
}), a2 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(J6, function(r, i, s) {
          return qi = {
            name: i,
            styles: s,
            next: qi
          }, i;
        });
  }
  return K6[t] !== 1 && !K5(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function $u(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return qi = {
          name: i.name,
          styles: i.styles,
          next: qi
        }, i.name;
      var s = n;
      if (s.styles !== void 0) {
        var a = s.next;
        if (a !== void 0)
          for (; a !== void 0; )
            qi = {
              name: a.name,
              styles: a.styles,
              next: qi
            }, a = a.next;
        var l = s.styles + ";";
        return l;
      }
      return e7(e, t, n);
    }
  }
  var c = n;
  return c;
}
function e7(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += $u(e, t, n[i]) + ";";
  else
    for (var s in n) {
      var a = n[s];
      if (typeof a != "object") {
        var l = a;
        s2(l) && (r += k1(s) + ":" + a2(s, l) + ";");
      } else if (Array.isArray(a) && typeof a[0] == "string" && t == null)
        for (var c = 0; c < a.length; c++)
          s2(a[c]) && (r += k1(s) + ":" + a2(s, a[c]) + ";");
      else {
        var u = $u(e, t, a);
        switch (s) {
          case "animation":
          case "animationName": {
            r += k1(s) + ":" + u + ";";
            break;
          }
          default:
            r += s + "{" + u + "}";
        }
      }
    }
  return r;
}
var l2 = /label:\s*([^\s;{]+)\s*(;|$)/g, qi;
function t7(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  qi = void 0;
  var s = e[0];
  if (s == null || s.raw === void 0)
    r = !1, i += $u(n, t, s);
  else {
    var a = s;
    i += a[0];
  }
  for (var l = 1; l < e.length; l++)
    if (i += $u(n, t, e[l]), r) {
      var c = s;
      i += c[l];
    }
  l2.lastIndex = 0;
  for (var u = "", f; (f = l2.exec(i)) !== null; )
    u += "-" + f[1];
  var g = q6(i) + u;
  return {
    name: g,
    styles: i,
    next: qi
  };
}
var x0 = { exports: {} }, qc = { exports: {} }, $n = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c2;
function n7() {
  if (c2) return $n;
  c2 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function S(T) {
    if (typeof T == "object" && T !== null) {
      var P = T.$$typeof;
      switch (P) {
        case t:
          switch (T = T.type, T) {
            case c:
            case u:
            case r:
            case s:
            case i:
            case g:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case l:
                case f:
                case v:
                case y:
                case a:
                  return T;
                default:
                  return P;
              }
          }
        case n:
          return P;
      }
    }
  }
  function k(T) {
    return S(T) === u;
  }
  return $n.AsyncMode = c, $n.ConcurrentMode = u, $n.ContextConsumer = l, $n.ContextProvider = a, $n.Element = t, $n.ForwardRef = f, $n.Fragment = r, $n.Lazy = v, $n.Memo = y, $n.Portal = n, $n.Profiler = s, $n.StrictMode = i, $n.Suspense = g, $n.isAsyncMode = function(T) {
    return k(T) || S(T) === c;
  }, $n.isConcurrentMode = k, $n.isContextConsumer = function(T) {
    return S(T) === l;
  }, $n.isContextProvider = function(T) {
    return S(T) === a;
  }, $n.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === t;
  }, $n.isForwardRef = function(T) {
    return S(T) === f;
  }, $n.isFragment = function(T) {
    return S(T) === r;
  }, $n.isLazy = function(T) {
    return S(T) === v;
  }, $n.isMemo = function(T) {
    return S(T) === y;
  }, $n.isPortal = function(T) {
    return S(T) === n;
  }, $n.isProfiler = function(T) {
    return S(T) === s;
  }, $n.isStrictMode = function(T) {
    return S(T) === i;
  }, $n.isSuspense = function(T) {
    return S(T) === g;
  }, $n.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === r || T === u || T === s || T === i || T === g || T === h || typeof T == "object" && T !== null && (T.$$typeof === v || T.$$typeof === y || T.$$typeof === a || T.$$typeof === l || T.$$typeof === f || T.$$typeof === b || T.$$typeof === C || T.$$typeof === E || T.$$typeof === m);
  }, $n.typeOf = S, $n;
}
var Ln = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var u2;
function o7() {
  return u2 || (u2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function S(J) {
      return typeof J == "string" || typeof J == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      J === r || J === u || J === s || J === i || J === g || J === h || typeof J == "object" && J !== null && (J.$$typeof === v || J.$$typeof === y || J.$$typeof === a || J.$$typeof === l || J.$$typeof === f || J.$$typeof === b || J.$$typeof === C || J.$$typeof === E || J.$$typeof === m);
    }
    function k(J) {
      if (typeof J == "object" && J !== null) {
        var se = J.$$typeof;
        switch (se) {
          case t:
            var ge = J.type;
            switch (ge) {
              case c:
              case u:
              case r:
              case s:
              case i:
              case g:
                return ge;
              default:
                var Se = ge && ge.$$typeof;
                switch (Se) {
                  case l:
                  case f:
                  case v:
                  case y:
                  case a:
                    return Se;
                  default:
                    return se;
                }
            }
          case n:
            return se;
        }
      }
    }
    var T = c, P = u, F = l, j = a, L = t, R = f, V = r, B = v, W = y, z = n, G = s, H = i, ie = g, ce = !1;
    function re(J) {
      return ce || (ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(J) || k(J) === c;
    }
    function A(J) {
      return k(J) === u;
    }
    function Y(J) {
      return k(J) === l;
    }
    function pe(J) {
      return k(J) === a;
    }
    function Ce(J) {
      return typeof J == "object" && J !== null && J.$$typeof === t;
    }
    function fe(J) {
      return k(J) === f;
    }
    function ee(J) {
      return k(J) === r;
    }
    function te(J) {
      return k(J) === v;
    }
    function ue(J) {
      return k(J) === y;
    }
    function K(J) {
      return k(J) === n;
    }
    function oe(J) {
      return k(J) === s;
    }
    function de(J) {
      return k(J) === i;
    }
    function ve(J) {
      return k(J) === g;
    }
    Ln.AsyncMode = T, Ln.ConcurrentMode = P, Ln.ContextConsumer = F, Ln.ContextProvider = j, Ln.Element = L, Ln.ForwardRef = R, Ln.Fragment = V, Ln.Lazy = B, Ln.Memo = W, Ln.Portal = z, Ln.Profiler = G, Ln.StrictMode = H, Ln.Suspense = ie, Ln.isAsyncMode = re, Ln.isConcurrentMode = A, Ln.isContextConsumer = Y, Ln.isContextProvider = pe, Ln.isElement = Ce, Ln.isForwardRef = fe, Ln.isFragment = ee, Ln.isLazy = te, Ln.isMemo = ue, Ln.isPortal = K, Ln.isProfiler = oe, Ln.isStrictMode = de, Ln.isSuspense = ve, Ln.isValidElementType = S, Ln.typeOf = k;
  }()), Ln;
}
var d2;
function X5() {
  return d2 || (d2 = 1, process.env.NODE_ENV === "production" ? qc.exports = n7() : qc.exports = o7()), qc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var P1, p2;
function r7() {
  if (p2) return P1;
  p2 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var a = {}, l = 0; l < 10; l++)
        a["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        u[f] = f;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return P1 = i() ? Object.assign : function(s, a) {
    for (var l, c = r(s), u, f = 1; f < arguments.length; f++) {
      l = Object(arguments[f]);
      for (var g in l)
        t.call(l, g) && (c[g] = l[g]);
      if (e) {
        u = e(l);
        for (var h = 0; h < u.length; h++)
          n.call(l, u[h]) && (c[u[h]] = l[u[h]]);
      }
    }
    return c;
  }, P1;
}
var I1, f2;
function dp() {
  if (f2) return I1;
  f2 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return I1 = e, I1;
}
var O1, g2;
function Q5() {
  return g2 || (g2 = 1, O1 = Function.call.bind(Object.prototype.hasOwnProperty)), O1;
}
var D1, m2;
function i7() {
  if (m2) return D1;
  m2 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = dp(), n = {}, r = Q5();
    e = function(s) {
      var a = "Warning: " + s;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(s, a, l, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in s)
        if (r(s, f)) {
          var g;
          try {
            if (typeof s[f] != "function") {
              var h = Error(
                (c || "React class") + ": " + l + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            g = s[f](a, f, c, l, null, t);
          } catch (v) {
            g = v;
          }
          if (g && !(g instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof g + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), g instanceof Error && !(g.message in n)) {
            n[g.message] = !0;
            var y = u ? u() : "";
            e(
              "Failed " + l + " type: " + g.message + (y ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, D1 = i, D1;
}
var j1, h2;
function s7() {
  if (h2) return j1;
  h2 = 1;
  var e = X5(), t = r7(), n = dp(), r = Q5(), i = i7(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return j1 = function(l, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function g(A) {
      var Y = A && (u && A[u] || A[f]);
      if (typeof Y == "function")
        return Y;
    }
    var h = "<<anonymous>>", y = {
      array: C("array"),
      bigint: C("bigint"),
      bool: C("boolean"),
      func: C("function"),
      number: C("number"),
      object: C("object"),
      string: C("string"),
      symbol: C("symbol"),
      any: E(),
      arrayOf: S,
      element: k(),
      elementType: T(),
      instanceOf: P,
      node: R(),
      objectOf: j,
      oneOf: F,
      oneOfType: L,
      shape: B,
      exact: W
    };
    function v(A, Y) {
      return A === Y ? A !== 0 || 1 / A === 1 / Y : A !== A && Y !== Y;
    }
    function m(A, Y) {
      this.message = A, this.data = Y && typeof Y == "object" ? Y : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function b(A) {
      if (process.env.NODE_ENV !== "production")
        var Y = {}, pe = 0;
      function Ce(ee, te, ue, K, oe, de, ve) {
        if (K = K || h, de = de || ue, ve !== n) {
          if (c) {
            var J = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw J.name = "Invariant Violation", J;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var se = K + ":" + ue;
            !Y[se] && // Avoid spamming the console because they are often not actionable except for lib authors
            pe < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + de + "` prop on `" + K + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Y[se] = !0, pe++);
          }
        }
        return te[ue] == null ? ee ? te[ue] === null ? new m("The " + oe + " `" + de + "` is marked as required " + ("in `" + K + "`, but its value is `null`.")) : new m("The " + oe + " `" + de + "` is marked as required in " + ("`" + K + "`, but its value is `undefined`.")) : null : A(te, ue, K, oe, de);
      }
      var fe = Ce.bind(null, !1);
      return fe.isRequired = Ce.bind(null, !0), fe;
    }
    function C(A) {
      function Y(pe, Ce, fe, ee, te, ue) {
        var K = pe[Ce], oe = H(K);
        if (oe !== A) {
          var de = ie(K);
          return new m(
            "Invalid " + ee + " `" + te + "` of type " + ("`" + de + "` supplied to `" + fe + "`, expected ") + ("`" + A + "`."),
            { expectedType: A }
          );
        }
        return null;
      }
      return b(Y);
    }
    function E() {
      return b(a);
    }
    function S(A) {
      function Y(pe, Ce, fe, ee, te) {
        if (typeof A != "function")
          return new m("Property `" + te + "` of component `" + fe + "` has invalid PropType notation inside arrayOf.");
        var ue = pe[Ce];
        if (!Array.isArray(ue)) {
          var K = H(ue);
          return new m("Invalid " + ee + " `" + te + "` of type " + ("`" + K + "` supplied to `" + fe + "`, expected an array."));
        }
        for (var oe = 0; oe < ue.length; oe++) {
          var de = A(ue, oe, fe, ee, te + "[" + oe + "]", n);
          if (de instanceof Error)
            return de;
        }
        return null;
      }
      return b(Y);
    }
    function k() {
      function A(Y, pe, Ce, fe, ee) {
        var te = Y[pe];
        if (!l(te)) {
          var ue = H(te);
          return new m("Invalid " + fe + " `" + ee + "` of type " + ("`" + ue + "` supplied to `" + Ce + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(A);
    }
    function T() {
      function A(Y, pe, Ce, fe, ee) {
        var te = Y[pe];
        if (!e.isValidElementType(te)) {
          var ue = H(te);
          return new m("Invalid " + fe + " `" + ee + "` of type " + ("`" + ue + "` supplied to `" + Ce + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(A);
    }
    function P(A) {
      function Y(pe, Ce, fe, ee, te) {
        if (!(pe[Ce] instanceof A)) {
          var ue = A.name || h, K = re(pe[Ce]);
          return new m("Invalid " + ee + " `" + te + "` of type " + ("`" + K + "` supplied to `" + fe + "`, expected ") + ("instance of `" + ue + "`."));
        }
        return null;
      }
      return b(Y);
    }
    function F(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), a;
      function Y(pe, Ce, fe, ee, te) {
        for (var ue = pe[Ce], K = 0; K < A.length; K++)
          if (v(ue, A[K]))
            return null;
        var oe = JSON.stringify(A, function(ve, J) {
          var se = ie(J);
          return se === "symbol" ? String(J) : J;
        });
        return new m("Invalid " + ee + " `" + te + "` of value `" + String(ue) + "` " + ("supplied to `" + fe + "`, expected one of " + oe + "."));
      }
      return b(Y);
    }
    function j(A) {
      function Y(pe, Ce, fe, ee, te) {
        if (typeof A != "function")
          return new m("Property `" + te + "` of component `" + fe + "` has invalid PropType notation inside objectOf.");
        var ue = pe[Ce], K = H(ue);
        if (K !== "object")
          return new m("Invalid " + ee + " `" + te + "` of type " + ("`" + K + "` supplied to `" + fe + "`, expected an object."));
        for (var oe in ue)
          if (r(ue, oe)) {
            var de = A(ue, oe, fe, ee, te + "." + oe, n);
            if (de instanceof Error)
              return de;
          }
        return null;
      }
      return b(Y);
    }
    function L(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var Y = 0; Y < A.length; Y++) {
        var pe = A[Y];
        if (typeof pe != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ce(pe) + " at index " + Y + "."
          ), a;
      }
      function Ce(fe, ee, te, ue, K) {
        for (var oe = [], de = 0; de < A.length; de++) {
          var ve = A[de], J = ve(fe, ee, te, ue, K, n);
          if (J == null)
            return null;
          J.data && r(J.data, "expectedType") && oe.push(J.data.expectedType);
        }
        var se = oe.length > 0 ? ", expected one of type [" + oe.join(", ") + "]" : "";
        return new m("Invalid " + ue + " `" + K + "` supplied to " + ("`" + te + "`" + se + "."));
      }
      return b(Ce);
    }
    function R() {
      function A(Y, pe, Ce, fe, ee) {
        return z(Y[pe]) ? null : new m("Invalid " + fe + " `" + ee + "` supplied to " + ("`" + Ce + "`, expected a ReactNode."));
      }
      return b(A);
    }
    function V(A, Y, pe, Ce, fe) {
      return new m(
        (A || "React class") + ": " + Y + " type `" + pe + "." + Ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + fe + "`."
      );
    }
    function B(A) {
      function Y(pe, Ce, fe, ee, te) {
        var ue = pe[Ce], K = H(ue);
        if (K !== "object")
          return new m("Invalid " + ee + " `" + te + "` of type `" + K + "` " + ("supplied to `" + fe + "`, expected `object`."));
        for (var oe in A) {
          var de = A[oe];
          if (typeof de != "function")
            return V(fe, ee, te, oe, ie(de));
          var ve = de(ue, oe, fe, ee, te + "." + oe, n);
          if (ve)
            return ve;
        }
        return null;
      }
      return b(Y);
    }
    function W(A) {
      function Y(pe, Ce, fe, ee, te) {
        var ue = pe[Ce], K = H(ue);
        if (K !== "object")
          return new m("Invalid " + ee + " `" + te + "` of type `" + K + "` " + ("supplied to `" + fe + "`, expected `object`."));
        var oe = t({}, pe[Ce], A);
        for (var de in oe) {
          var ve = A[de];
          if (r(A, de) && typeof ve != "function")
            return V(fe, ee, te, de, ie(ve));
          if (!ve)
            return new m(
              "Invalid " + ee + " `" + te + "` key `" + de + "` supplied to `" + fe + "`.\nBad object: " + JSON.stringify(pe[Ce], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
            );
          var J = ve(ue, de, fe, ee, te + "." + de, n);
          if (J)
            return J;
        }
        return null;
      }
      return b(Y);
    }
    function z(A) {
      switch (typeof A) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !A;
        case "object":
          if (Array.isArray(A))
            return A.every(z);
          if (A === null || l(A))
            return !0;
          var Y = g(A);
          if (Y) {
            var pe = Y.call(A), Ce;
            if (Y !== A.entries) {
              for (; !(Ce = pe.next()).done; )
                if (!z(Ce.value))
                  return !1;
            } else
              for (; !(Ce = pe.next()).done; ) {
                var fe = Ce.value;
                if (fe && !z(fe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function G(A, Y) {
      return A === "symbol" ? !0 : Y ? Y["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Y instanceof Symbol : !1;
    }
    function H(A) {
      var Y = typeof A;
      return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : G(Y, A) ? "symbol" : Y;
    }
    function ie(A) {
      if (typeof A > "u" || A === null)
        return "" + A;
      var Y = H(A);
      if (Y === "object") {
        if (A instanceof Date)
          return "date";
        if (A instanceof RegExp)
          return "regexp";
      }
      return Y;
    }
    function ce(A) {
      var Y = ie(A);
      switch (Y) {
        case "array":
        case "object":
          return "an " + Y;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Y;
        default:
          return Y;
      }
    }
    function re(A) {
      return !A.constructor || !A.constructor.name ? h : A.constructor.name;
    }
    return y.checkPropTypes = i, y.resetWarningCache = i.resetWarningCache, y.PropTypes = y, y;
  }, j1;
}
var F1, v2;
function a7() {
  if (v2) return F1;
  v2 = 1;
  var e = dp();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, F1 = function() {
    function r(a, l, c, u, f, g) {
      if (g !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, F1;
}
if (process.env.NODE_ENV !== "production") {
  var l7 = X5(), c7 = !0;
  x0.exports = s7()(l7.isElement, c7);
} else
  x0.exports = a7()();
var u7 = x0.exports;
const o = /* @__PURE__ */ G6(u7);
function d7(e) {
  return e == null || Object.keys(e).length === 0;
}
function pp(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, r = typeof t == "function" ? (i) => t(d7(i) ? n : i) : t;
  return /* @__PURE__ */ p.jsx(L6, {
    styles: r
  });
}
process.env.NODE_ENV !== "production" && (pp.propTypes = {
  defaultTheme: o.object,
  styles: o.oneOfType([o.array, o.string, o.object, o.func])
});
/**
 * @mui/styled-engine v6.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function J5(e, t) {
  const n = yo(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const i = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${i})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((s) => s === void 0) && console.error(`MUI: the styled(${i})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
function p7(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const y2 = [];
function Ji(e) {
  return y2[0] = e, t7(y2);
}
var w0 = { exports: {} }, Bn = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b2;
function f7() {
  if (b2) return Bn;
  b2 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), h = Symbol.for("react.view_transition"), y = Symbol.for("react.client.reference");
  function v(m) {
    if (typeof m == "object" && m !== null) {
      var b = m.$$typeof;
      switch (b) {
        case e:
          switch (m = m.type, m) {
            case n:
            case i:
            case r:
            case c:
            case u:
            case h:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case a:
                case l:
                case g:
                case f:
                  return m;
                case s:
                  return m;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return Bn.ContextConsumer = s, Bn.ContextProvider = a, Bn.Element = e, Bn.ForwardRef = l, Bn.Fragment = n, Bn.Lazy = g, Bn.Memo = f, Bn.Portal = t, Bn.Profiler = i, Bn.StrictMode = r, Bn.Suspense = c, Bn.SuspenseList = u, Bn.isContextConsumer = function(m) {
    return v(m) === s;
  }, Bn.isContextProvider = function(m) {
    return v(m) === a;
  }, Bn.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, Bn.isForwardRef = function(m) {
    return v(m) === l;
  }, Bn.isFragment = function(m) {
    return v(m) === n;
  }, Bn.isLazy = function(m) {
    return v(m) === g;
  }, Bn.isMemo = function(m) {
    return v(m) === f;
  }, Bn.isPortal = function(m) {
    return v(m) === t;
  }, Bn.isProfiler = function(m) {
    return v(m) === i;
  }, Bn.isStrictMode = function(m) {
    return v(m) === r;
  }, Bn.isSuspense = function(m) {
    return v(m) === c;
  }, Bn.isSuspenseList = function(m) {
    return v(m) === u;
  }, Bn.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === i || m === r || m === c || m === u || typeof m == "object" && m !== null && (m.$$typeof === g || m.$$typeof === f || m.$$typeof === a || m.$$typeof === s || m.$$typeof === l || m.$$typeof === y || m.getModuleId !== void 0);
  }, Bn.typeOf = v, Bn;
}
var _n = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C2;
function g7() {
  return C2 || (C2 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(m) {
      if (typeof m == "object" && m !== null) {
        var b = m.$$typeof;
        switch (b) {
          case t:
            switch (m = m.type, m) {
              case r:
              case s:
              case i:
              case u:
              case f:
              case y:
                return m;
              default:
                switch (m = m && m.$$typeof, m) {
                  case l:
                  case c:
                  case h:
                  case g:
                    return m;
                  case a:
                    return m;
                  default:
                    return b;
                }
            }
          case n:
            return b;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.view_transition"), v = Symbol.for("react.client.reference");
    _n.ContextConsumer = a, _n.ContextProvider = l, _n.Element = t, _n.ForwardRef = c, _n.Fragment = r, _n.Lazy = h, _n.Memo = g, _n.Portal = n, _n.Profiler = s, _n.StrictMode = i, _n.Suspense = u, _n.SuspenseList = f, _n.isContextConsumer = function(m) {
      return e(m) === a;
    }, _n.isContextProvider = function(m) {
      return e(m) === l;
    }, _n.isElement = function(m) {
      return typeof m == "object" && m !== null && m.$$typeof === t;
    }, _n.isForwardRef = function(m) {
      return e(m) === c;
    }, _n.isFragment = function(m) {
      return e(m) === r;
    }, _n.isLazy = function(m) {
      return e(m) === h;
    }, _n.isMemo = function(m) {
      return e(m) === g;
    }, _n.isPortal = function(m) {
      return e(m) === n;
    }, _n.isProfiler = function(m) {
      return e(m) === s;
    }, _n.isStrictMode = function(m) {
      return e(m) === i;
    }, _n.isSuspense = function(m) {
      return e(m) === u;
    }, _n.isSuspenseList = function(m) {
      return e(m) === f;
    }, _n.isValidElementType = function(m) {
      return typeof m == "string" || typeof m == "function" || m === r || m === s || m === i || m === u || m === f || typeof m == "object" && m !== null && (m.$$typeof === h || m.$$typeof === g || m.$$typeof === l || m.$$typeof === a || m.$$typeof === c || m.$$typeof === v || m.getModuleId !== void 0);
    }, _n.typeOf = e;
  }()), _n;
}
process.env.NODE_ENV === "production" ? w0.exports = f7() : w0.exports = g7();
var Pi = w0.exports;
function Zr(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function e4(e) {
  if (/* @__PURE__ */ d.isValidElement(e) || Pi.isValidElementType(e) || !Zr(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = e4(e[n]);
  }), t;
}
function Bo(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Zr(e) && Zr(t) && Object.keys(t).forEach((i) => {
    /* @__PURE__ */ d.isValidElement(t[i]) || Pi.isValidElementType(t[i]) ? r[i] = t[i] : Zr(t[i]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, i) && Zr(e[i]) ? r[i] = Bo(e[i], t[i], n) : n.clone ? r[i] = Zr(t[i]) ? e4(t[i]) : t[i] : r[i] = t[i];
  }), r;
}
const m7 = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function h7(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...i
  } = e, s = m7(t), a = Object.keys(s);
  function l(h) {
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n})`;
  }
  function c(h) {
    return `@media (max-width:${(typeof t[h] == "number" ? t[h] : h) - r / 100}${n})`;
  }
  function u(h, y) {
    const v = a.indexOf(y);
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n}) and (max-width:${(v !== -1 && typeof t[a[v]] == "number" ? t[a[v]] : y) - r / 100}${n})`;
  }
  function f(h) {
    return a.indexOf(h) + 1 < a.length ? u(h, a[a.indexOf(h) + 1]) : l(h);
  }
  function g(h) {
    const y = a.indexOf(h);
    return y === 0 ? l(a[1]) : y === a.length - 1 ? c(a[y]) : u(h, a[a.indexOf(h) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: a,
    values: s,
    up: l,
    down: c,
    between: u,
    only: f,
    not: g,
    unit: n,
    ...i
  };
}
function x2(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, i) => {
    var a, l;
    const s = /min-width:\s*([0-9.]+)/;
    return +(((a = r.match(s)) == null ? void 0 : a[1]) || 0) - +(((l = i.match(s)) == null ? void 0 : l[1]) || 0);
  });
  return n.length ? n.reduce((r, i) => {
    const s = t[i];
    return delete r[i], r[i] = s, r;
  }, {
    ...t
  }) : t;
}
function v7(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function y7(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : ei(18, `(${t})`));
    return null;
  }
  const [, r, i] = n, s = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(i).up(s);
}
function b7(e) {
  const t = (s, a) => s.replace("@media", a ? `@container ${a}` : "@container");
  function n(s, a) {
    s.up = (...l) => t(e.breakpoints.up(...l), a), s.down = (...l) => t(e.breakpoints.down(...l), a), s.between = (...l) => t(e.breakpoints.between(...l), a), s.only = (...l) => t(e.breakpoints.only(...l), a), s.not = (...l) => {
      const c = t(e.breakpoints.not(...l), a);
      return c.includes("not all and") ? c.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : c;
    };
  }
  const r = {}, i = (s) => (n(r, s), r);
  return n(i), {
    ...e,
    containerQueries: i
  };
}
const C7 = {
  borderRadius: 4
}, ls = process.env.NODE_ENV !== "production" ? o.oneOfType([o.number, o.string, o.object, o.array]) : {};
function El(e, t) {
  return t ? Bo(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const sd = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, w2 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${sd[e]}px)`
}, x7 = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : sd[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function Rr(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const s = r.breakpoints || w2;
    return t.reduce((a, l, c) => (a[s.up(s.keys[c])] = n(t[c]), a), {});
  }
  if (typeof t == "object") {
    const s = r.breakpoints || w2;
    return Object.keys(t).reduce((a, l) => {
      if (v7(s.keys, l)) {
        const c = y7(r.containerQueries ? r : x7, l);
        c && (a[c] = n(t[l], l));
      } else if (Object.keys(s.values || sd).includes(l)) {
        const c = s.up(l);
        a[c] = n(t[l], l);
      } else {
        const c = l;
        a[c] = t[c];
      }
      return a;
    }, {});
  }
  return n(t);
}
function w7(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, i) => {
    const s = e.up(i);
    return r[s] = {}, r;
  }, {})) || {};
}
function S2(e, t) {
  return e.reduce((n, r) => {
    const i = n[r];
    return (!i || Object.keys(i).length === 0) && delete n[r], n;
  }, t);
}
function S7(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, r = Object.keys(t);
  return Array.isArray(e) ? r.forEach((i, s) => {
    s < e.length && (n[i] = !0);
  }) : r.forEach((i) => {
    e[i] != null && (n[i] = !0);
  }), n;
}
function ad({
  values: e,
  breakpoints: t,
  base: n
}) {
  const r = n || S7(e, t), i = Object.keys(r);
  if (i.length === 0)
    return e;
  let s;
  return i.reduce((a, l, c) => (Array.isArray(e) ? (a[l] = e[c] != null ? e[c] : e[s], s = c) : typeof e == "object" ? (a[l] = e[l] != null ? e[l] : e[s], s = l) : a[l] = e, a), {});
}
function be(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : ei(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function ld(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((i, s) => i && i[s] ? i[s] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, i) => r && r[i] != null ? r[i] : null, e);
}
function Lu(e, t, n, r = n) {
  let i;
  return typeof e == "function" ? i = e(n) : Array.isArray(e) ? i = e[n] || r : i = ld(e, n) || r, t && (i = t(i, r, e)), i;
}
function xo(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: i
  } = e, s = (a) => {
    if (a[t] == null)
      return null;
    const l = a[t], c = a.theme, u = ld(c, r) || {};
    return Rr(a, l, (g) => {
      let h = Lu(u, i, g);
      return g === h && typeof g == "string" && (h = Lu(u, i, `${t}${g === "default" ? "" : be(g)}`, g)), n === !1 ? h : {
        [n]: h
      };
    });
  };
  return s.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: ls
  } : {}, s.filterProps = [t], s;
}
function E7(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const R7 = {
  m: "margin",
  p: "padding"
}, T7 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, E2 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, M7 = E7((e) => {
  if (e.length > 2)
    if (E2[e])
      e = E2[e];
    else
      return [e];
  const [t, n] = e.split(""), r = R7[t], i = T7[n] || "";
  return Array.isArray(i) ? i.map((s) => r + s) : [r + i];
}), cd = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], ud = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], k7 = [...cd, ...ud];
function tc(e, t, n, r) {
  const i = ld(e, t, !0) ?? n;
  return typeof i == "number" || typeof i == "string" ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && typeof s != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${s}.`), typeof i == "string" ? `calc(${s} * ${i})` : i * s) : Array.isArray(i) ? (s) => {
    if (typeof s == "string")
      return s;
    const a = Math.abs(s);
    process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > i.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${a} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const l = i[a];
    return s >= 0 ? l : typeof l == "number" ? -l : `-${l}`;
  } : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function fp(e) {
  return tc(e, "spacing", 8, "spacing");
}
function nc(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function P7(e, t) {
  return (n) => e.reduce((r, i) => (r[i] = nc(t, n), r), {});
}
function I7(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const i = M7(n), s = P7(i, r), a = e[n];
  return Rr(e, a, s);
}
function t4(e, t) {
  const n = fp(e.theme);
  return Object.keys(e).map((r) => I7(e, t, r, n)).reduce(El, {});
}
function mo(e) {
  return t4(e, cd);
}
mo.propTypes = process.env.NODE_ENV !== "production" ? cd.reduce((e, t) => (e[t] = ls, e), {}) : {};
mo.filterProps = cd;
function ho(e) {
  return t4(e, ud);
}
ho.propTypes = process.env.NODE_ENV !== "production" ? ud.reduce((e, t) => (e[t] = ls, e), {}) : {};
ho.filterProps = ud;
process.env.NODE_ENV !== "production" && k7.reduce((e, t) => (e[t] = ls, e), {});
function n4(e = 8, t = fp({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((s) => {
    const a = t(s);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" "));
  return n.mui = !0, n;
}
function dd(...e) {
  const t = e.reduce((r, i) => (i.filterProps.forEach((s) => {
    r[s] = i;
  }), r), {}), n = (r) => Object.keys(r).reduce((i, s) => t[s] ? El(i, t[s](r)) : i, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, i) => Object.assign(r, i.propTypes), {}) : {}, n.filterProps = e.reduce((r, i) => r.concat(i.filterProps), []), n;
}
function yr(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Ir(e, t) {
  return xo({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const O7 = Ir("border", yr), D7 = Ir("borderTop", yr), j7 = Ir("borderRight", yr), F7 = Ir("borderBottom", yr), V7 = Ir("borderLeft", yr), $7 = Ir("borderColor"), L7 = Ir("borderTopColor"), A7 = Ir("borderRightColor"), N7 = Ir("borderBottomColor"), B7 = Ir("borderLeftColor"), _7 = Ir("outline", yr), z7 = Ir("outlineColor"), pd = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = tc(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: nc(t, r)
    });
    return Rr(e, e.borderRadius, n);
  }
  return null;
};
pd.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: ls
} : {};
pd.filterProps = ["borderRadius"];
dd(O7, D7, j7, F7, V7, $7, L7, A7, N7, B7, pd, _7, z7);
const fd = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = tc(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: nc(t, r)
    });
    return Rr(e, e.gap, n);
  }
  return null;
};
fd.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: ls
} : {};
fd.filterProps = ["gap"];
const gd = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = tc(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: nc(t, r)
    });
    return Rr(e, e.columnGap, n);
  }
  return null;
};
gd.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: ls
} : {};
gd.filterProps = ["columnGap"];
const md = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = tc(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: nc(t, r)
    });
    return Rr(e, e.rowGap, n);
  }
  return null;
};
md.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: ls
} : {};
md.filterProps = ["rowGap"];
const H7 = xo({
  prop: "gridColumn"
}), W7 = xo({
  prop: "gridRow"
}), G7 = xo({
  prop: "gridAutoFlow"
}), U7 = xo({
  prop: "gridAutoColumns"
}), Y7 = xo({
  prop: "gridAutoRows"
}), Z7 = xo({
  prop: "gridTemplateColumns"
}), q7 = xo({
  prop: "gridTemplateRows"
}), K7 = xo({
  prop: "gridTemplateAreas"
}), X7 = xo({
  prop: "gridArea"
});
dd(fd, gd, md, H7, W7, G7, U7, Y7, Z7, q7, K7, X7);
function fa(e, t) {
  return t === "grey" ? t : e;
}
const Q7 = xo({
  prop: "color",
  themeKey: "palette",
  transform: fa
}), J7 = xo({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: fa
}), e8 = xo({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: fa
});
dd(Q7, J7, e8);
function lr(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const t8 = xo({
  prop: "width",
  transform: lr
}), gp = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var i, s, a, l, c;
      const r = ((a = (s = (i = e.theme) == null ? void 0 : i.breakpoints) == null ? void 0 : s.values) == null ? void 0 : a[n]) || sd[n];
      return r ? ((c = (l = e.theme) == null ? void 0 : l.breakpoints) == null ? void 0 : c.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: lr(n)
      };
    };
    return Rr(e, e.maxWidth, t);
  }
  return null;
};
gp.filterProps = ["maxWidth"];
const n8 = xo({
  prop: "minWidth",
  transform: lr
}), o8 = xo({
  prop: "height",
  transform: lr
}), r8 = xo({
  prop: "maxHeight",
  transform: lr
}), i8 = xo({
  prop: "minHeight",
  transform: lr
});
xo({
  prop: "size",
  cssProperty: "width",
  transform: lr
});
xo({
  prop: "size",
  cssProperty: "height",
  transform: lr
});
const s8 = xo({
  prop: "boxSizing"
});
dd(t8, gp, n8, o8, r8, i8, s8);
const oc = {
  // borders
  border: {
    themeKey: "borders",
    transform: yr
  },
  borderTop: {
    themeKey: "borders",
    transform: yr
  },
  borderRight: {
    themeKey: "borders",
    transform: yr
  },
  borderBottom: {
    themeKey: "borders",
    transform: yr
  },
  borderLeft: {
    themeKey: "borders",
    transform: yr
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: yr
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: pd
  },
  // palette
  color: {
    themeKey: "palette",
    transform: fa
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: fa
  },
  backgroundColor: {
    themeKey: "palette",
    transform: fa
  },
  // spacing
  p: {
    style: ho
  },
  pt: {
    style: ho
  },
  pr: {
    style: ho
  },
  pb: {
    style: ho
  },
  pl: {
    style: ho
  },
  px: {
    style: ho
  },
  py: {
    style: ho
  },
  padding: {
    style: ho
  },
  paddingTop: {
    style: ho
  },
  paddingRight: {
    style: ho
  },
  paddingBottom: {
    style: ho
  },
  paddingLeft: {
    style: ho
  },
  paddingX: {
    style: ho
  },
  paddingY: {
    style: ho
  },
  paddingInline: {
    style: ho
  },
  paddingInlineStart: {
    style: ho
  },
  paddingInlineEnd: {
    style: ho
  },
  paddingBlock: {
    style: ho
  },
  paddingBlockStart: {
    style: ho
  },
  paddingBlockEnd: {
    style: ho
  },
  m: {
    style: mo
  },
  mt: {
    style: mo
  },
  mr: {
    style: mo
  },
  mb: {
    style: mo
  },
  ml: {
    style: mo
  },
  mx: {
    style: mo
  },
  my: {
    style: mo
  },
  margin: {
    style: mo
  },
  marginTop: {
    style: mo
  },
  marginRight: {
    style: mo
  },
  marginBottom: {
    style: mo
  },
  marginLeft: {
    style: mo
  },
  marginX: {
    style: mo
  },
  marginY: {
    style: mo
  },
  marginInline: {
    style: mo
  },
  marginInlineStart: {
    style: mo
  },
  marginInlineEnd: {
    style: mo
  },
  marginBlock: {
    style: mo
  },
  marginBlockStart: {
    style: mo
  },
  marginBlockEnd: {
    style: mo
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: fd
  },
  rowGap: {
    style: md
  },
  columnGap: {
    style: gd
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: lr
  },
  maxWidth: {
    style: gp
  },
  minWidth: {
    transform: lr
  },
  height: {
    transform: lr
  },
  maxHeight: {
    transform: lr
  },
  minHeight: {
    transform: lr
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function a8(...e) {
  const t = e.reduce((r, i) => r.concat(Object.keys(i)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function l8(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function c8() {
  function e(n, r, i, s) {
    const a = {
      [n]: r,
      theme: i
    }, l = s[n];
    if (!l)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: u,
      transform: f,
      style: g
    } = l;
    if (r == null)
      return null;
    if (u === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const h = ld(i, u) || {};
    return g ? g(a) : Rr(a, r, (v) => {
      let m = Lu(h, f, v);
      return v === m && typeof v == "string" && (m = Lu(h, f, `${n}${v === "default" ? "" : be(v)}`, v)), c === !1 ? m : {
        [c]: m
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: i = {},
      nested: s
    } = n || {};
    if (!r)
      return null;
    const a = i.unstable_sxConfig ?? oc;
    function l(c) {
      let u = c;
      if (typeof c == "function")
        u = c(i);
      else if (typeof c != "object")
        return c;
      if (!u)
        return null;
      const f = w7(i.breakpoints), g = Object.keys(f);
      let h = f;
      return Object.keys(u).forEach((y) => {
        const v = l8(u[y], i);
        if (v != null)
          if (typeof v == "object")
            if (a[y])
              h = El(h, e(y, v, i, a));
            else {
              const m = Rr({
                theme: i
              }, v, (b) => ({
                [y]: b
              }));
              a8(m, v) ? h[y] = t({
                sx: v,
                theme: i,
                nested: !0
              }) : h = El(h, m);
            }
          else
            h = El(h, e(y, v, i, a));
      }), !s && i.modularCssLayers ? {
        "@layer sx": x2(i, S2(g, h))
      } : x2(i, S2(g, h));
    }
    return Array.isArray(r) ? r.map(l) : l(r);
  }
  return t;
}
const os = c8();
os.filterProps = ["sx"];
function u8(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let i = n.getColorSchemeSelector(e);
    return i === "&" ? t : ((i.includes("data-") || i.includes(".")) && (i = `*:where(${i.replace(/\s*&$/, "")}) &`), {
      [i]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function mp(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: i,
    shape: s = {},
    ...a
  } = e, l = h7(n), c = n4(i);
  let u = Bo({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: c,
    shape: {
      ...C7,
      ...s
    }
  }, a);
  return u = b7(u), u.applyStyles = u8, u = t.reduce((f, g) => Bo(f, g), u), u.unstable_sxConfig = {
    ...oc,
    ...a == null ? void 0 : a.unstable_sxConfig
  }, u.unstable_sx = function(g) {
    return os({
      sx: g,
      theme: this
    });
  }, u;
}
function d8(e) {
  return Object.keys(e).length === 0;
}
function hd(e = null) {
  const t = d.useContext(Z5);
  return !t || d8(t) ? e : t;
}
const p8 = mp();
function vd(e = p8) {
  return hd(e);
}
function V1(e) {
  const t = Ji(e);
  return e !== t && t.styles ? (t.styles.match(/^@layer\s+[^{]*$/) || (t.styles = `@layer global{${t.styles}}`), t) : e;
}
function hp({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const r = vd(n), i = t && r[t] || r;
  let s = typeof e == "function" ? e(i) : e;
  return i.modularCssLayers && (Array.isArray(s) ? s = s.map((a) => V1(typeof a == "function" ? a(i) : a)) : s = V1(s)), /* @__PURE__ */ p.jsx(pp, {
    styles: s
  });
}
process.env.NODE_ENV !== "production" && (hp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: o.object,
  /**
   * @ignore
   */
  styles: o.oneOfType([o.array, o.func, o.number, o.object, o.string, o.bool]),
  /**
   * @ignore
   */
  themeId: o.string
});
const f8 = (e) => {
  var r;
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = ((r = e == null ? void 0 : e.theme) == null ? void 0 : r.unstable_sxConfig) ?? oc;
  return Object.keys(e).forEach((i) => {
    n[i] ? t.systemProps[i] = e[i] : t.otherProps[i] = e[i];
  }), t;
};
function vp(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: r,
    otherProps: i
  } = f8(n);
  let s;
  return Array.isArray(t) ? s = [r, ...t] : typeof t == "function" ? s = (...a) => {
    const l = t(...a);
    return Zr(l) ? {
      ...r,
      ...l
    } : r;
  } : s = {
    ...r,
    ...t
  }, {
    ...i,
    sx: s
  };
}
const R2 = (e) => e, g8 = () => {
  let e = R2;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = R2;
    }
  };
}, yp = g8();
function o4(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: r = "MuiBox-root",
    generateClassName: i
  } = e, s = J5("div", {
    shouldForwardProp: (l) => l !== "theme" && l !== "sx" && l !== "as"
  })(os);
  return /* @__PURE__ */ d.forwardRef(function(c, u) {
    const f = vd(n), {
      className: g,
      component: h = "div",
      ...y
    } = vp(c);
    return /* @__PURE__ */ p.jsx(s, {
      as: h,
      ref: u,
      className: xe(g, i ? i(r) : r),
      theme: t && f[t] || f,
      ...y
    });
  });
}
const m8 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Pt(e, t, n = "Mui") {
  const r = m8[t];
  return r ? `${n}-${r}` : `${yp.generate(e)}-${t}`;
}
function Et(e, t, n = "Mui") {
  const r = {};
  return t.forEach((i) => {
    r[i] = Pt(e, i, n);
  }), r;
}
const h8 = Et("MuiBox", ["root"]), ko = o4({
  defaultClassName: h8.root,
  generateClassName: yp.generate
});
process.env.NODE_ENV !== "production" && (ko.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: o.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function r4(e, t = "") {
  return e.displayName || e.name || t;
}
function T2(e, t, n) {
  const r = r4(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function v8(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return r4(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case Pi.ForwardRef:
          return T2(e, e.render, "ForwardRef");
        case Pi.Memo:
          return T2(e, e.type, "memo");
        default:
          return;
      }
  }
}
function i4(e) {
  const {
    variants: t,
    ...n
  } = e, r = {
    variants: t,
    style: Ji(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((i) => {
    typeof i.style != "function" && (i.style = Ji(i.style));
  }), r;
}
const y8 = mp();
function Is(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function Rs(e, t) {
  return t && e && typeof e == "object" && e.styles && !e.styles.startsWith("@layer") && (e.styles = `@layer ${t}{${String(e.styles)}}`), e;
}
function b8(e) {
  return e ? (t, n) => n[e] : null;
}
function C8(e, t, n) {
  e.theme = S8(e.theme) ? n : e.theme[t] || e.theme;
}
function Tu(e, t, n) {
  const r = typeof t == "function" ? t(e) : t;
  if (Array.isArray(r))
    return r.flatMap((i) => Tu(e, i, n));
  if (Array.isArray(r == null ? void 0 : r.variants)) {
    let i;
    if (r.isProcessed)
      i = n ? Rs(r.style, n) : r.style;
    else {
      const {
        variants: s,
        ...a
      } = r;
      i = n ? Rs(Ji(a), n) : a;
    }
    return s4(e, r.variants, [i], n);
  }
  return r != null && r.isProcessed ? n ? Rs(Ji(r.style), n) : r.style : n ? Rs(Ji(r), n) : r;
}
function s4(e, t, n = [], r = void 0) {
  var s;
  let i;
  e: for (let a = 0; a < t.length; a += 1) {
    const l = t[a];
    if (typeof l.props == "function") {
      if (i ?? (i = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !l.props(i))
        continue;
    } else
      for (const c in l.props)
        if (e[c] !== l.props[c] && ((s = e.ownerState) == null ? void 0 : s[c]) !== l.props[c])
          continue e;
    typeof l.style == "function" ? (i ?? (i = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(r ? Rs(Ji(l.style(i)), r) : l.style(i))) : n.push(r ? Rs(Ji(l.style), r) : l.style);
  }
  return n;
}
function a4(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = y8,
    rootShouldForwardProp: r = Is,
    slotShouldForwardProp: i = Is
  } = e;
  function s(l) {
    C8(l, t, n);
  }
  return (l, c = {}) => {
    p7(l, (P) => P.filter((F) => F !== os));
    const {
      name: u,
      slot: f,
      skipVariantsResolver: g,
      skipSx: h,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: y = b8(l4(f)),
      ...v
    } = c, m = u && u.startsWith("Mui") || f ? "components" : "custom", b = g !== void 0 ? g : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      f && f !== "Root" && f !== "root" || !1
    ), C = h || !1;
    let E = Is;
    f === "Root" || f === "root" ? E = r : f ? E = i : E8(l) && (E = void 0);
    const S = J5(l, {
      shouldForwardProp: E,
      label: w8(u, f),
      ...v
    }), k = (P) => {
      if (P.__emotion_real === P)
        return P;
      if (typeof P == "function")
        return function(j) {
          return Tu(j, P, j.theme.modularCssLayers ? m : void 0);
        };
      if (Zr(P)) {
        const F = i4(P);
        return function(L) {
          return F.variants ? Tu(L, F, L.theme.modularCssLayers ? m : void 0) : L.theme.modularCssLayers ? Rs(F.style, m) : F.style;
        };
      }
      return P;
    }, T = (...P) => {
      const F = [], j = P.map(k), L = [];
      if (F.push(s), u && y && L.push(function(W) {
        var ie, ce;
        const G = (ce = (ie = W.theme.components) == null ? void 0 : ie[u]) == null ? void 0 : ce.styleOverrides;
        if (!G)
          return null;
        const H = {};
        for (const re in G)
          H[re] = Tu(W, G[re], W.theme.modularCssLayers ? "theme" : void 0);
        return y(W, H);
      }), u && !b && L.push(function(W) {
        var H, ie;
        const z = W.theme, G = (ie = (H = z == null ? void 0 : z.components) == null ? void 0 : H[u]) == null ? void 0 : ie.variants;
        return G ? s4(W, G, [], W.theme.modularCssLayers ? "theme" : void 0) : null;
      }), C || L.push(os), Array.isArray(j[0])) {
        const B = j.shift(), W = new Array(F.length).fill(""), z = new Array(L.length).fill("");
        let G;
        G = [...W, ...B, ...z], G.raw = [...W, ...B.raw, ...z], F.unshift(G);
      }
      const R = [...F, ...j, ...L], V = S(...R);
      return l.muiName && (V.muiName = l.muiName), process.env.NODE_ENV !== "production" && (V.displayName = x8(u, f, l)), V;
    };
    return S.withConfig && (T.withConfig = S.withConfig), T;
  };
}
function x8(e, t, n) {
  return e ? `${e}${be(t || "")}` : `Styled(${v8(n)})`;
}
function w8(e, t) {
  let n;
  return process.env.NODE_ENV !== "production" && e && (n = `${e}-${l4(t || "Root")}`), n;
}
function S8(e) {
  for (const t in e)
    return !1;
  return !0;
}
function E8(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function l4(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const yd = a4();
function Al(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const i = r;
      if (i === "components" || i === "slots")
        n[i] = {
          ...e[i],
          ...n[i]
        };
      else if (i === "componentsProps" || i === "slotProps") {
        const s = e[i], a = t[i];
        if (!a)
          n[i] = s || {};
        else if (!s)
          n[i] = a;
        else {
          n[i] = {
            ...a
          };
          for (const l in s)
            if (Object.prototype.hasOwnProperty.call(s, l)) {
              const c = l;
              n[i][c] = Al(s[c], a[c]);
            }
        }
      } else n[i] === void 0 && (n[i] = e[i]);
    }
  return n;
}
function c4(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : Al(t.components[n].defaultProps, r);
}
function R8({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let i = vd(n);
  return i = i[r] || i, c4({
    theme: i,
    name: t,
    props: e
  });
}
const Zo = typeof window < "u" ? d.useLayoutEffect : d.useEffect;
function T8(e, t, n, r, i) {
  const [s, a] = d.useState(() => i && n ? n(e).matches : r ? r(e).matches : t);
  return Zo(() => {
    if (!n)
      return;
    const l = n(e), c = () => {
      a(l.matches);
    };
    return c(), l.addEventListener("change", c), () => {
      l.removeEventListener("change", c);
    };
  }, [e, n]), s;
}
const M8 = {
  ...d
}, u4 = M8.useSyncExternalStore;
function k8(e, t, n, r, i) {
  const s = d.useCallback(() => t, [t]), a = d.useMemo(() => {
    if (i && n)
      return () => n(e).matches;
    if (r !== null) {
      const {
        matches: f
      } = r(e);
      return () => f;
    }
    return s;
  }, [s, e, r, i, n]), [l, c] = d.useMemo(() => {
    if (n === null)
      return [s, () => () => {
      }];
    const f = n(e);
    return [() => f.matches, (g) => (f.addEventListener("change", g), () => {
      f.removeEventListener("change", g);
    })];
  }, [s, n, e]);
  return u4(c, l, a);
}
function d4(e = {}) {
  const {
    themeId: t
  } = e;
  return function(r, i = {}) {
    let s = hd();
    s && t && (s = s[t] || s);
    const a = typeof window < "u" && typeof window.matchMedia < "u", {
      defaultMatches: l = !1,
      matchMedia: c = a ? window.matchMedia : null,
      ssrMatchMedia: u = null,
      noSsr: f = !1
    } = c4({
      name: "MuiUseMediaQuery",
      props: i,
      theme: s
    });
    process.env.NODE_ENV !== "production" && typeof r == "function" && s === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
    let g = typeof r == "function" ? r(s) : r;
    g = g.replace(/^@media( ?)/m, ""), g.includes("print") && console.warn(["MUI: You have provided a `print` query to the `useMediaQuery` hook.", "Using the print media query to modify print styles can lead to unexpected results.", "Consider using the `displayPrint` field in the `sx` prop instead.", "More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print."].join(`
`));
    const y = (u4 !== void 0 ? k8 : T8)(g, l, c, u, f);
    return process.env.NODE_ENV !== "production" && d.useDebugValue({
      query: g,
      match: y
    }), y;
  };
}
d4();
function Ss(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function bp(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), Ss(e, t, n);
}
function P8(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, i) => i < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function rs(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return rs(P8(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : ei(9, e));
  let r = e.substring(t + 1, e.length - 1), i;
  if (n === "color") {
    if (r = r.split(" "), i = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(i))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${i}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : ei(10, i));
  } else
    r = r.split(",");
  return r = r.map((s) => parseFloat(s)), {
    type: n,
    values: r,
    colorSpace: i
  };
}
const I8 = (e) => {
  const t = rs(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, vl = (e, t) => {
  try {
    return I8(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function bd(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((i, s) => s < 3 ? parseInt(i, 10) : i) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function p4(e) {
  e = rs(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, i = t[2] / 100, s = r * Math.min(i, 1 - i), a = (u, f = (u + n / 30) % 12) => i - s * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  let l = "rgb";
  const c = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (l += "a", c.push(t[3])), bd({
    type: l,
    values: c
  });
}
function S0(e) {
  e = rs(e);
  let t = e.type === "hsl" || e.type === "hsla" ? rs(p4(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function M2(e, t) {
  const n = S0(e), r = S0(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function At(e, t) {
  return e = rs(e), t = bp(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, bd(e);
}
function Kc(e, t, n) {
  try {
    return At(e, t);
  } catch {
    return e;
  }
}
function Ii(e, t) {
  if (e = rs(e), t = bp(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return bd(e);
}
function Wn(e, t, n) {
  try {
    return Ii(e, t);
  } catch {
    return e;
  }
}
function Oi(e, t) {
  if (e = rs(e), t = bp(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return bd(e);
}
function Gn(e, t, n) {
  try {
    return Oi(e, t);
  } catch {
    return e;
  }
}
function E0(e, t = 0.15) {
  return S0(e) > 0.5 ? Ii(e, t) : Oi(e, t);
}
function Xc(e, t, n) {
  try {
    return E0(e, t);
  } catch {
    return e;
  }
}
function nr(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function O8(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function f4(e, t, n, r, i) {
  const s = e[t], a = i || t;
  if (s == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  const c = s.type;
  return typeof c == "function" && !O8(c) && (l = "Did you accidentally use a plain function component for an element instead?"), l !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Bs = nr(o.element, f4);
Bs.isRequired = nr(o.element.isRequired, f4);
function D8(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function j8(e, t, n, r, i) {
  const s = e[t], a = i || t;
  if (s == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  return typeof s == "function" && !D8(s) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const rc = nr(o.elementType, j8), F8 = "exact-prop: ​";
function ic(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [F8]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function Di(e, t, n, r, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const s = e[t], a = i || t;
  return s == null ? null : s && s.nodeType !== 1 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const qo = o.oneOfType([o.func, o.object]);
function R0(...e) {
  return e.reduce((t, n) => n == null ? t : function(...i) {
    t.apply(this, i), n.apply(this, i);
  }, () => {
  });
}
function Cd(e, t = 166) {
  let n;
  function r(...i) {
    const s = () => {
      e.apply(this, i);
    };
    clearTimeout(n), n = setTimeout(s, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function Rl(e, t) {
  var n, r, i;
  return /* @__PURE__ */ d.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((i = (r = (n = e.type) == null ? void 0 : n._payload) == null ? void 0 : r.value) == null ? void 0 : i.muiName)
  ) !== -1;
}
function Co(e) {
  return e && e.ownerDocument || document;
}
function Lr(e) {
  return Co(e).defaultView || window;
}
function V8(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? {
    ...t.propTypes
  } : null;
  return (i) => (s, a, l, c, u, ...f) => {
    const g = u || a, h = n == null ? void 0 : n[g];
    if (h) {
      const y = h(s, a, l, c, u, ...f);
      if (y)
        return y;
    }
    return typeof s[a] < "u" && !s[i] ? new Error(`The prop \`${g}\` of \`${e}\` can only be used together with the \`${i}\` prop.`) : null;
  };
}
function T0(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let k2 = 0;
function $8(e) {
  const [t, n] = d.useState(e), r = e || t;
  return d.useEffect(() => {
    t == null && (k2 += 1, n(`mui-${k2}`));
  }, [t]), r;
}
const L8 = {
  ...d
}, P2 = L8.useId;
function ai(e) {
  if (P2 !== void 0) {
    const t = P2();
    return e ?? t;
  }
  return $8(e);
}
function g4(e, t, n, r, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const s = i || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${s}\` is not supported. Please remove it.`) : null;
}
function Xr({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: i
  } = d.useRef(e !== void 0), [s, a] = d.useState(t), l = i ? e : s;
  if (process.env.NODE_ENV !== "production") {
    d.useEffect(() => {
      i !== (e !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${r} state of ${n} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: u
    } = d.useRef(t);
    d.useEffect(() => {
      !i && !Object.is(u, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = d.useCallback((u) => {
    i || a(u);
  }, []);
  return [l, c];
}
function Eo(e) {
  const t = d.useRef(e);
  return Zo(() => {
    t.current = e;
  }), d.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function lo(...e) {
  const t = d.useRef(void 0), n = d.useCallback((r) => {
    const i = e.map((s) => {
      if (s == null)
        return null;
      if (typeof s == "function") {
        const a = s, l = a(r);
        return typeof l == "function" ? l : () => {
          a(null);
        };
      }
      return s.current = r, () => {
        s.current = null;
      };
    });
    return () => {
      i.forEach((s) => s == null ? void 0 : s());
    };
  }, e);
  return d.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    t.current && (t.current(), t.current = void 0), r != null && (t.current = n(r));
  }, e);
}
const I2 = {};
function m4(e, t) {
  const n = d.useRef(I2);
  return n.current === I2 && (n.current = e(t)), n;
}
const A8 = [];
function N8(e) {
  d.useEffect(e, A8);
}
class xd {
  constructor() {
    Ua(this, "currentId", null);
    Ua(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    Ua(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new xd();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function Ts() {
  const e = m4(xd.create).current;
  return N8(e.disposeEffect), e;
}
function is(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function h4(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
const Cp = (e) => {
  const t = d.useRef({});
  return d.useEffect(() => {
    t.current = e;
  }), t.current;
};
function B8(e) {
  return d.Children.toArray(e).filter((t) => /* @__PURE__ */ d.isValidElement(t));
}
const v4 = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function _8(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function y4(e, t, n, r) {
  const i = e[t];
  if (i == null || !Number.isInteger(i)) {
    const s = _8(i);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${s}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function b4(e, t, ...n) {
  return e[t] === void 0 ? null : y4(e, t, ...n);
}
function M0() {
  return null;
}
b4.isRequired = y4;
M0.isRequired = M0;
const Fr = process.env.NODE_ENV === "production" ? M0 : b4;
function Ot(e, t, n = void 0) {
  const r = {};
  for (const i in e) {
    const s = e[i];
    let a = "", l = !0;
    for (let c = 0; c < s.length; c += 1) {
      const u = s[c];
      u && (a += (l === !0 ? "" : " ") + t(u), l = !1, n && n[u] && (a += " " + n[u]));
    }
    r[i] = a;
  }
  return r;
}
function z8(e) {
  return typeof e == "string";
}
function C4(e, t, n) {
  return e === void 0 || z8(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function Tl(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function O2(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function x4(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: i,
    className: s
  } = e;
  if (!t) {
    const y = xe(n == null ? void 0 : n.className, s, i == null ? void 0 : i.className, r == null ? void 0 : r.className), v = {
      ...n == null ? void 0 : n.style,
      ...i == null ? void 0 : i.style,
      ...r == null ? void 0 : r.style
    }, m = {
      ...n,
      ...i,
      ...r
    };
    return y.length > 0 && (m.className = y), Object.keys(v).length > 0 && (m.style = v), {
      props: m,
      internalRef: void 0
    };
  }
  const a = Tl({
    ...i,
    ...r
  }), l = O2(r), c = O2(i), u = t(a), f = xe(u == null ? void 0 : u.className, n == null ? void 0 : n.className, s, i == null ? void 0 : i.className, r == null ? void 0 : r.className), g = {
    ...u == null ? void 0 : u.style,
    ...n == null ? void 0 : n.style,
    ...i == null ? void 0 : i.style,
    ...r == null ? void 0 : r.style
  }, h = {
    ...u,
    ...n,
    ...c,
    ...l
  };
  return f.length > 0 && (h.className = f), Object.keys(g).length > 0 && (h.style = g), {
    props: h,
    internalRef: u.ref
  };
}
function w4(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Yo(e) {
  var g;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: i = !1,
    ...s
  } = e, a = i ? {} : w4(n, r), {
    props: l,
    internalRef: c
  } = x4({
    ...s,
    externalSlotProps: a
  }), u = lo(c, a == null ? void 0 : a.ref, (g = e.additionalProps) == null ? void 0 : g.ref);
  return C4(t, {
    ...l,
    ref: u
  }, r);
}
function _s(e) {
  var t;
  return parseInt(d.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const xp = /* @__PURE__ */ d.createContext(null);
process.env.NODE_ENV !== "production" && (xp.displayName = "ThemeContext");
function wp() {
  const e = d.useContext(xp);
  return process.env.NODE_ENV !== "production" && d.useDebugValue(e), e;
}
const H8 = typeof Symbol == "function" && Symbol.for, W8 = H8 ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function G8(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return {
    ...e,
    ...t
  };
}
function Au(e) {
  const {
    children: t,
    theme: n
  } = e, r = wp();
  process.env.NODE_ENV !== "production" && r === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const i = d.useMemo(() => {
    const s = r === null ? {
      ...n
    } : G8(r, n);
    return s != null && (s[W8] = r !== null), s;
  }, [n, r]);
  return /* @__PURE__ */ p.jsx(xp.Provider, {
    value: i,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Au.propTypes = {
  /**
   * Your component tree.
   */
  children: o.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: o.oneOfType([o.object, o.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Au.propTypes = ic(Au.propTypes));
const S4 = /* @__PURE__ */ d.createContext();
function E4({
  value: e,
  ...t
}) {
  return /* @__PURE__ */ p.jsx(S4.Provider, {
    value: e ?? !0,
    ...t
  });
}
process.env.NODE_ENV !== "production" && (E4.propTypes = {
  children: o.node,
  value: o.bool
});
const Io = () => d.useContext(S4) ?? !1, R4 = /* @__PURE__ */ d.createContext(void 0);
function T4({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ p.jsx(R4.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (T4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: o.node,
  /**
   * @ignore
   */
  value: o.object
});
function U8(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const i = t.components[n];
  return i.defaultProps ? Al(i.defaultProps, r) : !i.styleOverrides && !i.variants ? Al(i, r) : r;
}
function Y8({
  props: e,
  name: t
}) {
  const n = d.useContext(R4);
  return U8({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
function Z8(e) {
  const t = hd(), n = ai() || "", {
    modularCssLayers: r
  } = e;
  let i = "mui.global, mui.components, mui.theme, mui.custom, mui.sx";
  return !r || t !== null ? i = "" : typeof r == "string" ? i = r.replace(/mui(?!\.)/g, i) : i = `@layer ${i};`, Zo(() => {
    var l, c;
    const s = document.querySelector("head");
    if (!s)
      return;
    const a = s.firstChild;
    if (i) {
      if (a && ((l = a.hasAttribute) != null && l.call(a, "data-mui-layer-order")) && a.getAttribute("data-mui-layer-order") === n)
        return;
      const u = document.createElement("style");
      u.setAttribute("data-mui-layer-order", n), u.textContent = i, s.prepend(u);
    } else
      (c = s.querySelector(`style[data-mui-layer-order="${n}"]`)) == null || c.remove();
  }, [i, n]), i ? /* @__PURE__ */ p.jsx(hp, {
    styles: i
  }) : null;
}
const D2 = {};
function j2(e, t, n, r = !1) {
  return d.useMemo(() => {
    const i = e && t[e] || t;
    if (typeof n == "function") {
      const s = n(i), a = e ? {
        ...t,
        [e]: s
      } : s;
      return r ? () => a : a;
    }
    return e ? {
      ...t,
      [e]: n
    } : {
      ...t,
      ...n
    };
  }, [e, t, n, r]);
}
function Nl(e) {
  const {
    children: t,
    theme: n,
    themeId: r
  } = e, i = hd(D2), s = wp() || D2;
  process.env.NODE_ENV !== "production" && (i === null && typeof n == "function" || r && i && !i[r] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const a = j2(r, i, n), l = j2(r, s, n, !0), c = (r ? a[r] : a).direction === "rtl", u = Z8(a);
  return /* @__PURE__ */ p.jsx(Au, {
    theme: l,
    children: /* @__PURE__ */ p.jsx(Z5.Provider, {
      value: a,
      children: /* @__PURE__ */ p.jsx(E4, {
        value: c,
        children: /* @__PURE__ */ p.jsxs(T4, {
          value: r ? a[r].components : a.components,
          children: [u, t]
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (Nl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: o.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: o.oneOfType([o.func, o.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: o.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Nl.propTypes = ic(Nl.propTypes));
const F2 = {
  theme: void 0
};
function q8(e) {
  let t, n;
  return function(i) {
    let s = t;
    return (s === void 0 || i.theme !== n) && (F2.theme = i.theme, s = i4(e(F2)), t = s, n = i.theme), s;
  };
}
const Sp = "mode", Ep = "color-scheme", K8 = "data-color-scheme";
function X8(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: n = "light",
    defaultDarkColorScheme: r = "dark",
    modeStorageKey: i = Sp,
    colorSchemeStorageKey: s = Ep,
    attribute: a = K8,
    colorSchemeNode: l = "document.documentElement",
    nonce: c
  } = e || {};
  let u = "", f = a;
  if (a === "class" && (f = ".%s"), a === "data" && (f = "[data-%s]"), f.startsWith(".")) {
    const h = f.substring(1);
    u += `${l}.classList.remove('${h}'.replace('%s', light), '${h}'.replace('%s', dark));
      ${l}.classList.add('${h}'.replace('%s', colorScheme));`;
  }
  const g = f.match(/\[([^\]]+)\]/);
  if (g) {
    const [h, y] = g[1].split("=");
    y || (u += `${l}.removeAttribute('${h}'.replace('%s', light));
      ${l}.removeAttribute('${h}'.replace('%s', dark));`), u += `
      ${l}.setAttribute('${h}'.replace('%s', colorScheme), ${y ? `${y}.replace('%s', colorScheme)` : '""'});`;
  } else
    u += `${l}.setAttribute('${f}', colorScheme);`;
  return /* @__PURE__ */ p.jsx("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? c : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${i}') || '${t}';
  const dark = localStorage.getItem('${s}-dark') || '${r}';
  const light = localStorage.getItem('${s}-light') || '${n}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${u}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function Q8() {
}
const J8 = ({
  key: e,
  storageWindow: t
}) => (!t && typeof window < "u" && (t = window), {
  get(n) {
    if (typeof window > "u")
      return;
    if (!t)
      return n;
    let r;
    try {
      r = t.localStorage.getItem(e);
    } catch {
    }
    return r || n;
  },
  set: (n) => {
    if (t)
      try {
        t.localStorage.setItem(e, n);
      } catch {
      }
  },
  subscribe: (n) => {
    if (!t)
      return Q8;
    const r = (i) => {
      const s = i.newValue;
      i.key === e && n(s);
    };
    return t.addEventListener("storage", r), () => {
      t.removeEventListener("storage", r);
    };
  }
});
function $1() {
}
function V2(e) {
  if (typeof window < "u" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function M4(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function e9(e) {
  return M4(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function t9(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: n,
    defaultDarkColorScheme: r,
    supportedColorSchemes: i = [],
    modeStorageKey: s = Sp,
    colorSchemeStorageKey: a = Ep,
    storageWindow: l = typeof window > "u" ? void 0 : window,
    storageManager: c = J8,
    noSsr: u = !1
  } = e, f = i.join(","), g = i.length > 1, h = d.useMemo(() => c == null ? void 0 : c({
    key: s,
    storageWindow: l
  }), [c, s, l]), y = d.useMemo(() => c == null ? void 0 : c({
    key: `${a}-light`,
    storageWindow: l
  }), [c, a, l]), v = d.useMemo(() => c == null ? void 0 : c({
    key: `${a}-dark`,
    storageWindow: l
  }), [c, a, l]), [m, b] = d.useState(() => {
    const j = (h == null ? void 0 : h.get(t)) || t, L = (y == null ? void 0 : y.get(n)) || n, R = (v == null ? void 0 : v.get(r)) || r;
    return {
      mode: j,
      systemMode: V2(j),
      lightColorScheme: L,
      darkColorScheme: R
    };
  }), [C, E] = d.useState(u || !g);
  d.useEffect(() => {
    E(!0);
  }, []);
  const S = e9(m), k = d.useCallback((j) => {
    b((L) => {
      if (j === L.mode)
        return L;
      const R = j ?? t;
      return h == null || h.set(R), {
        ...L,
        mode: R,
        systemMode: V2(R)
      };
    });
  }, [h, t]), T = d.useCallback((j) => {
    j ? typeof j == "string" ? j && !f.includes(j) ? console.error(`\`${j}\` does not exist in \`theme.colorSchemes\`.`) : b((L) => {
      const R = {
        ...L
      };
      return M4(L, (V) => {
        V === "light" && (y == null || y.set(j), R.lightColorScheme = j), V === "dark" && (v == null || v.set(j), R.darkColorScheme = j);
      }), R;
    }) : b((L) => {
      const R = {
        ...L
      }, V = j.light === null ? n : j.light, B = j.dark === null ? r : j.dark;
      return V && (f.includes(V) ? (R.lightColorScheme = V, y == null || y.set(V)) : console.error(`\`${V}\` does not exist in \`theme.colorSchemes\`.`)), B && (f.includes(B) ? (R.darkColorScheme = B, v == null || v.set(B)) : console.error(`\`${B}\` does not exist in \`theme.colorSchemes\`.`)), R;
    }) : b((L) => (y == null || y.set(n), v == null || v.set(r), {
      ...L,
      lightColorScheme: n,
      darkColorScheme: r
    }));
  }, [f, y, v, n, r]), P = d.useCallback((j) => {
    m.mode === "system" && b((L) => {
      const R = j != null && j.matches ? "dark" : "light";
      return L.systemMode === R ? L : {
        ...L,
        systemMode: R
      };
    });
  }, [m.mode]), F = d.useRef(P);
  return F.current = P, d.useEffect(() => {
    if (typeof window.matchMedia != "function" || !g)
      return;
    const j = (...R) => F.current(...R), L = window.matchMedia("(prefers-color-scheme: dark)");
    return L.addListener(j), j(L), () => {
      L.removeListener(j);
    };
  }, [g]), d.useEffect(() => {
    if (g) {
      const j = (h == null ? void 0 : h.subscribe((V) => {
        (!V || ["light", "dark", "system"].includes(V)) && k(V || t);
      })) || $1, L = (y == null ? void 0 : y.subscribe((V) => {
        (!V || f.match(V)) && T({
          light: V
        });
      })) || $1, R = (v == null ? void 0 : v.subscribe((V) => {
        (!V || f.match(V)) && T({
          dark: V
        });
      })) || $1;
      return () => {
        j(), L(), R();
      };
    }
  }, [T, k, f, t, l, g, h, y, v]), {
    ...m,
    mode: C ? m.mode : void 0,
    systemMode: C ? m.systemMode : void 0,
    colorScheme: C ? S : void 0,
    setMode: k,
    setColorScheme: T
  };
}
const n9 = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function o9(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: n = {},
    modeStorageKey: r = Sp,
    colorSchemeStorageKey: i = Ep,
    disableTransitionOnChange: s = !1,
    defaultColorScheme: a,
    resolveTheme: l
  } = e, c = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, u = /* @__PURE__ */ d.createContext(void 0);
  process.env.NODE_ENV !== "production" && (u.displayName = "ColorSchemeContext");
  const f = () => d.useContext(u) || c, g = {}, h = {};
  function y(C) {
    var Dt, ke, Ne, We;
    const {
      children: E,
      theme: S,
      modeStorageKey: k = r,
      colorSchemeStorageKey: T = i,
      disableTransitionOnChange: P = s,
      storageManager: F,
      storageWindow: j = typeof window > "u" ? void 0 : window,
      documentNode: L = typeof document > "u" ? void 0 : document,
      colorSchemeNode: R = typeof document > "u" ? void 0 : document.documentElement,
      disableNestedContext: V = !1,
      disableStyleSheetGeneration: B = !1,
      defaultMode: W = "system",
      noSsr: z
    } = C, G = d.useRef(!1), H = wp(), ie = d.useContext(u), ce = !!ie && !V, re = d.useMemo(() => S || (typeof n == "function" ? n() : n), [S]), A = re[t], Y = A || re, {
      colorSchemes: pe = g,
      components: Ce = h,
      cssVarPrefix: fe
    } = Y, ee = Object.keys(pe).filter((Ge) => !!pe[Ge]).join(","), te = d.useMemo(() => ee.split(","), [ee]), ue = typeof a == "string" ? a : a.light, K = typeof a == "string" ? a : a.dark, oe = pe[ue] && pe[K] ? W : ((ke = (Dt = pe[Y.defaultColorScheme]) == null ? void 0 : Dt.palette) == null ? void 0 : ke.mode) || ((Ne = Y.palette) == null ? void 0 : Ne.mode), {
      mode: de,
      setMode: ve,
      systemMode: J,
      lightColorScheme: se,
      darkColorScheme: ge,
      colorScheme: Se,
      setColorScheme: we
    } = t9({
      supportedColorSchemes: te,
      defaultLightColorScheme: ue,
      defaultDarkColorScheme: K,
      modeStorageKey: k,
      colorSchemeStorageKey: T,
      defaultMode: oe,
      storageManager: F,
      storageWindow: j,
      noSsr: z
    });
    let me = de, ye = Se;
    ce && (me = ie.mode, ye = ie.colorScheme);
    const Ie = d.useMemo(() => {
      var Ke;
      const Ge = ye || Y.defaultColorScheme, Qe = ((Ke = Y.generateThemeVars) == null ? void 0 : Ke.call(Y)) || Y.vars, Ve = {
        ...Y,
        components: Ce,
        colorSchemes: pe,
        cssVarPrefix: fe,
        vars: Qe
      };
      if (typeof Ve.generateSpacing == "function" && (Ve.spacing = Ve.generateSpacing()), Ge) {
        const bt = pe[Ge];
        bt && typeof bt == "object" && Object.keys(bt).forEach((vt) => {
          bt[vt] && typeof bt[vt] == "object" ? Ve[vt] = {
            ...Ve[vt],
            ...bt[vt]
          } : Ve[vt] = bt[vt];
        });
      }
      return l ? l(Ve) : Ve;
    }, [Y, ye, Ce, pe, fe]), je = Y.colorSchemeSelector;
    Zo(() => {
      if (ye && R && je && je !== "media") {
        const Ge = je;
        let Qe = je;
        if (Ge === "class" && (Qe = ".%s"), Ge === "data" && (Qe = "[data-%s]"), Ge != null && Ge.startsWith("data-") && !Ge.includes("%s") && (Qe = `[${Ge}="%s"]`), Qe.startsWith("."))
          R.classList.remove(...te.map((Ve) => Qe.substring(1).replace("%s", Ve))), R.classList.add(Qe.substring(1).replace("%s", ye));
        else {
          const Ve = Qe.replace("%s", ye).match(/\[([^\]]+)\]/);
          if (Ve) {
            const [Ke, bt] = Ve[1].split("=");
            bt || te.forEach((vt) => {
              R.removeAttribute(Ke.replace(ye, vt));
            }), R.setAttribute(Ke, bt ? bt.replace(/"|'/g, "") : "");
          } else
            R.setAttribute(Qe, ye);
        }
      }
    }, [ye, je, R, te]), d.useEffect(() => {
      let Ge;
      if (P && G.current && L) {
        const Qe = L.createElement("style");
        Qe.appendChild(L.createTextNode(n9)), L.head.appendChild(Qe), window.getComputedStyle(L.body), Ge = setTimeout(() => {
          L.head.removeChild(Qe);
        }, 1);
      }
      return () => {
        clearTimeout(Ge);
      };
    }, [ye, P, L]), d.useEffect(() => (G.current = !0, () => {
      G.current = !1;
    }), []);
    const Te = d.useMemo(() => ({
      allColorSchemes: te,
      colorScheme: ye,
      darkColorScheme: ge,
      lightColorScheme: se,
      mode: me,
      setColorScheme: we,
      setMode: process.env.NODE_ENV === "production" ? ve : (Ge) => {
        Ie.colorSchemeSelector === "media" && console.error(["MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).", "To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.", "To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"].join(`
`)), ve(Ge);
      },
      systemMode: J
    }), [te, ye, ge, se, me, we, ve, J, Ie.colorSchemeSelector]);
    let Fe = !0;
    (B || Y.cssVariables === !1 || ce && (H == null ? void 0 : H.cssVarPrefix) === fe) && (Fe = !1);
    const gt = /* @__PURE__ */ p.jsxs(d.Fragment, {
      children: [/* @__PURE__ */ p.jsx(Nl, {
        themeId: A ? t : void 0,
        theme: Ie,
        children: E
      }), Fe && /* @__PURE__ */ p.jsx(pp, {
        styles: ((We = Ie.generateStyleSheets) == null ? void 0 : We.call(Ie)) || []
      })]
    });
    return ce ? gt : /* @__PURE__ */ p.jsx(u.Provider, {
      value: Te,
      children: gt
    });
  }
  process.env.NODE_ENV !== "production" && (y.propTypes = {
    /**
     * The component tree.
     */
    children: o.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: o.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: o.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: o.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: o.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: o.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: o.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: o.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: o.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjuction with `InitColorSchemeScript` component.
     */
    noSsr: o.bool,
    /**
     * The storage manager to be used for storing the mode and color scheme
     * @default using `window.localStorage`
     */
    storageManager: o.func,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: o.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: o.object
  });
  const v = typeof a == "string" ? a : a.light, m = typeof a == "string" ? a : a.dark;
  return {
    CssVarsProvider: y,
    useColorScheme: f,
    getInitColorSchemeScript: (C) => X8({
      colorSchemeStorageKey: i,
      defaultLightColorScheme: v,
      defaultDarkColorScheme: m,
      modeStorageKey: r,
      ...C
    })
  };
}
function r9(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const i = r[0];
    return typeof i == "string" && !i.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${i}${t(...r.slice(1))})` : `, ${i}`;
  }
  return (r, ...i) => `var(--${e ? `${e}-` : ""}${r}${t(...i)})`;
}
const $2 = (e, t, n, r = []) => {
  let i = e;
  t.forEach((s, a) => {
    a === t.length - 1 ? Array.isArray(i) ? i[Number(s)] = n : i && typeof i == "object" && (i[s] = n) : i && typeof i == "object" && (i[s] || (i[s] = r.includes(s) ? [] : {}), i = i[s]);
  });
}, i9 = (e, t, n) => {
  function r(i, s = [], a = []) {
    Object.entries(i).forEach(([l, c]) => {
      (!n || n && !n([...s, l])) && c != null && (typeof c == "object" && Object.keys(c).length > 0 ? r(c, [...s, l], Array.isArray(c) ? [...a, l] : a) : t([...s, l], c, a));
    });
  }
  r(e);
}, s9 = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function L1(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, i = {}, s = {}, a = {};
  return i9(
    e,
    (l, c, u) => {
      if ((typeof c == "string" || typeof c == "number") && (!r || !r(l, c))) {
        const f = `--${n ? `${n}-` : ""}${l.join("-")}`, g = s9(l, c);
        Object.assign(i, {
          [f]: g
        }), $2(s, l, `var(${f})`, u), $2(a, l, `var(${f}, ${g})`, u);
      }
    },
    (l) => l[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: i,
    vars: s,
    varsWithDefaults: a
  };
}
function a9(e, t = {}) {
  const {
    getSelector: n = b,
    disableCssColorScheme: r,
    colorSchemeSelector: i
  } = t, {
    colorSchemes: s = {},
    components: a,
    defaultColorScheme: l = "light",
    ...c
  } = e, {
    vars: u,
    css: f,
    varsWithDefaults: g
  } = L1(c, t);
  let h = g;
  const y = {}, {
    [l]: v,
    ...m
  } = s;
  if (Object.entries(m || {}).forEach(([S, k]) => {
    const {
      vars: T,
      css: P,
      varsWithDefaults: F
    } = L1(k, t);
    h = Bo(h, F), y[S] = {
      css: P,
      vars: T
    };
  }), v) {
    const {
      css: S,
      vars: k,
      varsWithDefaults: T
    } = L1(v, t);
    h = Bo(h, T), y[l] = {
      css: S,
      vars: k
    };
  }
  function b(S, k) {
    var P, F;
    let T = i;
    if (i === "class" && (T = ".%s"), i === "data" && (T = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (T = `[${i}="%s"]`), S) {
      if (T === "media")
        return e.defaultColorScheme === S ? ":root" : {
          [`@media (prefers-color-scheme: ${((F = (P = s[S]) == null ? void 0 : P.palette) == null ? void 0 : F.mode) || S})`]: {
            ":root": k
          }
        };
      if (T)
        return e.defaultColorScheme === S ? `:root, ${T.replace("%s", String(S))}` : T.replace("%s", String(S));
    }
    return ":root";
  }
  return {
    vars: h,
    generateThemeVars: () => {
      let S = {
        ...u
      };
      return Object.entries(y).forEach(([, {
        vars: k
      }]) => {
        S = Bo(S, k);
      }), S;
    },
    generateStyleSheets: () => {
      var j, L;
      const S = [], k = e.defaultColorScheme || "light";
      function T(R, V) {
        Object.keys(V).length && S.push(typeof R == "string" ? {
          [R]: {
            ...V
          }
        } : R);
      }
      T(n(void 0, {
        ...f
      }), f);
      const {
        [k]: P,
        ...F
      } = y;
      if (P) {
        const {
          css: R
        } = P, V = (L = (j = s[k]) == null ? void 0 : j.palette) == null ? void 0 : L.mode, B = !r && V ? {
          colorScheme: V,
          ...R
        } : {
          ...R
        };
        T(n(k, {
          ...B
        }), B);
      }
      return Object.entries(F).forEach(([R, {
        css: V
      }]) => {
        var z, G;
        const B = (G = (z = s[R]) == null ? void 0 : z.palette) == null ? void 0 : G.mode, W = !r && B ? {
          colorScheme: B,
          ...V
        } : {
          ...V
        };
        T(n(R, {
          ...W
        }), W);
      }), S;
    }
  };
}
function l9(e) {
  return function(n) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
function k4() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Ll.white,
      default: Ll.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const c9 = k4();
function P4() {
  return {
    text: {
      primary: Ll.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Ll.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const L2 = P4();
function A2(e, t, n, r) {
  const i = r.light || r, s = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Oi(e.main, i) : t === "dark" && (e.dark = Ii(e.main, s)));
}
function u9(e = "light") {
  return e === "dark" ? {
    main: Xs[200],
    light: Xs[50],
    dark: Xs[400]
  } : {
    main: Xs[700],
    light: Xs[400],
    dark: Xs[800]
  };
}
function d9(e = "light") {
  return e === "dark" ? {
    main: Ks[200],
    light: Ks[50],
    dark: Ks[400]
  } : {
    main: Ks[500],
    light: Ks[300],
    dark: Ks[700]
  };
}
function p9(e = "light") {
  return e === "dark" ? {
    main: qs[500],
    light: qs[300],
    dark: qs[700]
  } : {
    main: qs[700],
    light: qs[400],
    dark: qs[800]
  };
}
function f9(e = "light") {
  return e === "dark" ? {
    main: Qs[400],
    light: Qs[300],
    dark: Qs[700]
  } : {
    main: Qs[700],
    light: Qs[500],
    dark: Qs[900]
  };
}
function g9(e = "light") {
  return e === "dark" ? {
    main: Js[400],
    light: Js[300],
    dark: Js[700]
  } : {
    main: Js[800],
    light: Js[500],
    dark: Js[900]
  };
}
function m9(e = "light") {
  return e === "dark" ? {
    main: qa[400],
    light: qa[300],
    dark: qa[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: qa[500],
    dark: qa[900]
  };
}
function Rp(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...i
  } = e, s = e.primary || u9(t), a = e.secondary || d9(t), l = e.error || p9(t), c = e.info || f9(t), u = e.success || g9(t), f = e.warning || m9(t);
  function g(m) {
    const b = M2(m, L2.text.primary) >= n ? L2.text.primary : c9.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const C = M2(m, b);
      C < 3 && console.error([`MUI: The contrast ratio of ${C}:1 for ${b} on ${m}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return b;
  }
  const h = ({
    color: m,
    name: b,
    mainShade: C = 500,
    lightShade: E = 300,
    darkShade: S = 700
  }) => {
    if (m = {
      ...m
    }, !m.main && m[C] && (m.main = m[C]), !m.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${C}\` property.` : ei(11, b ? ` (${b})` : "", C));
    if (typeof m.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(m.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : ei(12, b ? ` (${b})` : "", JSON.stringify(m.main)));
    return A2(m, "light", E, r), A2(m, "dark", S, r), m.contrastText || (m.contrastText = g(m.main)), m;
  };
  let y;
  return t === "light" ? y = k4() : t === "dark" && (y = P4()), process.env.NODE_ENV !== "production" && (y || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), Bo({
    // A collection of common colors.
    common: {
      ...Ll
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: h({
      color: s,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: h({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: h({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: h({
      color: f,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: h({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: h({
      color: u,
      name: "success"
    }),
    // The grey colors.
    grey: Z6,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: g,
    // Generate a rich color object.
    augmentColor: h,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...y
  }, i);
}
function h9(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [i, s] = r;
    typeof s == "object" && (t[i] = `${s.fontStyle ? `${s.fontStyle} ` : ""}${s.fontVariant ? `${s.fontVariant} ` : ""}${s.fontWeight ? `${s.fontWeight} ` : ""}${s.fontStretch ? `${s.fontStretch} ` : ""}${s.fontSize || ""}${s.lineHeight ? `/${s.lineHeight} ` : ""}${s.fontFamily || ""}`);
  }), t;
}
function v9(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function y9(e) {
  return Math.round(e * 1e5) / 1e5;
}
const N2 = {
  textTransform: "uppercase"
}, B2 = '"Roboto", "Helvetica", "Arial", sans-serif';
function I4(e, t) {
  const {
    fontFamily: n = B2,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: s = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: u,
    pxToRem: f,
    ...g
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof c != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const h = r / 14, y = f || ((b) => `${b / c * h}rem`), v = (b, C, E, S, k) => ({
    fontFamily: n,
    fontWeight: b,
    fontSize: y(C),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: E,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === B2 ? {
      letterSpacing: `${y9(S / C)}em`
    } : {},
    ...k,
    ...u
  }), m = {
    h1: v(i, 96, 1.167, -1.5),
    h2: v(i, 60, 1.2, -0.5),
    h3: v(s, 48, 1.167, 0),
    h4: v(s, 34, 1.235, 0.25),
    h5: v(s, 24, 1.334, 0),
    h6: v(a, 20, 1.6, 0.15),
    subtitle1: v(s, 16, 1.75, 0.15),
    subtitle2: v(a, 14, 1.57, 0.1),
    body1: v(s, 16, 1.5, 0.15),
    body2: v(s, 14, 1.43, 0.15),
    button: v(a, 14, 1.75, 0.4, N2),
    caption: v(s, 12, 1.66, 0.4),
    overline: v(s, 12, 2.66, 1, N2),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Bo({
    htmlFontSize: c,
    pxToRem: y,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: i,
    fontWeightRegular: s,
    fontWeightMedium: a,
    fontWeightBold: l,
    ...m
  }, g, {
    clone: !1
    // No need to clone deep
  });
}
const b9 = 0.2, C9 = 0.14, x9 = 0.12;
function io(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${b9})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${C9})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${x9})`].join(",");
}
const w9 = ["none", io(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), io(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), io(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), io(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), io(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), io(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), io(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), io(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), io(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), io(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), io(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), io(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), io(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), io(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), io(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), io(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), io(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), io(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), io(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), io(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), io(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), io(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), io(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), io(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], S9 = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, O4 = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function _2(e) {
  return `${Math.round(e)}ms`;
}
function E9(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function R9(e) {
  const t = {
    ...S9,
    ...e.easing
  }, n = {
    ...O4,
    ...e.duration
  };
  return {
    getAutoHeightDuration: E9,
    create: (i = ["all"], s = {}) => {
      const {
        duration: a = n.standard,
        easing: l = t.easeInOut,
        delay: c = 0,
        ...u
      } = s;
      if (process.env.NODE_ENV !== "production") {
        const f = (h) => typeof h == "string", g = (h) => !Number.isNaN(parseFloat(h));
        !f(i) && !Array.isArray(i) && console.error('MUI: Argument "props" must be a string or Array.'), !g(a) && !f(a) && console.error(`MUI: Argument "duration" must be a number or a string but found ${a}.`), f(l) || console.error('MUI: Argument "easing" must be a string.'), !g(c) && !f(c) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof s != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
      }
      return (Array.isArray(i) ? i : [i]).map((f) => `${f} ${typeof a == "string" ? a : _2(a)} ${l} ${typeof c == "string" ? c : _2(c)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const T9 = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function M9(e) {
  return Zr(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function D4(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const i = Object.entries(r);
    for (let s = 0; s < i.length; s++) {
      const [a, l] = i[s];
      !M9(l) || a.startsWith("unstable_") ? delete r[a] : Zr(l) && (r[a] = {
        ...l
      }, n(r[a]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function k0(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: i,
    palette: s = {},
    transitions: a = {},
    typography: l = {},
    shape: c,
    ...u
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : ei(20));
  const f = Rp(s), g = mp(e);
  let h = Bo(g, {
    mixins: v9(g.breakpoints, r),
    palette: f,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: w9.slice(),
    typography: I4(f, l),
    transitions: R9(a),
    zIndex: {
      ...T9
    }
  });
  if (h = Bo(h, u), h = t.reduce((y, v) => Bo(y, v), h), process.env.NODE_ENV !== "production") {
    const y = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], v = (m, b) => {
      let C;
      for (C in m) {
        const E = m[C];
        if (y.includes(C) && Object.keys(E).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const S = Pt("", C);
            console.error([`MUI: The \`${b}\` component increases the CSS specificity of the \`${C}\` internal state.`, "You can not override it like this: ", JSON.stringify(m, null, 2), "", `Instead, you need to use the '&.${S}' syntax:`, JSON.stringify({
              root: {
                [`&.${S}`]: E
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          m[C] = {};
        }
      }
    };
    Object.keys(h.components).forEach((m) => {
      const b = h.components[m].styleOverrides;
      b && m.startsWith("Mui") && v(b, m);
    });
  }
  return h.unstable_sxConfig = {
    ...oc,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, h.unstable_sx = function(v) {
    return os({
      sx: v,
      theme: this
    });
  }, h.toRuntimeSource = D4, h;
}
function P0(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const k9 = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = P0(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function j4(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function F4(e) {
  return e === "dark" ? k9 : [];
}
function P9(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...i
  } = e, s = Rp(t);
  return {
    palette: s,
    opacity: {
      ...j4(s.mode),
      ...n
    },
    overlays: r || F4(s.mode),
    ...i
  };
}
function I9(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const O9 = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], D9 = (e) => (t, n) => {
  const r = e.rootSelector || ":root", i = e.colorSchemeSelector;
  let s = i;
  if (i === "class" && (s = ".%s"), i === "data" && (s = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (s = `[${i}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const a = {};
      return O9(e.cssVarPrefix).forEach((l) => {
        a[l] = n[l], delete n[l];
      }), s === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: a
        }
      } : s ? {
        [s.replace("%s", t)]: a,
        [`${r}, ${s.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...a
        }
      };
    }
    if (s && s !== "media")
      return `${r}, ${s.replace("%s", String(t))}`;
  } else if (t) {
    if (s === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (s)
      return s.replace("%s", String(t));
  }
  return r;
};
function j9(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function Oe(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function yl(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : p4(e);
}
function gi(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = vl(yl(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function F9(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Ur = (e) => {
  try {
    return e();
  } catch {
  }
}, V9 = (e = "mui") => r9(e);
function A1(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const i = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = P9({
      ...t,
      palette: {
        mode: i,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: s,
    ...a
  } = k0({
    ...n,
    palette: {
      mode: i,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: s,
    opacity: {
      ...j4(i),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || F4(i)
  }, a;
}
function $9(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: i = !1,
    cssVarPrefix: s = "mui",
    shouldSkipGeneratingVar: a = I9,
    colorSchemeSelector: l = n.light && n.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...u
  } = e, f = Object.keys(n)[0], g = r || (n.light && f !== "light" ? "light" : f), h = V9(s), {
    [g]: y,
    light: v,
    dark: m,
    ...b
  } = n, C = {
    ...b
  };
  let E = y;
  if ((g === "dark" && !("dark" in n) || g === "light" && !("light" in n)) && (E = !0), !E)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${g}\` option is either missing or invalid.` : ei(21, g));
  const S = A1(C, E, u, g);
  v && !C.light && A1(C, v, void 0, "light"), m && !C.dark && A1(C, m, void 0, "dark");
  let k = {
    defaultColorScheme: g,
    ...S,
    cssVarPrefix: s,
    colorSchemeSelector: l,
    rootSelector: c,
    getCssVar: h,
    colorSchemes: C,
    font: {
      ...h9(S.typography),
      ...S.font
    },
    spacing: F9(u.spacing)
  };
  Object.keys(k.colorSchemes).forEach((L) => {
    const R = k.colorSchemes[L].palette, V = (B) => {
      const W = B.split("-"), z = W[1], G = W[2];
      return h(B, R[z][G]);
    };
    if (R.mode === "light" && (Oe(R.common, "background", "#fff"), Oe(R.common, "onBackground", "#000")), R.mode === "dark" && (Oe(R.common, "background", "#000"), Oe(R.common, "onBackground", "#fff")), j9(R, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), R.mode === "light") {
      Oe(R.Alert, "errorColor", Wn(R.error.light, 0.6)), Oe(R.Alert, "infoColor", Wn(R.info.light, 0.6)), Oe(R.Alert, "successColor", Wn(R.success.light, 0.6)), Oe(R.Alert, "warningColor", Wn(R.warning.light, 0.6)), Oe(R.Alert, "errorFilledBg", V("palette-error-main")), Oe(R.Alert, "infoFilledBg", V("palette-info-main")), Oe(R.Alert, "successFilledBg", V("palette-success-main")), Oe(R.Alert, "warningFilledBg", V("palette-warning-main")), Oe(R.Alert, "errorFilledColor", Ur(() => R.getContrastText(R.error.main))), Oe(R.Alert, "infoFilledColor", Ur(() => R.getContrastText(R.info.main))), Oe(R.Alert, "successFilledColor", Ur(() => R.getContrastText(R.success.main))), Oe(R.Alert, "warningFilledColor", Ur(() => R.getContrastText(R.warning.main))), Oe(R.Alert, "errorStandardBg", Gn(R.error.light, 0.9)), Oe(R.Alert, "infoStandardBg", Gn(R.info.light, 0.9)), Oe(R.Alert, "successStandardBg", Gn(R.success.light, 0.9)), Oe(R.Alert, "warningStandardBg", Gn(R.warning.light, 0.9)), Oe(R.Alert, "errorIconColor", V("palette-error-main")), Oe(R.Alert, "infoIconColor", V("palette-info-main")), Oe(R.Alert, "successIconColor", V("palette-success-main")), Oe(R.Alert, "warningIconColor", V("palette-warning-main")), Oe(R.AppBar, "defaultBg", V("palette-grey-100")), Oe(R.Avatar, "defaultBg", V("palette-grey-400")), Oe(R.Button, "inheritContainedBg", V("palette-grey-300")), Oe(R.Button, "inheritContainedHoverBg", V("palette-grey-A100")), Oe(R.Chip, "defaultBorder", V("palette-grey-400")), Oe(R.Chip, "defaultAvatarColor", V("palette-grey-700")), Oe(R.Chip, "defaultIconColor", V("palette-grey-700")), Oe(R.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), Oe(R.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), Oe(R.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), Oe(R.LinearProgress, "primaryBg", Gn(R.primary.main, 0.62)), Oe(R.LinearProgress, "secondaryBg", Gn(R.secondary.main, 0.62)), Oe(R.LinearProgress, "errorBg", Gn(R.error.main, 0.62)), Oe(R.LinearProgress, "infoBg", Gn(R.info.main, 0.62)), Oe(R.LinearProgress, "successBg", Gn(R.success.main, 0.62)), Oe(R.LinearProgress, "warningBg", Gn(R.warning.main, 0.62)), Oe(R.Skeleton, "bg", `rgba(${V("palette-text-primaryChannel")} / 0.11)`), Oe(R.Slider, "primaryTrack", Gn(R.primary.main, 0.62)), Oe(R.Slider, "secondaryTrack", Gn(R.secondary.main, 0.62)), Oe(R.Slider, "errorTrack", Gn(R.error.main, 0.62)), Oe(R.Slider, "infoTrack", Gn(R.info.main, 0.62)), Oe(R.Slider, "successTrack", Gn(R.success.main, 0.62)), Oe(R.Slider, "warningTrack", Gn(R.warning.main, 0.62));
      const B = Xc(R.background.default, 0.8);
      Oe(R.SnackbarContent, "bg", B), Oe(R.SnackbarContent, "color", Ur(() => R.getContrastText(B))), Oe(R.SpeedDialAction, "fabHoverBg", Xc(R.background.paper, 0.15)), Oe(R.StepConnector, "border", V("palette-grey-400")), Oe(R.StepContent, "border", V("palette-grey-400")), Oe(R.Switch, "defaultColor", V("palette-common-white")), Oe(R.Switch, "defaultDisabledColor", V("palette-grey-100")), Oe(R.Switch, "primaryDisabledColor", Gn(R.primary.main, 0.62)), Oe(R.Switch, "secondaryDisabledColor", Gn(R.secondary.main, 0.62)), Oe(R.Switch, "errorDisabledColor", Gn(R.error.main, 0.62)), Oe(R.Switch, "infoDisabledColor", Gn(R.info.main, 0.62)), Oe(R.Switch, "successDisabledColor", Gn(R.success.main, 0.62)), Oe(R.Switch, "warningDisabledColor", Gn(R.warning.main, 0.62)), Oe(R.TableCell, "border", Gn(Kc(R.divider, 1), 0.88)), Oe(R.Tooltip, "bg", Kc(R.grey[700], 0.92));
    }
    if (R.mode === "dark") {
      Oe(R.Alert, "errorColor", Gn(R.error.light, 0.6)), Oe(R.Alert, "infoColor", Gn(R.info.light, 0.6)), Oe(R.Alert, "successColor", Gn(R.success.light, 0.6)), Oe(R.Alert, "warningColor", Gn(R.warning.light, 0.6)), Oe(R.Alert, "errorFilledBg", V("palette-error-dark")), Oe(R.Alert, "infoFilledBg", V("palette-info-dark")), Oe(R.Alert, "successFilledBg", V("palette-success-dark")), Oe(R.Alert, "warningFilledBg", V("palette-warning-dark")), Oe(R.Alert, "errorFilledColor", Ur(() => R.getContrastText(R.error.dark))), Oe(R.Alert, "infoFilledColor", Ur(() => R.getContrastText(R.info.dark))), Oe(R.Alert, "successFilledColor", Ur(() => R.getContrastText(R.success.dark))), Oe(R.Alert, "warningFilledColor", Ur(() => R.getContrastText(R.warning.dark))), Oe(R.Alert, "errorStandardBg", Wn(R.error.light, 0.9)), Oe(R.Alert, "infoStandardBg", Wn(R.info.light, 0.9)), Oe(R.Alert, "successStandardBg", Wn(R.success.light, 0.9)), Oe(R.Alert, "warningStandardBg", Wn(R.warning.light, 0.9)), Oe(R.Alert, "errorIconColor", V("palette-error-main")), Oe(R.Alert, "infoIconColor", V("palette-info-main")), Oe(R.Alert, "successIconColor", V("palette-success-main")), Oe(R.Alert, "warningIconColor", V("palette-warning-main")), Oe(R.AppBar, "defaultBg", V("palette-grey-900")), Oe(R.AppBar, "darkBg", V("palette-background-paper")), Oe(R.AppBar, "darkColor", V("palette-text-primary")), Oe(R.Avatar, "defaultBg", V("palette-grey-600")), Oe(R.Button, "inheritContainedBg", V("palette-grey-800")), Oe(R.Button, "inheritContainedHoverBg", V("palette-grey-700")), Oe(R.Chip, "defaultBorder", V("palette-grey-700")), Oe(R.Chip, "defaultAvatarColor", V("palette-grey-300")), Oe(R.Chip, "defaultIconColor", V("palette-grey-300")), Oe(R.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), Oe(R.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), Oe(R.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), Oe(R.LinearProgress, "primaryBg", Wn(R.primary.main, 0.5)), Oe(R.LinearProgress, "secondaryBg", Wn(R.secondary.main, 0.5)), Oe(R.LinearProgress, "errorBg", Wn(R.error.main, 0.5)), Oe(R.LinearProgress, "infoBg", Wn(R.info.main, 0.5)), Oe(R.LinearProgress, "successBg", Wn(R.success.main, 0.5)), Oe(R.LinearProgress, "warningBg", Wn(R.warning.main, 0.5)), Oe(R.Skeleton, "bg", `rgba(${V("palette-text-primaryChannel")} / 0.13)`), Oe(R.Slider, "primaryTrack", Wn(R.primary.main, 0.5)), Oe(R.Slider, "secondaryTrack", Wn(R.secondary.main, 0.5)), Oe(R.Slider, "errorTrack", Wn(R.error.main, 0.5)), Oe(R.Slider, "infoTrack", Wn(R.info.main, 0.5)), Oe(R.Slider, "successTrack", Wn(R.success.main, 0.5)), Oe(R.Slider, "warningTrack", Wn(R.warning.main, 0.5));
      const B = Xc(R.background.default, 0.98);
      Oe(R.SnackbarContent, "bg", B), Oe(R.SnackbarContent, "color", Ur(() => R.getContrastText(B))), Oe(R.SpeedDialAction, "fabHoverBg", Xc(R.background.paper, 0.15)), Oe(R.StepConnector, "border", V("palette-grey-600")), Oe(R.StepContent, "border", V("palette-grey-600")), Oe(R.Switch, "defaultColor", V("palette-grey-300")), Oe(R.Switch, "defaultDisabledColor", V("palette-grey-600")), Oe(R.Switch, "primaryDisabledColor", Wn(R.primary.main, 0.55)), Oe(R.Switch, "secondaryDisabledColor", Wn(R.secondary.main, 0.55)), Oe(R.Switch, "errorDisabledColor", Wn(R.error.main, 0.55)), Oe(R.Switch, "infoDisabledColor", Wn(R.info.main, 0.55)), Oe(R.Switch, "successDisabledColor", Wn(R.success.main, 0.55)), Oe(R.Switch, "warningDisabledColor", Wn(R.warning.main, 0.55)), Oe(R.TableCell, "border", Wn(Kc(R.divider, 1), 0.68)), Oe(R.Tooltip, "bg", Kc(R.grey[700], 0.92));
    }
    gi(R.background, "default"), gi(R.background, "paper"), gi(R.common, "background"), gi(R.common, "onBackground"), gi(R, "divider"), Object.keys(R).forEach((B) => {
      const W = R[B];
      B !== "tonalOffset" && W && typeof W == "object" && (W.main && Oe(R[B], "mainChannel", vl(yl(W.main))), W.light && Oe(R[B], "lightChannel", vl(yl(W.light))), W.dark && Oe(R[B], "darkChannel", vl(yl(W.dark))), W.contrastText && Oe(R[B], "contrastTextChannel", vl(yl(W.contrastText))), B === "text" && (gi(R[B], "primary"), gi(R[B], "secondary")), B === "action" && (W.active && gi(R[B], "active"), W.selected && gi(R[B], "selected")));
    });
  }), k = t.reduce((L, R) => Bo(L, R), k);
  const T = {
    prefix: s,
    disableCssColorScheme: i,
    shouldSkipGeneratingVar: a,
    getSelector: D9(k)
  }, {
    vars: P,
    generateThemeVars: F,
    generateStyleSheets: j
  } = a9(k, T);
  return k.vars = P, Object.entries(k.colorSchemes[k.defaultColorScheme]).forEach(([L, R]) => {
    k[L] = R;
  }), k.generateThemeVars = F, k.generateStyleSheets = j, k.generateSpacing = function() {
    return n4(u.spacing, fp(this));
  }, k.getColorSchemeSelector = l9(l), k.spacing = k.generateSpacing(), k.shouldSkipGeneratingVar = a, k.unstable_sxConfig = {
    ...oc,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, k.unstable_sx = function(R) {
    return os({
      sx: R,
      theme: this
    });
  }, k.toRuntimeSource = D4, k;
}
function z2(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: Rp({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function Bl(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: i = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: s = n == null ? void 0 : n.mode,
    ...a
  } = e, l = s || "light", c = i == null ? void 0 : i[l], u = {
    ...i,
    ...n ? {
      [l]: {
        ...typeof c != "boolean" && c,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return k0(e, ...t);
    let f = n;
    "palette" in e || u[l] && (u[l] !== !0 ? f = u[l].palette : l === "dark" && (f = {
      mode: "dark"
    }));
    const g = k0({
      ...e,
      palette: f
    }, ...t);
    return g.defaultColorScheme = l, g.colorSchemes = u, g.palette.mode === "light" && (g.colorSchemes.light = {
      ...u.light !== !0 && u.light,
      palette: g.palette
    }, z2(g, "dark", u.dark)), g.palette.mode === "dark" && (g.colorSchemes.dark = {
      ...u.dark !== !0 && u.dark,
      palette: g.palette
    }, z2(g, "light", u.light)), g;
  }
  return !n && !("light" in u) && l === "light" && (u.light = !0), $9({
    ...a,
    colorSchemes: u,
    defaultColorScheme: l,
    ...typeof r != "boolean" && r
  }, ...t);
}
function L9(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function A9(e) {
  return parseFloat(e);
}
const wd = Bl();
function to() {
  const e = vd(wd);
  return process.env.NODE_ENV !== "production" && d.useDebugValue(e), e[Sr] || e;
}
function Kn({
  props: e,
  name: t
}) {
  return R8({
    props: e,
    name: t,
    defaultTheme: wd,
    themeId: Sr
  });
}
function sc(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const $o = (e) => sc(e) && e !== "classes", Z = a4({
  themeId: Sr,
  defaultTheme: wd,
  rootShouldForwardProp: $o
});
function N9({
  theme: e,
  ...t
}) {
  const n = Sr in e ? e[Sr] : void 0;
  return /* @__PURE__ */ p.jsx(Nl, {
    ...t,
    themeId: n ? Sr : void 0,
    theme: n || e
  });
}
const Qc = {
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: B9
} = o9({
  themeId: Sr,
  // @ts-ignore ignore module augmentation tests
  theme: () => Bl({
    cssVariables: !0
  }),
  colorSchemeStorageKey: Qc.colorSchemeStorageKey,
  modeStorageKey: Qc.modeStorageKey,
  defaultColorScheme: {
    light: Qc.defaultLightColorScheme,
    dark: Qc.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: I4(e.palette, e.typography)
    };
    return t.unstable_sx = function(r) {
      return os({
        sx: r,
        theme: this
      });
    }, t;
  }
}), _9 = B9;
function F_({
  theme: e,
  ...t
}) {
  const n = d.useMemo(() => {
    if (typeof e == "function")
      return e;
    const r = Sr in e ? e[Sr] : e;
    return "colorSchemes" in r ? null : "vars" in r ? e : {
      ...e,
      vars: null
    };
  }, [e]);
  return n ? /* @__PURE__ */ p.jsx(N9, {
    theme: n,
    ...t
  }) : /* @__PURE__ */ p.jsx(_9, {
    theme: e,
    ...t
  });
}
function V4(e) {
  return /* @__PURE__ */ p.jsx(hp, {
    ...e,
    defaultTheme: wd,
    themeId: Sr
  });
}
process.env.NODE_ENV !== "production" && (V4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: o.oneOfType([o.array, o.func, o.number, o.object, o.string, o.bool])
});
function z9(e) {
  return function(n) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ p.jsx(V4, {
        styles: typeof e == "function" ? (r) => e({
          theme: r,
          ...n
        }) : e
      })
    );
  };
}
function H9() {
  return vp;
}
const mt = q8;
process.env.NODE_ENV !== "production" && (o.node, o.object.isRequired);
function Vt(e) {
  return Y8(e);
}
function W9(e) {
  return Pt("MuiSvgIcon", e);
}
Et("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const G9 = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, i = {
    root: ["root", t !== "inherit" && `color${be(t)}`, `fontSize${be(n)}`]
  };
  return Ot(i, W9, r);
}, U9 = Z("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${be(n.color)}`], t[`fontSize${be(n.fontSize)}`]];
  }
})(mt(({
  theme: e
}) => {
  var t, n, r, i, s, a, l, c, u, f, g, h, y, v;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (i = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : i.call(t, "fill", {
      duration: (r = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : r.shorter
    }),
    variants: [
      {
        props: (m) => !m.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((a = (s = e.typography) == null ? void 0 : s.pxToRem) == null ? void 0 : a.call(s, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((c = (l = e.typography) == null ? void 0 : l.pxToRem) == null ? void 0 : c.call(l, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((f = (u = e.typography) == null ? void 0 : u.pxToRem) == null ? void 0 : f.call(u, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, m]) => m && m.main).map(([m]) => {
        var b, C;
        return {
          props: {
            color: m
          },
          style: {
            color: (C = (b = (e.vars ?? e).palette) == null ? void 0 : b[m]) == null ? void 0 : C.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (h = (g = (e.vars ?? e).palette) == null ? void 0 : g.action) == null ? void 0 : h.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (v = (y = (e.vars ?? e).palette) == null ? void 0 : y.action) == null ? void 0 : v.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), or = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: i,
    className: s,
    color: a = "inherit",
    component: l = "svg",
    fontSize: c = "medium",
    htmlColor: u,
    inheritViewBox: f = !1,
    titleAccess: g,
    viewBox: h = "0 0 24 24",
    ...y
  } = r, v = /* @__PURE__ */ d.isValidElement(i) && i.type === "svg", m = {
    ...r,
    color: a,
    component: l,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: f,
    viewBox: h,
    hasSvgAsChild: v
  }, b = {};
  f || (b.viewBox = h);
  const C = G9(m);
  return /* @__PURE__ */ p.jsxs(U9, {
    as: l,
    className: xe(C.root, s),
    focusable: "false",
    color: u,
    "aria-hidden": g ? void 0 : !0,
    role: g ? "img" : void 0,
    ref: n,
    ...b,
    ...y,
    ...v && i.props,
    ownerState: m,
    children: [v ? i.props.children : i, g ? /* @__PURE__ */ p.jsx("title", {
      children: g
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (or.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: o.oneOfType([o.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: o.oneOfType([o.oneOf(["inherit", "large", "medium", "small"]), o.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: o.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: o.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: o.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: o.string
});
or.muiName = "SvgIcon";
function jn(e, t) {
  function n(r, i) {
    return /* @__PURE__ */ p.jsx(or, {
      "data-testid": `${t}Icon`,
      ref: i,
      ...r,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = or.muiName, /* @__PURE__ */ d.memo(/* @__PURE__ */ d.forwardRef(n));
}
function $4(e, t) {
  if (!e)
    return t;
  if (typeof e == "function" || typeof t == "function")
    return (i) => {
      const s = typeof t == "function" ? t(i) : t, a = typeof e == "function" ? e({
        ...i,
        ...s
      }) : e, l = xe(i == null ? void 0 : i.className, s == null ? void 0 : s.className, a == null ? void 0 : a.className);
      return {
        ...s,
        ...a,
        ...!!l && {
          className: l
        },
        ...(s == null ? void 0 : s.style) && (a == null ? void 0 : a.style) && {
          style: {
            ...s.style,
            ...a.style
          }
        },
        ...(s == null ? void 0 : s.sx) && (a == null ? void 0 : a.sx) && {
          sx: [...Array.isArray(s.sx) ? s.sx : [s.sx], ...Array.isArray(a.sx) ? a.sx : [a.sx]]
        }
      };
    };
  const n = t, r = xe(n == null ? void 0 : n.className, e == null ? void 0 : e.className);
  return {
    ...t,
    ...e,
    ...!!r && {
      className: r
    },
    ...(n == null ? void 0 : n.style) && (e == null ? void 0 : e.style) && {
      style: {
        ...n.style,
        ...e.style
      }
    },
    ...(n == null ? void 0 : n.sx) && (e == null ? void 0 : e.sx) && {
      sx: [...Array.isArray(n.sx) ? n.sx : [n.sx], ...Array.isArray(e.sx) ? e.sx : [e.sx]]
    }
  };
}
function Q() {
  return Q = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Q.apply(null, arguments);
}
function Zt(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
function I0(e, t) {
  return I0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, I0(e, t);
}
function Tp(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, I0(e, t);
}
function Y9(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function Z9(e, t) {
  e.classList ? e.classList.add(t) : Y9(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function H2(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function q9(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = H2(e.className, t) : e.setAttribute("class", H2(e.className && e.className.baseVal || "", t));
}
const W2 = {
  disabled: !1
};
var K9 = process.env.NODE_ENV !== "production" ? o.oneOfType([o.number, o.shape({
  enter: o.number,
  exit: o.number,
  appear: o.number
}).isRequired]) : null, X9 = process.env.NODE_ENV !== "production" ? o.oneOfType([o.string, o.shape({
  enter: o.string,
  exit: o.string,
  active: o.string
}), o.shape({
  enter: o.string,
  enterDone: o.string,
  enterActive: o.string,
  exit: o.string,
  exitDone: o.string,
  exitActive: o.string
})]) : null;
const Nu = He.createContext(null);
var L4 = function(t) {
  return t.scrollTop;
}, bl = "unmounted", Cs = "exited", xs = "entering", aa = "entered", O0 = "exiting", dr = /* @__PURE__ */ function(e) {
  Tp(t, e);
  function t(r, i) {
    var s;
    s = e.call(this, r, i) || this;
    var a = i, l = a && !a.isMounting ? r.enter : r.appear, c;
    return s.appearStatus = null, r.in ? l ? (c = Cs, s.appearStatus = xs) : c = aa : r.unmountOnExit || r.mountOnEnter ? c = bl : c = Cs, s.state = {
      status: c
    }, s.nextCallback = null, s;
  }
  t.getDerivedStateFromProps = function(i, s) {
    var a = i.in;
    return a && s.status === bl ? {
      status: Cs
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(i) {
    var s = null;
    if (i !== this.props) {
      var a = this.state.status;
      this.props.in ? a !== xs && a !== aa && (s = xs) : (a === xs || a === aa) && (s = O0);
    }
    this.updateStatus(!1, s);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var i = this.props.timeout, s, a, l;
    return s = a = l = i, i != null && typeof i != "number" && (s = i.exit, a = i.enter, l = i.appear !== void 0 ? i.appear : a), {
      exit: s,
      enter: a,
      appear: l
    };
  }, n.updateStatus = function(i, s) {
    if (i === void 0 && (i = !1), s !== null)
      if (this.cancelNextCallback(), s === xs) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var a = this.props.nodeRef ? this.props.nodeRef.current : Zc.findDOMNode(this);
          a && L4(a);
        }
        this.performEnter(i);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === Cs && this.setState({
      status: bl
    });
  }, n.performEnter = function(i) {
    var s = this, a = this.props.enter, l = this.context ? this.context.isMounting : i, c = this.props.nodeRef ? [l] : [Zc.findDOMNode(this), l], u = c[0], f = c[1], g = this.getTimeouts(), h = l ? g.appear : g.enter;
    if (!i && !a || W2.disabled) {
      this.safeSetState({
        status: aa
      }, function() {
        s.props.onEntered(u);
      });
      return;
    }
    this.props.onEnter(u, f), this.safeSetState({
      status: xs
    }, function() {
      s.props.onEntering(u, f), s.onTransitionEnd(h, function() {
        s.safeSetState({
          status: aa
        }, function() {
          s.props.onEntered(u, f);
        });
      });
    });
  }, n.performExit = function() {
    var i = this, s = this.props.exit, a = this.getTimeouts(), l = this.props.nodeRef ? void 0 : Zc.findDOMNode(this);
    if (!s || W2.disabled) {
      this.safeSetState({
        status: Cs
      }, function() {
        i.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: O0
    }, function() {
      i.props.onExiting(l), i.onTransitionEnd(a.exit, function() {
        i.safeSetState({
          status: Cs
        }, function() {
          i.props.onExited(l);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(i, s) {
    s = this.setNextCallback(s), this.setState(i, s);
  }, n.setNextCallback = function(i) {
    var s = this, a = !0;
    return this.nextCallback = function(l) {
      a && (a = !1, s.nextCallback = null, i(l));
    }, this.nextCallback.cancel = function() {
      a = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(i, s) {
    this.setNextCallback(s);
    var a = this.props.nodeRef ? this.props.nodeRef.current : Zc.findDOMNode(this), l = i == null && !this.props.addEndListener;
    if (!a || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var c = this.props.nodeRef ? [this.nextCallback] : [a, this.nextCallback], u = c[0], f = c[1];
      this.props.addEndListener(u, f);
    }
    i != null && setTimeout(this.nextCallback, i);
  }, n.render = function() {
    var i = this.state.status;
    if (i === bl)
      return null;
    var s = this.props, a = s.children;
    s.in, s.mountOnEnter, s.unmountOnExit, s.appear, s.enter, s.exit, s.timeout, s.addEndListener, s.onEnter, s.onEntering, s.onEntered, s.onExit, s.onExiting, s.onExited, s.nodeRef;
    var l = Zt(s, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ He.createElement(Nu.Provider, {
        value: null
      }, typeof a == "function" ? a(i, l) : He.cloneElement(He.Children.only(a), l))
    );
  }, t;
}(He.Component);
dr.contextType = Nu;
dr.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: o.shape({
    current: typeof Element > "u" ? o.any : function(e, t, n, r, i, s) {
      var a = e[t];
      return o.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(e, t, n, r, i, s);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: o.oneOfType([o.func.isRequired, o.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: o.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: o.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: o.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: o.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: o.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: o.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = K9;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
      i[s - 1] = arguments[s];
    return n.apply(void 0, [t].concat(i));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: o.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: o.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: o.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: o.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: o.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: o.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: o.func
} : {};
function ea() {
}
dr.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: ea,
  onEntering: ea,
  onEntered: ea,
  onExit: ea,
  onExiting: ea,
  onExited: ea
};
dr.UNMOUNTED = bl;
dr.EXITED = Cs;
dr.ENTERING = xs;
dr.ENTERED = aa;
dr.EXITING = O0;
var Q9 = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return Z9(t, r);
  });
}, N1 = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return q9(t, r);
  });
}, Mp = /* @__PURE__ */ function(e) {
  Tp(t, e);
  function t() {
    for (var r, i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(s)) || this, r.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, r.onEnter = function(l, c) {
      var u = r.resolveArguments(l, c), f = u[0], g = u[1];
      r.removeClasses(f, "exit"), r.addClass(f, g ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(l, c);
    }, r.onEntering = function(l, c) {
      var u = r.resolveArguments(l, c), f = u[0], g = u[1], h = g ? "appear" : "enter";
      r.addClass(f, h, "active"), r.props.onEntering && r.props.onEntering(l, c);
    }, r.onEntered = function(l, c) {
      var u = r.resolveArguments(l, c), f = u[0], g = u[1], h = g ? "appear" : "enter";
      r.removeClasses(f, h), r.addClass(f, h, "done"), r.props.onEntered && r.props.onEntered(l, c);
    }, r.onExit = function(l) {
      var c = r.resolveArguments(l), u = c[0];
      r.removeClasses(u, "appear"), r.removeClasses(u, "enter"), r.addClass(u, "exit", "base"), r.props.onExit && r.props.onExit(l);
    }, r.onExiting = function(l) {
      var c = r.resolveArguments(l), u = c[0];
      r.addClass(u, "exit", "active"), r.props.onExiting && r.props.onExiting(l);
    }, r.onExited = function(l) {
      var c = r.resolveArguments(l), u = c[0];
      r.removeClasses(u, "exit"), r.addClass(u, "exit", "done"), r.props.onExited && r.props.onExited(l);
    }, r.resolveArguments = function(l, c) {
      return r.props.nodeRef ? [r.props.nodeRef.current, l] : [l, c];
    }, r.getClassNames = function(l) {
      var c = r.props.classNames, u = typeof c == "string", f = u && c ? c + "-" : "", g = u ? "" + f + l : c[l], h = u ? g + "-active" : c[l + "Active"], y = u ? g + "-done" : c[l + "Done"];
      return {
        baseClassName: g,
        activeClassName: h,
        doneClassName: y
      };
    }, r;
  }
  var n = t.prototype;
  return n.addClass = function(i, s, a) {
    var l = this.getClassNames(s)[a + "ClassName"], c = this.getClassNames("enter"), u = c.doneClassName;
    s === "appear" && a === "done" && u && (l += " " + u), a === "active" && i && L4(i), l && (this.appliedClasses[s][a] = l, Q9(i, l));
  }, n.removeClasses = function(i, s) {
    var a = this.appliedClasses[s], l = a.base, c = a.active, u = a.done;
    this.appliedClasses[s] = {}, l && N1(i, l), c && N1(i, c), u && N1(i, u);
  }, n.render = function() {
    var i = this.props;
    i.classNames;
    var s = Zt(i, ["classNames"]);
    return /* @__PURE__ */ He.createElement(dr, Q({}, s, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(He.Component);
Mp.defaultProps = {
  classNames: ""
};
Mp.propTypes = process.env.NODE_ENV !== "production" ? Q({}, dr.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: X9,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: o.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: o.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: o.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: o.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: o.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: o.func
}) : {};
function J9(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function kp(e, t) {
  var n = function(s) {
    return t && wl(s) ? t(s) : s;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && F6.map(e, function(i) {
    return i;
  }).forEach(function(i) {
    r[i.key] = n(i);
  }), r;
}
function ev(e, t) {
  e = e || {}, t = t || {};
  function n(f) {
    return f in t ? t[f] : e[f];
  }
  var r = /* @__PURE__ */ Object.create(null), i = [];
  for (var s in e)
    s in t ? i.length && (r[s] = i, i = []) : i.push(s);
  var a, l = {};
  for (var c in t) {
    if (r[c])
      for (a = 0; a < r[c].length; a++) {
        var u = r[c][a];
        l[r[c][a]] = n(u);
      }
    l[c] = n(c);
  }
  for (a = 0; a < i.length; a++)
    l[i[a]] = n(i[a]);
  return l;
}
function Ms(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function tv(e, t) {
  return kp(e.children, function(n) {
    return Sl(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Ms(n, "appear", e),
      enter: Ms(n, "enter", e),
      exit: Ms(n, "exit", e)
    });
  });
}
function nv(e, t, n) {
  var r = kp(e.children), i = ev(t, r);
  return Object.keys(i).forEach(function(s) {
    var a = i[s];
    if (wl(a)) {
      var l = s in t, c = s in r, u = t[s], f = wl(u) && !u.props.in;
      c && (!l || f) ? i[s] = Sl(a, {
        onExited: n.bind(null, a),
        in: !0,
        exit: Ms(a, "exit", e),
        enter: Ms(a, "enter", e)
      }) : !c && l && !f ? i[s] = Sl(a, {
        in: !1
      }) : c && l && wl(u) && (i[s] = Sl(a, {
        onExited: n.bind(null, a),
        in: u.props.in,
        exit: Ms(a, "exit", e),
        enter: Ms(a, "enter", e)
      }));
    }
  }), i;
}
var ov = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, rv = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, ac = /* @__PURE__ */ function(e) {
  Tp(t, e);
  function t(r, i) {
    var s;
    s = e.call(this, r, i) || this;
    var a = s.handleExited.bind(J9(s));
    return s.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, s;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(i, s) {
    var a = s.children, l = s.handleExited, c = s.firstRender;
    return {
      children: c ? tv(i, l) : nv(i, a, l),
      firstRender: !1
    };
  }, n.handleExited = function(i, s) {
    var a = kp(this.props.children);
    i.key in a || (i.props.onExited && i.props.onExited(s), this.mounted && this.setState(function(l) {
      var c = Q({}, l.children);
      return delete c[i.key], {
        children: c
      };
    }));
  }, n.render = function() {
    var i = this.props, s = i.component, a = i.childFactory, l = Zt(i, ["component", "childFactory"]), c = this.state.contextValue, u = ov(this.state.children).map(a);
    return delete l.appear, delete l.enter, delete l.exit, s === null ? /* @__PURE__ */ He.createElement(Nu.Provider, {
      value: c
    }, u) : /* @__PURE__ */ He.createElement(Nu.Provider, {
      value: c
    }, /* @__PURE__ */ He.createElement(s, l, u));
  }, t;
}(He.Component);
ac.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: o.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: o.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: o.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: o.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: o.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: o.func
} : {};
ac.defaultProps = rv;
const A4 = (e) => e.scrollTop;
function xa(e, t) {
  const {
    timeout: n,
    easing: r,
    style: i = {}
  } = e;
  return {
    duration: i.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: i.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: i.transitionDelay
  };
}
function iv(e) {
  return Pt("MuiCollapse", e);
}
Et("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const sv = (e) => {
  const {
    orientation: t,
    classes: n
  } = e, r = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return Ot(r, iv, n);
}, av = Z("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }
})(mt(({
  theme: e
}) => ({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: e.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.state === "exited" && !t.in && t.collapsedSize === "0px",
    style: {
      visibility: "hidden"
    }
  }]
}))), lv = Z("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), cv = Z("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), Bu = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: i,
    children: s,
    className: a,
    collapsedSize: l = "0px",
    component: c,
    easing: u,
    in: f,
    onEnter: g,
    onEntered: h,
    onEntering: y,
    onExit: v,
    onExited: m,
    onExiting: b,
    orientation: C = "vertical",
    style: E,
    timeout: S = O4.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: k = dr,
    ...T
  } = r, P = {
    ...r,
    orientation: C,
    collapsedSize: l
  }, F = sv(P), j = to(), L = Ts(), R = d.useRef(null), V = d.useRef(), B = typeof l == "number" ? `${l}px` : l, W = C === "horizontal", z = W ? "width" : "height", G = d.useRef(null), H = lo(n, G), ie = (te) => (ue) => {
    if (te) {
      const K = G.current;
      ue === void 0 ? te(K) : te(K, ue);
    }
  }, ce = () => R.current ? R.current[W ? "clientWidth" : "clientHeight"] : 0, re = ie((te, ue) => {
    R.current && W && (R.current.style.position = "absolute"), te.style[z] = B, g && g(te, ue);
  }), A = ie((te, ue) => {
    const K = ce();
    R.current && W && (R.current.style.position = "");
    const {
      duration: oe,
      easing: de
    } = xa({
      style: E,
      timeout: S,
      easing: u
    }, {
      mode: "enter"
    });
    if (S === "auto") {
      const ve = j.transitions.getAutoHeightDuration(K);
      te.style.transitionDuration = `${ve}ms`, V.current = ve;
    } else
      te.style.transitionDuration = typeof oe == "string" ? oe : `${oe}ms`;
    te.style[z] = `${K}px`, te.style.transitionTimingFunction = de, y && y(te, ue);
  }), Y = ie((te, ue) => {
    te.style[z] = "auto", h && h(te, ue);
  }), pe = ie((te) => {
    te.style[z] = `${ce()}px`, v && v(te);
  }), Ce = ie(m), fe = ie((te) => {
    const ue = ce(), {
      duration: K,
      easing: oe
    } = xa({
      style: E,
      timeout: S,
      easing: u
    }, {
      mode: "exit"
    });
    if (S === "auto") {
      const de = j.transitions.getAutoHeightDuration(ue);
      te.style.transitionDuration = `${de}ms`, V.current = de;
    } else
      te.style.transitionDuration = typeof K == "string" ? K : `${K}ms`;
    te.style[z] = B, te.style.transitionTimingFunction = oe, b && b(te);
  }), ee = (te) => {
    S === "auto" && L.start(V.current || 0, te), i && i(G.current, te);
  };
  return /* @__PURE__ */ p.jsx(k, {
    in: f,
    onEnter: re,
    onEntered: Y,
    onEntering: A,
    onExit: pe,
    onExited: Ce,
    onExiting: fe,
    addEndListener: ee,
    nodeRef: G,
    timeout: S === "auto" ? null : S,
    ...T,
    children: (te, {
      ownerState: ue,
      ...K
    }) => /* @__PURE__ */ p.jsx(av, {
      as: c,
      className: xe(F.root, a, {
        entered: F.entered,
        exited: !f && B === "0px" && F.hidden
      }[te]),
      style: {
        [W ? "minWidth" : "minHeight"]: B,
        ...E
      },
      ref: H,
      ownerState: {
        ...P,
        state: te
      },
      ...K,
      children: /* @__PURE__ */ p.jsx(lv, {
        ownerState: {
          ...P,
          state: te
        },
        className: F.wrapper,
        ref: R,
        children: /* @__PURE__ */ p.jsx(cv, {
          ownerState: {
            ...P,
            state: te
          },
          className: F.wrapperInner,
          children: s
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Bu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: o.func,
  /**
   * The content node to be collapsed.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: o.oneOfType([o.number, o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: rc,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: o.oneOfType([o.shape({
    enter: o.string,
    exit: o.string
  }), o.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: o.bool,
  /**
   * @ignore
   */
  onEnter: o.func,
  /**
   * @ignore
   */
  onEntered: o.func,
  /**
   * @ignore
   */
  onEntering: o.func,
  /**
   * @ignore
   */
  onExit: o.func,
  /**
   * @ignore
   */
  onExited: o.func,
  /**
   * @ignore
   */
  onExiting: o.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: o.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: o.oneOfType([o.oneOf(["auto"]), o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })])
});
Bu && (Bu.muiSupportAuto = !0);
function uv(e) {
  return Pt("MuiPaper", e);
}
Et("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const dv = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: i
  } = e, s = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return Ot(s, uv, i);
}, pv = Z("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(mt(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), li = /* @__PURE__ */ d.forwardRef(function(t, n) {
  var y;
  const r = Vt({
    props: t,
    name: "MuiPaper"
  }), i = to(), {
    className: s,
    component: a = "div",
    elevation: l = 1,
    square: c = !1,
    variant: u = "elevation",
    ...f
  } = r, g = {
    ...r,
    component: a,
    elevation: l,
    square: c,
    variant: u
  }, h = dv(g);
  return process.env.NODE_ENV !== "production" && i.shadows[l] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${l}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${l}]\` is defined.`].join(`
`)), /* @__PURE__ */ p.jsx(pv, {
    as: a,
    ownerState: g,
    className: xe(h.root, s),
    ref: n,
    ...f,
    style: {
      ...u === "elevation" && {
        "--Paper-shadow": (i.vars || i).shadows[l],
        ...i.vars && {
          "--Paper-overlay": (y = i.vars.overlays) == null ? void 0 : y[l]
        },
        ...!i.vars && i.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${At("#fff", P0(l))}, ${At("#fff", P0(l))})`
        }
      },
      ...f.style
    }
  });
});
process.env.NODE_ENV !== "production" && (li.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: nr(Fr, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: o.bool,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: o.oneOfType([o.oneOf(["elevation", "outlined"]), o.string])
});
function kt(e, t) {
  const {
    className: n,
    elementType: r,
    ownerState: i,
    externalForwardedProps: s,
    internalForwardedProps: a,
    shouldForwardComponentProp: l = !1,
    ...c
  } = t, {
    component: u,
    slots: f = {
      [e]: void 0
    },
    slotProps: g = {
      [e]: void 0
    },
    ...h
  } = s, y = f[e] || r, v = w4(g[e], i), {
    props: {
      component: m,
      ...b
    },
    internalRef: C
  } = x4({
    className: n,
    ...c,
    externalForwardedProps: e === "root" ? h : void 0,
    externalSlotProps: v
  }), E = lo(C, v == null ? void 0 : v.ref, t.ref), S = e === "root" ? m || u : m, k = C4(y, {
    ...e === "root" && !u && !f[e] && a,
    ...e !== "root" && !f[e] && a,
    ...b,
    ...S && !l && {
      as: S
    },
    ...S && l && {
      component: S
    },
    ref: E
  }, i);
  return [y, k];
}
class _u {
  constructor() {
    Ua(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new _u();
  }
  static use() {
    const t = m4(_u.create).current, [n, r] = d.useState(!1);
    return t.shouldMount = n, t.setShouldMount = r, d.useEffect(t.mountEffect, [n]), t;
  }
  mount() {
    return this.mounted || (this.mounted = gv(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.pulsate(...t);
    });
  }
}
function fv() {
  return _u.use();
}
function gv() {
  let e, t;
  const n = new Promise((r, i) => {
    e = r, t = i;
  });
  return n.resolve = e, n.reject = t, n;
}
function N4(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: i,
    rippleY: s,
    rippleSize: a,
    in: l,
    onExited: c,
    timeout: u
  } = e, [f, g] = d.useState(!1), h = xe(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), y = {
    width: a,
    height: a,
    top: -(a / 2) + s,
    left: -(a / 2) + i
  }, v = xe(n.child, f && n.childLeaving, r && n.childPulsate);
  return !l && !f && g(!0), d.useEffect(() => {
    if (!l && c != null) {
      const m = setTimeout(c, u);
      return () => {
        clearTimeout(m);
      };
    }
  }, [c, l, u]), /* @__PURE__ */ p.jsx("span", {
    className: h,
    style: y,
    children: /* @__PURE__ */ p.jsx("span", {
      className: v
    })
  });
}
process.env.NODE_ENV !== "production" && (N4.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object.isRequired,
  className: o.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: o.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: o.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: o.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: o.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: o.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: o.number,
  /**
   * exit delay
   */
  timeout: o.number.isRequired
});
const vr = Et("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), D0 = 550, mv = 80, hv = si`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, vv = si`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, yv = si`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, bv = Z("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), Cv = Z(N4, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${vr.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${hv};
    animation-duration: ${D0}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${vr.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${vr.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${vr.childLeaving} {
    opacity: 0;
    animation-name: ${vv};
    animation-duration: ${D0}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${vr.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${yv};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, B4 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: i = !1,
    classes: s = {},
    className: a,
    ...l
  } = r, [c, u] = d.useState([]), f = d.useRef(0), g = d.useRef(null);
  d.useEffect(() => {
    g.current && (g.current(), g.current = null);
  }, [c]);
  const h = d.useRef(!1), y = Ts(), v = d.useRef(null), m = d.useRef(null), b = d.useCallback((k) => {
    const {
      pulsate: T,
      rippleX: P,
      rippleY: F,
      rippleSize: j,
      cb: L
    } = k;
    u((R) => [...R, /* @__PURE__ */ p.jsx(Cv, {
      classes: {
        ripple: xe(s.ripple, vr.ripple),
        rippleVisible: xe(s.rippleVisible, vr.rippleVisible),
        ripplePulsate: xe(s.ripplePulsate, vr.ripplePulsate),
        child: xe(s.child, vr.child),
        childLeaving: xe(s.childLeaving, vr.childLeaving),
        childPulsate: xe(s.childPulsate, vr.childPulsate)
      },
      timeout: D0,
      pulsate: T,
      rippleX: P,
      rippleY: F,
      rippleSize: j
    }, f.current)]), f.current += 1, g.current = L;
  }, [s]), C = d.useCallback((k = {}, T = {}, P = () => {
  }) => {
    const {
      pulsate: F = !1,
      center: j = i || T.pulsate,
      fakeElement: L = !1
      // For test purposes
    } = T;
    if ((k == null ? void 0 : k.type) === "mousedown" && h.current) {
      h.current = !1;
      return;
    }
    (k == null ? void 0 : k.type) === "touchstart" && (h.current = !0);
    const R = L ? null : m.current, V = R ? R.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let B, W, z;
    if (j || k === void 0 || k.clientX === 0 && k.clientY === 0 || !k.clientX && !k.touches)
      B = Math.round(V.width / 2), W = Math.round(V.height / 2);
    else {
      const {
        clientX: G,
        clientY: H
      } = k.touches && k.touches.length > 0 ? k.touches[0] : k;
      B = Math.round(G - V.left), W = Math.round(H - V.top);
    }
    if (j)
      z = Math.sqrt((2 * V.width ** 2 + V.height ** 2) / 3), z % 2 === 0 && (z += 1);
    else {
      const G = Math.max(Math.abs((R ? R.clientWidth : 0) - B), B) * 2 + 2, H = Math.max(Math.abs((R ? R.clientHeight : 0) - W), W) * 2 + 2;
      z = Math.sqrt(G ** 2 + H ** 2);
    }
    k != null && k.touches ? v.current === null && (v.current = () => {
      b({
        pulsate: F,
        rippleX: B,
        rippleY: W,
        rippleSize: z,
        cb: P
      });
    }, y.start(mv, () => {
      v.current && (v.current(), v.current = null);
    })) : b({
      pulsate: F,
      rippleX: B,
      rippleY: W,
      rippleSize: z,
      cb: P
    });
  }, [i, b, y]), E = d.useCallback(() => {
    C({}, {
      pulsate: !0
    });
  }, [C]), S = d.useCallback((k, T) => {
    if (y.clear(), (k == null ? void 0 : k.type) === "touchend" && v.current) {
      v.current(), v.current = null, y.start(0, () => {
        S(k, T);
      });
      return;
    }
    v.current = null, u((P) => P.length > 0 ? P.slice(1) : P), g.current = T;
  }, [y]);
  return d.useImperativeHandle(n, () => ({
    pulsate: E,
    start: C,
    stop: S
  }), [E, C, S]), /* @__PURE__ */ p.jsx(bv, {
    className: xe(vr.root, s.root, a),
    ref: m,
    ...l,
    children: /* @__PURE__ */ p.jsx(ac, {
      component: null,
      exit: !0,
      children: c
    })
  });
});
process.env.NODE_ENV !== "production" && (B4.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string
});
function xv(e) {
  return Pt("MuiButtonBase", e);
}
const wv = Et("MuiButtonBase", ["root", "disabled", "focusVisible"]), Sv = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: i
  } = e, a = Ot({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, xv, i);
  return n && r && (a.root += ` ${r}`), a;
}, Ev = Z("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${wv.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Tr = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: i,
    centerRipple: s = !1,
    children: a,
    className: l,
    component: c = "button",
    disabled: u = !1,
    disableRipple: f = !1,
    disableTouchRipple: g = !1,
    focusRipple: h = !1,
    focusVisibleClassName: y,
    LinkComponent: v = "a",
    onBlur: m,
    onClick: b,
    onContextMenu: C,
    onDragLeave: E,
    onFocus: S,
    onFocusVisible: k,
    onKeyDown: T,
    onKeyUp: P,
    onMouseDown: F,
    onMouseLeave: j,
    onMouseUp: L,
    onTouchEnd: R,
    onTouchMove: V,
    onTouchStart: B,
    tabIndex: W = 0,
    TouchRippleProps: z,
    touchRippleRef: G,
    type: H,
    ...ie
  } = r, ce = d.useRef(null), re = fv(), A = lo(re.ref, G), [Y, pe] = d.useState(!1);
  u && Y && pe(!1), d.useImperativeHandle(i, () => ({
    focusVisible: () => {
      pe(!0), ce.current.focus();
    }
  }), []);
  const Ce = re.shouldMount && !f && !u;
  d.useEffect(() => {
    Y && h && !f && re.pulsate();
  }, [f, h, Y, re]);
  const fe = mi(re, "start", F, g), ee = mi(re, "stop", C, g), te = mi(re, "stop", E, g), ue = mi(re, "stop", L, g), K = mi(re, "stop", (Fe) => {
    Y && Fe.preventDefault(), j && j(Fe);
  }, g), oe = mi(re, "start", B, g), de = mi(re, "stop", R, g), ve = mi(re, "stop", V, g), J = mi(re, "stop", (Fe) => {
    is(Fe.target) || pe(!1), m && m(Fe);
  }, !1), se = Eo((Fe) => {
    ce.current || (ce.current = Fe.currentTarget), is(Fe.target) && (pe(!0), k && k(Fe)), S && S(Fe);
  }), ge = () => {
    const Fe = ce.current;
    return c && c !== "button" && !(Fe.tagName === "A" && Fe.href);
  }, Se = Eo((Fe) => {
    h && !Fe.repeat && Y && Fe.key === " " && re.stop(Fe, () => {
      re.start(Fe);
    }), Fe.target === Fe.currentTarget && ge() && Fe.key === " " && Fe.preventDefault(), T && T(Fe), Fe.target === Fe.currentTarget && ge() && Fe.key === "Enter" && !u && (Fe.preventDefault(), b && b(Fe));
  }), we = Eo((Fe) => {
    h && Fe.key === " " && Y && !Fe.defaultPrevented && re.stop(Fe, () => {
      re.pulsate(Fe);
    }), P && P(Fe), b && Fe.target === Fe.currentTarget && ge() && Fe.key === " " && !Fe.defaultPrevented && b(Fe);
  });
  let me = c;
  me === "button" && (ie.href || ie.to) && (me = v);
  const ye = {};
  me === "button" ? (ye.type = H === void 0 ? "button" : H, ye.disabled = u) : (!ie.href && !ie.to && (ye.role = "button"), u && (ye["aria-disabled"] = u));
  const Ie = lo(n, ce), je = {
    ...r,
    centerRipple: s,
    component: c,
    disabled: u,
    disableRipple: f,
    disableTouchRipple: g,
    focusRipple: h,
    tabIndex: W,
    focusVisible: Y
  }, Te = Sv(je);
  return /* @__PURE__ */ p.jsxs(Ev, {
    as: me,
    className: xe(Te.root, l),
    ownerState: je,
    onBlur: J,
    onClick: b,
    onContextMenu: ee,
    onFocus: se,
    onKeyDown: Se,
    onKeyUp: we,
    onMouseDown: fe,
    onMouseLeave: K,
    onMouseUp: ue,
    onDragLeave: te,
    onTouchEnd: de,
    onTouchMove: ve,
    onTouchStart: oe,
    ref: Ie,
    tabIndex: u ? -1 : W,
    type: H,
    ...ye,
    ...ie,
    children: [a, Ce ? /* @__PURE__ */ p.jsx(B4, {
      ref: A,
      center: s,
      ...z
    }) : null]
  });
});
function mi(e, t, n, r = !1) {
  return Eo((i) => (n && n(i), r || e[t](i), !0));
}
process.env.NODE_ENV !== "production" && (Tr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: qo,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: o.bool,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: rc,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: o.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: o.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: o.string,
  /**
   * @ignore
   */
  href: o.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: o.elementType,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * @ignore
   */
  onContextMenu: o.func,
  /**
   * @ignore
   */
  onDragLeave: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: o.func,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * @ignore
   */
  onKeyUp: o.func,
  /**
   * @ignore
   */
  onMouseDown: o.func,
  /**
   * @ignore
   */
  onMouseLeave: o.func,
  /**
   * @ignore
   */
  onMouseUp: o.func,
  /**
   * @ignore
   */
  onTouchEnd: o.func,
  /**
   * @ignore
   */
  onTouchMove: o.func,
  /**
   * @ignore
   */
  onTouchStart: o.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @default 0
   */
  tabIndex: o.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: o.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      pulsate: o.func.isRequired,
      start: o.func.isRequired,
      stop: o.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: o.oneOfType([o.oneOf(["button", "reset", "submit"]), o.string])
});
function Rv(e) {
  return typeof e.main == "string";
}
function Tv(e, t = []) {
  if (!Rv(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function Mn(e = []) {
  return ([, t]) => t && Tv(t, e);
}
function Mv(e) {
  return Pt("MuiAlert", e);
}
const G2 = Et("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
function kv(e) {
  return Pt("MuiCircularProgress", e);
}
Et("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const Ui = 44, j0 = si`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, F0 = si`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, Pv = typeof j0 != "string" ? ki`
        animation: ${j0} 1.4s linear infinite;
      ` : null, Iv = typeof F0 != "string" ? ki`
        animation: ${F0} 1.4s ease-in-out infinite;
      ` : null, Ov = (e) => {
  const {
    classes: t,
    variant: n,
    color: r,
    disableShrink: i
  } = e, s = {
    root: ["root", n, `color${be(r)}`],
    svg: ["svg"],
    circle: ["circle", `circle${be(n)}`, i && "circleDisableShrink"]
  };
  return Ot(s, kv, t);
}, Dv = Z("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${be(n.color)}`]];
  }
})(mt(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: Pv || {
      animation: `${j0} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), jv = Z("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), Fv = Z("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${be(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})(mt(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: Iv || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${F0} 1.4s ease-in-out infinite`
    }
  }]
}))), zs = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: i,
    color: s = "primary",
    disableShrink: a = !1,
    size: l = 40,
    style: c,
    thickness: u = 3.6,
    value: f = 0,
    variant: g = "indeterminate",
    ...h
  } = r, y = {
    ...r,
    color: s,
    disableShrink: a,
    size: l,
    thickness: u,
    value: f,
    variant: g
  }, v = Ov(y), m = {}, b = {}, C = {};
  if (g === "determinate") {
    const E = 2 * Math.PI * ((Ui - u) / 2);
    m.strokeDasharray = E.toFixed(3), C["aria-valuenow"] = Math.round(f), m.strokeDashoffset = `${((100 - f) / 100 * E).toFixed(3)}px`, b.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ p.jsx(Dv, {
    className: xe(v.root, i),
    style: {
      width: l,
      height: l,
      ...b,
      ...c
    },
    ownerState: y,
    ref: n,
    role: "progressbar",
    ...C,
    ...h,
    children: /* @__PURE__ */ p.jsx(jv, {
      className: v.svg,
      ownerState: y,
      viewBox: `${Ui / 2} ${Ui / 2} ${Ui} ${Ui}`,
      children: /* @__PURE__ */ p.jsx(Fv, {
        className: v.circle,
        style: m,
        ownerState: y,
        cx: Ui,
        cy: Ui,
        r: (Ui - u) / 2,
        fill: "none",
        strokeWidth: u
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (zs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: nr(o.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: o.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: o.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: o.oneOf(["determinate", "indeterminate"])
});
function Vv(e) {
  return Pt("MuiIconButton", e);
}
const U2 = Et("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), $v = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: i,
    size: s,
    loading: a
  } = e, l = {
    root: ["root", a && "loading", n && "disabled", r !== "default" && `color${be(r)}`, i && `edge${be(i)}`, `size${be(s)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return Ot(l, Vv, t);
}, Lv = Z(Tr, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.loading && t.loading, n.color !== "default" && t[`color${be(n.color)}`], n.edge && t[`edge${be(n.edge)}`], t[`size${be(n.size)}`]];
  }
})(mt(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), mt(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : At((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${U2.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${U2.loading}`]: {
    color: "transparent"
  }
}))), Av = Z("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), Ar = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: i = !1,
    children: s,
    className: a,
    color: l = "default",
    disabled: c = !1,
    disableFocusRipple: u = !1,
    size: f = "medium",
    id: g,
    loading: h = null,
    loadingIndicator: y,
    ...v
  } = r, m = ai(g), b = y ?? /* @__PURE__ */ p.jsx(zs, {
    "aria-labelledby": m,
    color: "inherit",
    size: 16
  }), C = {
    ...r,
    edge: i,
    color: l,
    disabled: c,
    disableFocusRipple: u,
    loading: h,
    loadingIndicator: b,
    size: f
  }, E = $v(C);
  return /* @__PURE__ */ p.jsxs(Lv, {
    id: h ? m : g,
    className: xe(E.root, a),
    centerRipple: !0,
    focusRipple: !u,
    disabled: c || h,
    ref: n,
    ...v,
    ownerState: C,
    children: [typeof h == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ p.jsx("span", {
      className: E.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ p.jsx(Av, {
        className: E.loadingIndicator,
        ownerState: C,
        children: h && b
      })
    }), s]
  });
});
process.env.NODE_ENV !== "production" && (Ar.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: nr(o.node, (e) => d.Children.toArray(e.children).some((n) => /* @__PURE__ */ d.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: o.oneOfType([o.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: o.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: o.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: o.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: o.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const Nv = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), Bv = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), _v = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), zv = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), _4 = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), Hv = (e) => {
  const {
    variant: t,
    color: n,
    severity: r,
    classes: i
  } = e, s = {
    root: ["root", `color${be(n || r)}`, `${t}${be(n || r)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return Ot(s, Mv, i);
}, Wv = Z(li, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${be(n.color || n.severity)}`]];
  }
})(mt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? Ii : Oi, n = e.palette.mode === "light" ? Oi : Ii;
  return {
    ...e.typography.body2,
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter(Mn(["light"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${r}Color`] : t(e.palette[r].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${r}StandardBg`] : n(e.palette[r].light, 0.9),
        [`& .${G2.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${r}IconColor`]
        } : {
          color: e.palette[r].main
        }
      }
    })), ...Object.entries(e.palette).filter(Mn(["light"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${r}Color`] : t(e.palette[r].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[r].light}`,
        [`& .${G2.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${r}IconColor`]
        } : {
          color: e.palette[r].main
        }
      }
    })), ...Object.entries(e.palette).filter(Mn(["dark"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "filled"
      },
      style: {
        fontWeight: e.typography.fontWeightMedium,
        ...e.vars ? {
          color: e.vars.palette.Alert[`${r}FilledColor`],
          backgroundColor: e.vars.palette.Alert[`${r}FilledBg`]
        } : {
          backgroundColor: e.palette.mode === "dark" ? e.palette[r].dark : e.palette[r].main,
          color: e.palette.getContrastText(e.palette[r].main)
        }
      }
    }))]
  };
})), Gv = Z("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), Uv = Z("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), Yv = Z("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), Y2 = {
  success: /* @__PURE__ */ p.jsx(Nv, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ p.jsx(Bv, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ p.jsx(_v, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ p.jsx(zv, {
    fontSize: "inherit"
  })
}, z4 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiAlert"
  }), {
    action: i,
    children: s,
    className: a,
    closeText: l = "Close",
    color: c,
    components: u = {},
    componentsProps: f = {},
    icon: g,
    iconMapping: h = Y2,
    onClose: y,
    role: v = "alert",
    severity: m = "success",
    slotProps: b = {},
    slots: C = {},
    variant: E = "standard",
    ...S
  } = r, k = {
    ...r,
    color: c,
    severity: m,
    variant: E,
    colorSeverity: c || m
  }, T = Hv(k), P = {
    slots: {
      closeButton: u.CloseButton,
      closeIcon: u.CloseIcon,
      ...C
    },
    slotProps: {
      ...f,
      ...b
    }
  }, [F, j] = kt("root", {
    ref: n,
    shouldForwardComponentProp: !0,
    className: xe(T.root, a),
    elementType: Wv,
    externalForwardedProps: {
      ...P,
      ...S
    },
    ownerState: k,
    additionalProps: {
      role: v,
      elevation: 0
    }
  }), [L, R] = kt("icon", {
    className: T.icon,
    elementType: Gv,
    externalForwardedProps: P,
    ownerState: k
  }), [V, B] = kt("message", {
    className: T.message,
    elementType: Uv,
    externalForwardedProps: P,
    ownerState: k
  }), [W, z] = kt("action", {
    className: T.action,
    elementType: Yv,
    externalForwardedProps: P,
    ownerState: k
  }), [G, H] = kt("closeButton", {
    elementType: Ar,
    externalForwardedProps: P,
    ownerState: k
  }), [ie, ce] = kt("closeIcon", {
    elementType: _4,
    externalForwardedProps: P,
    ownerState: k
  });
  return /* @__PURE__ */ p.jsxs(F, {
    ...j,
    children: [g !== !1 ? /* @__PURE__ */ p.jsx(L, {
      ...R,
      children: g || h[m] || Y2[m]
    }) : null, /* @__PURE__ */ p.jsx(V, {
      ...B,
      children: s
    }), i != null ? /* @__PURE__ */ p.jsx(W, {
      ...z,
      children: i
    }) : null, i == null && y ? /* @__PURE__ */ p.jsx(W, {
      ...z,
      children: /* @__PURE__ */ p.jsx(G, {
        size: "small",
        "aria-label": l,
        title: l,
        color: "inherit",
        onClick: y,
        ...H,
        children: /* @__PURE__ */ p.jsx(ie, {
          fontSize: "small",
          ...ce
        })
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (z4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: o.node,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: o.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: o.oneOfType([o.oneOf(["error", "info", "success", "warning"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    CloseButton: o.elementType,
    CloseIcon: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    closeButton: o.object,
    closeIcon: o.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: o.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: o.shape({
    error: o.node,
    info: o.node,
    success: o.node,
    warning: o.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: o.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: o.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: o.oneOfType([o.oneOf(["error", "info", "success", "warning"]), o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    action: o.oneOfType([o.func, o.object]),
    closeButton: o.oneOfType([o.func, o.object]),
    closeIcon: o.oneOfType([o.func, o.object]),
    icon: o.oneOfType([o.func, o.object]),
    message: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    action: o.elementType,
    closeButton: o.elementType,
    closeIcon: o.elementType,
    icon: o.elementType,
    message: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: o.oneOfType([o.oneOf(["filled", "outlined", "standard"]), o.string])
});
function Zv(e) {
  return Pt("MuiTypography", e);
}
const Z2 = Et("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), qv = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, Kv = H9(), Xv = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: i,
    variant: s,
    classes: a
  } = e, l = {
    root: ["root", s, e.align !== "inherit" && `align${be(t)}`, n && "gutterBottom", r && "noWrap", i && "paragraph"]
  };
  return Ot(l, Zv, a);
}, Qv = Z("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${be(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(mt(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([n, r]) => n !== "inherit" && r && typeof r == "object").map(([n, r]) => ({
      props: {
        variant: n
      },
      style: r
    })), ...Object.entries(e.palette).filter(Mn()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, n]) => typeof n == "string").map(([n]) => ({
      props: {
        color: `text${be(n)}`
      },
      style: {
        color: (e.vars || e).palette.text[n]
      }
    })), {
      props: ({
        ownerState: n
      }) => n.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), q2 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, vo = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    color: r,
    ...i
  } = Vt({
    props: t,
    name: "MuiTypography"
  }), s = !qv[r], a = Kv({
    ...i,
    ...s && {
      color: r
    }
  }), {
    align: l = "inherit",
    className: c,
    component: u,
    gutterBottom: f = !1,
    noWrap: g = !1,
    paragraph: h = !1,
    variant: y = "body1",
    variantMapping: v = q2,
    ...m
  } = a, b = {
    ...a,
    align: l,
    color: r,
    className: c,
    component: u,
    gutterBottom: f,
    noWrap: g,
    paragraph: h,
    variant: y,
    variantMapping: v
  }, C = u || (h ? "p" : v[y] || q2[y]) || "span", E = Xv(b);
  return /* @__PURE__ */ p.jsx(Qv, {
    as: C,
    ref: n,
    className: xe(E.root, c),
    ...m,
    ownerState: b,
    style: {
      ...l !== "inherit" && {
        "--Typography-textAlign": l
      },
      ...m.style
    }
  });
});
process.env.NODE_ENV !== "production" && (vo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: o.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: o.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: o.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: o.bool,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: o.oneOfType([o.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), o.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: o.object
});
function K2(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function H4(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: r,
    matchFrom: i = "any",
    stringify: s,
    trim: a = !1
  } = e;
  return (l, {
    inputValue: c,
    getOptionLabel: u
  }) => {
    let f = a ? c.trim() : c;
    n && (f = f.toLowerCase()), t && (f = K2(f));
    const g = f ? l.filter((h) => {
      let y = (s || u)(h);
      return n && (y = y.toLowerCase()), t && (y = K2(y)), i === "start" ? y.startsWith(f) : y.includes(f);
    }) : l;
    return typeof r == "number" ? g.slice(0, r) : g;
  };
}
const Jv = H4(), X2 = 5, ey = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, ty = [];
function Q2(e, t, n) {
  if (t || e == null)
    return "";
  const r = n(e);
  return typeof r == "string" ? r : "";
}
function ny(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = ey,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: r = !1,
    autoHighlight: i = !1,
    autoSelect: s = !1,
    blurOnSelect: a = !1,
    clearOnBlur: l = !e.freeSolo,
    clearOnEscape: c = !1,
    componentName: u = "useAutocomplete",
    defaultValue: f = e.multiple ? ty : null,
    disableClearable: g = !1,
    disableCloseOnSelect: h = !1,
    disabled: y,
    disabledItemsFocusable: v = !1,
    disableListWrap: m = !1,
    filterOptions: b = Jv,
    filterSelectedOptions: C = !1,
    freeSolo: E = !1,
    getOptionDisabled: S,
    getOptionKey: k,
    getOptionLabel: T = (Le) => Le.label ?? Le,
    groupBy: P,
    handleHomeEndKeys: F = !e.freeSolo,
    id: j,
    includeInputInList: L = !1,
    inputValue: R,
    isOptionEqualToValue: V = (Le, Pe) => Le === Pe,
    multiple: B = !1,
    onChange: W,
    onClose: z,
    onHighlightChange: G,
    onInputChange: H,
    onOpen: ie,
    open: ce,
    openOnFocus: re = !1,
    options: A,
    readOnly: Y = !1,
    selectOnFocus: pe = !e.freeSolo,
    value: Ce
  } = e, fe = ai(j);
  let ee = T;
  ee = (Le) => {
    const Pe = T(Le);
    if (typeof Pe != "string") {
      if (process.env.NODE_ENV !== "production") {
        const ot = Pe === void 0 ? "undefined" : `${typeof Pe} (${Pe})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${u} returned ${ot} instead of a string for ${JSON.stringify(Le)}.`);
      }
      return String(Pe);
    }
    return Pe;
  };
  const te = d.useRef(!1), ue = d.useRef(!0), K = d.useRef(null), oe = d.useRef(null), [de, ve] = d.useState(null), [J, se] = d.useState(-1), ge = i ? 0 : -1, Se = d.useRef(ge), we = d.useRef(Q2(f ?? Ce, B, ee)).current, [me, ye] = Xr({
    controlled: Ce,
    default: f,
    name: u
  }), [Ie, je] = Xr({
    controlled: R,
    default: we,
    name: u,
    state: "inputValue"
  }), [Te, Fe] = d.useState(!1), gt = d.useCallback((Le, Pe, ot) => {
    if (!(B ? me.length < Pe.length : Pe !== null) && !l)
      return;
    const dn = Q2(Pe, B, ee);
    Ie !== dn && (je(dn), H && H(Le, dn, ot));
  }, [ee, Ie, B, H, je, l, me]), [Dt, ke] = Xr({
    controlled: ce,
    default: !1,
    name: u,
    state: "open"
  }), [Ne, We] = d.useState(!0), Ge = !B && me != null && Ie === ee(me), Qe = Dt && !Y, Ve = Qe ? b(
    A.filter((Le) => !(C && (B ? me : [me]).some((Pe) => Pe !== null && V(Le, Pe)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Ge && Ne ? "" : Ie,
      getOptionLabel: ee
    }
  ) : [], Ke = Cp({
    filteredOptions: Ve,
    value: me,
    inputValue: Ie
  });
  d.useEffect(() => {
    const Le = me !== Ke.value;
    Te && !Le || E && !Le || gt(null, me, "reset");
  }, [me, gt, Te, Ke.value, E]);
  const bt = Dt && Ve.length > 0 && !Y, vt = Eo((Le) => {
    Le === -1 ? K.current.focus() : de.querySelector(`[data-tag-index="${Le}"]`).focus();
  });
  d.useEffect(() => {
    B && J > me.length - 1 && (se(-1), vt(-1));
  }, [me, B, J, vt]);
  function tn(Le, Pe) {
    if (!oe.current || Le < 0 || Le >= Ve.length)
      return -1;
    let ot = Le;
    for (; ; ) {
      const Qt = oe.current.querySelector(`[data-option-index="${ot}"]`), dn = v ? !1 : !Qt || Qt.disabled || Qt.getAttribute("aria-disabled") === "true";
      if (Qt && Qt.hasAttribute("tabindex") && !dn)
        return ot;
      if (Pe === "next" ? ot = (ot + 1) % Ve.length : ot = (ot - 1 + Ve.length) % Ve.length, ot === Le)
        return -1;
    }
  }
  const hn = Eo(({
    event: Le,
    index: Pe,
    reason: ot
  }) => {
    if (Se.current = Pe, Pe === -1 ? K.current.removeAttribute("aria-activedescendant") : K.current.setAttribute("aria-activedescendant", `${fe}-option-${Pe}`), G && ["mouse", "keyboard", "touch"].includes(ot) && G(Le, Pe === -1 ? null : Ve[Pe], ot), !oe.current)
      return;
    const Qt = oe.current.querySelector(`[role="option"].${n}-focused`);
    Qt && (Qt.classList.remove(`${n}-focused`), Qt.classList.remove(`${n}-focusVisible`));
    let dn = oe.current;
    if (oe.current.getAttribute("role") !== "listbox" && (dn = oe.current.parentElement.querySelector('[role="listbox"]')), !dn)
      return;
    if (Pe === -1) {
      dn.scrollTop = 0;
      return;
    }
    const xn = oe.current.querySelector(`[data-option-index="${Pe}"]`);
    if (xn && (xn.classList.add(`${n}-focused`), ot === "keyboard" && xn.classList.add(`${n}-focusVisible`), dn.scrollHeight > dn.clientHeight && ot !== "mouse" && ot !== "touch")) {
      const Qn = xn, Ro = dn.clientHeight + dn.scrollTop, pi = Qn.offsetTop + Qn.offsetHeight;
      pi > Ro ? dn.scrollTop = pi - dn.clientHeight : Qn.offsetTop - Qn.offsetHeight * (P ? 1.3 : 0) < dn.scrollTop && (dn.scrollTop = Qn.offsetTop - Qn.offsetHeight * (P ? 1.3 : 0));
    }
  }), Je = Eo(({
    event: Le,
    diff: Pe,
    direction: ot = "next",
    reason: Qt
  }) => {
    if (!Qe)
      return;
    const xn = tn((() => {
      const Qn = Ve.length - 1;
      if (Pe === "reset")
        return ge;
      if (Pe === "start")
        return 0;
      if (Pe === "end")
        return Qn;
      const Ro = Se.current + Pe;
      return Ro < 0 ? Ro === -1 && L ? -1 : m && Se.current !== -1 || Math.abs(Pe) > 1 ? 0 : Qn : Ro > Qn ? Ro === Qn + 1 && L ? -1 : m || Math.abs(Pe) > 1 ? Qn : 0 : Ro;
    })(), ot);
    if (hn({
      index: xn,
      reason: Qt,
      event: Le
    }), r && Pe !== "reset")
      if (xn === -1)
        K.current.value = Ie;
      else {
        const Qn = ee(Ve[xn]);
        K.current.value = Qn, Qn.toLowerCase().indexOf(Ie.toLowerCase()) === 0 && Ie.length > 0 && K.current.setSelectionRange(Ie.length, Qn.length);
      }
  }), $t = () => {
    const Le = (Pe, ot) => {
      const Qt = Pe ? ee(Pe) : "", dn = ot ? ee(ot) : "";
      return Qt === dn;
    };
    if (Se.current !== -1 && Ke.filteredOptions && Ke.filteredOptions.length !== Ve.length && Ke.inputValue === Ie && (B ? me.length === Ke.value.length && Ke.value.every((Pe, ot) => ee(me[ot]) === ee(Pe)) : Le(Ke.value, me))) {
      const Pe = Ke.filteredOptions[Se.current];
      if (Pe)
        return Ve.findIndex((ot) => ee(ot) === ee(Pe));
    }
    return -1;
  }, nn = d.useCallback(() => {
    if (!Qe)
      return;
    const Le = $t();
    if (Le !== -1) {
      Se.current = Le;
      return;
    }
    const Pe = B ? me[0] : me;
    if (Ve.length === 0 || Pe == null) {
      Je({
        diff: "reset"
      });
      return;
    }
    if (oe.current) {
      if (Pe != null) {
        const ot = Ve[Se.current];
        if (B && ot && me.findIndex((dn) => V(ot, dn)) !== -1)
          return;
        const Qt = Ve.findIndex((dn) => V(dn, Pe));
        Qt === -1 ? Je({
          diff: "reset"
        }) : hn({
          index: Qt
        });
        return;
      }
      if (Se.current >= Ve.length - 1) {
        hn({
          index: Ve.length - 1
        });
        return;
      }
      hn({
        index: Se.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    Ve.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    B ? !1 : me,
    C,
    Je,
    hn,
    Qe,
    Ie,
    B
  ]), Nt = Eo((Le) => {
    T0(oe, Le), Le && nn();
  });
  process.env.NODE_ENV !== "production" && d.useEffect(() => {
    (!K.current || K.current.nodeName !== "INPUT") && (K.current && K.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${u} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${K.current} while an HTMLInputElement was expected.`, `Instead, ${u} expects an input element.`, "", u === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [u]), d.useEffect(() => {
    nn();
  }, [nn]);
  const cn = (Le) => {
    Dt || (ke(!0), We(!0), ie && ie(Le));
  }, Lt = (Le, Pe) => {
    Dt && (ke(!1), z && z(Le, Pe));
  }, jt = (Le, Pe, ot, Qt) => {
    if (B) {
      if (me.length === Pe.length && me.every((dn, xn) => dn === Pe[xn]))
        return;
    } else if (me === Pe)
      return;
    W && W(Le, Pe, ot, Qt), ye(Pe);
  }, un = d.useRef(!1), On = (Le, Pe, ot = "selectOption", Qt = "options") => {
    let dn = ot, xn = Pe;
    if (B) {
      if (xn = Array.isArray(me) ? me.slice() : [], process.env.NODE_ENV !== "production") {
        const Ro = xn.filter((pi) => V(Pe, pi));
        Ro.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${u} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${Ro.length} matches.`].join(`
`));
      }
      const Qn = xn.findIndex((Ro) => V(Pe, Ro));
      Qn === -1 ? xn.push(Pe) : Qt !== "freeSolo" && (xn.splice(Qn, 1), dn = "removeOption");
    }
    gt(Le, xn, dn), jt(Le, xn, dn, {
      option: Pe
    }), !h && (!Le || !Le.ctrlKey && !Le.metaKey) && Lt(Le, dn), (a === !0 || a === "touch" && un.current || a === "mouse" && !un.current) && K.current.blur();
  };
  function Un(Le, Pe) {
    if (Le === -1)
      return -1;
    let ot = Le;
    for (; ; ) {
      if (Pe === "next" && ot === me.length || Pe === "previous" && ot === -1)
        return -1;
      const Qt = de.querySelector(`[data-tag-index="${ot}"]`);
      if (!Qt || !Qt.hasAttribute("tabindex") || Qt.disabled || Qt.getAttribute("aria-disabled") === "true")
        ot += Pe === "next" ? 1 : -1;
      else
        return ot;
    }
  }
  const ro = (Le, Pe) => {
    if (!B)
      return;
    Ie === "" && Lt(Le, "toggleInput");
    let ot = J;
    J === -1 ? Ie === "" && Pe === "previous" && (ot = me.length - 1) : (ot += Pe === "next" ? 1 : -1, ot < 0 && (ot = 0), ot === me.length && (ot = -1)), ot = Un(ot, Pe), se(ot), vt(ot);
  }, Ft = (Le) => {
    te.current = !0, je(""), H && H(Le, "", "clear"), jt(Le, B ? [] : null, "clear");
  }, Yn = (Le) => (Pe) => {
    if (Le.onKeyDown && Le.onKeyDown(Pe), !Pe.defaultMuiPrevented && (J !== -1 && !["ArrowLeft", "ArrowRight"].includes(Pe.key) && (se(-1), vt(-1)), Pe.which !== 229))
      switch (Pe.key) {
        case "Home":
          Qe && F && (Pe.preventDefault(), Je({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: Pe
          }));
          break;
        case "End":
          Qe && F && (Pe.preventDefault(), Je({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: Pe
          }));
          break;
        case "PageUp":
          Pe.preventDefault(), Je({
            diff: -X2,
            direction: "previous",
            reason: "keyboard",
            event: Pe
          }), cn(Pe);
          break;
        case "PageDown":
          Pe.preventDefault(), Je({
            diff: X2,
            direction: "next",
            reason: "keyboard",
            event: Pe
          }), cn(Pe);
          break;
        case "ArrowDown":
          Pe.preventDefault(), Je({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: Pe
          }), cn(Pe);
          break;
        case "ArrowUp":
          Pe.preventDefault(), Je({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: Pe
          }), cn(Pe);
          break;
        case "ArrowLeft":
          ro(Pe, "previous");
          break;
        case "ArrowRight":
          ro(Pe, "next");
          break;
        case "Enter":
          if (Se.current !== -1 && Qe) {
            const ot = Ve[Se.current], Qt = S ? S(ot) : !1;
            if (Pe.preventDefault(), Qt)
              return;
            On(Pe, ot, "selectOption"), r && K.current.setSelectionRange(K.current.value.length, K.current.value.length);
          } else E && Ie !== "" && Ge === !1 && (B && Pe.preventDefault(), On(Pe, Ie, "createOption", "freeSolo"));
          break;
        case "Escape":
          Qe ? (Pe.preventDefault(), Pe.stopPropagation(), Lt(Pe, "escape")) : c && (Ie !== "" || B && me.length > 0) && (Pe.preventDefault(), Pe.stopPropagation(), Ft(Pe));
          break;
        case "Backspace":
          if (B && !Y && Ie === "" && me.length > 0) {
            const ot = J === -1 ? me.length - 1 : J, Qt = me.slice();
            Qt.splice(ot, 1), jt(Pe, Qt, "removeOption", {
              option: me[ot]
            });
          }
          break;
        case "Delete":
          if (B && !Y && Ie === "" && me.length > 0 && J !== -1) {
            const ot = J, Qt = me.slice();
            Qt.splice(ot, 1), jt(Pe, Qt, "removeOption", {
              option: me[ot]
            });
          }
          break;
      }
  }, it = (Le) => {
    Fe(!0), re && !te.current && cn(Le);
  }, ft = (Le) => {
    if (t(oe)) {
      K.current.focus();
      return;
    }
    Fe(!1), ue.current = !0, te.current = !1, s && Se.current !== -1 && Qe ? On(Le, Ve[Se.current], "blur") : s && E && Ie !== "" ? On(Le, Ie, "blur", "freeSolo") : l && gt(Le, me, "blur"), Lt(Le, "blur");
  }, Xt = (Le) => {
    const Pe = Le.target.value;
    Ie !== Pe && (je(Pe), We(!1), H && H(Le, Pe, "input")), Pe === "" ? !g && !B && jt(Le, null, "clear") : cn(Le);
  }, Ae = (Le) => {
    const Pe = Number(Le.currentTarget.getAttribute("data-option-index"));
    Se.current !== Pe && hn({
      event: Le,
      index: Pe,
      reason: "mouse"
    });
  }, St = (Le) => {
    hn({
      event: Le,
      index: Number(Le.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), un.current = !0;
  }, yn = (Le) => {
    const Pe = Number(Le.currentTarget.getAttribute("data-option-index"));
    On(Le, Ve[Pe], "selectOption"), un.current = !1;
  }, In = (Le) => (Pe) => {
    const ot = me.slice();
    ot.splice(Le, 1), jt(Pe, ot, "removeOption", {
      option: me[Le]
    });
  }, Oo = (Le) => {
    Dt ? Lt(Le, "toggleInput") : cn(Le);
  }, Do = (Le) => {
    Le.currentTarget.contains(Le.target) && Le.target.getAttribute("id") !== fe && Le.preventDefault();
  }, Xn = (Le) => {
    Le.currentTarget.contains(Le.target) && (K.current.focus(), pe && ue.current && K.current.selectionEnd - K.current.selectionStart === 0 && K.current.select(), ue.current = !1);
  }, fo = (Le) => {
    !y && (Ie === "" || !Dt) && Oo(Le);
  };
  let Ko = E && Ie.length > 0;
  Ko = Ko || (B ? me.length > 0 : me !== null);
  let di = Ve;
  if (P) {
    const Le = /* @__PURE__ */ new Map();
    let Pe = !1;
    di = Ve.reduce((ot, Qt, dn) => {
      const xn = P(Qt);
      return ot.length > 0 && ot[ot.length - 1].group === xn ? ot[ot.length - 1].options.push(Qt) : (process.env.NODE_ENV !== "production" && (Le.get(xn) && !Pe && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${u} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), Pe = !0), Le.set(xn, !0)), ot.push({
        key: dn,
        index: dn,
        group: xn,
        options: [Qt]
      })), ot;
    }, []);
  }
  return y && Te && ft(), {
    getRootProps: (Le = {}) => ({
      ...Le,
      onKeyDown: Yn(Le),
      onMouseDown: Do,
      onClick: Xn
    }),
    getInputLabelProps: () => ({
      id: `${fe}-label`,
      htmlFor: fe
    }),
    getInputProps: () => ({
      id: fe,
      value: Ie,
      onBlur: ft,
      onFocus: it,
      onChange: Xt,
      onMouseDown: fo,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Qe ? "" : null,
      "aria-autocomplete": r ? "both" : "list",
      "aria-controls": bt ? `${fe}-listbox` : void 0,
      "aria-expanded": bt,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: K,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: y
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Ft
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Oo
    }),
    getTagProps: ({
      index: Le
    }) => ({
      key: Le,
      "data-tag-index": Le,
      tabIndex: -1,
      ...!Y && {
        onDelete: In(Le)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${fe}-listbox`,
      "aria-labelledby": `${fe}-label`,
      ref: Nt,
      onMouseDown: (Le) => {
        Le.preventDefault();
      }
    }),
    getOptionProps: ({
      index: Le,
      option: Pe
    }) => {
      const ot = (B ? me : [me]).some((dn) => dn != null && V(Pe, dn)), Qt = S ? S(Pe) : !1;
      return {
        key: (k == null ? void 0 : k(Pe)) ?? ee(Pe),
        tabIndex: -1,
        role: "option",
        id: `${fe}-option-${Le}`,
        onMouseMove: Ae,
        onClick: yn,
        onTouchStart: St,
        "data-option-index": Le,
        "aria-disabled": Qt,
        "aria-selected": ot
      };
    },
    id: fe,
    inputValue: Ie,
    value: me,
    dirty: Ko,
    expanded: Qe && de,
    popupOpen: Qe,
    focused: Te || J !== -1,
    anchorEl: de,
    setAnchorEl: ve,
    focusedTag: J,
    groupedOptions: di
  };
}
var er = "top", Mr = "bottom", kr = "right", tr = "left", Pp = "auto", lc = [er, Mr, kr, tr], wa = "start", _l = "end", oy = "clippingParents", W4 = "viewport", Ka = "popper", ry = "reference", J2 = /* @__PURE__ */ lc.reduce(function(e, t) {
  return e.concat([t + "-" + wa, t + "-" + _l]);
}, []), G4 = /* @__PURE__ */ [].concat(lc, [Pp]).reduce(function(e, t) {
  return e.concat([t, t + "-" + wa, t + "-" + _l]);
}, []), iy = "beforeRead", sy = "read", ay = "afterRead", ly = "beforeMain", cy = "main", uy = "afterMain", dy = "beforeWrite", py = "write", fy = "afterWrite", gy = [iy, sy, ay, ly, cy, uy, dy, py, fy];
function ti(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function cr(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Vs(e) {
  var t = cr(e).Element;
  return e instanceof t || e instanceof Element;
}
function Er(e) {
  var t = cr(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Ip(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = cr(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function my(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, s = t.elements[n];
    !Er(s) || !ti(s) || (Object.assign(s.style, r), Object.keys(i).forEach(function(a) {
      var l = i[a];
      l === !1 ? s.removeAttribute(a) : s.setAttribute(a, l === !0 ? "" : l);
    }));
  });
}
function hy(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], s = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), l = a.reduce(function(c, u) {
        return c[u] = "", c;
      }, {});
      !Er(i) || !ti(i) || (Object.assign(i.style, l), Object.keys(s).forEach(function(c) {
        i.removeAttribute(c);
      }));
    });
  };
}
const vy = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: my,
  effect: hy,
  requires: ["computeStyles"]
};
function Qr(e) {
  return e.split("-")[0];
}
var Os = Math.max, zu = Math.min, Sa = Math.round;
function V0() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function U4() {
  return !/^((?!chrome|android).)*safari/i.test(V0());
}
function Ea(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, s = 1;
  t && Er(e) && (i = e.offsetWidth > 0 && Sa(r.width) / e.offsetWidth || 1, s = e.offsetHeight > 0 && Sa(r.height) / e.offsetHeight || 1);
  var a = Vs(e) ? cr(e) : window, l = a.visualViewport, c = !U4() && n, u = (r.left + (c && l ? l.offsetLeft : 0)) / i, f = (r.top + (c && l ? l.offsetTop : 0)) / s, g = r.width / i, h = r.height / s;
  return {
    width: g,
    height: h,
    top: f,
    right: u + g,
    bottom: f + h,
    left: u,
    x: u,
    y: f
  };
}
function Op(e) {
  var t = Ea(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Y4(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Ip(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function ji(e) {
  return cr(e).getComputedStyle(e);
}
function yy(e) {
  return ["table", "td", "th"].indexOf(ti(e)) >= 0;
}
function cs(e) {
  return ((Vs(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Sd(e) {
  return ti(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Ip(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    cs(e)
  );
}
function e3(e) {
  return !Er(e) || // https://github.com/popperjs/popper-core/issues/837
  ji(e).position === "fixed" ? null : e.offsetParent;
}
function by(e) {
  var t = /firefox/i.test(V0()), n = /Trident/i.test(V0());
  if (n && Er(e)) {
    var r = ji(e);
    if (r.position === "fixed")
      return null;
  }
  var i = Sd(e);
  for (Ip(i) && (i = i.host); Er(i) && ["html", "body"].indexOf(ti(i)) < 0; ) {
    var s = ji(i);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || t && s.willChange === "filter" || t && s.filter && s.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function cc(e) {
  for (var t = cr(e), n = e3(e); n && yy(n) && ji(n).position === "static"; )
    n = e3(n);
  return n && (ti(n) === "html" || ti(n) === "body" && ji(n).position === "static") ? t : n || by(e) || t;
}
function Dp(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Ml(e, t, n) {
  return Os(e, zu(t, n));
}
function Cy(e, t, n) {
  var r = Ml(e, t, n);
  return r > n ? n : r;
}
function Z4() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function q4(e) {
  return Object.assign({}, Z4(), e);
}
function K4(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var xy = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, q4(typeof t != "number" ? t : K4(t, lc));
};
function wy(e) {
  var t, n = e.state, r = e.name, i = e.options, s = n.elements.arrow, a = n.modifiersData.popperOffsets, l = Qr(n.placement), c = Dp(l), u = [tr, kr].indexOf(l) >= 0, f = u ? "height" : "width";
  if (!(!s || !a)) {
    var g = xy(i.padding, n), h = Op(s), y = c === "y" ? er : tr, v = c === "y" ? Mr : kr, m = n.rects.reference[f] + n.rects.reference[c] - a[c] - n.rects.popper[f], b = a[c] - n.rects.reference[c], C = cc(s), E = C ? c === "y" ? C.clientHeight || 0 : C.clientWidth || 0 : 0, S = m / 2 - b / 2, k = g[y], T = E - h[f] - g[v], P = E / 2 - h[f] / 2 + S, F = Ml(k, P, T), j = c;
    n.modifiersData[r] = (t = {}, t[j] = F, t.centerOffset = F - P, t);
  }
}
function Sy(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || Y4(t.elements.popper, i) && (t.elements.arrow = i));
}
const Ey = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: wy,
  effect: Sy,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ra(e) {
  return e.split("-")[1];
}
var Ry = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ty(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: Sa(n * i) / i || 0,
    y: Sa(r * i) / i || 0
  };
}
function t3(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, s = e.variation, a = e.offsets, l = e.position, c = e.gpuAcceleration, u = e.adaptive, f = e.roundOffsets, g = e.isFixed, h = a.x, y = h === void 0 ? 0 : h, v = a.y, m = v === void 0 ? 0 : v, b = typeof f == "function" ? f({
    x: y,
    y: m
  }) : {
    x: y,
    y: m
  };
  y = b.x, m = b.y;
  var C = a.hasOwnProperty("x"), E = a.hasOwnProperty("y"), S = tr, k = er, T = window;
  if (u) {
    var P = cc(n), F = "clientHeight", j = "clientWidth";
    if (P === cr(n) && (P = cs(n), ji(P).position !== "static" && l === "absolute" && (F = "scrollHeight", j = "scrollWidth")), P = P, i === er || (i === tr || i === kr) && s === _l) {
      k = Mr;
      var L = g && P === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        P[F]
      );
      m -= L - r.height, m *= c ? 1 : -1;
    }
    if (i === tr || (i === er || i === Mr) && s === _l) {
      S = kr;
      var R = g && P === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        P[j]
      );
      y -= R - r.width, y *= c ? 1 : -1;
    }
  }
  var V = Object.assign({
    position: l
  }, u && Ry), B = f === !0 ? Ty({
    x: y,
    y: m
  }, cr(n)) : {
    x: y,
    y: m
  };
  if (y = B.x, m = B.y, c) {
    var W;
    return Object.assign({}, V, (W = {}, W[k] = E ? "0" : "", W[S] = C ? "0" : "", W.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + y + "px, " + m + "px)" : "translate3d(" + y + "px, " + m + "px, 0)", W));
  }
  return Object.assign({}, V, (t = {}, t[k] = E ? m + "px" : "", t[S] = C ? y + "px" : "", t.transform = "", t));
}
function My(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, s = n.adaptive, a = s === void 0 ? !0 : s, l = n.roundOffsets, c = l === void 0 ? !0 : l, u = {
    placement: Qr(t.placement),
    variation: Ra(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, t3(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, t3(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ky = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: My,
  data: {}
};
var Jc = {
  passive: !0
};
function Py(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, s = i === void 0 ? !0 : i, a = r.resize, l = a === void 0 ? !0 : a, c = cr(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return s && u.forEach(function(f) {
    f.addEventListener("scroll", n.update, Jc);
  }), l && c.addEventListener("resize", n.update, Jc), function() {
    s && u.forEach(function(f) {
      f.removeEventListener("scroll", n.update, Jc);
    }), l && c.removeEventListener("resize", n.update, Jc);
  };
}
const Iy = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Py,
  data: {}
};
var Oy = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Mu(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Oy[t];
  });
}
var Dy = {
  start: "end",
  end: "start"
};
function n3(e) {
  return e.replace(/start|end/g, function(t) {
    return Dy[t];
  });
}
function jp(e) {
  var t = cr(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Fp(e) {
  return Ea(cs(e)).left + jp(e).scrollLeft;
}
function jy(e, t) {
  var n = cr(e), r = cs(e), i = n.visualViewport, s = r.clientWidth, a = r.clientHeight, l = 0, c = 0;
  if (i) {
    s = i.width, a = i.height;
    var u = U4();
    (u || !u && t === "fixed") && (l = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: s,
    height: a,
    x: l + Fp(e),
    y: c
  };
}
function Fy(e) {
  var t, n = cs(e), r = jp(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, s = Os(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), a = Os(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), l = -r.scrollLeft + Fp(e), c = -r.scrollTop;
  return ji(i || n).direction === "rtl" && (l += Os(n.clientWidth, i ? i.clientWidth : 0) - s), {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function Vp(e) {
  var t = ji(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function X4(e) {
  return ["html", "body", "#document"].indexOf(ti(e)) >= 0 ? e.ownerDocument.body : Er(e) && Vp(e) ? e : X4(Sd(e));
}
function kl(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = X4(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), s = cr(r), a = i ? [s].concat(s.visualViewport || [], Vp(r) ? r : []) : r, l = t.concat(a);
  return i ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(kl(Sd(a)))
  );
}
function $0(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Vy(e, t) {
  var n = Ea(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function o3(e, t, n) {
  return t === W4 ? $0(jy(e, n)) : Vs(t) ? Vy(t, n) : $0(Fy(cs(e)));
}
function $y(e) {
  var t = kl(Sd(e)), n = ["absolute", "fixed"].indexOf(ji(e).position) >= 0, r = n && Er(e) ? cc(e) : e;
  return Vs(r) ? t.filter(function(i) {
    return Vs(i) && Y4(i, r) && ti(i) !== "body";
  }) : [];
}
function Ly(e, t, n, r) {
  var i = t === "clippingParents" ? $y(e) : [].concat(t), s = [].concat(i, [n]), a = s[0], l = s.reduce(function(c, u) {
    var f = o3(e, u, r);
    return c.top = Os(f.top, c.top), c.right = zu(f.right, c.right), c.bottom = zu(f.bottom, c.bottom), c.left = Os(f.left, c.left), c;
  }, o3(e, a, r));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function Q4(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? Qr(r) : null, s = r ? Ra(r) : null, a = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, c;
  switch (i) {
    case er:
      c = {
        x: a,
        y: t.y - n.height
      };
      break;
    case Mr:
      c = {
        x: a,
        y: t.y + t.height
      };
      break;
    case kr:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case tr:
      c = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var u = i ? Dp(i) : null;
  if (u != null) {
    var f = u === "y" ? "height" : "width";
    switch (s) {
      case wa:
        c[u] = c[u] - (t[f] / 2 - n[f] / 2);
        break;
      case _l:
        c[u] = c[u] + (t[f] / 2 - n[f] / 2);
        break;
    }
  }
  return c;
}
function zl(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, s = n.strategy, a = s === void 0 ? e.strategy : s, l = n.boundary, c = l === void 0 ? oy : l, u = n.rootBoundary, f = u === void 0 ? W4 : u, g = n.elementContext, h = g === void 0 ? Ka : g, y = n.altBoundary, v = y === void 0 ? !1 : y, m = n.padding, b = m === void 0 ? 0 : m, C = q4(typeof b != "number" ? b : K4(b, lc)), E = h === Ka ? ry : Ka, S = e.rects.popper, k = e.elements[v ? E : h], T = Ly(Vs(k) ? k : k.contextElement || cs(e.elements.popper), c, f, a), P = Ea(e.elements.reference), F = Q4({
    reference: P,
    element: S,
    placement: i
  }), j = $0(Object.assign({}, S, F)), L = h === Ka ? j : P, R = {
    top: T.top - L.top + C.top,
    bottom: L.bottom - T.bottom + C.bottom,
    left: T.left - L.left + C.left,
    right: L.right - T.right + C.right
  }, V = e.modifiersData.offset;
  if (h === Ka && V) {
    var B = V[i];
    Object.keys(R).forEach(function(W) {
      var z = [kr, Mr].indexOf(W) >= 0 ? 1 : -1, G = [er, Mr].indexOf(W) >= 0 ? "y" : "x";
      R[W] += B[G] * z;
    });
  }
  return R;
}
function Ay(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, s = n.rootBoundary, a = n.padding, l = n.flipVariations, c = n.allowedAutoPlacements, u = c === void 0 ? G4 : c, f = Ra(r), g = f ? l ? J2 : J2.filter(function(v) {
    return Ra(v) === f;
  }) : lc, h = g.filter(function(v) {
    return u.indexOf(v) >= 0;
  });
  h.length === 0 && (h = g);
  var y = h.reduce(function(v, m) {
    return v[m] = zl(e, {
      placement: m,
      boundary: i,
      rootBoundary: s,
      padding: a
    })[Qr(m)], v;
  }, {});
  return Object.keys(y).sort(function(v, m) {
    return y[v] - y[m];
  });
}
function Ny(e) {
  if (Qr(e) === Pp)
    return [];
  var t = Mu(e);
  return [n3(e), t, n3(t)];
}
function By(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, s = i === void 0 ? !0 : i, a = n.altAxis, l = a === void 0 ? !0 : a, c = n.fallbackPlacements, u = n.padding, f = n.boundary, g = n.rootBoundary, h = n.altBoundary, y = n.flipVariations, v = y === void 0 ? !0 : y, m = n.allowedAutoPlacements, b = t.options.placement, C = Qr(b), E = C === b, S = c || (E || !v ? [Mu(b)] : Ny(b)), k = [b].concat(S).reduce(function(fe, ee) {
      return fe.concat(Qr(ee) === Pp ? Ay(t, {
        placement: ee,
        boundary: f,
        rootBoundary: g,
        padding: u,
        flipVariations: v,
        allowedAutoPlacements: m
      }) : ee);
    }, []), T = t.rects.reference, P = t.rects.popper, F = /* @__PURE__ */ new Map(), j = !0, L = k[0], R = 0; R < k.length; R++) {
      var V = k[R], B = Qr(V), W = Ra(V) === wa, z = [er, Mr].indexOf(B) >= 0, G = z ? "width" : "height", H = zl(t, {
        placement: V,
        boundary: f,
        rootBoundary: g,
        altBoundary: h,
        padding: u
      }), ie = z ? W ? kr : tr : W ? Mr : er;
      T[G] > P[G] && (ie = Mu(ie));
      var ce = Mu(ie), re = [];
      if (s && re.push(H[B] <= 0), l && re.push(H[ie] <= 0, H[ce] <= 0), re.every(function(fe) {
        return fe;
      })) {
        L = V, j = !1;
        break;
      }
      F.set(V, re);
    }
    if (j)
      for (var A = v ? 3 : 1, Y = function(ee) {
        var te = k.find(function(ue) {
          var K = F.get(ue);
          if (K)
            return K.slice(0, ee).every(function(oe) {
              return oe;
            });
        });
        if (te)
          return L = te, "break";
      }, pe = A; pe > 0; pe--) {
        var Ce = Y(pe);
        if (Ce === "break") break;
      }
    t.placement !== L && (t.modifiersData[r]._skip = !0, t.placement = L, t.reset = !0);
  }
}
const _y = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: By,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function r3(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function i3(e) {
  return [er, kr, Mr, tr].some(function(t) {
    return e[t] >= 0;
  });
}
function zy(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, s = t.modifiersData.preventOverflow, a = zl(t, {
    elementContext: "reference"
  }), l = zl(t, {
    altBoundary: !0
  }), c = r3(a, r), u = r3(l, i, s), f = i3(c), g = i3(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: u,
    isReferenceHidden: f,
    hasPopperEscaped: g
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": g
  });
}
const Hy = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: zy
};
function Wy(e, t, n) {
  var r = Qr(e), i = [tr, er].indexOf(r) >= 0 ? -1 : 1, s = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = s[0], l = s[1];
  return a = a || 0, l = (l || 0) * i, [tr, kr].indexOf(r) >= 0 ? {
    x: l,
    y: a
  } : {
    x: a,
    y: l
  };
}
function Gy(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, s = i === void 0 ? [0, 0] : i, a = G4.reduce(function(f, g) {
    return f[g] = Wy(g, t.rects, s), f;
  }, {}), l = a[t.placement], c = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = a;
}
const Uy = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Gy
};
function Yy(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Q4({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const Zy = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Yy,
  data: {}
};
function qy(e) {
  return e === "x" ? "y" : "x";
}
function Ky(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, s = i === void 0 ? !0 : i, a = n.altAxis, l = a === void 0 ? !1 : a, c = n.boundary, u = n.rootBoundary, f = n.altBoundary, g = n.padding, h = n.tether, y = h === void 0 ? !0 : h, v = n.tetherOffset, m = v === void 0 ? 0 : v, b = zl(t, {
    boundary: c,
    rootBoundary: u,
    padding: g,
    altBoundary: f
  }), C = Qr(t.placement), E = Ra(t.placement), S = !E, k = Dp(C), T = qy(k), P = t.modifiersData.popperOffsets, F = t.rects.reference, j = t.rects.popper, L = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, R = typeof L == "number" ? {
    mainAxis: L,
    altAxis: L
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, L), V = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, B = {
    x: 0,
    y: 0
  };
  if (P) {
    if (s) {
      var W, z = k === "y" ? er : tr, G = k === "y" ? Mr : kr, H = k === "y" ? "height" : "width", ie = P[k], ce = ie + b[z], re = ie - b[G], A = y ? -j[H] / 2 : 0, Y = E === wa ? F[H] : j[H], pe = E === wa ? -j[H] : -F[H], Ce = t.elements.arrow, fe = y && Ce ? Op(Ce) : {
        width: 0,
        height: 0
      }, ee = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Z4(), te = ee[z], ue = ee[G], K = Ml(0, F[H], fe[H]), oe = S ? F[H] / 2 - A - K - te - R.mainAxis : Y - K - te - R.mainAxis, de = S ? -F[H] / 2 + A + K + ue + R.mainAxis : pe + K + ue + R.mainAxis, ve = t.elements.arrow && cc(t.elements.arrow), J = ve ? k === "y" ? ve.clientTop || 0 : ve.clientLeft || 0 : 0, se = (W = V == null ? void 0 : V[k]) != null ? W : 0, ge = ie + oe - se - J, Se = ie + de - se, we = Ml(y ? zu(ce, ge) : ce, ie, y ? Os(re, Se) : re);
      P[k] = we, B[k] = we - ie;
    }
    if (l) {
      var me, ye = k === "x" ? er : tr, Ie = k === "x" ? Mr : kr, je = P[T], Te = T === "y" ? "height" : "width", Fe = je + b[ye], gt = je - b[Ie], Dt = [er, tr].indexOf(C) !== -1, ke = (me = V == null ? void 0 : V[T]) != null ? me : 0, Ne = Dt ? Fe : je - F[Te] - j[Te] - ke + R.altAxis, We = Dt ? je + F[Te] + j[Te] - ke - R.altAxis : gt, Ge = y && Dt ? Cy(Ne, je, We) : Ml(y ? Ne : Fe, je, y ? We : gt);
      P[T] = Ge, B[T] = Ge - je;
    }
    t.modifiersData[r] = B;
  }
}
const Xy = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Ky,
  requiresIfExists: ["offset"]
};
function Qy(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Jy(e) {
  return e === cr(e) || !Er(e) ? jp(e) : Qy(e);
}
function eb(e) {
  var t = e.getBoundingClientRect(), n = Sa(t.width) / e.offsetWidth || 1, r = Sa(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function tb(e, t, n) {
  n === void 0 && (n = !1);
  var r = Er(t), i = Er(t) && eb(t), s = cs(t), a = Ea(e, i, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ti(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Vp(s)) && (l = Jy(t)), Er(t) ? (c = Ea(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : s && (c.x = Fp(s))), {
    x: a.left + l.scrollLeft - c.x,
    y: a.top + l.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function nb(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(s) {
    t.set(s.name, s);
  });
  function i(s) {
    n.add(s.name);
    var a = [].concat(s.requires || [], s.requiresIfExists || []);
    a.forEach(function(l) {
      if (!n.has(l)) {
        var c = t.get(l);
        c && i(c);
      }
    }), r.push(s);
  }
  return e.forEach(function(s) {
    n.has(s.name) || i(s);
  }), r;
}
function ob(e) {
  var t = nb(e);
  return gy.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function rb(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function ib(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var s3 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function a3() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function sb(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, s = i === void 0 ? s3 : i;
  return function(l, c, u) {
    u === void 0 && (u = s);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, s3, s),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, g = [], h = !1, y = {
      state: f,
      setOptions: function(C) {
        var E = typeof C == "function" ? C(f.options) : C;
        m(), f.options = Object.assign({}, s, f.options, E), f.scrollParents = {
          reference: Vs(l) ? kl(l) : l.contextElement ? kl(l.contextElement) : [],
          popper: kl(c)
        };
        var S = ob(ib([].concat(r, f.options.modifiers)));
        return f.orderedModifiers = S.filter(function(k) {
          return k.enabled;
        }), v(), y.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var C = f.elements, E = C.reference, S = C.popper;
          if (a3(E, S)) {
            f.rects = {
              reference: tb(E, cc(S), f.options.strategy === "fixed"),
              popper: Op(S)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(R) {
              return f.modifiersData[R.name] = Object.assign({}, R.data);
            });
            for (var k = 0; k < f.orderedModifiers.length; k++) {
              if (f.reset === !0) {
                f.reset = !1, k = -1;
                continue;
              }
              var T = f.orderedModifiers[k], P = T.fn, F = T.options, j = F === void 0 ? {} : F, L = T.name;
              typeof P == "function" && (f = P({
                state: f,
                options: j,
                name: L,
                instance: y
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: rb(function() {
        return new Promise(function(b) {
          y.forceUpdate(), b(f);
        });
      }),
      destroy: function() {
        m(), h = !0;
      }
    };
    if (!a3(l, c))
      return y;
    y.setOptions(u).then(function(b) {
      !h && u.onFirstUpdate && u.onFirstUpdate(b);
    });
    function v() {
      f.orderedModifiers.forEach(function(b) {
        var C = b.name, E = b.options, S = E === void 0 ? {} : E, k = b.effect;
        if (typeof k == "function") {
          var T = k({
            state: f,
            name: C,
            instance: y,
            options: S
          }), P = function() {
          };
          g.push(T || P);
        }
      });
    }
    function m() {
      g.forEach(function(b) {
        return b();
      }), g = [];
    }
    return y;
  };
}
var ab = [Iy, Zy, ky, vy, Uy, _y, Xy, Ey, Hy], lb = /* @__PURE__ */ sb({
  defaultModifiers: ab
});
function cb(e) {
  return typeof e == "function" ? e() : e;
}
const Hl = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    children: r,
    container: i,
    disablePortal: s = !1
  } = t, [a, l] = d.useState(null), c = lo(/* @__PURE__ */ d.isValidElement(r) ? _s(r) : null, n);
  if (Zo(() => {
    s || l(cb(i) || document.body);
  }, [i, s]), Zo(() => {
    if (a && !s)
      return T0(n, a), () => {
        T0(n, null);
      };
  }, [n, a, s]), s) {
    if (/* @__PURE__ */ d.isValidElement(r)) {
      const u = {
        ref: c
      };
      return /* @__PURE__ */ d.cloneElement(r, u);
    }
    return r;
  }
  return a && /* @__PURE__ */ N6.createPortal(r, a);
});
process.env.NODE_ENV !== "production" && (Hl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: o.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([Di, o.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool
});
process.env.NODE_ENV !== "production" && (Hl.propTypes = ic(Hl.propTypes));
function ub(e) {
  return Pt("MuiPopper", e);
}
Et("MuiPopper", ["root"]);
function db(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Hu(e) {
  return typeof e == "function" ? e() : e;
}
function Ed(e) {
  return e.nodeType !== void 0;
}
function pb(e) {
  return !Ed(e);
}
const fb = (e) => {
  const {
    classes: t
  } = e;
  return Ot({
    root: ["root"]
  }, ub, t);
}, gb = {}, mb = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: i,
    direction: s,
    disablePortal: a,
    modifiers: l,
    open: c,
    placement: u,
    popperOptions: f,
    popperRef: g,
    slotProps: h = {},
    slots: y = {},
    TransitionProps: v,
    // @ts-ignore internal logic
    ownerState: m,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...b
  } = t, C = d.useRef(null), E = lo(C, n), S = d.useRef(null), k = lo(S, g), T = d.useRef(k);
  Zo(() => {
    T.current = k;
  }, [k]), d.useImperativeHandle(g, () => S.current, []);
  const P = db(u, s), [F, j] = d.useState(P), [L, R] = d.useState(Hu(r));
  d.useEffect(() => {
    S.current && S.current.forceUpdate();
  }), d.useEffect(() => {
    r && R(Hu(r));
  }, [r]), Zo(() => {
    if (!L || !c)
      return;
    const G = (ce) => {
      j(ce.placement);
    };
    if (process.env.NODE_ENV !== "production" && L && Ed(L) && L.nodeType === 1) {
      const ce = L.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && ce.top === 0 && ce.left === 0 && ce.right === 0 && ce.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let H = [{
      name: "preventOverflow",
      options: {
        altBoundary: a
      }
    }, {
      name: "flip",
      options: {
        altBoundary: a
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: ce
      }) => {
        G(ce);
      }
    }];
    l != null && (H = H.concat(l)), f && f.modifiers != null && (H = H.concat(f.modifiers));
    const ie = lb(L, C.current, {
      placement: P,
      ...f,
      modifiers: H
    });
    return T.current(ie), () => {
      ie.destroy(), T.current(null);
    };
  }, [L, a, l, c, f, P]);
  const V = {
    placement: F
  };
  v !== null && (V.TransitionProps = v);
  const B = fb(t), W = y.root ?? "div", z = Yo({
    elementType: W,
    externalSlotProps: h.root,
    externalForwardedProps: b,
    additionalProps: {
      role: "tooltip",
      ref: E
    },
    ownerState: t,
    className: B.root
  });
  return /* @__PURE__ */ p.jsx(W, {
    ...z,
    children: typeof i == "function" ? i(V) : i
  });
}), J4 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: i,
    container: s,
    direction: a = "ltr",
    disablePortal: l = !1,
    keepMounted: c = !1,
    modifiers: u,
    open: f,
    placement: g = "bottom",
    popperOptions: h = gb,
    popperRef: y,
    style: v,
    transition: m = !1,
    slotProps: b = {},
    slots: C = {},
    ...E
  } = t, [S, k] = d.useState(!0), T = () => {
    k(!1);
  }, P = () => {
    k(!0);
  };
  if (!c && !f && (!m || S))
    return null;
  let F;
  if (s)
    F = s;
  else if (r) {
    const R = Hu(r);
    F = R && Ed(R) ? Co(R).body : Co(null).body;
  }
  const j = !f && c && (!m || S) ? "none" : void 0, L = m ? {
    in: f,
    onEnter: T,
    onExited: P
  } : void 0;
  return /* @__PURE__ */ p.jsx(Hl, {
    disablePortal: l,
    container: F,
    children: /* @__PURE__ */ p.jsx(mb, {
      anchorEl: r,
      direction: a,
      disablePortal: l,
      modifiers: u,
      ref: n,
      open: m ? !S : f,
      placement: g,
      popperOptions: h,
      popperRef: y,
      slotProps: b,
      slots: C,
      ...E,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: j,
        ...v
      },
      TransitionProps: L,
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (J4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: nr(o.oneOfType([Di, o.object, o.func]), (e) => {
    if (e.open) {
      const t = Hu(e.anchorEl);
      if (t && Ed(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || pb(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: o.oneOfType([o.node, o.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([Di, o.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: o.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: o.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: o.arrayOf(o.shape({
    data: o.object,
    effect: o.func,
    enabled: o.bool,
    fn: o.func,
    name: o.any,
    options: o.object,
    phase: o.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: o.arrayOf(o.string),
    requiresIfExists: o.arrayOf(o.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: o.shape({
    modifiers: o.array,
    onFirstUpdate: o.func,
    placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: o.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: qo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: o.shape({
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    root: o.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: o.bool
});
const hb = Z(J4, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), us = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Io(), i = Vt({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: s,
    component: a,
    components: l,
    componentsProps: c,
    container: u,
    disablePortal: f,
    keepMounted: g,
    modifiers: h,
    open: y,
    placement: v,
    popperOptions: m,
    popperRef: b,
    transition: C,
    slots: E,
    slotProps: S,
    ...k
  } = i, T = (E == null ? void 0 : E.root) ?? (l == null ? void 0 : l.Root), P = {
    anchorEl: s,
    container: u,
    disablePortal: f,
    keepMounted: g,
    modifiers: h,
    open: y,
    placement: v,
    popperOptions: m,
    popperRef: b,
    transition: C,
    ...k
  };
  return /* @__PURE__ */ p.jsx(hb, {
    as: a,
    direction: r ? "rtl" : "ltr",
    slots: {
      root: T
    },
    slotProps: S ?? c,
    ...P,
    ref: n
  });
});
process.env.NODE_ENV !== "production" && (us.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: o.oneOfType([Di, o.object, o.func]),
  /**
   * Popper render function or node.
   */
  children: o.oneOfType([o.node, o.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: o.shape({
    Root: o.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: o.shape({
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([Di, o.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: o.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: o.arrayOf(o.shape({
    data: o.object,
    effect: o.func,
    enabled: o.bool,
    fn: o.func,
    name: o.any,
    options: o.object,
    phase: o.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: o.arrayOf(o.string),
    requiresIfExists: o.arrayOf(o.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: o.shape({
    modifiers: o.array,
    onFirstUpdate: o.func,
    placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: o.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: qo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: o.shape({
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: o.bool
});
function vb(e) {
  return Pt("MuiListSubheader", e);
}
Et("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const yb = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: r,
    inset: i,
    disableSticky: s
  } = e, a = {
    root: ["root", n !== "default" && `color${be(n)}`, !r && "gutters", i && "inset", !s && "sticky"]
  };
  return Ot(a, vb, t);
}, bb = Z("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${be(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(mt(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), Wu = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: i,
    color: s = "default",
    component: a = "li",
    disableGutters: l = !1,
    disableSticky: c = !1,
    inset: u = !1,
    ...f
  } = r, g = {
    ...r,
    color: s,
    component: a,
    disableGutters: l,
    disableSticky: c,
    inset: u
  }, h = yb(g);
  return /* @__PURE__ */ p.jsx(bb, {
    as: a,
    className: xe(h.root, i),
    ref: n,
    ownerState: g,
    ...f
  });
});
Wu && (Wu.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (Wu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: o.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: o.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: o.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const Cb = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function xb(e) {
  return Pt("MuiChip", e);
}
const wn = Et("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), wb = (e) => {
  const {
    classes: t,
    disabled: n,
    size: r,
    color: i,
    iconColor: s,
    onDelete: a,
    clickable: l,
    variant: c
  } = e, u = {
    root: ["root", c, n && "disabled", `size${be(r)}`, `color${be(i)}`, l && "clickable", l && `clickableColor${be(i)}`, a && "deletable", a && `deletableColor${be(i)}`, `${c}${be(i)}`],
    label: ["label", `label${be(r)}`],
    avatar: ["avatar", `avatar${be(r)}`, `avatarColor${be(i)}`],
    icon: ["icon", `icon${be(r)}`, `iconColor${be(s)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${be(r)}`, `deleteIconColor${be(i)}`, `deleteIcon${be(c)}Color${be(i)}`]
  };
  return Ot(u, xb, t);
}, Sb = Z("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: r,
      iconColor: i,
      clickable: s,
      onDelete: a,
      size: l,
      variant: c
    } = n;
    return [{
      [`& .${wn.avatar}`]: t.avatar
    }, {
      [`& .${wn.avatar}`]: t[`avatar${be(l)}`]
    }, {
      [`& .${wn.avatar}`]: t[`avatarColor${be(r)}`]
    }, {
      [`& .${wn.icon}`]: t.icon
    }, {
      [`& .${wn.icon}`]: t[`icon${be(l)}`]
    }, {
      [`& .${wn.icon}`]: t[`iconColor${be(i)}`]
    }, {
      [`& .${wn.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${wn.deleteIcon}`]: t[`deleteIcon${be(l)}`]
    }, {
      [`& .${wn.deleteIcon}`]: t[`deleteIconColor${be(r)}`]
    }, {
      [`& .${wn.deleteIcon}`]: t[`deleteIcon${be(c)}Color${be(r)}`]
    }, t.root, t[`size${be(l)}`], t[`color${be(r)}`], s && t.clickable, s && r !== "default" && t[`clickableColor${be(r)})`], a && t.deletable, a && r !== "default" && t[`deletableColor${be(r)}`], t[c], t[`${c}${be(r)}`]];
  }
})(mt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${wn.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${wn.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${wn.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${wn.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${wn.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${wn.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${wn.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : At(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : At(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${wn.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${wn.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(Mn(["contrastText"])).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText,
        [`& .${wn.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].contrastTextChannel} / 0.7)` : At(e.palette[n].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].contrastText
          }
        }
      }
    })), {
      props: (n) => n.iconColor === n.color,
      style: {
        [`& .${wn.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (n) => n.iconColor === n.color && n.color !== "default",
      style: {
        [`& .${wn.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${wn.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : At(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(Mn(["dark"])).map(([n]) => ({
      props: {
        color: n,
        onDelete: !0
      },
      style: {
        [`&.${wn.focusVisible}`]: {
          background: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : At(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${wn.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : At(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(Mn(["dark"])).map(([n]) => ({
      props: {
        color: n,
        clickable: !0
      },
      style: {
        [`&:hover, &.${wn.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${wn.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${wn.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${wn.avatar}`]: {
          marginLeft: 4
        },
        [`& .${wn.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${wn.icon}`]: {
          marginLeft: 4
        },
        [`& .${wn.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${wn.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${wn.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(Mn()).map(([n]) => ({
      props: {
        variant: "outlined",
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : At(e.palette[n].main, 0.7)}`,
        [`&.${wn.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette[n].main, e.palette.action.hoverOpacity)
        },
        [`&.${wn.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.focusOpacity})` : At(e.palette[n].main, e.palette.action.focusOpacity)
        },
        [`& .${wn.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : At(e.palette[n].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].main
          }
        }
      }
    }))]
  };
})), Eb = Z("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: r
    } = n;
    return [t.label, t[`label${be(r)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function l3(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const Ia = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiChip"
  }), {
    avatar: i,
    className: s,
    clickable: a,
    color: l = "default",
    component: c,
    deleteIcon: u,
    disabled: f = !1,
    icon: g,
    label: h,
    onClick: y,
    onDelete: v,
    onKeyDown: m,
    onKeyUp: b,
    size: C = "medium",
    variant: E = "filled",
    tabIndex: S,
    skipFocusWhenDisabled: k = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...T
  } = r, P = d.useRef(null), F = lo(P, n), j = (re) => {
    re.stopPropagation(), v && v(re);
  }, L = (re) => {
    re.currentTarget === re.target && l3(re) && re.preventDefault(), m && m(re);
  }, R = (re) => {
    re.currentTarget === re.target && v && l3(re) && v(re), b && b(re);
  }, V = a !== !1 && y ? !0 : a, B = V || v ? Tr : c || "div", W = {
    ...r,
    component: B,
    disabled: f,
    size: C,
    color: l,
    iconColor: /* @__PURE__ */ d.isValidElement(g) && g.props.color || l,
    onDelete: !!v,
    clickable: V,
    variant: E
  }, z = wb(W), G = B === Tr ? {
    component: c || "div",
    focusVisibleClassName: z.focusVisible,
    ...v && {
      disableRipple: !0
    }
  } : {};
  let H = null;
  v && (H = u && /* @__PURE__ */ d.isValidElement(u) ? /* @__PURE__ */ d.cloneElement(u, {
    className: xe(u.props.className, z.deleteIcon),
    onClick: j
  }) : /* @__PURE__ */ p.jsx(Cb, {
    className: xe(z.deleteIcon),
    onClick: j
  }));
  let ie = null;
  i && /* @__PURE__ */ d.isValidElement(i) && (ie = /* @__PURE__ */ d.cloneElement(i, {
    className: xe(z.avatar, i.props.className)
  }));
  let ce = null;
  return g && /* @__PURE__ */ d.isValidElement(g) && (ce = /* @__PURE__ */ d.cloneElement(g, {
    className: xe(z.icon, g.props.className)
  })), process.env.NODE_ENV !== "production" && ie && ce && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ p.jsxs(Sb, {
    as: B,
    className: xe(z.root, s),
    disabled: V && f ? !0 : void 0,
    onClick: y,
    onKeyDown: L,
    onKeyUp: R,
    ref: F,
    tabIndex: k && f ? -1 : S,
    ownerState: W,
    ...G,
    ...T,
    children: [ie || ce, /* @__PURE__ */ p.jsx(Eb, {
      className: xe(z.label),
      ownerState: W,
      children: h
    }), H]
  });
});
process.env.NODE_ENV !== "production" && (Ia.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: o.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: g4,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: o.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: o.oneOfType([o.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: o.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * Icon element.
   */
  icon: o.element,
  /**
   * The content of the component.
   */
  label: o.node,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: o.func,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * @ignore
   */
  onKeyUp: o.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @ignore
   */
  tabIndex: o.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: o.oneOfType([o.oneOf(["filled", "outlined"]), o.string])
});
function eu(e) {
  return parseInt(e, 10) || 0;
}
const Rb = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function Tb(e) {
  for (const t in e)
    return !1;
  return !0;
}
function c3(e) {
  return Tb(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
const $p = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    onChange: r,
    maxRows: i,
    minRows: s = 1,
    style: a,
    value: l,
    ...c
  } = t, {
    current: u
  } = d.useRef(l != null), f = d.useRef(null), g = lo(n, f), h = d.useRef(null), y = d.useRef(null), v = d.useCallback(() => {
    const S = f.current, k = y.current;
    if (!S || !k)
      return;
    const P = Lr(S).getComputedStyle(S);
    if (P.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    k.style.width = P.width, k.value = S.value || t.placeholder || "x", k.value.slice(-1) === `
` && (k.value += " ");
    const F = P.boxSizing, j = eu(P.paddingBottom) + eu(P.paddingTop), L = eu(P.borderBottomWidth) + eu(P.borderTopWidth), R = k.scrollHeight;
    k.value = "x";
    const V = k.scrollHeight;
    let B = R;
    s && (B = Math.max(Number(s) * V, B)), i && (B = Math.min(Number(i) * V, B)), B = Math.max(B, V);
    const W = B + (F === "border-box" ? j + L : 0), z = Math.abs(B - R) <= 1;
    return {
      outerHeightStyle: W,
      overflowing: z
    };
  }, [i, s, t.placeholder]), m = Eo(() => {
    const S = f.current, k = v();
    if (!S || !k || c3(k))
      return !1;
    const T = k.outerHeightStyle;
    return h.current != null && h.current !== T;
  }), b = d.useCallback(() => {
    const S = f.current, k = v();
    if (!S || !k || c3(k))
      return;
    const T = k.outerHeightStyle;
    h.current !== T && (h.current = T, S.style.height = `${T}px`), S.style.overflow = k.overflowing ? "hidden" : "";
  }, [v]), C = d.useRef(-1);
  Zo(() => {
    const S = Cd(b), k = f == null ? void 0 : f.current;
    if (!k)
      return;
    const T = Lr(k);
    T.addEventListener("resize", S);
    let P;
    return typeof ResizeObserver < "u" && (P = new ResizeObserver(() => {
      m() && (P.unobserve(k), cancelAnimationFrame(C.current), b(), C.current = requestAnimationFrame(() => {
        P.observe(k);
      }));
    }), P.observe(k)), () => {
      S.clear(), cancelAnimationFrame(C.current), T.removeEventListener("resize", S), P && P.disconnect();
    };
  }, [v, b, m]), Zo(() => {
    b();
  });
  const E = (S) => {
    u || b(), r && r(S);
  };
  return /* @__PURE__ */ p.jsxs(d.Fragment, {
    children: [/* @__PURE__ */ p.jsx("textarea", {
      value: l,
      onChange: E,
      ref: g,
      rows: s,
      style: a,
      ...c
    }), /* @__PURE__ */ p.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: y,
      tabIndex: -1,
      style: {
        ...Rb.shadow,
        ...a,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && ($p.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: o.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  onChange: o.func,
  /**
   * @ignore
   */
  placeholder: o.string,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * @ignore
   */
  value: o.oneOfType([o.arrayOf(o.string), o.number, o.string])
});
function Ti(e) {
  return typeof e == "string";
}
function Oa({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, i) => (r[i] = e[i], n && typeof e[i] > "u" && (r[i] = n[i]), r), {});
}
const uc = /* @__PURE__ */ d.createContext(void 0);
process.env.NODE_ENV !== "production" && (uc.displayName = "FormControlContext");
function pr() {
  return d.useContext(uc);
}
function u3(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function Gu(e, t = !1) {
  return e && (u3(e.value) && e.value !== "" || t && u3(e.defaultValue) && e.defaultValue !== "");
}
function Mb(e) {
  return e.startAdornment;
}
function kb(e) {
  return Pt("MuiInputBase", e);
}
const ir = Et("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var d3;
const Rd = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${be(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, Td = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, Pb = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: i,
    endAdornment: s,
    focused: a,
    formControl: l,
    fullWidth: c,
    hiddenLabel: u,
    multiline: f,
    readOnly: g,
    size: h,
    startAdornment: y,
    type: v
  } = e, m = {
    root: ["root", `color${be(n)}`, r && "disabled", i && "error", c && "fullWidth", a && "focused", l && "formControl", h && h !== "medium" && `size${be(h)}`, f && "multiline", y && "adornedStart", s && "adornedEnd", u && "hiddenLabel", g && "readOnly"],
    input: ["input", r && "disabled", v === "search" && "inputTypeSearch", f && "inputMultiline", h === "small" && "inputSizeSmall", u && "inputHiddenLabel", y && "inputAdornedStart", s && "inputAdornedEnd", g && "readOnly"]
  };
  return Ot(m, kb, t);
}, Md = Z("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: Rd
})(mt(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${ir.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: n
    }) => t.multiline && n === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), kd = Z("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: Td
})(mt(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, r = {
    opacity: "0 !important"
  }, i = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${ir.formControl} &`]: {
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus::-webkit-input-placeholder": i,
      "&:focus::-moz-placeholder": i,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": i
      // Edge
    },
    [`&.${ir.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: s
      }) => !s.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: s
      }) => s.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), p3 = z9({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), dc = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": i,
    autoComplete: s,
    autoFocus: a,
    className: l,
    color: c,
    components: u = {},
    componentsProps: f = {},
    defaultValue: g,
    disabled: h,
    disableInjectingGlobalStyles: y,
    endAdornment: v,
    error: m,
    fullWidth: b = !1,
    id: C,
    inputComponent: E = "input",
    inputProps: S = {},
    inputRef: k,
    margin: T,
    maxRows: P,
    minRows: F,
    multiline: j = !1,
    name: L,
    onBlur: R,
    onChange: V,
    onClick: B,
    onFocus: W,
    onKeyDown: z,
    onKeyUp: G,
    placeholder: H,
    readOnly: ie,
    renderSuffix: ce,
    rows: re,
    size: A,
    slotProps: Y = {},
    slots: pe = {},
    startAdornment: Ce,
    type: fe = "text",
    value: ee,
    ...te
  } = r, ue = S.value != null ? S.value : ee, {
    current: K
  } = d.useRef(ue != null), oe = d.useRef(), de = d.useCallback((Ke) => {
    process.env.NODE_ENV !== "production" && Ke && Ke.nodeName !== "INPUT" && !Ke.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), ve = lo(oe, k, S.ref, de), [J, se] = d.useState(!1), ge = pr();
  process.env.NODE_ENV !== "production" && d.useEffect(() => {
    if (ge)
      return ge.registerEffect();
  }, [ge]);
  const Se = Oa({
    props: r,
    muiFormControl: ge,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Se.focused = ge ? ge.focused : J, d.useEffect(() => {
    !ge && h && J && (se(!1), R && R());
  }, [ge, h, J, R]);
  const we = ge && ge.onFilled, me = ge && ge.onEmpty, ye = d.useCallback((Ke) => {
    Gu(Ke) ? we && we() : me && me();
  }, [we, me]);
  Zo(() => {
    K && ye({
      value: ue
    });
  }, [ue, ye, K]);
  const Ie = (Ke) => {
    W && W(Ke), S.onFocus && S.onFocus(Ke), ge && ge.onFocus ? ge.onFocus(Ke) : se(!0);
  }, je = (Ke) => {
    R && R(Ke), S.onBlur && S.onBlur(Ke), ge && ge.onBlur ? ge.onBlur(Ke) : se(!1);
  }, Te = (Ke, ...bt) => {
    if (!K) {
      const vt = Ke.target || oe.current;
      if (vt == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : ei(1));
      ye({
        value: vt.value
      });
    }
    S.onChange && S.onChange(Ke, ...bt), V && V(Ke, ...bt);
  };
  d.useEffect(() => {
    ye(oe.current);
  }, []);
  const Fe = (Ke) => {
    oe.current && Ke.currentTarget === Ke.target && oe.current.focus(), B && B(Ke);
  };
  let gt = E, Dt = S;
  j && gt === "input" && (re ? (process.env.NODE_ENV !== "production" && (F || P) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Dt = {
    type: void 0,
    minRows: re,
    maxRows: re,
    ...Dt
  }) : Dt = {
    type: void 0,
    maxRows: P,
    minRows: F,
    ...Dt
  }, gt = $p);
  const ke = (Ke) => {
    ye(Ke.animationName === "mui-auto-fill-cancel" ? oe.current : {
      value: "x"
    });
  };
  d.useEffect(() => {
    ge && ge.setAdornedStart(!!Ce);
  }, [ge, Ce]);
  const Ne = {
    ...r,
    color: Se.color || "primary",
    disabled: Se.disabled,
    endAdornment: v,
    error: Se.error,
    focused: Se.focused,
    formControl: ge,
    fullWidth: b,
    hiddenLabel: Se.hiddenLabel,
    multiline: j,
    size: Se.size,
    startAdornment: Ce,
    type: fe
  }, We = Pb(Ne), Ge = pe.root || u.Root || Md, Qe = Y.root || f.root || {}, Ve = pe.input || u.Input || kd;
  return Dt = {
    ...Dt,
    ...Y.input ?? f.input
  }, /* @__PURE__ */ p.jsxs(d.Fragment, {
    children: [!y && typeof p3 == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (d3 || (d3 = /* @__PURE__ */ p.jsx(p3, {}))), /* @__PURE__ */ p.jsxs(Ge, {
      ...Qe,
      ref: n,
      onClick: Fe,
      ...te,
      ...!Ti(Ge) && {
        ownerState: {
          ...Ne,
          ...Qe.ownerState
        }
      },
      className: xe(We.root, Qe.className, l, ie && "MuiInputBase-readOnly"),
      children: [Ce, /* @__PURE__ */ p.jsx(uc.Provider, {
        value: null,
        children: /* @__PURE__ */ p.jsx(Ve, {
          "aria-invalid": Se.error,
          "aria-describedby": i,
          autoComplete: s,
          autoFocus: a,
          defaultValue: g,
          disabled: Se.disabled,
          id: C,
          onAnimationStart: ke,
          name: L,
          placeholder: H,
          readOnly: ie,
          required: Se.required,
          rows: re,
          value: ue,
          onKeyDown: z,
          onKeyUp: G,
          type: fe,
          ...Dt,
          ...!Ti(Ve) && {
            as: gt,
            ownerState: {
              ...Ne,
              ...Dt.ownerState
            }
          },
          ref: ve,
          className: xe(We.input, Dt.className, ie && "MuiInputBase-readOnly"),
          onBlur: je,
          onChange: Te,
          onFocus: Ie
        })
      }), v, ce ? ce({
        ...Se,
        startAdornment: Ce
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (dc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": o.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: rc,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: o.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: o.func,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * @ignore
   */
  onKeyUp: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * @ignore
   */
  renderSuffix: o.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The size of the component.
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
function Ib(e) {
  return Pt("MuiInput", e);
}
const Zi = {
  ...ir,
  ...Et("MuiInput", ["root", "underline", "input"])
};
function Ob(e) {
  return Pt("MuiOutlinedInput", e);
}
const hr = {
  ...ir,
  ...Et("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function Db(e) {
  return Pt("MuiFilledInput", e);
}
const sr = {
  ...ir,
  ...Et("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, eg = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function jb(e) {
  return Pt("MuiAutocomplete", e);
}
const vn = Et("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var f3, g3;
const Fb = (e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: r,
    focused: i,
    fullWidth: s,
    hasClearIcon: a,
    hasPopupIcon: l,
    inputFocused: c,
    popupOpen: u,
    size: f
  } = e, g = {
    root: ["root", r && "expanded", i && "focused", s && "fullWidth", a && "hasClearIcon", l && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", c && "inputFocused"],
    tag: ["tag", `tagSize${be(f)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", u && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return Ot(g, jb, t);
}, Vb = Z("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: r,
      hasClearIcon: i,
      hasPopupIcon: s,
      inputFocused: a,
      size: l
    } = n;
    return [{
      [`& .${vn.tag}`]: t.tag
    }, {
      [`& .${vn.tag}`]: t[`tagSize${be(l)}`]
    }, {
      [`& .${vn.inputRoot}`]: t.inputRoot
    }, {
      [`& .${vn.input}`]: t.input
    }, {
      [`& .${vn.input}`]: a && t.inputFocused
    }, t.root, r && t.fullWidth, s && t.hasPopupIcon, i && t.hasClearIcon];
  }
})({
  [`&.${vn.focused} .${vn.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${vn.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${vn.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${vn.inputRoot}`]: {
    [`.${vn.hasPopupIcon}&, .${vn.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${vn.hasPopupIcon}.${vn.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${vn.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${Zi.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${Zi.root}.${ir.sizeSmall}`]: {
    [`& .${Zi.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${hr.root}`]: {
    padding: 9,
    [`.${vn.hasPopupIcon}&, .${vn.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${vn.hasPopupIcon}.${vn.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${vn.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${vn.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${hr.root}.${ir.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${vn.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${sr.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${vn.hasPopupIcon}&, .${vn.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${vn.hasPopupIcon}.${vn.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${sr.input}`]: {
      padding: "7px 4px"
    },
    [`& .${vn.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${sr.root}.${ir.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${sr.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${ir.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${sr.root}.${ir.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${vn.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${sr.root}.${ir.hiddenLabel}.${ir.sizeSmall}`]: {
    [`& .${vn.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${vn.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${vn.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${vn.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${vn.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), $b = Z("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), Lb = Z(Ar, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), Ab = Z(Ar, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popupIndicator, n.popupOpen && t.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), Nb = Z(us, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${vn.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }
})(mt(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), Bb = Z(li, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(mt(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), _b = Z("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(mt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), zb = Z("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(mt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), Hb = Z("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(mt(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${vn.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${vn.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${vn.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : At(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${vn.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : At(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${vn.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : At(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), Wb = Z(Wu, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(mt(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), Gb = Z("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${vn.option}`]: {
    paddingLeft: 24
  }
}), Lp = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: i = !1,
    autoHighlight: s = !1,
    autoSelect: a = !1,
    blurOnSelect: l = !1,
    ChipProps: c,
    className: u,
    clearIcon: f = f3 || (f3 = /* @__PURE__ */ p.jsx(_4, {
      fontSize: "small"
    })),
    clearOnBlur: g = !r.freeSolo,
    clearOnEscape: h = !1,
    clearText: y = "Clear",
    closeText: v = "Close",
    componentsProps: m,
    defaultValue: b = r.multiple ? [] : null,
    disableClearable: C = !1,
    disableCloseOnSelect: E = !1,
    disabled: S = !1,
    disabledItemsFocusable: k = !1,
    disableListWrap: T = !1,
    disablePortal: P = !1,
    filterOptions: F,
    filterSelectedOptions: j = !1,
    forcePopupIcon: L = "auto",
    freeSolo: R = !1,
    fullWidth: V = !1,
    getLimitTagsText: B = (Sn) => `+${Sn}`,
    getOptionDisabled: W,
    getOptionKey: z,
    getOptionLabel: G,
    isOptionEqualToValue: H,
    groupBy: ie,
    handleHomeEndKeys: ce = !r.freeSolo,
    id: re,
    includeInputInList: A = !1,
    inputValue: Y,
    limitTags: pe = -1,
    ListboxComponent: Ce,
    ListboxProps: fe,
    loading: ee = !1,
    loadingText: te = "Loading…",
    multiple: ue = !1,
    noOptionsText: K = "No options",
    onChange: oe,
    onClose: de,
    onHighlightChange: ve,
    onInputChange: J,
    onOpen: se,
    open: ge,
    openOnFocus: Se = !1,
    openText: we = "Open",
    options: me,
    PaperComponent: ye,
    PopperComponent: Ie,
    popupIcon: je = g3 || (g3 = /* @__PURE__ */ p.jsx(eg, {})),
    readOnly: Te = !1,
    renderGroup: Fe,
    renderInput: gt,
    renderOption: Dt,
    renderTags: ke,
    selectOnFocus: Ne = !r.freeSolo,
    size: We = "medium",
    slots: Ge = {},
    slotProps: Qe = {},
    value: Ve,
    ...Ke
  } = r, {
    getRootProps: bt,
    getInputProps: vt,
    getInputLabelProps: tn,
    getPopupIndicatorProps: hn,
    getClearProps: Je,
    getTagProps: $t,
    getListboxProps: nn,
    getOptionProps: Nt,
    value: cn,
    dirty: Lt,
    expanded: jt,
    id: un,
    popupOpen: On,
    focused: Un,
    focusedTag: ro,
    anchorEl: Ft,
    setAnchorEl: Yn,
    inputValue: it,
    groupedOptions: ft
  } = ny({
    ...r,
    componentName: "Autocomplete"
  }), Xt = !C && !S && Lt && !Te, Ae = (!R || L === !0) && L !== !1, {
    onMouseDown: St
  } = vt(), {
    ref: yn,
    ...In
  } = nn(), Do = G || ((Sn) => Sn.label ?? Sn), Xn = {
    ...r,
    disablePortal: P,
    expanded: jt,
    focused: Un,
    fullWidth: V,
    getOptionLabel: Do,
    hasClearIcon: Xt,
    hasPopupIcon: Ae,
    inputFocused: ro === -1,
    popupOpen: On,
    size: We
  }, fo = Fb(Xn), Ko = {
    slots: {
      paper: ye,
      popper: Ie,
      ...Ge
    },
    slotProps: {
      chip: c,
      listbox: fe,
      ...m,
      ...Qe
    }
  }, [di, Le] = kt("listbox", {
    elementType: Hb,
    externalForwardedProps: Ko,
    ownerState: Xn,
    className: fo.listbox,
    additionalProps: In,
    ref: yn
  }), [Pe, ot] = kt("paper", {
    elementType: li,
    externalForwardedProps: Ko,
    ownerState: Xn,
    className: fo.paper
  }), [Qt, dn] = kt("popper", {
    elementType: us,
    externalForwardedProps: Ko,
    ownerState: Xn,
    className: fo.popper,
    additionalProps: {
      disablePortal: P,
      style: {
        width: Ft ? Ft.clientWidth : null
      },
      role: "presentation",
      anchorEl: Ft,
      open: On
    }
  });
  let xn;
  if (ue && cn.length > 0) {
    const Sn = (Lo) => ({
      className: fo.tag,
      disabled: S,
      ...$t(Lo)
    });
    ke ? xn = ke(cn, Sn, Xn) : xn = cn.map((Lo, rr) => {
      const {
        key: fi,
        ...$a
      } = Sn({
        index: rr
      });
      return /* @__PURE__ */ p.jsx(Ia, {
        label: Do(Lo),
        size: We,
        ...$a,
        ...Ko.slotProps.chip
      }, fi);
    });
  }
  if (pe > -1 && Array.isArray(xn)) {
    const Sn = xn.length - pe;
    !Un && Sn > 0 && (xn = xn.splice(0, pe), xn.push(/* @__PURE__ */ p.jsx("span", {
      className: fo.tag,
      children: B(Sn)
    }, xn.length)));
  }
  const Ro = Fe || ((Sn) => /* @__PURE__ */ p.jsxs("li", {
    children: [/* @__PURE__ */ p.jsx(Wb, {
      className: fo.groupLabel,
      ownerState: Xn,
      component: "div",
      children: Sn.group
    }), /* @__PURE__ */ p.jsx(Gb, {
      className: fo.groupUl,
      ownerState: Xn,
      children: Sn.children
    })]
  }, Sn.key)), Va = Dt || ((Sn, Lo) => {
    const {
      key: rr,
      ...fi
    } = Sn;
    return /* @__PURE__ */ p.jsx("li", {
      ...fi,
      children: Do(Lo)
    }, rr);
  }), ds = (Sn, Lo) => {
    const rr = Nt({
      option: Sn,
      index: Lo
    });
    return Va({
      ...rr,
      className: fo.option
    }, Sn, {
      selected: rr["aria-selected"],
      index: Lo,
      inputValue: it
    }, Xn);
  }, Hr = Ko.slotProps.clearIndicator, _i = Ko.slotProps.popupIndicator;
  return /* @__PURE__ */ p.jsxs(d.Fragment, {
    children: [/* @__PURE__ */ p.jsx(Vb, {
      ref: n,
      className: xe(fo.root, u),
      ownerState: Xn,
      ...bt(Ke),
      children: gt({
        id: un,
        disabled: S,
        fullWidth: !0,
        size: We === "small" ? "small" : void 0,
        InputLabelProps: tn(),
        InputProps: {
          ref: Yn,
          className: fo.inputRoot,
          startAdornment: xn,
          onMouseDown: (Sn) => {
            Sn.target === Sn.currentTarget && St(Sn);
          },
          ...(Xt || Ae) && {
            endAdornment: /* @__PURE__ */ p.jsxs($b, {
              className: fo.endAdornment,
              ownerState: Xn,
              children: [Xt ? /* @__PURE__ */ p.jsx(Lb, {
                ...Je(),
                "aria-label": y,
                title: y,
                ownerState: Xn,
                ...Hr,
                className: xe(fo.clearIndicator, Hr == null ? void 0 : Hr.className),
                children: f
              }) : null, Ae ? /* @__PURE__ */ p.jsx(Ab, {
                ...hn(),
                disabled: S,
                "aria-label": On ? v : we,
                title: On ? v : we,
                ownerState: Xn,
                ..._i,
                className: xe(fo.popupIndicator, _i == null ? void 0 : _i.className),
                children: je
              }) : null]
            })
          }
        },
        inputProps: {
          className: fo.input,
          disabled: S,
          readOnly: Te,
          ...vt()
        }
      })
    }), Ft ? /* @__PURE__ */ p.jsx(Nb, {
      as: Qt,
      ...dn,
      children: /* @__PURE__ */ p.jsxs(Bb, {
        as: Pe,
        ...ot,
        children: [ee && ft.length === 0 ? /* @__PURE__ */ p.jsx(_b, {
          className: fo.loading,
          ownerState: Xn,
          children: te
        }) : null, ft.length === 0 && !R && !ee ? /* @__PURE__ */ p.jsx(zb, {
          className: fo.noOptions,
          ownerState: Xn,
          role: "presentation",
          onMouseDown: (Sn) => {
            Sn.preventDefault();
          },
          children: K
        }) : null, ft.length > 0 ? /* @__PURE__ */ p.jsx(di, {
          as: Ce,
          ...Le,
          children: ft.map((Sn, Lo) => ie ? Ro({
            key: Sn.key,
            group: Sn.group,
            children: Sn.options.map((rr, fi) => ds(rr, Sn.index + fi))
          }) : ds(Sn, Lo))
        }) : null]
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (Lp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: o.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: o.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: o.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: o.oneOfType([o.oneOf(["mouse", "touch"]), o.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: o.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: o.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: o.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: o.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: o.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: o.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: o.shape({
    clearIndicator: o.object,
    paper: o.object,
    popper: o.object,
    popupIndicator: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: nr(o.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: o.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: o.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: o.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: o.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: o.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: o.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: o.oneOfType([o.oneOf(["auto"]), o.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: o.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: o.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: o.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: o.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: o.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: o.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: o.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: o.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: o.bool,
  /**
   * The input value.
   */
  inputValue: o.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: o.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: Fr,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: o.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: o.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: o.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: o.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: o.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: o.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: o.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: o.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: o.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: o.func,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: o.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: o.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: o.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: o.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: o.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: o.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: o.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: o.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: o.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: o.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: o.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: o.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium"]), o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    chip: o.oneOfType([o.func, o.object]),
    clearIndicator: o.oneOfType([o.func, o.object]),
    listbox: o.oneOfType([o.func, o.object]),
    paper: o.oneOfType([o.func, o.object]),
    popper: o.oneOfType([o.func, o.object]),
    popupIndicator: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    listbox: o.elementType,
    paper: o.elementType,
    popper: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: nr(o.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const Ub = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function Yb(e) {
  return Pt("MuiAvatar", e);
}
Et("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]);
const Zb = (e) => {
  const {
    classes: t,
    variant: n,
    colorDefault: r
  } = e;
  return Ot({
    root: ["root", n, r && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, Yb, t);
}, qb = Z("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.colorDefault && t.colorDefault];
  }
})(mt(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: {
      color: (e.vars || e).palette.background.default,
      ...e.vars ? {
        backgroundColor: e.vars.palette.Avatar.defaultBg
      } : {
        backgroundColor: e.palette.grey[400],
        ...e.applyStyles("dark", {
          backgroundColor: e.palette.grey[600]
        })
      }
    }
  }]
}))), Kb = Z("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), Xb = Z(Ub, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "75%",
  height: "75%"
});
function Qb({
  crossOrigin: e,
  referrerPolicy: t,
  src: n,
  srcSet: r
}) {
  const [i, s] = d.useState(!1);
  return d.useEffect(() => {
    if (!n && !r)
      return;
    s(!1);
    let a = !0;
    const l = new Image();
    return l.onload = () => {
      a && s("loaded");
    }, l.onerror = () => {
      a && s("error");
    }, l.crossOrigin = e, l.referrerPolicy = t, l.src = n, r && (l.srcset = r), () => {
      a = !1;
    };
  }, [e, t, n, r]), i;
}
const Jb = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: i,
    children: s,
    className: a,
    component: l = "div",
    slots: c = {},
    slotProps: u = {},
    imgProps: f,
    sizes: g,
    src: h,
    srcSet: y,
    variant: v = "circular",
    ...m
  } = r;
  let b = null;
  const C = {
    ...r,
    component: l,
    variant: v
  }, E = Qb({
    ...f,
    ...typeof u.img == "function" ? u.img(C) : u.img,
    src: h,
    srcSet: y
  }), S = h || y, k = S && E !== "error";
  C.colorDefault = !k, delete C.ownerState;
  const T = Zb(C), [P, F] = kt("img", {
    className: T.img,
    elementType: Kb,
    externalForwardedProps: {
      slots: c,
      slotProps: {
        img: {
          ...f,
          ...u.img
        }
      }
    },
    additionalProps: {
      alt: i,
      src: h,
      srcSet: y,
      sizes: g
    },
    ownerState: C
  });
  return k ? b = /* @__PURE__ */ p.jsx(P, {
    ...F
  }) : s || s === 0 ? b = s : S && i ? b = i[0] : b = /* @__PURE__ */ p.jsx(Xb, {
    ownerState: C,
    className: T.fallback
  }), /* @__PURE__ */ p.jsx(qb, {
    as: l,
    className: xe(T.root, a),
    ref: n,
    ...m,
    ownerState: C,
    children: b
  });
});
process.env.NODE_ENV !== "production" && (Jb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: o.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  imgProps: o.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: o.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    img: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    img: o.elementType
  }),
  /**
   * The `src` attribute for the `img` element.
   */
  src: o.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: o.oneOfType([o.oneOf(["circular", "rounded", "square"]), o.string])
});
const eC = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Fi = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = to(), i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: s,
    appear: a = !0,
    children: l,
    easing: c,
    in: u,
    onEnter: f,
    onEntered: g,
    onEntering: h,
    onExit: y,
    onExited: v,
    onExiting: m,
    style: b,
    timeout: C = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: E = dr,
    ...S
  } = t, k = d.useRef(null), T = lo(k, _s(l), n), P = (z) => (G) => {
    if (z) {
      const H = k.current;
      G === void 0 ? z(H) : z(H, G);
    }
  }, F = P(h), j = P((z, G) => {
    A4(z);
    const H = xa({
      style: b,
      timeout: C,
      easing: c
    }, {
      mode: "enter"
    });
    z.style.webkitTransition = r.transitions.create("opacity", H), z.style.transition = r.transitions.create("opacity", H), f && f(z, G);
  }), L = P(g), R = P(m), V = P((z) => {
    const G = xa({
      style: b,
      timeout: C,
      easing: c
    }, {
      mode: "exit"
    });
    z.style.webkitTransition = r.transitions.create("opacity", G), z.style.transition = r.transitions.create("opacity", G), y && y(z);
  }), B = P(v), W = (z) => {
    s && s(k.current, z);
  };
  return /* @__PURE__ */ p.jsx(E, {
    appear: a,
    in: u,
    nodeRef: k,
    onEnter: j,
    onEntered: L,
    onEntering: F,
    onExit: V,
    onExited: B,
    onExiting: R,
    addEndListener: W,
    timeout: C,
    ...S,
    children: (z, {
      ownerState: G,
      ...H
    }) => /* @__PURE__ */ d.cloneElement(l, {
      style: {
        opacity: 0,
        visibility: z === "exited" && !u ? "hidden" : void 0,
        ...eC[z],
        ...b,
        ...l.props.style
      },
      ref: T,
      ...H
    })
  });
});
process.env.NODE_ENV !== "production" && (Fi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: o.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: o.bool,
  /**
   * A single child content element.
   */
  children: Bs.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: o.oneOfType([o.shape({
    enter: o.string,
    exit: o.string
  }), o.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: o.bool,
  /**
   * @ignore
   */
  onEnter: o.func,
  /**
   * @ignore
   */
  onEntered: o.func,
  /**
   * @ignore
   */
  onEntering: o.func,
  /**
   * @ignore
   */
  onExit: o.func,
  /**
   * @ignore
   */
  onExited: o.func,
  /**
   * @ignore
   */
  onExiting: o.func,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: o.oneOfType([o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })])
});
function tC(e) {
  return Pt("MuiBackdrop", e);
}
Et("MuiBackdrop", ["root", "invisible"]);
const nC = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return Ot({
    root: ["root", n && "invisible"]
  }, tC, t);
}, oC = Z("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), Ap = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: i,
    className: s,
    component: a = "div",
    invisible: l = !1,
    open: c,
    components: u = {},
    componentsProps: f = {},
    slotProps: g = {},
    slots: h = {},
    TransitionComponent: y,
    transitionDuration: v,
    ...m
  } = r, b = {
    ...r,
    component: a,
    invisible: l
  }, C = nC(b), E = {
    transition: y,
    root: u.Root,
    ...h
  }, S = {
    ...f,
    ...g
  }, k = {
    slots: E,
    slotProps: S
  }, [T, P] = kt("root", {
    elementType: oC,
    externalForwardedProps: k,
    className: xe(C.root, s),
    ownerState: b
  }), [F, j] = kt("transition", {
    elementType: Fi,
    externalForwardedProps: k,
    ownerState: b
  });
  return /* @__PURE__ */ p.jsx(F, {
    in: c,
    timeout: v,
    ...m,
    ...j,
    children: /* @__PURE__ */ p.jsx(T, {
      "aria-hidden": !0,
      ...P,
      classes: C,
      ref: n,
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (Ap.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    root: o.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: o.bool,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    root: o.oneOfType([o.func, o.object]),
    transition: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    root: o.elementType,
    transition: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: o.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: o.oneOfType([o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })])
});
function rC(e) {
  const {
    badgeContent: t,
    invisible: n = !1,
    max: r = 99,
    showZero: i = !1
  } = e, s = Cp({
    badgeContent: t,
    max: r
  });
  let a = n;
  n === !1 && t === 0 && !i && (a = !0);
  const {
    badgeContent: l,
    max: c = r
  } = a ? s : e, u = l && Number(l) > c ? `${c}+` : l;
  return {
    badgeContent: l,
    invisible: a,
    max: c,
    displayValue: u
  };
}
function iC(e) {
  return Pt("MuiBadge", e);
}
const Yi = Et("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), B1 = 10, _1 = 4, sC = (e) => {
  const {
    color: t,
    anchorOrigin: n,
    invisible: r,
    overlap: i,
    variant: s,
    classes: a = {}
  } = e, l = {
    root: ["root"],
    badge: ["badge", s, r && "invisible", `anchorOrigin${be(n.vertical)}${be(n.horizontal)}`, `anchorOrigin${be(n.vertical)}${be(n.horizontal)}${be(i)}`, `overlap${be(i)}`, t !== "default" && `color${be(t)}`]
  };
  return Ot(l, iC, a);
}, aC = Z("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), lC = Z("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.badge, t[n.variant], t[`anchorOrigin${be(n.anchorOrigin.vertical)}${be(n.anchorOrigin.horizontal)}${be(n.overlap)}`], n.color !== "default" && t[`color${be(n.color)}`], n.invisible && t.invisible];
  }
})(mt(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  position: "absolute",
  boxSizing: "border-box",
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(12),
  minWidth: B1 * 2,
  lineHeight: 1,
  padding: "0 6px",
  height: B1 * 2,
  borderRadius: B1,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeInOut,
    duration: e.transitions.duration.enteringScreen
  }),
  variants: [...Object.entries(e.palette).filter(Mn(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main,
      color: (e.vars || e).palette[t].contrastText
    }
  })), {
    props: {
      variant: "dot"
    },
    style: {
      borderRadius: _1,
      height: _1 * 2,
      minWidth: _1 * 2,
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      top: 0,
      right: 0,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${Yi.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      right: 0,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${Yi.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      top: 0,
      left: 0,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${Yi.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      left: 0,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${Yi.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      top: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${Yi.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      bottom: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${Yi.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      top: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${Yi.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      bottom: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${Yi.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: {
      invisible: !0
    },
    style: {
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeInOut,
        duration: e.transitions.duration.leavingScreen
      })
    }
  }]
})));
function m3(e) {
  return {
    vertical: (e == null ? void 0 : e.vertical) ?? "top",
    horizontal: (e == null ? void 0 : e.horizontal) ?? "right"
  };
}
const Np = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: i,
    className: s,
    classes: a,
    component: l,
    components: c = {},
    componentsProps: u = {},
    children: f,
    overlap: g = "rectangular",
    color: h = "default",
    invisible: y = !1,
    max: v = 99,
    badgeContent: m,
    slots: b,
    slotProps: C,
    showZero: E = !1,
    variant: S = "standard",
    ...k
  } = r, {
    badgeContent: T,
    invisible: P,
    max: F,
    displayValue: j
  } = rC({
    max: v,
    invisible: y,
    badgeContent: m,
    showZero: E
  }), L = Cp({
    anchorOrigin: m3(i),
    color: h,
    overlap: g,
    variant: S,
    badgeContent: m
  }), R = P || T == null && S !== "dot", {
    color: V = h,
    overlap: B = g,
    anchorOrigin: W,
    variant: z = S
  } = R ? L : r, G = m3(W), H = z !== "dot" ? j : void 0, ie = {
    ...r,
    badgeContent: T,
    invisible: R,
    max: F,
    displayValue: H,
    showZero: E,
    anchorOrigin: G,
    color: V,
    overlap: B,
    variant: z
  }, ce = sC(ie), re = {
    slots: {
      root: (b == null ? void 0 : b.root) ?? c.Root,
      badge: (b == null ? void 0 : b.badge) ?? c.Badge
    },
    slotProps: {
      root: (C == null ? void 0 : C.root) ?? u.root,
      badge: (C == null ? void 0 : C.badge) ?? u.badge
    }
  }, [A, Y] = kt("root", {
    elementType: aC,
    externalForwardedProps: {
      ...re,
      ...k
    },
    ownerState: ie,
    className: xe(ce.root, s),
    ref: n,
    additionalProps: {
      as: l
    }
  }), [pe, Ce] = kt("badge", {
    elementType: lC,
    externalForwardedProps: re,
    ownerState: ie,
    className: ce.badge
  });
  return /* @__PURE__ */ p.jsxs(A, {
    ...Y,
    children: [f, /* @__PURE__ */ p.jsx(pe, {
      ...Ce,
      children: H
    })]
  });
});
process.env.NODE_ENV !== "production" && (Np.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: o.shape({
    horizontal: o.oneOf(["left", "right"]),
    vertical: o.oneOf(["bottom", "top"])
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: o.node,
  /**
   * The badge will be added relative to this node.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: o.oneOfType([o.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Badge: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    badge: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: o.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: o.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: o.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: o.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    badge: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    badge: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: o.oneOfType([o.oneOf(["dot", "standard"]), o.string])
});
const cC = Et("MuiBox", ["root"]), uC = Bl(), An = o4({
  themeId: Sr,
  defaultTheme: uC,
  defaultClassName: cC.root,
  generateClassName: yp.generate
});
process.env.NODE_ENV !== "production" && (An.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: o.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const dC = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz"), pC = Z(Tr, {
  name: "MuiBreadcrumbCollapsed"
})(mt(({
  theme: e
}) => ({
  display: "flex",
  marginLeft: `calc(${e.spacing(1)} * 0.5)`,
  marginRight: `calc(${e.spacing(1)} * 0.5)`,
  ...e.palette.mode === "light" ? {
    backgroundColor: e.palette.grey[100],
    color: e.palette.grey[700]
  } : {
    backgroundColor: e.palette.grey[700],
    color: e.palette.grey[100]
  },
  borderRadius: 2,
  "&:hover, &:focus": {
    ...e.palette.mode === "light" ? {
      backgroundColor: e.palette.grey[200]
    } : {
      backgroundColor: e.palette.grey[600]
    }
  },
  "&:active": {
    boxShadow: e.shadows[0],
    ...e.palette.mode === "light" ? {
      backgroundColor: E0(e.palette.grey[200], 0.12)
    } : {
      backgroundColor: E0(e.palette.grey[600], 0.12)
    }
  }
}))), fC = Z(dC)({
  width: 24,
  height: 16
});
function tg(e) {
  const {
    slots: t = {},
    slotProps: n = {},
    ...r
  } = e, i = e;
  return /* @__PURE__ */ p.jsx("li", {
    children: /* @__PURE__ */ p.jsx(pC, {
      focusRipple: !0,
      ...r,
      ownerState: i,
      children: /* @__PURE__ */ p.jsx(fC, {
        as: t.CollapsedIcon,
        ownerState: i,
        ...n.collapsedIcon
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (tg.propTypes = {
  /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */
  slotProps: o.shape({
    collapsedIcon: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    CollapsedIcon: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.object
});
function gC(e) {
  return Pt("MuiBreadcrumbs", e);
}
const mC = Et("MuiBreadcrumbs", ["root", "ol", "li", "separator"]), hC = (e) => {
  const {
    classes: t
  } = e;
  return Ot({
    root: ["root"],
    li: ["li"],
    ol: ["ol"],
    separator: ["separator"]
  }, gC, t);
}, vC = Z(vo, {
  name: "MuiBreadcrumbs",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${mC.li}`]: t.li
  }, t.root]
})({}), yC = Z("ol", {
  name: "MuiBreadcrumbs",
  slot: "Ol",
  overridesResolver: (e, t) => t.ol
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
}), bC = Z("li", {
  name: "MuiBreadcrumbs",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  display: "flex",
  userSelect: "none",
  marginLeft: 8,
  marginRight: 8
});
function CC(e, t, n, r) {
  return e.reduce((i, s, a) => (a < e.length - 1 ? i = i.concat(s, /* @__PURE__ */ p.jsx(bC, {
    "aria-hidden": !0,
    className: t,
    ownerState: r,
    children: n
  }, `separator-${a}`)) : i.push(s), i), []);
}
const ng = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiBreadcrumbs"
  }), {
    children: i,
    className: s,
    component: a = "nav",
    slots: l = {},
    slotProps: c = {},
    expandText: u = "Show path",
    itemsAfterCollapse: f = 1,
    itemsBeforeCollapse: g = 1,
    maxItems: h = 8,
    separator: y = "/",
    ...v
  } = r, [m, b] = d.useState(!1), C = {
    ...r,
    component: a,
    expanded: m,
    expandText: u,
    itemsAfterCollapse: f,
    itemsBeforeCollapse: g,
    maxItems: h,
    separator: y
  }, E = hC(C), S = Yo({
    elementType: l.CollapsedIcon,
    externalSlotProps: c.collapsedIcon,
    ownerState: C
  }), k = d.useRef(null), T = (F) => {
    const j = () => {
      b(!0);
      const L = k.current.querySelector("a[href],button,[tabindex]");
      L && L.focus();
    };
    return g + f >= F.length ? (process.env.NODE_ENV !== "production" && console.error(["MUI: You have provided an invalid combination of props to the Breadcrumbs.", `itemsAfterCollapse={${f}} + itemsBeforeCollapse={${g}} >= maxItems={${h}}`].join(`
`)), F) : [...F.slice(0, g), /* @__PURE__ */ p.jsx(tg, {
      "aria-label": u,
      slots: {
        CollapsedIcon: l.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: S
      },
      onClick: j
    }, "ellipsis"), ...F.slice(F.length - f, F.length)];
  }, P = d.Children.toArray(i).filter((F) => (process.env.NODE_ENV !== "production" && Pi.isFragment(F) && console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ d.isValidElement(F))).map((F, j) => /* @__PURE__ */ p.jsx("li", {
    className: E.li,
    children: F
  }, `child-${j}`));
  return /* @__PURE__ */ p.jsx(vC, {
    ref: n,
    component: a,
    color: "textSecondary",
    className: xe(E.root, s),
    ownerState: C,
    ...v,
    children: /* @__PURE__ */ p.jsx(yC, {
      className: E.ol,
      ref: k,
      ownerState: C,
      children: CC(m || h && P.length <= h ? P : T(P), E.separator, y, C)
    })
  });
});
process.env.NODE_ENV !== "production" && (ng.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Show path'
   */
  expandText: o.string,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: Fr,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: Fr,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: Fr,
  /**
   * Custom separator node.
   * @default '/'
   */
  separator: o.node,
  /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */
  slotProps: o.shape({
    collapsedIcon: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    CollapsedIcon: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function xC(e) {
  return Pt("MuiButton", e);
}
const ms = Et("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge", "loading", "loadingWrapper", "loadingIconPlaceholder", "loadingIndicator", "loadingPositionCenter", "loadingPositionStart", "loadingPositionEnd"]), Bp = /* @__PURE__ */ d.createContext({});
process.env.NODE_ENV !== "production" && (Bp.displayName = "ButtonGroupContext");
const _p = /* @__PURE__ */ d.createContext(void 0);
process.env.NODE_ENV !== "production" && (_p.displayName = "ButtonGroupButtonContext");
const wC = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: r,
    size: i,
    variant: s,
    loading: a,
    loadingPosition: l,
    classes: c
  } = e, u = {
    root: ["root", a && "loading", s, `${s}${be(t)}`, `size${be(i)}`, `${s}Size${be(i)}`, `color${be(t)}`, n && "disableElevation", r && "fullWidth", a && `loadingPosition${be(l)}`],
    startIcon: ["icon", "startIcon", `iconSize${be(i)}`],
    endIcon: ["icon", "endIcon", `iconSize${be(i)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  }, f = Ot(u, xC, c);
  return {
    ...c,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...f
  };
}, og = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], SC = Z(Tr, {
  shouldForwardProp: (e) => $o(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${be(n.color)}`], t[`size${be(n.size)}`], t[`${n.variant}Size${be(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth, n.loading && t.loading];
  }
})(mt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], n = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${ms.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${ms.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${ms.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${ms.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(Mn()).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[r].main,
        "--variant-outlinedColor": (e.vars || e).palette[r].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.5)` : At(e.palette[r].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[r].contrastText,
        "--variant-containedBg": (e.vars || e).palette[r].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[r].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette[r].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[r].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette[r].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : n,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${ms.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${ms.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }, {
      props: {
        loadingPosition: "center"
      },
      style: {
        transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
          duration: e.transitions.duration.short
        }),
        [`&.${ms.loading}`]: {
          color: "transparent"
        }
      }
    }]
  };
})), EC = Z("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, n.loading && t.startIconLoadingStart, t[`iconSize${be(n.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginRight: -8
    }
  }, ...og]
})), RC = Z("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, n.loading && t.endIconLoadingEnd, t[`iconSize${be(n.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginLeft: -8
    }
  }, ...og]
})), TC = Z("span", {
  name: "MuiButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }, {
    props: {
      loadingPosition: "start"
    },
    style: {
      left: 14
    }
  }, {
    props: {
      loadingPosition: "start",
      size: "small"
    },
    style: {
      left: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "start"
    },
    style: {
      left: 6
    }
  }, {
    props: {
      loadingPosition: "center"
    },
    style: {
      left: "50%",
      transform: "translate(-50%)",
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      loadingPosition: "end"
    },
    style: {
      right: 14
    }
  }, {
    props: {
      loadingPosition: "end",
      size: "small"
    },
    style: {
      right: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "end"
    },
    style: {
      right: 6
    }
  }, {
    props: {
      loadingPosition: "start",
      fullWidth: !0
    },
    style: {
      position: "relative",
      left: -10
    }
  }, {
    props: {
      loadingPosition: "end",
      fullWidth: !0
    },
    style: {
      position: "relative",
      right: -10
    }
  }]
})), h3 = Z("span", {
  name: "MuiButton",
  slot: "LoadingIconPlaceholder",
  overridesResolver: (e, t) => t.loadingIconPlaceholder
})({
  display: "inline-block",
  width: "1em",
  height: "1em"
}), Si = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = d.useContext(Bp), i = d.useContext(_p), s = Al(r, t), a = Vt({
    props: s,
    name: "MuiButton"
  }), {
    children: l,
    color: c = "primary",
    component: u = "button",
    className: f,
    disabled: g = !1,
    disableElevation: h = !1,
    disableFocusRipple: y = !1,
    endIcon: v,
    focusVisibleClassName: m,
    fullWidth: b = !1,
    id: C,
    loading: E = null,
    loadingIndicator: S,
    loadingPosition: k = "center",
    size: T = "medium",
    startIcon: P,
    type: F,
    variant: j = "text",
    ...L
  } = a, R = ai(C), V = S ?? /* @__PURE__ */ p.jsx(zs, {
    "aria-labelledby": R,
    color: "inherit",
    size: 16
  }), B = {
    ...a,
    color: c,
    component: u,
    disabled: g,
    disableElevation: h,
    disableFocusRipple: y,
    fullWidth: b,
    loading: E,
    loadingIndicator: V,
    loadingPosition: k,
    size: T,
    type: F,
    variant: j
  }, W = wC(B), z = (P || E && k === "start") && /* @__PURE__ */ p.jsx(EC, {
    className: W.startIcon,
    ownerState: B,
    children: P || /* @__PURE__ */ p.jsx(h3, {
      className: W.loadingIconPlaceholder,
      ownerState: B
    })
  }), G = (v || E && k === "end") && /* @__PURE__ */ p.jsx(RC, {
    className: W.endIcon,
    ownerState: B,
    children: v || /* @__PURE__ */ p.jsx(h3, {
      className: W.loadingIconPlaceholder,
      ownerState: B
    })
  }), H = i || "", ie = typeof E == "boolean" ? (
    // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ p.jsx("span", {
      className: W.loadingWrapper,
      style: {
        display: "contents"
      },
      children: E && /* @__PURE__ */ p.jsx(TC, {
        className: W.loadingIndicator,
        ownerState: B,
        children: V
      })
    })
  ) : null;
  return /* @__PURE__ */ p.jsxs(SC, {
    ownerState: B,
    className: xe(r.className, W.root, f, H),
    component: u,
    disabled: g || E,
    focusRipple: !y,
    focusVisibleClassName: xe(W.focusVisible, m),
    ref: n,
    type: F,
    id: E ? R : C,
    ...L,
    classes: W,
    children: [z, k !== "end" && ie, l, k === "end" && ie, G]
  });
});
process.env.NODE_ENV !== "production" && (Si.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: o.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * Element placed after the children.
   */
  endIcon: o.node,
  /**
   * @ignore
   */
  focusVisibleClassName: o.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: o.string,
  /**
   * @ignore
   */
  id: o.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: o.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: o.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: o.oneOf(["center", "end", "start"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * Element placed before the children.
   */
  startIcon: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @ignore
   */
  type: o.oneOfType([o.oneOf(["button", "reset", "submit"]), o.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: o.oneOfType([o.oneOf(["contained", "outlined", "text"]), o.string])
});
function MC(e) {
  return Pt("MuiButtonGroup", e);
}
const gn = Et("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "horizontal", "vertical", "colorPrimary", "colorSecondary", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]), kC = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [{
    [`& .${gn.grouped}`]: t.grouped
  }, {
    [`& .${gn.grouped}`]: t[`grouped${be(n.orientation)}`]
  }, {
    [`& .${gn.grouped}`]: t[`grouped${be(n.variant)}`]
  }, {
    [`& .${gn.grouped}`]: t[`grouped${be(n.variant)}${be(n.orientation)}`]
  }, {
    [`& .${gn.grouped}`]: t[`grouped${be(n.variant)}${be(n.color)}`]
  }, {
    [`& .${gn.firstButton}`]: t.firstButton
  }, {
    [`& .${gn.lastButton}`]: t.lastButton
  }, {
    [`& .${gn.middleButton}`]: t.middleButton
  }, t.root, t[n.variant], n.disableElevation === !0 && t.disableElevation, n.fullWidth && t.fullWidth, n.orientation === "vertical" && t.vertical];
}, PC = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    disableElevation: i,
    fullWidth: s,
    orientation: a,
    variant: l
  } = e, c = {
    root: ["root", l, a, s && "fullWidth", i && "disableElevation", `color${be(n)}`],
    grouped: ["grouped", `grouped${be(a)}`, `grouped${be(l)}`, `grouped${be(l)}${be(a)}`, `grouped${be(l)}${be(n)}`, r && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return Ot(c, MC, t);
}, IC = Z("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: kC
})(mt(({
  theme: e
}) => ({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius,
  variants: [{
    props: {
      variant: "contained"
    },
    style: {
      boxShadow: (e.vars || e).shadows[2]
    }
  }, {
    props: {
      disableElevation: !0
    },
    style: {
      boxShadow: "none"
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column",
      [`& .${gn.lastButton},& .${gn.middleButton}`]: {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      },
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${gn.lastButton},& .${gn.middleButton}`]: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "horizontal"
    },
    style: {
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderRight: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${gn.disabled}`]: {
          borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "vertical"
    },
    style: {
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderBottom: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${gn.disabled}`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(e.palette).filter(Mn()).flatMap(([t]) => [{
    props: {
      variant: "text",
      color: t
    },
    style: {
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.5)` : At(e.palette[t].main, 0.5)
      }
    }
  }]), {
    props: {
      variant: "outlined",
      orientation: "horizontal"
    },
    style: {
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderRightColor: "transparent",
        "&:hover": {
          borderRightColor: "currentColor"
        }
      },
      [`& .${gn.lastButton},& .${gn.middleButton}`]: {
        marginLeft: -1
      }
    }
  }, {
    props: {
      variant: "outlined",
      orientation: "vertical"
    },
    style: {
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderBottomColor: "transparent",
        "&:hover": {
          borderBottomColor: "currentColor"
        }
      },
      [`& .${gn.lastButton},& .${gn.middleButton}`]: {
        marginTop: -1
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "horizontal"
    },
    style: {
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
        [`&.${gn.disabled}`]: {
          borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "vertical"
    },
    style: {
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderBottom: `1px solid ${(e.vars || e).palette.grey[400]}`,
        [`&.${gn.disabled}`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(e.palette).filter(Mn(["dark"])).map(([t]) => ({
    props: {
      variant: "contained",
      color: t
    },
    style: {
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderColor: (e.vars || e).palette[t].dark
      }
    }
  }))],
  [`& .${gn.grouped}`]: {
    minWidth: 40,
    boxShadow: "none",
    props: {
      variant: "contained"
    },
    style: {
      "&:hover": {
        boxShadow: "none"
      }
    }
  }
}))), zp = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiButtonGroup"
  }), {
    children: i,
    className: s,
    color: a = "primary",
    component: l = "div",
    disabled: c = !1,
    disableElevation: u = !1,
    disableFocusRipple: f = !1,
    disableRipple: g = !1,
    fullWidth: h = !1,
    orientation: y = "horizontal",
    size: v = "medium",
    variant: m = "outlined",
    ...b
  } = r, C = {
    ...r,
    color: a,
    component: l,
    disabled: c,
    disableElevation: u,
    disableFocusRipple: f,
    disableRipple: g,
    fullWidth: h,
    orientation: y,
    size: v,
    variant: m
  }, E = PC(C), S = d.useMemo(() => ({
    className: E.grouped,
    color: a,
    disabled: c,
    disableElevation: u,
    disableFocusRipple: f,
    disableRipple: g,
    fullWidth: h,
    size: v,
    variant: m
  }), [a, c, u, f, g, h, v, m, E.grouped]), k = B8(i), T = k.length, P = (F) => {
    const j = F === 0, L = F === T - 1;
    return j && L ? "" : j ? E.firstButton : L ? E.lastButton : E.middleButton;
  };
  return /* @__PURE__ */ p.jsx(IC, {
    as: l,
    role: "group",
    className: xe(E.root, s),
    ref: n,
    ownerState: C,
    ...b,
    children: /* @__PURE__ */ p.jsx(Bp.Provider, {
      value: S,
      children: k.map((F, j) => /* @__PURE__ */ p.jsx(_p.Provider, {
        value: P(j),
        children: F
      }, j))
    })
  });
});
process.env.NODE_ENV !== "production" && (zp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: o.bool,
  /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: o.bool,
  /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: o.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOfType([o.oneOf(["contained", "outlined", "text"]), o.string])
});
function OC(e) {
  return Pt("PrivateSwitchBase", e);
}
Et("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const DC = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: r,
    edge: i
  } = e, s = {
    root: ["root", n && "checked", r && "disabled", i && `edge${be(i)}`],
    input: ["input"]
  };
  return Ot(s, OC, t);
}, jC = Z(Tr, {
  name: "MuiSwitchBase"
})({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), FC = Z("input", {
  name: "MuiSwitchBase",
  shouldForwardProp: $o
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), Pd = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    autoFocus: r,
    checked: i,
    checkedIcon: s,
    defaultChecked: a,
    disabled: l,
    disableFocusRipple: c = !1,
    edge: u = !1,
    icon: f,
    id: g,
    inputProps: h,
    inputRef: y,
    name: v,
    onBlur: m,
    onChange: b,
    onFocus: C,
    readOnly: E,
    required: S = !1,
    tabIndex: k,
    type: T,
    value: P,
    slots: F = {},
    slotProps: j = {},
    ...L
  } = t, [R, V] = Xr({
    controlled: i,
    default: !!a,
    name: "SwitchBase",
    state: "checked"
  }), B = pr(), W = (ee) => {
    C && C(ee), B && B.onFocus && B.onFocus(ee);
  }, z = (ee) => {
    m && m(ee), B && B.onBlur && B.onBlur(ee);
  }, G = (ee) => {
    if (ee.nativeEvent.defaultPrevented)
      return;
    const te = ee.target.checked;
    V(te), b && b(ee, te);
  };
  let H = l;
  B && typeof H > "u" && (H = B.disabled);
  const ie = T === "checkbox" || T === "radio", ce = {
    ...t,
    checked: R,
    disabled: H,
    disableFocusRipple: c,
    edge: u
  }, re = DC(ce), A = {
    slots: F,
    slotProps: {
      input: h,
      ...j
    }
  }, [Y, pe] = kt("root", {
    ref: n,
    elementType: jC,
    className: re.root,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...A,
      component: "span",
      ...L
    },
    getSlotProps: (ee) => ({
      ...ee,
      onFocus: (te) => {
        var ue;
        (ue = ee.onFocus) == null || ue.call(ee, te), W(te);
      },
      onBlur: (te) => {
        var ue;
        (ue = ee.onBlur) == null || ue.call(ee, te), z(te);
      }
    }),
    ownerState: ce,
    additionalProps: {
      centerRipple: !0,
      focusRipple: !c,
      disabled: H,
      role: void 0,
      tabIndex: null
    }
  }), [Ce, fe] = kt("input", {
    ref: y,
    elementType: FC,
    className: re.input,
    externalForwardedProps: A,
    getSlotProps: (ee) => ({
      onChange: (te) => {
        var ue;
        (ue = ee.onChange) == null || ue.call(ee, te), G(te);
      }
    }),
    ownerState: ce,
    additionalProps: {
      autoFocus: r,
      checked: i,
      defaultChecked: a,
      disabled: H,
      id: ie ? g : void 0,
      name: v,
      readOnly: E,
      required: S,
      tabIndex: k,
      type: T,
      ...T === "checkbox" && P === void 0 ? {} : {
        value: P
      }
    }
  });
  return /* @__PURE__ */ p.jsxs(Y, {
    ...pe,
    children: [/* @__PURE__ */ p.jsx(Ce, {
      ...fe
    }), R ? s : f]
  });
});
process.env.NODE_ENV !== "production" && (Pd.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: o.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: o.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * @ignore
   */
  defaultChecked: o.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: o.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: o.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: o.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qo,
  /*
   * @ignore
   */
  name: o.string,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: o.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    input: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.object,
  /**
   * @ignore
   */
  tabIndex: o.oneOfType([o.number, o.string]),
  /**
   * The input component prop `type`.
   */
  type: o.string.isRequired,
  /**
   * The value of the component.
   */
  value: o.any
});
const VC = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), $C = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), LC = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function AC(e) {
  return Pt("MuiCheckbox", e);
}
const z1 = Et("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), NC = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: r,
    size: i
  } = e, s = {
    root: ["root", n && "indeterminate", `color${be(r)}`, `size${be(i)}`]
  }, a = Ot(s, AC, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...a
  };
}, BC = Z(Pd, {
  shouldForwardProp: (e) => $o(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${be(n.size)}`], n.color !== "default" && t[`color${be(n.color)}`]];
  }
})(mt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${z1.checked}, &.${z1.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${z1.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), _C = /* @__PURE__ */ p.jsx($C, {}), zC = /* @__PURE__ */ p.jsx(VC, {}), HC = /* @__PURE__ */ p.jsx(LC, {}), Hp = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: i = _C,
    color: s = "primary",
    icon: a = zC,
    indeterminate: l = !1,
    indeterminateIcon: c = HC,
    inputProps: u,
    size: f = "medium",
    disableRipple: g = !1,
    className: h,
    slots: y = {},
    slotProps: v = {},
    ...m
  } = r, b = l ? c : a, C = l ? c : i, E = {
    ...r,
    disableRipple: g,
    color: s,
    indeterminate: l,
    size: f
  }, S = NC(E), k = v.input ?? u, [T, P] = kt("root", {
    ref: n,
    elementType: BC,
    className: xe(S.root, h),
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      slots: y,
      slotProps: v,
      ...m
    },
    ownerState: E,
    additionalProps: {
      type: "checkbox",
      icon: /* @__PURE__ */ d.cloneElement(b, {
        fontSize: b.props.fontSize ?? f
      }),
      checkedIcon: /* @__PURE__ */ d.cloneElement(C, {
        fontSize: C.props.fontSize ?? f
      }),
      disableRipple: g,
      slots: y,
      slotProps: {
        input: $4(typeof k == "function" ? k(E) : k, {
          "data-indeterminate": l
        })
      }
    }
  });
  return /* @__PURE__ */ p.jsx(T, {
    ...P,
    classes: S
  });
});
process.env.NODE_ENV !== "production" && (Hp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: o.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: o.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: o.node,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: o.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: o.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: o.object,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: o.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: o.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    input: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: o.any
});
function v3(e) {
  return e.substring(2).toLowerCase();
}
function WC(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function Ta(e) {
  const {
    children: t,
    disableReactTree: n = !1,
    mouseEvent: r = "onClick",
    onClickAway: i,
    touchEvent: s = "onTouchEnd"
  } = e, a = d.useRef(!1), l = d.useRef(null), c = d.useRef(!1), u = d.useRef(!1);
  d.useEffect(() => (setTimeout(() => {
    c.current = !0;
  }, 0), () => {
    c.current = !1;
  }), []);
  const f = lo(_s(t), l), g = Eo((v) => {
    const m = u.current;
    u.current = !1;
    const b = Co(l.current);
    if (!c.current || !l.current || "clientX" in v && WC(v, b))
      return;
    if (a.current) {
      a.current = !1;
      return;
    }
    let C;
    v.composedPath ? C = v.composedPath().includes(l.current) : C = !b.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      v.target
    ) || l.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      v.target
    ), !C && (n || !m) && i(v);
  }), h = (v) => (m) => {
    u.current = !0;
    const b = t.props[v];
    b && b(m);
  }, y = {
    ref: f
  };
  return s !== !1 && (y[s] = h(s)), d.useEffect(() => {
    if (s !== !1) {
      const v = v3(s), m = Co(l.current), b = () => {
        a.current = !0;
      };
      return m.addEventListener(v, g), m.addEventListener("touchmove", b), () => {
        m.removeEventListener(v, g), m.removeEventListener("touchmove", b);
      };
    }
  }, [g, s]), r !== !1 && (y[r] = h(r)), d.useEffect(() => {
    if (r !== !1) {
      const v = v3(r), m = Co(l.current);
      return m.addEventListener(v, g), () => {
        m.removeEventListener(v, g);
      };
    }
  }, [g, r]), /* @__PURE__ */ d.cloneElement(t, y);
}
process.env.NODE_ENV !== "production" && (Ta.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: Bs.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: o.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: o.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: o.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: o.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (Ta.propTypes = ic(Ta.propTypes));
function GC(e) {
  const t = Co(e);
  return t.body === e ? Lr(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function Pl(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function y3(e) {
  return parseInt(Lr(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function UC(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function b3(e, t, n, r, i) {
  const s = [t, n, ...r];
  [].forEach.call(e.children, (a) => {
    const l = !s.includes(a), c = !UC(a);
    l && c && Pl(a, i);
  });
}
function H1(e, t) {
  let n = -1;
  return e.some((r, i) => t(r) ? (n = i, !0) : !1), n;
}
function YC(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (GC(r)) {
      const a = h4(Lr(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${y3(r) + a}px`;
      const l = Co(r).querySelectorAll(".mui-fixed");
      [].forEach.call(l, (c) => {
        n.push({
          value: c.style.paddingRight,
          property: "padding-right",
          el: c
        }), c.style.paddingRight = `${y3(c) + a}px`;
      });
    }
    let s;
    if (r.parentNode instanceof DocumentFragment)
      s = Co(r).body;
    else {
      const a = r.parentElement, l = Lr(r);
      s = (a == null ? void 0 : a.nodeName) === "HTML" && l.getComputedStyle(a).overflowY === "scroll" ? a : r;
    }
    n.push({
      value: s.style.overflow,
      property: "overflow",
      el: s
    }, {
      value: s.style.overflowX,
      property: "overflow-x",
      el: s
    }, {
      value: s.style.overflowY,
      property: "overflow-y",
      el: s
    }), s.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: s,
      el: a,
      property: l
    }) => {
      s ? a.style.setProperty(l, s) : a.style.removeProperty(l);
    });
  };
}
function ZC(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class qC {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && Pl(t.modalRef, !1);
    const i = ZC(n);
    b3(n, t.mount, t.modalRef, i, !0);
    const s = H1(this.containers, (a) => a.container === n);
    return s !== -1 ? (this.containers[s].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: i
    }), r);
  }
  mount(t, n) {
    const r = H1(this.containers, (s) => s.modals.includes(t)), i = this.containers[r];
    i.restore || (i.restore = YC(i, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const i = H1(this.containers, (a) => a.modals.includes(t)), s = this.containers[i];
    if (s.modals.splice(s.modals.indexOf(t), 1), this.modals.splice(r, 1), s.modals.length === 0)
      s.restore && s.restore(), t.modalRef && Pl(t.modalRef, n), b3(s.container, t.mount, t.modalRef, s.hiddenSiblings, !1), this.containers.splice(i, 1);
    else {
      const a = s.modals[s.modals.length - 1];
      a.modalRef && Pl(a.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const KC = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function XC(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function QC(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function JC(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || QC(e));
}
function ex(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(KC)).forEach((r, i) => {
    const s = XC(r);
    s === -1 || !JC(r) || (s === 0 ? t.push(r) : n.push({
      documentOrder: i,
      tabIndex: s,
      node: r
    }));
  }), n.sort((r, i) => r.tabIndex === i.tabIndex ? r.documentOrder - i.documentOrder : r.tabIndex - i.tabIndex).map((r) => r.node).concat(t);
}
function tx() {
  return !0;
}
function Wl(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: i = !1,
    getTabbable: s = ex,
    isEnabled: a = tx,
    open: l
  } = e, c = d.useRef(!1), u = d.useRef(null), f = d.useRef(null), g = d.useRef(null), h = d.useRef(null), y = d.useRef(!1), v = d.useRef(null), m = lo(_s(t), v), b = d.useRef(null);
  d.useEffect(() => {
    !l || !v.current || (y.current = !n);
  }, [n, l]), d.useEffect(() => {
    if (!l || !v.current)
      return;
    const S = Co(v.current);
    return v.current.contains(S.activeElement) || (v.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), v.current.setAttribute("tabIndex", "-1")), y.current && v.current.focus()), () => {
      i || (g.current && g.current.focus && (c.current = !0, g.current.focus()), g.current = null);
    };
  }, [l]), d.useEffect(() => {
    if (!l || !v.current)
      return;
    const S = Co(v.current), k = (F) => {
      b.current = F, !(r || !a() || F.key !== "Tab") && S.activeElement === v.current && F.shiftKey && (c.current = !0, f.current && f.current.focus());
    }, T = () => {
      var L, R;
      const F = v.current;
      if (F === null)
        return;
      if (!S.hasFocus() || !a() || c.current) {
        c.current = !1;
        return;
      }
      if (F.contains(S.activeElement) || r && S.activeElement !== u.current && S.activeElement !== f.current)
        return;
      if (S.activeElement !== h.current)
        h.current = null;
      else if (h.current !== null)
        return;
      if (!y.current)
        return;
      let j = [];
      if ((S.activeElement === u.current || S.activeElement === f.current) && (j = s(v.current)), j.length > 0) {
        const V = !!((L = b.current) != null && L.shiftKey && ((R = b.current) == null ? void 0 : R.key) === "Tab"), B = j[0], W = j[j.length - 1];
        typeof B != "string" && typeof W != "string" && (V ? W.focus() : B.focus());
      } else
        F.focus();
    };
    S.addEventListener("focusin", T), S.addEventListener("keydown", k, !0);
    const P = setInterval(() => {
      S.activeElement && S.activeElement.tagName === "BODY" && T();
    }, 50);
    return () => {
      clearInterval(P), S.removeEventListener("focusin", T), S.removeEventListener("keydown", k, !0);
    };
  }, [n, r, i, a, l, s]);
  const C = (S) => {
    g.current === null && (g.current = S.relatedTarget), y.current = !0, h.current = S.target;
    const k = t.props.onFocus;
    k && k(S);
  }, E = (S) => {
    g.current === null && (g.current = S.relatedTarget), y.current = !0;
  };
  return /* @__PURE__ */ p.jsxs(d.Fragment, {
    children: [/* @__PURE__ */ p.jsx("div", {
      tabIndex: l ? 0 : -1,
      onFocus: E,
      ref: u,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ d.cloneElement(t, {
      ref: m,
      onFocus: C
    }), /* @__PURE__ */ p.jsx("div", {
      tabIndex: l ? 0 : -1,
      onFocus: E,
      ref: f,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (Wl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: Bs,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: o.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: o.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: o.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: o.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: o.func,
  /**
   * If `true`, focus is locked.
   */
  open: o.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Wl.propTypes = ic(Wl.propTypes));
function nx(e) {
  return typeof e == "function" ? e() : e;
}
function ox(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const C3 = () => {
}, tu = new qC();
function rx(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    closeAfterTransition: i = !1,
    onTransitionEnter: s,
    onTransitionExited: a,
    children: l,
    onClose: c,
    open: u,
    rootRef: f
  } = e, g = d.useRef({}), h = d.useRef(null), y = d.useRef(null), v = lo(y, f), [m, b] = d.useState(!u), C = ox(l);
  let E = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (E = !1);
  const S = () => Co(h.current), k = () => (g.current.modalRef = y.current, g.current.mount = h.current, g.current), T = () => {
    tu.mount(k(), {
      disableScrollLock: r
    }), y.current && (y.current.scrollTop = 0);
  }, P = Eo(() => {
    const G = nx(t) || S().body;
    tu.add(k(), G), y.current && T();
  }), F = () => tu.isTopModal(k()), j = Eo((G) => {
    h.current = G, G && (u && F() ? T() : y.current && Pl(y.current, E));
  }), L = d.useCallback(() => {
    tu.remove(k(), E);
  }, [E]);
  d.useEffect(() => () => {
    L();
  }, [L]), d.useEffect(() => {
    u ? P() : (!C || !i) && L();
  }, [u, L, C, i, P]);
  const R = (G) => (H) => {
    var ie;
    (ie = G.onKeyDown) == null || ie.call(G, H), !(H.key !== "Escape" || H.which === 229 || // Wait until IME is settled.
    !F()) && (n || (H.stopPropagation(), c && c(H, "escapeKeyDown")));
  }, V = (G) => (H) => {
    var ie;
    (ie = G.onClick) == null || ie.call(G, H), H.target === H.currentTarget && c && c(H, "backdropClick");
  };
  return {
    getRootProps: (G = {}) => {
      const H = Tl(e);
      delete H.onTransitionEnter, delete H.onTransitionExited;
      const ie = {
        ...H,
        ...G
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...ie,
        onKeyDown: R(ie),
        ref: v
      };
    },
    getBackdropProps: (G = {}) => {
      const H = G;
      return {
        "aria-hidden": !0,
        ...H,
        onClick: V(H),
        open: u
      };
    },
    getTransitionProps: () => {
      const G = () => {
        b(!1), s && s();
      }, H = () => {
        b(!0), a && a(), i && L();
      };
      return {
        onEnter: R0(G, (l == null ? void 0 : l.props.onEnter) ?? C3),
        onExited: R0(H, (l == null ? void 0 : l.props.onExited) ?? C3)
      };
    },
    rootRef: v,
    portalRef: j,
    isTopModal: F,
    exited: m,
    hasTransition: C
  };
}
function ix(e) {
  return Pt("MuiModal", e);
}
Et("MuiModal", ["root", "hidden", "backdrop"]);
const sx = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return Ot({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, ix, r);
}, ax = Z("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(mt(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), lx = Z(Ap, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), Id = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: i = lx,
    BackdropProps: s,
    classes: a,
    className: l,
    closeAfterTransition: c = !1,
    children: u,
    container: f,
    component: g,
    components: h = {},
    componentsProps: y = {},
    disableAutoFocus: v = !1,
    disableEnforceFocus: m = !1,
    disableEscapeKeyDown: b = !1,
    disablePortal: C = !1,
    disableRestoreFocus: E = !1,
    disableScrollLock: S = !1,
    hideBackdrop: k = !1,
    keepMounted: T = !1,
    onBackdropClick: P,
    onClose: F,
    onTransitionEnter: j,
    onTransitionExited: L,
    open: R,
    slotProps: V = {},
    slots: B = {},
    // eslint-disable-next-line react/prop-types
    theme: W,
    ...z
  } = r, G = {
    ...r,
    closeAfterTransition: c,
    disableAutoFocus: v,
    disableEnforceFocus: m,
    disableEscapeKeyDown: b,
    disablePortal: C,
    disableRestoreFocus: E,
    disableScrollLock: S,
    hideBackdrop: k,
    keepMounted: T
  }, {
    getRootProps: H,
    getBackdropProps: ie,
    getTransitionProps: ce,
    portalRef: re,
    isTopModal: A,
    exited: Y,
    hasTransition: pe
  } = rx({
    ...G,
    rootRef: n
  }), Ce = {
    ...G,
    exited: Y
  }, fe = sx(Ce), ee = {};
  if (u.props.tabIndex === void 0 && (ee.tabIndex = "-1"), pe) {
    const {
      onEnter: ve,
      onExited: J
    } = ce();
    ee.onEnter = ve, ee.onExited = J;
  }
  const te = {
    slots: {
      root: h.Root,
      backdrop: h.Backdrop,
      ...B
    },
    slotProps: {
      ...y,
      ...V
    }
  }, [ue, K] = kt("root", {
    ref: n,
    elementType: ax,
    externalForwardedProps: {
      ...te,
      ...z,
      component: g
    },
    getSlotProps: H,
    ownerState: Ce,
    className: xe(l, fe == null ? void 0 : fe.root, !Ce.open && Ce.exited && (fe == null ? void 0 : fe.hidden))
  }), [oe, de] = kt("backdrop", {
    ref: s == null ? void 0 : s.ref,
    elementType: i,
    externalForwardedProps: te,
    shouldForwardComponentProp: !0,
    additionalProps: s,
    getSlotProps: (ve) => ie({
      ...ve,
      onClick: (J) => {
        P && P(J), ve != null && ve.onClick && ve.onClick(J);
      }
    }),
    className: xe(s == null ? void 0 : s.className, fe == null ? void 0 : fe.backdrop),
    ownerState: Ce
  });
  return !T && !R && (!pe || Y) ? null : /* @__PURE__ */ p.jsx(Hl, {
    ref: re,
    container: f,
    disablePortal: C,
    children: /* @__PURE__ */ p.jsxs(ue, {
      ...K,
      children: [!k && i ? /* @__PURE__ */ p.jsx(oe, {
        ...de
      }) : null, /* @__PURE__ */ p.jsx(Wl, {
        disableEnforceFocus: m,
        disableAutoFocus: v,
        disableRestoreFocus: E,
        isEnabled: A,
        open: R,
        children: /* @__PURE__ */ d.cloneElement(u, ee)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Id.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: o.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: o.object,
  /**
   * A single child content element.
   */
  children: Bs.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: o.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Backdrop: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    backdrop: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([Di, o.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: o.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: o.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: o.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: o.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: o.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: o.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: o.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: o.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: o.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: o.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: o.shape({
    backdrop: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    backdrop: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function cx(e) {
  return Pt("MuiDialog", e);
}
const Il = Et("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), Wp = /* @__PURE__ */ d.createContext({});
process.env.NODE_ENV !== "production" && (Wp.displayName = "DialogContext");
const ux = Z(Ap, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), dx = (e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: r,
    fullWidth: i,
    fullScreen: s
  } = e, a = {
    root: ["root"],
    container: ["container", `scroll${be(n)}`],
    paper: ["paper", `paperScroll${be(n)}`, `paperWidth${be(String(r))}`, i && "paperFullWidth", s && "paperFullScreen"]
  };
  return Ot(a, cx, t);
}, px = Z(Id, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), fx = Z("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${be(n.scroll)}`]];
  }
})({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&::after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    }
  }]
}), gx = Z(li, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${be(n.scroll)}`], t[`paperWidth${be(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }
})(mt(({
  theme: e
}) => ({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  },
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "initial"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.maxWidth,
    style: {
      maxWidth: "calc(100% - 64px)"
    }
  }, {
    props: {
      maxWidth: "xs"
    },
    style: {
      maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
      [`&.${Il.paperScrollBody}`]: {
        [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  }, ...Object.keys(e.breakpoints.values).filter((t) => t !== "xs").map((t) => ({
    props: {
      maxWidth: t
    },
    style: {
      maxWidth: `${e.breakpoints.values[t]}${e.breakpoints.unit}`,
      [`&.${Il.paperScrollBody}`]: {
        [e.breakpoints.down(e.breakpoints.values[t] + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  })), {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "calc(100% - 64px)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullScreen,
    style: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      [`&.${Il.paperScrollBody}`]: {
        margin: 0,
        maxWidth: "100%"
      }
    }
  }]
}))), Gp = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiDialog"
  }), i = to(), s = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    "aria-describedby": a,
    "aria-labelledby": l,
    "aria-modal": c = !0,
    BackdropComponent: u,
    BackdropProps: f,
    children: g,
    className: h,
    disableEscapeKeyDown: y = !1,
    fullScreen: v = !1,
    fullWidth: m = !1,
    maxWidth: b = "sm",
    onBackdropClick: C,
    onClick: E,
    onClose: S,
    open: k,
    PaperComponent: T = li,
    PaperProps: P = {},
    scroll: F = "paper",
    slots: j = {},
    slotProps: L = {},
    TransitionComponent: R = Fi,
    transitionDuration: V = s,
    TransitionProps: B,
    ...W
  } = r, z = {
    ...r,
    disableEscapeKeyDown: y,
    fullScreen: v,
    fullWidth: m,
    maxWidth: b,
    scroll: F
  }, G = dx(z), H = d.useRef(), ie = (ge) => {
    H.current = ge.target === ge.currentTarget;
  }, ce = (ge) => {
    E && E(ge), H.current && (H.current = null, C && C(ge), S && S(ge, "backdropClick"));
  }, re = ai(l), A = d.useMemo(() => ({
    titleId: re
  }), [re]), Y = {
    transition: R,
    ...j
  }, pe = {
    transition: B,
    paper: P,
    backdrop: f,
    ...L
  }, Ce = {
    slots: Y,
    slotProps: pe
  }, [fe, ee] = kt("root", {
    elementType: px,
    shouldForwardComponentProp: !0,
    externalForwardedProps: Ce,
    ownerState: z,
    className: xe(G.root, h),
    ref: n
  }), [te, ue] = kt("backdrop", {
    elementType: ux,
    shouldForwardComponentProp: !0,
    externalForwardedProps: Ce,
    ownerState: z
  }), [K, oe] = kt("paper", {
    elementType: gx,
    shouldForwardComponentProp: !0,
    externalForwardedProps: Ce,
    ownerState: z,
    className: xe(G.paper, P.className)
  }), [de, ve] = kt("container", {
    elementType: fx,
    externalForwardedProps: Ce,
    ownerState: z,
    className: xe(G.container)
  }), [J, se] = kt("transition", {
    elementType: Fi,
    externalForwardedProps: Ce,
    ownerState: z,
    additionalProps: {
      appear: !0,
      in: k,
      timeout: V,
      role: "presentation"
    }
  });
  return /* @__PURE__ */ p.jsx(fe, {
    closeAfterTransition: !0,
    slots: {
      backdrop: te
    },
    slotProps: {
      backdrop: {
        transitionDuration: V,
        as: u,
        ...ue
      }
    },
    disableEscapeKeyDown: y,
    onClose: S,
    open: k,
    onClick: ce,
    ...ee,
    ...W,
    children: /* @__PURE__ */ p.jsx(J, {
      ...se,
      children: /* @__PURE__ */ p.jsx(de, {
        onMouseDown: ie,
        ...ve,
        children: /* @__PURE__ */ p.jsx(K, {
          as: T,
          elevation: 24,
          role: "dialog",
          "aria-describedby": a,
          "aria-labelledby": re,
          "aria-modal": c,
          ...oe,
          children: /* @__PURE__ */ p.jsx(Wp.Provider, {
            value: A,
            children: g
          })
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Gp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": o.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": o.string,
  /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */
  "aria-modal": o.oneOfType([o.oneOf(["false", "true"]), o.bool]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: o.elementType,
  /**
   * @ignore
   */
  BackdropProps: o.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: o.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: o.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: o.oneOfType([o.oneOf(["xs", "sm", "md", "lg", "xl", !1]), o.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: o.func,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: o.elementType,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   * @deprecated Use `slotProps.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperProps: o.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: o.oneOf(["body", "paper"]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    backdrop: o.oneOfType([o.func, o.object]),
    container: o.oneOfType([o.func, o.object]),
    paper: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object]),
    transition: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    backdrop: o.elementType,
    container: o.elementType,
    paper: o.elementType,
    root: o.elementType,
    transition: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: o.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: o.oneOfType([o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: o.object
});
function mx(e) {
  return Pt("MuiDialogActions", e);
}
Et("MuiDialogActions", ["root", "spacing"]);
const hx = (e) => {
  const {
    classes: t,
    disableSpacing: n
  } = e;
  return Ot({
    root: ["root", !n && "spacing"]
  }, mx, t);
}, vx = Z("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableSpacing && t.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disableSpacing,
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
}), rg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: i,
    disableSpacing: s = !1,
    ...a
  } = r, l = {
    ...r,
    disableSpacing: s
  }, c = hx(l);
  return /* @__PURE__ */ p.jsx(vx, {
    className: xe(c.root, i),
    ownerState: l,
    ref: n,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (rg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function yx(e) {
  return Pt("MuiDialogContent", e);
}
Et("MuiDialogContent", ["root", "dividers"]);
function bx(e) {
  return Pt("MuiDialogTitle", e);
}
const Cx = Et("MuiDialogTitle", ["root"]), xx = (e) => {
  const {
    classes: t,
    dividers: n
  } = e;
  return Ot({
    root: ["root", n && "dividers"]
  }, yx, t);
}, wx = Z("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.dividers && t.dividers];
  }
})(mt(({
  theme: e
}) => ({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px",
  variants: [{
    props: ({
      ownerState: t
    }) => t.dividers,
    style: {
      padding: "16px 24px",
      borderTop: `1px solid ${(e.vars || e).palette.divider}`,
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dividers,
    style: {
      [`.${Cx.root} + &`]: {
        paddingTop: 0
      }
    }
  }]
}))), ig = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: i,
    dividers: s = !1,
    ...a
  } = r, l = {
    ...r,
    dividers: s
  }, c = xx(l);
  return /* @__PURE__ */ p.jsx(wx, {
    className: xe(c.root, i),
    ownerState: l,
    ref: n,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (ig.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function Sx(e) {
  return Pt("MuiDialogContentText", e);
}
Et("MuiDialogContentText", ["root"]);
const Ex = (e) => {
  const {
    classes: t
  } = e, r = Ot({
    root: ["root"]
  }, Sx, t);
  return {
    ...t,
    // forward classes to the Typography
    ...r
  };
}, Rx = Z(vo, {
  shouldForwardProp: (e) => $o(e) || e === "classes",
  name: "MuiDialogContentText",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Tx = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiDialogContentText"
  }), {
    children: i,
    className: s,
    ...a
  } = r, l = Ex(a);
  return /* @__PURE__ */ p.jsx(Rx, {
    component: "p",
    variant: "body1",
    color: "textSecondary",
    ref: n,
    ownerState: a,
    className: xe(l.root, s),
    ...r,
    classes: l
  });
});
process.env.NODE_ENV !== "production" && (Tx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const Mx = (e) => {
  const {
    classes: t
  } = e;
  return Ot({
    root: ["root"]
  }, bx, t);
}, kx = Z(vo, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), Px = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: i,
    id: s,
    ...a
  } = r, l = r, c = Mx(l), {
    titleId: u = s
  } = d.useContext(Wp);
  return /* @__PURE__ */ p.jsx(kx, {
    component: "h2",
    className: xe(c.root, i),
    ownerState: l,
    ref: n,
    variant: "h6",
    id: s ?? u,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (Px.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * @ignore
   */
  id: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function Ix(e) {
  return Pt("MuiDivider", e);
}
const x3 = Et("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), Ox = (e) => {
  const {
    absolute: t,
    children: n,
    classes: r,
    flexItem: i,
    light: s,
    orientation: a,
    textAlign: l,
    variant: c
  } = e;
  return Ot({
    root: ["root", t && "absolute", c, s && "light", a === "vertical" && "vertical", i && "flexItem", n && "withChildren", n && a === "vertical" && "withChildrenVertical", l === "right" && a !== "vertical" && "textAlignRight", l === "left" && a !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", a === "vertical" && "wrapperVertical"]
  }, Ix, r);
}, Dx = Z("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(mt(({
  theme: e
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : At(e.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: e.spacing(1),
      marginBottom: e.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(e.vars || e).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), jx = Z("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(mt(({
  theme: e
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${e.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${e.spacing(1)} * 1.2)`
    }
  }]
}))), Gl = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: i = !1,
    children: s,
    className: a,
    orientation: l = "horizontal",
    component: c = s || l === "vertical" ? "div" : "hr",
    flexItem: u = !1,
    light: f = !1,
    role: g = c !== "hr" ? "separator" : void 0,
    textAlign: h = "center",
    variant: y = "fullWidth",
    ...v
  } = r, m = {
    ...r,
    absolute: i,
    component: c,
    flexItem: u,
    light: f,
    orientation: l,
    role: g,
    textAlign: h,
    variant: y
  }, b = Ox(m);
  return /* @__PURE__ */ p.jsx(Dx, {
    as: c,
    className: xe(b.root, a),
    role: g,
    ref: n,
    ownerState: m,
    "aria-orientation": g === "separator" && (c !== "hr" || l === "vertical") ? l : void 0,
    ...v,
    children: s ? /* @__PURE__ */ p.jsx(jx, {
      className: b.wrapper,
      ownerState: m,
      children: s
    }) : null
  });
});
Gl && (Gl.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (Gl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: o.bool,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: o.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: o.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: o.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: o.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: o.oneOfType([o.oneOf(["fullWidth", "inset", "middle"]), o.string])
});
const Fx = (e) => {
  const {
    classes: t,
    disableUnderline: n,
    startAdornment: r,
    endAdornment: i,
    size: s,
    hiddenLabel: a,
    multiline: l
  } = e, c = {
    root: ["root", !n && "underline", r && "adornedStart", i && "adornedEnd", s === "small" && `size${be(s)}`, a && "hiddenLabel", l && "multiline"],
    input: ["input"]
  }, u = Ot(c, Db, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...u
  };
}, Vx = Z(Md, {
  shouldForwardProp: (e) => $o(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...Rd(e, t), !n.disableUnderline && t.underline];
  }
})(mt(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", i = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", s = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : i,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${sr.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${sr.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : s
    },
    variants: [{
      props: ({
        ownerState: a
      }) => !a.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${sr.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${sr.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${sr.disabled}, .${sr.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${sr.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Mn()).map(([a]) => {
      var l;
      return {
        props: {
          disableUnderline: !1,
          color: a
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(l = (e.vars || e).palette[a]) == null ? void 0 : l.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: a
      }) => a.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: a
      }) => a.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: a,
        size: l
      }) => a.multiline && l === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline && a.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline && a.hiddenLabel && a.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), $x = Z(kd, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: Td
})(mt(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), Od = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: i = !1,
    components: s = {},
    componentsProps: a,
    fullWidth: l = !1,
    hiddenLabel: c,
    // declare here to prevent spreading to DOM
    inputComponent: u = "input",
    multiline: f = !1,
    slotProps: g,
    slots: h = {},
    type: y = "text",
    ...v
  } = r, m = {
    ...r,
    disableUnderline: i,
    fullWidth: l,
    inputComponent: u,
    multiline: f,
    type: y
  }, b = Fx(r), C = {
    root: {
      ownerState: m
    },
    input: {
      ownerState: m
    }
  }, E = g ?? a ? Bo(C, g ?? a) : C, S = h.root ?? s.Root ?? Vx, k = h.input ?? s.Input ?? $x;
  return /* @__PURE__ */ p.jsx(dc, {
    slots: {
      root: S,
      input: k
    },
    slotProps: E,
    fullWidth: l,
    inputComponent: u,
    multiline: f,
    ref: n,
    type: y,
    ...v,
    classes: b
  });
});
process.env.NODE_ENV !== "production" && (Od.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: o.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
Od.muiName = "Input";
function Lx(e) {
  return Pt("MuiFormControl", e);
}
Et("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const Ax = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: r
  } = e, i = {
    root: ["root", n !== "none" && `margin${be(n)}`, r && "fullWidth"]
  };
  return Ot(i, Lx, t);
}, Nx = Z("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`margin${be(n.margin)}`], n.fullWidth && t.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), Up = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiFormControl"
  }), {
    children: i,
    className: s,
    color: a = "primary",
    component: l = "div",
    disabled: c = !1,
    error: u = !1,
    focused: f,
    fullWidth: g = !1,
    hiddenLabel: h = !1,
    margin: y = "none",
    required: v = !1,
    size: m = "medium",
    variant: b = "outlined",
    ...C
  } = r, E = {
    ...r,
    color: a,
    component: l,
    disabled: c,
    error: u,
    fullWidth: g,
    hiddenLabel: h,
    margin: y,
    required: v,
    size: m,
    variant: b
  }, S = Ax(E), [k, T] = d.useState(() => {
    let H = !1;
    return i && d.Children.forEach(i, (ie) => {
      if (!Rl(ie, ["Input", "Select"]))
        return;
      const ce = Rl(ie, ["Select"]) ? ie.props.input : ie;
      ce && Mb(ce.props) && (H = !0);
    }), H;
  }), [P, F] = d.useState(() => {
    let H = !1;
    return i && d.Children.forEach(i, (ie) => {
      Rl(ie, ["Input", "Select"]) && (Gu(ie.props, !0) || Gu(ie.props.inputProps, !0)) && (H = !0);
    }), H;
  }), [j, L] = d.useState(!1);
  c && j && L(!1);
  const R = f !== void 0 && !c ? f : j;
  let V;
  const B = d.useRef(!1);
  process.env.NODE_ENV !== "production" && (V = () => (B.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), B.current = !0, () => {
    B.current = !1;
  }));
  const W = d.useCallback(() => {
    F(!0);
  }, []), z = d.useCallback(() => {
    F(!1);
  }, []), G = d.useMemo(() => ({
    adornedStart: k,
    setAdornedStart: T,
    color: a,
    disabled: c,
    error: u,
    filled: P,
    focused: R,
    fullWidth: g,
    hiddenLabel: h,
    size: m,
    onBlur: () => {
      L(!1);
    },
    onFocus: () => {
      L(!0);
    },
    onEmpty: z,
    onFilled: W,
    registerEffect: V,
    required: v,
    variant: b
  }), [k, a, c, u, P, R, g, h, V, z, W, v, m, b]);
  return /* @__PURE__ */ p.jsx(uc.Provider, {
    value: G,
    children: /* @__PURE__ */ p.jsx(Nx, {
      as: l,
      ownerState: E,
      className: xe(S.root, s),
      ref: n,
      ...C,
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (Up.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: o.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: o.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: o.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: o.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: o.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
function Bx(e) {
  return Pt("MuiFormHelperText", e);
}
const w3 = Et("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var S3;
const _x = (e) => {
  const {
    classes: t,
    contained: n,
    size: r,
    disabled: i,
    error: s,
    filled: a,
    focused: l,
    required: c
  } = e, u = {
    root: ["root", i && "disabled", s && "error", r && `size${be(r)}`, n && "contained", l && "focused", a && "filled", c && "required"]
  };
  return Ot(u, Bx, t);
}, zx = Z("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${be(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(mt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${w3.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${w3.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), Yp = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: i,
    className: s,
    component: a = "p",
    disabled: l,
    error: c,
    filled: u,
    focused: f,
    margin: g,
    required: h,
    variant: y,
    ...v
  } = r, m = pr(), b = Oa({
    props: r,
    muiFormControl: m,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), C = {
    ...r,
    component: a,
    contained: b.variant === "filled" || b.variant === "outlined",
    variant: b.variant,
    size: b.size,
    disabled: b.disabled,
    error: b.error,
    filled: b.filled,
    focused: b.focused,
    required: b.required
  };
  delete C.ownerState;
  const E = _x(C);
  return /* @__PURE__ */ p.jsx(zx, {
    as: a,
    className: xe(E.root, s),
    ref: n,
    ...v,
    ownerState: C,
    children: i === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      S3 || (S3 = /* @__PURE__ */ p.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : i
  });
});
process.env.NODE_ENV !== "production" && (Yp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: o.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: o.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: o.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: o.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: o.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   */
  variant: o.oneOfType([o.oneOf(["filled", "outlined", "standard"]), o.string])
});
function Hx(e) {
  return Pt("MuiFormLabel", e);
}
const Ol = Et("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), Wx = (e) => {
  const {
    classes: t,
    color: n,
    focused: r,
    disabled: i,
    error: s,
    filled: a,
    required: l
  } = e, c = {
    root: ["root", `color${be(n)}`, i && "disabled", s && "error", a && "filled", r && "focused", l && "required"],
    asterisk: ["asterisk", s && "error"]
  };
  return Ot(c, Hx, t);
}, Gx = Z("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color === "secondary" && t.colorSecondary, n.filled && t.filled];
  }
})(mt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Ol.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${Ol.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${Ol.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), Ux = Z("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(mt(({
  theme: e
}) => ({
  [`&.${Ol.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), sg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: i,
    className: s,
    color: a,
    component: l = "label",
    disabled: c,
    error: u,
    filled: f,
    focused: g,
    required: h,
    ...y
  } = r, v = pr(), m = Oa({
    props: r,
    muiFormControl: v,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), b = {
    ...r,
    color: m.color || "primary",
    component: l,
    disabled: m.disabled,
    error: m.error,
    filled: m.filled,
    focused: m.focused,
    required: m.required
  }, C = Wx(b);
  return /* @__PURE__ */ p.jsxs(Gx, {
    as: l,
    ownerState: b,
    className: xe(C.root, s),
    ref: n,
    ...y,
    children: [i, m.required && /* @__PURE__ */ p.jsxs(Ux, {
      ownerState: b,
      "aria-hidden": !0,
      className: C.asterisk,
      children: [" ", "*"]
    })]
  });
});
process.env.NODE_ENV !== "production" && (sg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: o.oneOfType([o.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: o.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: o.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: o.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: o.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const L0 = /* @__PURE__ */ d.createContext();
process.env.NODE_ENV !== "production" && (L0.displayName = "GridContext");
function Yx(e) {
  return Pt("MuiGrid", e);
}
const Zx = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], qx = ["column-reverse", "column", "row-reverse", "row"], Kx = ["nowrap", "wrap-reverse", "wrap"], Xa = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], Ul = Et("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...Zx.map((e) => `spacing-xs-${e}`),
  // direction values
  ...qx.map((e) => `direction-xs-${e}`),
  // wrap values
  ...Kx.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ...Xa.map((e) => `grid-xs-${e}`),
  ...Xa.map((e) => `grid-sm-${e}`),
  ...Xa.map((e) => `grid-md-${e}`),
  ...Xa.map((e) => `grid-lg-${e}`),
  ...Xa.map((e) => `grid-xl-${e}`)
]);
function Xx({
  theme: e,
  ownerState: t
}) {
  let n;
  return e.breakpoints.keys.reduce((r, i) => {
    let s = {};
    if (t[i] && (n = t[i]), !n)
      return r;
    if (n === !0)
      s = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (n === "auto")
      s = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const a = ad({
        values: t.columns,
        breakpoints: e.breakpoints.values
      }), l = typeof a == "object" ? a[i] : a;
      if (l == null)
        return r;
      const c = `${Math.round(n / l * 1e8) / 1e6}%`;
      let u = {};
      if (t.container && t.item && t.columnSpacing !== 0) {
        const f = e.spacing(t.columnSpacing);
        if (f !== "0px") {
          const g = `calc(${c} + ${f})`;
          u = {
            flexBasis: g,
            maxWidth: g
          };
        }
      }
      s = {
        flexBasis: c,
        flexGrow: 0,
        maxWidth: c,
        ...u
      };
    }
    return e.breakpoints.values[i] === 0 ? Object.assign(r, s) : r[e.breakpoints.up(i)] = s, r;
  }, {});
}
function Qx({
  theme: e,
  ownerState: t
}) {
  const n = ad({
    values: t.direction,
    breakpoints: e.breakpoints.values
  });
  return Rr({
    theme: e
  }, n, (r) => {
    const i = {
      flexDirection: r
    };
    return r.startsWith("column") && (i[`& > .${Ul.item}`] = {
      maxWidth: "none"
    }), i;
  });
}
function ag({
  breakpoints: e,
  values: t
}) {
  let n = "";
  Object.keys(t).forEach((i) => {
    n === "" && t[i] !== 0 && (n = i);
  });
  const r = Object.keys(e).sort((i, s) => e[i] - e[s]);
  return r.slice(0, r.indexOf(n));
}
function Jx({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    rowSpacing: r
  } = t;
  let i = {};
  if (n && r !== 0) {
    const s = ad({
      values: r,
      breakpoints: e.breakpoints.values
    });
    let a;
    typeof s == "object" && (a = ag({
      breakpoints: e.breakpoints.values,
      values: s
    })), i = Rr({
      theme: e
    }, s, (l, c) => {
      const u = e.spacing(l);
      return u !== "0px" ? {
        marginTop: `calc(-1 * ${u})`,
        [`& > .${Ul.item}`]: {
          paddingTop: u
        }
      } : a != null && a.includes(c) ? {} : {
        marginTop: 0,
        [`& > .${Ul.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return i;
}
function ew({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    columnSpacing: r
  } = t;
  let i = {};
  if (n && r !== 0) {
    const s = ad({
      values: r,
      breakpoints: e.breakpoints.values
    });
    let a;
    typeof s == "object" && (a = ag({
      breakpoints: e.breakpoints.values,
      values: s
    })), i = Rr({
      theme: e
    }, s, (l, c) => {
      const u = e.spacing(l);
      if (u !== "0px") {
        const f = `calc(-1 * ${u})`;
        return {
          width: `calc(100% + ${u})`,
          marginLeft: f,
          [`& > .${Ul.item}`]: {
            paddingLeft: u
          }
        };
      }
      return a != null && a.includes(c) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${Ul.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return i;
}
function tw(e, t, n = {}) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [n[`spacing-xs-${String(e)}`]];
  const r = [];
  return t.forEach((i) => {
    const s = e[i];
    Number(s) > 0 && r.push(n[`spacing-${i}-${String(s)}`]);
  }), r;
}
const nw = Z("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      container: r,
      direction: i,
      item: s,
      spacing: a,
      wrap: l,
      zeroMinWidth: c,
      breakpoints: u
    } = n;
    let f = [];
    r && (f = tw(a, u, t));
    const g = [];
    return u.forEach((h) => {
      const y = n[h];
      y && g.push(t[`grid-${h}-${String(y)}`]);
    }), [t.root, r && t.container, s && t.item, c && t.zeroMinWidth, ...f, i !== "row" && t[`direction-xs-${String(i)}`], l !== "wrap" && t[`wrap-xs-${String(l)}`], ...g];
  }
})(
  // FIXME(romgrk): Can't use memoTheme here
  ({
    ownerState: e
  }) => ({
    boxSizing: "border-box",
    ...e.container && {
      display: "flex",
      flexWrap: "wrap",
      width: "100%"
    },
    ...e.item && {
      margin: 0
      // For instance, it's useful when used with a `figure` element.
    },
    ...e.zeroMinWidth && {
      minWidth: 0
    },
    ...e.wrap !== "wrap" && {
      flexWrap: e.wrap
    }
  }),
  Qx,
  Jx,
  ew,
  Xx
);
function ow(e, t) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [`spacing-xs-${String(e)}`];
  const n = [];
  return t.forEach((r) => {
    const i = e[r];
    if (Number(i) > 0) {
      const s = `spacing-${r}-${String(i)}`;
      n.push(s);
    }
  }), n;
}
const rw = (e) => {
  const {
    classes: t,
    container: n,
    direction: r,
    item: i,
    spacing: s,
    wrap: a,
    zeroMinWidth: l,
    breakpoints: c
  } = e;
  let u = [];
  n && (u = ow(s, c));
  const f = [];
  c.forEach((h) => {
    const y = e[h];
    y && f.push(`grid-${h}-${String(y)}`);
  });
  const g = {
    root: ["root", n && "container", i && "item", l && "zeroMinWidth", ...u, r !== "row" && `direction-xs-${String(r)}`, a !== "wrap" && `wrap-xs-${String(a)}`, ...f]
  };
  return Ot(g, Yx, t);
}, Tn = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiGrid"
  }), {
    breakpoints: i
  } = to(), s = vp(r), {
    className: a,
    columns: l,
    columnSpacing: c,
    component: u = "div",
    container: f = !1,
    direction: g = "row",
    item: h = !1,
    rowSpacing: y,
    spacing: v = 0,
    wrap: m = "wrap",
    zeroMinWidth: b = !1,
    ...C
  } = s, E = y || v, S = c || v, k = d.useContext(L0), T = f ? l || 12 : k, P = {}, F = {
    ...C
  };
  i.keys.forEach((R) => {
    C[R] != null && (P[R] = C[R], delete F[R]);
  });
  const j = {
    ...s,
    columns: T,
    container: f,
    direction: g,
    item: h,
    rowSpacing: E,
    columnSpacing: S,
    wrap: m,
    zeroMinWidth: b,
    spacing: v,
    ...P,
    breakpoints: i.keys
  }, L = rw(j);
  return /* @__PURE__ */ p.jsx(L0.Provider, {
    value: T,
    children: /* @__PURE__ */ p.jsx(nw, {
      ownerState: j,
      className: xe(L.root, a),
      as: u,
      ref: n,
      ...F
    })
  });
});
process.env.NODE_ENV !== "production" && (Tn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: o.oneOfType([o.arrayOf(o.number), o.number, o.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: o.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: o.oneOfType([o.oneOf(["column-reverse", "column", "row-reverse", "row"]), o.arrayOf(o.oneOf(["column-reverse", "column", "row-reverse", "row"])), o.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: o.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: o.oneOfType([o.oneOf(["auto"]), o.number, o.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: o.oneOfType([o.oneOf(["auto"]), o.number, o.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: o.oneOfType([o.oneOf(["auto"]), o.number, o.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: o.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: o.oneOfType([o.oneOf(["auto"]), o.number, o.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: o.oneOfType([o.oneOf(["auto"]), o.number, o.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: o.bool
});
if (process.env.NODE_ENV !== "production") {
  const e = V8("Grid", Tn);
  Tn.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...Tn.propTypes,
    direction: e("container"),
    lg: e("item"),
    md: e("item"),
    sm: e("item"),
    spacing: e("container"),
    wrap: e("container"),
    xs: e("item"),
    zeroMinWidth: e("item")
  };
}
function A0(e) {
  return `scale(${e}, ${e ** 2})`;
}
const iw = {
  entering: {
    opacity: 1,
    transform: A0(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, W1 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), ss = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: i = !0,
    children: s,
    easing: a,
    in: l,
    onEnter: c,
    onEntered: u,
    onEntering: f,
    onExit: g,
    onExited: h,
    onExiting: y,
    style: v,
    timeout: m = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: b = dr,
    ...C
  } = t, E = Ts(), S = d.useRef(), k = to(), T = d.useRef(null), P = lo(T, _s(s), n), F = (G) => (H) => {
    if (G) {
      const ie = T.current;
      H === void 0 ? G(ie) : G(ie, H);
    }
  }, j = F(f), L = F((G, H) => {
    A4(G);
    const {
      duration: ie,
      delay: ce,
      easing: re
    } = xa({
      style: v,
      timeout: m,
      easing: a
    }, {
      mode: "enter"
    });
    let A;
    m === "auto" ? (A = k.transitions.getAutoHeightDuration(G.clientHeight), S.current = A) : A = ie, G.style.transition = [k.transitions.create("opacity", {
      duration: A,
      delay: ce
    }), k.transitions.create("transform", {
      duration: W1 ? A : A * 0.666,
      delay: ce,
      easing: re
    })].join(","), c && c(G, H);
  }), R = F(u), V = F(y), B = F((G) => {
    const {
      duration: H,
      delay: ie,
      easing: ce
    } = xa({
      style: v,
      timeout: m,
      easing: a
    }, {
      mode: "exit"
    });
    let re;
    m === "auto" ? (re = k.transitions.getAutoHeightDuration(G.clientHeight), S.current = re) : re = H, G.style.transition = [k.transitions.create("opacity", {
      duration: re,
      delay: ie
    }), k.transitions.create("transform", {
      duration: W1 ? re : re * 0.666,
      delay: W1 ? ie : ie || re * 0.333,
      easing: ce
    })].join(","), G.style.opacity = 0, G.style.transform = A0(0.75), g && g(G);
  }), W = F(h), z = (G) => {
    m === "auto" && E.start(S.current || 0, G), r && r(T.current, G);
  };
  return /* @__PURE__ */ p.jsx(b, {
    appear: i,
    in: l,
    nodeRef: T,
    onEnter: L,
    onEntered: R,
    onEntering: j,
    onExit: B,
    onExited: W,
    onExiting: V,
    addEndListener: z,
    timeout: m === "auto" ? null : m,
    ...C,
    children: (G, {
      ownerState: H,
      ...ie
    }) => /* @__PURE__ */ d.cloneElement(s, {
      style: {
        opacity: 0,
        transform: A0(0.75),
        visibility: G === "exited" && !l ? "hidden" : void 0,
        ...iw[G],
        ...v,
        ...s.props.style
      },
      ref: P,
      ...ie
    })
  });
});
process.env.NODE_ENV !== "production" && (ss.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: o.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: o.bool,
  /**
   * A single child content element.
   */
  children: Bs.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: o.oneOfType([o.shape({
    enter: o.string,
    exit: o.string
  }), o.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: o.bool,
  /**
   * @ignore
   */
  onEnter: o.func,
  /**
   * @ignore
   */
  onEntered: o.func,
  /**
   * @ignore
   */
  onEntering: o.func,
  /**
   * @ignore
   */
  onExit: o.func,
  /**
   * @ignore
   */
  onExited: o.func,
  /**
   * @ignore
   */
  onExiting: o.func,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: o.oneOfType([o.oneOf(["auto"]), o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })])
});
ss && (ss.muiSupportAuto = !0);
const lg = d4({
  themeId: Sr
}), sw = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = Ot({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, Ib, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...i
  };
}, aw = Z(Md, {
  shouldForwardProp: (e) => $o(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...Rd(e, t), !n.disableUnderline && t.underline];
  }
})(mt(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: r
      }) => r.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => !r.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Zi.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Zi.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Zi.disabled}, .${Zi.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${Zi.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Mn()).map(([r]) => ({
      props: {
        color: r,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[r].main}`
        }
      }
    }))]
  };
})), lw = Z(kd, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: Td
})({}), Dd = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: i = !1,
    components: s = {},
    componentsProps: a,
    fullWidth: l = !1,
    inputComponent: c = "input",
    multiline: u = !1,
    slotProps: f,
    slots: g = {},
    type: h = "text",
    ...y
  } = r, v = sw(r), b = {
    root: {
      ownerState: {
        disableUnderline: i
      }
    }
  }, C = f ?? a ? Bo(f ?? a, b) : b, E = g.root ?? s.Root ?? aw, S = g.input ?? s.Input ?? lw;
  return /* @__PURE__ */ p.jsx(dc, {
    slots: {
      root: E,
      input: S
    },
    slotProps: C,
    fullWidth: l,
    inputComponent: c,
    multiline: u,
    ref: n,
    type: h,
    ...y,
    classes: v
  });
});
process.env.NODE_ENV !== "production" && (Dd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: o.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
Dd.muiName = "Input";
function cw(e) {
  return Pt("MuiInputAdornment", e);
}
const E3 = Et("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var R3;
const uw = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${be(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, dw = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: r,
    position: i,
    size: s,
    variant: a
  } = e, l = {
    root: ["root", n && "disablePointerEvents", i && `position${be(i)}`, a, r && "hiddenLabel", s && `size${be(s)}`]
  };
  return Ot(l, cw, t);
}, pw = Z("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: uw
})(mt(({
  theme: e
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${E3.positionStart}&:not(.${E3.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), jd = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: i,
    className: s,
    component: a = "div",
    disablePointerEvents: l = !1,
    disableTypography: c = !1,
    position: u,
    variant: f,
    ...g
  } = r, h = pr() || {};
  let y = f;
  f && h.variant && process.env.NODE_ENV !== "production" && f === h.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), h && !y && (y = h.variant);
  const v = {
    ...r,
    hiddenLabel: h.hiddenLabel,
    size: h.size,
    disablePointerEvents: l,
    position: u,
    variant: y
  }, m = dw(v);
  return /* @__PURE__ */ p.jsx(uc.Provider, {
    value: null,
    children: /* @__PURE__ */ p.jsx(pw, {
      as: a,
      ownerState: v,
      className: xe(m.root, s),
      ref: n,
      ...g,
      children: typeof i == "string" && !c ? /* @__PURE__ */ p.jsx(vo, {
        color: "textSecondary",
        children: i
      }) : /* @__PURE__ */ p.jsxs(d.Fragment, {
        children: [u === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          R3 || (R3 = /* @__PURE__ */ p.jsx("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, i]
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (jd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: o.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: o.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: o.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
function fw(e) {
  return Pt("MuiInputLabel", e);
}
Et("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const gw = (e) => {
  const {
    classes: t,
    formControl: n,
    size: r,
    shrink: i,
    disableAnimation: s,
    variant: a,
    required: l
  } = e, c = {
    root: ["root", n && "formControl", !s && "animated", i && "shrink", r && r !== "normal" && `size${be(r)}`, a],
    asterisk: [l && "asterisk"]
  }, u = Ot(c, fw, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...u
  };
}, mw = Z(sg, {
  shouldForwardProp: (e) => $o(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Ol.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(mt(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: t
    }) => t.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableAnimation,
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "filled" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n,
      size: r
    }) => t === "filled" && n.shrink && r === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "outlined" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), Zp = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: i = !1,
    margin: s,
    shrink: a,
    variant: l,
    className: c,
    ...u
  } = r, f = pr();
  let g = a;
  typeof g > "u" && f && (g = f.filled || f.focused || f.adornedStart);
  const h = Oa({
    props: r,
    muiFormControl: f,
    states: ["size", "variant", "required", "focused"]
  }), y = {
    ...r,
    disableAnimation: i,
    formControl: f,
    shrink: g,
    size: h.size,
    variant: h.variant,
    required: h.required,
    focused: h.focused
  }, v = gw(y);
  return /* @__PURE__ */ p.jsx(mw, {
    "data-shrink": g,
    ref: n,
    className: xe(v.root, c),
    ...u,
    ownerState: y,
    classes: v
  });
});
process.env.NODE_ENV !== "production" && (Zp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: o.oneOfType([o.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), o.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: o.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: o.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: o.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: o.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: o.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: o.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: o.oneOfType([o.oneOf(["normal", "small"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
function hw(e) {
  return Pt("MuiLinearProgress", e);
}
Et("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "bar1", "bar2", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const N0 = 4, B0 = si`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`, vw = typeof B0 != "string" ? ki`
        animation: ${B0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null, _0 = si`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`, yw = typeof _0 != "string" ? ki`
        animation: ${_0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null, z0 = si`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`, bw = typeof z0 != "string" ? ki`
        animation: ${z0} 3s infinite linear;
      ` : null, Cw = (e) => {
  const {
    classes: t,
    variant: n,
    color: r
  } = e, i = {
    root: ["root", `color${be(r)}`, n],
    dashed: ["dashed", `dashedColor${be(r)}`],
    bar1: ["bar", "bar1", `barColor${be(r)}`, (n === "indeterminate" || n === "query") && "bar1Indeterminate", n === "determinate" && "bar1Determinate", n === "buffer" && "bar1Buffer"],
    bar2: ["bar", "bar2", n !== "buffer" && `barColor${be(r)}`, n === "buffer" && `color${be(r)}`, (n === "indeterminate" || n === "query") && "bar2Indeterminate", n === "buffer" && "bar2Buffer"]
  };
  return Ot(i, hw, t);
}, qp = (e, t) => e.vars ? e.vars.palette.LinearProgress[`${t}Bg`] : e.palette.mode === "light" ? Oi(e.palette[t].main, 0.62) : Ii(e.palette[t].main, 0.5), xw = Z("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${be(n.color)}`], t[n.variant]];
  }
})(mt(({
  theme: e
}) => ({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  // Fix Safari's bug during composition of different paint.
  zIndex: 0,
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: qp(e, t)
    }
  })), {
    props: ({
      ownerState: t
    }) => t.color === "inherit" && t.variant !== "buffer",
    style: {
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "currentColor",
        opacity: 0.3
      }
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      backgroundColor: "transparent"
    }
  }, {
    props: {
      variant: "query"
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}))), ww = Z("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.dashed, t[`dashedColor${be(n.color)}`]];
  }
})(mt(({
  theme: e
}) => ({
  position: "absolute",
  marginTop: 0,
  height: "100%",
  width: "100%",
  backgroundSize: "10px 10px",
  backgroundPosition: "0 -23px",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3,
      backgroundImage: "radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)"
    }
  }, ...Object.entries(e.palette).filter(Mn()).map(([t]) => {
    const n = qp(e, t);
    return {
      props: {
        color: t
      },
      style: {
        backgroundImage: `radial-gradient(${n} 0%, ${n} 16%, transparent 42%)`
      }
    };
  })]
})), bw || {
  // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
  animation: `${z0} 3s infinite linear`
}), Sw = Z("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.bar, t.bar1, t[`barColor${be(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && t.bar1Indeterminate, n.variant === "determinate" && t.bar1Determinate, n.variant === "buffer" && t.bar1Buffer];
  }
})(mt(({
  theme: e
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      backgroundColor: "currentColor"
    }
  }, ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main
    }
  })), {
    props: {
      variant: "determinate"
    },
    style: {
      transition: `transform .${N0}s linear`
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      zIndex: 1,
      transition: `transform .${N0}s linear`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: vw || {
      animation: `${B0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
    }
  }]
}))), Ew = Z("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.bar, t.bar2, t[`barColor${be(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && t.bar2Indeterminate, n.variant === "buffer" && t.bar2Buffer];
  }
})(mt(({
  theme: e
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--LinearProgressBar2-barColor": (e.vars || e).palette[t].main
    }
  })), {
    props: ({
      ownerState: t
    }) => t.variant !== "buffer" && t.color !== "inherit",
    style: {
      backgroundColor: "var(--LinearProgressBar2-barColor, currentColor)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant !== "buffer" && t.color === "inherit",
    style: {
      backgroundColor: "currentColor"
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3
    }
  }, ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t,
      variant: "buffer"
    },
    style: {
      backgroundColor: qp(e, t),
      transition: `transform .${N0}s linear`
    }
  })), {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: yw || {
      animation: `${_0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
    }
  }]
}))), cg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiLinearProgress"
  }), {
    className: i,
    color: s = "primary",
    value: a,
    valueBuffer: l,
    variant: c = "indeterminate",
    ...u
  } = r, f = {
    ...r,
    color: s,
    variant: c
  }, g = Cw(f), h = Io(), y = {}, v = {
    bar1: {},
    bar2: {}
  };
  if (c === "determinate" || c === "buffer")
    if (a !== void 0) {
      y["aria-valuenow"] = Math.round(a), y["aria-valuemin"] = 0, y["aria-valuemax"] = 100;
      let m = a - 100;
      h && (m = -m), v.bar1.transform = `translateX(${m}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (c === "buffer")
    if (l !== void 0) {
      let m = (l || 0) - 100;
      h && (m = -m), v.bar2.transform = `translateX(${m}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ p.jsxs(xw, {
    className: xe(g.root, i),
    ownerState: f,
    role: "progressbar",
    ...y,
    ref: n,
    ...u,
    children: [c === "buffer" ? /* @__PURE__ */ p.jsx(ww, {
      className: g.dashed,
      ownerState: f
    }) : null, /* @__PURE__ */ p.jsx(Sw, {
      className: g.bar1,
      ownerState: f,
      style: v.bar1
    }), c === "determinate" ? null : /* @__PURE__ */ p.jsx(Ew, {
      className: g.bar2,
      ownerState: f,
      style: v.bar2
    })]
  });
});
process.env.NODE_ENV !== "production" && (cg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["inherit", "primary", "secondary"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: o.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: o.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: o.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
const Jr = /* @__PURE__ */ d.createContext({});
process.env.NODE_ENV !== "production" && (Jr.displayName = "ListContext");
function Rw(e) {
  return Pt("MuiList", e);
}
Et("MuiList", ["root", "padding", "dense", "subheader"]);
const Tw = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: i
  } = e;
  return Ot({
    root: ["root", !n && "padding", r && "dense", i && "subheader"]
  }, Rw, t);
}, Mw = Z("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), Kp = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiList"
  }), {
    children: i,
    className: s,
    component: a = "ul",
    dense: l = !1,
    disablePadding: c = !1,
    subheader: u,
    ...f
  } = r, g = d.useMemo(() => ({
    dense: l
  }), [l]), h = {
    ...r,
    component: a,
    dense: l,
    disablePadding: c
  }, y = Tw(h);
  return /* @__PURE__ */ p.jsx(Jr.Provider, {
    value: g,
    children: /* @__PURE__ */ p.jsxs(Mw, {
      as: a,
      className: xe(y.root, s),
      ref: n,
      ownerState: h,
      ...f,
      children: [u, i]
    })
  });
});
process.env.NODE_ENV !== "production" && (Kp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: o.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: o.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function kw(e) {
  return Pt("MuiListItem", e);
}
Et("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
const Pw = Et("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function Iw(e) {
  return Pt("MuiListItemSecondaryAction", e);
}
Et("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const Ow = (e) => {
  const {
    disableGutters: t,
    classes: n
  } = e;
  return Ot({
    root: ["root", t && "disableGutters"]
  }, Iw, n);
}, Dw = Z("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: e
    }) => e.disableGutters,
    style: {
      right: 0
    }
  }]
}), Xp = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: i,
    ...s
  } = r, a = d.useContext(Jr), l = {
    ...r,
    disableGutters: a.disableGutters
  }, c = Ow(l);
  return /* @__PURE__ */ p.jsx(Dw, {
    className: xe(c.root, i),
    ownerState: l,
    ref: n,
    ...s
  });
});
process.env.NODE_ENV !== "production" && (Xp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
Xp.muiName = "ListItemSecondaryAction";
const jw = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters, !n.disablePadding && t.padding, n.hasSecondaryAction && t.secondaryAction];
}, Fw = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: r,
    disableGutters: i,
    disablePadding: s,
    divider: a,
    hasSecondaryAction: l
  } = e;
  return Ot({
    root: ["root", r && "dense", !i && "gutters", !s && "padding", a && "divider", t === "flex-start" && "alignItemsFlexStart", l && "secondaryAction"],
    container: ["container"]
  }, kw, n);
}, Vw = Z("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: jw
})(mt(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${Pw.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), $w = Z("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), ug = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: i = "center",
    children: s,
    className: a,
    component: l,
    components: c = {},
    componentsProps: u = {},
    ContainerComponent: f = "li",
    ContainerProps: {
      className: g,
      ...h
    } = {},
    dense: y = !1,
    disableGutters: v = !1,
    disablePadding: m = !1,
    divider: b = !1,
    secondaryAction: C,
    slotProps: E = {},
    slots: S = {},
    ...k
  } = r, T = d.useContext(Jr), P = d.useMemo(() => ({
    dense: y || T.dense || !1,
    alignItems: i,
    disableGutters: v
  }), [i, T.dense, y, v]), F = d.useRef(null), j = d.Children.toArray(s), L = j.length && Rl(j[j.length - 1], ["ListItemSecondaryAction"]), R = {
    ...r,
    alignItems: i,
    dense: P.dense,
    disableGutters: v,
    disablePadding: m,
    divider: b,
    hasSecondaryAction: L
  }, V = Fw(R), B = lo(F, n), W = S.root || c.Root || Vw, z = E.root || u.root || {}, G = {
    className: xe(V.root, z.className, a),
    ...k
  };
  let H = l || "li";
  return L ? (H = !G.component && !l ? "div" : H, f === "li" && (H === "li" ? H = "div" : G.component === "li" && (G.component = "div")), /* @__PURE__ */ p.jsx(Jr.Provider, {
    value: P,
    children: /* @__PURE__ */ p.jsxs($w, {
      as: f,
      className: xe(V.container, g),
      ref: B,
      ownerState: R,
      ...h,
      children: [/* @__PURE__ */ p.jsx(W, {
        ...z,
        ...!Ti(W) && {
          as: H,
          ownerState: {
            ...R,
            ...z.ownerState
          }
        },
        ...G,
        children: j
      }), j.pop()]
    })
  })) : /* @__PURE__ */ p.jsx(Jr.Provider, {
    value: P,
    children: /* @__PURE__ */ p.jsxs(W, {
      ...z,
      as: H,
      ref: B,
      ...!Ti(W) && {
        ownerState: {
          ...R,
          ...z.ownerState
        }
      },
      ...G,
      children: [j, C && /* @__PURE__ */ p.jsx(Xp, {
        children: C
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (ug.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: o.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: nr(o.node, (e) => {
    const t = d.Children.toArray(e.children);
    let n = -1;
    for (let r = t.length - 1; r >= 0; r -= 1) {
      const i = t[r];
      if (Rl(i, ["ListItemSecondaryAction"])) {
        n = r;
        break;
      }
    }
    return n !== -1 && n !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: o.shape({
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: o.shape({
    root: o.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: rc,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: o.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: o.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: o.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: o.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: o.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: o.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: o.shape({
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.shape({
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function Lw(e) {
  return Pt("MuiListItemIcon", e);
}
const T3 = Et("MuiListItemIcon", ["root", "alignItemsFlexStart"]), Aw = (e) => {
  const {
    alignItems: t,
    classes: n
  } = e;
  return Ot({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, Lw, n);
}, Nw = Z("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(mt(({
  theme: e
}) => ({
  minWidth: 56,
  color: (e.vars || e).palette.action.active,
  flexShrink: 0,
  display: "inline-flex",
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}))), Bw = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: i,
    ...s
  } = r, a = d.useContext(Jr), l = {
    ...r,
    alignItems: a.alignItems
  }, c = Aw(l);
  return /* @__PURE__ */ p.jsx(Nw, {
    className: xe(c.root, i),
    ownerState: l,
    ref: n,
    ...s
  });
});
process.env.NODE_ENV !== "production" && (Bw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function _w(e) {
  return Pt("MuiListItemText", e);
}
const ca = Et("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), zw = (e) => {
  const {
    classes: t,
    inset: n,
    primary: r,
    secondary: i,
    dense: s
  } = e;
  return Ot({
    root: ["root", n && "inset", s && "dense", r && i && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, _w, t);
}, Hw = Z("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${ca.primary}`]: t.primary
    }, {
      [`& .${ca.secondary}`]: t.secondary
    }, t.root, n.inset && t.inset, n.primary && n.secondary && t.multiline, n.dense && t.dense];
  }
})({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4,
  [`.${Z2.root}:where(& .${ca.primary})`]: {
    display: "block"
  },
  [`.${Z2.root}:where(& .${ca.secondary})`]: {
    display: "block"
  },
  variants: [{
    props: ({
      ownerState: e
    }) => e.primary && e.secondary,
    style: {
      marginTop: 6,
      marginBottom: 6
    }
  }, {
    props: ({
      ownerState: e
    }) => e.inset,
    style: {
      paddingLeft: 56
    }
  }]
}), Ww = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiListItemText"
  }), {
    children: i,
    className: s,
    disableTypography: a = !1,
    inset: l = !1,
    primary: c,
    primaryTypographyProps: u,
    secondary: f,
    secondaryTypographyProps: g,
    slots: h = {},
    slotProps: y = {},
    ...v
  } = r, {
    dense: m
  } = d.useContext(Jr);
  let b = c ?? i, C = f;
  const E = {
    ...r,
    disableTypography: a,
    inset: l,
    primary: !!b,
    secondary: !!C,
    dense: m
  }, S = zw(E), k = {
    slots: h,
    slotProps: {
      primary: u,
      secondary: g,
      ...y
    }
  }, [T, P] = kt("root", {
    className: xe(S.root, s),
    elementType: Hw,
    externalForwardedProps: {
      ...k,
      ...v
    },
    ownerState: E,
    ref: n
  }), [F, j] = kt("primary", {
    className: S.primary,
    elementType: vo,
    externalForwardedProps: k,
    ownerState: E
  }), [L, R] = kt("secondary", {
    className: S.secondary,
    elementType: vo,
    externalForwardedProps: k,
    ownerState: E
  });
  return b != null && b.type !== vo && !a && (b = /* @__PURE__ */ p.jsx(F, {
    variant: m ? "body2" : "body1",
    component: j != null && j.variant ? void 0 : "span",
    ...j,
    children: b
  })), C != null && C.type !== vo && !a && (C = /* @__PURE__ */ p.jsx(L, {
    variant: "body2",
    color: "textSecondary",
    ...R,
    children: C
  })), /* @__PURE__ */ p.jsxs(T, {
    ...P,
    children: [b, C]
  });
});
process.env.NODE_ENV !== "production" && (Ww.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: o.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: o.bool,
  /**
   * The main content element.
   */
  primary: o.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.primary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  primaryTypographyProps: o.object,
  /**
   * The secondary content element.
   */
  secondary: o.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.secondary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  secondaryTypographyProps: o.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    primary: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object]),
    secondary: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    primary: o.elementType,
    root: o.elementType,
    secondary: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function G1(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function M3(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function dg(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.startsWith(t.keys.join(""));
}
function Qa(e, t, n, r, i, s) {
  let a = !1, l = i(e, t, t ? n : !1);
  for (; l; ) {
    if (l === e.firstChild) {
      if (a)
        return !1;
      a = !0;
    }
    const c = r ? !1 : l.disabled || l.getAttribute("aria-disabled") === "true";
    if (!l.hasAttribute("tabindex") || !dg(l, s) || c)
      l = i(e, l, n);
    else
      return l.focus(), !0;
  }
  return !1;
}
const Fd = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    autoFocus: i = !1,
    autoFocusItem: s = !1,
    children: a,
    className: l,
    disabledItemsFocusable: c = !1,
    disableListWrap: u = !1,
    onKeyDown: f,
    variant: g = "selectedMenu",
    ...h
  } = t, y = d.useRef(null), v = d.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Zo(() => {
    i && y.current.focus();
  }, [i]), d.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (S, {
      direction: k
    }) => {
      const T = !y.current.style.width;
      if (S.clientHeight < y.current.clientHeight && T) {
        const P = `${h4(Lr(S))}px`;
        y.current.style[k === "rtl" ? "paddingLeft" : "paddingRight"] = P, y.current.style.width = `calc(100% + ${P})`;
      }
      return y.current;
    }
  }), []);
  const m = (S) => {
    const k = y.current, T = S.key;
    if (S.ctrlKey || S.metaKey || S.altKey) {
      f && f(S);
      return;
    }
    const F = Co(k).activeElement;
    if (T === "ArrowDown")
      S.preventDefault(), Qa(k, F, u, c, G1);
    else if (T === "ArrowUp")
      S.preventDefault(), Qa(k, F, u, c, M3);
    else if (T === "Home")
      S.preventDefault(), Qa(k, null, u, c, G1);
    else if (T === "End")
      S.preventDefault(), Qa(k, null, u, c, M3);
    else if (T.length === 1) {
      const j = v.current, L = T.toLowerCase(), R = performance.now();
      j.keys.length > 0 && (R - j.lastTime > 500 ? (j.keys = [], j.repeating = !0, j.previousKeyMatched = !0) : j.repeating && L !== j.keys[0] && (j.repeating = !1)), j.lastTime = R, j.keys.push(L);
      const V = F && !j.repeating && dg(F, j);
      j.previousKeyMatched && (V || Qa(k, F, !1, c, G1, j)) ? S.preventDefault() : j.previousKeyMatched = !1;
    }
    f && f(S);
  }, b = lo(y, n);
  let C = -1;
  d.Children.forEach(a, (S, k) => {
    if (!/* @__PURE__ */ d.isValidElement(S)) {
      C === k && (C += 1, C >= a.length && (C = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && Pi.isFragment(S) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), S.props.disabled || (g === "selectedMenu" && S.props.selected || C === -1) && (C = k), C === k && (S.props.disabled || S.props.muiSkipListHighlight || S.type.muiSkipListHighlight) && (C += 1, C >= a.length && (C = -1));
  });
  const E = d.Children.map(a, (S, k) => {
    if (k === C) {
      const T = {};
      return s && (T.autoFocus = !0), S.props.tabIndex === void 0 && g === "selectedMenu" && (T.tabIndex = 0), /* @__PURE__ */ d.cloneElement(S, T);
    }
    return S;
  });
  return /* @__PURE__ */ p.jsx(Kp, {
    role: "menu",
    ref: b,
    className: l,
    onKeyDown: m,
    tabIndex: i ? 0 : -1,
    ...h,
    children: E
  });
});
process.env.NODE_ENV !== "production" && (Fd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: o.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: o.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: o.node,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: o.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: o.bool,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: o.oneOf(["menu", "selectedMenu"])
});
function Gw(e) {
  return Pt("MuiPopover", e);
}
Et("MuiPopover", ["root", "paper"]);
function k3(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function P3(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function I3(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function Cl(e) {
  return typeof e == "function" ? e() : e;
}
const Uw = (e) => {
  const {
    classes: t
  } = e;
  return Ot({
    root: ["root"],
    paper: ["paper"]
  }, Gw, t);
}, Yw = Z(Id, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), pg = Z(li, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Qp = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiPopover"
  }), {
    action: i,
    anchorEl: s,
    anchorOrigin: a = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: l,
    anchorReference: c = "anchorEl",
    children: u,
    className: f,
    container: g,
    elevation: h = 8,
    marginThreshold: y = 16,
    open: v,
    PaperProps: m = {},
    // TODO: remove in v7
    slots: b = {},
    slotProps: C = {},
    transformOrigin: E = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: S,
    // TODO: remove in v7
    transitionDuration: k = "auto",
    TransitionProps: T = {},
    // TODO: remove in v7
    disableScrollLock: P = !1,
    ...F
  } = r, j = d.useRef(), L = {
    ...r,
    anchorOrigin: a,
    anchorReference: c,
    elevation: h,
    marginThreshold: y,
    transformOrigin: E,
    TransitionComponent: S,
    transitionDuration: k,
    TransitionProps: T
  }, R = Uw(L), V = d.useCallback(() => {
    if (c === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (l || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), l;
    const de = Cl(s), ve = de && de.nodeType === 1 ? de : Co(j.current).body, J = ve.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const se = ve.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && se.top === 0 && se.left === 0 && se.right === 0 && se.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: J.top + k3(J, a.vertical),
      left: J.left + P3(J, a.horizontal)
    };
  }, [s, a.horizontal, a.vertical, l, c]), B = d.useCallback((de) => ({
    vertical: k3(de, E.vertical),
    horizontal: P3(de, E.horizontal)
  }), [E.horizontal, E.vertical]), W = d.useCallback((de) => {
    const ve = {
      width: de.offsetWidth,
      height: de.offsetHeight
    }, J = B(ve);
    if (c === "none")
      return {
        top: null,
        left: null,
        transformOrigin: I3(J)
      };
    const se = V();
    let ge = se.top - J.vertical, Se = se.left - J.horizontal;
    const we = ge + ve.height, me = Se + ve.width, ye = Lr(Cl(s)), Ie = ye.innerHeight - y, je = ye.innerWidth - y;
    if (y !== null && ge < y) {
      const Te = ge - y;
      ge -= Te, J.vertical += Te;
    } else if (y !== null && we > Ie) {
      const Te = we - Ie;
      ge -= Te, J.vertical += Te;
    }
    if (process.env.NODE_ENV !== "production" && ve.height > Ie && ve.height && Ie && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ve.height - Ie}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), y !== null && Se < y) {
      const Te = Se - y;
      Se -= Te, J.horizontal += Te;
    } else if (me > je) {
      const Te = me - je;
      Se -= Te, J.horizontal += Te;
    }
    return {
      top: `${Math.round(ge)}px`,
      left: `${Math.round(Se)}px`,
      transformOrigin: I3(J)
    };
  }, [s, c, V, B, y]), [z, G] = d.useState(v), H = d.useCallback(() => {
    const de = j.current;
    if (!de)
      return;
    const ve = W(de);
    ve.top !== null && de.style.setProperty("top", ve.top), ve.left !== null && (de.style.left = ve.left), de.style.transformOrigin = ve.transformOrigin, G(!0);
  }, [W]);
  d.useEffect(() => (P && window.addEventListener("scroll", H), () => window.removeEventListener("scroll", H)), [s, P, H]);
  const ie = () => {
    H();
  }, ce = () => {
    G(!1);
  };
  d.useEffect(() => {
    v && H();
  }), d.useImperativeHandle(i, () => v ? {
    updatePosition: () => {
      H();
    }
  } : null, [v, H]), d.useEffect(() => {
    if (!v)
      return;
    const de = Cd(() => {
      H();
    }), ve = Lr(Cl(s));
    return ve.addEventListener("resize", de), () => {
      de.clear(), ve.removeEventListener("resize", de);
    };
  }, [s, v, H]);
  let re = k;
  const A = {
    slots: {
      transition: S,
      ...b
    },
    slotProps: {
      transition: T,
      paper: m,
      ...C
    }
  }, [Y, pe] = kt("transition", {
    elementType: ss,
    externalForwardedProps: A,
    ownerState: L,
    getSlotProps: (de) => ({
      ...de,
      onEntering: (ve, J) => {
        var se;
        (se = de.onEntering) == null || se.call(de, ve, J), ie();
      },
      onExited: (ve) => {
        var J;
        (J = de.onExited) == null || J.call(de, ve), ce();
      }
    }),
    additionalProps: {
      appear: !0,
      in: v
    }
  });
  k === "auto" && !Y.muiSupportAuto && (re = void 0);
  const Ce = g || (s ? Co(Cl(s)).body : void 0), [fe, {
    slots: ee,
    slotProps: te,
    ...ue
  }] = kt("root", {
    ref: n,
    elementType: Yw,
    externalForwardedProps: {
      ...A,
      ...F
    },
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: b.backdrop
      },
      slotProps: {
        backdrop: $4(typeof C.backdrop == "function" ? C.backdrop(L) : C.backdrop, {
          invisible: !0
        })
      },
      container: Ce,
      open: v
    },
    ownerState: L,
    className: xe(R.root, f)
  }), [K, oe] = kt("paper", {
    ref: j,
    className: R.paper,
    elementType: pg,
    externalForwardedProps: A,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: h,
      style: z ? void 0 : {
        opacity: 0
      }
    },
    ownerState: L
  });
  return /* @__PURE__ */ p.jsx(fe, {
    ...ue,
    ...!Ti(fe) && {
      slots: ee,
      slotProps: te,
      disableScrollLock: P
    },
    children: /* @__PURE__ */ p.jsx(Y, {
      ...pe,
      timeout: re,
      children: /* @__PURE__ */ p.jsx(K, {
        ...oe,
        children: u
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Qp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: qo,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: nr(o.oneOfType([Di, o.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = Cl(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: o.shape({
    horizontal: o.oneOfType([o.oneOf(["center", "left", "right"]), o.number]).isRequired,
    vertical: o.oneOfType([o.oneOf(["bottom", "center", "top"]), o.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: o.shape({
    left: o.number.isRequired,
    top: o.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: o.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: o.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: o.object,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([Di, o.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: o.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Fr,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: o.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: o.shape({
    component: rc
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    backdrop: o.oneOfType([o.func, o.object]),
    paper: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object]),
    transition: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    backdrop: o.elementType,
    paper: o.elementType,
    root: o.elementType,
    transition: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: o.shape({
    horizontal: o.oneOfType([o.oneOf(["center", "left", "right"]), o.number]).isRequired,
    vertical: o.oneOfType([o.oneOf(["bottom", "center", "top"]), o.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: o.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: o.oneOfType([o.oneOf(["auto"]), o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: o.object
});
function Zw(e) {
  return Pt("MuiMenu", e);
}
Et("MuiMenu", ["root", "paper", "list"]);
const qw = {
  vertical: "top",
  horizontal: "right"
}, Kw = {
  vertical: "top",
  horizontal: "left"
}, Xw = (e) => {
  const {
    classes: t
  } = e;
  return Ot({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, Zw, t);
}, Qw = Z(Qp, {
  shouldForwardProp: (e) => $o(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Jw = Z(pg, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), eS = Z(Fd, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Jp = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: i = !0,
    children: s,
    className: a,
    disableAutoFocusItem: l = !1,
    MenuListProps: c = {},
    onClose: u,
    open: f,
    PaperProps: g = {},
    PopoverClasses: h,
    transitionDuration: y = "auto",
    TransitionProps: {
      onEntering: v,
      ...m
    } = {},
    variant: b = "selectedMenu",
    slots: C = {},
    slotProps: E = {},
    ...S
  } = r, k = Io(), T = {
    ...r,
    autoFocus: i,
    disableAutoFocusItem: l,
    MenuListProps: c,
    onEntering: v,
    PaperProps: g,
    transitionDuration: y,
    TransitionProps: m,
    variant: b
  }, P = Xw(T), F = i && !l && f, j = d.useRef(null), L = (re, A) => {
    j.current && j.current.adjustStyleForScrollbar(re, {
      direction: k ? "rtl" : "ltr"
    }), v && v(re, A);
  }, R = (re) => {
    re.key === "Tab" && (re.preventDefault(), u && u(re, "tabKeyDown"));
  };
  let V = -1;
  d.Children.map(s, (re, A) => {
    /* @__PURE__ */ d.isValidElement(re) && (process.env.NODE_ENV !== "production" && Pi.isFragment(re) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), re.props.disabled || (b === "selectedMenu" && re.props.selected || V === -1) && (V = A));
  });
  const B = {
    slots: C,
    slotProps: {
      list: c,
      transition: m,
      paper: g,
      ...E
    }
  }, W = Yo({
    elementType: C.root,
    externalSlotProps: E.root,
    ownerState: T,
    className: [P.root, a]
  }), [z, G] = kt("paper", {
    className: P.paper,
    elementType: Jw,
    externalForwardedProps: B,
    shouldForwardComponentProp: !0,
    ownerState: T
  }), [H, ie] = kt("list", {
    className: xe(P.list, c.className),
    elementType: eS,
    shouldForwardComponentProp: !0,
    externalForwardedProps: B,
    getSlotProps: (re) => ({
      ...re,
      onKeyDown: (A) => {
        var Y;
        R(A), (Y = re.onKeyDown) == null || Y.call(re, A);
      }
    }),
    ownerState: T
  }), ce = typeof B.slotProps.transition == "function" ? B.slotProps.transition(T) : B.slotProps.transition;
  return /* @__PURE__ */ p.jsx(Qw, {
    onClose: u,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: k ? "right" : "left"
    },
    transformOrigin: k ? qw : Kw,
    slots: {
      root: C.root,
      paper: z,
      backdrop: C.backdrop,
      ...C.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: C.transition
      }
    },
    slotProps: {
      root: W,
      paper: G,
      backdrop: typeof E.backdrop == "function" ? E.backdrop(T) : E.backdrop,
      transition: {
        ...ce,
        onEntering: (...re) => {
          var A;
          L(...re), (A = ce == null ? void 0 : ce.onEntering) == null || A.call(ce, ...re);
        }
      }
    },
    open: f,
    ref: n,
    transitionDuration: y,
    ownerState: T,
    ...S,
    classes: h,
    children: /* @__PURE__ */ p.jsx(H, {
      actions: j,
      autoFocus: i && (V === -1 || l),
      autoFocusItem: F,
      variant: b,
      ...ie,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (Jp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: o.oneOfType([Di, o.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: o.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: o.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: o.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: o.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: o.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    backdrop: o.oneOfType([o.func, o.object]),
    list: o.oneOfType([o.func, o.object]),
    paper: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object]),
    transition: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    backdrop: o.elementType,
    list: o.elementType,
    paper: o.elementType,
    root: o.elementType,
    transition: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: o.oneOfType([o.oneOf(["auto"]), o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: o.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: o.oneOf(["menu", "selectedMenu"])
});
function tS(e) {
  return Pt("MuiMenuItem", e);
}
const Ja = Et("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), nS = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, oS = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: i,
    selected: s,
    classes: a
  } = e, c = Ot({
    root: ["root", n && "dense", t && "disabled", !i && "gutters", r && "divider", s && "selected"]
  }, tS, a);
  return {
    ...a,
    ...c
  };
}, rS = Z(Tr, {
  shouldForwardProp: (e) => $o(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: nS
})(mt(({
  theme: e
}) => ({
  ...e.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Ja.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : At(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Ja.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : At(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Ja.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : At(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : At(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Ja.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Ja.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${x3.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${x3.inset}`]: {
    marginLeft: 52
  },
  [`& .${ca.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${ca.inset}`]: {
    paddingLeft: 36
  },
  [`& .${T3.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dense,
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...e.typography.body2,
      [`& .${T3.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), xr = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: i = !1,
    component: s = "li",
    dense: a = !1,
    divider: l = !1,
    disableGutters: c = !1,
    focusVisibleClassName: u,
    role: f = "menuitem",
    tabIndex: g,
    className: h,
    ...y
  } = r, v = d.useContext(Jr), m = d.useMemo(() => ({
    dense: a || v.dense || !1,
    disableGutters: c
  }), [v.dense, a, c]), b = d.useRef(null);
  Zo(() => {
    i && (b.current ? b.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [i]);
  const C = {
    ...r,
    dense: m.dense,
    divider: l,
    disableGutters: c
  }, E = oS(r), S = lo(b, n);
  let k;
  return r.disabled || (k = g !== void 0 ? g : -1), /* @__PURE__ */ p.jsx(Jr.Provider, {
    value: m,
    children: /* @__PURE__ */ p.jsx(rS, {
      ref: S,
      role: f,
      tabIndex: k,
      component: s,
      focusVisibleClassName: xe(E.focusVisible, u),
      className: xe(E.root, h),
      ...y,
      ownerState: C,
      classes: E
    })
  });
});
process.env.NODE_ENV !== "production" && (xr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: o.bool,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: o.bool,
  /**
   * @ignore
   */
  disabled: o.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: o.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: o.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: o.string,
  /**
   * @ignore
   */
  role: o.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @default 0
   */
  tabIndex: o.number
});
function iS(e) {
  return Pt("MuiNativeSelect", e);
}
const ef = Et("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), sS = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: i,
    open: s,
    error: a
  } = e, l = {
    select: ["select", n, r && "disabled", i && "multiple", a && "error"],
    icon: ["icon", `icon${be(n)}`, s && "iconOpen", r && "disabled"]
  };
  return Ot(l, iS, t);
}, fg = Z("select", {
  name: "MuiNativeSelect"
})(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${ef.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), aS = Z(fg, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: $o,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${ef.multiple}`]: t.multiple
    }];
  }
})({}), gg = Z("svg", {
  name: "MuiNativeSelect"
})(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${ef.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), lS = Z(gg, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${be(n.variant)}`], n.open && t.iconOpen];
  }
})({}), mg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: i,
    error: s,
    IconComponent: a,
    inputRef: l,
    variant: c = "standard",
    ...u
  } = t, f = {
    ...t,
    disabled: i,
    variant: c,
    error: s
  }, g = sS(f);
  return /* @__PURE__ */ p.jsxs(d.Fragment, {
    children: [/* @__PURE__ */ p.jsx(aS, {
      ownerState: f,
      className: xe(g.select, r),
      disabled: i,
      ref: l || n,
      ...u
    }), t.multiple ? null : /* @__PURE__ */ p.jsx(lS, {
      as: a,
      ownerState: f,
      className: g.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (mg.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The CSS class name of the select element.
   */
  className: o.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: o.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: o.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: qo,
  /**
   * @ignore
   */
  multiple: o.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: o.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The input value.
   */
  value: o.any,
  /**
   * The variant to use.
   */
  variant: o.oneOf(["standard", "outlined", "filled"])
});
var O3;
const cS = Z("fieldset", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: $o
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), uS = Z("legend", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: $o
})(mt(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function hg(e) {
  const {
    children: t,
    classes: n,
    className: r,
    label: i,
    notched: s,
    ...a
  } = e, l = i != null && i !== "", c = {
    ...e,
    notched: s,
    withLabel: l
  };
  return /* @__PURE__ */ p.jsx(cS, {
    "aria-hidden": !0,
    className: r,
    ownerState: c,
    ...a,
    children: /* @__PURE__ */ p.jsx(uS, {
      ownerState: c,
      children: l ? /* @__PURE__ */ p.jsx("span", {
        children: i
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        O3 || (O3 = /* @__PURE__ */ p.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" && (hg.propTypes = {
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The label.
   */
  label: o.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: o.bool.isRequired,
  /**
   * @ignore
   */
  style: o.object
});
const dS = (e) => {
  const {
    classes: t
  } = e, r = Ot({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, Ob, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...r
  };
}, pS = Z(Md, {
  shouldForwardProp: (e) => $o(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: Rd
})(mt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${hr.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${hr.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${hr.focused} .${hr.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(Mn()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        [`&.${hr.focused} .${hr.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[n].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${hr.error} .${hr.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${hr.disabled} .${hr.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: n,
        size: r
      }) => n.multiline && r === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), fS = Z(hg, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(mt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), gS = Z(kd, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: Td
})(mt(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), pc = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: i = {},
    fullWidth: s = !1,
    inputComponent: a = "input",
    label: l,
    multiline: c = !1,
    notched: u,
    slots: f = {},
    slotProps: g = {},
    type: h = "text",
    ...y
  } = r, v = dS(r), m = pr(), b = Oa({
    props: r,
    muiFormControl: m,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), C = {
    ...r,
    color: b.color || "primary",
    disabled: b.disabled,
    error: b.error,
    focused: b.focused,
    formControl: m,
    fullWidth: s,
    hiddenLabel: b.hiddenLabel,
    multiline: c,
    size: b.size,
    type: h
  }, E = f.root ?? i.Root ?? pS, S = f.input ?? i.Input ?? gS, [k, T] = kt("notchedOutline", {
    elementType: fS,
    className: v.notchedOutline,
    shouldForwardComponentProp: !0,
    ownerState: C,
    externalForwardedProps: {
      slots: f,
      slotProps: g
    },
    additionalProps: {
      label: l != null && l !== "" && b.required ? /* @__PURE__ */ p.jsxs(d.Fragment, {
        children: [l, " ", "*"]
      }) : l
    }
  });
  return /* @__PURE__ */ p.jsx(dc, {
    slots: {
      root: E,
      input: S
    },
    slotProps: g,
    renderSuffix: (P) => /* @__PURE__ */ p.jsx(k, {
      ...T,
      notched: typeof u < "u" ? u : !!(P.startAdornment || P.filled || P.focused)
    }),
    fullWidth: s,
    inputComponent: a,
    multiline: c,
    ref: n,
    type: h,
    ...y,
    classes: {
      ...v,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" && (pc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: o.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qo,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: o.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: o.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    input: o.object,
    notchedOutline: o.oneOfType([o.func, o.object]),
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    notchedOutline: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
pc.muiName = "Input";
function mS(e) {
  return Pt("MuiPagination", e);
}
Et("MuiPagination", ["root", "ul", "outlined", "text"]);
function hS(e = {}) {
  const {
    boundaryCount: t = 1,
    componentName: n = "usePagination",
    count: r = 1,
    defaultPage: i = 1,
    disabled: s = !1,
    hideNextButton: a = !1,
    hidePrevButton: l = !1,
    onChange: c,
    page: u,
    showFirstButton: f = !1,
    showLastButton: g = !1,
    siblingCount: h = 1,
    ...y
  } = e, [v, m] = Xr({
    controlled: u,
    default: i,
    name: n,
    state: "page"
  }), b = (L, R) => {
    u || m(R), c && c(L, R);
  }, C = (L, R) => {
    const V = R - L + 1;
    return Array.from({
      length: V
    }, (B, W) => L + W);
  }, E = C(1, Math.min(t, r)), S = C(Math.max(r - t + 1, t + 1), r), k = Math.max(
    Math.min(
      // Natural start
      v - h,
      // Lower boundary when page is high
      r - t - h * 2 - 1
    ),
    // Greater than startPages
    t + 2
  ), T = Math.min(
    Math.max(
      // Natural end
      v + h,
      // Upper boundary when page is low
      t + h * 2 + 2
    ),
    // Less than endPages
    r - t - 1
  ), P = [
    ...f ? ["first"] : [],
    ...l ? [] : ["previous"],
    ...E,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...k > t + 2 ? ["start-ellipsis"] : t + 1 < r - t ? [t + 1] : [],
    // Sibling pages
    ...C(k, T),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...T < r - t - 1 ? ["end-ellipsis"] : r - t > t ? [r - t] : [],
    ...S,
    ...a ? [] : ["next"],
    ...g ? ["last"] : []
  ], F = (L) => {
    switch (L) {
      case "first":
        return 1;
      case "previous":
        return v - 1;
      case "next":
        return v + 1;
      case "last":
        return r;
      default:
        return null;
    }
  };
  return {
    items: P.map((L) => typeof L == "number" ? {
      onClick: (R) => {
        b(R, L);
      },
      type: "page",
      page: L,
      selected: L === v,
      disabled: s,
      "aria-current": L === v ? "page" : void 0
    } : {
      onClick: (R) => {
        b(R, F(L));
      },
      type: L,
      page: F(L),
      selected: !1,
      disabled: s || !L.includes("ellipsis") && (L === "next" || L === "last" ? v >= r : v <= 1)
    }),
    ...y
  };
}
function vS(e) {
  return Pt("MuiPaginationItem", e);
}
const Go = Et("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), yS = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), bS = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), CS = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), xS = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), vg = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[n.variant], t[`size${be(n.size)}`], n.variant === "text" && t[`text${be(n.color)}`], n.variant === "outlined" && t[`outlined${be(n.color)}`], n.shape === "rounded" && t.rounded, n.type === "page" && t.page, (n.type === "start-ellipsis" || n.type === "end-ellipsis") && t.ellipsis, (n.type === "previous" || n.type === "next") && t.previousNext, (n.type === "first" || n.type === "last") && t.firstLast];
}, wS = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    selected: i,
    size: s,
    shape: a,
    type: l,
    variant: c
  } = e, u = {
    root: ["root", `size${be(s)}`, c, a, n !== "standard" && `color${be(n)}`, n !== "standard" && `${c}${be(n)}`, r && "disabled", i && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[l]],
    icon: ["icon"]
  };
  return Ot(u, vS, t);
}, SS = Z("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: vg
})(mt(({
  theme: e
}) => ({
  ...e.typography.body2,
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  height: "auto",
  [`&.${Go.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: e.typography.pxToRem(15)
    }
  }]
}))), ES = Z(Tr, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: vg
})(mt(({
  theme: e
}) => ({
  ...e.typography.body2,
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  [`&.${Go.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Go.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  transition: e.transitions.create(["color", "background-color"], {
    duration: e.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Go.selected}`]: {
    backgroundColor: (e.vars || e).palette.action.selected,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : At(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette.action.selected
      }
    },
    [`&.${Go.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : At(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    },
    [`&.${Go.disabled}`]: {
      opacity: 1,
      color: (e.vars || e).palette.action.disabled,
      backgroundColor: (e.vars || e).palette.action.selected
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      height: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      height: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: e.typography.pxToRem(15)
    }
  }, {
    props: {
      shape: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
      [`&.${Go.selected}`]: {
        [`&.${Go.disabled}`]: {
          borderColor: (e.vars || e).palette.action.disabledBackground,
          color: (e.vars || e).palette.action.disabled
        }
      }
    }
  }, {
    props: {
      variant: "text"
    },
    style: {
      [`&.${Go.selected}`]: {
        [`&.${Go.disabled}`]: {
          color: (e.vars || e).palette.action.disabled
        }
      }
    }
  }, ...Object.entries(e.palette).filter(Mn(["dark", "contrastText"])).map(([t]) => ({
    props: {
      variant: "text",
      color: t
    },
    style: {
      [`&.${Go.selected}`]: {
        color: (e.vars || e).palette[t].contrastText,
        backgroundColor: (e.vars || e).palette[t].main,
        "&:hover": {
          backgroundColor: (e.vars || e).palette[t].dark,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: (e.vars || e).palette[t].main
          }
        },
        [`&.${Go.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[t].dark
        },
        [`&.${Go.disabled}`]: {
          color: (e.vars || e).palette.action.disabled
        }
      }
    }
  })), ...Object.entries(e.palette).filter(Mn(["light"])).map(([t]) => ({
    props: {
      variant: "outlined",
      color: t
    },
    style: {
      [`&.${Go.selected}`]: {
        color: (e.vars || e).palette[t].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.5)` : At(e.palette[t].main, 0.5)}`,
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.activatedOpacity})` : At(e.palette[t].main, e.palette.action.activatedOpacity),
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : At(e.palette[t].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${Go.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : At(e.palette[t].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity)
        }
      }
    }
  }))]
}))), RS = Z("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})(mt(({
  theme: e
}) => ({
  fontSize: e.typography.pxToRem(20),
  margin: "0 -8px",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      fontSize: e.typography.pxToRem(22)
    }
  }]
}))), yg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiPaginationItem"
  }), {
    className: i,
    color: s = "standard",
    component: a,
    components: l = {},
    disabled: c = !1,
    page: u,
    selected: f = !1,
    shape: g = "circular",
    size: h = "medium",
    slots: y = {},
    slotProps: v = {},
    type: m = "page",
    variant: b = "text",
    ...C
  } = r, E = {
    ...r,
    color: s,
    disabled: c,
    selected: f,
    shape: g,
    size: h,
    type: m,
    variant: b
  }, S = Io(), k = wS(E), T = {
    slots: {
      previous: y.previous ?? l.previous,
      next: y.next ?? l.next,
      first: y.first ?? l.first,
      last: y.last ?? l.last
    },
    slotProps: v
  }, [P, F] = kt("previous", {
    elementType: CS,
    externalForwardedProps: T,
    ownerState: E
  }), [j, L] = kt("next", {
    elementType: xS,
    externalForwardedProps: T,
    ownerState: E
  }), [R, V] = kt("first", {
    elementType: yS,
    externalForwardedProps: T,
    ownerState: E
  }), [B, W] = kt("last", {
    elementType: bS,
    externalForwardedProps: T,
    ownerState: E
  }), z = S ? {
    previous: "next",
    next: "previous",
    first: "last",
    last: "first"
  }[m] : m, G = {
    previous: P,
    next: j,
    first: R,
    last: B
  }[z], H = {
    previous: F,
    next: L,
    first: V,
    last: W
  }[z];
  return m === "start-ellipsis" || m === "end-ellipsis" ? /* @__PURE__ */ p.jsx(SS, {
    ref: n,
    ownerState: E,
    className: xe(k.root, i),
    children: "…"
  }) : /* @__PURE__ */ p.jsxs(ES, {
    ref: n,
    ownerState: E,
    component: a,
    disabled: c,
    className: xe(k.root, i),
    ...C,
    children: [m === "page" && u, G ? /* @__PURE__ */ p.jsx(RS, {
      ...H,
      className: k.icon,
      as: G
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (yg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "standard"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  components: o.shape({
    first: o.elementType,
    last: o.elementType,
    next: o.elementType,
    previous: o.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * The current page number.
   */
  page: o.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: o.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: o.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    first: o.oneOfType([o.func, o.object]),
    last: o.oneOfType([o.func, o.object]),
    next: o.oneOfType([o.func, o.object]),
    previous: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    first: o.elementType,
    last: o.elementType,
    next: o.elementType,
    previous: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: o.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: o.oneOfType([o.oneOf(["outlined", "text"]), o.string])
});
const TS = (e) => {
  const {
    classes: t,
    variant: n
  } = e;
  return Ot({
    root: ["root", n],
    ul: ["ul"]
  }, mS, t);
}, MS = Z("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant]];
  }
})({}), kS = Z("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (e, t) => t.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function PS(e, t, n) {
  return e === "page" ? `${n ? "" : "Go to "}page ${t}` : `Go to ${e} page`;
}
const bg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiPagination"
  }), {
    boundaryCount: i = 1,
    className: s,
    color: a = "standard",
    count: l = 1,
    defaultPage: c = 1,
    disabled: u = !1,
    getItemAriaLabel: f = PS,
    hideNextButton: g = !1,
    hidePrevButton: h = !1,
    onChange: y,
    page: v,
    renderItem: m = (R) => /* @__PURE__ */ p.jsx(yg, {
      ...R
    }),
    shape: b = "circular",
    showFirstButton: C = !1,
    showLastButton: E = !1,
    siblingCount: S = 1,
    size: k = "medium",
    variant: T = "text",
    ...P
  } = r, {
    items: F
  } = hS({
    ...r,
    componentName: "Pagination"
  }), j = {
    ...r,
    boundaryCount: i,
    color: a,
    count: l,
    defaultPage: c,
    disabled: u,
    getItemAriaLabel: f,
    hideNextButton: g,
    hidePrevButton: h,
    renderItem: m,
    shape: b,
    showFirstButton: C,
    showLastButton: E,
    siblingCount: S,
    size: k,
    variant: T
  }, L = TS(j);
  return /* @__PURE__ */ p.jsx(MS, {
    "aria-label": "pagination navigation",
    className: xe(L.root, s),
    ownerState: j,
    ref: n,
    ...P,
    children: /* @__PURE__ */ p.jsx(kS, {
      className: L.ul,
      ownerState: j,
      children: F.map((R, V) => /* @__PURE__ */ p.jsx("li", {
        children: m({
          ...R,
          color: a,
          "aria-label": f(R.type, R.page, R.selected),
          shape: b,
          size: k,
          variant: T
        })
      }, V))
    })
  });
});
process.env.NODE_ENV !== "production" && (bg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: Fr,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "standard"]), o.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: Fr,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: Fr,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number | null} page The page number to format.
   * @param {boolean} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: o.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: o.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: o.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: o.func,
  /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */
  page: Fr,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: o.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: o.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: o.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: o.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: Fr,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: o.oneOfType([o.oneOf(["outlined", "text"]), o.string])
});
const IS = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), OS = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), DS = Z("span", {
  name: "MuiRadioButtonIcon",
  shouldForwardProp: $o
})({
  position: "relative",
  display: "flex"
}), jS = Z(IS, {
  name: "MuiRadioButtonIcon"
})({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), FS = Z(OS, {
  name: "MuiRadioButtonIcon"
})(mt(({
  theme: e
}) => ({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      checked: !0
    },
    style: {
      transform: "scale(1)",
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeOut,
        duration: e.transitions.duration.shortest
      })
    }
  }]
})));
function tf(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: r
  } = e, i = {
    ...e,
    checked: t
  };
  return /* @__PURE__ */ p.jsxs(DS, {
    className: n.root,
    ownerState: i,
    children: [/* @__PURE__ */ p.jsx(jS, {
      fontSize: r,
      className: n.background,
      ownerState: i
    }), /* @__PURE__ */ p.jsx(FS, {
      fontSize: r,
      className: n.dot,
      ownerState: i
    })]
  });
}
process.env.NODE_ENV !== "production" && (tf.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: o.oneOf(["small", "medium"])
});
const Cg = /* @__PURE__ */ d.createContext(void 0);
process.env.NODE_ENV !== "production" && (Cg.displayName = "RadioGroupContext");
function VS() {
  return d.useContext(Cg);
}
function $S(e) {
  return Pt("MuiRadio", e);
}
const D3 = Et("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), LS = (e) => {
  const {
    classes: t,
    color: n,
    size: r
  } = e, i = {
    root: ["root", `color${be(n)}`, r !== "medium" && `size${be(r)}`]
  };
  return {
    ...t,
    ...Ot(i, $S, t)
  };
}, AS = Z(Pd, {
  shouldForwardProp: (e) => $o(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size !== "medium" && t[`size${be(n.size)}`], t[`color${be(n.color)}`]];
  }
})(mt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  [`&.${D3.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: {
      color: "default",
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1
    },
    style: {
      [`&.${D3.checked}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
})));
function NS(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const BS = /* @__PURE__ */ p.jsx(tf, {
  checked: !0
}), _S = /* @__PURE__ */ p.jsx(tf, {}), xg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiRadio"
  }), {
    checked: i,
    checkedIcon: s = BS,
    color: a = "primary",
    icon: l = _S,
    name: c,
    onChange: u,
    size: f = "medium",
    className: g,
    disabled: h,
    disableRipple: y = !1,
    slots: v = {},
    slotProps: m = {},
    inputProps: b,
    ...C
  } = r, E = pr();
  let S = h;
  E && typeof S > "u" && (S = E.disabled), S ?? (S = !1);
  const k = {
    ...r,
    disabled: S,
    disableRipple: y,
    color: a,
    size: f
  }, T = LS(k), P = VS();
  let F = i;
  const j = R0(u, P && P.onChange);
  let L = c;
  P && (typeof F > "u" && (F = NS(P.value, r.value)), typeof L > "u" && (L = P.name));
  const R = m.input ?? b, [V, B] = kt("root", {
    ref: n,
    elementType: AS,
    className: xe(T.root, g),
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      slots: v,
      slotProps: m,
      ...C
    },
    getSlotProps: (W) => ({
      ...W,
      onChange: (z, ...G) => {
        var H;
        (H = W.onChange) == null || H.call(W, z, ...G), j(z, ...G);
      }
    }),
    ownerState: k,
    additionalProps: {
      type: "radio",
      icon: /* @__PURE__ */ d.cloneElement(l, {
        fontSize: l.props.fontSize ?? f
      }),
      checkedIcon: /* @__PURE__ */ d.cloneElement(s, {
        fontSize: s.props.fontSize ?? f
      }),
      disabled: S,
      name: L,
      checked: F,
      slots: v,
      slotProps: {
        // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
        input: typeof R == "function" ? R(k) : R
      }
    }
  });
  return /* @__PURE__ */ p.jsx(V, {
    ...B,
    classes: T
  });
});
process.env.NODE_ENV !== "production" && (xg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: o.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: o.node,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputRef: qo,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: o.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: o.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    input: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: o.any
});
const zS = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), "Star"), HS = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), "StarBorder");
function WS(e) {
  return Pt("MuiRating", e);
}
const el = Et("MuiRating", ["root", "sizeSmall", "sizeMedium", "sizeLarge", "readOnly", "disabled", "focusVisible", "visuallyHidden", "pristine", "label", "labelEmptyValueActive", "icon", "iconEmpty", "iconFilled", "iconHover", "iconFocus", "iconActive", "decimal"]);
function GS(e) {
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function U1(e, t) {
  if (e == null)
    return e;
  const n = Math.round(e / t) * t;
  return Number(n.toFixed(GS(t)));
}
const US = (e) => {
  const {
    classes: t,
    size: n,
    readOnly: r,
    disabled: i,
    emptyValueFocused: s,
    focusVisible: a
  } = e, l = {
    root: ["root", `size${be(n)}`, i && "disabled", a && "focusVisible", r && "readOnly"],
    label: ["label", "pristine"],
    labelEmptyValue: [s && "labelEmptyValueActive"],
    icon: ["icon"],
    iconEmpty: ["iconEmpty"],
    iconFilled: ["iconFilled"],
    iconHover: ["iconHover"],
    iconFocus: ["iconFocus"],
    iconActive: ["iconActive"],
    decimal: ["decimal"],
    visuallyHidden: ["visuallyHidden"]
  };
  return Ot(l, WS, t);
}, YS = Z("span", {
  name: "MuiRating",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${el.visuallyHidden}`]: t.visuallyHidden
    }, t.root, t[`size${be(n.size)}`], n.readOnly && t.readOnly];
  }
})(mt(({
  theme: e
}) => ({
  display: "inline-flex",
  // Required to position the pristine input absolutely
  position: "relative",
  fontSize: e.typography.pxToRem(24),
  color: "#faaf00",
  cursor: "pointer",
  textAlign: "left",
  width: "min-content",
  WebkitTapHighlightColor: "transparent",
  [`&.${el.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity,
    pointerEvents: "none"
  },
  [`&.${el.focusVisible} .${el.iconActive}`]: {
    outline: "1px solid #999"
  },
  [`& .${el.visuallyHidden}`]: v4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      fontSize: e.typography.pxToRem(30)
    }
  }, {
    // TODO v6: use the .Mui-readOnly global state class
    props: ({
      ownerState: t
    }) => t.readOnly,
    style: {
      pointerEvents: "none"
    }
  }]
}))), wg = Z("label", {
  name: "MuiRating",
  slot: "Label",
  overridesResolver: ({
    ownerState: e
  }, t) => [t.label, e.emptyValueFocused && t.labelEmptyValueActive]
})({
  cursor: "inherit",
  variants: [{
    props: ({
      ownerState: e
    }) => e.emptyValueFocused,
    style: {
      top: 0,
      bottom: 0,
      position: "absolute",
      outline: "1px solid #999",
      width: "100%"
    }
  }]
}), ZS = Z("span", {
  name: "MuiRating",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.iconEmpty && t.iconEmpty, n.iconFilled && t.iconFilled, n.iconHover && t.iconHover, n.iconFocus && t.iconFocus, n.iconActive && t.iconActive];
  }
})(mt(({
  theme: e
}) => ({
  // Fit wrapper to actual icon size.
  display: "flex",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  // Fix mouseLeave issue.
  // https://github.com/facebook/react/issues/4492
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => t.iconActive,
    style: {
      transform: "scale(1.2)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.iconEmpty,
    style: {
      color: (e.vars || e).palette.action.disabled
    }
  }]
}))), qS = Z("span", {
  name: "MuiRating",
  slot: "Decimal",
  shouldForwardProp: (e) => sc(e) && e !== "iconActive",
  overridesResolver: (e, t) => {
    const {
      iconActive: n
    } = e;
    return [t.decimal, n && t.iconActive];
  }
})({
  position: "relative",
  variants: [{
    props: ({
      iconActive: e
    }) => e,
    style: {
      transform: "scale(1.2)"
    }
  }]
});
function Sg(e) {
  const {
    value: t,
    ...n
  } = e;
  return /* @__PURE__ */ p.jsx("span", {
    ...n
  });
}
process.env.NODE_ENV !== "production" && (Sg.propTypes = {
  value: o.number.isRequired
});
function H0(e) {
  const {
    classes: t,
    disabled: n,
    emptyIcon: r,
    focus: i,
    getLabelText: s,
    highlightSelectedOnly: a,
    hover: l,
    icon: c,
    IconContainerComponent: u,
    isActive: f,
    itemValue: g,
    labelProps: h,
    name: y,
    onBlur: v,
    onChange: m,
    onClick: b,
    onFocus: C,
    readOnly: E,
    ownerState: S,
    ratingValue: k,
    ratingValueRounded: T,
    slots: P = {},
    slotProps: F = {}
  } = e, j = a ? g === k : g <= k, L = g <= l, R = g <= i, V = g === T, B = `${y}-${ai()}`, W = {
    slots: P,
    slotProps: F
  }, [z, G] = kt("icon", {
    elementType: ZS,
    className: xe(t.icon, j ? t.iconFilled : t.iconEmpty, L && t.iconHover, R && t.iconFocus, f && t.iconActive),
    externalForwardedProps: W,
    ownerState: {
      ...S,
      iconEmpty: !j,
      iconFilled: j,
      iconHover: L,
      iconFocus: R,
      iconActive: f
    },
    additionalProps: {
      value: g
    },
    internalForwardedProps: {
      // TODO: remove this in v7 because `IconContainerComponent` is deprecated
      // only forward if `slots.icon` is NOT provided
      as: u
    }
  }), [H, ie] = kt("label", {
    elementType: wg,
    externalForwardedProps: W,
    ownerState: {
      ...S,
      emptyValueFocused: void 0
    },
    additionalProps: {
      style: h == null ? void 0 : h.style,
      htmlFor: B
    }
  }), ce = /* @__PURE__ */ p.jsx(z, {
    ...G,
    children: r && !j ? r : c
  });
  return E ? /* @__PURE__ */ p.jsx("span", {
    ...h,
    children: ce
  }) : /* @__PURE__ */ p.jsxs(d.Fragment, {
    children: [/* @__PURE__ */ p.jsxs(H, {
      ...ie,
      children: [ce, /* @__PURE__ */ p.jsx("span", {
        className: t.visuallyHidden,
        children: s(g)
      })]
    }), /* @__PURE__ */ p.jsx("input", {
      className: t.visuallyHidden,
      onFocus: C,
      onBlur: v,
      onChange: m,
      onClick: b,
      disabled: n,
      value: g,
      id: B,
      type: "radio",
      name: y,
      checked: V
    })]
  });
}
process.env.NODE_ENV !== "production" && (H0.propTypes = {
  classes: o.object.isRequired,
  disabled: o.bool.isRequired,
  emptyIcon: o.node,
  focus: o.number.isRequired,
  getLabelText: o.func.isRequired,
  highlightSelectedOnly: o.bool.isRequired,
  hover: o.number.isRequired,
  icon: o.node,
  IconContainerComponent: o.elementType.isRequired,
  isActive: o.bool.isRequired,
  itemValue: o.number.isRequired,
  labelProps: o.object,
  name: o.string,
  onBlur: o.func.isRequired,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onFocus: o.func.isRequired,
  ownerState: o.object.isRequired,
  ratingValue: o.number,
  ratingValueRounded: o.number,
  readOnly: o.bool.isRequired,
  slotProps: o.object,
  slots: o.object
});
const KS = /* @__PURE__ */ p.jsx(zS, {
  fontSize: "inherit"
}), XS = /* @__PURE__ */ p.jsx(HS, {
  fontSize: "inherit"
});
function QS(e) {
  return `${e || "0"} Star${e !== 1 ? "s" : ""}`;
}
const JS = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    name: "MuiRating",
    props: t
  }), {
    component: i = "span",
    className: s,
    defaultValue: a = null,
    disabled: l = !1,
    emptyIcon: c = XS,
    emptyLabelText: u = "Empty",
    getLabelText: f = QS,
    highlightSelectedOnly: g = !1,
    icon: h = KS,
    IconContainerComponent: y = Sg,
    max: v = 5,
    name: m,
    onChange: b,
    onChangeActive: C,
    onMouseLeave: E,
    onMouseMove: S,
    precision: k = 1,
    readOnly: T = !1,
    size: P = "medium",
    value: F,
    slots: j = {},
    slotProps: L = {},
    ...R
  } = r, V = ai(m), [B, W] = Xr({
    controlled: F,
    default: a,
    name: "Rating"
  }), z = U1(B, k), G = Io(), [{
    hover: H,
    focus: ie
  }, ce] = d.useState({
    hover: -1,
    focus: -1
  });
  let re = z;
  H !== -1 && (re = H), ie !== -1 && (re = ie);
  const [A, Y] = d.useState(!1), pe = d.useRef(), Ce = lo(pe, n), fe = (Te) => {
    S && S(Te);
    const Fe = pe.current, {
      right: gt,
      left: Dt,
      width: ke
    } = Fe.getBoundingClientRect();
    let Ne;
    G ? Ne = (gt - Te.clientX) / ke : Ne = (Te.clientX - Dt) / ke;
    let We = U1(v * Ne + k / 2, k);
    We = Ss(We, k, v), ce((Ge) => Ge.hover === We && Ge.focus === We ? Ge : {
      hover: We,
      focus: We
    }), Y(!1), C && H !== We && C(Te, We);
  }, ee = (Te) => {
    E && E(Te);
    const Fe = -1;
    ce({
      hover: Fe,
      focus: Fe
    }), C && H !== Fe && C(Te, Fe);
  }, te = (Te) => {
    let Fe = Te.target.value === "" ? null : parseFloat(Te.target.value);
    H !== -1 && (Fe = H), W(Fe), b && b(Te, Fe);
  }, ue = (Te) => {
    Te.clientX === 0 && Te.clientY === 0 || (ce({
      hover: -1,
      focus: -1
    }), W(null), b && parseFloat(Te.target.value) === z && b(Te, null));
  }, K = (Te) => {
    is(Te.target) && Y(!0);
    const Fe = parseFloat(Te.target.value);
    ce((gt) => ({
      hover: gt.hover,
      focus: Fe
    }));
  }, oe = (Te) => {
    if (H !== -1)
      return;
    is(Te.target) || Y(!1);
    const Fe = -1;
    ce((gt) => ({
      hover: gt.hover,
      focus: Fe
    }));
  }, [de, ve] = d.useState(!1), J = {
    ...r,
    component: i,
    defaultValue: a,
    disabled: l,
    emptyIcon: c,
    emptyLabelText: u,
    emptyValueFocused: de,
    focusVisible: A,
    getLabelText: f,
    icon: h,
    IconContainerComponent: y,
    max: v,
    precision: k,
    readOnly: T,
    size: P
  }, se = US(J), ge = {
    slots: j,
    slotProps: L
  }, [Se, we] = kt("root", {
    ref: Ce,
    className: xe(se.root, s),
    elementType: YS,
    externalForwardedProps: {
      ...ge,
      ...R,
      component: i
    },
    getSlotProps: (Te) => ({
      ...Te,
      onMouseMove: (Fe) => {
        var gt;
        fe(Fe), (gt = Te.onMouseMove) == null || gt.call(Te, Fe);
      },
      onMouseLeave: (Fe) => {
        var gt;
        ee(Fe), (gt = Te.onMouseLeave) == null || gt.call(Te, Fe);
      }
    }),
    ownerState: J,
    additionalProps: {
      role: T ? "img" : null,
      "aria-label": T ? f(re) : null
    }
  }), [me, ye] = kt("label", {
    className: xe(se.label, se.labelEmptyValue),
    elementType: wg,
    externalForwardedProps: ge,
    ownerState: J
  }), [Ie, je] = kt("decimal", {
    className: se.decimal,
    elementType: qS,
    externalForwardedProps: ge,
    ownerState: J
  });
  return /* @__PURE__ */ p.jsxs(Se, {
    ...we,
    children: [Array.from(new Array(v)).map((Te, Fe) => {
      const gt = Fe + 1, Dt = {
        classes: se,
        disabled: l,
        emptyIcon: c,
        focus: ie,
        getLabelText: f,
        highlightSelectedOnly: g,
        hover: H,
        icon: h,
        IconContainerComponent: y,
        name: V,
        onBlur: oe,
        onChange: te,
        onClick: ue,
        onFocus: K,
        ratingValue: re,
        ratingValueRounded: z,
        readOnly: T,
        ownerState: J,
        slots: j,
        slotProps: L
      }, ke = gt === Math.ceil(re) && (H !== -1 || ie !== -1);
      if (k < 1) {
        const Ne = Array.from(new Array(1 / k));
        return /* @__PURE__ */ Cr(Ie, {
          ...je,
          key: gt,
          className: xe(je.className, ke && se.iconActive),
          iconActive: ke
        }, Ne.map((We, Ge) => {
          const Qe = U1(gt - 1 + (Ge + 1) * k, k);
          return /* @__PURE__ */ p.jsx(H0, {
            ...Dt,
            // The icon is already displayed as active
            isActive: !1,
            itemValue: Qe,
            labelProps: {
              style: Ne.length - 1 === Ge ? {} : {
                width: Qe === re ? `${(Ge + 1) * k * 100}%` : "0%",
                overflow: "hidden",
                position: "absolute"
              }
            }
          }, Qe);
        }));
      }
      return /* @__PURE__ */ p.jsx(H0, {
        ...Dt,
        isActive: ke,
        itemValue: gt
      }, gt);
    }), !T && !l && /* @__PURE__ */ p.jsxs(me, {
      ...ye,
      children: [/* @__PURE__ */ p.jsx("input", {
        className: se.visuallyHidden,
        value: "",
        id: `${V}-empty`,
        type: "radio",
        name: V,
        checked: z == null,
        onFocus: () => ve(!0),
        onBlur: () => ve(!1),
        onChange: te
      }), /* @__PURE__ */ p.jsx("span", {
        className: se.visuallyHidden,
        children: u
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (JS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The default value. Use when the component is not controlled.
   * @default null
   */
  defaultValue: o.number,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * The icon to display when empty.
   * @default <StarBorder fontSize="inherit" />
   */
  emptyIcon: o.node,
  /**
   * The label read when the rating input is empty.
   * @default 'Empty'
   */
  emptyLabelText: o.node,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the rating.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {number} value The rating label's value to format.
   * @returns {string}
   * @default function defaultLabelText(value) {
   *   return `${value || '0'} Star${value !== 1 ? 's' : ''}`;
   * }
   */
  getLabelText: o.func,
  /**
   * If `true`, only the selected icon will be highlighted.
   * @default false
   */
  highlightSelectedOnly: o.bool,
  /**
   * The icon to display.
   * @default <Star fontSize="inherit" />
   */
  icon: o.node,
  /**
   * The component containing the icon.
   * @deprecated Use `slotProps.icon.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default function IconContainer(props) {
   *   const { value, ...other } = props;
   *   return <span {...other} />;
   * }
   */
  IconContainerComponent: o.elementType,
  /**
   * Maximum rating.
   * @default 5
   */
  max: o.number,
  /**
   * The name attribute of the radio `input` elements.
   * This input `name` should be unique within the page.
   * Being unique within a form is insufficient since the `name` is used to generate IDs.
   */
  name: o.string,
  /**
   * Callback fired when the value changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number|null} value The new value.
   */
  onChange: o.func,
  /**
   * Callback function that is fired when the hover state changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChangeActive: o.func,
  /**
   * @ignore
   */
  onMouseLeave: o.func,
  /**
   * @ignore
   */
  onMouseMove: o.func,
  /**
   * The minimum increment value change allowed.
   * @default 1
   */
  precision: nr(o.number, (e) => e.precision < 0.1 ? new Error(["MUI: The prop `precision` should be above 0.1.", "A value below this limit has an imperceptible impact."].join(`
`)) : null),
  /**
   * Removes all hover effects and pointer events.
   * @default false
   */
  readOnly: o.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    decimal: o.oneOfType([o.func, o.object]),
    icon: o.oneOfType([o.func, o.object]),
    label: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    decimal: o.elementType,
    icon: o.elementType,
    label: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The rating value.
   */
  value: o.number
});
function Eg(e) {
  return Pt("MuiSelect", e);
}
const tl = Et("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var j3;
const eE = Z(fg, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${tl.select}`]: t.select
      },
      {
        [`&.${tl.select}`]: t[n.variant]
      },
      {
        [`&.${tl.error}`]: t.error
      },
      {
        [`&.${tl.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${tl.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), tE = Z(gg, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${be(n.variant)}`], n.open && t.iconOpen];
  }
})({}), nE = Z("input", {
  shouldForwardProp: (e) => sc(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function F3(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function oE(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const rE = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: i,
    open: s,
    error: a
  } = e, l = {
    select: ["select", n, r && "disabled", i && "multiple", a && "error"],
    icon: ["icon", `icon${be(n)}`, s && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Ot(l, Eg, t);
}, Rg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  var hn;
  const {
    "aria-describedby": r,
    "aria-label": i,
    autoFocus: s,
    autoWidth: a,
    children: l,
    className: c,
    defaultOpen: u,
    defaultValue: f,
    disabled: g,
    displayEmpty: h,
    error: y = !1,
    IconComponent: v,
    inputRef: m,
    labelId: b,
    MenuProps: C = {},
    multiple: E,
    name: S,
    onBlur: k,
    onChange: T,
    onClose: P,
    onFocus: F,
    onOpen: j,
    open: L,
    readOnly: R,
    renderValue: V,
    required: B,
    SelectDisplayProps: W = {},
    tabIndex: z,
    // catching `type` from Input which makes no sense for SelectInput
    type: G,
    value: H,
    variant: ie = "standard",
    ...ce
  } = t, [re, A] = Xr({
    controlled: H,
    default: f,
    name: "Select"
  }), [Y, pe] = Xr({
    controlled: L,
    default: u,
    name: "Select"
  }), Ce = d.useRef(null), fe = d.useRef(null), [ee, te] = d.useState(null), {
    current: ue
  } = d.useRef(L != null), [K, oe] = d.useState(), de = lo(n, m), ve = d.useCallback((Je) => {
    fe.current = Je, Je && te(Je);
  }, []), J = ee == null ? void 0 : ee.parentNode;
  d.useImperativeHandle(de, () => ({
    focus: () => {
      fe.current.focus();
    },
    node: Ce.current,
    value: re
  }), [re]), d.useEffect(() => {
    u && Y && ee && !ue && (oe(a ? null : J.clientWidth), fe.current.focus());
  }, [ee, a]), d.useEffect(() => {
    s && fe.current.focus();
  }, [s]), d.useEffect(() => {
    if (!b)
      return;
    const Je = Co(fe.current).getElementById(b);
    if (Je) {
      const $t = () => {
        getSelection().isCollapsed && fe.current.focus();
      };
      return Je.addEventListener("click", $t), () => {
        Je.removeEventListener("click", $t);
      };
    }
  }, [b]);
  const se = (Je, $t) => {
    Je ? j && j($t) : P && P($t), ue || (oe(a ? null : J.clientWidth), pe(Je));
  }, ge = (Je) => {
    Je.button === 0 && (Je.preventDefault(), fe.current.focus(), se(!0, Je));
  }, Se = (Je) => {
    se(!1, Je);
  }, we = d.Children.toArray(l), me = (Je) => {
    const $t = we.find((nn) => nn.props.value === Je.target.value);
    $t !== void 0 && (A($t.props.value), T && T(Je, $t));
  }, ye = (Je) => ($t) => {
    let nn;
    if ($t.currentTarget.hasAttribute("tabindex")) {
      if (E) {
        nn = Array.isArray(re) ? re.slice() : [];
        const Nt = re.indexOf(Je.props.value);
        Nt === -1 ? nn.push(Je.props.value) : nn.splice(Nt, 1);
      } else
        nn = Je.props.value;
      if (Je.props.onClick && Je.props.onClick($t), re !== nn && (A(nn), T)) {
        const Nt = $t.nativeEvent || $t, cn = new Nt.constructor(Nt.type, Nt);
        Object.defineProperty(cn, "target", {
          writable: !0,
          value: {
            value: nn,
            name: S
          }
        }), T(cn, Je);
      }
      E || se(!1, $t);
    }
  }, Ie = (Je) => {
    R || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(Je.key) && (Je.preventDefault(), se(!0, Je));
  }, je = ee !== null && Y, Te = (Je) => {
    !je && k && (Object.defineProperty(Je, "target", {
      writable: !0,
      value: {
        value: re,
        name: S
      }
    }), k(Je));
  };
  delete ce["aria-invalid"];
  let Fe, gt;
  const Dt = [];
  let ke = !1, Ne = !1;
  (Gu({
    value: re
  }) || h) && (V ? Fe = V(re) : ke = !0);
  const We = we.map((Je) => {
    if (!/* @__PURE__ */ d.isValidElement(Je))
      return null;
    process.env.NODE_ENV !== "production" && Pi.isFragment(Je) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let $t;
    if (E) {
      if (!Array.isArray(re))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : ei(2));
      $t = re.some((nn) => F3(nn, Je.props.value)), $t && ke && Dt.push(Je.props.children);
    } else
      $t = F3(re, Je.props.value), $t && ke && (gt = Je.props.children);
    return $t && (Ne = !0), /* @__PURE__ */ d.cloneElement(Je, {
      "aria-selected": $t ? "true" : "false",
      onClick: ye(Je),
      onKeyUp: (nn) => {
        nn.key === " " && nn.preventDefault(), Je.props.onKeyUp && Je.props.onKeyUp(nn);
      },
      role: "option",
      selected: $t,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Je.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && d.useEffect(() => {
    if (!Ne && !E && re !== "") {
      const Je = we.map(($t) => $t.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${re}\` for the select ${S ? `(name="${S}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${Je.filter(($t) => $t != null).map(($t) => `\`${$t}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Ne, we, E, S, re]), ke && (E ? Dt.length === 0 ? Fe = null : Fe = Dt.reduce((Je, $t, nn) => (Je.push($t), nn < Dt.length - 1 && Je.push(", "), Je), []) : Fe = gt);
  let Ge = K;
  !a && ue && ee && (Ge = J.clientWidth);
  let Qe;
  typeof z < "u" ? Qe = z : Qe = g ? null : 0;
  const Ve = W.id || (S ? `mui-component-select-${S}` : void 0), Ke = {
    ...t,
    variant: ie,
    value: re,
    open: je,
    error: y
  }, bt = rE(Ke), vt = {
    ...C.PaperProps,
    ...(hn = C.slotProps) == null ? void 0 : hn.paper
  }, tn = ai();
  return /* @__PURE__ */ p.jsxs(d.Fragment, {
    children: [/* @__PURE__ */ p.jsx(eE, {
      as: "div",
      ref: ve,
      tabIndex: Qe,
      role: "combobox",
      "aria-controls": je ? tn : void 0,
      "aria-disabled": g ? "true" : void 0,
      "aria-expanded": je ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": i,
      "aria-labelledby": [b, Ve].filter(Boolean).join(" ") || void 0,
      "aria-describedby": r,
      "aria-required": B ? "true" : void 0,
      "aria-invalid": y ? "true" : void 0,
      onKeyDown: Ie,
      onMouseDown: g || R ? null : ge,
      onBlur: Te,
      onFocus: F,
      ...W,
      ownerState: Ke,
      className: xe(W.className, bt.select, c),
      id: Ve,
      children: oE(Fe) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        j3 || (j3 = /* @__PURE__ */ p.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : Fe
    }), /* @__PURE__ */ p.jsx(nE, {
      "aria-invalid": y,
      value: Array.isArray(re) ? re.join(",") : re,
      name: S,
      ref: Ce,
      "aria-hidden": !0,
      onChange: me,
      tabIndex: -1,
      disabled: g,
      className: bt.nativeInput,
      autoFocus: s,
      required: B,
      ...ce,
      ownerState: Ke
    }), /* @__PURE__ */ p.jsx(tE, {
      as: v,
      className: bt.icon,
      ownerState: Ke
    }), /* @__PURE__ */ p.jsx(Jp, {
      id: `menu-${S || ""}`,
      anchorEl: J,
      open: je,
      onClose: Se,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...C,
      slotProps: {
        ...C.slotProps,
        list: {
          "aria-labelledby": b,
          role: "listbox",
          "aria-multiselectable": E ? "true" : void 0,
          disableListWrap: !0,
          id: tn,
          ...C.MenuListProps
        },
        paper: {
          ...vt,
          style: {
            minWidth: Ge,
            ...vt != null ? vt.style : null
          }
        }
      },
      children: We
    })]
  });
});
process.env.NODE_ENV !== "production" && (Rg.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": o.string,
  /**
   * @ignore
   */
  "aria-label": o.string,
  /**
   * @ignore
   */
  autoFocus: o.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: o.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The CSS class name of the select element.
   */
  className: o.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: o.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: o.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: o.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: o.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: qo,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: o.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: o.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: o.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: o.string,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: o.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool,
  /**
   * @ignore
   */
  readOnly: o.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: o.func,
  /**
   * If `true`, the component is required.
   */
  required: o.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: o.object,
  /**
   * @ignore
   */
  tabIndex: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  type: o.any,
  /**
   * The input value.
   */
  value: o.any,
  /**
   * The variant to use.
   */
  variant: o.oneOf(["standard", "outlined", "filled"])
});
const iE = (e) => {
  const {
    classes: t
  } = e, r = Ot({
    root: ["root"]
  }, Eg, t);
  return {
    ...t,
    ...r
  };
}, nf = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => $o(e) && e !== "variant",
  slot: "Root"
}, sE = Z(Dd, nf)(""), aE = Z(pc, nf)(""), lE = Z(Od, nf)(""), fc = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: i = !1,
    children: s,
    classes: a = {},
    className: l,
    defaultOpen: c = !1,
    displayEmpty: u = !1,
    IconComponent: f = eg,
    id: g,
    input: h,
    inputProps: y,
    label: v,
    labelId: m,
    MenuProps: b,
    multiple: C = !1,
    native: E = !1,
    onClose: S,
    onOpen: k,
    open: T,
    renderValue: P,
    SelectDisplayProps: F,
    variant: j = "outlined",
    ...L
  } = r, R = E ? mg : Rg, V = pr(), B = Oa({
    props: r,
    muiFormControl: V,
    states: ["variant", "error"]
  }), W = B.variant || j, z = {
    ...r,
    variant: W,
    classes: a
  }, G = iE(z), {
    root: H,
    ...ie
  } = G, ce = h || {
    standard: /* @__PURE__ */ p.jsx(sE, {
      ownerState: z
    }),
    outlined: /* @__PURE__ */ p.jsx(aE, {
      label: v,
      ownerState: z
    }),
    filled: /* @__PURE__ */ p.jsx(lE, {
      ownerState: z
    })
  }[W], re = lo(n, _s(ce));
  return /* @__PURE__ */ p.jsx(d.Fragment, {
    children: /* @__PURE__ */ d.cloneElement(ce, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: R,
      inputProps: {
        children: s,
        error: B.error,
        IconComponent: f,
        variant: W,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: C,
        ...E ? {
          id: g
        } : {
          autoWidth: i,
          defaultOpen: c,
          displayEmpty: u,
          labelId: m,
          MenuProps: b,
          onClose: S,
          onOpen: k,
          open: T,
          renderValue: P,
          SelectDisplayProps: {
            id: g,
            ...F
          }
        },
        ...y,
        classes: y ? Bo(ie, y.classes) : ie,
        ...h ? h.props.inputProps : {}
      },
      ...(C && E || u) && W === "outlined" ? {
        notched: !0
      } : {},
      ref: re,
      className: xe(ce.props.className, l, G.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!h && {
        variant: W
      },
      ...L
    })
  });
});
process.env.NODE_ENV !== "production" && (fc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: o.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: o.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: o.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: o.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: o.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: o.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: o.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: o.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: o.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: o.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: o.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: o.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: o.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: o.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: o.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: o.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: o.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: o.oneOfType([o.oneOf([""]), o.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
fc.muiName = "Select";
function cE(e) {
  return Pt("MuiSkeleton", e);
}
Et("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const uE = (e) => {
  const {
    classes: t,
    variant: n,
    animation: r,
    hasChildren: i,
    width: s,
    height: a
  } = e;
  return Ot({
    root: ["root", n, r, i && "withChildren", i && !s && "fitContent", i && !a && "heightAuto"]
  }, cE, t);
}, W0 = si`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`, G0 = si`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`, dE = typeof W0 != "string" ? ki`
        animation: ${W0} 2s ease-in-out 0.5s infinite;
      ` : null, pE = typeof G0 != "string" ? ki`
        &::after {
          animation: ${G0} 2s linear 0.5s infinite;
        }
      ` : null, fE = Z("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.animation !== !1 && t[n.animation], n.hasChildren && t.withChildren, n.hasChildren && !n.width && t.fitContent, n.hasChildren && !n.height && t.heightAuto];
  }
})(mt(({
  theme: e
}) => {
  const t = L9(e.shape.borderRadius) || "px", n = A9(e.shape.borderRadius);
  return {
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : At(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em",
    variants: [{
      props: {
        variant: "text"
      },
      style: {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${n}${t}/${Math.round(n / 0.6 * 10) / 10}${t}`,
        "&:empty:before": {
          content: '"\\00a0"'
        }
      }
    }, {
      props: {
        variant: "circular"
      },
      style: {
        borderRadius: "50%"
      }
    }, {
      props: {
        variant: "rounded"
      },
      style: {
        borderRadius: (e.vars || e).shape.borderRadius
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren,
      style: {
        "& > *": {
          visibility: "hidden"
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren && !r.width,
      style: {
        maxWidth: "fit-content"
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren && !r.height,
      style: {
        height: "auto"
      }
    }, {
      props: {
        animation: "pulse"
      },
      style: dE || {
        animation: `${W0} 2s ease-in-out 0.5s infinite`
      }
    }, {
      props: {
        animation: "wave"
      },
      style: {
        position: "relative",
        overflow: "hidden",
        /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
        WebkitMaskImage: "-webkit-radial-gradient(white, black)",
        "&::after": {
          background: `linear-gradient(
                90deg,
                transparent,
                ${(e.vars || e).palette.action.hover},
                transparent
              )`,
          content: '""',
          position: "absolute",
          transform: "translateX(-100%)",
          bottom: 0,
          left: 0,
          right: 0,
          top: 0
        }
      }
    }, {
      props: {
        animation: "wave"
      },
      style: pE || {
        "&::after": {
          animation: `${G0} 2s linear 0.5s infinite`
        }
      }
    }]
  };
})), Tg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: i = "pulse",
    className: s,
    component: a = "span",
    height: l,
    style: c,
    variant: u = "text",
    width: f,
    ...g
  } = r, h = {
    ...r,
    animation: i,
    component: a,
    variant: u,
    hasChildren: !!g.children
  }, y = uE(h);
  return /* @__PURE__ */ p.jsx(fE, {
    as: a,
    ref: n,
    className: xe(y.root, s),
    ownerState: h,
    ...g,
    style: {
      width: f,
      height: l,
      ...c
    }
  });
});
process.env.NODE_ENV !== "production" && (Tg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: o.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: o.oneOfType([o.oneOf(["circular", "rectangular", "rounded", "text"]), o.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: o.oneOfType([o.number, o.string])
});
function gE(e, t, n = (r, i) => r === i) {
  return e.length === t.length && e.every((r, i) => n(r, t[i]));
}
const mE = 2;
function ta(e, t, n, r, i) {
  return n === 1 ? Math.min(e + t, i) : Math.max(e - t, r);
}
function Mg(e, t) {
  return e - t;
}
function V3(e, t) {
  const {
    index: n
  } = e.reduce((r, i, s) => {
    const a = Math.abs(t - i);
    return r === null || a < r.distance || a === r.distance ? {
      distance: a,
      index: s
    } : r;
  }, null) ?? {};
  return n;
}
function nu(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const n = e;
    for (let r = 0; r < n.changedTouches.length; r += 1) {
      const i = n.changedTouches[r];
      if (i.identifier === t.current)
        return {
          x: i.clientX,
          y: i.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function Uu(e, t, n) {
  return (e - t) * 100 / (n - t);
}
function hE(e, t, n) {
  return (n - t) * e + t;
}
function vE(e) {
  if (Math.abs(e) < 1) {
    const n = e.toExponential().split("e-"), r = n[0].split(".")[1];
    return (r ? r.length : 0) + parseInt(n[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function yE(e, t, n) {
  const r = Math.round((e - n) / t) * t + n;
  return Number(r.toFixed(vE(t)));
}
function $3({
  values: e,
  newValue: t,
  index: n
}) {
  const r = e.slice();
  return r[n] = t, r.sort(Mg);
}
function ou({
  sliderRef: e,
  activeIndex: t,
  setActive: n
}) {
  var i, s, a;
  const r = Co(e.current);
  (!((i = e.current) != null && i.contains(r.activeElement)) || Number((s = r == null ? void 0 : r.activeElement) == null ? void 0 : s.getAttribute("data-index")) !== t) && ((a = e.current) == null || a.querySelector(`[type="range"][data-index="${t}"]`).focus()), n && n(t);
}
function ru(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? gE(e, t) : !1;
}
const bE = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, CE = (e) => e;
let iu;
function L3() {
  return iu === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? iu = CSS.supports("touch-action", "none") : iu = !0), iu;
}
function xE(e) {
  const {
    "aria-labelledby": t,
    defaultValue: n,
    disabled: r = !1,
    disableSwap: i = !1,
    isRtl: s = !1,
    marks: a = !1,
    max: l = 100,
    min: c = 0,
    name: u,
    onChange: f,
    onChangeCommitted: g,
    orientation: h = "horizontal",
    rootRef: y,
    scale: v = CE,
    step: m = 1,
    shiftStep: b = 10,
    tabIndex: C,
    value: E
  } = e, S = d.useRef(void 0), [k, T] = d.useState(-1), [P, F] = d.useState(-1), [j, L] = d.useState(!1), R = d.useRef(0), V = d.useRef(null), [B, W] = Xr({
    controlled: E,
    default: n ?? c,
    name: "Slider"
  }), z = f && ((ke, Ne, We) => {
    const Ge = ke.nativeEvent || ke, Qe = new Ge.constructor(Ge.type, Ge);
    Object.defineProperty(Qe, "target", {
      writable: !0,
      value: {
        value: Ne,
        name: u
      }
    }), V.current = Ne, f(Qe, Ne, We);
  }), G = Array.isArray(B);
  let H = G ? B.slice().sort(Mg) : [B];
  H = H.map((ke) => ke == null ? c : Ss(ke, c, l));
  const ie = a === !0 && m !== null ? [...Array(Math.floor((l - c) / m) + 1)].map((ke, Ne) => ({
    value: c + m * Ne
  })) : a || [], ce = ie.map((ke) => ke.value), [re, A] = d.useState(-1), Y = d.useRef(null), pe = lo(y, Y), Ce = (ke) => (Ne) => {
    var Ge;
    const We = Number(Ne.currentTarget.getAttribute("data-index"));
    is(Ne.target) && A(We), F(We), (Ge = ke == null ? void 0 : ke.onFocus) == null || Ge.call(ke, Ne);
  }, fe = (ke) => (Ne) => {
    var We;
    is(Ne.target) || A(-1), F(-1), (We = ke == null ? void 0 : ke.onBlur) == null || We.call(ke, Ne);
  }, ee = (ke, Ne) => {
    const We = Number(ke.currentTarget.getAttribute("data-index")), Ge = H[We], Qe = ce.indexOf(Ge);
    let Ve = Ne;
    if (ie && m == null) {
      const Ke = ce[ce.length - 1];
      Ve >= Ke ? Ve = Ke : Ve <= ce[0] ? Ve = ce[0] : Ve = Ve < Ge ? ce[Qe - 1] : ce[Qe + 1];
    }
    if (Ve = Ss(Ve, c, l), G) {
      i && (Ve = Ss(Ve, H[We - 1] || -1 / 0, H[We + 1] || 1 / 0));
      const Ke = Ve;
      Ve = $3({
        values: H,
        newValue: Ve,
        index: We
      });
      let bt = We;
      i || (bt = Ve.indexOf(Ke)), ou({
        sliderRef: Y,
        activeIndex: bt
      });
    }
    W(Ve), A(We), z && !ru(Ve, B) && z(ke, Ve, We), g && g(ke, V.current ?? Ve);
  }, te = (ke) => (Ne) => {
    var We;
    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "PageUp", "PageDown", "Home", "End"].includes(Ne.key)) {
      Ne.preventDefault();
      const Ge = Number(Ne.currentTarget.getAttribute("data-index")), Qe = H[Ge];
      let Ve = null;
      if (m != null) {
        const Ke = Ne.shiftKey ? b : m;
        switch (Ne.key) {
          case "ArrowUp":
            Ve = ta(Qe, Ke, 1, c, l);
            break;
          case "ArrowRight":
            Ve = ta(Qe, Ke, s ? -1 : 1, c, l);
            break;
          case "ArrowDown":
            Ve = ta(Qe, Ke, -1, c, l);
            break;
          case "ArrowLeft":
            Ve = ta(Qe, Ke, s ? 1 : -1, c, l);
            break;
          case "PageUp":
            Ve = ta(Qe, b, 1, c, l);
            break;
          case "PageDown":
            Ve = ta(Qe, b, -1, c, l);
            break;
          case "Home":
            Ve = c;
            break;
          case "End":
            Ve = l;
            break;
        }
      } else if (ie) {
        const Ke = ce[ce.length - 1], bt = ce.indexOf(Qe), vt = [s ? "ArrowRight" : "ArrowLeft", "ArrowDown", "PageDown", "Home"], tn = [s ? "ArrowLeft" : "ArrowRight", "ArrowUp", "PageUp", "End"];
        vt.includes(Ne.key) ? bt === 0 ? Ve = ce[0] : Ve = ce[bt - 1] : tn.includes(Ne.key) && (bt === ce.length - 1 ? Ve = Ke : Ve = ce[bt + 1]);
      }
      Ve != null && ee(Ne, Ve);
    }
    (We = ke == null ? void 0 : ke.onKeyDown) == null || We.call(ke, Ne);
  };
  Zo(() => {
    var ke;
    r && Y.current.contains(document.activeElement) && ((ke = document.activeElement) == null || ke.blur());
  }, [r]), r && k !== -1 && T(-1), r && re !== -1 && A(-1);
  const ue = (ke) => (Ne) => {
    var We;
    (We = ke.onChange) == null || We.call(ke, Ne), ee(Ne, Ne.target.valueAsNumber);
  }, K = d.useRef(void 0);
  let oe = h;
  s && h === "horizontal" && (oe += "-reverse");
  const de = ({
    finger: ke,
    move: Ne = !1
  }) => {
    const {
      current: We
    } = Y, {
      width: Ge,
      height: Qe,
      bottom: Ve,
      left: Ke
    } = We.getBoundingClientRect();
    let bt;
    oe.startsWith("vertical") ? bt = (Ve - ke.y) / Qe : bt = (ke.x - Ke) / Ge, oe.includes("-reverse") && (bt = 1 - bt);
    let vt;
    if (vt = hE(bt, c, l), m)
      vt = yE(vt, m, c);
    else {
      const hn = V3(ce, vt);
      vt = ce[hn];
    }
    vt = Ss(vt, c, l);
    let tn = 0;
    if (G) {
      Ne ? tn = K.current : tn = V3(H, vt), i && (vt = Ss(vt, H[tn - 1] || -1 / 0, H[tn + 1] || 1 / 0));
      const hn = vt;
      vt = $3({
        values: H,
        newValue: vt,
        index: tn
      }), i && Ne || (tn = vt.indexOf(hn), K.current = tn);
    }
    return {
      newValue: vt,
      activeIndex: tn
    };
  }, ve = Eo((ke) => {
    const Ne = nu(ke, S);
    if (!Ne)
      return;
    if (R.current += 1, ke.type === "mousemove" && ke.buttons === 0) {
      J(ke);
      return;
    }
    const {
      newValue: We,
      activeIndex: Ge
    } = de({
      finger: Ne,
      move: !0
    });
    ou({
      sliderRef: Y,
      activeIndex: Ge,
      setActive: T
    }), W(We), !j && R.current > mE && L(!0), z && !ru(We, B) && z(ke, We, Ge);
  }), J = Eo((ke) => {
    const Ne = nu(ke, S);
    if (L(!1), !Ne)
      return;
    const {
      newValue: We
    } = de({
      finger: Ne,
      move: !0
    });
    T(-1), ke.type === "touchend" && F(-1), g && g(ke, V.current ?? We), S.current = void 0, ge();
  }), se = Eo((ke) => {
    if (r)
      return;
    L3() || ke.preventDefault();
    const Ne = ke.changedTouches[0];
    Ne != null && (S.current = Ne.identifier);
    const We = nu(ke, S);
    if (We !== !1) {
      const {
        newValue: Qe,
        activeIndex: Ve
      } = de({
        finger: We
      });
      ou({
        sliderRef: Y,
        activeIndex: Ve,
        setActive: T
      }), W(Qe), z && !ru(Qe, B) && z(ke, Qe, Ve);
    }
    R.current = 0;
    const Ge = Co(Y.current);
    Ge.addEventListener("touchmove", ve, {
      passive: !0
    }), Ge.addEventListener("touchend", J, {
      passive: !0
    });
  }), ge = d.useCallback(() => {
    const ke = Co(Y.current);
    ke.removeEventListener("mousemove", ve), ke.removeEventListener("mouseup", J), ke.removeEventListener("touchmove", ve), ke.removeEventListener("touchend", J);
  }, [J, ve]);
  d.useEffect(() => {
    const {
      current: ke
    } = Y;
    return ke.addEventListener("touchstart", se, {
      passive: L3()
    }), () => {
      ke.removeEventListener("touchstart", se), ge();
    };
  }, [ge, se]), d.useEffect(() => {
    r && ge();
  }, [r, ge]);
  const Se = (ke) => (Ne) => {
    var Qe;
    if ((Qe = ke.onMouseDown) == null || Qe.call(ke, Ne), r || Ne.defaultPrevented || Ne.button !== 0)
      return;
    Ne.preventDefault();
    const We = nu(Ne, S);
    if (We !== !1) {
      const {
        newValue: Ve,
        activeIndex: Ke
      } = de({
        finger: We
      });
      ou({
        sliderRef: Y,
        activeIndex: Ke,
        setActive: T
      }), W(Ve), z && !ru(Ve, B) && z(Ne, Ve, Ke);
    }
    R.current = 0;
    const Ge = Co(Y.current);
    Ge.addEventListener("mousemove", ve, {
      passive: !0
    }), Ge.addEventListener("mouseup", J);
  }, we = Uu(G ? H[0] : c, c, l), me = Uu(H[H.length - 1], c, l) - we, ye = (ke = {}) => {
    const Ne = Tl(ke), We = {
      onMouseDown: Se(Ne || {})
    }, Ge = {
      ...Ne,
      ...We
    };
    return {
      ...ke,
      ref: pe,
      ...Ge
    };
  }, Ie = (ke) => (Ne) => {
    var Ge;
    (Ge = ke.onMouseOver) == null || Ge.call(ke, Ne);
    const We = Number(Ne.currentTarget.getAttribute("data-index"));
    F(We);
  }, je = (ke) => (Ne) => {
    var We;
    (We = ke.onMouseLeave) == null || We.call(ke, Ne), F(-1);
  }, Te = (ke = {}) => {
    const Ne = Tl(ke), We = {
      onMouseOver: Ie(Ne || {}),
      onMouseLeave: je(Ne || {})
    };
    return {
      ...ke,
      ...Ne,
      ...We
    };
  }, Fe = (ke) => ({
    // So the non active thumb doesn't show its label on hover.
    pointerEvents: k !== -1 && k !== ke ? "none" : void 0
  });
  let gt;
  return h === "vertical" && (gt = s ? "vertical-rl" : "vertical-lr"), {
    active: k,
    axis: oe,
    axisProps: bE,
    dragging: j,
    focusedThumbIndex: re,
    getHiddenInputProps: (ke = {}) => {
      const Ne = Tl(ke), We = {
        onChange: ue(Ne || {}),
        onFocus: Ce(Ne || {}),
        onBlur: fe(Ne || {}),
        onKeyDown: te(Ne || {})
      }, Ge = {
        ...Ne,
        ...We
      };
      return {
        tabIndex: C,
        "aria-labelledby": t,
        "aria-orientation": h,
        "aria-valuemax": v(l),
        "aria-valuemin": v(c),
        name: u,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : e.step ?? void 0,
        disabled: r,
        ...ke,
        ...Ge,
        style: {
          ...v4,
          direction: s ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%",
          writingMode: gt
        }
      };
    },
    getRootProps: ye,
    getThumbProps: Te,
    marks: ie,
    open: P,
    range: G,
    rootRef: pe,
    trackLeap: me,
    trackOffset: we,
    values: H,
    getThumbStyle: Fe
  };
}
const wE = (e) => !e || !Ti(e);
function SE(e) {
  return Pt("MuiSlider", e);
}
const wr = Et("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), EE = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: xe(t && wr.valueLabelOpen),
    circle: wr.valueLabelCircle,
    label: wr.valueLabelLabel
  };
};
function kg(e) {
  const {
    children: t,
    className: n,
    value: r
  } = e, i = EE(e);
  return t ? /* @__PURE__ */ d.cloneElement(t, {
    className: xe(t.props.className)
  }, /* @__PURE__ */ p.jsxs(d.Fragment, {
    children: [t.props.children, /* @__PURE__ */ p.jsx("span", {
      className: xe(i.offset, n),
      "aria-hidden": !0,
      children: /* @__PURE__ */ p.jsx("span", {
        className: i.circle,
        children: /* @__PURE__ */ p.jsx("span", {
          className: i.label,
          children: r
        })
      })
    })]
  })) : null;
}
process.env.NODE_ENV !== "production" && (kg.propTypes = {
  children: o.element.isRequired,
  className: o.string,
  value: o.node
});
function A3(e) {
  return e;
}
const RE = Z("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${be(n.color)}`], n.size !== "medium" && t[`size${be(n.size)}`], n.marked && t.marked, n.orientation === "vertical" && t.vertical, n.track === "inverted" && t.trackInverted, n.track === !1 && t.trackFalse];
  }
})(mt(({
  theme: e
}) => ({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  WebkitTapHighlightColor: "transparent",
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${wr.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${wr.dragging}`]: {
    [`& .${wr.thumb}, & .${wr.track}`]: {
      transition: "none"
    }
  },
  variants: [...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: 4,
      width: "100%",
      padding: "13px 0",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "20px 0"
      }
    }
  }, {
    props: {
      orientation: "horizontal",
      size: "small"
    },
    style: {
      height: 2
    }
  }, {
    props: {
      orientation: "horizontal",
      marked: !0
    },
    style: {
      marginBottom: 20
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: 4,
      padding: "0 13px",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "0 20px"
      }
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      width: 2
    }
  }, {
    props: {
      orientation: "vertical",
      marked: !0
    },
    style: {
      marginRight: 44
    }
  }]
}))), TE = Z("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), ME = Z("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(mt(({
  theme: e
}) => ({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  border: "1px solid currentColor",
  backgroundColor: "currentColor",
  transition: e.transitions.create(["left", "width", "bottom", "height"], {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      size: "small"
    },
    style: {
      border: "none"
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: !1
    },
    style: {
      display: "none"
    }
  }, ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t,
      track: "inverted"
    },
    style: {
      ...e.vars ? {
        backgroundColor: e.vars.palette.Slider[`${t}Track`],
        borderColor: e.vars.palette.Slider[`${t}Track`]
      } : {
        backgroundColor: Oi(e.palette[t].main, 0.62),
        borderColor: Oi(e.palette[t].main, 0.62),
        ...e.applyStyles("dark", {
          backgroundColor: Ii(e.palette[t].main, 0.5)
        }),
        ...e.applyStyles("dark", {
          borderColor: Ii(e.palette[t].main, 0.5)
        })
      }
    }
  }))]
}))), kE = Z("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.thumb, t[`thumbColor${be(n.color)}`], n.size !== "medium" && t[`thumbSize${be(n.size)}`]];
  }
})(mt(({
  theme: e
}) => ({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  }),
  "&::before": {
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  },
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&.${wr.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      width: 12,
      height: 12,
      "&::before": {
        boxShadow: "none"
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-50%, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 50%)"
    }
  }, ...Object.entries(e.palette).filter(Mn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&:hover, &.${wr.focusVisible}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${e.vars.palette[t].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${At(e.palette[t].main, 0.16)}`
        },
        "@media (hover: none)": {
          boxShadow: "none"
        }
      },
      [`&.${wr.active}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${e.vars.palette[t].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${At(e.palette[t].main, 0.16)}`
        }
      }
    }
  }))]
}))), Pg = Z(kg, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})(mt(({
  theme: e
}) => ({
  zIndex: 1,
  whiteSpace: "nowrap",
  ...e.typography.body2,
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${wr.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${wr.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
})));
process.env.NODE_ENV !== "production" && (Pg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: o.element.isRequired,
  /**
   * @ignore
   */
  index: o.number.isRequired,
  /**
   * @ignore
   */
  open: o.bool.isRequired,
  /**
   * @ignore
   */
  value: o.node
});
const PE = Z("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => sc(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: n
    } = e;
    return [t.mark, n && t.markActive];
  }
})(mt(({
  theme: e
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.background.paper,
      opacity: 0.8
    }
  }]
}))), IE = Z("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => sc(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})(mt(({
  theme: e
}) => ({
  ...e.typography.body2,
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }]
}))), OE = (e) => {
  const {
    disabled: t,
    dragging: n,
    marked: r,
    orientation: i,
    track: s,
    classes: a,
    color: l,
    size: c
  } = e, u = {
    root: ["root", t && "disabled", n && "dragging", r && "marked", i === "vertical" && "vertical", s === "inverted" && "trackInverted", s === !1 && "trackFalse", l && `color${be(l)}`, c && `size${be(c)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", c && `thumbSize${be(c)}`, l && `thumbColor${be(l)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return Ot(u, SE, a);
}, DE = ({
  children: e
}) => e, Ig = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiSlider"
  }), i = Io(), {
    "aria-label": s,
    "aria-valuetext": a,
    "aria-labelledby": l,
    // eslint-disable-next-line react/prop-types
    component: c = "span",
    components: u = {},
    componentsProps: f = {},
    color: g = "primary",
    classes: h,
    className: y,
    disableSwap: v = !1,
    disabled: m = !1,
    getAriaLabel: b,
    getAriaValueText: C,
    marks: E = !1,
    max: S = 100,
    min: k = 0,
    name: T,
    onChange: P,
    onChangeCommitted: F,
    orientation: j = "horizontal",
    shiftStep: L = 10,
    size: R = "medium",
    step: V = 1,
    scale: B = A3,
    slotProps: W,
    slots: z,
    tabIndex: G,
    track: H = "normal",
    value: ie,
    valueLabelDisplay: ce = "off",
    valueLabelFormat: re = A3,
    ...A
  } = r, Y = {
    ...r,
    isRtl: i,
    max: S,
    min: k,
    classes: h,
    disabled: m,
    disableSwap: v,
    orientation: j,
    marks: E,
    color: g,
    size: R,
    step: V,
    shiftStep: L,
    scale: B,
    track: H,
    valueLabelDisplay: ce,
    valueLabelFormat: re
  }, {
    axisProps: pe,
    getRootProps: Ce,
    getHiddenInputProps: fe,
    getThumbProps: ee,
    open: te,
    active: ue,
    axis: K,
    focusedThumbIndex: oe,
    range: de,
    dragging: ve,
    marks: J,
    values: se,
    trackOffset: ge,
    trackLeap: Se,
    getThumbStyle: we
  } = xE({
    ...Y,
    rootRef: n
  });
  Y.marked = J.length > 0 && J.some((jt) => jt.label), Y.dragging = ve, Y.focusedThumbIndex = oe;
  const me = OE(Y), ye = (z == null ? void 0 : z.root) ?? u.Root ?? RE, Ie = (z == null ? void 0 : z.rail) ?? u.Rail ?? TE, je = (z == null ? void 0 : z.track) ?? u.Track ?? ME, Te = (z == null ? void 0 : z.thumb) ?? u.Thumb ?? kE, Fe = (z == null ? void 0 : z.valueLabel) ?? u.ValueLabel ?? Pg, gt = (z == null ? void 0 : z.mark) ?? u.Mark ?? PE, Dt = (z == null ? void 0 : z.markLabel) ?? u.MarkLabel ?? IE, ke = (z == null ? void 0 : z.input) ?? u.Input ?? "input", Ne = (W == null ? void 0 : W.root) ?? f.root, We = (W == null ? void 0 : W.rail) ?? f.rail, Ge = (W == null ? void 0 : W.track) ?? f.track, Qe = (W == null ? void 0 : W.thumb) ?? f.thumb, Ve = (W == null ? void 0 : W.valueLabel) ?? f.valueLabel, Ke = (W == null ? void 0 : W.mark) ?? f.mark, bt = (W == null ? void 0 : W.markLabel) ?? f.markLabel, vt = (W == null ? void 0 : W.input) ?? f.input, tn = Yo({
    elementType: ye,
    getSlotProps: Ce,
    externalSlotProps: Ne,
    externalForwardedProps: A,
    additionalProps: {
      ...wE(ye) && {
        as: c
      }
    },
    ownerState: {
      ...Y,
      ...Ne == null ? void 0 : Ne.ownerState
    },
    className: [me.root, y]
  }), hn = Yo({
    elementType: Ie,
    externalSlotProps: We,
    ownerState: Y,
    className: me.rail
  }), Je = Yo({
    elementType: je,
    externalSlotProps: Ge,
    additionalProps: {
      style: {
        ...pe[K].offset(ge),
        ...pe[K].leap(Se)
      }
    },
    ownerState: {
      ...Y,
      ...Ge == null ? void 0 : Ge.ownerState
    },
    className: me.track
  }), $t = Yo({
    elementType: Te,
    getSlotProps: ee,
    externalSlotProps: Qe,
    ownerState: {
      ...Y,
      ...Qe == null ? void 0 : Qe.ownerState
    },
    className: me.thumb
  }), nn = Yo({
    elementType: Fe,
    externalSlotProps: Ve,
    ownerState: {
      ...Y,
      ...Ve == null ? void 0 : Ve.ownerState
    },
    className: me.valueLabel
  }), Nt = Yo({
    elementType: gt,
    externalSlotProps: Ke,
    ownerState: Y,
    className: me.mark
  }), cn = Yo({
    elementType: Dt,
    externalSlotProps: bt,
    ownerState: Y,
    className: me.markLabel
  }), Lt = Yo({
    elementType: ke,
    getSlotProps: fe,
    externalSlotProps: vt,
    ownerState: Y
  });
  return /* @__PURE__ */ p.jsxs(ye, {
    ...tn,
    children: [/* @__PURE__ */ p.jsx(Ie, {
      ...hn
    }), /* @__PURE__ */ p.jsx(je, {
      ...Je
    }), J.filter((jt) => jt.value >= k && jt.value <= S).map((jt, un) => {
      const On = Uu(jt.value, k, S), Un = pe[K].offset(On);
      let ro;
      return H === !1 ? ro = se.includes(jt.value) : ro = H === "normal" && (de ? jt.value >= se[0] && jt.value <= se[se.length - 1] : jt.value <= se[0]) || H === "inverted" && (de ? jt.value <= se[0] || jt.value >= se[se.length - 1] : jt.value >= se[0]), /* @__PURE__ */ p.jsxs(d.Fragment, {
        children: [/* @__PURE__ */ p.jsx(gt, {
          "data-index": un,
          ...Nt,
          ...!Ti(gt) && {
            markActive: ro
          },
          style: {
            ...Un,
            ...Nt.style
          },
          className: xe(Nt.className, ro && me.markActive)
        }), jt.label != null ? /* @__PURE__ */ p.jsx(Dt, {
          "aria-hidden": !0,
          "data-index": un,
          ...cn,
          ...!Ti(Dt) && {
            markLabelActive: ro
          },
          style: {
            ...Un,
            ...cn.style
          },
          className: xe(me.markLabel, cn.className, ro && me.markLabelActive),
          children: jt.label
        }) : null]
      }, un);
    }), se.map((jt, un) => {
      const On = Uu(jt, k, S), Un = pe[K].offset(On), ro = ce === "off" ? DE : Fe;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ p.jsx(ro, {
          ...!Ti(ro) && {
            valueLabelFormat: re,
            valueLabelDisplay: ce,
            value: typeof re == "function" ? re(B(jt), un) : re,
            index: un,
            open: te === un || ue === un || ce === "on",
            disabled: m
          },
          ...nn,
          children: /* @__PURE__ */ p.jsx(Te, {
            "data-index": un,
            ...$t,
            className: xe(me.thumb, $t.className, ue === un && me.active, oe === un && me.focusVisible),
            style: {
              ...Un,
              ...we(un),
              ...$t.style
            },
            children: /* @__PURE__ */ p.jsx(ke, {
              "data-index": un,
              "aria-label": b ? b(un) : s,
              "aria-valuenow": B(jt),
              "aria-labelledby": l,
              "aria-valuetext": C ? C(B(jt), un) : a,
              value: se[un],
              ...Lt
            })
          })
        }, un)
      );
    })]
  });
});
process.env.NODE_ENV !== "production" && (Ig.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The label of the slider.
   */
  "aria-label": nr(o.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": o.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": nr(o.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Mark: o.elementType,
    MarkLabel: o.elementType,
    Rail: o.elementType,
    Root: o.elementType,
    Thumb: o.elementType,
    Track: o.elementType,
    ValueLabel: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    input: o.oneOfType([o.func, o.object]),
    mark: o.oneOfType([o.func, o.object]),
    markLabel: o.oneOfType([o.func, o.object]),
    rail: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object]),
    thumb: o.oneOfType([o.func, o.object]),
    track: o.oneOfType([o.func, o.object]),
    valueLabel: o.oneOfType([o.func, o.shape({
      children: o.element,
      className: o.string,
      open: o.bool,
      style: o.object,
      value: o.node,
      valueLabelDisplay: o.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.oneOfType([o.arrayOf(o.number), o.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: o.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: o.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: o.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: o.oneOfType([o.arrayOf(o.shape({
    label: o.node,
    value: o.number.isRequired
  })), o.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: o.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: o.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: o.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: o.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: o.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: o.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: o.func,
  /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */
  shiftStep: o.number,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium"]), o.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: o.shape({
    input: o.oneOfType([o.func, o.object]),
    mark: o.oneOfType([o.func, o.object]),
    markLabel: o.oneOfType([o.func, o.object]),
    rail: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object]),
    thumb: o.oneOfType([o.func, o.object]),
    track: o.oneOfType([o.func, o.object]),
    valueLabel: o.oneOfType([o.func, o.shape({
      children: o.element,
      className: o.string,
      open: o.bool,
      style: o.object,
      value: o.node,
      valueLabelDisplay: o.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    mark: o.elementType,
    markLabel: o.elementType,
    rail: o.elementType,
    root: o.elementType,
    thumb: o.elementType,
    track: o.elementType,
    valueLabel: o.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: o.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: o.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: o.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: o.oneOfType([o.arrayOf(o.number), o.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: o.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: o.oneOfType([o.func, o.string])
});
function jE(e) {
  return Pt("MuiTooltip", e);
}
const so = Et("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function FE(e) {
  return Math.round(e * 1e5) / 1e5;
}
const VE = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: r,
    touch: i,
    placement: s
  } = e, a = {
    popper: ["popper", !n && "popperInteractive", r && "popperArrow"],
    tooltip: ["tooltip", r && "tooltipArrow", i && "touch", `tooltipPlacement${be(s.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Ot(a, jE, t);
}, $E = Z(us, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(mt(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: t
    }) => !t,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${so.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${so.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${so.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${so.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${so.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${so.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${so.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${so.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), LE = Z("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${be(n.placement.split("-")[0])}`]];
  }
})(mt(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : At(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${so.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${so.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${so.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${so.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${FE(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl,
    style: {
      [`.${so.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${so.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl && t.touch,
    style: {
      [`.${so.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${so.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl,
    style: {
      [`.${so.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${so.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl && t.touch,
    style: {
      [`.${so.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${so.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${so.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${so.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), AE = Z("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(mt(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : At(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let su = !1;
const N3 = new xd();
let nl = {
  x: 0,
  y: 0
};
function au(e, t) {
  return (n, ...r) => {
    t && t(n, ...r), e(n, ...r);
  };
}
const _r = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: i = !1,
    children: s,
    classes: a,
    components: l = {},
    componentsProps: c = {},
    describeChild: u = !1,
    disableFocusListener: f = !1,
    disableHoverListener: g = !1,
    disableInteractive: h = !1,
    disableTouchListener: y = !1,
    enterDelay: v = 100,
    enterNextDelay: m = 0,
    enterTouchDelay: b = 700,
    followCursor: C = !1,
    id: E,
    leaveDelay: S = 0,
    leaveTouchDelay: k = 1500,
    onClose: T,
    onOpen: P,
    open: F,
    placement: j = "bottom",
    PopperComponent: L,
    PopperProps: R = {},
    slotProps: V = {},
    slots: B = {},
    title: W,
    TransitionComponent: z,
    TransitionProps: G,
    ...H
  } = r, ie = /* @__PURE__ */ d.isValidElement(s) ? s : /* @__PURE__ */ p.jsx("span", {
    children: s
  }), ce = to(), re = Io(), [A, Y] = d.useState(), [pe, Ce] = d.useState(null), fe = d.useRef(!1), ee = h || C, te = Ts(), ue = Ts(), K = Ts(), oe = Ts(), [de, ve] = Xr({
    controlled: F,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let J = de;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: Ft
    } = d.useRef(F !== void 0);
    d.useEffect(() => {
      A && A.disabled && !Ft && W !== "" && A.tagName.toLowerCase() === "button" && console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [W, A, Ft]);
  }
  const se = ai(E), ge = d.useRef(), Se = Eo(() => {
    ge.current !== void 0 && (document.body.style.WebkitUserSelect = ge.current, ge.current = void 0), oe.clear();
  });
  d.useEffect(() => Se, [Se]);
  const we = (Ft) => {
    N3.clear(), su = !0, ve(!0), P && !J && P(Ft);
  }, me = Eo(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Ft) => {
      N3.start(800 + S, () => {
        su = !1;
      }), ve(!1), T && J && T(Ft), te.start(ce.transitions.duration.shortest, () => {
        fe.current = !1;
      });
    }
  ), ye = (Ft) => {
    fe.current && Ft.type !== "touchstart" || (A && A.removeAttribute("title"), ue.clear(), K.clear(), v || su && m ? ue.start(su ? m : v, () => {
      we(Ft);
    }) : we(Ft));
  }, Ie = (Ft) => {
    ue.clear(), K.start(S, () => {
      me(Ft);
    });
  }, [, je] = d.useState(!1), Te = (Ft) => {
    is(Ft.target) || (je(!1), Ie(Ft));
  }, Fe = (Ft) => {
    A || Y(Ft.currentTarget), is(Ft.target) && (je(!0), ye(Ft));
  }, gt = (Ft) => {
    fe.current = !0;
    const Yn = ie.props;
    Yn.onTouchStart && Yn.onTouchStart(Ft);
  }, Dt = (Ft) => {
    gt(Ft), K.clear(), te.clear(), Se(), ge.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", oe.start(b, () => {
      document.body.style.WebkitUserSelect = ge.current, ye(Ft);
    });
  }, ke = (Ft) => {
    ie.props.onTouchEnd && ie.props.onTouchEnd(Ft), Se(), K.start(k, () => {
      me(Ft);
    });
  };
  d.useEffect(() => {
    if (!J)
      return;
    function Ft(Yn) {
      Yn.key === "Escape" && me(Yn);
    }
    return document.addEventListener("keydown", Ft), () => {
      document.removeEventListener("keydown", Ft);
    };
  }, [me, J]);
  const Ne = lo(_s(ie), Y, n);
  !W && W !== 0 && (J = !1);
  const We = d.useRef(), Ge = (Ft) => {
    const Yn = ie.props;
    Yn.onMouseMove && Yn.onMouseMove(Ft), nl = {
      x: Ft.clientX,
      y: Ft.clientY
    }, We.current && We.current.update();
  }, Qe = {}, Ve = typeof W == "string";
  u ? (Qe.title = !J && Ve && !g ? W : null, Qe["aria-describedby"] = J ? se : null) : (Qe["aria-label"] = Ve ? W : null, Qe["aria-labelledby"] = J && !Ve ? se : null);
  const Ke = {
    ...Qe,
    ...H,
    ...ie.props,
    className: xe(H.className, ie.props.className),
    onTouchStart: gt,
    ref: Ne,
    ...C ? {
      onMouseMove: Ge
    } : {}
  };
  process.env.NODE_ENV !== "production" && (Ke["data-mui-internal-clone-element"] = !0, d.useEffect(() => {
    A && !A.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [A]));
  const bt = {};
  y || (Ke.onTouchStart = Dt, Ke.onTouchEnd = ke), g || (Ke.onMouseOver = au(ye, Ke.onMouseOver), Ke.onMouseLeave = au(Ie, Ke.onMouseLeave), ee || (bt.onMouseOver = ye, bt.onMouseLeave = Ie)), f || (Ke.onFocus = au(Fe, Ke.onFocus), Ke.onBlur = au(Te, Ke.onBlur), ee || (bt.onFocus = Fe, bt.onBlur = Te)), process.env.NODE_ENV !== "production" && ie.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${ie.props.title}\` or the Tooltip component.`].join(`
`));
  const vt = {
    ...r,
    isRtl: re,
    arrow: i,
    disableInteractive: ee,
    placement: j,
    PopperComponentProp: L,
    touch: fe.current
  }, tn = typeof V.popper == "function" ? V.popper(vt) : V.popper, hn = d.useMemo(() => {
    var Yn, it;
    let Ft = [{
      name: "arrow",
      enabled: !!pe,
      options: {
        element: pe,
        padding: 4
      }
    }];
    return (Yn = R.popperOptions) != null && Yn.modifiers && (Ft = Ft.concat(R.popperOptions.modifiers)), (it = tn == null ? void 0 : tn.popperOptions) != null && it.modifiers && (Ft = Ft.concat(tn.popperOptions.modifiers)), {
      ...R.popperOptions,
      ...tn == null ? void 0 : tn.popperOptions,
      modifiers: Ft
    };
  }, [pe, R.popperOptions, tn == null ? void 0 : tn.popperOptions]), Je = VE(vt), $t = typeof V.transition == "function" ? V.transition(vt) : V.transition, nn = {
    slots: {
      popper: l.Popper,
      transition: l.Transition ?? z,
      tooltip: l.Tooltip,
      arrow: l.Arrow,
      ...B
    },
    slotProps: {
      arrow: V.arrow ?? c.arrow,
      popper: {
        ...R,
        ...tn ?? c.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: V.tooltip ?? c.tooltip,
      transition: {
        ...G,
        ...$t ?? c.transition
      }
    }
  }, [Nt, cn] = kt("popper", {
    elementType: $E,
    externalForwardedProps: nn,
    ownerState: vt,
    className: xe(Je.popper, R == null ? void 0 : R.className)
  }), [Lt, jt] = kt("transition", {
    elementType: ss,
    externalForwardedProps: nn,
    ownerState: vt
  }), [un, On] = kt("tooltip", {
    elementType: LE,
    className: Je.tooltip,
    externalForwardedProps: nn,
    ownerState: vt
  }), [Un, ro] = kt("arrow", {
    elementType: AE,
    className: Je.arrow,
    externalForwardedProps: nn,
    ownerState: vt,
    ref: Ce
  });
  return /* @__PURE__ */ p.jsxs(d.Fragment, {
    children: [/* @__PURE__ */ d.cloneElement(ie, Ke), /* @__PURE__ */ p.jsx(Nt, {
      as: L ?? us,
      placement: j,
      anchorEl: C ? {
        getBoundingClientRect: () => ({
          top: nl.y,
          left: nl.x,
          right: nl.x,
          bottom: nl.y,
          width: 0,
          height: 0
        })
      } : A,
      popperRef: We,
      open: A ? J : !1,
      id: se,
      transition: !0,
      ...bt,
      ...cn,
      popperOptions: hn,
      children: ({
        TransitionProps: Ft
      }) => /* @__PURE__ */ p.jsx(Lt, {
        timeout: ce.transitions.duration.shorter,
        ...Ft,
        ...jt,
        children: /* @__PURE__ */ p.jsxs(un, {
          ...On,
          children: [W, i ? /* @__PURE__ */ p.jsx(Un, {
            ...ro
          }) : null]
        })
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (_r.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: o.bool,
  /**
   * Tooltip reference element.
   */
  children: Bs.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Arrow: o.elementType,
    Popper: o.elementType,
    Tooltip: o.elementType,
    Transition: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    arrow: o.object,
    popper: o.object,
    tooltip: o.object,
    transition: o.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: o.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: o.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: o.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: o.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: o.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: o.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: o.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: o.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: o.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: o.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: o.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: o.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: o.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: o.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: o.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    arrow: o.oneOfType([o.func, o.object]),
    popper: o.oneOfType([o.func, o.object]),
    tooltip: o.oneOfType([o.func, o.object]),
    transition: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    arrow: o.elementType,
    popper: o.elementType,
    tooltip: o.elementType,
    transition: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: o.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: o.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: o.object
});
function NE(e) {
  return Pt("MuiSwitch", e);
}
const Uo = Et("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), BE = (e) => {
  const {
    classes: t,
    edge: n,
    size: r,
    color: i,
    checked: s,
    disabled: a
  } = e, l = {
    root: ["root", n && `edge${be(n)}`, `size${be(r)}`],
    switchBase: ["switchBase", `color${be(i)}`, s && "checked", a && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, c = Ot(l, NE, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...c
  };
}, _E = Z("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.edge && t[`edge${be(n.edge)}`], t[`size${be(n.size)}`]];
  }
})({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${Uo.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${Uo.switchBase}`]: {
        padding: 4,
        [`&.${Uo.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), zE = Z(Pd, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.switchBase, {
      [`& .${Uo.input}`]: t.input
    }, n.color !== "default" && t[`color${be(n.color)}`]];
  }
})(mt(({
  theme: e
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: e.vars ? e.vars.palette.Switch.defaultColor : `${e.palette.mode === "light" ? e.palette.common.white : e.palette.grey[300]}`,
  transition: e.transitions.create(["left", "transform"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Uo.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${Uo.disabled}`]: {
    color: e.vars ? e.vars.palette.Switch.defaultDisabledColor : `${e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]}`
  },
  [`&.${Uo.checked} + .${Uo.track}`]: {
    opacity: 0.5
  },
  [`&.${Uo.disabled} + .${Uo.track}`]: {
    opacity: e.vars ? e.vars.opacity.switchTrackDisabled : `${e.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${Uo.input}`]: {
    left: "-100%",
    width: "300%"
  }
})), mt(({
  theme: e
}) => ({
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(e.palette).filter(Mn(["light"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Uo.checked}`]: {
        color: (e.vars || e).palette[t].main,
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette[t].main, e.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${Uo.disabled}`]: {
          color: e.vars ? e.vars.palette.Switch[`${t}DisabledColor`] : `${e.palette.mode === "light" ? Oi(e.palette[t].main, 0.62) : Ii(e.palette[t].main, 0.55)}`
        }
      },
      [`&.${Uo.checked} + .${Uo.track}`]: {
        backgroundColor: (e.vars || e).palette[t].main
      }
    }
  }))]
}))), HE = Z("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(mt(({
  theme: e
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: e.transitions.create(["opacity", "background-color"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: e.vars ? e.vars.palette.common.onBackground : `${e.palette.mode === "light" ? e.palette.common.black : e.palette.common.white}`,
  opacity: e.vars ? e.vars.opacity.switchTrack : `${e.palette.mode === "light" ? 0.38 : 0.3}`
}))), WE = Z("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(mt(({
  theme: e
}) => ({
  boxShadow: (e.vars || e).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
}))), Og = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiSwitch"
  }), {
    className: i,
    color: s = "primary",
    edge: a = !1,
    size: l = "medium",
    sx: c,
    slots: u = {},
    slotProps: f = {},
    ...g
  } = r, h = {
    ...r,
    color: s,
    edge: a,
    size: l
  }, y = BE(h), v = {
    slots: u,
    slotProps: f
  }, [m, b] = kt("root", {
    className: xe(y.root, i),
    elementType: _E,
    externalForwardedProps: v,
    ownerState: h,
    additionalProps: {
      sx: c
    }
  }), [C, E] = kt("thumb", {
    className: y.thumb,
    elementType: WE,
    externalForwardedProps: v,
    ownerState: h
  }), S = /* @__PURE__ */ p.jsx(C, {
    ...E
  }), [k, T] = kt("track", {
    className: y.track,
    elementType: HE,
    externalForwardedProps: v,
    ownerState: h
  });
  return /* @__PURE__ */ p.jsxs(m, {
    ...b,
    children: [/* @__PURE__ */ p.jsx(zE, {
      type: "checkbox",
      icon: S,
      checkedIcon: S,
      ref: n,
      ownerState: h,
      ...g,
      classes: {
        ...y,
        root: y.switchBase
      },
      slots: {
        ...u.switchBase && {
          root: u.switchBase
        },
        ...u.input && {
          input: u.input
        }
      },
      slotProps: {
        ...f.switchBase && {
          root: typeof f.switchBase == "function" ? f.switchBase(h) : f.switchBase
        },
        ...f.input && {
          input: typeof f.input == "function" ? f.input(h) : f.input
        }
      }
    }), /* @__PURE__ */ p.jsx(k, {
      ...T
    })]
  });
});
process.env.NODE_ENV !== "production" && (Og.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: o.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: o.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: o.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: o.node,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputRef: qo,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: o.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: o.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    input: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object]),
    switchBase: o.oneOfType([o.func, o.object]),
    thumb: o.oneOfType([o.func, o.object]),
    track: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType,
    switchBase: o.elementType,
    thumb: o.elementType,
    track: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: o.any
});
function GE(e) {
  return Pt("MuiTab", e);
}
const gr = Et("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper", "icon"]), UE = (e) => {
  const {
    classes: t,
    textColor: n,
    fullWidth: r,
    wrapped: i,
    icon: s,
    label: a,
    selected: l,
    disabled: c
  } = e, u = {
    root: ["root", s && a && "labelIcon", `textColor${be(n)}`, r && "fullWidth", i && "wrapped", l && "selected", c && "disabled"],
    icon: ["iconWrapper", "icon"]
  };
  return Ot(u, GE, t);
}, YE = Z(Tr, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.label && n.icon && t.labelIcon, t[`textColor${be(n.textColor)}`], n.fullWidth && t.fullWidth, n.wrapped && t.wrapped, {
      [`& .${gr.iconWrapper}`]: t.iconWrapper
    }, {
      [`& .${gr.icon}`]: t.icon
    }];
  }
})(mt(({
  theme: e
}) => ({
  ...e.typography.button,
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center",
  lineHeight: 1.25,
  variants: [{
    props: ({
      ownerState: t
    }) => t.label && (t.iconPosition === "top" || t.iconPosition === "bottom"),
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.label && t.iconPosition !== "top" && t.iconPosition !== "bottom",
    style: {
      flexDirection: "row"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.icon && t.label,
    style: {
      minHeight: 72,
      paddingTop: 9,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "top",
    style: {
      [`& > .${gr.icon}`]: {
        marginBottom: 6
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "bottom",
    style: {
      [`& > .${gr.icon}`]: {
        marginTop: 6
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "start",
    style: {
      [`& > .${gr.icon}`]: {
        marginRight: e.spacing(1)
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "end",
    style: {
      [`& > .${gr.icon}`]: {
        marginLeft: e.spacing(1)
      }
    }
  }, {
    props: {
      textColor: "inherit"
    },
    style: {
      color: "inherit",
      opacity: 0.6,
      // same opacity as theme.palette.text.secondary
      [`&.${gr.selected}`]: {
        opacity: 1
      },
      [`&.${gr.disabled}`]: {
        opacity: (e.vars || e).palette.action.disabledOpacity
      }
    }
  }, {
    props: {
      textColor: "primary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${gr.selected}`]: {
        color: (e.vars || e).palette.primary.main
      },
      [`&.${gr.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: {
      textColor: "secondary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${gr.selected}`]: {
        color: (e.vars || e).palette.secondary.main
      },
      [`&.${gr.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.wrapped,
    style: {
      fontSize: e.typography.pxToRem(12)
    }
  }]
}))), ZE = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiTab"
  }), {
    className: i,
    disabled: s = !1,
    disableFocusRipple: a = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: l,
    icon: c,
    iconPosition: u = "top",
    // eslint-disable-next-line react/prop-types
    indicator: f,
    label: g,
    onChange: h,
    onClick: y,
    onFocus: v,
    // eslint-disable-next-line react/prop-types
    selected: m,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: b,
    // eslint-disable-next-line react/prop-types
    textColor: C = "inherit",
    value: E,
    wrapped: S = !1,
    ...k
  } = r, T = {
    ...r,
    disabled: s,
    disableFocusRipple: a,
    selected: m,
    icon: !!c,
    iconPosition: u,
    label: !!g,
    fullWidth: l,
    textColor: C,
    wrapped: S
  }, P = UE(T), F = c && g && /* @__PURE__ */ d.isValidElement(c) ? /* @__PURE__ */ d.cloneElement(c, {
    className: xe(P.icon, c.props.className)
  }) : c, j = (R) => {
    !m && h && h(R, E), y && y(R);
  }, L = (R) => {
    b && !m && h && h(R, E), v && v(R);
  };
  return /* @__PURE__ */ p.jsxs(YE, {
    focusRipple: !a,
    className: xe(P.root, i),
    ref: n,
    role: "tab",
    "aria-selected": m,
    disabled: s,
    onClick: j,
    onFocus: L,
    ownerState: T,
    tabIndex: m ? 0 : -1,
    ...k,
    children: [u === "top" || u === "start" ? /* @__PURE__ */ p.jsxs(d.Fragment, {
      children: [F, g]
    }) : /* @__PURE__ */ p.jsxs(d.Fragment, {
      children: [g, F]
    }), f]
  });
});
process.env.NODE_ENV !== "production" && (ZE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: g4,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * The icon to display.
   */
  icon: o.oneOfType([o.element, o.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: o.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: o.node,
  /**
   * @ignore
   */
  onChange: o.func,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: o.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: o.bool
});
const qE = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), KE = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function XE(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function QE(e, t, n, r = {}, i = () => {
}) {
  const {
    ease: s = XE,
    duration: a = 300
    // standard
  } = r;
  let l = null;
  const c = t[e];
  let u = !1;
  const f = () => {
    u = !0;
  }, g = (h) => {
    if (u) {
      i(new Error("Animation cancelled"));
      return;
    }
    l === null && (l = h);
    const y = Math.min(1, (h - l) / a);
    if (t[e] = s(y) * (n - c) + c, y >= 1) {
      requestAnimationFrame(() => {
        i(null);
      });
      return;
    }
    requestAnimationFrame(g);
  };
  return c === n ? (i(new Error("Element already at target position")), f) : (requestAnimationFrame(g), f);
}
const JE = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function Dg(e) {
  const {
    onChange: t,
    ...n
  } = e, r = d.useRef(), i = d.useRef(null), s = () => {
    r.current = i.current.offsetHeight - i.current.clientHeight;
  };
  return Zo(() => {
    const a = Cd(() => {
      const c = r.current;
      s(), c !== r.current && t(r.current);
    }), l = Lr(i.current);
    return l.addEventListener("resize", a), () => {
      a.clear(), l.removeEventListener("resize", a);
    };
  }, [t]), d.useEffect(() => {
    s(), t(r.current);
  }, [t]), /* @__PURE__ */ p.jsx("div", {
    style: JE,
    ...n,
    ref: i
  });
}
process.env.NODE_ENV !== "production" && (Dg.propTypes = {
  onChange: o.func.isRequired
});
function eR(e) {
  return Pt("MuiTabScrollButton", e);
}
const tR = Et("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), nR = (e) => {
  const {
    classes: t,
    orientation: n,
    disabled: r
  } = e;
  return Ot({
    root: ["root", n, r && "disabled"]
  }, eR, t);
}, oR = Z(Tr, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.orientation && t[n.orientation]];
  }
})({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${tR.disabled}`]: {
    opacity: 0
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      width: "100%",
      height: 40,
      "& svg": {
        transform: "var(--TabScrollButton-svgRotate)"
      }
    }
  }]
}), jg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: i,
    slots: s = {},
    slotProps: a = {},
    direction: l,
    orientation: c,
    disabled: u,
    ...f
  } = r, g = Io(), h = {
    isRtl: g,
    ...r
  }, y = nR(h), v = s.StartScrollButtonIcon ?? qE, m = s.EndScrollButtonIcon ?? KE, b = Yo({
    elementType: v,
    externalSlotProps: a.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: h
  }), C = Yo({
    elementType: m,
    externalSlotProps: a.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: h
  });
  return /* @__PURE__ */ p.jsx(oR, {
    component: "div",
    className: xe(y.root, i),
    ref: n,
    role: null,
    ownerState: h,
    tabIndex: null,
    ...f,
    style: {
      ...f.style,
      ...c === "vertical" && {
        "--TabScrollButton-svgRotate": `rotate(${g ? -90 : 90}deg)`
      }
    },
    children: l === "left" ? /* @__PURE__ */ p.jsx(v, {
      ...b
    }) : /* @__PURE__ */ p.jsx(m, {
      ...C
    })
  });
});
process.env.NODE_ENV !== "production" && (jg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The direction the button should indicate.
   */
  direction: o.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: o.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: o.shape({
    endScrollButtonIcon: o.oneOfType([o.func, o.object]),
    startScrollButtonIcon: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    EndScrollButtonIcon: o.elementType,
    StartScrollButtonIcon: o.elementType
  }),
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function rR(e) {
  return Pt("MuiTabs", e);
}
const Y1 = Et("MuiTabs", ["root", "vertical", "list", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), B3 = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, _3 = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, lu = (e, t, n) => {
  let r = !1, i = n(e, t);
  for (; i; ) {
    if (i === e.firstChild) {
      if (r)
        return;
      r = !0;
    }
    const s = i.disabled || i.getAttribute("aria-disabled") === "true";
    if (!i.hasAttribute("tabindex") || s)
      i = n(e, i);
    else {
      i.focus();
      return;
    }
  }
}, iR = (e) => {
  const {
    vertical: t,
    fixed: n,
    hideScrollbar: r,
    scrollableX: i,
    scrollableY: s,
    centered: a,
    scrollButtonsHideMobile: l,
    classes: c
  } = e;
  return Ot({
    root: ["root", t && "vertical"],
    scroller: ["scroller", n && "fixed", r && "hideScrollbar", i && "scrollableX", s && "scrollableY"],
    list: ["list", "flexContainer", t && "flexContainerVertical", t && "vertical", a && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", l && "scrollButtonsHideMobile"],
    scrollableX: [i && "scrollableX"],
    hideScrollbar: [r && "hideScrollbar"]
  }, rR, c);
}, sR = Z("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Y1.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${Y1.scrollButtons}`]: n.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, n.vertical && t.vertical];
  }
})(mt(({
  theme: e
}) => ({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex",
  variants: [{
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.scrollButtonsHideMobile,
    style: {
      [`& .${Y1.scrollButtons}`]: {
        [e.breakpoints.down("sm")]: {
          display: "none"
        }
      }
    }
  }]
}))), aR = Z("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.scroller, n.fixed && t.fixed, n.hideScrollbar && t.hideScrollbar, n.scrollableX && t.scrollableX, n.scrollableY && t.scrollableY];
  }
})({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap",
  variants: [{
    props: ({
      ownerState: e
    }) => e.fixed,
    style: {
      overflowX: "hidden",
      width: "100%"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.hideScrollbar,
    style: {
      // Hide dimensionless scrollbar on macOS
      scrollbarWidth: "none",
      // Firefox
      "&::-webkit-scrollbar": {
        display: "none"
        // Safari + Chrome
      }
    }
  }, {
    props: ({
      ownerState: e
    }) => e.scrollableX,
    style: {
      overflowX: "auto",
      overflowY: "hidden"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.scrollableY,
    style: {
      overflowY: "auto",
      overflowX: "hidden"
    }
  }]
}), lR = Z("div", {
  name: "MuiTabs",
  slot: "List",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.list, t.flexContainer, n.vertical && t.flexContainerVertical, n.centered && t.centered];
  }
})({
  display: "flex",
  variants: [{
    props: ({
      ownerState: e
    }) => e.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.centered,
    style: {
      justifyContent: "center"
    }
  }]
}), cR = Z("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})(mt(({
  theme: e
}) => ({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: e.transitions.create(),
  variants: [{
    props: {
      indicatorColor: "primary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      indicatorColor: "secondary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.secondary.main
    }
  }, {
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      height: "100%",
      width: 2,
      right: 0
    }
  }]
}))), uR = Z(Dg)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), z3 = {};
let H3 = !1;
const dR = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiTabs"
  }), i = to(), s = Io(), {
    "aria-label": a,
    "aria-labelledby": l,
    action: c,
    centered: u = !1,
    children: f,
    className: g,
    component: h = "div",
    allowScrollButtonsMobile: y = !1,
    indicatorColor: v = "primary",
    onChange: m,
    orientation: b = "horizontal",
    ScrollButtonComponent: C,
    // TODO: remove in v7 (deprecated in v6)
    scrollButtons: E = "auto",
    selectionFollowsFocus: S,
    slots: k = {},
    slotProps: T = {},
    TabIndicatorProps: P = {},
    // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps: F = {},
    // TODO: remove in v7 (deprecated in v6)
    textColor: j = "primary",
    value: L,
    variant: R = "standard",
    visibleScrollbar: V = !1,
    ...B
  } = r, W = R === "scrollable", z = b === "vertical", G = z ? "scrollTop" : "scrollLeft", H = z ? "top" : "left", ie = z ? "bottom" : "right", ce = z ? "clientHeight" : "clientWidth", re = z ? "height" : "width", A = {
    ...r,
    component: h,
    allowScrollButtonsMobile: y,
    indicatorColor: v,
    orientation: b,
    vertical: z,
    scrollButtons: E,
    textColor: j,
    variant: R,
    visibleScrollbar: V,
    fixed: !W,
    hideScrollbar: W && !V,
    scrollableX: W && !z,
    scrollableY: W && z,
    centered: u && !W,
    scrollButtonsHideMobile: !y
  }, Y = iR(A), pe = Yo({
    elementType: k.StartScrollButtonIcon,
    externalSlotProps: T.startScrollButtonIcon,
    ownerState: A
  }), Ce = Yo({
    elementType: k.EndScrollButtonIcon,
    externalSlotProps: T.endScrollButtonIcon,
    ownerState: A
  });
  process.env.NODE_ENV !== "production" && u && W && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [fe, ee] = d.useState(!1), [te, ue] = d.useState(z3), [K, oe] = d.useState(!1), [de, ve] = d.useState(!1), [J, se] = d.useState(!1), [ge, Se] = d.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), we = /* @__PURE__ */ new Map(), me = d.useRef(null), ye = d.useRef(null), Ie = {
    slots: k,
    slotProps: {
      indicator: P,
      scrollButton: F,
      ...T
    }
  }, je = () => {
    const it = me.current;
    let ft;
    if (it) {
      const Ae = it.getBoundingClientRect();
      ft = {
        clientWidth: it.clientWidth,
        scrollLeft: it.scrollLeft,
        scrollTop: it.scrollTop,
        scrollWidth: it.scrollWidth,
        top: Ae.top,
        bottom: Ae.bottom,
        left: Ae.left,
        right: Ae.right
      };
    }
    let Xt;
    if (it && L !== !1) {
      const Ae = ye.current.children;
      if (Ae.length > 0) {
        const St = Ae[we.get(L)];
        process.env.NODE_ENV !== "production" && (St || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${L}".`, we.keys ? `You can provide one of the following values: ${Array.from(we.keys()).join(", ")}.` : null].join(`
`))), Xt = St ? St.getBoundingClientRect() : null, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && !H3 && Xt && Xt.width === 0 && Xt.height === 0 && // if the whole Tabs component is hidden, don't warn
        ft.clientWidth !== 0 && (ft = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${L}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), H3 = !0);
      }
    }
    return {
      tabsMeta: ft,
      tabMeta: Xt
    };
  }, Te = Eo(() => {
    const {
      tabsMeta: it,
      tabMeta: ft
    } = je();
    let Xt = 0, Ae;
    z ? (Ae = "top", ft && it && (Xt = ft.top - it.top + it.scrollTop)) : (Ae = s ? "right" : "left", ft && it && (Xt = (s ? -1 : 1) * (ft[Ae] - it[Ae] + it.scrollLeft)));
    const St = {
      [Ae]: Xt,
      // May be wrong until the font is loaded.
      [re]: ft ? ft[re] : 0
    };
    if (typeof te[Ae] != "number" || typeof te[re] != "number")
      ue(St);
    else {
      const yn = Math.abs(te[Ae] - St[Ae]), In = Math.abs(te[re] - St[re]);
      (yn >= 1 || In >= 1) && ue(St);
    }
  }), Fe = (it, {
    animation: ft = !0
  } = {}) => {
    ft ? QE(G, me.current, it, {
      duration: i.transitions.duration.standard
    }) : me.current[G] = it;
  }, gt = (it) => {
    let ft = me.current[G];
    z ? ft += it : ft += it * (s ? -1 : 1), Fe(ft);
  }, Dt = () => {
    const it = me.current[ce];
    let ft = 0;
    const Xt = Array.from(ye.current.children);
    for (let Ae = 0; Ae < Xt.length; Ae += 1) {
      const St = Xt[Ae];
      if (ft + St[ce] > it) {
        Ae === 0 && (ft = it);
        break;
      }
      ft += St[ce];
    }
    return ft;
  }, ke = () => {
    gt(-1 * Dt());
  }, Ne = () => {
    gt(Dt());
  }, [We, {
    onChange: Ge,
    ...Qe
  }] = kt("scrollbar", {
    className: xe(Y.scrollableX, Y.hideScrollbar),
    elementType: uR,
    shouldForwardComponentProp: !0,
    externalForwardedProps: Ie,
    ownerState: A
  }), Ve = d.useCallback((it) => {
    Ge == null || Ge(it), Se({
      overflow: null,
      scrollbarWidth: it
    });
  }, [Ge]), [Ke, bt] = kt("scrollButtons", {
    className: xe(Y.scrollButtons, F.className),
    elementType: jg,
    externalForwardedProps: Ie,
    ownerState: A,
    additionalProps: {
      orientation: b,
      slots: {
        StartScrollButtonIcon: k.startScrollButtonIcon || k.StartScrollButtonIcon,
        EndScrollButtonIcon: k.endScrollButtonIcon || k.EndScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: pe,
        endScrollButtonIcon: Ce
      }
    }
  }), vt = () => {
    const it = {};
    it.scrollbarSizeListener = W ? /* @__PURE__ */ p.jsx(We, {
      ...Qe,
      onChange: Ve
    }) : null;
    const Xt = W && (E === "auto" && (K || de) || E === !0);
    return it.scrollButtonStart = Xt ? /* @__PURE__ */ p.jsx(Ke, {
      direction: s ? "right" : "left",
      onClick: ke,
      disabled: !K,
      ...bt
    }) : null, it.scrollButtonEnd = Xt ? /* @__PURE__ */ p.jsx(Ke, {
      direction: s ? "left" : "right",
      onClick: Ne,
      disabled: !de,
      ...bt
    }) : null, it;
  }, tn = Eo((it) => {
    const {
      tabsMeta: ft,
      tabMeta: Xt
    } = je();
    if (!(!Xt || !ft)) {
      if (Xt[H] < ft[H]) {
        const Ae = ft[G] + (Xt[H] - ft[H]);
        Fe(Ae, {
          animation: it
        });
      } else if (Xt[ie] > ft[ie]) {
        const Ae = ft[G] + (Xt[ie] - ft[ie]);
        Fe(Ae, {
          animation: it
        });
      }
    }
  }), hn = Eo(() => {
    W && E !== !1 && se(!J);
  });
  d.useEffect(() => {
    const it = Cd(() => {
      me.current && Te();
    });
    let ft;
    const Xt = (yn) => {
      yn.forEach((In) => {
        In.removedNodes.forEach((Oo) => {
          ft == null || ft.unobserve(Oo);
        }), In.addedNodes.forEach((Oo) => {
          ft == null || ft.observe(Oo);
        });
      }), it(), hn();
    }, Ae = Lr(me.current);
    Ae.addEventListener("resize", it);
    let St;
    return typeof ResizeObserver < "u" && (ft = new ResizeObserver(it), Array.from(ye.current.children).forEach((yn) => {
      ft.observe(yn);
    })), typeof MutationObserver < "u" && (St = new MutationObserver(Xt), St.observe(ye.current, {
      childList: !0
    })), () => {
      it.clear(), Ae.removeEventListener("resize", it), St == null || St.disconnect(), ft == null || ft.disconnect();
    };
  }, [Te, hn]), d.useEffect(() => {
    const it = Array.from(ye.current.children), ft = it.length;
    if (typeof IntersectionObserver < "u" && ft > 0 && W && E !== !1) {
      const Xt = it[0], Ae = it[ft - 1], St = {
        root: me.current,
        threshold: 0.99
      }, yn = (Xn) => {
        oe(!Xn[0].isIntersecting);
      }, In = new IntersectionObserver(yn, St);
      In.observe(Xt);
      const Oo = (Xn) => {
        ve(!Xn[0].isIntersecting);
      }, Do = new IntersectionObserver(Oo, St);
      return Do.observe(Ae), () => {
        In.disconnect(), Do.disconnect();
      };
    }
  }, [W, E, J, f == null ? void 0 : f.length]), d.useEffect(() => {
    ee(!0);
  }, []), d.useEffect(() => {
    Te();
  }), d.useEffect(() => {
    tn(z3 !== te);
  }, [tn, te]), d.useImperativeHandle(c, () => ({
    updateIndicator: Te,
    updateScrollButtons: hn
  }), [Te, hn]);
  const [Je, $t] = kt("indicator", {
    className: xe(Y.indicator, P.className),
    elementType: cR,
    externalForwardedProps: Ie,
    ownerState: A,
    additionalProps: {
      style: te
    }
  }), nn = /* @__PURE__ */ p.jsx(Je, {
    ...$t
  });
  let Nt = 0;
  const cn = d.Children.map(f, (it) => {
    if (!/* @__PURE__ */ d.isValidElement(it))
      return null;
    process.env.NODE_ENV !== "production" && Pi.isFragment(it) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const ft = it.props.value === void 0 ? Nt : it.props.value;
    we.set(ft, Nt);
    const Xt = ft === L;
    return Nt += 1, /* @__PURE__ */ d.cloneElement(it, {
      fullWidth: R === "fullWidth",
      indicator: Xt && !fe && nn,
      selected: Xt,
      selectionFollowsFocus: S,
      onChange: m,
      textColor: j,
      value: ft,
      ...Nt === 1 && L === !1 && !it.props.tabIndex ? {
        tabIndex: 0
      } : {}
    });
  }), Lt = (it) => {
    if (it.altKey || it.shiftKey || it.ctrlKey || it.metaKey)
      return;
    const ft = ye.current, Xt = Co(ft).activeElement;
    if (Xt.getAttribute("role") !== "tab")
      return;
    let St = b === "horizontal" ? "ArrowLeft" : "ArrowUp", yn = b === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (b === "horizontal" && s && (St = "ArrowRight", yn = "ArrowLeft"), it.key) {
      case St:
        it.preventDefault(), lu(ft, Xt, _3);
        break;
      case yn:
        it.preventDefault(), lu(ft, Xt, B3);
        break;
      case "Home":
        it.preventDefault(), lu(ft, null, B3);
        break;
      case "End":
        it.preventDefault(), lu(ft, null, _3);
        break;
    }
  }, jt = vt(), [un, On] = kt("root", {
    ref: n,
    className: xe(Y.root, g),
    elementType: sR,
    externalForwardedProps: {
      ...Ie,
      ...B,
      component: h
    },
    ownerState: A
  }), [Un, ro] = kt("scroller", {
    ref: me,
    className: Y.scroller,
    elementType: aR,
    externalForwardedProps: Ie,
    ownerState: A,
    additionalProps: {
      style: {
        overflow: ge.overflow,
        [z ? `margin${s ? "Left" : "Right"}` : "marginBottom"]: V ? void 0 : -ge.scrollbarWidth
      }
    }
  }), [Ft, Yn] = kt("list", {
    ref: ye,
    className: xe(Y.list, Y.flexContainer),
    elementType: lR,
    externalForwardedProps: Ie,
    ownerState: A,
    getSlotProps: (it) => ({
      ...it,
      onKeyDown: (ft) => {
        var Xt;
        Lt(ft), (Xt = it.onKeyDown) == null || Xt.call(it, ft);
      }
    })
  });
  return /* @__PURE__ */ p.jsxs(un, {
    ...On,
    children: [jt.scrollButtonStart, jt.scrollbarSizeListener, /* @__PURE__ */ p.jsxs(Un, {
      ...ro,
      children: [/* @__PURE__ */ p.jsx(Ft, {
        "aria-label": a,
        "aria-labelledby": l,
        "aria-orientation": b === "vertical" ? "vertical" : null,
        role: "tablist",
        ...Yn,
        children: cn
      }), fe && nn]
    }), jt.scrollButtonEnd]
  });
});
process.env.NODE_ENV !== "production" && (dR.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: qo,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: o.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": o.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": o.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: o.bool,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: o.oneOfType([o.oneOf(["primary", "secondary"]), o.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: o.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: o.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @deprecated use the `slots.scrollButtons` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default TabScrollButton
   */
  ScrollButtonComponent: o.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: o.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: o.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    endScrollButtonIcon: o.oneOfType([o.func, o.object]),
    indicator: o.oneOfType([o.func, o.object]),
    list: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object]),
    scrollbar: o.oneOfType([o.func, o.object]),
    scrollButtons: o.oneOfType([o.func, o.object]),
    scroller: o.oneOfType([o.func, o.object]),
    startScrollButtonIcon: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    endScrollButtonIcon: o.elementType,
    EndScrollButtonIcon: o.elementType,
    indicator: o.elementType,
    list: o.elementType,
    root: o.elementType,
    scrollbar: o.elementType,
    scrollButtons: o.elementType,
    scroller: o.elementType,
    startScrollButtonIcon: o.elementType,
    StartScrollButtonIcon: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Props applied to the tab indicator element.
   * @deprecated use the `slotProps.indicator` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default  {}
   */
  TabIndicatorProps: o.object,
  /**
   * Props applied to the [`TabScrollButton`](https://mui.com/material-ui/api/tab-scroll-button/) element.
   * @deprecated use the `slotProps.scrollButtons` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TabScrollButtonProps: o.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: o.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: o.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: o.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: o.bool
});
function pR(e) {
  return Pt("MuiTextField", e);
}
Et("MuiTextField", ["root"]);
const fR = {
  standard: Dd,
  filled: Od,
  outlined: pc
}, gR = (e) => {
  const {
    classes: t
  } = e;
  return Ot({
    root: ["root"]
  }, pR, t);
}, mR = Z(Up, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), gc = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Vt({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: i,
    autoFocus: s = !1,
    children: a,
    className: l,
    color: c = "primary",
    defaultValue: u,
    disabled: f = !1,
    error: g = !1,
    FormHelperTextProps: h,
    fullWidth: y = !1,
    helperText: v,
    id: m,
    InputLabelProps: b,
    inputProps: C,
    InputProps: E,
    inputRef: S,
    label: k,
    maxRows: T,
    minRows: P,
    multiline: F = !1,
    name: j,
    onBlur: L,
    onChange: R,
    onFocus: V,
    placeholder: B,
    required: W = !1,
    rows: z,
    select: G = !1,
    SelectProps: H,
    slots: ie = {},
    slotProps: ce = {},
    type: re,
    value: A,
    variant: Y = "outlined",
    ...pe
  } = r, Ce = {
    ...r,
    autoFocus: s,
    color: c,
    disabled: f,
    error: g,
    fullWidth: y,
    multiline: F,
    required: W,
    select: G,
    variant: Y
  }, fe = gR(Ce);
  process.env.NODE_ENV !== "production" && G && !a && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const ee = ai(m), te = v && ee ? `${ee}-helper-text` : void 0, ue = k && ee ? `${ee}-label` : void 0, K = fR[Y], oe = {
    slots: ie,
    slotProps: {
      input: E,
      inputLabel: b,
      htmlInput: C,
      formHelperText: h,
      select: H,
      ...ce
    }
  }, de = {}, ve = oe.slotProps.inputLabel;
  Y === "outlined" && (ve && typeof ve.shrink < "u" && (de.notched = ve.shrink), de.label = k), G && ((!H || !H.native) && (de.id = void 0), de["aria-describedby"] = void 0);
  const [J, se] = kt("root", {
    elementType: mR,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...oe,
      ...pe
    },
    ownerState: Ce,
    className: xe(fe.root, l),
    ref: n,
    additionalProps: {
      disabled: f,
      error: g,
      fullWidth: y,
      required: W,
      color: c,
      variant: Y
    }
  }), [ge, Se] = kt("input", {
    elementType: K,
    externalForwardedProps: oe,
    additionalProps: de,
    ownerState: Ce
  }), [we, me] = kt("inputLabel", {
    elementType: Zp,
    externalForwardedProps: oe,
    ownerState: Ce
  }), [ye, Ie] = kt("htmlInput", {
    elementType: "input",
    externalForwardedProps: oe,
    ownerState: Ce
  }), [je, Te] = kt("formHelperText", {
    elementType: Yp,
    externalForwardedProps: oe,
    ownerState: Ce
  }), [Fe, gt] = kt("select", {
    elementType: fc,
    externalForwardedProps: oe,
    ownerState: Ce
  }), Dt = /* @__PURE__ */ p.jsx(ge, {
    "aria-describedby": te,
    autoComplete: i,
    autoFocus: s,
    defaultValue: u,
    fullWidth: y,
    multiline: F,
    name: j,
    rows: z,
    maxRows: T,
    minRows: P,
    type: re,
    value: A,
    id: ee,
    inputRef: S,
    onBlur: L,
    onChange: R,
    onFocus: V,
    placeholder: B,
    inputProps: Ie,
    slots: {
      input: ie.htmlInput ? ye : void 0
    },
    ...Se
  });
  return /* @__PURE__ */ p.jsxs(J, {
    ...se,
    children: [k != null && k !== "" && /* @__PURE__ */ p.jsx(we, {
      htmlFor: ee,
      id: ue,
      ...me,
      children: k
    }), G ? /* @__PURE__ */ p.jsx(Fe, {
      "aria-describedby": te,
      id: ee,
      labelId: ue,
      value: A,
      input: Dt,
      ...gt,
      children: a
    }) : Dt, v && /* @__PURE__ */ p.jsx(je, {
      id: te,
      ...Te,
      children: v
    })]
  });
});
process.env.NODE_ENV !== "production" && (gc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: o.bool,
  /**
   * @ignore
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: o.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: o.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The helper text content.
   */
  helperText: o.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: o.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: o.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: o.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qo,
  /**
   * The label content.
   */
  label: o.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: o.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: o.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: o.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    formHelperText: o.oneOfType([o.func, o.object]),
    htmlInput: o.oneOfType([o.func, o.object]),
    input: o.oneOfType([o.func, o.object]),
    inputLabel: o.oneOfType([o.func, o.object]),
    select: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    formHelperText: o.elementType,
    htmlInput: o.elementType,
    input: o.elementType,
    inputLabel: o.elementType,
    root: o.elementType,
    select: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
const $s = (e) => (t = 0.6, n = "primary") => {
  var r;
  return Vu(t, ((r = e.palette) == null ? void 0 : r[n].main) || "#000000");
}, hR = Z(fc)`
  height: 30px;
  background-color: #ffffff;
  border-radius: ${({ theme: e }) => {
  var t;
  return ((t = e.shape) == null ? void 0 : t.borderRadius) || 0;
}}px;
  font-size: ${(e) => e.native && "0.9rem"};
  /* &.select-root { */
  padding: 0;
  font-size: 13px;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[1e3];
}};
  .select-base {
    padding-left: 10px;
    padding-top: 0;
    padding-bottom: 0;
  }
  /* } */
  &.button-group-disabled {
    .select-icon {
      color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[300];
}};
    }
  }
  .select-icon {
    color: ${({ theme: e }) => $s(e)()};
  }
  .select-notched-outline {
    border-color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.borderColor.main;
}};
  }
  :hover:not(.button-group-disabled),
  &.select-focused {
    fieldset,
    .select-notched-outline {
      border-width: 1px;
      border-color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.borderColor.main;
}} !important;
    }
  }
  &.select-small {
    height: 24px;
    font-size: 12px;
    line-height: 22px;
    .select-icon {
      right: 1px;
    }
  }
`, Yu = Z(xr)`
  padding-top: ${({ theme: e }) => e.spacing ? e.spacing(1) : "12px"};
  padding-bottom: ${({ theme: e }) => e.spacing ? e.spacing(1) : "12px"};
  padding-left: ${({ theme: e }) => e.spacing ? e.spacing(1.5) : "15px"};
  font-size: ${({ theme: e }) => e.typography.fontSize};
  font-weight: ${({ theme: e }) => {
  var t;
  return ((t = e.typography) == null ? void 0 : t.fontWeightMedium) || 300;
}};
  color: ${({ theme: e }) => e.palette && e.palette.grey[900] || "black"};
  &.medium {
    padding-top: ${({ theme: e }) => e.spacing ? e.spacing(0.8) : "8px"};
    padding-bottom: ${({ theme: e }) => e.spacing ? e.spacing(0.8) : "8px"};
    padding-left: ${({ theme: e }) => e.spacing ? e.spacing(1) : "12px"};
    font-size: 0.85em;
  }
  &.small {
    padding-top: ${({ theme: e }) => e.spacing ? e.spacing(0.5) : "5px"};
    padding-bottom: ${({ theme: e }) => e.spacing ? e.spacing(0.5) : "5px"};
    padding-left: ${({ theme: e }) => e.spacing ? e.spacing(1) : "12px"};
    font-size: 0.8em;
  }
`, Fg = (e) => {
  const {
    native: t = !1,
    className: n,
    multiple: r,
    value: i,
    options: s,
    fullWidth: a,
    placeholder: l,
    size: c,
    onChange: u,
    name: f,
    disablePortal: g = !1,
    disabled: h,
    cropItems: y
  } = e;
  return /* @__PURE__ */ p.jsx(He.Fragment, { children: /* @__PURE__ */ p.jsxs(
    hR,
    {
      ...e.id ? { id: e.id } : {},
      name: f,
      variant: "outlined",
      margin: "dense",
      native: t,
      multiple: r,
      value: i,
      size: c,
      onChange: (v) => {
        u && u(v.target.value, v);
      },
      fullWidth: a,
      displayEmpty: !0,
      className: xe(n, "c-select"),
      classes: {
        select: "select-menu",
        root: "select-root",
        nativeInput: "native-select-input",
        icon: "select-icon"
      },
      disabled: h,
      input: /* @__PURE__ */ p.jsx(
        pc,
        {
          classes: {
            root: "select-base",
            focused: "select-focused",
            notchedOutline: "select-notched-outline",
            input: "select-base",
            sizeSmall: "select-small"
          }
        }
      ),
      MenuProps: {
        disablePortal: g,
        classes: {
          root: "select-menu-container",
          paper: "select-menu",
          list: "select-menu-list"
        }
      },
      renderValue: y && r ? (v) => {
        var b;
        const m = ((b = s.find(
          (C) => C.value === v[0] || C === v[0]
        )) == null ? void 0 : b.name) || v[0];
        return /* @__PURE__ */ p.jsx(p.Fragment, { children: (v == null ? void 0 : v.length) > 1 ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          m,
          /* @__PURE__ */ p.jsx(
            Ia,
            {
              label: `+${v.length - 1}`,
              size: "small",
              sx: {
                borderRadius: 1,
                height: 18,
                ml: 0.8,
                fontSize: 11,
                ".MuiChip-label": {
                  py: 0,
                  px: 0.75
                }
              }
            }
          )
        ] }) : m });
      } : void 0,
      children: [
        l && (t ? /* @__PURE__ */ p.jsx("option", { value: "", disabled: !0, children: l }, "placeholder") : /* @__PURE__ */ p.jsx(
          Yu,
          {
            value: "",
            disabled: !0,
            className: c,
            children: l
          },
          "placeholder"
        )),
        s && !!s.length && s.map(
          (v) => t ? /* @__PURE__ */ p.jsx("option", { value: v.value, children: v.name }, v.name) : /* @__PURE__ */ p.jsxs(
            Yu,
            {
              value: v.value,
              className: c,
              children: [
                v.name,
                " ",
                v.tag != null ? `(${v.tag})` : ""
              ]
            },
            v.name
          )
        )
      ]
    }
  ) });
}, vR = yo(gc)`
  margin: 0;
  background-color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette) == null ? void 0 : t.backgroundColor.paper) || "#fff";
}};
  border-radius: ${({ theme: e }) => {
  var t;
  return ((t = e.shape) == null ? void 0 : t.borderRadius) || 0;
}}px;
  .input-focused .input-notched-outline {
    border-size: 1px;
    border-color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.borderColor.main;
}} !important;
  }
  &.number .input-root {
    padding-right: 2px;
  }
  & .input-focused,
  & .input-root:hover {
    .input-notched-outline {
      border: 1px solid ${({ theme: e }) => $s(e)()};
    }
  }
  &::placeholder {
    color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette) == null ? void 0 : t.grey[500]) || "lightgrey";
}};
  }
  &.number .input-root.input-small {
    padding-right: 2px;
  }
  .input-root {
    min-height: 30px;
    line-height: 28px;
    padding: 5px 10px;
    font-size: 14px;
    font-family: ${({ theme: e }) => {
  var t;
  return ((t = e.typography) == null ? void 0 : t.fontFamily) || "sans-serif";
}};
    border-radius: ${({ theme: e }) => {
  var t;
  return ((t = e.shape) == null ? void 0 : t.borderRadius) || 0;
}}px;

    &.input-small {
      min-height: 24px;
      font-size: 12px;
      padding: 3px 8px;
      line-height: 24px;
    }
    &.input-large {
      min-height: 48px;
      font-size: 14px;
      padding: 5px 10px;
      /* line-height: 24px; */
    }
  }
  .input-base {
    padding: 0;
  }
`, of = (e) => {
  const {
    type: t = "text",
    className: n,
    pattern: r,
    min: i,
    max: s,
    size: a = "medium",
    id: l,
    variant: c,
    step: u,
    ...f
  } = e;
  return /* @__PURE__ */ p.jsx(
    vR,
    {
      ...f,
      className: xe("input", t, n),
      variant: c,
      margin: "dense",
      classes: {
        root: "input",
        ...f.classes
      },
      inputProps: {
        step: u
      },
      slotProps: {
        htmlInput: {
          pattern: r,
          min: i,
          max: s,
          type: t,
          step: u,
          ...l ? { id: l } : {},
          ...f.inputProps
        },
        input: {
          size: a,
          className: "input-" + a,
          classes: {
            root: "input-root",
            focused: "input-focused",
            notchedOutline: "input-notched-outline",
            input: "input-base",
            sizeSmall: "input-small"
          },
          ...f.InputProps
        }
      }
    }
  );
}, yR = yo($p, {
  shouldForwardProp: (e) => e !== "disableResize" && e !== "disableVerticalResize" && e !== "disableHorizontalResize"
})(
  (e) => {
    var t, n, r, i, s, a;
    return `
  width: calc(100% - 24px);
  border: 1px solid ${(t = e.theme.palette) == null ? void 0 : t.borderColor.main};
  border-radius: 4px;
  padding: 6px 12px;
  font-family: ${((n = e.theme.typography) == null ? void 0 : n.fontFamily) || "sans-serif"};
  font-size: ${((r = e.theme.typography) == null ? void 0 : r.fontSize) || 14};
  &::placeholder {
    color: ${((i = e.theme.palette) == null ? void 0 : i.grey[500]) || "lightgrey"};
    font-family: ${((s = e.theme.typography) == null ? void 0 : s.fontFamily) || "sans-serif"};
    font-weight: ${((a = e.theme.typography) == null ? void 0 : a.fontWeightRegular) || 400};
  }
  resize: ${bR(e)};
  max-height: calc(100% - 20px);
  &:focus {
    border: 1px solid ${$s(e.theme)()};
    outline: none;
  }
  &:hover {
    border: 1px solid ${$s(e.theme)()};
  }
  ${e.size == "small" && `
      font-size: 12px;
      padding: 6px 8px;
      width: calc(100% - 16px);
    `}`;
  }
), bR = ({
  disableResize: e,
  disableVerticalResize: t,
  disableHorizontalResize: n
}) => e || t && n ? "none" : t ? "horizontal" : n ? "vertical" : "both", V_ = (e) => {
  const [t, n] = So(e.value);
  return /* @__PURE__ */ p.jsx(
    yR,
    {
      id: e.id || "",
      className: e.className,
      value: t,
      onChange: (r) => {
        var i;
        n(r.target.value), (i = e.onChange) == null || i.call(e, r.target.value);
      },
      maxRows: e.maxRows,
      minRows: e.minRows,
      disabled: e.disabled,
      placeholder: e.placeholder,
      name: e.name,
      disableResize: e.disableResize,
      disableVerticalResize: e.disableVerticalResize,
      disableHorizontalResize: e.disableHorizontalResize,
      readOnly: e.readOnly
    }
  );
}, Vd = (e) => /* @__PURE__ */ p.jsx(zs, { ...e }), $_ = ({ text: e = "AI Generation" }) => /* @__PURE__ */ p.jsxs("div", { className: "loading-container", children: [
  /* @__PURE__ */ p.jsx("div", { className: "spinner" }),
  /* @__PURE__ */ p.jsx("div", { className: "particles", children: [...Array(6)].map((t, n) => /* @__PURE__ */ p.jsx(
    ko,
    {
      className: "particle",
      sx: { animationDelay: `${n * 0.2}s` }
    },
    n
  )) }),
  /* @__PURE__ */ p.jsx("div", { className: "text-container", children: /* @__PURE__ */ p.jsx("span", { className: "ai-text", children: e }) })
] }), L_ = (e) => /* @__PURE__ */ p.jsx(cg, { ...e, variant: "determinate", value: e.progress });
function wi(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function CR(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function xR(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function wR(e, t, n, r, i) {
  const s = e[t], a = i || t;
  if (s == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  return typeof s == "function" && !xR(s) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const SR = CR(o.elementType, wR);
function ER(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const $i = o.oneOfType([o.func, o.object]);
function RR(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : ER(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function ku(e) {
  return e && e.ownerDocument || document;
}
function TR(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const ni = typeof window < "u" ? d.useLayoutEffect : d.useEffect;
let W3 = 0;
function MR(e) {
  const [t, n] = d.useState(e), r = e || t;
  return d.useEffect(() => {
    t == null && (W3 += 1, n(`mui-${W3}`));
  }, [t]), r;
}
const G3 = d.useId;
function mc(e) {
  if (G3 !== void 0) {
    const t = G3();
    return e ?? t;
  }
  return MR(e);
}
function kR(e, t, n, r, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const s = i || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${s}\` is not supported. Please remove it.`) : null;
}
function Ls({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: i
  } = d.useRef(e !== void 0), [s, a] = d.useState(t), l = i ? e : s;
  if (process.env.NODE_ENV !== "production") {
    d.useEffect(() => {
      i !== (e !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${r} state of ${n} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: u
    } = d.useRef(t);
    d.useEffect(() => {
      !i && !Object.is(u, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = d.useCallback((u) => {
    i || a(u);
  }, []);
  return [l, c];
}
function yt(e) {
  const t = d.useRef(e);
  return ni(() => {
    t.current = e;
  }), d.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function Vo(...e) {
  return d.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      TR(n, t);
    });
  }, e);
}
const PR = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function co(e, t, n = void 0) {
  const r = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (i) => {
      r[i] = e[i].reduce((s, a) => {
        if (a) {
          const l = t(a);
          l !== "" && s.push(l), n && n[a] && s.push(n[a]);
        }
        return s;
      }, []).join(" ");
    }
  ), r;
}
const U3 = (e) => e, IR = () => {
  let e = U3;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = U3;
    }
  };
}, OR = IR(), DR = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function uo(e, t, n = "Mui") {
  const r = DR[t];
  return r ? `${n}-${r}` : `${OR.generate(e)}-${t}`;
}
function po(e, t, n = "Mui") {
  const r = {};
  return t.forEach((i) => {
    r[i] = uo(e, i, n);
  }), r;
}
function jR(e) {
  return typeof e == "string";
}
function FR(e, t, n) {
  return e === void 0 || jR(e) ? t : Q({}, t, {
    ownerState: Q({}, t.ownerState, n)
  });
}
function U0(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function Y3(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function VR(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: i,
    className: s
  } = e;
  if (!t) {
    const y = xe(n == null ? void 0 : n.className, s, i == null ? void 0 : i.className, r == null ? void 0 : r.className), v = Q({}, n == null ? void 0 : n.style, i == null ? void 0 : i.style, r == null ? void 0 : r.style), m = Q({}, n, i, r);
    return y.length > 0 && (m.className = y), Object.keys(v).length > 0 && (m.style = v), {
      props: m,
      internalRef: void 0
    };
  }
  const a = U0(Q({}, i, r)), l = Y3(r), c = Y3(i), u = t(a), f = xe(u == null ? void 0 : u.className, n == null ? void 0 : n.className, s, i == null ? void 0 : i.className, r == null ? void 0 : r.className), g = Q({}, u == null ? void 0 : u.style, n == null ? void 0 : n.style, i == null ? void 0 : i.style, r == null ? void 0 : r.style), h = Q({}, u, n, c, l);
  return f.length > 0 && (h.className = f), Object.keys(g).length > 0 && (h.style = g), {
    props: h,
    internalRef: u.ref
  };
}
const $R = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function kn(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: i,
    skipResolvingSlotProps: s = !1
  } = e, a = Zt(e, $R), l = s ? {} : wi(r, i), {
    props: c,
    internalRef: u
  } = VR(Q({}, a, {
    externalSlotProps: l
  })), f = Vo(u, l == null ? void 0 : l.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return FR(n, Q({}, c, {
    ref: f
  }), i);
}
const ol = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), LR = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: r
}) => {
  const i = n ?? r;
  let s;
  if (e != null)
    s = e;
  else if (i.includes(t))
    s = t;
  else if (i.length > 0)
    s = i[0];
  else
    throw new Error("MUI X: The `views` prop must contain at least one view.");
  return {
    views: i,
    openTo: s
  };
}, Zu = (e, t, n) => {
  let r = t;
  return r = e.setHours(r, e.getHours(n)), r = e.setMinutes(r, e.getMinutes(n)), r = e.setSeconds(r, e.getSeconds(n)), r = e.setMilliseconds(r, e.getMilliseconds(n)), r;
}, Dl = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: r,
  minDate: i,
  isDateDisabled: s,
  utils: a,
  timezone: l
}) => {
  const c = Zu(a, a.date(void 0, l), e);
  n && a.isBefore(i, c) && (i = c), t && a.isAfter(r, c) && (r = c);
  let u = e, f = e;
  for (a.isBefore(e, i) && (u = i, f = null), a.isAfter(e, r) && (f && (f = r), u = null); u || f; ) {
    if (u && a.isAfter(u, r) && (u = null), f && a.isBefore(f, i) && (f = null), u) {
      if (!s(u))
        return u;
      u = a.addDays(u, 1);
    }
    if (f) {
      if (!s(f))
        return f;
      f = a.addDays(f, -1);
    }
  }
  return null;
}, AR = (e, t) => t == null || !e.isValid(t) ? null : t, Pr = (e, t, n) => t == null || !e.isValid(t) ? n : t, NR = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), rf = (e, t) => {
  const r = [e.startOfYear(t)];
  for (; r.length < 12; ) {
    const i = r[r.length - 1];
    r.push(e.addMonths(i, 1));
  }
  return r;
}, Vg = (e, t, n) => n === "date" ? e.startOfDay(e.date(void 0, t)) : e.date(void 0, t), BR = ["year", "month", "day"], Z3 = (e) => BR.includes(e), sf = (e, {
  format: t,
  views: n
}, r) => {
  if (t != null)
    return t;
  const i = e.formats;
  return ol(n, ["year"]) ? i.year : ol(n, ["month"]) ? i.month : ol(n, ["day"]) ? i.dayOfMonth : ol(n, ["month", "year"]) ? `${i.month} ${i.year}` : ol(n, ["day", "month"]) ? `${i.month} ${i.dayOfMonth}` : r ? /en/.test(e.getCurrentLocaleCode()) ? i.normalDateWithWeekday : i.normalDate : i.keyboardDate;
}, _R = (e, t) => {
  const n = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((r) => e.addDays(n, r));
}, zR = ["hours", "minutes", "seconds"], HR = (e) => zR.includes(e), q3 = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), WR = (e, t) => (n, r) => e ? t.isAfter(n, r) : q3(n, t) > q3(r, t), Yr = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, GR = (e) => Math.max(...e.map((t) => Yr[t.type] ?? 1)), rl = (e, t, n) => {
  if (t === Yr.year)
    return e.startOfYear(n);
  if (t === Yr.month)
    return e.startOfMonth(n);
  if (t === Yr.day)
    return e.startOfDay(n);
  let r = n;
  return t < Yr.minutes && (r = e.setMinutes(r, 0)), t < Yr.seconds && (r = e.setSeconds(r, 0)), t < Yr.milliseconds && (r = e.setMilliseconds(r, 0)), r;
}, UR = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: r,
  getTodayDate: i
}) => {
  let s = i ? i() : rl(t, n, Vg(t, r));
  e.minDate != null && t.isAfterDay(e.minDate, s) && (s = rl(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, s) && (s = rl(t, n, e.maxDate));
  const a = WR(e.disableIgnoringDatePartForTimeValidation ?? !1, t);
  return e.minTime != null && a(e.minTime, s) && (s = rl(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : Zu(t, s, e.minTime))), e.maxTime != null && a(s, e.maxTime) && (s = rl(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : Zu(t, s, e.maxTime))), s;
}, af = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI X: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, YR = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, $d = (e, t) => {
  const n = [], r = e.date(void 0, "default"), i = e.startOfWeek(r), s = e.endOfWeek(r);
  let a = i;
  for (; e.isBefore(a, s); )
    n.push(a), a = e.addDays(a, 1);
  return n.map((l) => e.formatByString(l, t));
}, $g = (e, t, n, r) => {
  switch (n) {
    case "month":
      return rf(e, e.date(void 0, t)).map((i) => e.formatByString(i, r));
    case "weekDay":
      return $d(e, r);
    case "meridiem": {
      const i = e.date(void 0, t);
      return [e.startOfDay(i), e.endOfDay(i)].map((s) => e.formatByString(s, r));
    }
    default:
      return [];
  }
}, K3 = "s", ZR = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], qR = (e) => {
  const t = e.date(void 0);
  return e.formatByString(e.setSeconds(t, 0), K3) === "0" ? ZR : Array.from({
    length: 10
  }).map((r, i) => e.formatByString(e.setSeconds(t, i), K3));
}, As = (e, t) => {
  if (t[0] === "0")
    return e;
  const n = [];
  let r = "";
  for (let i = 0; i < e.length; i += 1) {
    r += e[i];
    const s = t.indexOf(r);
    s > -1 && (n.push(s.toString()), r = "");
  }
  return n.join("");
}, lf = (e, t) => t[0] === "0" ? e : e.split("").map((n) => t[Number(n)]).join(""), X3 = (e, t) => {
  const n = As(e, t);
  return n !== " " && !Number.isNaN(Number(n));
}, Lg = (e, t) => {
  let n = e;
  for (n = Number(n).toString(); n.length < t; )
    n = `0${n}`;
  return n;
}, Ag = (e, t, n, r, i) => {
  if (process.env.NODE_ENV !== "production" && i.type !== "day" && i.contentType === "digit-with-letter")
    throw new Error([`MUI X: The token "${i.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (i.type === "day" && i.contentType === "digit-with-letter") {
    const a = e.setDate(n.longestMonth, t);
    return e.formatByString(a, i.format);
  }
  let s = t.toString();
  return i.hasLeadingZerosInInput && (s = Lg(s, i.maxLength)), lf(s, r);
}, KR = (e, t, n, r, i, s, a, l) => {
  const c = YR(r), u = r === "Home", f = r === "End", g = n.value === "" || u || f, h = () => {
    const v = i[n.type]({
      currentDate: a,
      format: n.format,
      contentType: n.contentType
    }), m = (E) => Ag(e, E, v, s, n), b = n.type === "minutes" && (l != null && l.minutesStep) ? l.minutesStep : 1;
    let C;
    if (g) {
      if (n.type === "year" && !f && !u)
        return e.formatByString(e.date(void 0, t), n.format);
      c > 0 || u ? C = v.minimum : C = v.maximum;
    } else
      C = parseInt(As(n.value, s), 10) + c * b;
    return C % b !== 0 && ((c < 0 || u) && (C += b - (b + C) % b), (c > 0 || f) && (C -= C % b)), C > v.maximum ? m(v.minimum + (C - v.maximum - 1) % (v.maximum - v.minimum + 1)) : C < v.minimum ? m(v.maximum - (v.minimum - C - 1) % (v.maximum - v.minimum + 1)) : m(C);
  }, y = () => {
    const v = $g(e, t, n.type, n.format);
    if (v.length === 0)
      return n.value;
    if (g)
      return c > 0 || u ? v[0] : v[v.length - 1];
    const C = ((v.indexOf(n.value) + c) % v.length + v.length) % v.length;
    return v[C];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? h() : y();
}, cf = (e, t, n) => {
  let r = e.value || e.placeholder;
  const i = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (r = Number(As(r, n)).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !i && r.length === 1 && (r = `${r}‎`), t === "input-rtl" && (r = `⁨${r}⁩`), r;
}, Q3 = (e, t, n, r) => {
  if (process.env.NODE_ENV !== "production" && af(e, n).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, n), r);
}, XR = (e, t) => e.formatByString(e.date(void 0, "system"), t).length === 4, Ng = (e, t, n, r) => {
  if (t !== "digit")
    return !1;
  const i = e.date(void 0, "default");
  switch (n) {
    case "year":
      return e.lib === "dayjs" && r === "YY" ? !0 : e.formatByString(e.setYear(i, 1), r).startsWith("0");
    case "month":
      return e.formatByString(e.startOfYear(i), r).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(i), r).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(i), r).length > 1;
    case "hours":
      return e.formatByString(e.setHours(i, 1), r).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(i, 1), r).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(i, 1), r).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, QR = (e, t, n) => {
  const r = t.some((c) => c.type === "day"), i = [], s = [];
  for (let c = 0; c < t.length; c += 1) {
    const u = t[c];
    r && u.type === "weekDay" || (i.push(u.format), s.push(cf(u, "non-input", n)));
  }
  const a = i.join(" "), l = s.join(" ");
  return e.parse(l, a);
}, JR = (e) => e.map((t) => `${t.startSeparator}${t.value || t.placeholder}${t.endSeparator}`).join(""), eT = (e, t, n) => {
  const i = e.map((s) => {
    const a = cf(s, n ? "input-rtl" : "input-ltr", t);
    return `${s.startSeparator}${a}${s.endSeparator}`;
  }).join("");
  return n ? `⁦${i}⁩` : i;
}, tT = (e, t, n) => {
  const r = e.date(void 0, n), i = e.endOfYear(r), s = e.endOfDay(r), {
    maxDaysInMonth: a,
    longestMonth: l
  } = rf(e, r).reduce((c, u) => {
    const f = e.getDaysInMonth(u);
    return f > c.maxDaysInMonth ? {
      maxDaysInMonth: f,
      longestMonth: u
    } : c;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: c
    }) => ({
      minimum: 0,
      maximum: XR(e, c) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(i) + 1
    }),
    day: ({
      currentDate: c
    }) => ({
      minimum: 1,
      maximum: c != null && e.isValid(c) ? e.getDaysInMonth(c) : a,
      longestMonth: l
    }),
    weekDay: ({
      format: c,
      contentType: u
    }) => {
      if (u === "digit") {
        const f = $d(e, c).map(Number);
        return {
          minimum: Math.min(...f),
          maximum: Math.max(...f)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: c
    }) => {
      const u = e.getHours(s);
      return As(e.formatByString(e.endOfDay(r), c), t) !== u.toString() ? {
        minimum: 1,
        maximum: Number(As(e.formatByString(e.startOfDay(r), c), t))
      } : {
        minimum: 0,
        maximum: u
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(s)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(s)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 1
    }),
    empty: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let J3 = !1;
const e5 = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !J3) {
    const n = ["empty"];
    ["date", "date-time"].includes(t) && n.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && n.push("hours", "minutes", "seconds", "meridiem");
    const r = e.find((i) => !n.includes(i.type));
    r && (console.warn(`MUI X: The field component you are using is not compatible with the "${r.type}" date section.`, `The supported date sections are ["${n.join('", "')}"]\`.`), J3 = !0);
  }
}, nT = (e, t, n, r) => {
  switch (t.type) {
    case "year":
      return e.setYear(r, e.getYear(n));
    case "month":
      return e.setMonth(r, e.getMonth(n));
    case "weekDay": {
      const i = $d(e, t.format), s = e.formatByString(n, t.format), a = i.indexOf(s), c = i.indexOf(t.value) - a;
      return e.addDays(n, c);
    }
    case "day":
      return e.setDate(r, e.getDate(n));
    case "meridiem": {
      const i = e.getHours(n) < 12, s = e.getHours(r);
      return i && s >= 12 ? e.addHours(r, -12) : !i && s < 12 ? e.addHours(r, 12) : r;
    }
    case "hours":
      return e.setHours(r, e.getHours(n));
    case "minutes":
      return e.setMinutes(r, e.getMinutes(n));
    case "seconds":
      return e.setSeconds(r, e.getSeconds(n));
    default:
      return r;
  }
}, t5 = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8,
  empty: 9
}, n5 = (e, t, n, r, i) => (
  // cloning sections before sort to avoid mutating it
  [...n].sort((s, a) => t5[s.type] - t5[a.type]).reduce((s, a) => !i || a.modified ? nT(e, a, t, s) : s, r)
), oT = () => navigator.userAgent.toLowerCase().includes("android"), rT = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((c, u) => {
      const f = u === 0 ? null : u - 1, g = u === e.length - 1 ? null : u + 1;
      n[u] = {
        leftIndex: f,
        rightIndex: g
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const r = {}, i = {};
  let s = 0, a = 0, l = e.length - 1;
  for (; l >= 0; ) {
    a = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (c, u) => {
        var f;
        return u >= s && ((f = c.endSeparator) == null ? void 0 : f.includes(" ")) && // Special case where the spaces were not there in the initial input
        c.endSeparator !== " / ";
      }
    ), a === -1 && (a = e.length - 1);
    for (let c = a; c >= s; c -= 1)
      i[c] = l, r[l] = c, l -= 1;
    s = a + 1;
  }
  return e.forEach((c, u) => {
    const f = i[u], g = f === 0 ? null : r[f - 1], h = f === e.length - 1 ? null : r[f + 1];
    n[u] = {
      leftIndex: g,
      rightIndex: h
    };
  }), {
    neighbors: n,
    startIndex: r[0],
    endIndex: r[e.length - 1]
  };
}, Y0 = (e, t) => {
  if (e == null)
    return null;
  if (e === "all")
    return "all";
  if (typeof e == "string") {
    const n = t.findIndex((r) => r.type === e);
    return n === -1 ? null : n;
  }
  return e;
}, iT = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "month": {
        if (e.contentType === "digit")
          return t.format(t.setMonth(t.date(), Number(e.value) - 1), "month");
        const n = t.parse(e.value, e.format);
        return n ? t.format(n, "month") : void 0;
      }
      case "day":
        return e.contentType === "digit" ? t.format(t.setDate(t.startOfYear(t.date()), Number(e.value)), "dayOfMonthFull") : e.value;
      case "weekDay":
        return;
      default:
        return;
    }
}, sT = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "weekDay":
        return e.contentType === "letter" ? void 0 : Number(e.value);
      case "meridiem": {
        const n = t.parse(`01:00 ${e.value}`, `${t.formats.hours12h}:${t.formats.minutes} ${e.format}`);
        return n ? t.getHours(n) >= 12 ? 1 : 0 : void 0;
      }
      case "day":
        return e.contentType === "digit-with-letter" ? parseInt(e.value, 10) : Number(e.value);
      case "month": {
        if (e.contentType === "digit")
          return Number(e.value);
        const n = t.parse(e.value, e.format);
        return n ? t.getMonth(n) + 1 : void 0;
      }
      default:
        return e.contentType !== "letter" ? Number(e.value) : void 0;
    }
}, aT = ["value", "referenceDate"], oi = {
  emptyValue: null,
  getTodayValue: Vg,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, r = Zt(e, aT);
    return t != null && r.utils.isValid(t) ? t : n ?? UR(r);
  },
  cleanValue: AR,
  areValuesEqual: NR,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, lT = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, r) => !e.isValid(t) && !!n ? n : r(t),
  getV7HiddenInputValueFromSections: JR,
  getV6InputValueFromSections: eT,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
}, cT = ["localeText"], qu = /* @__PURE__ */ d.createContext(null);
process.env.NODE_ENV !== "production" && (qu.displayName = "MuiPickersAdapterContext");
const Ld = function(t) {
  const {
    localeText: n
  } = t, r = Zt(t, cT), {
    utils: i,
    localeText: s
  } = d.useContext(qu) ?? {
    utils: void 0,
    localeText: void 0
  }, a = Kn({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: r,
    name: "MuiLocalizationProvider"
  }), {
    children: l,
    dateAdapter: c,
    dateFormats: u,
    dateLibInstance: f,
    adapterLocale: g,
    localeText: h
  } = a, y = d.useMemo(() => Q({}, h, s, n), [h, s, n]), v = d.useMemo(() => {
    if (!c)
      return i || null;
    const C = new c({
      locale: g,
      formats: u,
      instance: f
    });
    if (!C.isMUIAdapter)
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return C;
  }, [c, g, u, f, i]), m = d.useMemo(() => v ? {
    minDate: v.date("1900-01-01T00:00:00.000"),
    maxDate: v.date("2099-12-31T00:00:00.000")
  } : null, [v]), b = d.useMemo(() => ({
    utils: v,
    defaultDates: m,
    localeText: y
  }), [m, v, y]);
  return /* @__PURE__ */ p.jsx(qu.Provider, {
    value: b,
    children: l
  });
};
process.env.NODE_ENV !== "production" && (Ld.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: o.any,
  children: o.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#date-library-adapter-setup date adapter setup section} for more details.
   */
  dateAdapter: o.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: o.shape({
    dayOfMonth: o.string,
    dayOfMonthFull: o.string,
    fullDate: o.string,
    fullTime: o.string,
    fullTime12h: o.string,
    fullTime24h: o.string,
    hours12h: o.string,
    hours24h: o.string,
    keyboardDate: o.string,
    keyboardDateTime: o.string,
    keyboardDateTime12h: o.string,
    keyboardDateTime24h: o.string,
    meridiem: o.string,
    minutes: o.string,
    month: o.string,
    monthShort: o.string,
    normalDate: o.string,
    normalDateWithWeekday: o.string,
    seconds: o.string,
    shortDate: o.string,
    weekday: o.string,
    weekdayShort: o.string,
    year: o.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: o.any,
  /**
   * Locale for components texts
   */
  localeText: o.object
});
const uT = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: Q({}, e)
      }
    }
  }
}), Bg = (e) => {
  const {
    utils: t,
    formatKey: n,
    contextTranslation: r,
    propsTranslation: i
  } = e;
  return (s) => {
    const a = s !== null && t.isValid(s) ? t.format(s, n) : null;
    return (i ?? r)(s, t, a);
  };
}, _g = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "Open previous view",
  openNextView: "Open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange labels
  start: "Start",
  end: "End",
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n, r) => `Select ${e}. ${!r && (t === null || !n.isValid(t)) ? "No time selected" : `Selected time is ${r ?? n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t, n) => n || e !== null && t.isValid(e) ? `Choose date, selected date is ${n ?? t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t, n) => n || e !== null && t.isValid(e) ? `Choose time, selected time is ${n ?? t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa",
  // View names
  year: "Year",
  month: "Month",
  day: "Day",
  weekDay: "Week day",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  meridiem: "Meridiem",
  // Common
  empty: "Empty"
}, dT = _g;
uT(_g);
const Hs = () => {
  const e = d.useContext(qu);
  if (e === null)
    throw new Error(["MUI X: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI X: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = d.useMemo(() => Q({}, dT, e.localeText), [e.localeText]);
  return d.useMemo(() => Q({}, e, {
    localeText: t
  }), [e, t]);
}, no = () => Hs().utils, hc = () => Hs().defaultDates, Ad = (e) => {
  const t = no(), n = d.useRef(void 0);
  return n.current === void 0 && (n.current = t.date(void 0, e)), n.current;
};
function pT(e) {
  return uo("MuiPickersToolbar", e);
}
po("MuiPickersToolbar", ["root", "content"]);
const fT = ["children", "className", "toolbarTitle", "hidden", "titleId", "isLandscape", "classes", "landscapeDirection"], gT = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"],
    content: ["content"]
  }, pT, t);
}, mT = Z("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3),
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      height: "auto",
      maxWidth: 160,
      padding: 16,
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }]
})), hT = Z("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column"
    }
  }, {
    props: {
      isLandscape: !0,
      landscapeDirection: "row"
    },
    style: {
      flexDirection: "row"
    }
  }]
}), vT = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: i,
    className: s,
    toolbarTitle: a,
    hidden: l,
    titleId: c
  } = r, u = Zt(r, fT), f = r, g = gT(f);
  return l ? null : /* @__PURE__ */ p.jsxs(mT, Q({
    ref: n,
    className: xe(g.root, s),
    ownerState: f
  }, u, {
    children: [/* @__PURE__ */ p.jsx(vo, {
      color: "text.secondary",
      variant: "overline",
      id: c,
      children: a
    }), /* @__PURE__ */ p.jsx(hT, {
      className: g.content,
      ownerState: f,
      children: i
    })]
  }));
}), Li = () => Hs().localeText;
function yT(e) {
  return uo("MuiDatePickerToolbar", e);
}
po("MuiDatePickerToolbar", ["root", "title"]);
const bT = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className", "onViewChange", "view"], CT = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"],
    title: ["title"]
  }, yT, t);
}, xT = Z(vT, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), wT = Z(vo, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (e, t) => t.title
})({
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "auto 16px auto auto"
    }
  }]
}), zg = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiDatePickerToolbar"
  }), {
    value: i,
    isLandscape: s,
    toolbarFormat: a,
    toolbarPlaceholder: l = "––",
    views: c,
    className: u
  } = r, f = Zt(r, bT), g = no(), h = Li(), y = CT(r), v = d.useMemo(() => {
    if (!i)
      return l;
    const b = sf(g, {
      format: a,
      views: c
    }, !0);
    return g.formatByString(i, b);
  }, [i, a, l, g, c]), m = r;
  return /* @__PURE__ */ p.jsx(xT, Q({
    ref: n,
    toolbarTitle: h.datePickerToolbarTitle,
    isLandscape: s,
    className: xe(y.root, u)
  }, f, {
    children: /* @__PURE__ */ p.jsx(wT, {
      variant: "h4",
      align: s ? "left" : "center",
      ownerState: m,
      className: y.title,
      children: v
    })
  }));
});
process.env.NODE_ENV !== "production" && (zg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  disabled: o.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: o.bool,
  isLandscape: o.bool.isRequired,
  onChange: o.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: o.func.isRequired,
  readOnly: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  titleId: o.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: o.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: o.node,
  value: o.object,
  /**
   * Currently visible picker view.
   */
  view: o.oneOf(["day", "month", "year"]).isRequired,
  /**
   * Available views.
   */
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired).isRequired
});
function Hg(e, t) {
  const n = no(), r = hc(), i = Kn({
    props: e,
    name: t
  }), s = d.useMemo(() => {
    var a;
    return ((a = i.localeText) == null ? void 0 : a.toolbarTitle) == null ? i.localeText : Q({}, i.localeText, {
      datePickerToolbarTitle: i.localeText.toolbarTitle
    });
  }, [i.localeText]);
  return Q({}, i, {
    localeText: s
  }, LR({
    views: i.views,
    openTo: i.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: i.disableFuture ?? !1,
    disablePast: i.disablePast ?? !1,
    minDate: Pr(n, i.minDate, r.minDate),
    maxDate: Pr(n, i.maxDate, r.maxDate),
    slots: Q({
      toolbar: zg
    }, i.slots)
  });
}
const vc = ({
  props: e,
  value: t,
  timezone: n,
  adapter: r
}) => {
  if (t === null)
    return null;
  const {
    shouldDisableDate: i,
    shouldDisableMonth: s,
    shouldDisableYear: a,
    disablePast: l,
    disableFuture: c
  } = e, u = r.utils.date(void 0, n), f = Pr(r.utils, e.minDate, r.defaultDates.minDate), g = Pr(r.utils, e.maxDate, r.defaultDates.maxDate);
  switch (!0) {
    case !r.utils.isValid(t):
      return "invalidDate";
    case !!(i && i(t)):
      return "shouldDisableDate";
    case !!(s && s(t)):
      return "shouldDisableMonth";
    case !!(a && a(t)):
      return "shouldDisableYear";
    case !!(c && r.utils.isAfterDay(t, u)):
      return "disableFuture";
    case !!(l && r.utils.isBeforeDay(t, u)):
      return "disablePast";
    case !!(f && r.utils.isBeforeDay(t, f)):
      return "minDate";
    case !!(g && r.utils.isAfterDay(t, g)):
      return "maxDate";
    default:
      return null;
  }
};
vc.valueManager = oi;
const Wg = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], ST = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], ET = ["minDateTime", "maxDateTime"], RT = [...Wg, ...ST, ...ET], Gg = (e) => RT.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {});
function Ug(e) {
  const {
    props: t,
    validator: n,
    value: r,
    timezone: i,
    onError: s
  } = e, a = Hs(), l = d.useRef(n.valueManager.defaultErrorState), c = n({
    adapter: a,
    value: r,
    timezone: i,
    props: t
  }), u = n.valueManager.hasError(c);
  d.useEffect(() => {
    s && !n.valueManager.isSameError(c, l.current) && s(c, r), l.current = c;
  }, [n, s, c, r]);
  const f = yt((g) => n({
    adapter: a,
    value: g,
    timezone: i,
    props: t
  }));
  return {
    validationError: c,
    hasValidationError: u,
    getValidationErrorForNewValue: f
  };
}
function TT(e) {
  return uo("MuiPickersPopper", e);
}
po("MuiPickersPopper", ["root", "paper"]);
function MT(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const kT = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation());
}, Jo = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? Jo(t.shadowRoot) : t : null;
}, PT = "@media (pointer: fine)", IT = "@media (prefers-reduced-motion: reduce)", ga = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), o5 = ga && ga[1] ? parseInt(ga[1], 10) : null, r5 = ga && ga[2] ? parseInt(ga[2], 10) : null, OT = o5 && o5 < 10 || r5 && r5 < 13 || !1, Yg = () => lg(IT, {
  defaultMatches: !1
}) || OT, DT = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], jT = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"],
    paper: ["paper"]
  }, TT, t);
}, FT = Z(us, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), VT = Z(li, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  outline: 0,
  transformOrigin: "top center",
  variants: [{
    props: ({
      placement: e
    }) => ["top", "top-start", "top-end"].includes(e),
    style: {
      transformOrigin: "bottom center"
    }
  }]
});
function $T(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function LT(e, t) {
  const n = d.useRef(!1), r = d.useRef(!1), i = d.useRef(null), s = d.useRef(!1);
  d.useEffect(() => {
    if (!e)
      return;
    function c() {
      s.current = !0;
    }
    return document.addEventListener("mousedown", c, !0), document.addEventListener("touchstart", c, !0), () => {
      document.removeEventListener("mousedown", c, !0), document.removeEventListener("touchstart", c, !0), s.current = !1;
    };
  }, [e]);
  const a = yt((c) => {
    if (!s.current)
      return;
    const u = r.current;
    r.current = !1;
    const f = ku(i.current);
    if (!i.current || // is a TouchEvent?
    "clientX" in c && $T(c, f))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let g;
    c.composedPath ? g = c.composedPath().indexOf(i.current) > -1 : g = !f.documentElement.contains(c.target) || i.current.contains(c.target), !g && !u && t(c);
  }), l = () => {
    r.current = !0;
  };
  return d.useEffect(() => {
    if (e) {
      const c = ku(i.current), u = () => {
        n.current = !0;
      };
      return c.addEventListener("touchstart", a), c.addEventListener("touchmove", u), () => {
        c.removeEventListener("touchstart", a), c.removeEventListener("touchmove", u);
      };
    }
  }, [e, a]), d.useEffect(() => {
    if (e) {
      const c = ku(i.current);
      return c.addEventListener("click", a), () => {
        c.removeEventListener("click", a), r.current = !1;
      };
    }
  }, [e, a]), [i, l, l];
}
const AT = /* @__PURE__ */ d.forwardRef((e, t) => {
  const {
    PaperComponent: n,
    popperPlacement: r,
    ownerState: i,
    children: s,
    paperSlotProps: a,
    paperClasses: l,
    onPaperClick: c,
    onPaperTouchStart: u
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, f = Zt(e, DT), g = Q({}, i, {
    placement: r
  }), h = kn({
    elementType: n,
    externalSlotProps: a,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: l,
    ownerState: g
  });
  return /* @__PURE__ */ p.jsx(n, Q({}, f, h, {
    onClick: (y) => {
      var v;
      c(y), (v = h.onClick) == null || v.call(h, y);
    },
    onTouchStart: (y) => {
      var v;
      u(y), (v = h.onTouchStart) == null || v.call(h, y);
    },
    ownerState: g,
    children: s
  }));
});
function NT(e) {
  const t = Kn({
    props: e,
    name: "MuiPickersPopper"
  }), {
    anchorEl: n,
    children: r,
    containerRef: i = null,
    shouldRestoreFocus: s,
    onBlur: a,
    onDismiss: l,
    open: c,
    role: u,
    placement: f,
    slots: g,
    slotProps: h,
    reduceAnimations: y
  } = t;
  d.useEffect(() => {
    function G(H) {
      c && H.key === "Escape" && l();
    }
    return document.addEventListener("keydown", G), () => {
      document.removeEventListener("keydown", G);
    };
  }, [l, c]);
  const v = d.useRef(null);
  d.useEffect(() => {
    u === "tooltip" || s && !s() || (c ? v.current = Jo(document) : v.current && v.current instanceof HTMLElement && setTimeout(() => {
      v.current instanceof HTMLElement && v.current.focus();
    }));
  }, [c, u, s]);
  const [m, b, C] = LT(c, a ?? l), E = d.useRef(null), S = Vo(E, i), k = Vo(S, m), T = t, P = jT(T), F = Yg(), j = y ?? F, L = (G) => {
    G.key === "Escape" && (G.stopPropagation(), l());
  }, R = (g == null ? void 0 : g.desktopTransition) ?? j ? Fi : ss, V = (g == null ? void 0 : g.desktopTrapFocus) ?? Wl, B = (g == null ? void 0 : g.desktopPaper) ?? VT, W = (g == null ? void 0 : g.popper) ?? FT, z = kn({
    elementType: W,
    externalSlotProps: h == null ? void 0 : h.popper,
    additionalProps: {
      transition: !0,
      role: u,
      open: c,
      anchorEl: n,
      placement: f,
      onKeyDown: L
    },
    className: P.root,
    ownerState: t
  });
  return /* @__PURE__ */ p.jsx(W, Q({}, z, {
    children: ({
      TransitionProps: G,
      placement: H
    }) => /* @__PURE__ */ p.jsx(V, Q({
      open: c,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: u === "tooltip",
      isEnabled: () => !0
    }, h == null ? void 0 : h.desktopTrapFocus, {
      children: /* @__PURE__ */ p.jsx(R, Q({}, G, h == null ? void 0 : h.desktopTransition, {
        children: /* @__PURE__ */ p.jsx(AT, {
          PaperComponent: B,
          ownerState: T,
          popperPlacement: H,
          ref: k,
          onPaperClick: b,
          onPaperTouchStart: C,
          paperClasses: P.paper,
          paperSlotProps: h == null ? void 0 : h.desktopPaper,
          children: r
        })
      }))
    }))
  }));
}
const i5 = /* @__PURE__ */ new Set();
function Yl(e, t = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const n = Array.isArray(e) ? e.join(`
`) : e;
  i5.has(n) || (i5.add(n), t === "error" ? console.error(n) : console.warn(n));
}
const BT = ({
  open: e,
  onOpen: t,
  onClose: n
}) => {
  const r = d.useRef(typeof e == "boolean").current, [i, s] = d.useState(!1);
  d.useEffect(() => {
    if (r) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      s(e);
    }
  }, [r, e]);
  const a = d.useCallback((l) => {
    r || s(l), l && t && t(), !l && n && n();
  }, [r, t, n]);
  return {
    isOpen: i,
    setIsOpen: a
  };
}, uf = ({
  timezone: e,
  value: t,
  defaultValue: n,
  referenceDate: r,
  onChange: i,
  valueManager: s
}) => {
  const a = no(), l = d.useRef(n), c = t ?? l.current ?? s.emptyValue, u = d.useMemo(() => s.getTimezone(a, c), [a, s, c]), f = yt((v) => u == null ? v : s.setTimezone(a, u, v));
  let g;
  e ? g = e : u ? g = u : r ? g = a.getTimezone(r) : g = "default";
  const h = d.useMemo(() => s.setTimezone(a, g, c), [s, a, g, c]), y = yt((v, ...m) => {
    const b = f(v);
    i == null || i(b, ...m);
  });
  return {
    value: h,
    handleValueChange: y,
    timezone: g
  };
}, df = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: r,
  referenceDate: i,
  onChange: s,
  valueManager: a
}) => {
  const [l, c] = Ls({
    name: e,
    state: "value",
    controlled: n,
    default: r ?? a.emptyValue
  }), u = yt((f, ...g) => {
    c(f), s == null || s(f, ...g);
  });
  return uf({
    timezone: t,
    value: l,
    defaultValue: void 0,
    referenceDate: i,
    onChange: u,
    valueManager: a
  });
}, _T = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: i
  } = e, s = !i && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? s && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? s ? !0 : n(r.lastPublishedValue) : !1;
}, zT = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: i,
    closeOnSelect: s
  } = e, a = !i && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? a && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && s ? a ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && n(r.lastCommittedValue) : !1;
}, HT = (e) => {
  const {
    action: t,
    closeOnSelect: n
  } = e;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && n : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, WT = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  validator: i
}) => {
  const {
    onAccept: s,
    onChange: a,
    value: l,
    defaultValue: c,
    closeOnSelect: u = r === "desktop",
    timezone: f,
    referenceDate: g
  } = e, {
    current: h
  } = d.useRef(c), {
    current: y
  } = d.useRef(l !== void 0), [v, m] = d.useState(f);
  process.env.NODE_ENV !== "production" && (d.useEffect(() => {
    y !== (l !== void 0) && console.error([`MUI X: A component is changing the ${y ? "" : "un"}controlled value of a picker to be ${y ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [l]), d.useEffect(() => {
    !y && h !== c && console.error(["MUI X: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(h)]));
  const b = no(), C = Hs(), {
    isOpen: E,
    setIsOpen: S
  } = BT(e), {
    timezone: k,
    value: T,
    handleValueChange: P
  } = uf({
    timezone: f,
    value: l,
    defaultValue: h,
    referenceDate: g,
    onChange: a,
    valueManager: t
  }), [F, j] = d.useState(() => {
    let oe;
    return T !== void 0 ? oe = T : h !== void 0 ? oe = h : oe = t.emptyValue, {
      draft: oe,
      lastPublishedValue: oe,
      lastCommittedValue: oe,
      lastControlledValue: l,
      hasBeenModifiedSinceMount: !1
    };
  }), L = t.getTimezone(b, F.draft);
  v !== f && (m(f), f && L && f !== L && j((oe) => Q({}, oe, {
    draft: t.setTimezone(b, f, oe.draft)
  })));
  const {
    getValidationErrorForNewValue: R
  } = Ug({
    props: e,
    validator: i,
    timezone: k,
    value: F.draft,
    onError: e.onError
  }), V = yt((oe) => {
    const de = {
      action: oe,
      dateState: F,
      hasChanged: (we) => !t.areValuesEqual(b, oe.value, we),
      isControlled: y,
      closeOnSelect: u
    }, ve = _T(de), J = zT(de), se = HT(de);
    j((we) => Q({}, we, {
      draft: oe.value,
      lastPublishedValue: ve ? oe.value : we.lastPublishedValue,
      lastCommittedValue: J ? oe.value : we.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    }));
    let ge = null;
    const Se = () => (ge || (ge = {
      validationError: oe.name === "setValueFromField" ? oe.context.validationError : R(oe.value)
    }, oe.name === "setValueFromShortcut" && (ge.shortcut = oe.shortcut)), ge);
    ve && P(oe.value, Se()), J && s && s(oe.value, Se()), se && S(!1);
  });
  if (F.lastControlledValue !== l) {
    const oe = t.areValuesEqual(b, F.draft, T);
    j((de) => Q({}, de, {
      lastControlledValue: l
    }, oe ? {} : {
      lastCommittedValue: T,
      lastPublishedValue: T,
      draft: T,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const B = yt(() => {
    V({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), W = yt(() => {
    V({
      value: F.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), z = yt(() => {
    V({
      value: F.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), G = yt(() => {
    V({
      value: F.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), H = yt(() => {
    V({
      value: t.getTodayValue(b, k, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), ie = yt((oe) => {
    oe.preventDefault(), S(!0);
  }), ce = yt((oe) => {
    oe == null || oe.preventDefault(), S(!1);
  }), re = yt((oe, de = "partial") => V({
    name: "setValueFromView",
    value: oe,
    selectionState: de
  })), A = yt((oe, de, ve) => V({
    name: "setValueFromShortcut",
    value: oe,
    changeImportance: de,
    shortcut: ve
  })), Y = yt((oe, de) => V({
    name: "setValueFromField",
    value: oe,
    context: de
  })), pe = {
    onClear: B,
    onAccept: W,
    onDismiss: z,
    onCancel: G,
    onSetToday: H,
    onOpen: ie,
    onClose: ce
  }, Ce = {
    value: F.draft,
    onChange: Y
  }, fe = d.useMemo(() => t.cleanValue(b, F.draft), [b, t, F.draft]), ee = {
    value: fe,
    onChange: re,
    onClose: ce,
    open: E
  }, ue = Q({}, pe, {
    value: fe,
    onChange: re,
    onSelectShortcut: A,
    isValid: (oe) => {
      const de = i({
        adapter: C,
        value: oe,
        timezone: k,
        props: e
      });
      return !t.hasError(de);
    }
  }), K = d.useMemo(() => ({
    onOpen: ie,
    onClose: ce,
    open: E
  }), [E, ce, ie]);
  return {
    open: E,
    fieldProps: Ce,
    viewProps: ee,
    layoutProps: ue,
    actions: pe,
    contextValue: K
  };
};
let Z1 = !1;
function Zg({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: r,
  views: i,
  autoFocus: s,
  focusedView: a,
  onFocusedViewChange: l
}) {
  process.env.NODE_ENV !== "production" && (Z1 || (r != null && !i.includes(r) && (console.warn(`MUI X: \`view="${r}"\` is not a valid prop.`, `It must be an element of \`views=["${i.join('", "')}"]\`.`), Z1 = !0), r == null && n != null && !i.includes(n) && (console.warn(`MUI X: \`openTo="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${i.join('", "')}"]\`.`), Z1 = !0)));
  const c = d.useRef(n), u = d.useRef(i), f = d.useRef(i.includes(n) ? n : i[0]), [g, h] = Ls({
    name: "useViews",
    state: "view",
    controlled: r,
    default: f.current
  }), y = d.useRef(s ? g : null), [v, m] = Ls({
    name: "useViews",
    state: "focusedView",
    controlled: a,
    default: y.current
  });
  d.useEffect(() => {
    (c.current && c.current !== n || u.current && u.current.some((F) => !i.includes(F))) && (h(i.includes(n) ? n : i[0]), u.current = i, c.current = n);
  }, [n, h, g, i]);
  const b = i.indexOf(g), C = i[b - 1] ?? null, E = i[b + 1] ?? null, S = yt((F, j) => {
    m(j ? F : (L) => F === L ? null : L), l == null || l(F, j);
  }), k = yt((F) => {
    S(F, !0), F !== g && (h(F), t && t(F));
  }), T = yt(() => {
    E && k(E);
  }), P = yt((F, j, L) => {
    const R = j === "finish", V = L ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but when it's not the final view given all `views` -> overall selection state should be `partial`.
      i.indexOf(L) < i.length - 1
    ) : !!E;
    if (e(F, R && V ? "partial" : j, L), L && L !== g) {
      const W = i[i.indexOf(L) + 1];
      W && k(W);
    } else R && T();
  });
  return {
    view: g,
    setView: k,
    focusedView: v,
    setFocusedView: S,
    nextView: E,
    previousView: C,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: i.includes(n) ? n : i[0],
    goToNextView: T,
    setValueAndGoToNextView: P
  };
}
const GT = ["className", "sx"], UT = ({
  props: e,
  propsFromPickerValue: t,
  additionalViewProps: n,
  autoFocusView: r,
  rendererInterceptor: i,
  fieldRef: s
}) => {
  const {
    onChange: a,
    open: l,
    onClose: c
  } = t, {
    view: u,
    views: f,
    openTo: g,
    onViewChange: h,
    viewRenderers: y,
    timezone: v
  } = e, m = Zt(e, GT), {
    view: b,
    setView: C,
    defaultView: E,
    focusedView: S,
    setFocusedView: k,
    setValueAndGoToNextView: T
  } = Zg({
    view: u,
    views: f,
    openTo: g,
    onChange: a,
    onViewChange: h,
    autoFocus: r
  }), {
    hasUIView: P,
    viewModeLookup: F
  } = d.useMemo(() => f.reduce((z, G) => {
    let H;
    return y[G] != null ? H = "UI" : H = "field", z.viewModeLookup[G] = H, H === "UI" && (z.hasUIView = !0), z;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [y, f]), j = d.useMemo(() => f.reduce((z, G) => y[G] != null && HR(G) ? z + 1 : z, 0), [y, f]), L = F[b], R = yt(() => L === "UI"), [V, B] = d.useState(L === "UI" ? b : null);
  return V !== b && F[b] === "UI" && B(b), ni(() => {
    L === "field" && l && (c(), setTimeout(() => {
      var z, G;
      (z = s == null ? void 0 : s.current) == null || z.setSelectedSections(b), (G = s == null ? void 0 : s.current) == null || G.focusField(b);
    }));
  }, [b]), ni(() => {
    if (!l)
      return;
    let z = b;
    L === "field" && V != null && (z = V), z !== E && F[z] === "UI" && F[E] === "UI" && (z = E), z !== b && C(z), k(z, !0);
  }, [l]), {
    hasUIView: P,
    shouldRestoreFocus: R,
    layoutProps: {
      views: f,
      view: V,
      onViewChange: C
    },
    renderCurrentView: () => {
      if (V == null)
        return null;
      const z = y[V];
      if (z == null)
        return null;
      const G = Q({}, m, n, t, {
        views: f,
        timezone: v,
        onChange: T,
        view: V,
        onViewChange: C,
        focusedView: S,
        onFocusedViewChange: k,
        showViewSwitcher: j > 1,
        timeViewsCount: j
      });
      return i ? i(y, V, G) : z(G);
    }
  };
};
function s5() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const YT = (e, t) => {
  const [n, r] = d.useState(s5);
  return ni(() => {
    const s = () => {
      r(s5());
    };
    return window.addEventListener("orientationchange", s), () => {
      window.removeEventListener("orientationchange", s);
    };
  }, []), MT(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}, ZT = ({
  props: e,
  propsFromPickerValue: t,
  propsFromPickerViews: n,
  wrapperVariant: r
}) => {
  const {
    orientation: i
  } = e, s = YT(n.views, i), a = Io();
  return {
    layoutProps: Q({}, n, t, {
      isLandscape: s,
      isRtl: a,
      wrapperVariant: r,
      disabled: e.disabled,
      readOnly: e.readOnly
    })
  };
};
function qT(e) {
  const {
    props: t,
    pickerValueResponse: n
  } = e;
  return d.useMemo(() => ({
    value: n.viewProps.value,
    open: n.open,
    disabled: t.disabled ?? !1,
    readOnly: t.readOnly ?? !1
  }), [n.viewProps.value, n.open, t.disabled, t.readOnly]);
}
const qg = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  additionalViewProps: i,
  validator: s,
  autoFocusView: a,
  rendererInterceptor: l,
  fieldRef: c
}) => {
  process.env.NODE_ENV !== "production" && e.renderInput != null && Yl(["MUI X: The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]);
  const u = WT({
    props: e,
    valueManager: t,
    valueType: n,
    wrapperVariant: r,
    validator: s
  }), f = UT({
    props: e,
    additionalViewProps: i,
    autoFocusView: a,
    fieldRef: c,
    propsFromPickerValue: u.viewProps,
    rendererInterceptor: l
  }), g = ZT({
    props: e,
    wrapperVariant: r,
    propsFromPickerValue: u.layoutProps,
    propsFromPickerViews: f.layoutProps
  }), h = qT({
    props: e,
    pickerValueResponse: u
  });
  return {
    // Picker value
    open: u.open,
    actions: u.actions,
    fieldProps: u.fieldProps,
    // Picker views
    renderCurrentView: f.renderCurrentView,
    hasUIView: f.hasUIView,
    shouldRestoreFocus: f.shouldRestoreFocus,
    // Picker layout
    layoutProps: g.layoutProps,
    // Picker context
    contextValue: u.contextValue,
    // Picker owner state
    ownerState: h
  };
};
function Kg(e) {
  return uo("MuiPickersLayout", e);
}
const hs = po("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]), KT = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function Xg(e) {
  const {
    onAccept: t,
    onClear: n,
    onCancel: r,
    onSetToday: i,
    actions: s
  } = e, a = Zt(e, KT), l = Li();
  if (s == null || s.length === 0)
    return null;
  const c = s == null ? void 0 : s.map((u) => {
    switch (u) {
      case "clear":
        return /* @__PURE__ */ p.jsx(Si, {
          onClick: n,
          children: l.clearButtonLabel
        }, u);
      case "cancel":
        return /* @__PURE__ */ p.jsx(Si, {
          onClick: r,
          children: l.cancelButtonLabel
        }, u);
      case "accept":
        return /* @__PURE__ */ p.jsx(Si, {
          onClick: t,
          children: l.okButtonLabel
        }, u);
      case "today":
        return /* @__PURE__ */ p.jsx(Si, {
          onClick: i,
          children: l.todayButtonLabel
        }, u);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ p.jsx(rg, Q({}, a, {
    children: c
  }));
}
process.env.NODE_ENV !== "production" && (Xg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: o.arrayOf(o.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: o.bool,
  onAccept: o.func.isRequired,
  onCancel: o.func.isRequired,
  onClear: o.func.isRequired,
  onSetToday: o.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const Zl = 36, Nd = 2, Bd = 320, XT = 280, pf = 336, QT = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], JT = ["getValue"];
function Qg(e) {
  const {
    items: t,
    changeImportance: n = "accept",
    onChange: r,
    isValid: i
  } = e, s = Zt(e, QT);
  if (t == null || t.length === 0)
    return null;
  const a = t.map((l) => {
    let {
      getValue: c
    } = l, u = Zt(l, JT);
    const f = c({
      isValid: i
    });
    return Q({}, u, {
      label: u.label,
      onClick: () => {
        r(f, n, u);
      },
      disabled: !i(f)
    });
  });
  return /* @__PURE__ */ p.jsx(Kp, Q({
    dense: !0,
    sx: [{
      maxHeight: pf,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(s.sx) ? s.sx : [s.sx]]
  }, s, {
    children: a.map((l) => /* @__PURE__ */ p.jsx(ug, {
      children: /* @__PURE__ */ p.jsx(Ia, Q({}, l))
    }, l.id ?? l.label))
  }));
}
process.env.NODE_ENV !== "production" && (Qg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: o.oneOf(["accept", "set"]),
  className: o.string,
  component: o.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: o.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: o.bool,
  isLandscape: o.bool.isRequired,
  isValid: o.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default []
   */
  items: o.arrayOf(o.shape({
    getValue: o.func.isRequired,
    id: o.string,
    label: o.string.isRequired
  })),
  onChange: o.func.isRequired,
  style: o.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function eM(e) {
  return e.view !== null;
}
const tM = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return co({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, Kg, t);
}, nM = (e) => {
  const {
    wrapperVariant: t,
    onAccept: n,
    onClear: r,
    onCancel: i,
    onSetToday: s,
    view: a,
    views: l,
    onViewChange: c,
    value: u,
    onChange: f,
    onSelectShortcut: g,
    isValid: h,
    isLandscape: y,
    disabled: v,
    readOnly: m,
    children: b,
    slots: C,
    slotProps: E
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = e, S = tM(e), k = (C == null ? void 0 : C.actionBar) ?? Xg, T = kn({
    elementType: k,
    externalSlotProps: E == null ? void 0 : E.actionBar,
    additionalProps: {
      onAccept: n,
      onClear: r,
      onCancel: i,
      onSetToday: s,
      actions: t === "desktop" ? [] : ["cancel", "accept"]
    },
    className: S.actionBar,
    ownerState: Q({}, e, {
      wrapperVariant: t
    })
  }), P = /* @__PURE__ */ p.jsx(k, Q({}, T)), F = C == null ? void 0 : C.toolbar, j = kn({
    elementType: F,
    externalSlotProps: E == null ? void 0 : E.toolbar,
    additionalProps: {
      isLandscape: y,
      onChange: f,
      value: u,
      view: a,
      onViewChange: c,
      views: l,
      disabled: v,
      readOnly: m
    },
    className: S.toolbar,
    ownerState: Q({}, e, {
      wrapperVariant: t
    })
  }), L = eM(j) && F ? /* @__PURE__ */ p.jsx(F, Q({}, j)) : null, R = b, V = C == null ? void 0 : C.tabs, B = a && V ? /* @__PURE__ */ p.jsx(V, Q({
    view: a,
    onViewChange: c,
    className: S.tabs
  }, E == null ? void 0 : E.tabs)) : null, W = (C == null ? void 0 : C.shortcuts) ?? Qg, z = kn({
    elementType: W,
    externalSlotProps: E == null ? void 0 : E.shortcuts,
    additionalProps: {
      isValid: h,
      isLandscape: y,
      onChange: g
    },
    className: S.shortcuts,
    ownerState: {
      isValid: h,
      isLandscape: y,
      onChange: g,
      wrapperVariant: t
    }
  }), G = a && W ? /* @__PURE__ */ p.jsx(W, Q({}, z)) : null;
  return {
    toolbar: L,
    content: R,
    tabs: B,
    actionBar: P,
    shortcuts: G
  };
}, oM = (e) => {
  const {
    isLandscape: t,
    classes: n
  } = e;
  return co({
    root: ["root", t && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, Kg, n);
}, rM = Z("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${hs.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      [`& .${hs.toolbar}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      },
      [`.${hs.shortcuts}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      }
    }
  }, {
    props: {
      isLandscape: !0,
      isRtl: !0
    },
    style: {
      [`& .${hs.toolbar}`]: {
        gridColumn: 3
      }
    }
  }, {
    props: {
      isLandscape: !1
    },
    style: {
      [`& .${hs.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      },
      [`& .${hs.shortcuts}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      }
    }
  }, {
    props: {
      isLandscape: !1,
      isRtl: !0
    },
    style: {
      [`& .${hs.shortcuts}`]: {
        gridColumn: 3
      }
    }
  }]
}), iM = Z("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (e, t) => t.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), ff = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: i,
    content: s,
    tabs: a,
    actionBar: l,
    shortcuts: c
  } = nM(r), {
    sx: u,
    className: f,
    isLandscape: g,
    wrapperVariant: h
  } = r, y = oM(r);
  return /* @__PURE__ */ p.jsxs(rM, {
    ref: n,
    sx: u,
    className: xe(y.root, f),
    ownerState: r,
    children: [g ? c : i, g ? i : c, /* @__PURE__ */ p.jsx(iM, {
      className: y.contentWrapper,
      children: h === "desktop" ? /* @__PURE__ */ p.jsxs(d.Fragment, {
        children: [s, a]
      }) : /* @__PURE__ */ p.jsxs(d.Fragment, {
        children: [a, s]
      })
    }), l]
  });
});
process.env.NODE_ENV !== "production" && (ff.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  disabled: o.bool,
  isLandscape: o.bool.isRequired,
  /**
   * `true` if the application is in right-to-left direction.
   */
  isRtl: o.bool.isRequired,
  isValid: o.func.isRequired,
  onAccept: o.func.isRequired,
  onCancel: o.func.isRequired,
  onChange: o.func.isRequired,
  onClear: o.func.isRequired,
  onClose: o.func.isRequired,
  onDismiss: o.func.isRequired,
  onOpen: o.func.isRequired,
  onSelectShortcut: o.func.isRequired,
  onSetToday: o.func.isRequired,
  onViewChange: o.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: o.oneOf(["landscape", "portrait"]),
  readOnly: o.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.any,
  view: o.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: o.arrayOf(o.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: o.oneOf(["desktop", "mobile"])
});
const sM = /* @__PURE__ */ d.createContext(null);
function Jg(e) {
  const {
    contextValue: t,
    localeText: n,
    children: r
  } = e;
  return /* @__PURE__ */ p.jsx(sM.Provider, {
    value: t,
    children: /* @__PURE__ */ p.jsx(Ld, {
      localeText: n,
      children: r
    })
  });
}
const aM = ["props", "getOpenDialogAriaText"], lM = ["ownerState"], cM = ["ownerState"], uM = (e) => {
  var Se;
  let {
    props: t,
    getOpenDialogAriaText: n
  } = e, r = Zt(e, aM);
  const {
    slots: i,
    slotProps: s,
    className: a,
    sx: l,
    format: c,
    formatDensity: u,
    enableAccessibleFieldDOMStructure: f,
    selectedSections: g,
    onSelectedSectionsChange: h,
    timezone: y,
    name: v,
    label: m,
    inputRef: b,
    readOnly: C,
    disabled: E,
    autoFocus: S,
    localeText: k,
    reduceAnimations: T
  } = t, P = d.useRef(null), F = d.useRef(null), j = mc(), L = ((Se = s == null ? void 0 : s.toolbar) == null ? void 0 : Se.hidden) ?? !1, {
    open: R,
    actions: V,
    hasUIView: B,
    layoutProps: W,
    renderCurrentView: z,
    shouldRestoreFocus: G,
    fieldProps: H,
    contextValue: ie,
    ownerState: ce
  } = qg(Q({}, r, {
    props: t,
    fieldRef: F,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), re = i.inputAdornment ?? jd, A = kn({
    elementType: re,
    externalSlotProps: s == null ? void 0 : s.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: t
  }), Y = Zt(A, lM), pe = i.openPickerButton ?? Ar, Ce = kn({
    elementType: pe,
    externalSlotProps: s == null ? void 0 : s.openPickerButton,
    additionalProps: {
      disabled: E || C,
      onClick: R ? V.onClose : V.onOpen,
      "aria-label": n(H.value),
      edge: Y.position
    },
    ownerState: t
  }), fe = Zt(Ce, cM), ee = i.openPickerIcon, te = kn({
    elementType: ee,
    externalSlotProps: s == null ? void 0 : s.openPickerIcon,
    ownerState: ce
  }), ue = i.field, K = kn({
    elementType: ue,
    externalSlotProps: s == null ? void 0 : s.field,
    additionalProps: Q({}, H, L && {
      id: j
    }, {
      readOnly: C,
      disabled: E,
      className: a,
      sx: l,
      format: c,
      formatDensity: u,
      enableAccessibleFieldDOMStructure: f,
      selectedSections: g,
      onSelectedSectionsChange: h,
      timezone: y,
      label: m,
      name: v,
      autoFocus: S && !t.open,
      focused: R ? !0 : void 0
    }, b ? {
      inputRef: b
    } : {}),
    ownerState: t
  });
  B && (K.InputProps = Q({}, K.InputProps, {
    ref: P
  }, !t.disableOpenPicker && {
    [`${Y.position}Adornment`]: /* @__PURE__ */ p.jsx(re, Q({}, Y, {
      children: /* @__PURE__ */ p.jsx(pe, Q({}, fe, {
        children: /* @__PURE__ */ p.jsx(ee, Q({}, te))
      }))
    }))
  }));
  const oe = Q({
    textField: i.textField,
    clearIcon: i.clearIcon,
    clearButton: i.clearButton
  }, K.slots), de = i.layout ?? ff;
  let ve = j;
  L && (m ? ve = `${j}-label` : ve = void 0);
  const J = Q({}, s, {
    toolbar: Q({}, s == null ? void 0 : s.toolbar, {
      titleId: j
    }),
    popper: Q({
      "aria-labelledby": ve
    }, s == null ? void 0 : s.popper)
  }), se = Vo(F, K.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ p.jsxs(Jg, {
      contextValue: ie,
      localeText: k,
      children: [/* @__PURE__ */ p.jsx(ue, Q({}, K, {
        slots: oe,
        slotProps: J,
        unstableFieldRef: se
      })), /* @__PURE__ */ p.jsx(NT, Q({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: P.current
      }, V, {
        open: R,
        slots: i,
        slotProps: J,
        shouldRestoreFocus: G,
        reduceAnimations: T,
        children: /* @__PURE__ */ p.jsx(de, Q({}, W, J == null ? void 0 : J.layout, {
          slots: i,
          slotProps: J,
          children: z()
        }))
      }))]
    })
  };
}, dM = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), pM = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), fM = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), gM = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
jn(/* @__PURE__ */ p.jsxs(d.Fragment, {
  children: [/* @__PURE__ */ p.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ p.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
jn(/* @__PURE__ */ p.jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
jn(/* @__PURE__ */ p.jsxs(d.Fragment, {
  children: [/* @__PURE__ */ p.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ p.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time");
const mM = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear"), hM = ({
  utils: e,
  format: t
}) => {
  let n = 10, r = t, i = e.expandFormat(t);
  for (; i !== r; )
    if (r = i, i = e.expandFormat(r), n -= 1, n < 0)
      throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
  return i;
}, vM = ({
  utils: e,
  expandedFormat: t
}) => {
  const n = [], {
    start: r,
    end: i
  } = e.escapedCharacters, s = new RegExp(`(\\${r}[^\\${i}]*\\${i})+`, "g");
  let a = null;
  for (; a = s.exec(t); )
    n.push({
      start: a.index,
      end: s.lastIndex - 1
    });
  return n;
}, yM = (e, t, n, r) => {
  switch (n.type) {
    case "year":
      return t.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.date(void 0, "default"), r).length,
        format: r
      });
    case "month":
      return t.fieldMonthPlaceholder({
        contentType: n.contentType,
        format: r
      });
    case "day":
      return t.fieldDayPlaceholder({
        format: r
      });
    case "weekDay":
      return t.fieldWeekDayPlaceholder({
        contentType: n.contentType,
        format: r
      });
    case "hours":
      return t.fieldHoursPlaceholder({
        format: r
      });
    case "minutes":
      return t.fieldMinutesPlaceholder({
        format: r
      });
    case "seconds":
      return t.fieldSecondsPlaceholder({
        format: r
      });
    case "meridiem":
      return t.fieldMeridiemPlaceholder({
        format: r
      });
    default:
      return r;
  }
}, bM = ({
  utils: e,
  date: t,
  shouldRespectLeadingZeros: n,
  localeText: r,
  localizedDigits: i,
  now: s,
  token: a,
  startSeparator: l
}) => {
  if (a === "")
    throw new Error("MUI X: Should not call `commitToken` with an empty token");
  const c = af(e, a), u = Ng(e, c.contentType, c.type, a), f = n ? u : c.contentType === "digit", g = t != null && e.isValid(t);
  let h = g ? e.formatByString(t, a) : "", y = null;
  if (f)
    if (u)
      y = h === "" ? e.formatByString(s, a).length : h.length;
    else {
      if (c.maxLength == null)
        throw new Error(`MUI X: The token ${a} should have a 'maxDigitNumber' property on it's adapter`);
      y = c.maxLength, g && (h = lf(Lg(As(h, i), y), i));
    }
  return Q({}, c, {
    format: a,
    maxLength: y,
    value: h,
    placeholder: yM(e, r, c, a),
    hasLeadingZerosInFormat: u,
    hasLeadingZerosInInput: f,
    startSeparator: l,
    endSeparator: "",
    modified: !1
  });
}, CM = (e) => {
  var y;
  const {
    utils: t,
    expandedFormat: n,
    escapedParts: r
  } = e, i = t.date(void 0), s = [];
  let a = "";
  const l = Object.keys(t.formatTokenMap).sort((v, m) => m.length - v.length), c = /^([a-zA-Z]+)/, u = new RegExp(`^(${l.join("|")})*$`), f = new RegExp(`^(${l.join("|")})`), g = (v) => r.find((m) => m.start <= v && m.end >= v);
  let h = 0;
  for (; h < n.length; ) {
    const v = g(h), m = v != null, b = (y = c.exec(n.slice(h))) == null ? void 0 : y[1];
    if (!m && b != null && u.test(b)) {
      let C = b;
      for (; C.length > 0; ) {
        const E = f.exec(C)[1];
        C = C.slice(E.length), s.push(bM(Q({}, e, {
          now: i,
          token: E,
          startSeparator: a
        }))), a = "";
      }
      h += b.length;
    } else {
      const C = n[h];
      m && (v == null ? void 0 : v.start) === h || (v == null ? void 0 : v.end) === h || (s.length === 0 ? a += C : s[s.length - 1].endSeparator += C), h += 1;
    }
  }
  return s.length === 0 && a.length > 0 && s.push({
    type: "empty",
    contentType: "letter",
    maxLength: null,
    format: "",
    value: "",
    placeholder: "",
    hasLeadingZerosInFormat: !1,
    hasLeadingZerosInInput: !1,
    startSeparator: a,
    endSeparator: "",
    modified: !1
  }), s;
}, xM = ({
  isRtl: e,
  formatDensity: t,
  sections: n
}) => n.map((r) => {
  const i = (s) => {
    let a = s;
    return e && a !== null && a.includes(" ") && (a = `⁩${a}⁦`), t === "spacious" && ["/", ".", "-"].includes(a) && (a = ` ${a} `), a;
  };
  return r.startSeparator = i(r.startSeparator), r.endSeparator = i(r.endSeparator), r;
}), a5 = (e) => {
  let t = hM(e);
  e.isRtl && e.enableAccessibleFieldDOMStructure && (t = t.split(" ").reverse().join(" "));
  const n = vM(Q({}, e, {
    expandedFormat: t
  })), r = CM(Q({}, e, {
    expandedFormat: t,
    escapedParts: n
  }));
  return xM(Q({}, e, {
    sections: r
  }));
}, wM = (e) => {
  const t = no(), n = Li(), r = Hs(), i = Io(), {
    valueManager: s,
    fieldValueManager: a,
    valueType: l,
    validator: c,
    internalProps: u,
    internalProps: {
      value: f,
      defaultValue: g,
      referenceDate: h,
      onChange: y,
      format: v,
      formatDensity: m = "dense",
      selectedSections: b,
      onSelectedSectionsChange: C,
      shouldRespectLeadingZeros: E = !1,
      timezone: S,
      enableAccessibleFieldDOMStructure: k = !1
    }
  } = e, {
    timezone: T,
    value: P,
    handleValueChange: F
  } = uf({
    timezone: S,
    value: f,
    defaultValue: g,
    referenceDate: h,
    onChange: y,
    valueManager: s
  }), j = d.useMemo(() => qR(t), [t]), L = d.useMemo(() => tT(t, j, T), [t, j, T]), R = d.useCallback((ee, te = null) => a.getSectionsFromValue(t, ee, te, (ue) => a5({
    utils: t,
    localeText: n,
    localizedDigits: j,
    format: v,
    date: ue,
    formatDensity: m,
    shouldRespectLeadingZeros: E,
    enableAccessibleFieldDOMStructure: k,
    isRtl: i
  })), [a, v, n, j, i, E, t, m, k]), [V, B] = d.useState(() => {
    const ee = R(P);
    e5(ee, l);
    const te = {
      sections: ee,
      value: P,
      referenceValue: s.emptyValue,
      tempValueStrAndroid: null
    }, ue = GR(ee), K = s.getInitialReferenceValue({
      referenceDate: h,
      value: P,
      utils: t,
      props: u,
      granularity: ue,
      timezone: T
    });
    return Q({}, te, {
      referenceValue: K
    });
  }), [W, z] = Ls({
    controlled: b,
    default: null,
    name: "useField",
    state: "selectedSections"
  }), G = (ee) => {
    z(ee), C == null || C(ee);
  }, H = d.useMemo(() => Y0(W, V.sections), [W, V.sections]), ie = H === "all" ? 0 : H, ce = ({
    value: ee,
    referenceValue: te,
    sections: ue
  }) => {
    if (B((oe) => Q({}, oe, {
      sections: ue,
      value: ee,
      referenceValue: te,
      tempValueStrAndroid: null
    })), s.areValuesEqual(t, V.value, ee))
      return;
    const K = {
      validationError: c({
        adapter: r,
        value: ee,
        timezone: T,
        props: u
      })
    };
    F(ee, K);
  }, re = (ee, te) => {
    const ue = [...V.sections];
    return ue[ee] = Q({}, ue[ee], {
      value: te,
      modified: !0
    }), ue;
  }, A = () => {
    ce({
      value: s.emptyValue,
      referenceValue: V.referenceValue,
      sections: R(s.emptyValue)
    });
  }, Y = () => {
    if (ie == null)
      return;
    const ee = V.sections[ie], te = a.getActiveDateManager(t, V, ee), K = te.getSections(V.sections).filter((J) => J.value !== "").length === (ee.value === "" ? 0 : 1), oe = re(ie, ""), de = K ? null : t.getInvalidDate(), ve = te.getNewValuesFromNewActiveDate(de);
    ce(Q({}, ve, {
      sections: oe
    }));
  }, pe = (ee) => {
    const te = (oe, de) => {
      const ve = t.parse(oe, v);
      if (ve == null || !t.isValid(ve))
        return null;
      const J = a5({
        utils: t,
        localeText: n,
        localizedDigits: j,
        format: v,
        date: ve,
        formatDensity: m,
        shouldRespectLeadingZeros: E,
        enableAccessibleFieldDOMStructure: k,
        isRtl: i
      });
      return n5(t, ve, J, de, !1);
    }, ue = a.parseValueStr(ee, V.referenceValue, te), K = a.updateReferenceValue(t, ue, V.referenceValue);
    ce({
      value: ue,
      referenceValue: K,
      sections: R(ue, V.sections)
    });
  }, Ce = ({
    activeSection: ee,
    newSectionValue: te,
    shouldGoToNextSection: ue
  }) => {
    ue && ie < V.sections.length - 1 && G(ie + 1);
    const K = a.getActiveDateManager(t, V, ee), oe = re(ie, te), de = K.getSections(oe), ve = QR(t, de, j);
    let J, se;
    if (ve != null && t.isValid(ve)) {
      const ge = n5(t, ve, de, K.referenceDate, !0);
      J = K.getNewValuesFromNewActiveDate(ge), se = !0;
    } else
      J = K.getNewValuesFromNewActiveDate(ve), se = (ve != null && !t.isValid(ve)) != (K.date != null && !t.isValid(K.date));
    return se ? ce(Q({}, J, {
      sections: oe
    })) : B((ge) => Q({}, ge, J, {
      sections: oe,
      tempValueStrAndroid: null
    }));
  }, fe = (ee) => B((te) => Q({}, te, {
    tempValueStrAndroid: ee
  }));
  return d.useEffect(() => {
    const ee = R(V.value);
    e5(ee, l), B((te) => Q({}, te, {
      sections: ee
    }));
  }, [v, t.locale, i]), d.useEffect(() => {
    let ee;
    s.areValuesEqual(t, V.value, P) ? ee = s.getTimezone(t, V.value) !== s.getTimezone(t, P) : ee = !0, ee && B((te) => Q({}, te, {
      value: P,
      referenceValue: a.updateReferenceValue(t, P, te.referenceValue),
      sections: R(P)
    }));
  }, [P]), {
    state: V,
    activeSectionIndex: ie,
    parsedSelectedSections: H,
    setSelectedSections: G,
    clearValue: A,
    clearActiveSection: Y,
    updateSectionValue: Ce,
    updateValueFromValueStr: pe,
    setTempAndroidValueStr: fe,
    getSectionsFromValue: R,
    sectionsValueBoundaries: L,
    localizedDigits: j,
    timezone: T
  };
}, SM = 5e3, na = (e) => e.saveQuery != null, EM = ({
  sections: e,
  updateSectionValue: t,
  sectionsValueBoundaries: n,
  localizedDigits: r,
  setTempAndroidValueStr: i,
  timezone: s
}) => {
  const a = no(), [l, c] = d.useState(null), u = yt(() => c(null));
  d.useEffect(() => {
    var v;
    l != null && ((v = e[l.sectionIndex]) == null ? void 0 : v.type) !== l.sectionType && u();
  }, [e, l, u]), d.useEffect(() => {
    if (l != null) {
      const v = setTimeout(() => u(), SM);
      return () => {
        clearTimeout(v);
      };
    }
    return () => {
    };
  }, [l, u]);
  const f = ({
    keyPressed: v,
    sectionIndex: m
  }, b, C) => {
    const E = v.toLowerCase(), S = e[m];
    if (l != null && (!C || C(l.value)) && l.sectionIndex === m) {
      const T = `${l.value}${E}`, P = b(T, S);
      if (!na(P))
        return c({
          sectionIndex: m,
          value: T,
          sectionType: S.type
        }), P;
    }
    const k = b(E, S);
    return na(k) && !k.saveQuery ? (u(), null) : (c({
      sectionIndex: m,
      value: E,
      sectionType: S.type
    }), na(k) ? null : k);
  }, g = (v) => {
    const m = (E, S, k) => {
      const T = S.filter((P) => P.toLowerCase().startsWith(k));
      return T.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: T[0],
        shouldGoToNextSection: T.length === 1
      };
    }, b = (E, S, k, T) => {
      const P = (F) => $g(a, s, S.type, F);
      if (S.contentType === "letter")
        return m(S.format, P(S.format), E);
      if (k && T != null && af(a, k).contentType === "letter") {
        const F = P(k), j = m(k, F, E);
        return na(j) ? {
          saveQuery: !1
        } : Q({}, j, {
          sectionValue: T(j.sectionValue, F)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return f(v, (E, S) => {
      switch (S.type) {
        case "month": {
          const k = (T) => Q3(a, T, a.formats.month, S.format);
          return b(E, S, a.formats.month, k);
        }
        case "weekDay": {
          const k = (T, P) => P.indexOf(T).toString();
          return b(E, S, a.formats.weekday, k);
        }
        case "meridiem":
          return b(E, S);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, h = (v) => {
    const m = (C, E) => {
      const S = As(C, r), k = Number(S), T = n[E.type]({
        currentDate: null,
        format: E.format,
        contentType: E.contentType
      });
      if (k > T.maximum)
        return {
          saveQuery: !1
        };
      if (k < T.minimum)
        return {
          saveQuery: !0
        };
      const P = k * 10 > T.maximum || S.length === T.maximum.toString().length;
      return {
        sectionValue: Ag(a, k, T, r, E),
        shouldGoToNextSection: P
      };
    };
    return f(v, (C, E) => {
      if (E.contentType === "digit" || E.contentType === "digit-with-letter")
        return m(C, E);
      if (E.type === "month") {
        Ng(a, "digit", "month", "MM");
        const S = m(C, {
          type: E.type,
          format: "MM",
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (na(S))
          return S;
        const k = Q3(a, S.sectionValue, "MM", E.format);
        return Q({}, S, {
          sectionValue: k
        });
      }
      if (E.type === "weekDay") {
        const S = m(C, E);
        if (na(S))
          return S;
        const k = $d(a, E.format)[Number(S.sectionValue) - 1];
        return Q({}, S, {
          sectionValue: k
        });
      }
      return {
        saveQuery: !1
      };
    }, (C) => X3(C, r));
  };
  return {
    applyCharacterEditing: yt((v) => {
      const m = e[v.sectionIndex], C = X3(v.keyPressed, r) ? h(Q({}, v, {
        keyPressed: lf(v.keyPressed, r)
      })) : g(v);
      if (C == null) {
        i(null);
        return;
      }
      t({
        activeSection: m,
        newSectionValue: C.sectionValue,
        shouldGoToNextSection: C.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: u
  };
}, RM = (e) => {
  const {
    internalProps: {
      disabled: t,
      readOnly: n = !1
    },
    forwardedProps: {
      sectionListRef: r,
      onBlur: i,
      onClick: s,
      onFocus: a,
      onInput: l,
      onPaste: c,
      focused: u,
      autoFocus: f = !1
    },
    fieldValueManager: g,
    applyCharacterEditing: h,
    resetCharacterQuery: y,
    setSelectedSections: v,
    parsedSelectedSections: m,
    state: b,
    clearActiveSection: C,
    clearValue: E,
    updateSectionValue: S,
    updateValueFromValueStr: k,
    sectionOrder: T,
    areAllSectionsEmpty: P,
    sectionsValueBoundaries: F
  } = e, j = d.useRef(null), L = Vo(r, j), R = Li(), V = no(), B = mc(), [W, z] = d.useState(!1), G = d.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!j.current)
        return;
      const se = document.getSelection();
      if (!se)
        return;
      if (m == null) {
        se.rangeCount > 0 && j.current.getRoot().contains(se.getRangeAt(0).startContainer) && se.removeAllRanges(), W && j.current.getRoot().blur();
        return;
      }
      if (!j.current.getRoot().contains(Jo(document)))
        return;
      const ge = new window.Range();
      let Se;
      m === "all" ? Se = j.current.getRoot() : b.sections[m].type === "empty" ? Se = j.current.getSectionContainer(m) : Se = j.current.getSectionContent(m), ge.selectNodeContents(Se), Se.focus(), se.removeAllRanges(), se.addRange(ge);
    },
    getActiveSectionIndexFromDOM: () => {
      const se = Jo(document);
      return !se || !j.current || !j.current.getRoot().contains(se) ? null : j.current.getSectionIndexFromDOMElement(se);
    },
    focusField: (se = 0) => {
      if (!j.current || // if the field is already focused, we don't need to focus it again
      G.getActiveSectionIndexFromDOM() != null)
        return;
      const ge = Y0(se, b.sections);
      z(!0), j.current.getSectionContent(ge).focus();
    },
    setSelectedSections: (se) => {
      if (!j.current)
        return;
      const ge = Y0(se, b.sections);
      z((ge === "all" ? 0 : ge) !== null), v(se);
    },
    isFieldFocused: () => {
      const se = Jo(document);
      return !!j.current && j.current.getRoot().contains(se);
    }
  }), [m, v, b.sections, W]), H = yt((se) => {
    if (!j.current)
      return;
    const ge = b.sections[se];
    j.current.getSectionContent(se).innerHTML = ge.value || ge.placeholder, G.syncSelectionToDOM();
  }), ie = yt((se, ...ge) => {
    se.isDefaultPrevented() || !j.current || (z(!0), s == null || s(se, ...ge), m === "all" ? setTimeout(() => {
      const Se = document.getSelection().getRangeAt(0).startOffset;
      if (Se === 0) {
        v(T.startIndex);
        return;
      }
      let we = 0, me = 0;
      for (; me < Se && we < b.sections.length; ) {
        const ye = b.sections[we];
        we += 1, me += `${ye.startSeparator}${ye.value || ye.placeholder}${ye.endSeparator}`.length;
      }
      v(we - 1);
    }) : W ? j.current.getRoot().contains(se.target) || v(T.startIndex) : (z(!0), v(T.startIndex)));
  }), ce = yt((se) => {
    if (l == null || l(se), !j.current || m !== "all")
      return;
    const Se = se.target.textContent ?? "";
    j.current.getRoot().innerHTML = b.sections.map((we) => `${we.startSeparator}${we.value || we.placeholder}${we.endSeparator}`).join(""), G.syncSelectionToDOM(), Se.length === 0 || Se.charCodeAt(0) === 10 ? (y(), E(), v("all")) : Se.length > 1 ? k(Se) : (m === "all" && v(0), h({
      keyPressed: Se,
      sectionIndex: 0
    }));
  }), re = yt((se) => {
    if (c == null || c(se), n || m !== "all") {
      se.preventDefault();
      return;
    }
    const ge = se.clipboardData.getData("text");
    se.preventDefault(), y(), k(ge);
  }), A = yt((...se) => {
    if (a == null || a(...se), W || !j.current)
      return;
    z(!0), j.current.getSectionIndexFromDOMElement(Jo(document)) != null || v(T.startIndex);
  }), Y = yt((...se) => {
    i == null || i(...se), setTimeout(() => {
      if (!j.current)
        return;
      const ge = Jo(document);
      !j.current.getRoot().contains(ge) && (z(!1), v(null));
    });
  }), pe = yt((se) => (ge) => {
    ge.isDefaultPrevented() || v(se);
  }), Ce = yt((se) => {
    se.preventDefault();
  }), fe = yt((se) => () => {
    v(se);
  }), ee = yt((se) => {
    if (se.preventDefault(), n || t || typeof m != "number")
      return;
    const ge = b.sections[m], Se = se.clipboardData.getData("text"), we = /^[a-zA-Z]+$/.test(Se), me = /^[0-9]+$/.test(Se), ye = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(Se);
    ge.contentType === "letter" && we || ge.contentType === "digit" && me || ge.contentType === "digit-with-letter" && ye ? (y(), S({
      activeSection: ge,
      newSectionValue: Se,
      shouldGoToNextSection: !0
    })) : !we && !me && (y(), k(Se));
  }), te = yt((se) => {
    se.preventDefault(), se.dataTransfer.dropEffect = "none";
  }), ue = yt((se) => {
    if (!j.current)
      return;
    const ge = se.target, Se = ge.textContent ?? "", we = j.current.getSectionIndexFromDOMElement(ge), me = b.sections[we];
    if (n || !j.current) {
      H(we);
      return;
    }
    if (Se.length === 0) {
      if (me.value === "") {
        H(we);
        return;
      }
      const ye = se.nativeEvent.inputType;
      if (ye === "insertParagraph" || ye === "insertLineBreak") {
        H(we);
        return;
      }
      y(), C();
      return;
    }
    h({
      keyPressed: Se,
      sectionIndex: we
    }), H(we);
  });
  ni(() => {
    if (!(!W || !j.current)) {
      if (m === "all")
        j.current.getRoot().focus();
      else if (typeof m == "number") {
        const se = j.current.getSectionContent(m);
        se && se.focus();
      }
    }
  }, [m, W]);
  const K = d.useMemo(() => b.sections.reduce((se, ge) => (se[ge.type] = F[ge.type]({
    currentDate: null,
    contentType: ge.contentType,
    format: ge.format
  }), se), {}), [F, b.sections]), oe = m === "all", de = d.useMemo(() => b.sections.map((se, ge) => {
    const Se = !oe && !t && !n;
    return {
      container: {
        "data-sectionindex": ge,
        onClick: pe(ge)
      },
      content: {
        tabIndex: oe || ge > 0 ? -1 : 0,
        contentEditable: !oe && !t && !n,
        role: "spinbutton",
        id: `${B}-${se.type}`,
        "aria-labelledby": `${B}-${se.type}`,
        "aria-readonly": n,
        "aria-valuenow": sT(se, V),
        "aria-valuemin": K[se.type].minimum,
        "aria-valuemax": K[se.type].maximum,
        "aria-valuetext": se.value ? iT(se, V) : R.empty,
        "aria-label": R[se.type],
        "aria-disabled": t,
        spellCheck: Se ? !1 : void 0,
        autoCapitalize: Se ? "off" : void 0,
        autoCorrect: Se ? "off" : void 0,
        [parseInt(d.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: Se ? "next" : void 0,
        children: se.value || se.placeholder,
        onInput: ue,
        onPaste: ee,
        onFocus: fe(ge),
        onDragOver: te,
        onMouseUp: Ce,
        inputMode: se.contentType === "letter" ? "text" : "numeric"
      },
      before: {
        children: se.startSeparator
      },
      after: {
        children: se.endSeparator
      }
    };
  }), [b.sections, fe, ee, te, ue, pe, Ce, t, n, oe, R, V, K, B]), ve = yt((se) => {
    k(se.target.value);
  }), J = d.useMemo(() => P ? "" : g.getV7HiddenInputValueFromSections(b.sections), [P, b.sections, g]);
  return d.useEffect(() => {
    if (j.current == null)
      throw new Error(["MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`", "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.", "", "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:", "", "<DatePicker slots={{ textField: MyCustomTextField }} />", "", "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"].join(`
`));
    f && j.current && j.current.getSectionContent(T.startIndex).focus();
  }, []), {
    interactions: G,
    returnedValue: {
      // Forwarded
      autoFocus: f,
      readOnly: n,
      focused: u ?? W,
      sectionListRef: L,
      onBlur: Y,
      onClick: ie,
      onFocus: A,
      onInput: ce,
      onPaste: re,
      // Additional
      enableAccessibleFieldDOMStructure: !0,
      elements: de,
      // TODO v7: Try to set to undefined when there is a section selected.
      tabIndex: m === 0 ? -1 : 0,
      contentEditable: oe,
      value: J,
      onChange: ve,
      areAllSectionsEmpty: P
    }
  };
}, ua = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), TM = (e, t, n) => {
  let r = 0, i = n ? 1 : 0;
  const s = [];
  for (let a = 0; a < e.length; a += 1) {
    const l = e[a], c = cf(l, n ? "input-rtl" : "input-ltr", t), u = `${l.startSeparator}${c}${l.endSeparator}`, f = ua(u).length, g = u.length, h = ua(c), y = i + (h === "" ? 0 : c.indexOf(h[0])) + l.startSeparator.length, v = y + h.length;
    s.push(Q({}, l, {
      start: r,
      end: r + f,
      startInInput: y,
      endInInput: v
    })), r += f, i += g;
  }
  return s;
}, MM = (e) => {
  const t = Io(), n = d.useRef(void 0), r = d.useRef(void 0), {
    forwardedProps: {
      onFocus: i,
      onClick: s,
      onPaste: a,
      onBlur: l,
      inputRef: c,
      placeholder: u
    },
    internalProps: {
      readOnly: f = !1,
      disabled: g = !1
    },
    parsedSelectedSections: h,
    activeSectionIndex: y,
    state: v,
    fieldValueManager: m,
    valueManager: b,
    applyCharacterEditing: C,
    resetCharacterQuery: E,
    updateSectionValue: S,
    updateValueFromValueStr: k,
    clearActiveSection: T,
    clearValue: P,
    setTempAndroidValueStr: F,
    setSelectedSections: j,
    getSectionsFromValue: L,
    areAllSectionsEmpty: R,
    localizedDigits: V
  } = e, B = d.useRef(null), W = Vo(c, B), z = d.useMemo(() => TM(v.sections, V, t), [v.sections, V, t]), G = d.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!B.current)
        return;
      if (h == null) {
        B.current.scrollLeft && (B.current.scrollLeft = 0);
        return;
      }
      if (B.current !== Jo(document))
        return;
      const ue = B.current.scrollTop;
      if (h === "all")
        B.current.select();
      else {
        const K = z[h], oe = K.type === "empty" ? K.startInInput - K.startSeparator.length : K.startInInput, de = K.type === "empty" ? K.endInInput + K.endSeparator.length : K.endInInput;
        (oe !== B.current.selectionStart || de !== B.current.selectionEnd) && B.current === Jo(document) && B.current.setSelectionRange(oe, de), clearTimeout(r.current), r.current = setTimeout(() => {
          B.current && B.current === Jo(document) && // The section might loose all selection, where `selectionStart === selectionEnd`
          // https://github.com/mui/mui-x/pull/13652
          B.current.selectionStart === B.current.selectionEnd && (B.current.selectionStart !== oe || B.current.selectionEnd !== de) && G.syncSelectionToDOM();
        });
      }
      B.current.scrollTop = ue;
    },
    getActiveSectionIndexFromDOM: () => {
      const ue = B.current.selectionStart ?? 0, K = B.current.selectionEnd ?? 0;
      if (ue === 0 && K === 0)
        return null;
      const oe = ue <= z[0].startInInput ? 1 : z.findIndex((de) => de.startInInput - de.startSeparator.length > ue);
      return oe === -1 ? z.length - 1 : oe - 1;
    },
    focusField: (ue = 0) => {
      var K;
      Jo(document) !== B.current && ((K = B.current) == null || K.focus(), j(ue));
    },
    setSelectedSections: (ue) => j(ue),
    isFieldFocused: () => B.current === Jo(document)
  }), [B, h, z, j]), H = () => {
    const ue = B.current.selectionStart ?? 0;
    let K;
    ue <= z[0].startInInput || ue >= z[z.length - 1].endInInput ? K = 1 : K = z.findIndex((de) => de.startInInput - de.startSeparator.length > ue);
    const oe = K === -1 ? z.length - 1 : K - 1;
    j(oe);
  }, ie = yt((...ue) => {
    i == null || i(...ue);
    const K = B.current;
    clearTimeout(n.current), n.current = setTimeout(() => {
      !K || K !== B.current || y == null && (// avoid selecting all sections when focusing empty field without value
      K.value.length && Number(K.selectionEnd) - Number(K.selectionStart) === K.value.length ? j("all") : H());
    });
  }), ce = yt((ue, ...K) => {
    ue.isDefaultPrevented() || (s == null || s(ue, ...K), H());
  }), re = yt((ue) => {
    if (a == null || a(ue), ue.preventDefault(), f || g)
      return;
    const K = ue.clipboardData.getData("text");
    if (typeof h == "number") {
      const oe = v.sections[h], de = /^[a-zA-Z]+$/.test(K), ve = /^[0-9]+$/.test(K), J = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(K);
      if (oe.contentType === "letter" && de || oe.contentType === "digit" && ve || oe.contentType === "digit-with-letter" && J) {
        E(), S({
          activeSection: oe,
          newSectionValue: K,
          shouldGoToNextSection: !0
        });
        return;
      }
      if (de || ve)
        return;
    }
    E(), k(K);
  }), A = yt((...ue) => {
    l == null || l(...ue), j(null);
  }), Y = yt((ue) => {
    if (f)
      return;
    const K = ue.target.value;
    if (K === "") {
      E(), P();
      return;
    }
    const oe = ue.nativeEvent.data, de = oe && oe.length > 1, ve = de ? oe : K, J = ua(ve);
    if (h === "all" && j(y), y == null || de) {
      k(de ? oe : J);
      return;
    }
    let se;
    if (h === "all" && J.length === 1)
      se = J;
    else {
      const ge = ua(m.getV6InputValueFromSections(z, V, t));
      let Se = -1, we = -1;
      for (let je = 0; je < ge.length; je += 1)
        Se === -1 && ge[je] !== J[je] && (Se = je), we === -1 && ge[ge.length - je - 1] !== J[J.length - je - 1] && (we = je);
      const me = z[y];
      if (Se < me.start || ge.length - we - 1 > me.end)
        return;
      const Ie = J.length - ge.length + me.end - ua(me.endSeparator || "").length;
      se = J.slice(me.start + ua(me.startSeparator || "").length, Ie);
    }
    if (se.length === 0) {
      oT() && F(ve), E(), T();
      return;
    }
    C({
      keyPressed: se,
      sectionIndex: y
    });
  }), pe = d.useMemo(() => u !== void 0 ? u : m.getV6InputValueFromSections(L(b.emptyValue), V, t), [u, m, L, b.emptyValue, V, t]), Ce = d.useMemo(() => v.tempValueStrAndroid ?? m.getV6InputValueFromSections(v.sections, V, t), [v.sections, m, v.tempValueStrAndroid, V, t]);
  d.useEffect(() => (B.current && B.current === Jo(document) && j("all"), () => {
    clearTimeout(n.current), clearTimeout(r.current);
  }), []);
  const fe = d.useMemo(() => y == null || v.sections[y].contentType === "letter" ? "text" : "numeric", [y, v.sections]), te = !(B.current && B.current === Jo(document)) && R;
  return {
    interactions: G,
    returnedValue: {
      // Forwarded
      readOnly: f,
      onBlur: A,
      onClick: ce,
      onFocus: ie,
      onPaste: re,
      inputRef: W,
      // Additional
      enableAccessibleFieldDOMStructure: !1,
      placeholder: pe,
      inputMode: fe,
      autoComplete: "off",
      value: te ? "" : Ce,
      onChange: Y
    }
  };
}, kM = (e) => {
  const t = no(), {
    internalProps: n,
    internalProps: {
      unstableFieldRef: r,
      minutesStep: i,
      enableAccessibleFieldDOMStructure: s = !1,
      disabled: a = !1,
      readOnly: l = !1
    },
    forwardedProps: {
      onKeyDown: c,
      error: u,
      clearable: f,
      onClear: g
    },
    fieldValueManager: h,
    valueManager: y,
    validator: v
  } = e, m = Io(), b = wM(e), {
    state: C,
    activeSectionIndex: E,
    parsedSelectedSections: S,
    setSelectedSections: k,
    clearValue: T,
    clearActiveSection: P,
    updateSectionValue: F,
    setTempAndroidValueStr: j,
    sectionsValueBoundaries: L,
    localizedDigits: R,
    timezone: V
  } = b, B = EM({
    sections: C.sections,
    updateSectionValue: F,
    sectionsValueBoundaries: L,
    localizedDigits: R,
    setTempAndroidValueStr: j,
    timezone: V
  }), {
    resetCharacterQuery: W
  } = B, z = y.areValuesEqual(t, C.value, y.emptyValue), G = s ? RM : MM, H = d.useMemo(() => rT(C.sections, m && !s), [C.sections, m, s]), {
    returnedValue: ie,
    interactions: ce
  } = G(Q({}, e, b, B, {
    areAllSectionsEmpty: z,
    sectionOrder: H
  })), re = yt((ee) => {
    if (c == null || c(ee), !a)
      switch (!0) {
        case ((ee.ctrlKey || ee.metaKey) && String.fromCharCode(ee.keyCode) === "A" && !ee.shiftKey && !ee.altKey): {
          ee.preventDefault(), k("all");
          break;
        }
        case ee.key === "ArrowRight": {
          if (ee.preventDefault(), S == null)
            k(H.startIndex);
          else if (S === "all")
            k(H.endIndex);
          else {
            const te = H.neighbors[S].rightIndex;
            te !== null && k(te);
          }
          break;
        }
        case ee.key === "ArrowLeft": {
          if (ee.preventDefault(), S == null)
            k(H.endIndex);
          else if (S === "all")
            k(H.startIndex);
          else {
            const te = H.neighbors[S].leftIndex;
            te !== null && k(te);
          }
          break;
        }
        case ee.key === "Delete": {
          if (ee.preventDefault(), l)
            break;
          S == null || S === "all" ? T() : P(), W();
          break;
        }
        case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(ee.key): {
          if (ee.preventDefault(), l || E == null)
            break;
          S === "all" && k(E);
          const te = C.sections[E], ue = h.getActiveDateManager(t, C, te), K = KR(t, V, te, ee.key, L, R, ue.date, {
            minutesStep: i
          });
          F({
            activeSection: te,
            newSectionValue: K,
            shouldGoToNextSection: !1
          });
          break;
        }
      }
  });
  ni(() => {
    ce.syncSelectionToDOM();
  });
  const {
    hasValidationError: A
  } = Ug({
    props: n,
    validator: v,
    timezone: V,
    value: C.value,
    onError: n.onError
  }), Y = d.useMemo(() => u !== void 0 ? u : A, [A, u]);
  d.useEffect(() => {
    !Y && E == null && W();
  }, [C.referenceValue, E, Y]), d.useEffect(() => {
    C.tempValueStrAndroid != null && E != null && (W(), P());
  }, [C.sections]), d.useImperativeHandle(r, () => ({
    getSections: () => C.sections,
    getActiveSectionIndex: ce.getActiveSectionIndexFromDOM,
    setSelectedSections: ce.setSelectedSections,
    focusField: ce.focusField,
    isFieldFocused: ce.isFieldFocused
  }));
  const pe = yt((ee, ...te) => {
    ee.preventDefault(), g == null || g(ee, ...te), T(), ce.isFieldFocused() ? k(H.startIndex) : ce.focusField(0);
  }), Ce = {
    onKeyDown: re,
    onClear: pe,
    error: Y,
    clearable: !!(f && !z && !l && !a)
  }, fe = {
    disabled: a,
    readOnly: l
  };
  return Q({}, e.forwardedProps, Ce, fe, ie);
}, PM = ["clearable", "onClear", "InputProps", "sx", "slots", "slotProps"], IM = ["ownerState"], OM = (e) => {
  const t = Li(), {
    clearable: n,
    onClear: r,
    InputProps: i,
    sx: s,
    slots: a,
    slotProps: l
  } = e, c = Zt(e, PM), u = (a == null ? void 0 : a.clearButton) ?? Ar, f = kn({
    elementType: u,
    externalSlotProps: l == null ? void 0 : l.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: t.fieldClearLabel
    }
  }), g = Zt(f, IM), h = (a == null ? void 0 : a.clearIcon) ?? mM, y = kn({
    elementType: h,
    externalSlotProps: l == null ? void 0 : l.clearIcon,
    ownerState: {}
  });
  return Q({}, c, {
    InputProps: Q({}, i, {
      endAdornment: /* @__PURE__ */ p.jsxs(d.Fragment, {
        children: [n && /* @__PURE__ */ p.jsx(jd, {
          position: "end",
          sx: {
            marginRight: i != null && i.endAdornment ? -1 : -1.5
          },
          children: /* @__PURE__ */ p.jsx(u, Q({}, g, {
            onClick: r,
            children: /* @__PURE__ */ p.jsx(h, Q({
              fontSize: "small"
            }, y))
          }))
        }), i == null ? void 0 : i.endAdornment]
      })
    }),
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(s) ? s : [s]]
  });
}, DM = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef", "enableAccessibleFieldDOMStructure", "disabled", "readOnly", "dateSeparator"], jM = (e, t) => d.useMemo(() => {
  const n = Q({}, e), r = {}, i = (s) => {
    n.hasOwnProperty(s) && (r[s] = n[s], delete n[s]);
  };
  return DM.forEach(i), Wg.forEach(i), {
    forwardedProps: n,
    internalProps: r
  };
}, [e, t]), FM = (e) => {
  const t = no(), n = hc();
  return Q({}, e, {
    disablePast: e.disablePast ?? !1,
    disableFuture: e.disableFuture ?? !1,
    format: e.format ?? t.formats.keyboardDate,
    minDate: Pr(t, e.minDate, n.minDate),
    maxDate: Pr(t, e.maxDate, n.maxDate)
  });
}, VM = (e) => {
  const t = FM(e), {
    forwardedProps: n,
    internalProps: r
  } = jM(t, "date");
  return kM({
    forwardedProps: n,
    internalProps: r,
    valueManager: oi,
    fieldValueManager: lT,
    validator: vc,
    valueType: "date"
  });
};
function $M(e) {
  return uo("MuiPickersTextField", e);
}
po("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);
function LM(e) {
  return uo("MuiPickersInputBase", e);
}
const ma = po("MuiPickersInputBase", ["root", "focused", "disabled", "error", "notchedOutline", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input"]);
function AM(e) {
  return uo("MuiPickersSectionList", e);
}
const il = po("MuiPickersSectionList", ["root", "section", "sectionContent"]), NM = ["slots", "slotProps", "elements", "sectionListRef"], em = Z("div", {
  name: "MuiPickersSectionList",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  direction: "ltr /*! @noflip */",
  outline: "none"
}), tm = Z("span", {
  name: "MuiPickersSectionList",
  slot: "Section",
  overridesResolver: (e, t) => t.section
})({}), nm = Z("span", {
  name: "MuiPickersSectionList",
  slot: "SectionSeparator",
  overridesResolver: (e, t) => t.sectionSeparator
})({
  whiteSpace: "pre"
}), om = Z("span", {
  name: "MuiPickersSectionList",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.sectionContent
})({
  outline: "none"
}), BM = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"],
    section: ["section"],
    sectionContent: ["sectionContent"]
  }, AM, t);
};
function rm(e) {
  const {
    slots: t,
    slotProps: n,
    element: r,
    classes: i
  } = e, s = (t == null ? void 0 : t.section) ?? tm, a = kn({
    elementType: s,
    externalSlotProps: n == null ? void 0 : n.section,
    externalForwardedProps: r.container,
    className: i.section,
    ownerState: {}
  }), l = (t == null ? void 0 : t.sectionContent) ?? om, c = kn({
    elementType: l,
    externalSlotProps: n == null ? void 0 : n.sectionContent,
    externalForwardedProps: r.content,
    additionalProps: {
      suppressContentEditableWarning: !0
    },
    className: i.sectionContent,
    ownerState: {}
  }), u = (t == null ? void 0 : t.sectionSeparator) ?? nm, f = kn({
    elementType: u,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: r.before,
    ownerState: {
      position: "before"
    }
  }), g = kn({
    elementType: u,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: r.after,
    ownerState: {
      position: "after"
    }
  });
  return /* @__PURE__ */ p.jsxs(s, Q({}, a, {
    children: [/* @__PURE__ */ p.jsx(u, Q({}, f)), /* @__PURE__ */ p.jsx(l, Q({}, c)), /* @__PURE__ */ p.jsx(u, Q({}, g))]
  }));
}
process.env.NODE_ENV !== "production" && (rm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: o.object.isRequired,
  element: o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  }).isRequired,
  /**
   * The props used for each component slot.
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   */
  slots: o.object
});
const im = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiPickersSectionList"
  }), {
    slots: i,
    slotProps: s,
    elements: a,
    sectionListRef: l
  } = r, c = Zt(r, NM), u = BM(r), f = d.useRef(null), g = Vo(n, f), h = (m) => {
    if (!f.current)
      throw new Error(`MUI X: Cannot call sectionListRef.${m} before the mount of the component.`);
    return f.current;
  };
  d.useImperativeHandle(l, () => ({
    getRoot() {
      return h("getRoot");
    },
    getSectionContainer(m) {
      return h("getSectionContainer").querySelector(`.${il.section}[data-sectionindex="${m}"]`);
    },
    getSectionContent(m) {
      return h("getSectionContent").querySelector(`.${il.section}[data-sectionindex="${m}"] .${il.sectionContent}`);
    },
    getSectionIndexFromDOMElement(m) {
      const b = h("getSectionIndexFromDOMElement");
      if (m == null || !b.contains(m))
        return null;
      let C = null;
      return m.classList.contains(il.section) ? C = m : m.classList.contains(il.sectionContent) && (C = m.parentElement), C == null ? null : Number(C.dataset.sectionindex);
    }
  }));
  const y = (i == null ? void 0 : i.root) ?? em, v = kn({
    elementType: y,
    externalSlotProps: s == null ? void 0 : s.root,
    externalForwardedProps: c,
    additionalProps: {
      ref: g,
      suppressContentEditableWarning: !0
    },
    className: u.root,
    ownerState: {}
  });
  return /* @__PURE__ */ p.jsx(y, Q({}, v, {
    children: v.contentEditable ? a.map(({
      content: m,
      before: b,
      after: C
    }) => `${b.children}${m.children}${C.children}`).join("") : /* @__PURE__ */ p.jsx(d.Fragment, {
      children: a.map((m, b) => /* @__PURE__ */ p.jsx(rm, {
        slots: i,
        slotProps: s,
        element: m,
        classes: u
      }, b))
    })
  }));
});
process.env.NODE_ENV !== "production" && (im.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   */
  slots: o.object
});
const _M = ["elements", "areAllSectionsEmpty", "defaultValue", "label", "value", "onChange", "id", "autoFocus", "endAdornment", "startAdornment", "renderSuffix", "slots", "slotProps", "contentEditable", "tabIndex", "onInput", "onPaste", "onKeyDown", "fullWidth", "name", "readOnly", "inputProps", "inputRef", "sectionListRef"], zM = (e) => Math.round(e * 1e5) / 1e5, _d = Z("div", {
  name: "MuiPickersInputBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => Q({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  cursor: "text",
  padding: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  letterSpacing: `${zM(0.15 / 16)}em`,
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
})), gf = Z(em, {
  name: "MuiPickersInputBase",
  slot: "SectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})(({
  theme: e
}) => ({
  padding: "4px 0 5px",
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  lineHeight: "1.4375em",
  // 23px
  flexGrow: 1,
  outline: "none",
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  letterSpacing: "inherit",
  // Baseline behavior
  width: "182px",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      textAlign: "right /*! @noflip */"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingTop: 1
    }
  }, {
    props: {
      adornedStart: !1,
      focused: !1,
      filled: !1
    },
    style: {
      color: "currentColor",
      opacity: 0
    }
  }, {
    // Can't use the object notation because label can be null or undefined
    props: ({
      adornedStart: t,
      focused: n,
      filled: r,
      label: i
    }) => !t && !n && !r && i == null,
    style: e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: e.palette.mode === "light" ? 0.42 : 0.5
    }
  }]
})), HM = Z(tm, {
  name: "MuiPickersInputBase",
  slot: "Section",
  overridesResolver: (e, t) => t.section
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  letterSpacing: "inherit",
  lineHeight: "1.4375em",
  // 23px
  display: "inline-block",
  whiteSpace: "nowrap"
})), WM = Z(om, {
  name: "MuiPickersInputBase",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.content
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  lineHeight: "1.4375em",
  // 23px
  letterSpacing: "inherit",
  width: "fit-content",
  outline: "none"
})), GM = Z(nm, {
  name: "MuiPickersInputBase",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})(() => ({
  whiteSpace: "pre",
  letterSpacing: "inherit"
})), UM = Z("input", {
  name: "MuiPickersInputBase",
  slot: "Input",
  overridesResolver: (e, t) => t.hiddenInput
})(Q({}, PR)), YM = (e) => {
  const {
    focused: t,
    disabled: n,
    error: r,
    classes: i,
    fullWidth: s,
    readOnly: a,
    color: l,
    size: c,
    endAdornment: u,
    startAdornment: f
  } = e, g = {
    root: ["root", t && !n && "focused", n && "disabled", a && "readOnly", r && "error", s && "fullWidth", `color${RR(l)}`, c === "small" && "inputSizeSmall", !!f && "adornedStart", !!u && "adornedEnd"],
    notchedOutline: ["notchedOutline"],
    input: ["input"],
    sectionsContainer: ["sectionsContainer"],
    sectionContent: ["sectionContent"],
    sectionBefore: ["sectionBefore"],
    sectionAfter: ["sectionAfter"]
  };
  return co(g, LM, i);
}, zd = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiPickersInputBase"
  }), {
    elements: i,
    areAllSectionsEmpty: s,
    value: a,
    onChange: l,
    id: c,
    endAdornment: u,
    startAdornment: f,
    renderSuffix: g,
    slots: h,
    slotProps: y,
    contentEditable: v,
    tabIndex: m,
    onInput: b,
    onPaste: C,
    onKeyDown: E,
    name: S,
    readOnly: k,
    inputProps: T,
    inputRef: P,
    sectionListRef: F
  } = r, j = Zt(r, _M), L = d.useRef(null), R = Vo(n, L), V = Vo(T == null ? void 0 : T.ref, P), B = Io(), W = pr();
  if (!W)
    throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
  const z = (A) => {
    var Y;
    if (W.disabled) {
      A.stopPropagation();
      return;
    }
    (Y = W.onFocus) == null || Y.call(W, A);
  };
  d.useEffect(() => {
    W && W.setAdornedStart(!!f);
  }, [W, f]), d.useEffect(() => {
    W && (s ? W.onEmpty() : W.onFilled());
  }, [W, s]);
  const G = Q({}, r, W, {
    isRtl: B
  }), H = YM(G), ie = (h == null ? void 0 : h.root) || _d, ce = kn({
    elementType: ie,
    externalSlotProps: y == null ? void 0 : y.root,
    externalForwardedProps: j,
    additionalProps: {
      "aria-invalid": W.error,
      ref: R
    },
    className: H.root,
    ownerState: G
  }), re = (h == null ? void 0 : h.input) || gf;
  return /* @__PURE__ */ p.jsxs(ie, Q({}, ce, {
    children: [f, /* @__PURE__ */ p.jsx(im, {
      sectionListRef: F,
      elements: i,
      contentEditable: v,
      tabIndex: m,
      className: H.sectionsContainer,
      onFocus: z,
      onBlur: W.onBlur,
      onInput: b,
      onPaste: C,
      onKeyDown: E,
      slots: {
        root: re,
        section: HM,
        sectionContent: WM,
        sectionSeparator: GM
      },
      slotProps: {
        root: {
          ownerState: G
        },
        sectionContent: {
          className: ma.sectionContent
        },
        sectionSeparator: ({
          position: A
        }) => ({
          className: A === "before" ? ma.sectionBefore : ma.sectionAfter
        })
      }
    }), u, g ? g(Q({}, W)) : null, /* @__PURE__ */ p.jsx(UM, Q({
      name: S,
      className: H.input,
      value: a,
      onChange: l,
      id: c,
      "aria-hidden": "true",
      tabIndex: -1,
      readOnly: k,
      required: W.required,
      disabled: W.disabled
    }, T, {
      ref: V
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (zd.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: o.bool.isRequired,
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  endAdornment: o.node,
  fullWidth: o.bool,
  id: o.string,
  inputProps: o.object,
  inputRef: $i,
  label: o.node,
  margin: o.oneOf(["dense", "none", "normal"]),
  name: o.string,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onInput: o.func.isRequired,
  onKeyDown: o.func.isRequired,
  onPaste: o.func.isRequired,
  ownerState: o.any,
  readOnly: o.bool,
  renderSuffix: o.func,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.object,
  startAdornment: o.node,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.string.isRequired
});
function ZM(e) {
  return uo("MuiPickersOutlinedInput", e);
}
const jr = Q({}, ma, po("MuiPickersOutlinedInput", ["root", "notchedOutline", "input"])), qM = ["children", "className", "label", "notched", "shrink"], KM = Z("fieldset", {
  name: "MuiPickersOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%",
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), l5 = Z("span")(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit"
})), XM = Z("legend")(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: {
      withLabel: !1
    },
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      withLabel: !0
    },
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: {
      withLabel: !0,
      notched: !0
    },
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
}));
function QM(e) {
  const {
    className: t,
    label: n
  } = e, r = Zt(e, qM), i = n != null && n !== "", s = Q({}, e, {
    withLabel: i
  });
  return /* @__PURE__ */ p.jsx(KM, Q({
    "aria-hidden": !0,
    className: t
  }, r, {
    ownerState: s,
    children: /* @__PURE__ */ p.jsx(XM, {
      ownerState: s,
      children: i ? /* @__PURE__ */ p.jsx(l5, {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        /* @__PURE__ */ p.jsx(l5, {
          className: "notranslate",
          children: "​"
        })
      )
    })
  }));
}
const JM = ["label", "autoFocus", "ownerState", "notched"], ek = Z(_d, {
  name: "MuiPickersOutlinedInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    padding: "0 14px",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${jr.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${jr.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${jr.focused} .${jr.notchedOutline}`]: {
      borderStyle: "solid",
      borderWidth: 2
    },
    [`&.${jr.disabled}`]: {
      [`& .${jr.notchedOutline}`]: {
        borderColor: (e.vars || e).palette.action.disabled
      },
      "*": {
        color: (e.vars || e).palette.action.disabled
      }
    },
    [`&.${jr.error} .${jr.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    variants: Object.keys((e.vars ?? e).palette).filter((n) => {
      var r;
      return ((r = (e.vars ?? e).palette[n]) == null ? void 0 : r.main) ?? !1;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        [`&.${jr.focused}:not(.${jr.error}) .${jr.notchedOutline}`]: {
          // @ts-ignore
          borderColor: (e.vars || e).palette[n].main
        }
      }
    }))
  };
}), tk = Z(gf, {
  name: "MuiPickersOutlinedInput",
  slot: "SectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})({
  padding: "16.5px 0",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 0"
    }
  }]
}), nk = (e) => {
  const {
    classes: t
  } = e, r = co({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, ZM, t);
  return Q({}, t, r);
}, mf = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiPickersOutlinedInput"
  }), {
    label: i,
    ownerState: s,
    notched: a
  } = r, l = Zt(r, JM), c = pr(), u = Q({}, r, s, c, {
    color: (c == null ? void 0 : c.color) || "primary"
  }), f = nk(u);
  return /* @__PURE__ */ p.jsx(zd, Q({
    slots: {
      root: ek,
      input: tk
    },
    renderSuffix: (g) => /* @__PURE__ */ p.jsx(QM, {
      shrink: !!(a || g.adornedStart || g.focused || g.filled),
      notched: !!(a || g.adornedStart || g.focused || g.filled),
      className: f.notchedOutline,
      label: i != null && i !== "" && (c != null && c.required) ? /* @__PURE__ */ p.jsxs(d.Fragment, {
        children: [i, " ", "*"]
      }) : i,
      ownerState: u
    })
  }, l, {
    label: i,
    classes: f,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (mf.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: o.bool.isRequired,
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  endAdornment: o.node,
  fullWidth: o.bool,
  id: o.string,
  inputProps: o.object,
  inputRef: $i,
  label: o.node,
  margin: o.oneOf(["dense", "none", "normal"]),
  name: o.string,
  notched: o.bool,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onInput: o.func.isRequired,
  onKeyDown: o.func.isRequired,
  onPaste: o.func.isRequired,
  ownerState: o.any,
  readOnly: o.bool,
  renderSuffix: o.func,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.object,
  startAdornment: o.node,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.string.isRequired
});
mf.muiName = "Input";
function ok(e) {
  return uo("MuiPickersFilledInput", e);
}
const vs = Q({}, ma, po("MuiPickersFilledInput", ["root", "underline", "input"])), rk = ["label", "autoFocus", "disableUnderline", "ownerState"], ik = Z(_d, {
  name: "MuiPickersFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Is(e) && e !== "disableUnderline"
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", i = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", s = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : i,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${vs.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${vs.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : s
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((a) => (e.vars ?? e).palette[a].main).map((a) => {
      var l;
      return {
        props: {
          color: a,
          disableUnderline: !1
        },
        style: {
          "&::after": {
            // @ts-ignore
            borderBottom: `2px solid ${(l = (e.vars || e).palette[a]) == null ? void 0 : l.main}`
          }
        }
      };
    }), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${vs.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${vs.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${vs.disabled}, .${vs.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${vs.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, {
      props: ({
        startAdornment: a
      }) => !!a,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        endAdornment: a
      }) => !!a,
      style: {
        paddingRight: 12
      }
    }]
  };
}), sk = Z(gf, {
  name: "MuiPickersFilledInput",
  slot: "sectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      startAdornment: e
    }) => !!e,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      endAdornment: e
    }) => !!e,
    style: {
      paddingRight: 0
    }
  }, {
    props: {
      hiddenLabel: !0
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: {
      hiddenLabel: !0,
      size: "small"
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]
}), ak = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = co({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, ok, t);
  return Q({}, t, i);
}, hf = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiPickersFilledInput"
  }), {
    label: i,
    disableUnderline: s = !1,
    ownerState: a
  } = r, l = Zt(r, rk), c = pr(), u = Q({}, r, a, c, {
    color: (c == null ? void 0 : c.color) || "primary"
  }), f = ak(u);
  return /* @__PURE__ */ p.jsx(zd, Q({
    slots: {
      root: ik,
      input: sk
    },
    slotProps: {
      root: {
        disableUnderline: s
      }
    }
  }, l, {
    label: i,
    classes: f,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (hf.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: o.bool.isRequired,
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  disableUnderline: o.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  endAdornment: o.node,
  fullWidth: o.bool,
  hiddenLabel: o.bool,
  id: o.string,
  inputProps: o.object,
  inputRef: $i,
  label: o.node,
  margin: o.oneOf(["dense", "none", "normal"]),
  name: o.string,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onInput: o.func.isRequired,
  onKeyDown: o.func.isRequired,
  onPaste: o.func.isRequired,
  ownerState: o.any,
  readOnly: o.bool,
  renderSuffix: o.func,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.object,
  startAdornment: o.node,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.string.isRequired
});
hf.muiName = "Input";
function lk(e) {
  return uo("MuiPickersFilledInput", e);
}
const sl = Q({}, ma, po("MuiPickersInput", ["root", "input"])), ck = ["label", "autoFocus", "disableUnderline", "ownerState"], uk = Z(_d, {
  name: "MuiPickersInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    "label + &": {
      marginTop: 16
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((r) => (e.vars ?? e).palette[r].main).map((r) => ({
      props: {
        color: r
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(e.vars || e).palette[r].main}`
        }
      }
    })), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          background: "red",
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${sl.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${sl.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${sl.disabled}, .${sl.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${sl.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }]
  };
}), dk = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = co({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, lk, t);
  return Q({}, t, i);
}, vf = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiPickersInput"
  }), {
    label: i,
    disableUnderline: s = !1,
    ownerState: a
  } = r, l = Zt(r, ck), c = pr(), u = Q({}, r, a, c, {
    disableUnderline: s,
    color: (c == null ? void 0 : c.color) || "primary"
  }), f = dk(u);
  return /* @__PURE__ */ p.jsx(zd, Q({
    slots: {
      root: uk
    }
  }, l, {
    label: i,
    classes: f,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (vf.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: o.bool.isRequired,
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  disableUnderline: o.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  endAdornment: o.node,
  fullWidth: o.bool,
  id: o.string,
  inputProps: o.object,
  inputRef: $i,
  label: o.node,
  margin: o.oneOf(["dense", "none", "normal"]),
  name: o.string,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onInput: o.func.isRequired,
  onKeyDown: o.func.isRequired,
  onPaste: o.func.isRequired,
  ownerState: o.any,
  readOnly: o.bool,
  renderSuffix: o.func,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.object,
  startAdornment: o.node,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.string.isRequired
});
vf.muiName = "Input";
const pk = ["onFocus", "onBlur", "className", "color", "disabled", "error", "variant", "required", "InputProps", "inputProps", "inputRef", "sectionListRef", "elements", "areAllSectionsEmpty", "onClick", "onKeyDown", "onKeyUp", "onPaste", "onInput", "endAdornment", "startAdornment", "tabIndex", "contentEditable", "focused", "value", "onChange", "fullWidth", "id", "name", "helperText", "FormHelperTextProps", "label", "InputLabelProps"], fk = {
  standard: vf,
  filled: hf,
  outlined: mf
}, gk = Z(Up, {
  name: "MuiPickersTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  maxWidth: "100%"
}), mk = (e) => {
  const {
    focused: t,
    disabled: n,
    classes: r,
    required: i
  } = e;
  return co({
    root: ["root", t && !n && "focused", n && "disabled", i && "required"]
  }, $M, r);
}, sm = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiPickersTextField"
  }), {
    // Props used by FormControl
    onFocus: i,
    onBlur: s,
    className: a,
    color: l = "primary",
    disabled: c = !1,
    error: u = !1,
    variant: f = "outlined",
    required: g = !1,
    // Props used by PickersInput
    InputProps: h,
    inputProps: y,
    inputRef: v,
    sectionListRef: m,
    elements: b,
    areAllSectionsEmpty: C,
    onClick: E,
    onKeyDown: S,
    onKeyUp: k,
    onPaste: T,
    onInput: P,
    endAdornment: F,
    startAdornment: j,
    tabIndex: L,
    contentEditable: R,
    focused: V,
    value: B,
    onChange: W,
    fullWidth: z,
    id: G,
    name: H,
    // Props used by FormHelperText
    helperText: ie,
    FormHelperTextProps: ce,
    // Props used by InputLabel
    label: re,
    InputLabelProps: A
  } = r, Y = Zt(r, pk), pe = d.useRef(null), Ce = Vo(n, pe), fe = mc(G), ee = ie && fe ? `${fe}-helper-text` : void 0, te = re && fe ? `${fe}-label` : void 0, ue = Q({}, r, {
    color: l,
    disabled: c,
    error: u,
    focused: V,
    required: g,
    variant: f
  }), K = mk(ue), oe = fk[f];
  return /* @__PURE__ */ p.jsxs(gk, Q({
    className: xe(K.root, a),
    ref: Ce,
    focused: V,
    onFocus: i,
    onBlur: s,
    disabled: c,
    variant: f,
    error: u,
    color: l,
    fullWidth: z,
    required: g,
    ownerState: ue
  }, Y, {
    children: [/* @__PURE__ */ p.jsx(Zp, Q({
      htmlFor: fe,
      id: te
    }, A, {
      children: re
    })), /* @__PURE__ */ p.jsx(oe, Q({
      elements: b,
      areAllSectionsEmpty: C,
      onClick: E,
      onKeyDown: S,
      onKeyUp: k,
      onInput: P,
      onPaste: T,
      endAdornment: F,
      startAdornment: j,
      tabIndex: L,
      contentEditable: R,
      value: B,
      onChange: W,
      id: fe,
      fullWidth: z,
      inputProps: y,
      inputRef: v,
      sectionListRef: m,
      label: re,
      name: H,
      role: "group",
      "aria-labelledby": te,
      "aria-describedby": ee,
      "aria-live": ee ? "polite" : void 0
    }, h)), ie && /* @__PURE__ */ p.jsx(Yp, Q({
      id: ee
    }, ce, {
      children: ie
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (sm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: o.bool.isRequired,
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: o.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  disabled: o.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  endAdornment: o.node,
  error: o.bool.isRequired,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: o.bool,
  FormHelperTextProps: o.object,
  fullWidth: o.bool,
  /**
   * The helper text content.
   */
  helperText: o.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: o.bool,
  id: o.string,
  InputLabelProps: o.object,
  inputProps: o.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: o.object,
  inputRef: $i,
  label: o.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: o.oneOf(["dense", "none", "normal"]),
  name: o.string,
  onBlur: o.func.isRequired,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onFocus: o.func.isRequired,
  onInput: o.func.isRequired,
  onKeyDown: o.func.isRequired,
  onPaste: o.func.isRequired,
  readOnly: o.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: o.bool,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOf(["medium", "small"]),
  startAdornment: o.node,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.string.isRequired,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
const hk = ["enableAccessibleFieldDOMStructure"], vk = ["InputProps", "readOnly"], yk = ["onPaste", "onKeyDown", "inputMode", "readOnly", "InputProps", "inputProps", "inputRef"], bk = (e) => {
  let {
    enableAccessibleFieldDOMStructure: t
  } = e, n = Zt(e, hk);
  if (t) {
    const {
      InputProps: g,
      readOnly: h
    } = n, y = Zt(n, vk);
    return Q({}, y, {
      InputProps: Q({}, g ?? {}, {
        readOnly: h
      })
    });
  }
  const {
    onPaste: r,
    onKeyDown: i,
    inputMode: s,
    readOnly: a,
    InputProps: l,
    inputProps: c,
    inputRef: u
  } = n, f = Zt(n, yk);
  return Q({}, f, {
    InputProps: Q({}, l ?? {}, {
      readOnly: a
    }),
    inputProps: Q({}, c ?? {}, {
      inputMode: s,
      onPaste: r,
      onKeyDown: i,
      ref: u
    })
  });
}, Ck = ["slots", "slotProps", "InputProps", "inputProps"], yf = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiDateField"
  }), {
    slots: i,
    slotProps: s,
    InputProps: a,
    inputProps: l
  } = r, c = Zt(r, Ck), u = r, f = (i == null ? void 0 : i.textField) ?? (t.enableAccessibleFieldDOMStructure ? sm : gc), g = kn({
    elementType: f,
    externalSlotProps: s == null ? void 0 : s.textField,
    externalForwardedProps: c,
    additionalProps: {
      ref: n
    },
    ownerState: u
  });
  g.inputProps = Q({}, l, g.inputProps), g.InputProps = Q({}, a, g.InputProps);
  const h = VM(g), y = bk(h), v = OM(Q({}, y, {
    slots: i,
    slotProps: s
  }));
  return /* @__PURE__ */ p.jsx(f, Q({}, v));
});
process.env.NODE_ENV !== "production" && (yf.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: o.bool,
  className: o.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: o.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: o.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: o.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: o.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: o.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: o.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: o.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The helper text content.
   */
  helperText: o.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: o.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: o.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: o.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: o.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $i,
  /**
   * The label content.
   */
  label: o.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: o.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  onBlur: o.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: o.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: o.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: o.func,
  onFocus: o.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: o.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: o.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: o.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: o.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: o.oneOfType([o.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), o.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: o.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: o.bool,
  /**
   * The size of the component.
   */
  size: o.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: o.oneOfType([o.func, o.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
const am = ({
  shouldDisableDate: e,
  shouldDisableMonth: t,
  shouldDisableYear: n,
  minDate: r,
  maxDate: i,
  disableFuture: s,
  disablePast: a,
  timezone: l
}) => {
  const c = Hs();
  return d.useCallback((u) => vc({
    adapter: c,
    value: u,
    timezone: l,
    props: {
      shouldDisableDate: e,
      shouldDisableMonth: t,
      shouldDisableYear: n,
      minDate: r,
      maxDate: i,
      disableFuture: s,
      disablePast: a
    }
  }) !== null, [c, e, t, n, r, i, s, a, l]);
}, xk = (e, t, n) => (r, i) => {
  switch (i.type) {
    case "changeMonth":
      return Q({}, r, {
        slideDirection: i.direction,
        currentMonth: i.newMonth,
        isMonthSwitchingAnimating: !e
      });
    case "changeMonthTimezone": {
      const s = i.newTimezone;
      if (n.getTimezone(r.currentMonth) === s)
        return r;
      let a = n.setTimezone(r.currentMonth, s);
      return n.getMonth(a) !== n.getMonth(r.currentMonth) && (a = n.setMonth(a, n.getMonth(r.currentMonth))), Q({}, r, {
        currentMonth: a
      });
    }
    case "finishMonthSwitchingAnimation":
      return Q({}, r, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (r.focusedDay != null && i.focusedDay != null && n.isSameDay(i.focusedDay, r.focusedDay))
        return r;
      const s = i.focusedDay != null && !t && !n.isSameMonth(r.currentMonth, i.focusedDay);
      return Q({}, r, {
        focusedDay: i.focusedDay,
        isMonthSwitchingAnimating: s && !e && !i.withoutMonthSwitchingAnimation,
        currentMonth: s ? n.startOfMonth(i.focusedDay) : r.currentMonth,
        slideDirection: i.focusedDay != null && n.isAfterDay(i.focusedDay, r.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, wk = (e) => {
  const {
    value: t,
    referenceDate: n,
    disableFuture: r,
    disablePast: i,
    disableSwitchToMonthOnDayFocus: s = !1,
    maxDate: a,
    minDate: l,
    onMonthChange: c,
    reduceAnimations: u,
    shouldDisableDate: f,
    timezone: g
  } = e, h = no(), y = d.useRef(xk(!!u, s, h)).current, v = d.useMemo(
    () => oi.getInitialReferenceValue({
      value: t,
      utils: h,
      timezone: g,
      props: e,
      referenceDate: n,
      granularity: Yr.day
    }),
    // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, g]
  ), [m, b] = d.useReducer(y, {
    isMonthSwitchingAnimating: !1,
    focusedDay: v,
    currentMonth: h.startOfMonth(v),
    slideDirection: "left"
  });
  d.useEffect(() => {
    b({
      type: "changeMonthTimezone",
      newTimezone: h.getTimezone(v)
    });
  }, [v, h]);
  const C = d.useCallback((P) => {
    b(Q({
      type: "changeMonth"
    }, P)), c && c(P.newMonth);
  }, [c]), E = d.useCallback((P) => {
    const F = P;
    h.isSameMonth(F, m.currentMonth) || C({
      newMonth: h.startOfMonth(F),
      direction: h.isAfterDay(F, m.currentMonth) ? "left" : "right"
    });
  }, [m.currentMonth, C, h]), S = am({
    shouldDisableDate: f,
    minDate: l,
    maxDate: a,
    disableFuture: r,
    disablePast: i,
    timezone: g
  }), k = d.useCallback(() => {
    b({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), T = yt((P, F) => {
    S(P) || b({
      type: "changeFocusedDay",
      focusedDay: P,
      withoutMonthSwitchingAnimation: F
    });
  });
  return {
    referenceDate: v,
    calendarState: m,
    changeMonth: E,
    changeFocusedDay: T,
    isDateDisabled: S,
    onMonthSwitchingAnimationEnd: k,
    handleChangeMonth: C
  };
}, Sk = (e) => uo("MuiPickersFadeTransitionGroup", e);
po("MuiPickersFadeTransitionGroup", ["root"]);
const Ek = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"]
  }, Sk, t);
}, Rk = Z(ac, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "block",
  position: "relative"
});
function lm(e) {
  const t = Kn({
    props: e,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: n,
    className: r,
    reduceAnimations: i,
    transKey: s
  } = t, a = Ek(t), l = to();
  return i ? n : /* @__PURE__ */ p.jsx(Rk, {
    className: xe(a.root, r),
    children: /* @__PURE__ */ p.jsx(Fi, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: l.transitions.duration.enteringScreen,
        enter: l.transitions.duration.enteringScreen,
        exit: 0
      },
      children: n
    }, s)
  });
}
function Tk(e) {
  return uo("MuiPickersDay", e);
}
const ys = po("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), Mk = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"], kk = (e) => {
  const {
    selected: t,
    disableMargin: n,
    disableHighlightToday: r,
    today: i,
    disabled: s,
    outsideCurrentMonth: a,
    showDaysOutsideCurrentMonth: l,
    classes: c
  } = e, u = a && !l;
  return co({
    root: ["root", t && !u && "selected", s && "disabled", !n && "dayWithMargin", !r && i && "today", a && l && "dayOutsideMonth", u && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, Tk, c);
}, cm = ({
  theme: e
}) => Q({}, e.typography.caption, {
  width: Zl,
  height: Zl,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.short
  }),
  color: (e.vars || e).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette.primary.main, e.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : At(e.palette.primary.main, e.palette.action.focusOpacity),
    [`&.${ys.selected}`]: {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${ys.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${ys.disabled}:not(.${ys.selected})`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${ys.disabled}&.${ys.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: !1
    },
    style: {
      margin: `0 ${Nd}px`
    }
  }, {
    props: {
      outsideCurrentMonth: !0,
      showDaysOutsideCurrentMonth: !0
    },
    style: {
      color: (e.vars || e).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: !1,
      today: !0
    },
    style: {
      [`&:not(.${ys.selected})`]: {
        border: `1px solid ${(e.vars || e).palette.text.secondary}`
      }
    }
  }]
}), um = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, !n.disableMargin && t.dayWithMargin, !n.disableHighlightToday && n.today && t.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && t.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
}, Pk = Z(Tr, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: um
})(cm), Ik = Z("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: um
})(({
  theme: e
}) => Q({}, cm({
  theme: e
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), al = () => {
}, dm = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiPickersDay"
  }), {
    autoFocus: i = !1,
    className: s,
    day: a,
    disabled: l = !1,
    disableHighlightToday: c = !1,
    disableMargin: u = !1,
    isAnimating: f,
    onClick: g,
    onDaySelect: h,
    onFocus: y = al,
    onBlur: v = al,
    onKeyDown: m = al,
    onMouseDown: b = al,
    onMouseEnter: C = al,
    outsideCurrentMonth: E,
    selected: S = !1,
    showDaysOutsideCurrentMonth: k = !1,
    children: T,
    today: P = !1
  } = r, F = Zt(r, Mk), j = Q({}, r, {
    autoFocus: i,
    disabled: l,
    disableHighlightToday: c,
    disableMargin: u,
    selected: S,
    showDaysOutsideCurrentMonth: k,
    today: P
  }), L = kk(j), R = no(), V = d.useRef(null), B = Vo(V, n);
  ni(() => {
    i && !l && !f && !E && V.current.focus();
  }, [i, l, f, E]);
  const W = (G) => {
    b(G), E && G.preventDefault();
  }, z = (G) => {
    l || h(a), E && G.currentTarget.focus(), g && g(G);
  };
  return E && !k ? /* @__PURE__ */ p.jsx(Ik, {
    className: xe(L.root, L.hiddenDaySpacingFiller, s),
    ownerState: j,
    role: F.role
  }) : /* @__PURE__ */ p.jsx(Pk, Q({
    className: xe(L.root, s),
    ref: B,
    centerRipple: !0,
    disabled: l,
    tabIndex: S ? 0 : -1,
    onKeyDown: (G) => m(G, a),
    onFocus: (G) => y(G, a),
    onBlur: (G) => v(G, a),
    onMouseEnter: (G) => C(G, a),
    onClick: z,
    onMouseDown: W
  }, F, {
    ownerState: j,
    children: T || R.format(a, "dayOfMonth")
  }));
});
process.env.NODE_ENV !== "production" && (dm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: o.oneOfType([o.func, o.shape({
    current: o.shape({
      focusVisible: o.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  component: o.elementType,
  /**
   * The date to show.
   */
  day: o.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: o.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: o.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: o.string,
  isAnimating: o.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: o.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: o.bool.isRequired,
  onBlur: o.func,
  onDaySelect: o.func.isRequired,
  onFocus: o.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: o.func,
  onKeyDown: o.func,
  onMouseEnter: o.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: o.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: o.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: o.bool,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @default 0
   */
  tabIndex: o.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: o.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: o.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      pulsate: o.func.isRequired,
      start: o.func.isRequired,
      stop: o.func.isRequired
    })
  })])
});
const Ok = /* @__PURE__ */ d.memo(dm), Dk = (e) => uo("MuiPickersSlideTransition", e), mr = po("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), jk = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], Fk = (e) => {
  const {
    classes: t,
    slideDirection: n
  } = e, r = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${n}`],
    exitActive: [`slideExitActiveLeft-${n}`]
  };
  return co(r, Dk, t);
}, Vk = Z(ac, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`.${mr["slideEnter-left"]}`]: t["slideEnter-left"]
  }, {
    [`.${mr["slideEnter-right"]}`]: t["slideEnter-right"]
  }, {
    [`.${mr.slideEnterActive}`]: t.slideEnterActive
  }, {
    [`.${mr.slideExit}`]: t.slideExit
  }, {
    [`.${mr["slideExitActiveLeft-left"]}`]: t["slideExitActiveLeft-left"]
  }, {
    [`.${mr["slideExitActiveLeft-right"]}`]: t["slideExitActiveLeft-right"]
  }]
})(({
  theme: e
}) => {
  const t = e.transitions.create("transform", {
    duration: e.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${mr["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${mr["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${mr.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${mr.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${mr["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${mr["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
});
function $k(e) {
  const t = Kn({
    props: e,
    name: "MuiPickersSlideTransition"
  }), {
    children: n,
    className: r,
    reduceAnimations: i,
    transKey: s
    // extracting `classes` from `other`
  } = t, a = Zt(t, jk), l = Fk(t), c = to();
  if (i)
    return /* @__PURE__ */ p.jsx("div", {
      className: xe(l.root, r),
      children: n
    });
  const u = {
    exit: l.exit,
    enterActive: l.enterActive,
    enter: l.enter,
    exitActive: l.exitActive
  };
  return /* @__PURE__ */ p.jsx(Vk, {
    className: xe(l.root, r),
    childFactory: (f) => /* @__PURE__ */ d.cloneElement(f, {
      classNames: u
    }),
    role: "presentation",
    children: /* @__PURE__ */ p.jsx(Mp, Q({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: c.transitions.duration.complex,
      classNames: u
    }, a, {
      children: n
    }), s)
  });
}
const Lk = (e) => uo("MuiDayCalendar", e);
po("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const Ak = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], Nk = ["ownerState"], Bk = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, Lk, t);
}, pm = (Zl + Nd * 2) * 6, _k = Z("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), zk = Z("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (e, t) => t.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), Hk = Z(vo, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (e, t) => t.weekDayLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (e.vars || e).palette.text.secondary
})), Wk = Z(vo, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (e, t) => t.weekNumberLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: e.palette.text.disabled
})), Gk = Z(vo, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (e, t) => t.weekNumber
})(({
  theme: e
}) => Q({}, e.typography.caption, {
  width: Zl,
  height: Zl,
  padding: 0,
  margin: `0 ${Nd}px`,
  color: e.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), Uk = Z("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (e, t) => t.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: pm
}), Yk = Z($k, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (e, t) => t.slideTransition
})({
  minHeight: pm
}), Zk = Z("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (e, t) => t.monthContainer
})({
  overflow: "hidden"
}), qk = Z("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (e, t) => t.weekContainer
})({
  margin: `${Nd}px 0`,
  display: "flex",
  justifyContent: "center"
});
function Kk(e) {
  let {
    parentProps: t,
    day: n,
    focusableDay: r,
    selectedDays: i,
    isDateDisabled: s,
    currentMonthNumber: a,
    isViewFocused: l
  } = e, c = Zt(e, Ak);
  const {
    disabled: u,
    disableHighlightToday: f,
    isMonthSwitchingAnimating: g,
    showDaysOutsideCurrentMonth: h,
    slots: y,
    slotProps: v,
    timezone: m
  } = t, b = no(), C = Ad(m), E = r !== null && b.isSameDay(n, r), S = i.some((B) => b.isSameDay(B, n)), k = b.isSameDay(n, C), T = (y == null ? void 0 : y.day) ?? Ok, P = kn({
    elementType: T,
    externalSlotProps: v == null ? void 0 : v.day,
    additionalProps: Q({
      disableHighlightToday: f,
      showDaysOutsideCurrentMonth: h,
      role: "gridcell",
      isAnimating: g,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": b.toJsDate(n).valueOf()
    }, c),
    ownerState: Q({}, t, {
      day: n,
      selected: S
    })
  }), F = Zt(P, Nk), j = d.useMemo(() => u || s(n), [u, s, n]), L = d.useMemo(() => b.getMonth(n) !== a, [b, n, a]), R = d.useMemo(() => {
    const B = b.startOfMonth(b.setMonth(n, a));
    return h ? b.isSameDay(n, b.startOfWeek(B)) : b.isSameDay(n, B);
  }, [a, n, h, b]), V = d.useMemo(() => {
    const B = b.endOfMonth(b.setMonth(n, a));
    return h ? b.isSameDay(n, b.endOfWeek(B)) : b.isSameDay(n, B);
  }, [a, n, h, b]);
  return /* @__PURE__ */ p.jsx(T, Q({}, F, {
    day: n,
    disabled: j,
    autoFocus: l && E,
    today: k,
    outsideCurrentMonth: L,
    isFirstVisibleCell: R,
    isLastVisibleCell: V,
    selected: S,
    tabIndex: E ? 0 : -1,
    "aria-selected": S,
    "aria-current": k ? "date" : void 0
  }));
}
function Xk(e) {
  const t = Kn({
    props: e,
    name: "MuiDayCalendar"
  }), n = no(), {
    onFocusedDayChange: r,
    className: i,
    currentMonth: s,
    selectedDays: a,
    focusedDay: l,
    loading: c,
    onSelectedDaysChange: u,
    onMonthSwitchingAnimationEnd: f,
    readOnly: g,
    reduceAnimations: h,
    renderLoading: y = () => /* @__PURE__ */ p.jsx("span", {
      children: "..."
    }),
    slideDirection: v,
    TransitionProps: m,
    disablePast: b,
    disableFuture: C,
    minDate: E,
    maxDate: S,
    shouldDisableDate: k,
    shouldDisableMonth: T,
    shouldDisableYear: P,
    dayOfWeekFormatter: F = (we) => n.format(we, "weekdayShort").charAt(0).toUpperCase(),
    hasFocus: j,
    onFocusedViewChange: L,
    gridLabelId: R,
    displayWeekNumber: V,
    fixedWeekNumber: B,
    autoFocus: W,
    timezone: z
  } = t, G = Ad(z), H = Bk(t), ie = Io(), ce = am({
    shouldDisableDate: k,
    shouldDisableMonth: T,
    shouldDisableYear: P,
    minDate: E,
    maxDate: S,
    disablePast: b,
    disableFuture: C,
    timezone: z
  }), re = Li(), [A, Y] = Ls({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: j,
    default: W ?? !1
  }), [pe, Ce] = d.useState(() => l || G), fe = yt((we) => {
    g || u(we);
  }), ee = (we) => {
    ce(we) || (r(we), Ce(we), L == null || L(!0), Y(!0));
  }, te = yt((we, me) => {
    switch (we.key) {
      case "ArrowUp":
        ee(n.addDays(me, -7)), we.preventDefault();
        break;
      case "ArrowDown":
        ee(n.addDays(me, 7)), we.preventDefault();
        break;
      case "ArrowLeft": {
        const ye = n.addDays(me, ie ? 1 : -1), Ie = n.addMonths(me, ie ? 1 : -1), je = Dl({
          utils: n,
          date: ye,
          minDate: ie ? ye : n.startOfMonth(Ie),
          maxDate: ie ? n.endOfMonth(Ie) : ye,
          isDateDisabled: ce,
          timezone: z
        });
        ee(je || ye), we.preventDefault();
        break;
      }
      case "ArrowRight": {
        const ye = n.addDays(me, ie ? -1 : 1), Ie = n.addMonths(me, ie ? -1 : 1), je = Dl({
          utils: n,
          date: ye,
          minDate: ie ? n.startOfMonth(Ie) : ye,
          maxDate: ie ? ye : n.endOfMonth(Ie),
          isDateDisabled: ce,
          timezone: z
        });
        ee(je || ye), we.preventDefault();
        break;
      }
      case "Home":
        ee(n.startOfWeek(me)), we.preventDefault();
        break;
      case "End":
        ee(n.endOfWeek(me)), we.preventDefault();
        break;
      case "PageUp":
        ee(n.addMonths(me, 1)), we.preventDefault();
        break;
      case "PageDown":
        ee(n.addMonths(me, -1)), we.preventDefault();
        break;
    }
  }), ue = yt((we, me) => ee(me)), K = yt((we, me) => {
    A && n.isSameDay(pe, me) && (L == null || L(!1));
  }), oe = n.getMonth(s), de = n.getYear(s), ve = d.useMemo(() => a.filter((we) => !!we).map((we) => n.startOfDay(we)), [n, a]), J = `${de}-${oe}`, se = d.useMemo(() => /* @__PURE__ */ d.createRef(), [J]), ge = d.useMemo(() => {
    const we = n.startOfMonth(s), me = n.endOfMonth(s);
    return ce(pe) || n.isAfterDay(pe, me) || n.isBeforeDay(pe, we) ? Dl({
      utils: n,
      date: pe,
      minDate: we,
      maxDate: me,
      disablePast: b,
      disableFuture: C,
      isDateDisabled: ce,
      timezone: z
    }) : pe;
  }, [s, C, b, pe, ce, n, z]), Se = d.useMemo(() => {
    const we = n.getWeekArray(s);
    let me = n.addMonths(s, 1);
    for (; B && we.length < B; ) {
      const ye = n.getWeekArray(me), Ie = n.isSameDay(we[we.length - 1][0], ye[0][0]);
      ye.slice(Ie ? 1 : 0).forEach((je) => {
        we.length < B && we.push(je);
      }), me = n.addMonths(me, 1);
    }
    return we;
  }, [s, B, n]);
  return /* @__PURE__ */ p.jsxs(_k, {
    role: "grid",
    "aria-labelledby": R,
    className: H.root,
    children: [/* @__PURE__ */ p.jsxs(zk, {
      role: "row",
      className: H.header,
      children: [V && /* @__PURE__ */ p.jsx(Wk, {
        variant: "caption",
        role: "columnheader",
        "aria-label": re.calendarWeekNumberHeaderLabel,
        className: H.weekNumberLabel,
        children: re.calendarWeekNumberHeaderText
      }), _R(n, G).map((we, me) => /* @__PURE__ */ p.jsx(Hk, {
        variant: "caption",
        role: "columnheader",
        "aria-label": n.format(we, "weekday"),
        className: H.weekDayLabel,
        children: F(we)
      }, me.toString()))]
    }), c ? /* @__PURE__ */ p.jsx(Uk, {
      className: H.loadingContainer,
      children: y()
    }) : /* @__PURE__ */ p.jsx(Yk, Q({
      transKey: J,
      onExited: f,
      reduceAnimations: h,
      slideDirection: v,
      className: xe(i, H.slideTransition)
    }, m, {
      nodeRef: se,
      children: /* @__PURE__ */ p.jsx(Zk, {
        ref: se,
        role: "rowgroup",
        className: H.monthContainer,
        children: Se.map((we, me) => /* @__PURE__ */ p.jsxs(qk, {
          role: "row",
          className: H.weekContainer,
          "aria-rowindex": me + 1,
          children: [V && /* @__PURE__ */ p.jsx(Gk, {
            className: H.weekNumber,
            role: "rowheader",
            "aria-label": re.calendarWeekNumberAriaLabelText(n.getWeekNumber(we[0])),
            children: re.calendarWeekNumberText(n.getWeekNumber(we[0]))
          }), we.map((ye, Ie) => /* @__PURE__ */ p.jsx(Kk, {
            parentProps: t,
            day: ye,
            selectedDays: ve,
            focusableDay: ge,
            onKeyDown: te,
            onFocus: ue,
            onBlur: K,
            onDaySelect: fe,
            isDateDisabled: ce,
            currentMonthNumber: oe,
            isViewFocused: A,
            "aria-colindex": Ie + 1
          }, ye.toString()))]
        }, `week-${we[0]}`))
      })
    }))]
  });
}
function Qk(e) {
  return uo("MuiPickersMonth", e);
}
const cu = po("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]), Jk = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow", "slots", "slotProps"], eP = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: r
  } = e;
  return co({
    root: ["root"],
    monthButton: ["monthButton", t && "disabled", n && "selected"]
  }, Qk, r);
}, tP = Z("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      monthsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), nP = Z("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (e, t) => [t.monthButton, {
    [`&.${cu.disabled}`]: t.disabled
  }, {
    [`&.${cu.selected}`]: t.selected
  }]
})(({
  theme: e
}) => Q({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${cu.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${cu.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), oP = /* @__PURE__ */ d.memo(function(t) {
  const n = Kn({
    props: t,
    name: "MuiPickersMonth"
  }), {
    autoFocus: r,
    className: i,
    children: s,
    disabled: a,
    selected: l,
    value: c,
    tabIndex: u,
    onClick: f,
    onKeyDown: g,
    onFocus: h,
    onBlur: y,
    "aria-current": v,
    "aria-label": m,
    slots: b,
    slotProps: C
  } = n, E = Zt(n, Jk), S = d.useRef(null), k = eP(n);
  ni(() => {
    var F;
    r && ((F = S.current) == null || F.focus());
  }, [r]);
  const T = (b == null ? void 0 : b.monthButton) ?? nP, P = kn({
    elementType: T,
    externalSlotProps: C == null ? void 0 : C.monthButton,
    additionalProps: {
      children: s,
      disabled: a,
      tabIndex: u,
      ref: S,
      type: "button",
      role: "radio",
      "aria-current": v,
      "aria-checked": l,
      "aria-label": m,
      onClick: (F) => f(F, c),
      onKeyDown: (F) => g(F, c),
      onFocus: (F) => h(F, c),
      onBlur: (F) => y(F, c)
    },
    ownerState: n,
    className: k.monthButton
  });
  return /* @__PURE__ */ p.jsx(tP, Q({
    className: xe(k.root, i),
    ownerState: n
  }, E, {
    children: /* @__PURE__ */ p.jsx(T, Q({}, P))
  }));
});
function rP(e) {
  return uo("MuiMonthCalendar", e);
}
po("MuiMonthCalendar", ["root"]);
const iP = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], sP = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"]
  }, rP, t);
};
function aP(e, t) {
  const n = no(), r = hc(), i = Kn({
    props: e,
    name: t
  });
  return Q({
    disableFuture: !1,
    disablePast: !1
  }, i, {
    minDate: Pr(n, i.minDate, r.minDate),
    maxDate: Pr(n, i.maxDate, r.maxDate)
  });
}
const lP = Z("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: Bd,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
}), fm = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = aP(t, "MuiMonthCalendar"), {
    className: i,
    value: s,
    defaultValue: a,
    referenceDate: l,
    disabled: c,
    disableFuture: u,
    disablePast: f,
    maxDate: g,
    minDate: h,
    onChange: y,
    shouldDisableMonth: v,
    readOnly: m,
    autoFocus: b = !1,
    onMonthFocus: C,
    hasFocus: E,
    onFocusedViewChange: S,
    monthsPerRow: k = 3,
    timezone: T,
    gridLabelId: P,
    slots: F,
    slotProps: j
  } = r, L = Zt(r, iP), {
    value: R,
    handleValueChange: V,
    timezone: B
  } = df({
    name: "MonthCalendar",
    timezone: T,
    value: s,
    defaultValue: a,
    referenceDate: l,
    onChange: y,
    valueManager: oi
  }), W = Ad(B), z = Io(), G = no(), H = d.useMemo(
    () => oi.getInitialReferenceValue({
      value: R,
      utils: G,
      props: r,
      timezone: B,
      referenceDate: l,
      granularity: Yr.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), ie = r, ce = sP(ie), re = d.useMemo(() => G.getMonth(W), [G, W]), A = d.useMemo(() => R != null ? G.getMonth(R) : null, [R, G]), [Y, pe] = d.useState(() => A || G.getMonth(H)), [Ce, fe] = Ls({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: E,
    default: b ?? !1
  }), ee = yt((J) => {
    fe(J), S && S(J);
  }), te = d.useCallback((J) => {
    const se = G.startOfMonth(f && G.isAfter(W, h) ? W : h), ge = G.startOfMonth(u && G.isBefore(W, g) ? W : g), Se = G.startOfMonth(J);
    return G.isBefore(Se, se) || G.isAfter(Se, ge) ? !0 : v ? v(Se) : !1;
  }, [u, f, g, h, W, v, G]), ue = yt((J, se) => {
    if (m)
      return;
    const ge = G.setMonth(R ?? H, se);
    V(ge);
  }), K = yt((J) => {
    te(G.setMonth(R ?? H, J)) || (pe(J), ee(!0), C && C(J));
  });
  d.useEffect(() => {
    pe((J) => A !== null && J !== A ? A : J);
  }, [A]);
  const oe = yt((J, se) => {
    switch (J.key) {
      case "ArrowUp":
        K((12 + se - 3) % 12), J.preventDefault();
        break;
      case "ArrowDown":
        K((12 + se + 3) % 12), J.preventDefault();
        break;
      case "ArrowLeft":
        K((12 + se + (z ? 1 : -1)) % 12), J.preventDefault();
        break;
      case "ArrowRight":
        K((12 + se + (z ? -1 : 1)) % 12), J.preventDefault();
        break;
    }
  }), de = yt((J, se) => {
    K(se);
  }), ve = yt((J, se) => {
    Y === se && ee(!1);
  });
  return /* @__PURE__ */ p.jsx(lP, Q({
    ref: n,
    className: xe(ce.root, i),
    ownerState: ie,
    role: "radiogroup",
    "aria-labelledby": P
  }, L, {
    children: rf(G, R ?? H).map((J) => {
      const se = G.getMonth(J), ge = G.format(J, "monthShort"), Se = G.format(J, "month"), we = se === A, me = c || te(J);
      return /* @__PURE__ */ p.jsx(oP, {
        selected: we,
        value: se,
        onClick: ue,
        onKeyDown: oe,
        autoFocus: Ce && se === Y,
        disabled: me,
        tabIndex: se === Y && !me ? 0 : -1,
        onFocus: de,
        onBlur: ve,
        "aria-current": re === se ? "date" : void 0,
        "aria-label": Se,
        monthsPerRow: k,
        slots: F,
        slotProps: j,
        children: ge
      }, ge);
    })
  }));
});
process.env.NODE_ENV !== "production" && (fm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true` picker is disabled
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  gridLabelId: o.string,
  hasFocus: o.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: o.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: o.func,
  onFocusedViewChange: o.func,
  onMonthFocus: o.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: o.object,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object
});
function cP(e) {
  return uo("MuiPickersYear", e);
}
const uu = po("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]), uP = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow", "slots", "slotProps"], dP = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: r
  } = e;
  return co({
    root: ["root"],
    yearButton: ["yearButton", t && "disabled", n && "selected"]
  }, cP, r);
}, pP = Z("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      yearsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), fP = Z("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (e, t) => [t.yearButton, {
    [`&.${uu.disabled}`]: t.disabled
  }, {
    [`&.${uu.selected}`]: t.selected
  }]
})(({
  theme: e
}) => Q({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.focusOpacity})` : At(e.palette.action.active, e.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : At(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${uu.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${uu.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), gP = /* @__PURE__ */ d.memo(function(t) {
  const n = Kn({
    props: t,
    name: "MuiPickersYear"
  }), {
    autoFocus: r,
    className: i,
    children: s,
    disabled: a,
    selected: l,
    value: c,
    tabIndex: u,
    onClick: f,
    onKeyDown: g,
    onFocus: h,
    onBlur: y,
    "aria-current": v,
    slots: m,
    slotProps: b
  } = n, C = Zt(n, uP), E = d.useRef(null), S = dP(n);
  ni(() => {
    var P;
    r && ((P = E.current) == null || P.focus());
  }, [r]);
  const k = (m == null ? void 0 : m.yearButton) ?? fP, T = kn({
    elementType: k,
    externalSlotProps: b == null ? void 0 : b.yearButton,
    additionalProps: {
      children: s,
      disabled: a,
      tabIndex: u,
      ref: E,
      type: "button",
      role: "radio",
      "aria-current": v,
      "aria-checked": l,
      onClick: (P) => f(P, c),
      onKeyDown: (P) => g(P, c),
      onFocus: (P) => h(P, c),
      onBlur: (P) => y(P, c)
    },
    ownerState: n,
    className: S.yearButton
  });
  return /* @__PURE__ */ p.jsx(pP, Q({
    className: xe(S.root, i),
    ownerState: n
  }, C, {
    children: /* @__PURE__ */ p.jsx(k, Q({}, T))
  }));
});
function mP(e) {
  return uo("MuiYearCalendar", e);
}
po("MuiYearCalendar", ["root"]);
const hP = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsOrder", "yearsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], vP = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"]
  }, mP, t);
};
function yP(e, t) {
  const n = no(), r = hc(), i = Kn({
    props: e,
    name: t
  });
  return Q({
    disablePast: !1,
    disableFuture: !1
  }, i, {
    yearsPerRow: i.yearsPerRow ?? 3,
    minDate: Pr(n, i.minDate, r.minDate),
    maxDate: Pr(n, i.maxDate, r.maxDate)
  });
}
const bP = Z("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: Bd,
  maxHeight: XT,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), gm = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = yP(t, "MuiYearCalendar"), {
    autoFocus: i,
    className: s,
    value: a,
    defaultValue: l,
    referenceDate: c,
    disabled: u,
    disableFuture: f,
    disablePast: g,
    maxDate: h,
    minDate: y,
    onChange: v,
    readOnly: m,
    shouldDisableYear: b,
    onYearFocus: C,
    hasFocus: E,
    onFocusedViewChange: S,
    yearsOrder: k = "asc",
    yearsPerRow: T,
    timezone: P,
    gridLabelId: F,
    slots: j,
    slotProps: L
  } = r, R = Zt(r, hP), {
    value: V,
    handleValueChange: B,
    timezone: W
  } = df({
    name: "YearCalendar",
    timezone: P,
    value: a,
    defaultValue: l,
    referenceDate: c,
    onChange: v,
    valueManager: oi
  }), z = Ad(W), G = Io(), H = no(), ie = d.useMemo(
    () => oi.getInitialReferenceValue({
      value: V,
      utils: H,
      props: r,
      timezone: W,
      referenceDate: c,
      granularity: Yr.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), ce = r, re = vP(ce), A = d.useMemo(() => H.getYear(z), [H, z]), Y = d.useMemo(() => V != null ? H.getYear(V) : null, [V, H]), [pe, Ce] = d.useState(() => Y || H.getYear(ie)), [fe, ee] = Ls({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: E,
    default: i ?? !1
  }), te = yt((ye) => {
    ee(ye), S && S(ye);
  }), ue = d.useCallback((ye) => {
    if (g && H.isBeforeYear(ye, z) || f && H.isAfterYear(ye, z) || y && H.isBeforeYear(ye, y) || h && H.isAfterYear(ye, h))
      return !0;
    if (!b)
      return !1;
    const Ie = H.startOfYear(ye);
    return b(Ie);
  }, [f, g, h, y, z, b, H]), K = yt((ye, Ie) => {
    if (m)
      return;
    const je = H.setYear(V ?? ie, Ie);
    B(je);
  }), oe = yt((ye) => {
    ue(H.setYear(V ?? ie, ye)) || (Ce(ye), te(!0), C == null || C(ye));
  });
  d.useEffect(() => {
    Ce((ye) => Y !== null && ye !== Y ? Y : ye);
  }, [Y]);
  const de = k !== "desc" ? T * 1 : T * -1, ve = G && k === "asc" || !G && k === "desc" ? -1 : 1, J = yt((ye, Ie) => {
    switch (ye.key) {
      case "ArrowUp":
        oe(Ie - de), ye.preventDefault();
        break;
      case "ArrowDown":
        oe(Ie + de), ye.preventDefault();
        break;
      case "ArrowLeft":
        oe(Ie - ve), ye.preventDefault();
        break;
      case "ArrowRight":
        oe(Ie + ve), ye.preventDefault();
        break;
    }
  }), se = yt((ye, Ie) => {
    oe(Ie);
  }), ge = yt((ye, Ie) => {
    pe === Ie && te(!1);
  }), Se = d.useRef(null), we = Vo(n, Se);
  d.useEffect(() => {
    if (i || Se.current === null)
      return;
    const ye = Se.current.querySelector('[tabindex="0"]');
    if (!ye)
      return;
    const Ie = ye.offsetHeight, je = ye.offsetTop, Te = Se.current.clientHeight, Fe = Se.current.scrollTop, gt = je + Ie;
    Ie > Te || je < Fe || (Se.current.scrollTop = gt - Te / 2 - Ie / 2);
  }, [i]);
  const me = H.getYearRange([y, h]);
  return k === "desc" && me.reverse(), /* @__PURE__ */ p.jsx(bP, Q({
    ref: we,
    className: xe(re.root, s),
    ownerState: ce,
    role: "radiogroup",
    "aria-labelledby": F
  }, R, {
    children: me.map((ye) => {
      const Ie = H.getYear(ye), je = Ie === Y, Te = u || ue(ye);
      return /* @__PURE__ */ p.jsx(gP, {
        selected: je,
        value: Ie,
        onClick: K,
        onKeyDown: J,
        autoFocus: fe && Ie === pe,
        disabled: Te,
        tabIndex: Ie === pe && !Te ? 0 : -1,
        onFocus: se,
        onBlur: ge,
        "aria-current": A === Ie ? "date" : void 0,
        yearsPerRow: T,
        slots: j,
        slotProps: L,
        children: H.format(ye, "year")
      }, H.format(ye, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" && (gm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true` picker is disabled
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  gridLabelId: o.string,
  hasFocus: o.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: o.func,
  onFocusedViewChange: o.func,
  onYearFocus: o.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: o.object,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: o.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: o.oneOf([3, 4])
});
const CP = (e) => uo("MuiPickersCalendarHeader", e), xP = po("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]);
function wP(e) {
  return uo("MuiPickersArrowSwitcher", e);
}
po("MuiPickersArrowSwitcher", ["root", "spacer", "button", "previousIconButton", "nextIconButton", "leftArrowIcon", "rightArrowIcon"]);
const SP = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel", "labelId"], EP = ["ownerState"], RP = ["ownerState"], TP = Z("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), MP = Z("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), c5 = Z(Ar, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})({
  variants: [{
    props: {
      hidden: !0
    },
    style: {
      visibility: "hidden"
    }
  }]
}), kP = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"],
    previousIconButton: ["previousIconButton"],
    nextIconButton: ["nextIconButton"],
    leftArrowIcon: ["leftArrowIcon"],
    rightArrowIcon: ["rightArrowIcon"]
  }, wP, t);
}, PP = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Io(), i = Kn({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: s,
    className: a,
    slots: l,
    slotProps: c,
    isNextDisabled: u,
    isNextHidden: f,
    onGoToNext: g,
    nextLabel: h,
    isPreviousDisabled: y,
    isPreviousHidden: v,
    onGoToPrevious: m,
    previousLabel: b,
    labelId: C
  } = i, E = Zt(i, SP), S = i, k = kP(S), T = {
    isDisabled: u,
    isHidden: f,
    goTo: g,
    label: h
  }, P = {
    isDisabled: y,
    isHidden: v,
    goTo: m,
    label: b
  }, F = (l == null ? void 0 : l.previousIconButton) ?? c5, j = kn({
    elementType: F,
    externalSlotProps: c == null ? void 0 : c.previousIconButton,
    additionalProps: {
      size: "medium",
      title: P.label,
      "aria-label": P.label,
      disabled: P.isDisabled,
      edge: "end",
      onClick: P.goTo
    },
    ownerState: Q({}, S, {
      hidden: P.isHidden
    }),
    className: xe(k.button, k.previousIconButton)
  }), L = (l == null ? void 0 : l.nextIconButton) ?? c5, R = kn({
    elementType: L,
    externalSlotProps: c == null ? void 0 : c.nextIconButton,
    additionalProps: {
      size: "medium",
      title: T.label,
      "aria-label": T.label,
      disabled: T.isDisabled,
      edge: "start",
      onClick: T.goTo
    },
    ownerState: Q({}, S, {
      hidden: T.isHidden
    }),
    className: xe(k.button, k.nextIconButton)
  }), V = (l == null ? void 0 : l.leftArrowIcon) ?? pM, B = kn({
    elementType: V,
    externalSlotProps: c == null ? void 0 : c.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: S,
    className: k.leftArrowIcon
  }), W = Zt(B, EP), z = (l == null ? void 0 : l.rightArrowIcon) ?? fM, G = kn({
    elementType: z,
    externalSlotProps: c == null ? void 0 : c.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: S,
    className: k.rightArrowIcon
  }), H = Zt(G, RP);
  return /* @__PURE__ */ p.jsxs(TP, Q({
    ref: n,
    className: xe(k.root, a),
    ownerState: S
  }, E, {
    children: [/* @__PURE__ */ p.jsx(F, Q({}, j, {
      children: r ? /* @__PURE__ */ p.jsx(z, Q({}, H)) : /* @__PURE__ */ p.jsx(V, Q({}, W))
    })), s ? /* @__PURE__ */ p.jsx(vo, {
      variant: "subtitle1",
      component: "span",
      id: C,
      children: s
    }) : /* @__PURE__ */ p.jsx(MP, {
      className: k.spacer,
      ownerState: S
    }), /* @__PURE__ */ p.jsx(L, Q({}, R, {
      children: r ? /* @__PURE__ */ p.jsx(V, Q({}, W)) : /* @__PURE__ */ p.jsx(z, Q({}, H))
    }))]
  }));
});
function IP(e, {
  disableFuture: t,
  maxDate: n,
  timezone: r
}) {
  const i = no();
  return d.useMemo(() => {
    const s = i.date(void 0, r), a = i.startOfMonth(t && i.isBefore(s, n) ? s : n);
    return !i.isAfter(a, e);
  }, [t, n, e, i, r]);
}
function OP(e, {
  disablePast: t,
  minDate: n,
  timezone: r
}) {
  const i = no();
  return d.useMemo(() => {
    const s = i.date(void 0, r), a = i.startOfMonth(t && i.isAfter(s, n) ? s : n);
    return !i.isBefore(a, e);
  }, [t, n, e, i, r]);
}
const DP = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone", "format"], jP = ["ownerState"], FP = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, CP, t);
}, VP = Z("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
}), $P = Z("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => Q({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, e.typography.body1, {
  fontWeight: e.typography.fontWeightMedium
})), LP = Z("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})({
  marginRight: 6
}), AP = Z(Ar, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (e, t) => t.switchViewButton
})({
  marginRight: "auto",
  variants: [{
    props: {
      view: "year"
    },
    style: {
      [`.${xP.switchViewIcon}`]: {
        transform: "rotate(180deg)"
      }
    }
  }]
}), NP = Z(dM, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (e, t) => t.switchViewIcon
})(({
  theme: e
}) => ({
  willChange: "transform",
  transition: e.transitions.create("transform"),
  transform: "rotate(0deg)"
})), mm = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Li(), i = no(), s = Kn({
    props: t,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: a,
    slotProps: l,
    currentMonth: c,
    disabled: u,
    disableFuture: f,
    disablePast: g,
    maxDate: h,
    minDate: y,
    onMonthChange: v,
    onViewChange: m,
    view: b,
    reduceAnimations: C,
    views: E,
    labelId: S,
    className: k,
    timezone: T,
    format: P = `${i.formats.month} ${i.formats.year}`
  } = s, F = Zt(s, DP), j = s, L = FP(s), R = (a == null ? void 0 : a.switchViewButton) ?? AP, V = kn({
    elementType: R,
    externalSlotProps: l == null ? void 0 : l.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": r.calendarViewSwitchingButtonAriaLabel(b)
    },
    ownerState: j,
    className: L.switchViewButton
  }), B = (a == null ? void 0 : a.switchViewIcon) ?? NP, W = kn({
    elementType: B,
    externalSlotProps: l == null ? void 0 : l.switchViewIcon,
    ownerState: j,
    className: L.switchViewIcon
  }), z = Zt(W, jP), G = () => v(i.addMonths(c, 1), "left"), H = () => v(i.addMonths(c, -1), "right"), ie = IP(c, {
    disableFuture: f,
    maxDate: h,
    timezone: T
  }), ce = OP(c, {
    disablePast: g,
    minDate: y,
    timezone: T
  }), re = () => {
    if (!(E.length === 1 || !m || u))
      if (E.length === 2)
        m(E.find((Y) => Y !== b) || E[0]);
      else {
        const Y = E.indexOf(b) !== 0 ? 0 : 1;
        m(E[Y]);
      }
  };
  if (E.length === 1 && E[0] === "year")
    return null;
  const A = i.formatByString(c, P);
  return /* @__PURE__ */ p.jsxs(VP, Q({}, F, {
    ownerState: j,
    className: xe(L.root, k),
    ref: n,
    children: [/* @__PURE__ */ p.jsxs($P, {
      role: "presentation",
      onClick: re,
      ownerState: j,
      "aria-live": "polite",
      className: L.labelContainer,
      children: [/* @__PURE__ */ p.jsx(lm, {
        reduceAnimations: C,
        transKey: A,
        children: /* @__PURE__ */ p.jsx(LP, {
          id: S,
          ownerState: j,
          className: L.label,
          children: A
        })
      }), E.length > 1 && !u && /* @__PURE__ */ p.jsx(R, Q({}, V, {
        children: /* @__PURE__ */ p.jsx(B, Q({}, z))
      }))]
    }), /* @__PURE__ */ p.jsx(Fi, {
      in: b === "day",
      appear: !C,
      enter: !C,
      children: /* @__PURE__ */ p.jsx(PP, {
        slots: a,
        slotProps: l,
        onGoToPrevious: H,
        isPreviousDisabled: ce,
        previousLabel: r.previousMonth,
        onGoToNext: G,
        isNextDisabled: ie,
        nextLabel: r.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (mm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  currentMonth: o.object.isRequired,
  disabled: o.bool,
  disableFuture: o.bool,
  disablePast: o.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: o.string,
  /**
   * Id of the calendar text element.
   * It is used to establish an `aria-labelledby` relationship with the calendar `grid` element.
   */
  labelId: o.string,
  maxDate: o.object.isRequired,
  minDate: o.object.isRequired,
  onMonthChange: o.func.isRequired,
  onViewChange: o.func,
  reduceAnimations: o.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  timezone: o.string.isRequired,
  view: o.oneOf(["day", "month", "year"]).isRequired,
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const BP = Z("div")({
  overflow: "hidden",
  width: Bd,
  maxHeight: pf,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
}), _P = (e) => uo("MuiDateCalendar", e);
po("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const zP = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsOrder", "yearsPerRow", "monthsPerRow", "timezone"], HP = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, _P, t);
};
function WP(e, t) {
  const n = no(), r = hc(), i = Yg(), s = Kn({
    props: e,
    name: t
  });
  return Q({}, s, {
    loading: s.loading ?? !1,
    disablePast: s.disablePast ?? !1,
    disableFuture: s.disableFuture ?? !1,
    openTo: s.openTo ?? "day",
    views: s.views ?? ["year", "day"],
    reduceAnimations: s.reduceAnimations ?? i,
    renderLoading: s.renderLoading ?? (() => /* @__PURE__ */ p.jsx("span", {
      children: "..."
    })),
    minDate: Pr(n, s.minDate, r.minDate),
    maxDate: Pr(n, s.maxDate, r.maxDate)
  });
}
const GP = Z(BP, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  height: pf
}), UP = Z(lm, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (e, t) => t.viewTransitionContainer
})({}), hm = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = no(), i = mc(), s = WP(t, "MuiDateCalendar"), {
    autoFocus: a,
    onViewChange: l,
    value: c,
    defaultValue: u,
    referenceDate: f,
    disableFuture: g,
    disablePast: h,
    onChange: y,
    onYearChange: v,
    onMonthChange: m,
    reduceAnimations: b,
    shouldDisableDate: C,
    shouldDisableMonth: E,
    shouldDisableYear: S,
    view: k,
    views: T,
    openTo: P,
    className: F,
    disabled: j,
    readOnly: L,
    minDate: R,
    maxDate: V,
    disableHighlightToday: B,
    focusedView: W,
    onFocusedViewChange: z,
    showDaysOutsideCurrentMonth: G,
    fixedWeekNumber: H,
    dayOfWeekFormatter: ie,
    slots: ce,
    slotProps: re,
    loading: A,
    renderLoading: Y,
    displayWeekNumber: pe,
    yearsOrder: Ce,
    yearsPerRow: fe,
    monthsPerRow: ee,
    timezone: te
  } = s, ue = Zt(s, zP), {
    value: K,
    handleValueChange: oe,
    timezone: de
  } = df({
    name: "DateCalendar",
    timezone: te,
    value: c,
    defaultValue: u,
    referenceDate: f,
    onChange: y,
    valueManager: oi
  }), {
    view: ve,
    setView: J,
    focusedView: se,
    setFocusedView: ge,
    goToNextView: Se,
    setValueAndGoToNextView: we
  } = Zg({
    view: k,
    views: T,
    openTo: P,
    onChange: oe,
    onViewChange: l,
    autoFocus: a,
    focusedView: W,
    onFocusedViewChange: z
  }), {
    referenceDate: me,
    calendarState: ye,
    changeFocusedDay: Ie,
    changeMonth: je,
    handleChangeMonth: Te,
    isDateDisabled: Fe,
    onMonthSwitchingAnimationEnd: gt
  } = wk({
    value: K,
    referenceDate: f,
    reduceAnimations: b,
    onMonthChange: m,
    minDate: R,
    maxDate: V,
    shouldDisableDate: C,
    disablePast: h,
    disableFuture: g,
    timezone: de
  }), Dt = j && K || R, ke = j && K || V, Ne = `${i}-grid-label`, We = se !== null, Ge = (ce == null ? void 0 : ce.calendarHeader) ?? mm, Qe = kn({
    elementType: Ge,
    externalSlotProps: re == null ? void 0 : re.calendarHeader,
    additionalProps: {
      views: T,
      view: ve,
      currentMonth: ye.currentMonth,
      onViewChange: J,
      onMonthChange: (Nt, cn) => Te({
        newMonth: Nt,
        direction: cn
      }),
      minDate: Dt,
      maxDate: ke,
      disabled: j,
      disablePast: h,
      disableFuture: g,
      reduceAnimations: b,
      timezone: de,
      labelId: Ne
    },
    ownerState: s
  }), Ve = yt((Nt) => {
    const cn = r.startOfMonth(Nt), Lt = r.endOfMonth(Nt), jt = Fe(Nt) ? Dl({
      utils: r,
      date: Nt,
      minDate: r.isBefore(R, cn) ? cn : R,
      maxDate: r.isAfter(V, Lt) ? Lt : V,
      disablePast: h,
      disableFuture: g,
      isDateDisabled: Fe,
      timezone: de
    }) : Nt;
    jt ? (we(jt, "finish"), m == null || m(cn)) : (Se(), je(cn)), Ie(jt, !0);
  }), Ke = yt((Nt) => {
    const cn = r.startOfYear(Nt), Lt = r.endOfYear(Nt), jt = Fe(Nt) ? Dl({
      utils: r,
      date: Nt,
      minDate: r.isBefore(R, cn) ? cn : R,
      maxDate: r.isAfter(V, Lt) ? Lt : V,
      disablePast: h,
      disableFuture: g,
      isDateDisabled: Fe,
      timezone: de
    }) : Nt;
    jt ? (we(jt, "finish"), v == null || v(jt)) : (Se(), je(cn)), Ie(jt, !0);
  }), bt = yt((Nt) => oe(Nt && Zu(r, Nt, K ?? me), "finish", ve));
  d.useEffect(() => {
    K != null && r.isValid(K) && je(K);
  }, [K]);
  const vt = s, tn = HP(vt), hn = {
    disablePast: h,
    disableFuture: g,
    maxDate: V,
    minDate: R
  }, Je = {
    disableHighlightToday: B,
    readOnly: L,
    disabled: j,
    timezone: de,
    gridLabelId: Ne,
    slots: ce,
    slotProps: re
  }, $t = d.useRef(ve);
  d.useEffect(() => {
    $t.current !== ve && (se === $t.current && ge(ve, !0), $t.current = ve);
  }, [se, ge, ve]);
  const nn = d.useMemo(() => [K], [K]);
  return /* @__PURE__ */ p.jsxs(GP, Q({
    ref: n,
    className: xe(tn.root, F),
    ownerState: vt
  }, ue, {
    children: [/* @__PURE__ */ p.jsx(Ge, Q({}, Qe, {
      slots: ce,
      slotProps: re
    })), /* @__PURE__ */ p.jsx(UP, {
      reduceAnimations: b,
      className: tn.viewTransitionContainer,
      transKey: ve,
      ownerState: vt,
      children: /* @__PURE__ */ p.jsxs("div", {
        children: [ve === "year" && /* @__PURE__ */ p.jsx(gm, Q({}, hn, Je, {
          value: K,
          onChange: Ke,
          shouldDisableYear: S,
          hasFocus: We,
          onFocusedViewChange: (Nt) => ge("year", Nt),
          yearsOrder: Ce,
          yearsPerRow: fe,
          referenceDate: me
        })), ve === "month" && /* @__PURE__ */ p.jsx(fm, Q({}, hn, Je, {
          hasFocus: We,
          className: F,
          value: K,
          onChange: Ve,
          shouldDisableMonth: E,
          onFocusedViewChange: (Nt) => ge("month", Nt),
          monthsPerRow: ee,
          referenceDate: me
        })), ve === "day" && /* @__PURE__ */ p.jsx(Xk, Q({}, ye, hn, Je, {
          onMonthSwitchingAnimationEnd: gt,
          onFocusedDayChange: Ie,
          reduceAnimations: b,
          selectedDays: nn,
          onSelectedDaysChange: bt,
          shouldDisableDate: C,
          shouldDisableMonth: E,
          shouldDisableYear: S,
          hasFocus: We,
          onFocusedViewChange: (Nt) => ge("day", Nt),
          showDaysOutsideCurrentMonth: G,
          fixedWeekNumber: H,
          dayOfWeekFormatter: ie,
          displayWeekNumber: pe,
          loading: A,
          renderLoading: Y
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (hm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: o.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: o.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: o.number,
  /**
   * Controlled focused view.
   */
  focusedView: o.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: o.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: o.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: o.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: o.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: o.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: o.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: o.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: o.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: o.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: o.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: o.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: o.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: o.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: o.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: o.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: o.oneOf([3, 4])
});
const ha = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: r,
  onFocusedViewChange: i,
  value: s,
  defaultValue: a,
  referenceDate: l,
  onChange: c,
  className: u,
  classes: f,
  disableFuture: g,
  disablePast: h,
  minDate: y,
  maxDate: v,
  shouldDisableDate: m,
  shouldDisableMonth: b,
  shouldDisableYear: C,
  reduceAnimations: E,
  onMonthChange: S,
  monthsPerRow: k,
  onYearChange: T,
  yearsOrder: P,
  yearsPerRow: F,
  slots: j,
  slotProps: L,
  loading: R,
  renderLoading: V,
  disableHighlightToday: B,
  readOnly: W,
  disabled: z,
  showDaysOutsideCurrentMonth: G,
  dayOfWeekFormatter: H,
  sx: ie,
  autoFocus: ce,
  fixedWeekNumber: re,
  displayWeekNumber: A,
  timezone: Y
}) => /* @__PURE__ */ p.jsx(hm, {
  view: e,
  onViewChange: t,
  views: n.filter(Z3),
  focusedView: r && Z3(r) ? r : null,
  onFocusedViewChange: i,
  value: s,
  defaultValue: a,
  referenceDate: l,
  onChange: c,
  className: u,
  classes: f,
  disableFuture: g,
  disablePast: h,
  minDate: y,
  maxDate: v,
  shouldDisableDate: m,
  shouldDisableMonth: b,
  shouldDisableYear: C,
  reduceAnimations: E,
  onMonthChange: S,
  monthsPerRow: k,
  onYearChange: T,
  yearsOrder: P,
  yearsPerRow: F,
  slots: j,
  slotProps: L,
  loading: R,
  renderLoading: V,
  disableHighlightToday: B,
  readOnly: W,
  disabled: z,
  showDaysOutsideCurrentMonth: G,
  dayOfWeekFormatter: H,
  sx: ie,
  autoFocus: ce,
  fixedWeekNumber: re,
  displayWeekNumber: A,
  timezone: Y
}), bf = /* @__PURE__ */ d.forwardRef(function(t, n) {
  var u, f;
  const r = Li(), i = no(), s = Hg(t, "MuiDesktopDatePicker"), a = Q({
    day: ha,
    month: ha,
    year: ha
  }, s.viewRenderers), l = Q({}, s, {
    viewRenderers: a,
    format: sf(i, s, !1),
    yearsPerRow: s.yearsPerRow ?? 4,
    slots: Q({
      openPickerIcon: gM,
      field: yf
    }, s.slots),
    slotProps: Q({}, s.slotProps, {
      field: (g) => {
        var h;
        return Q({}, wi((h = s.slotProps) == null ? void 0 : h.field, g), Gg(s), {
          ref: n
        });
      },
      toolbar: Q({
        hidden: !0
      }, (u = s.slotProps) == null ? void 0 : u.toolbar)
    })
  }), {
    renderPicker: c
  } = uM({
    props: l,
    valueManager: oi,
    valueType: "date",
    getOpenDialogAriaText: Bg({
      utils: i,
      formatKey: "fullDate",
      contextTranslation: r.openDatePickerDialogue,
      propsTranslation: (f = l.localeText) == null ? void 0 : f.openDatePickerDialogue
    }),
    validator: vc
  });
  return c();
});
bf.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: o.bool,
  className: o.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: o.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: o.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: o.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: o.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: o.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: o.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: o.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $i,
  /**
   * The label content.
   */
  label: o.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: o.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: o.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: o.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: o.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: o.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: o.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: o.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: o.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: o.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: o.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: o.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: o.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: o.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: o.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: o.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: o.oneOf(["landscape", "portrait"]),
  readOnly: o.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: o.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: o.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: o.oneOfType([o.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), o.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: o.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: o.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: o.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: o.shape({
    day: o.func,
    month: o.func,
    year: o.func
  }),
  /**
   * Available views.
   */
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: o.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: o.oneOf([3, 4])
};
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var vm;
function ct() {
  return vm.apply(null, arguments);
}
function YP(e) {
  vm = e;
}
function Nr(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Ds(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Dn(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Cf(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (Dn(e, t))
      return !1;
  return !0;
}
function Qo(e) {
  return e === void 0;
}
function Vi(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function yc(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function ym(e, t) {
  var n = [], r, i = e.length;
  for (r = 0; r < i; ++r)
    n.push(t(e[r], r));
  return n;
}
function Ki(e, t) {
  for (var n in t)
    Dn(t, n) && (e[n] = t[n]);
  return Dn(t, "toString") && (e.toString = t.toString), Dn(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function ci(e, t, n, r) {
  return zm(e, t, n, r, !0).utc();
}
function ZP() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function mn(e) {
  return e._pf == null && (e._pf = ZP()), e._pf;
}
var Z0;
Array.prototype.some ? Z0 = Array.prototype.some : Z0 = function(e) {
  var t = Object(this), n = t.length >>> 0, r;
  for (r = 0; r < n; r++)
    if (r in t && e.call(this, t[r], r, t))
      return !0;
  return !1;
};
function xf(e) {
  if (e._isValid == null) {
    var t = mn(e), n = Z0.call(t.parsedDateParts, function(i) {
      return i != null;
    }), r = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
    if (e._strict && (r = r && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = r;
    else
      return r;
  }
  return e._isValid;
}
function Hd(e) {
  var t = ci(NaN);
  return e != null ? Ki(mn(t), e) : mn(t).userInvalidated = !0, t;
}
var u5 = ct.momentProperties = [], q1 = !1;
function wf(e, t) {
  var n, r, i, s = u5.length;
  if (Qo(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Qo(t._i) || (e._i = t._i), Qo(t._f) || (e._f = t._f), Qo(t._l) || (e._l = t._l), Qo(t._strict) || (e._strict = t._strict), Qo(t._tzm) || (e._tzm = t._tzm), Qo(t._isUTC) || (e._isUTC = t._isUTC), Qo(t._offset) || (e._offset = t._offset), Qo(t._pf) || (e._pf = mn(t)), Qo(t._locale) || (e._locale = t._locale), s > 0)
    for (n = 0; n < s; n++)
      r = u5[n], i = t[r], Qo(i) || (e[r] = i);
  return e;
}
function bc(e) {
  wf(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), q1 === !1 && (q1 = !0, ct.updateOffset(this), q1 = !1);
}
function Br(e) {
  return e instanceof bc || e != null && e._isAMomentObject != null;
}
function bm(e) {
  ct.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Or(e, t) {
  var n = !0;
  return Ki(function() {
    if (ct.deprecationHandler != null && ct.deprecationHandler(null, e), n) {
      var r = [], i, s, a, l = arguments.length;
      for (s = 0; s < l; s++) {
        if (i = "", typeof arguments[s] == "object") {
          i += `
[` + s + "] ";
          for (a in arguments[0])
            Dn(arguments[0], a) && (i += a + ": " + arguments[0][a] + ", ");
          i = i.slice(0, -2);
        } else
          i = arguments[s];
        r.push(i);
      }
      bm(
        e + `
Arguments: ` + Array.prototype.slice.call(r).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var d5 = {};
function Cm(e, t) {
  ct.deprecationHandler != null && ct.deprecationHandler(e, t), d5[e] || (bm(t), d5[e] = !0);
}
ct.suppressDeprecationWarnings = !1;
ct.deprecationHandler = null;
function ui(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function qP(e) {
  var t, n;
  for (n in e)
    Dn(e, n) && (t = e[n], ui(t) ? this[n] = t : this["_" + n] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function q0(e, t) {
  var n = Ki({}, e), r;
  for (r in t)
    Dn(t, r) && (Ds(e[r]) && Ds(t[r]) ? (n[r] = {}, Ki(n[r], e[r]), Ki(n[r], t[r])) : t[r] != null ? n[r] = t[r] : delete n[r]);
  for (r in e)
    Dn(e, r) && !Dn(t, r) && Ds(e[r]) && (n[r] = Ki({}, n[r]));
  return n;
}
function Sf(e) {
  e != null && this.set(e);
}
var K0;
Object.keys ? K0 = Object.keys : K0 = function(e) {
  var t, n = [];
  for (t in e)
    Dn(e, t) && n.push(t);
  return n;
};
var KP = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function XP(e, t, n) {
  var r = this._calendar[e] || this._calendar.sameElse;
  return ui(r) ? r.call(t, n) : r;
}
function ri(e, t, n) {
  var r = "" + Math.abs(e), i = t - r.length, s = e >= 0;
  return (s ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + r;
}
var Ef = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, du = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, K1 = {}, va = {};
function Bt(e, t, n, r) {
  var i = r;
  typeof r == "string" && (i = function() {
    return this[r]();
  }), e && (va[e] = i), t && (va[t[0]] = function() {
    return ri(i.apply(this, arguments), t[1], t[2]);
  }), n && (va[n] = function() {
    return this.localeData().ordinal(
      i.apply(this, arguments),
      e
    );
  });
}
function QP(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function JP(e) {
  var t = e.match(Ef), n, r;
  for (n = 0, r = t.length; n < r; n++)
    va[t[n]] ? t[n] = va[t[n]] : t[n] = QP(t[n]);
  return function(i) {
    var s = "", a;
    for (a = 0; a < r; a++)
      s += ui(t[a]) ? t[a].call(i, e) : t[a];
    return s;
  };
}
function Pu(e, t) {
  return e.isValid() ? (t = xm(t, e.localeData()), K1[t] = K1[t] || JP(t), K1[t](e)) : e.localeData().invalidDate();
}
function xm(e, t) {
  var n = 5;
  function r(i) {
    return t.longDateFormat(i) || i;
  }
  for (du.lastIndex = 0; n >= 0 && du.test(e); )
    e = e.replace(
      du,
      r
    ), du.lastIndex = 0, n -= 1;
  return e;
}
var eI = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function tI(e) {
  var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return t || !n ? t : (this._longDateFormat[e] = n.match(Ef).map(function(r) {
    return r === "MMMM" || r === "MM" || r === "DD" || r === "dddd" ? r.slice(1) : r;
  }).join(""), this._longDateFormat[e]);
}
var nI = "Invalid date";
function oI() {
  return this._invalidDate;
}
var rI = "%d", iI = /\d{1,2}/;
function sI(e) {
  return this._ordinal.replace("%d", e);
}
var aI = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function lI(e, t, n, r) {
  var i = this._relativeTime[n];
  return ui(i) ? i(e, t, n, r) : i.replace(/%d/i, e);
}
function cI(e, t) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return ui(n) ? n(t) : n.replace(/%s/i, t);
}
var jl = {};
function zo(e, t) {
  var n = e.toLowerCase();
  jl[n] = jl[n + "s"] = jl[t] = e;
}
function Dr(e) {
  return typeof e == "string" ? jl[e] || jl[e.toLowerCase()] : void 0;
}
function Rf(e) {
  var t = {}, n, r;
  for (r in e)
    Dn(e, r) && (n = Dr(r), n && (t[n] = e[r]));
  return t;
}
var wm = {};
function Ho(e, t) {
  wm[e] = t;
}
function uI(e) {
  var t = [], n;
  for (n in e)
    Dn(e, n) && t.push({ unit: n, priority: wm[n] });
  return t.sort(function(r, i) {
    return r.priority - i.priority;
  }), t;
}
function Wd(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function br(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function Cn(e) {
  var t = +e, n = 0;
  return t !== 0 && isFinite(t) && (n = br(t)), n;
}
function Da(e, t) {
  return function(n) {
    return n != null ? (Sm(this, e, n), ct.updateOffset(this, t), this) : Ku(this, e);
  };
}
function Ku(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function Sm(e, t, n) {
  e.isValid() && !isNaN(n) && (t === "FullYear" && Wd(e.year()) && e.month() === 1 && e.date() === 29 ? (n = Cn(n), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    n,
    e.month(),
    Kd(n, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
}
function dI(e) {
  return e = Dr(e), ui(this[e]) ? this[e]() : this;
}
function pI(e, t) {
  if (typeof e == "object") {
    e = Rf(e);
    var n = uI(e), r, i = n.length;
    for (r = 0; r < i; r++)
      this[n[r].unit](e[n[r].unit]);
  } else if (e = Dr(e), ui(this[e]))
    return this[e](t);
  return this;
}
var Em = /\d/, fr = /\d\d/, Rm = /\d{3}/, Tf = /\d{4}/, Gd = /[+-]?\d{6}/, oo = /\d\d?/, Tm = /\d\d\d\d?/, Mm = /\d\d\d\d\d\d?/, Ud = /\d{1,3}/, Mf = /\d{1,4}/, Yd = /[+-]?\d{1,6}/, ja = /\d+/, Zd = /[+-]?\d+/, fI = /Z|[+-]\d\d:?\d\d/gi, qd = /Z|[+-]\d\d(?::?\d\d)?/gi, gI = /[+-]?\d+(\.\d{1,3})?/, Cc = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Xu;
Xu = {};
function xt(e, t, n) {
  Xu[e] = ui(t) ? t : function(r, i) {
    return r && n ? n : t;
  };
}
function mI(e, t) {
  return Dn(Xu, e) ? Xu[e](t._strict, t._locale) : new RegExp(hI(e));
}
function hI(e) {
  return ar(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, n, r, i, s) {
        return n || r || i || s;
      }
    )
  );
}
function ar(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var X0 = {};
function Hn(e, t) {
  var n, r = t, i;
  for (typeof e == "string" && (e = [e]), Vi(t) && (r = function(s, a) {
    a[t] = Cn(s);
  }), i = e.length, n = 0; n < i; n++)
    X0[e[n]] = r;
}
function xc(e, t) {
  Hn(e, function(n, r, i, s) {
    i._w = i._w || {}, t(n, i._w, i, s);
  });
}
function vI(e, t, n) {
  t != null && Dn(X0, e) && X0[e](t, n._a, n, e);
}
var _o = 0, Ei = 1, qr = 2, Po = 3, Vr = 4, Ri = 5, ks = 6, yI = 7, bI = 8;
function CI(e, t) {
  return (e % t + t) % t;
}
var bo;
Array.prototype.indexOf ? bo = Array.prototype.indexOf : bo = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function Kd(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var n = CI(t, 12);
  return e += (t - n) / 12, n === 1 ? Wd(e) ? 29 : 28 : 31 - n % 7 % 2;
}
Bt("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Bt("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
Bt("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
zo("month", "M");
Ho("month", 8);
xt("M", oo);
xt("MM", oo, fr);
xt("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
xt("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
Hn(["M", "MM"], function(e, t) {
  t[Ei] = Cn(e) - 1;
});
Hn(["MMM", "MMMM"], function(e, t, n, r) {
  var i = n._locale.monthsParse(e, r, n._strict);
  i != null ? t[Ei] = i : mn(n).invalidMonth = e;
});
var xI = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), km = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Pm = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, wI = Cc, SI = Cc;
function EI(e, t) {
  return e ? Nr(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Pm).test(t) ? "format" : "standalone"][e.month()] : Nr(this._months) ? this._months : this._months.standalone;
}
function RI(e, t) {
  return e ? Nr(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Pm.test(t) ? "format" : "standalone"][e.month()] : Nr(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function TI(e, t, n) {
  var r, i, s, a = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)
      s = ci([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(
        s,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[r] = this.months(s, "").toLocaleLowerCase();
  return n ? t === "MMM" ? (i = bo.call(this._shortMonthsParse, a), i !== -1 ? i : null) : (i = bo.call(this._longMonthsParse, a), i !== -1 ? i : null) : t === "MMM" ? (i = bo.call(this._shortMonthsParse, a), i !== -1 ? i : (i = bo.call(this._longMonthsParse, a), i !== -1 ? i : null)) : (i = bo.call(this._longMonthsParse, a), i !== -1 ? i : (i = bo.call(this._shortMonthsParse, a), i !== -1 ? i : null));
}
function MI(e, t, n) {
  var r, i, s;
  if (this._monthsParseExact)
    return TI.call(this, e, t, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
    if (i = ci([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp(
      "^" + this.months(i, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[r] = new RegExp(
      "^" + this.monthsShort(i, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[r] && (s = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[r] = new RegExp(s.replace(".", ""), "i")), n && t === "MMMM" && this._longMonthsParse[r].test(e))
      return r;
    if (n && t === "MMM" && this._shortMonthsParse[r].test(e))
      return r;
    if (!n && this._monthsParse[r].test(e))
      return r;
  }
}
function Im(e, t) {
  var n;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = Cn(t);
    else if (t = e.localeData().monthsParse(t), !Vi(t))
      return e;
  }
  return n = Math.min(e.date(), Kd(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
}
function Om(e) {
  return e != null ? (Im(this, e), ct.updateOffset(this, !0), this) : Ku(this, "Month");
}
function kI() {
  return Kd(this.year(), this.month());
}
function PI(e) {
  return this._monthsParseExact ? (Dn(this, "_monthsRegex") || Dm.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Dn(this, "_monthsShortRegex") || (this._monthsShortRegex = wI), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function II(e) {
  return this._monthsParseExact ? (Dn(this, "_monthsRegex") || Dm.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Dn(this, "_monthsRegex") || (this._monthsRegex = SI), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Dm() {
  function e(a, l) {
    return l.length - a.length;
  }
  var t = [], n = [], r = [], i, s;
  for (i = 0; i < 12; i++)
    s = ci([2e3, i]), t.push(this.monthsShort(s, "")), n.push(this.months(s, "")), r.push(this.months(s, "")), r.push(this.monthsShort(s, ""));
  for (t.sort(e), n.sort(e), r.sort(e), i = 0; i < 12; i++)
    t[i] = ar(t[i]), n[i] = ar(n[i]);
  for (i = 0; i < 24; i++)
    r[i] = ar(r[i]);
  this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
Bt("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? ri(e, 4) : "+" + e;
});
Bt(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Bt(0, ["YYYY", 4], 0, "year");
Bt(0, ["YYYYY", 5], 0, "year");
Bt(0, ["YYYYYY", 6, !0], 0, "year");
zo("year", "y");
Ho("year", 1);
xt("Y", Zd);
xt("YY", oo, fr);
xt("YYYY", Mf, Tf);
xt("YYYYY", Yd, Gd);
xt("YYYYYY", Yd, Gd);
Hn(["YYYYY", "YYYYYY"], _o);
Hn("YYYY", function(e, t) {
  t[_o] = e.length === 2 ? ct.parseTwoDigitYear(e) : Cn(e);
});
Hn("YY", function(e, t) {
  t[_o] = ct.parseTwoDigitYear(e);
});
Hn("Y", function(e, t) {
  t[_o] = parseInt(e, 10);
});
function Fl(e) {
  return Wd(e) ? 366 : 365;
}
ct.parseTwoDigitYear = function(e) {
  return Cn(e) + (Cn(e) > 68 ? 1900 : 2e3);
};
var jm = Da("FullYear", !0);
function OI() {
  return Wd(this.year());
}
function DI(e, t, n, r, i, s, a) {
  var l;
  return e < 100 && e >= 0 ? (l = new Date(e + 400, t, n, r, i, s, a), isFinite(l.getFullYear()) && l.setFullYear(e)) : l = new Date(e, t, n, r, i, s, a), l;
}
function ql(e) {
  var t, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function Qu(e, t, n) {
  var r = 7 + t - n, i = (7 + ql(e, 0, r).getUTCDay() - t) % 7;
  return -i + r - 1;
}
function Fm(e, t, n, r, i) {
  var s = (7 + n - r) % 7, a = Qu(e, r, i), l = 1 + 7 * (t - 1) + s + a, c, u;
  return l <= 0 ? (c = e - 1, u = Fl(c) + l) : l > Fl(e) ? (c = e + 1, u = l - Fl(e)) : (c = e, u = l), {
    year: c,
    dayOfYear: u
  };
}
function Kl(e, t, n) {
  var r = Qu(e.year(), t, n), i = Math.floor((e.dayOfYear() - r - 1) / 7) + 1, s, a;
  return i < 1 ? (a = e.year() - 1, s = i + Mi(a, t, n)) : i > Mi(e.year(), t, n) ? (s = i - Mi(e.year(), t, n), a = e.year() + 1) : (a = e.year(), s = i), {
    week: s,
    year: a
  };
}
function Mi(e, t, n) {
  var r = Qu(e, t, n), i = Qu(e + 1, t, n);
  return (Fl(e) - r + i) / 7;
}
Bt("w", ["ww", 2], "wo", "week");
Bt("W", ["WW", 2], "Wo", "isoWeek");
zo("week", "w");
zo("isoWeek", "W");
Ho("week", 5);
Ho("isoWeek", 5);
xt("w", oo);
xt("ww", oo, fr);
xt("W", oo);
xt("WW", oo, fr);
xc(
  ["w", "ww", "W", "WW"],
  function(e, t, n, r) {
    t[r.substr(0, 1)] = Cn(e);
  }
);
function jI(e) {
  return Kl(e, this._week.dow, this._week.doy).week;
}
var FI = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function VI() {
  return this._week.dow;
}
function $I() {
  return this._week.doy;
}
function LI(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function AI(e) {
  var t = Kl(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
Bt("d", 0, "do", "day");
Bt("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
Bt("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
Bt("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
Bt("e", 0, 0, "weekday");
Bt("E", 0, 0, "isoWeekday");
zo("day", "d");
zo("weekday", "e");
zo("isoWeekday", "E");
Ho("day", 11);
Ho("weekday", 11);
Ho("isoWeekday", 11);
xt("d", oo);
xt("e", oo);
xt("E", oo);
xt("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
xt("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
xt("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
xc(["dd", "ddd", "dddd"], function(e, t, n, r) {
  var i = n._locale.weekdaysParse(e, r, n._strict);
  i != null ? t.d = i : mn(n).invalidWeekday = e;
});
xc(["d", "e", "E"], function(e, t, n, r) {
  t[r] = Cn(e);
});
function NI(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function BI(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function kf(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var _I = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Vm = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), zI = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), HI = Cc, WI = Cc, GI = Cc;
function UI(e, t) {
  var n = Nr(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? kf(n, this._week.dow) : e ? n[e.day()] : n;
}
function YI(e) {
  return e === !0 ? kf(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function ZI(e) {
  return e === !0 ? kf(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function qI(e, t, n) {
  var r, i, s, a = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)
      s = ci([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(
        s,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(
        s,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(s, "").toLocaleLowerCase();
  return n ? t === "dddd" ? (i = bo.call(this._weekdaysParse, a), i !== -1 ? i : null) : t === "ddd" ? (i = bo.call(this._shortWeekdaysParse, a), i !== -1 ? i : null) : (i = bo.call(this._minWeekdaysParse, a), i !== -1 ? i : null) : t === "dddd" ? (i = bo.call(this._weekdaysParse, a), i !== -1 || (i = bo.call(this._shortWeekdaysParse, a), i !== -1) ? i : (i = bo.call(this._minWeekdaysParse, a), i !== -1 ? i : null)) : t === "ddd" ? (i = bo.call(this._shortWeekdaysParse, a), i !== -1 || (i = bo.call(this._weekdaysParse, a), i !== -1) ? i : (i = bo.call(this._minWeekdaysParse, a), i !== -1 ? i : null)) : (i = bo.call(this._minWeekdaysParse, a), i !== -1 || (i = bo.call(this._weekdaysParse, a), i !== -1) ? i : (i = bo.call(this._shortWeekdaysParse, a), i !== -1 ? i : null));
}
function KI(e, t, n) {
  var r, i, s;
  if (this._weekdaysParseExact)
    return qI.call(this, e, t, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
    if (i = ci([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp(
      "^" + this.weekdays(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[r] || (s = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[r] = new RegExp(s.replace(".", ""), "i")), n && t === "dddd" && this._fullWeekdaysParse[r].test(e))
      return r;
    if (n && t === "ddd" && this._shortWeekdaysParse[r].test(e))
      return r;
    if (n && t === "dd" && this._minWeekdaysParse[r].test(e))
      return r;
    if (!n && this._weekdaysParse[r].test(e))
      return r;
  }
}
function XI(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = NI(e, this.localeData()), this.add(e - t, "d")) : t;
}
function QI(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function JI(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = BI(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function eO(e) {
  return this._weekdaysParseExact ? (Dn(this, "_weekdaysRegex") || Pf.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Dn(this, "_weekdaysRegex") || (this._weekdaysRegex = HI), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function tO(e) {
  return this._weekdaysParseExact ? (Dn(this, "_weekdaysRegex") || Pf.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Dn(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = WI), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function nO(e) {
  return this._weekdaysParseExact ? (Dn(this, "_weekdaysRegex") || Pf.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Dn(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = GI), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Pf() {
  function e(f, g) {
    return g.length - f.length;
  }
  var t = [], n = [], r = [], i = [], s, a, l, c, u;
  for (s = 0; s < 7; s++)
    a = ci([2e3, 1]).day(s), l = ar(this.weekdaysMin(a, "")), c = ar(this.weekdaysShort(a, "")), u = ar(this.weekdays(a, "")), t.push(l), n.push(c), r.push(u), i.push(l), i.push(c), i.push(u);
  t.sort(e), n.sort(e), r.sort(e), i.sort(e), this._weekdaysRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function If() {
  return this.hours() % 12 || 12;
}
function oO() {
  return this.hours() || 24;
}
Bt("H", ["HH", 2], 0, "hour");
Bt("h", ["hh", 2], 0, If);
Bt("k", ["kk", 2], 0, oO);
Bt("hmm", 0, 0, function() {
  return "" + If.apply(this) + ri(this.minutes(), 2);
});
Bt("hmmss", 0, 0, function() {
  return "" + If.apply(this) + ri(this.minutes(), 2) + ri(this.seconds(), 2);
});
Bt("Hmm", 0, 0, function() {
  return "" + this.hours() + ri(this.minutes(), 2);
});
Bt("Hmmss", 0, 0, function() {
  return "" + this.hours() + ri(this.minutes(), 2) + ri(this.seconds(), 2);
});
function $m(e, t) {
  Bt(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
$m("a", !0);
$m("A", !1);
zo("hour", "h");
Ho("hour", 13);
function Lm(e, t) {
  return t._meridiemParse;
}
xt("a", Lm);
xt("A", Lm);
xt("H", oo);
xt("h", oo);
xt("k", oo);
xt("HH", oo, fr);
xt("hh", oo, fr);
xt("kk", oo, fr);
xt("hmm", Tm);
xt("hmmss", Mm);
xt("Hmm", Tm);
xt("Hmmss", Mm);
Hn(["H", "HH"], Po);
Hn(["k", "kk"], function(e, t, n) {
  var r = Cn(e);
  t[Po] = r === 24 ? 0 : r;
});
Hn(["a", "A"], function(e, t, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
Hn(["h", "hh"], function(e, t, n) {
  t[Po] = Cn(e), mn(n).bigHour = !0;
});
Hn("hmm", function(e, t, n) {
  var r = e.length - 2;
  t[Po] = Cn(e.substr(0, r)), t[Vr] = Cn(e.substr(r)), mn(n).bigHour = !0;
});
Hn("hmmss", function(e, t, n) {
  var r = e.length - 4, i = e.length - 2;
  t[Po] = Cn(e.substr(0, r)), t[Vr] = Cn(e.substr(r, 2)), t[Ri] = Cn(e.substr(i)), mn(n).bigHour = !0;
});
Hn("Hmm", function(e, t, n) {
  var r = e.length - 2;
  t[Po] = Cn(e.substr(0, r)), t[Vr] = Cn(e.substr(r));
});
Hn("Hmmss", function(e, t, n) {
  var r = e.length - 4, i = e.length - 2;
  t[Po] = Cn(e.substr(0, r)), t[Vr] = Cn(e.substr(r, 2)), t[Ri] = Cn(e.substr(i));
});
function rO(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var iO = /[ap]\.?m?\.?/i, sO = Da("Hours", !0);
function aO(e, t, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var Am = {
  calendar: KP,
  longDateFormat: eI,
  invalidDate: nI,
  ordinal: rI,
  dayOfMonthOrdinalParse: iI,
  relativeTime: aI,
  months: xI,
  monthsShort: km,
  week: FI,
  weekdays: _I,
  weekdaysMin: zI,
  weekdaysShort: Vm,
  meridiemParse: iO
}, ao = {}, ll = {}, Xl;
function lO(e, t) {
  var n, r = Math.min(e.length, t.length);
  for (n = 0; n < r; n += 1)
    if (e[n] !== t[n])
      return n;
  return r;
}
function p5(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function cO(e) {
  for (var t = 0, n, r, i, s; t < e.length; ) {
    for (s = p5(e[t]).split("-"), n = s.length, r = p5(e[t + 1]), r = r ? r.split("-") : null; n > 0; ) {
      if (i = Xd(s.slice(0, n).join("-")), i)
        return i;
      if (r && r.length >= n && lO(s, r) >= n - 1)
        break;
      n--;
    }
    t++;
  }
  return Xl;
}
function uO(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function Xd(e) {
  var t = null, n;
  if (ao[e] === void 0 && typeof module < "u" && module && module.exports && uO(e))
    try {
      t = Xl._abbr, n = require, n("./locale/" + e), es(t);
    } catch {
      ao[e] = null;
    }
  return ao[e];
}
function es(e, t) {
  var n;
  return e && (Qo(t) ? n = Ai(e) : n = Of(e, t), n ? Xl = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Xl._abbr;
}
function Of(e, t) {
  if (t !== null) {
    var n, r = Am;
    if (t.abbr = e, ao[e] != null)
      Cm(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), r = ao[e]._config;
    else if (t.parentLocale != null)
      if (ao[t.parentLocale] != null)
        r = ao[t.parentLocale]._config;
      else if (n = Xd(t.parentLocale), n != null)
        r = n._config;
      else
        return ll[t.parentLocale] || (ll[t.parentLocale] = []), ll[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return ao[e] = new Sf(q0(r, t)), ll[e] && ll[e].forEach(function(i) {
      Of(i.name, i.config);
    }), es(e), ao[e];
  } else
    return delete ao[e], null;
}
function dO(e, t) {
  if (t != null) {
    var n, r, i = Am;
    ao[e] != null && ao[e].parentLocale != null ? ao[e].set(q0(ao[e]._config, t)) : (r = Xd(e), r != null && (i = r._config), t = q0(i, t), r == null && (t.abbr = e), n = new Sf(t), n.parentLocale = ao[e], ao[e] = n), es(e);
  } else
    ao[e] != null && (ao[e].parentLocale != null ? (ao[e] = ao[e].parentLocale, e === es() && es(e)) : ao[e] != null && delete ao[e]);
  return ao[e];
}
function Ai(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Xl;
  if (!Nr(e)) {
    if (t = Xd(e), t)
      return t;
    e = [e];
  }
  return cO(e);
}
function pO() {
  return K0(ao);
}
function Df(e) {
  var t, n = e._a;
  return n && mn(e).overflow === -2 && (t = n[Ei] < 0 || n[Ei] > 11 ? Ei : n[qr] < 1 || n[qr] > Kd(n[_o], n[Ei]) ? qr : n[Po] < 0 || n[Po] > 24 || n[Po] === 24 && (n[Vr] !== 0 || n[Ri] !== 0 || n[ks] !== 0) ? Po : n[Vr] < 0 || n[Vr] > 59 ? Vr : n[Ri] < 0 || n[Ri] > 59 ? Ri : n[ks] < 0 || n[ks] > 999 ? ks : -1, mn(e)._overflowDayOfYear && (t < _o || t > qr) && (t = qr), mn(e)._overflowWeeks && t === -1 && (t = yI), mn(e)._overflowWeekday && t === -1 && (t = bI), mn(e).overflow = t), e;
}
var fO = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, gO = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, mO = /Z|[+-]\d\d(?::?\d\d)?/, pu = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], X1 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], hO = /^\/?Date\((-?\d+)/i, vO = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, yO = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Nm(e) {
  var t, n, r = e._i, i = fO.exec(r) || gO.exec(r), s, a, l, c, u = pu.length, f = X1.length;
  if (i) {
    for (mn(e).iso = !0, t = 0, n = u; t < n; t++)
      if (pu[t][1].exec(i[1])) {
        a = pu[t][0], s = pu[t][2] !== !1;
        break;
      }
    if (a == null) {
      e._isValid = !1;
      return;
    }
    if (i[3]) {
      for (t = 0, n = f; t < n; t++)
        if (X1[t][1].exec(i[3])) {
          l = (i[2] || " ") + X1[t][0];
          break;
        }
      if (l == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!s && l != null) {
      e._isValid = !1;
      return;
    }
    if (i[4])
      if (mO.exec(i[4]))
        c = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = a + (l || "") + (c || ""), Ff(e);
  } else
    e._isValid = !1;
}
function bO(e, t, n, r, i, s) {
  var a = [
    CO(e),
    km.indexOf(t),
    parseInt(n, 10),
    parseInt(r, 10),
    parseInt(i, 10)
  ];
  return s && a.push(parseInt(s, 10)), a;
}
function CO(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function xO(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function wO(e, t, n) {
  if (e) {
    var r = Vm.indexOf(e), i = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (r !== i)
      return mn(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function SO(e, t, n) {
  if (e)
    return yO[e];
  if (t)
    return 0;
  var r = parseInt(n, 10), i = r % 100, s = (r - i) / 100;
  return s * 60 + i;
}
function Bm(e) {
  var t = vO.exec(xO(e._i)), n;
  if (t) {
    if (n = bO(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !wO(t[1], n, e))
      return;
    e._a = n, e._tzm = SO(t[8], t[9], t[10]), e._d = ql.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), mn(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function EO(e) {
  var t = hO.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (Nm(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Bm(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : ct.createFromInputFallback(e);
}
ct.createFromInputFallback = Or(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function la(e, t, n) {
  return e ?? t ?? n;
}
function RO(e) {
  var t = new Date(ct.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function jf(e) {
  var t, n, r = [], i, s, a;
  if (!e._d) {
    for (i = RO(e), e._w && e._a[qr] == null && e._a[Ei] == null && TO(e), e._dayOfYear != null && (a = la(e._a[_o], i[_o]), (e._dayOfYear > Fl(a) || e._dayOfYear === 0) && (mn(e)._overflowDayOfYear = !0), n = ql(a, 0, e._dayOfYear), e._a[Ei] = n.getUTCMonth(), e._a[qr] = n.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = r[t] = i[t];
    for (; t < 7; t++)
      e._a[t] = r[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[Po] === 24 && e._a[Vr] === 0 && e._a[Ri] === 0 && e._a[ks] === 0 && (e._nextDay = !0, e._a[Po] = 0), e._d = (e._useUTC ? ql : DI).apply(
      null,
      r
    ), s = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Po] = 24), e._w && typeof e._w.d < "u" && e._w.d !== s && (mn(e).weekdayMismatch = !0);
  }
}
function TO(e) {
  var t, n, r, i, s, a, l, c, u;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (s = 1, a = 4, n = la(
    t.GG,
    e._a[_o],
    Kl(eo(), 1, 4).year
  ), r = la(t.W, 1), i = la(t.E, 1), (i < 1 || i > 7) && (c = !0)) : (s = e._locale._week.dow, a = e._locale._week.doy, u = Kl(eo(), s, a), n = la(t.gg, e._a[_o], u.year), r = la(t.w, u.week), t.d != null ? (i = t.d, (i < 0 || i > 6) && (c = !0)) : t.e != null ? (i = t.e + s, (t.e < 0 || t.e > 6) && (c = !0)) : i = s), r < 1 || r > Mi(n, s, a) ? mn(e)._overflowWeeks = !0 : c != null ? mn(e)._overflowWeekday = !0 : (l = Fm(n, r, i, s, a), e._a[_o] = l.year, e._dayOfYear = l.dayOfYear);
}
ct.ISO_8601 = function() {
};
ct.RFC_2822 = function() {
};
function Ff(e) {
  if (e._f === ct.ISO_8601) {
    Nm(e);
    return;
  }
  if (e._f === ct.RFC_2822) {
    Bm(e);
    return;
  }
  e._a = [], mn(e).empty = !0;
  var t = "" + e._i, n, r, i, s, a, l = t.length, c = 0, u, f;
  for (i = xm(e._f, e._locale).match(Ef) || [], f = i.length, n = 0; n < f; n++)
    s = i[n], r = (t.match(mI(s, e)) || [])[0], r && (a = t.substr(0, t.indexOf(r)), a.length > 0 && mn(e).unusedInput.push(a), t = t.slice(
      t.indexOf(r) + r.length
    ), c += r.length), va[s] ? (r ? mn(e).empty = !1 : mn(e).unusedTokens.push(s), vI(s, r, e)) : e._strict && !r && mn(e).unusedTokens.push(s);
  mn(e).charsLeftOver = l - c, t.length > 0 && mn(e).unusedInput.push(t), e._a[Po] <= 12 && mn(e).bigHour === !0 && e._a[Po] > 0 && (mn(e).bigHour = void 0), mn(e).parsedDateParts = e._a.slice(0), mn(e).meridiem = e._meridiem, e._a[Po] = MO(
    e._locale,
    e._a[Po],
    e._meridiem
  ), u = mn(e).era, u !== null && (e._a[_o] = e._locale.erasConvertYear(u, e._a[_o])), jf(e), Df(e);
}
function MO(e, t, n) {
  var r;
  return n == null ? t : e.meridiemHour != null ? e.meridiemHour(t, n) : (e.isPM != null && (r = e.isPM(n), r && t < 12 && (t += 12), !r && t === 12 && (t = 0)), t);
}
function kO(e) {
  var t, n, r, i, s, a, l = !1, c = e._f.length;
  if (c === 0) {
    mn(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < c; i++)
    s = 0, a = !1, t = wf({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[i], Ff(t), xf(t) && (a = !0), s += mn(t).charsLeftOver, s += mn(t).unusedTokens.length * 10, mn(t).score = s, l ? s < r && (r = s, n = t) : (r == null || s < r || a) && (r = s, n = t, a && (l = !0));
  Ki(e, n || t);
}
function PO(e) {
  if (!e._d) {
    var t = Rf(e._i), n = t.day === void 0 ? t.date : t.day;
    e._a = ym(
      [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
      function(r) {
        return r && parseInt(r, 10);
      }
    ), jf(e);
  }
}
function IO(e) {
  var t = new bc(Df(_m(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function _m(e) {
  var t = e._i, n = e._f;
  return e._locale = e._locale || Ai(e._l), t === null || n === void 0 && t === "" ? Hd({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), Br(t) ? new bc(Df(t)) : (yc(t) ? e._d = t : Nr(n) ? kO(e) : n ? Ff(e) : OO(e), xf(e) || (e._d = null), e));
}
function OO(e) {
  var t = e._i;
  Qo(t) ? e._d = new Date(ct.now()) : yc(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? EO(e) : Nr(t) ? (e._a = ym(t.slice(0), function(n) {
    return parseInt(n, 10);
  }), jf(e)) : Ds(t) ? PO(e) : Vi(t) ? e._d = new Date(t) : ct.createFromInputFallback(e);
}
function zm(e, t, n, r, i) {
  var s = {};
  return (t === !0 || t === !1) && (r = t, t = void 0), (n === !0 || n === !1) && (r = n, n = void 0), (Ds(e) && Cf(e) || Nr(e) && e.length === 0) && (e = void 0), s._isAMomentObject = !0, s._useUTC = s._isUTC = i, s._l = n, s._i = e, s._f = t, s._strict = r, IO(s);
}
function eo(e, t, n, r) {
  return zm(e, t, n, r, !1);
}
var DO = Or(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = eo.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Hd();
  }
), jO = Or(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = eo.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Hd();
  }
);
function Hm(e, t) {
  var n, r;
  if (t.length === 1 && Nr(t[0]) && (t = t[0]), !t.length)
    return eo();
  for (n = t[0], r = 1; r < t.length; ++r)
    (!t[r].isValid() || t[r][e](n)) && (n = t[r]);
  return n;
}
function FO() {
  var e = [].slice.call(arguments, 0);
  return Hm("isBefore", e);
}
function VO() {
  var e = [].slice.call(arguments, 0);
  return Hm("isAfter", e);
}
var $O = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, cl = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function LO(e) {
  var t, n = !1, r, i = cl.length;
  for (t in e)
    if (Dn(e, t) && !(bo.call(cl, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (r = 0; r < i; ++r)
    if (e[cl[r]]) {
      if (n)
        return !1;
      parseFloat(e[cl[r]]) !== Cn(e[cl[r]]) && (n = !0);
    }
  return !0;
}
function AO() {
  return this._isValid;
}
function NO() {
  return zr(NaN);
}
function Qd(e) {
  var t = Rf(e), n = t.year || 0, r = t.quarter || 0, i = t.month || 0, s = t.week || t.isoWeek || 0, a = t.day || 0, l = t.hour || 0, c = t.minute || 0, u = t.second || 0, f = t.millisecond || 0;
  this._isValid = LO(t), this._milliseconds = +f + u * 1e3 + // 1000
  c * 6e4 + // 1000 * 60
  l * 1e3 * 60 * 60, this._days = +a + s * 7, this._months = +i + r * 3 + n * 12, this._data = {}, this._locale = Ai(), this._bubble();
}
function Iu(e) {
  return e instanceof Qd;
}
function Q0(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function BO(e, t, n) {
  var r = Math.min(e.length, t.length), i = Math.abs(e.length - t.length), s = 0, a;
  for (a = 0; a < r; a++)
    Cn(e[a]) !== Cn(t[a]) && s++;
  return s + i;
}
function Wm(e, t) {
  Bt(e, 0, 0, function() {
    var n = this.utcOffset(), r = "+";
    return n < 0 && (n = -n, r = "-"), r + ri(~~(n / 60), 2) + t + ri(~~n % 60, 2);
  });
}
Wm("Z", ":");
Wm("ZZ", "");
xt("Z", qd);
xt("ZZ", qd);
Hn(["Z", "ZZ"], function(e, t, n) {
  n._useUTC = !0, n._tzm = Vf(qd, e);
});
var _O = /([\+\-]|\d\d)/gi;
function Vf(e, t) {
  var n = (t || "").match(e), r, i, s;
  return n === null ? null : (r = n[n.length - 1] || [], i = (r + "").match(_O) || ["-", 0, 0], s = +(i[1] * 60) + Cn(i[2]), s === 0 ? 0 : i[0] === "+" ? s : -s);
}
function $f(e, t) {
  var n, r;
  return t._isUTC ? (n = t.clone(), r = (Br(e) || yc(e) ? e.valueOf() : eo(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), ct.updateOffset(n, !1), n) : eo(e).local();
}
function J0(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
ct.updateOffset = function() {
};
function zO(e, t, n) {
  var r = this._offset || 0, i;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Vf(qd, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && t && (i = J0(this)), this._offset = e, this._isUTC = !0, i != null && this.add(i, "m"), r !== e && (!t || this._changeInProgress ? Ym(
      this,
      zr(e - r, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, ct.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? r : J0(this);
}
function HO(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function WO(e) {
  return this.utcOffset(0, e);
}
function GO(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(J0(this), "m")), this;
}
function UO() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Vf(fI, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function YO(e) {
  return this.isValid() ? (e = e ? eo(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function ZO() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function qO() {
  if (!Qo(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return wf(e, this), e = _m(e), e._a ? (t = e._isUTC ? ci(e._a) : eo(e._a), this._isDSTShifted = this.isValid() && BO(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function KO() {
  return this.isValid() ? !this._isUTC : !1;
}
function XO() {
  return this.isValid() ? this._isUTC : !1;
}
function Gm() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var QO = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, JO = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function zr(e, t) {
  var n = e, r = null, i, s, a;
  return Iu(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Vi(e) || !isNaN(+e) ? (n = {}, t ? n[t] = +e : n.milliseconds = +e) : (r = QO.exec(e)) ? (i = r[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: Cn(r[qr]) * i,
    h: Cn(r[Po]) * i,
    m: Cn(r[Vr]) * i,
    s: Cn(r[Ri]) * i,
    ms: Cn(Q0(r[ks] * 1e3)) * i
    // the millisecond decimal point is included in the match
  }) : (r = JO.exec(e)) ? (i = r[1] === "-" ? -1 : 1, n = {
    y: bs(r[2], i),
    M: bs(r[3], i),
    w: bs(r[4], i),
    d: bs(r[5], i),
    h: bs(r[6], i),
    m: bs(r[7], i),
    s: bs(r[8], i)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (a = eD(
    eo(n.from),
    eo(n.to)
  ), n = {}, n.ms = a.milliseconds, n.M = a.months), s = new Qd(n), Iu(e) && Dn(e, "_locale") && (s._locale = e._locale), Iu(e) && Dn(e, "_isValid") && (s._isValid = e._isValid), s;
}
zr.fn = Qd.prototype;
zr.invalid = NO;
function bs(e, t) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * t;
}
function f5(e, t) {
  var n = {};
  return n.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
}
function eD(e, t) {
  var n;
  return e.isValid() && t.isValid() ? (t = $f(t, e), e.isBefore(t) ? n = f5(e, t) : (n = f5(t, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function Um(e, t) {
  return function(n, r) {
    var i, s;
    return r !== null && !isNaN(+r) && (Cm(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), s = n, n = r, r = s), i = zr(n, r), Ym(this, i, e), this;
  };
}
function Ym(e, t, n, r) {
  var i = t._milliseconds, s = Q0(t._days), a = Q0(t._months);
  e.isValid() && (r = r ?? !0, a && Im(e, Ku(e, "Month") + a * n), s && Sm(e, "Date", Ku(e, "Date") + s * n), i && e._d.setTime(e._d.valueOf() + i * n), r && ct.updateOffset(e, s || a));
}
var tD = Um(1, "add"), nD = Um(-1, "subtract");
function Zm(e) {
  return typeof e == "string" || e instanceof String;
}
function oD(e) {
  return Br(e) || yc(e) || Zm(e) || Vi(e) || iD(e) || rD(e) || e === null || e === void 0;
}
function rD(e) {
  var t = Ds(e) && !Cf(e), n = !1, r = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, s, a = r.length;
  for (i = 0; i < a; i += 1)
    s = r[i], n = n || Dn(e, s);
  return t && n;
}
function iD(e) {
  var t = Nr(e), n = !1;
  return t && (n = e.filter(function(r) {
    return !Vi(r) && Zm(e);
  }).length === 0), t && n;
}
function sD(e) {
  var t = Ds(e) && !Cf(e), n = !1, r = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, s;
  for (i = 0; i < r.length; i += 1)
    s = r[i], n = n || Dn(e, s);
  return t && n;
}
function aD(e, t) {
  var n = e.diff(t, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function lD(e, t) {
  arguments.length === 1 && (arguments[0] ? oD(arguments[0]) ? (e = arguments[0], t = void 0) : sD(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var n = e || eo(), r = $f(n, this).startOf("day"), i = ct.calendarFormat(this, r) || "sameElse", s = t && (ui(t[i]) ? t[i].call(this, n) : t[i]);
  return this.format(
    s || this.localeData().calendar(i, this, eo(n))
  );
}
function cD() {
  return new bc(this);
}
function uD(e, t) {
  var n = Br(e) ? e : eo(e);
  return this.isValid() && n.isValid() ? (t = Dr(t) || "millisecond", t === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function dD(e, t) {
  var n = Br(e) ? e : eo(e);
  return this.isValid() && n.isValid() ? (t = Dr(t) || "millisecond", t === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf()) : !1;
}
function pD(e, t, n, r) {
  var i = Br(e) ? e : eo(e), s = Br(t) ? t : eo(t);
  return this.isValid() && i.isValid() && s.isValid() ? (r = r || "()", (r[0] === "(" ? this.isAfter(i, n) : !this.isBefore(i, n)) && (r[1] === ")" ? this.isBefore(s, n) : !this.isAfter(s, n))) : !1;
}
function fD(e, t) {
  var n = Br(e) ? e : eo(e), r;
  return this.isValid() && n.isValid() ? (t = Dr(t) || "millisecond", t === "millisecond" ? this.valueOf() === n.valueOf() : (r = n.valueOf(), this.clone().startOf(t).valueOf() <= r && r <= this.clone().endOf(t).valueOf())) : !1;
}
function gD(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function mD(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function hD(e, t, n) {
  var r, i, s;
  if (!this.isValid())
    return NaN;
  if (r = $f(e, this), !r.isValid())
    return NaN;
  switch (i = (r.utcOffset() - this.utcOffset()) * 6e4, t = Dr(t), t) {
    case "year":
      s = Ou(this, r) / 12;
      break;
    case "month":
      s = Ou(this, r);
      break;
    case "quarter":
      s = Ou(this, r) / 3;
      break;
    case "second":
      s = (this - r) / 1e3;
      break;
    case "minute":
      s = (this - r) / 6e4;
      break;
    case "hour":
      s = (this - r) / 36e5;
      break;
    case "day":
      s = (this - r - i) / 864e5;
      break;
    case "week":
      s = (this - r - i) / 6048e5;
      break;
    default:
      s = this - r;
  }
  return n ? s : br(s);
}
function Ou(e, t) {
  if (e.date() < t.date())
    return -Ou(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()), r = e.clone().add(n, "months"), i, s;
  return t - r < 0 ? (i = e.clone().add(n - 1, "months"), s = (t - r) / (r - i)) : (i = e.clone().add(n + 1, "months"), s = (t - r) / (i - r)), -(n + s) || 0;
}
ct.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
ct.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function vD() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function yD(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? Pu(
    n,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : ui(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Pu(n, "Z")) : Pu(
    n,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function bD() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", n, r, i, s;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), n = "[" + e + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = "-MM-DD[T]HH:mm:ss.SSS", s = t + '[")]', this.format(n + r + i + s);
}
function CD(e) {
  e || (e = this.isUtc() ? ct.defaultFormatUtc : ct.defaultFormat);
  var t = Pu(this, e);
  return this.localeData().postformat(t);
}
function xD(e, t) {
  return this.isValid() && (Br(e) && e.isValid() || eo(e).isValid()) ? zr({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function wD(e) {
  return this.from(eo(), e);
}
function SD(e, t) {
  return this.isValid() && (Br(e) && e.isValid() || eo(e).isValid()) ? zr({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function ED(e) {
  return this.to(eo(), e);
}
function qm(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = Ai(e), t != null && (this._locale = t), this);
}
var Km = Or(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Xm() {
  return this._locale;
}
var Ju = 1e3, ya = 60 * Ju, ed = 60 * ya, Qm = (365 * 400 + 97) * 24 * ed;
function ba(e, t) {
  return (e % t + t) % t;
}
function Jm(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - Qm : new Date(e, t, n).valueOf();
}
function eh(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - Qm : Date.UTC(e, t, n);
}
function RD(e) {
  var t, n;
  if (e = Dr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? eh : Jm, e) {
    case "year":
      t = n(this.year(), 0, 1);
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = n(this.year(), this.month(), 1);
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= ba(
        t + (this._isUTC ? 0 : this.utcOffset() * ya),
        ed
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= ba(t, ya);
      break;
    case "second":
      t = this._d.valueOf(), t -= ba(t, Ju);
      break;
  }
  return this._d.setTime(t), ct.updateOffset(this, !0), this;
}
function TD(e) {
  var t, n;
  if (e = Dr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? eh : Jm, e) {
    case "year":
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += ed - ba(
        t + (this._isUTC ? 0 : this.utcOffset() * ya),
        ed
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += ya - ba(t, ya) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += Ju - ba(t, Ju) - 1;
      break;
  }
  return this._d.setTime(t), ct.updateOffset(this, !0), this;
}
function MD() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function kD() {
  return Math.floor(this.valueOf() / 1e3);
}
function PD() {
  return new Date(this.valueOf());
}
function ID() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function OD() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function DD() {
  return this.isValid() ? this.toISOString() : null;
}
function jD() {
  return xf(this);
}
function FD() {
  return Ki({}, mn(this));
}
function VD() {
  return mn(this).overflow;
}
function $D() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Bt("N", 0, 0, "eraAbbr");
Bt("NN", 0, 0, "eraAbbr");
Bt("NNN", 0, 0, "eraAbbr");
Bt("NNNN", 0, 0, "eraName");
Bt("NNNNN", 0, 0, "eraNarrow");
Bt("y", ["y", 1], "yo", "eraYear");
Bt("y", ["yy", 2], 0, "eraYear");
Bt("y", ["yyy", 3], 0, "eraYear");
Bt("y", ["yyyy", 4], 0, "eraYear");
xt("N", Lf);
xt("NN", Lf);
xt("NNN", Lf);
xt("NNNN", YD);
xt("NNNNN", ZD);
Hn(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, n, r) {
    var i = n._locale.erasParse(e, r, n._strict);
    i ? mn(n).era = i : mn(n).invalidEra = e;
  }
);
xt("y", ja);
xt("yy", ja);
xt("yyy", ja);
xt("yyyy", ja);
xt("yo", qD);
Hn(["y", "yy", "yyy", "yyyy"], _o);
Hn(["yo"], function(e, t, n, r) {
  var i;
  n._locale._eraYearOrdinalRegex && (i = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[_o] = n._locale.eraYearOrdinalParse(e, i) : t[_o] = parseInt(e, 10);
});
function LD(e, t) {
  var n, r, i, s = this._eras || Ai("en")._eras;
  for (n = 0, r = s.length; n < r; ++n) {
    switch (typeof s[n].since) {
      case "string":
        i = ct(s[n].since).startOf("day"), s[n].since = i.valueOf();
        break;
    }
    switch (typeof s[n].until) {
      case "undefined":
        s[n].until = 1 / 0;
        break;
      case "string":
        i = ct(s[n].until).startOf("day").valueOf(), s[n].until = i.valueOf();
        break;
    }
  }
  return s;
}
function AD(e, t, n) {
  var r, i, s = this.eras(), a, l, c;
  for (e = e.toUpperCase(), r = 0, i = s.length; r < i; ++r)
    if (a = s[r].name.toUpperCase(), l = s[r].abbr.toUpperCase(), c = s[r].narrow.toUpperCase(), n)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (l === e)
            return s[r];
          break;
        case "NNNN":
          if (a === e)
            return s[r];
          break;
        case "NNNNN":
          if (c === e)
            return s[r];
          break;
      }
    else if ([a, l, c].indexOf(e) >= 0)
      return s[r];
}
function ND(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? ct(e.since).year() : ct(e.since).year() + (t - e.offset) * n;
}
function BD() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].name;
  return "";
}
function _D() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].narrow;
  return "";
}
function zD() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].abbr;
  return "";
}
function HD() {
  var e, t, n, r, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (n = i[e].since <= i[e].until ? 1 : -1, r = this.clone().startOf("day").valueOf(), i[e].since <= r && r <= i[e].until || i[e].until <= r && r <= i[e].since)
      return (this.year() - ct(i[e].since).year()) * n + i[e].offset;
  return this.year();
}
function WD(e) {
  return Dn(this, "_erasNameRegex") || Af.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function GD(e) {
  return Dn(this, "_erasAbbrRegex") || Af.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function UD(e) {
  return Dn(this, "_erasNarrowRegex") || Af.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Lf(e, t) {
  return t.erasAbbrRegex(e);
}
function YD(e, t) {
  return t.erasNameRegex(e);
}
function ZD(e, t) {
  return t.erasNarrowRegex(e);
}
function qD(e, t) {
  return t._eraYearOrdinalRegex || ja;
}
function Af() {
  var e = [], t = [], n = [], r = [], i, s, a = this.eras();
  for (i = 0, s = a.length; i < s; ++i)
    t.push(ar(a[i].name)), e.push(ar(a[i].abbr)), n.push(ar(a[i].narrow)), r.push(ar(a[i].name)), r.push(ar(a[i].abbr)), r.push(ar(a[i].narrow));
  this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
Bt(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Bt(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Jd(e, t) {
  Bt(0, [e, e.length], 0, t);
}
Jd("gggg", "weekYear");
Jd("ggggg", "weekYear");
Jd("GGGG", "isoWeekYear");
Jd("GGGGG", "isoWeekYear");
zo("weekYear", "gg");
zo("isoWeekYear", "GG");
Ho("weekYear", 1);
Ho("isoWeekYear", 1);
xt("G", Zd);
xt("g", Zd);
xt("GG", oo, fr);
xt("gg", oo, fr);
xt("GGGG", Mf, Tf);
xt("gggg", Mf, Tf);
xt("GGGGG", Yd, Gd);
xt("ggggg", Yd, Gd);
xc(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, n, r) {
    t[r.substr(0, 2)] = Cn(e);
  }
);
xc(["gg", "GG"], function(e, t, n, r) {
  t[r] = ct.parseTwoDigitYear(e);
});
function KD(e) {
  return th.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function XD(e) {
  return th.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function QD() {
  return Mi(this.year(), 1, 4);
}
function JD() {
  return Mi(this.isoWeekYear(), 1, 4);
}
function ej() {
  var e = this.localeData()._week;
  return Mi(this.year(), e.dow, e.doy);
}
function tj() {
  var e = this.localeData()._week;
  return Mi(this.weekYear(), e.dow, e.doy);
}
function th(e, t, n, r, i) {
  var s;
  return e == null ? Kl(this, r, i).year : (s = Mi(e, r, i), t > s && (t = s), nj.call(this, e, t, n, r, i));
}
function nj(e, t, n, r, i) {
  var s = Fm(e, t, n, r, i), a = ql(s.year, 0, s.dayOfYear);
  return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
}
Bt("Q", 0, "Qo", "quarter");
zo("quarter", "Q");
Ho("quarter", 7);
xt("Q", Em);
Hn("Q", function(e, t) {
  t[Ei] = (Cn(e) - 1) * 3;
});
function oj(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
Bt("D", ["DD", 2], "Do", "date");
zo("date", "D");
Ho("date", 9);
xt("D", oo);
xt("DD", oo, fr);
xt("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
Hn(["D", "DD"], qr);
Hn("Do", function(e, t) {
  t[qr] = Cn(e.match(oo)[0]);
});
var nh = Da("Date", !0);
Bt("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
zo("dayOfYear", "DDD");
Ho("dayOfYear", 4);
xt("DDD", Ud);
xt("DDDD", Rm);
Hn(["DDD", "DDDD"], function(e, t, n) {
  n._dayOfYear = Cn(e);
});
function rj(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
Bt("m", ["mm", 2], 0, "minute");
zo("minute", "m");
Ho("minute", 14);
xt("m", oo);
xt("mm", oo, fr);
Hn(["m", "mm"], Vr);
var ij = Da("Minutes", !1);
Bt("s", ["ss", 2], 0, "second");
zo("second", "s");
Ho("second", 15);
xt("s", oo);
xt("ss", oo, fr);
Hn(["s", "ss"], Ri);
var sj = Da("Seconds", !1);
Bt("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Bt(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Bt(0, ["SSS", 3], 0, "millisecond");
Bt(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Bt(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Bt(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Bt(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Bt(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Bt(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
zo("millisecond", "ms");
Ho("millisecond", 16);
xt("S", Ud, Em);
xt("SS", Ud, fr);
xt("SSS", Ud, Rm);
var Xi, oh;
for (Xi = "SSSS"; Xi.length <= 9; Xi += "S")
  xt(Xi, ja);
function aj(e, t) {
  t[ks] = Cn(("0." + e) * 1e3);
}
for (Xi = "S"; Xi.length <= 9; Xi += "S")
  Hn(Xi, aj);
oh = Da("Milliseconds", !1);
Bt("z", 0, 0, "zoneAbbr");
Bt("zz", 0, 0, "zoneName");
function lj() {
  return this._isUTC ? "UTC" : "";
}
function cj() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var qe = bc.prototype;
qe.add = tD;
qe.calendar = lD;
qe.clone = cD;
qe.diff = hD;
qe.endOf = TD;
qe.format = CD;
qe.from = xD;
qe.fromNow = wD;
qe.to = SD;
qe.toNow = ED;
qe.get = dI;
qe.invalidAt = VD;
qe.isAfter = uD;
qe.isBefore = dD;
qe.isBetween = pD;
qe.isSame = fD;
qe.isSameOrAfter = gD;
qe.isSameOrBefore = mD;
qe.isValid = jD;
qe.lang = Km;
qe.locale = qm;
qe.localeData = Xm;
qe.max = jO;
qe.min = DO;
qe.parsingFlags = FD;
qe.set = pI;
qe.startOf = RD;
qe.subtract = nD;
qe.toArray = ID;
qe.toObject = OD;
qe.toDate = PD;
qe.toISOString = yD;
qe.inspect = bD;
typeof Symbol < "u" && Symbol.for != null && (qe[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
qe.toJSON = DD;
qe.toString = vD;
qe.unix = kD;
qe.valueOf = MD;
qe.creationData = $D;
qe.eraName = BD;
qe.eraNarrow = _D;
qe.eraAbbr = zD;
qe.eraYear = HD;
qe.year = jm;
qe.isLeapYear = OI;
qe.weekYear = KD;
qe.isoWeekYear = XD;
qe.quarter = qe.quarters = oj;
qe.month = Om;
qe.daysInMonth = kI;
qe.week = qe.weeks = LI;
qe.isoWeek = qe.isoWeeks = AI;
qe.weeksInYear = ej;
qe.weeksInWeekYear = tj;
qe.isoWeeksInYear = QD;
qe.isoWeeksInISOWeekYear = JD;
qe.date = nh;
qe.day = qe.days = XI;
qe.weekday = QI;
qe.isoWeekday = JI;
qe.dayOfYear = rj;
qe.hour = qe.hours = sO;
qe.minute = qe.minutes = ij;
qe.second = qe.seconds = sj;
qe.millisecond = qe.milliseconds = oh;
qe.utcOffset = zO;
qe.utc = WO;
qe.local = GO;
qe.parseZone = UO;
qe.hasAlignedHourOffset = YO;
qe.isDST = ZO;
qe.isLocal = KO;
qe.isUtcOffset = XO;
qe.isUtc = Gm;
qe.isUTC = Gm;
qe.zoneAbbr = lj;
qe.zoneName = cj;
qe.dates = Or(
  "dates accessor is deprecated. Use date instead.",
  nh
);
qe.months = Or(
  "months accessor is deprecated. Use month instead",
  Om
);
qe.years = Or(
  "years accessor is deprecated. Use year instead",
  jm
);
qe.zone = Or(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  HO
);
qe.isDSTShifted = Or(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  qO
);
function uj(e) {
  return eo(e * 1e3);
}
function dj() {
  return eo.apply(null, arguments).parseZone();
}
function rh(e) {
  return e;
}
var Fn = Sf.prototype;
Fn.calendar = XP;
Fn.longDateFormat = tI;
Fn.invalidDate = oI;
Fn.ordinal = sI;
Fn.preparse = rh;
Fn.postformat = rh;
Fn.relativeTime = lI;
Fn.pastFuture = cI;
Fn.set = qP;
Fn.eras = LD;
Fn.erasParse = AD;
Fn.erasConvertYear = ND;
Fn.erasAbbrRegex = GD;
Fn.erasNameRegex = WD;
Fn.erasNarrowRegex = UD;
Fn.months = EI;
Fn.monthsShort = RI;
Fn.monthsParse = MI;
Fn.monthsRegex = II;
Fn.monthsShortRegex = PI;
Fn.week = jI;
Fn.firstDayOfYear = $I;
Fn.firstDayOfWeek = VI;
Fn.weekdays = UI;
Fn.weekdaysMin = ZI;
Fn.weekdaysShort = YI;
Fn.weekdaysParse = KI;
Fn.weekdaysRegex = eO;
Fn.weekdaysShortRegex = tO;
Fn.weekdaysMinRegex = nO;
Fn.isPM = rO;
Fn.meridiem = aO;
function td(e, t, n, r) {
  var i = Ai(), s = ci().set(r, t);
  return i[n](s, e);
}
function ih(e, t, n) {
  if (Vi(e) && (t = e, e = void 0), e = e || "", t != null)
    return td(e, t, n, "month");
  var r, i = [];
  for (r = 0; r < 12; r++)
    i[r] = td(e, r, n, "month");
  return i;
}
function Nf(e, t, n, r) {
  typeof e == "boolean" ? (Vi(t) && (n = t, t = void 0), t = t || "") : (t = e, n = t, e = !1, Vi(t) && (n = t, t = void 0), t = t || "");
  var i = Ai(), s = e ? i._week.dow : 0, a, l = [];
  if (n != null)
    return td(t, (n + s) % 7, r, "day");
  for (a = 0; a < 7; a++)
    l[a] = td(t, (a + s) % 7, r, "day");
  return l;
}
function pj(e, t) {
  return ih(e, t, "months");
}
function fj(e, t) {
  return ih(e, t, "monthsShort");
}
function gj(e, t, n) {
  return Nf(e, t, n, "weekdays");
}
function mj(e, t, n) {
  return Nf(e, t, n, "weekdaysShort");
}
function hj(e, t, n) {
  return Nf(e, t, n, "weekdaysMin");
}
es("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, n = Cn(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + n;
  }
});
ct.lang = Or(
  "moment.lang is deprecated. Use moment.locale instead.",
  es
);
ct.langData = Or(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Ai
);
var hi = Math.abs;
function vj() {
  var e = this._data;
  return this._milliseconds = hi(this._milliseconds), this._days = hi(this._days), this._months = hi(this._months), e.milliseconds = hi(e.milliseconds), e.seconds = hi(e.seconds), e.minutes = hi(e.minutes), e.hours = hi(e.hours), e.months = hi(e.months), e.years = hi(e.years), this;
}
function sh(e, t, n, r) {
  var i = zr(t, n);
  return e._milliseconds += r * i._milliseconds, e._days += r * i._days, e._months += r * i._months, e._bubble();
}
function yj(e, t) {
  return sh(this, e, t, 1);
}
function bj(e, t) {
  return sh(this, e, t, -1);
}
function g5(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function Cj() {
  var e = this._milliseconds, t = this._days, n = this._months, r = this._data, i, s, a, l, c;
  return e >= 0 && t >= 0 && n >= 0 || e <= 0 && t <= 0 && n <= 0 || (e += g5(ep(n) + t) * 864e5, t = 0, n = 0), r.milliseconds = e % 1e3, i = br(e / 1e3), r.seconds = i % 60, s = br(i / 60), r.minutes = s % 60, a = br(s / 60), r.hours = a % 24, t += br(a / 24), c = br(ah(t)), n += c, t -= g5(ep(c)), l = br(n / 12), n %= 12, r.days = t, r.months = n, r.years = l, this;
}
function ah(e) {
  return e * 4800 / 146097;
}
function ep(e) {
  return e * 146097 / 4800;
}
function xj(e) {
  if (!this.isValid())
    return NaN;
  var t, n, r = this._milliseconds;
  if (e = Dr(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + r / 864e5, n = this._months + ah(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (t = this._days + Math.round(ep(this._months)), e) {
      case "week":
        return t / 7 + r / 6048e5;
      case "day":
        return t + r / 864e5;
      case "hour":
        return t * 24 + r / 36e5;
      case "minute":
        return t * 1440 + r / 6e4;
      case "second":
        return t * 86400 + r / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + r;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function wj() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + Cn(this._months / 12) * 31536e6 : NaN;
}
function Ni(e) {
  return function() {
    return this.as(e);
  };
}
var Sj = Ni("ms"), Ej = Ni("s"), Rj = Ni("m"), Tj = Ni("h"), Mj = Ni("d"), kj = Ni("w"), Pj = Ni("M"), Ij = Ni("Q"), Oj = Ni("y");
function Dj() {
  return zr(this);
}
function jj(e) {
  return e = Dr(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Ws(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Fj = Ws("milliseconds"), Vj = Ws("seconds"), $j = Ws("minutes"), Lj = Ws("hours"), Aj = Ws("days"), Nj = Ws("months"), Bj = Ws("years");
function _j() {
  return br(this.days() / 7);
}
var Ci = Math.round, da = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function zj(e, t, n, r, i) {
  return i.relativeTime(t || 1, !!n, e, r);
}
function Hj(e, t, n, r) {
  var i = zr(e).abs(), s = Ci(i.as("s")), a = Ci(i.as("m")), l = Ci(i.as("h")), c = Ci(i.as("d")), u = Ci(i.as("M")), f = Ci(i.as("w")), g = Ci(i.as("y")), h = s <= n.ss && ["s", s] || s < n.s && ["ss", s] || a <= 1 && ["m"] || a < n.m && ["mm", a] || l <= 1 && ["h"] || l < n.h && ["hh", l] || c <= 1 && ["d"] || c < n.d && ["dd", c];
  return n.w != null && (h = h || f <= 1 && ["w"] || f < n.w && ["ww", f]), h = h || u <= 1 && ["M"] || u < n.M && ["MM", u] || g <= 1 && ["y"] || ["yy", g], h[2] = t, h[3] = +e > 0, h[4] = r, zj.apply(null, h);
}
function Wj(e) {
  return e === void 0 ? Ci : typeof e == "function" ? (Ci = e, !0) : !1;
}
function Gj(e, t) {
  return da[e] === void 0 ? !1 : t === void 0 ? da[e] : (da[e] = t, e === "s" && (da.ss = t - 1), !0);
}
function Uj(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, r = da, i, s;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (n = e), typeof t == "object" && (r = Object.assign({}, da, t), t.s != null && t.ss == null && (r.ss = t.s - 1)), i = this.localeData(), s = Hj(this, !n, r, i), n && (s = i.pastFuture(+this, s)), i.postformat(s);
}
var Q1 = Math.abs;
function oa(e) {
  return (e > 0) - (e < 0) || +e;
}
function e1() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Q1(this._milliseconds) / 1e3, t = Q1(this._days), n = Q1(this._months), r, i, s, a, l = this.asSeconds(), c, u, f, g;
  return l ? (r = br(e / 60), i = br(r / 60), e %= 60, r %= 60, s = br(n / 12), n %= 12, a = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", c = l < 0 ? "-" : "", u = oa(this._months) !== oa(l) ? "-" : "", f = oa(this._days) !== oa(l) ? "-" : "", g = oa(this._milliseconds) !== oa(l) ? "-" : "", c + "P" + (s ? u + s + "Y" : "") + (n ? u + n + "M" : "") + (t ? f + t + "D" : "") + (i || r || e ? "T" : "") + (i ? g + i + "H" : "") + (r ? g + r + "M" : "") + (e ? g + a + "S" : "")) : "P0D";
}
var Pn = Qd.prototype;
Pn.isValid = AO;
Pn.abs = vj;
Pn.add = yj;
Pn.subtract = bj;
Pn.as = xj;
Pn.asMilliseconds = Sj;
Pn.asSeconds = Ej;
Pn.asMinutes = Rj;
Pn.asHours = Tj;
Pn.asDays = Mj;
Pn.asWeeks = kj;
Pn.asMonths = Pj;
Pn.asQuarters = Ij;
Pn.asYears = Oj;
Pn.valueOf = wj;
Pn._bubble = Cj;
Pn.clone = Dj;
Pn.get = jj;
Pn.milliseconds = Fj;
Pn.seconds = Vj;
Pn.minutes = $j;
Pn.hours = Lj;
Pn.days = Aj;
Pn.weeks = _j;
Pn.months = Nj;
Pn.years = Bj;
Pn.humanize = Uj;
Pn.toISOString = e1;
Pn.toString = e1;
Pn.toJSON = e1;
Pn.locale = qm;
Pn.localeData = Xm;
Pn.toIsoString = Or(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  e1
);
Pn.lang = Km;
Bt("X", 0, 0, "unix");
Bt("x", 0, 0, "valueOf");
xt("x", Zd);
xt("X", gI);
Hn("X", function(e, t, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
Hn("x", function(e, t, n) {
  n._d = new Date(Cn(e));
});
//! moment.js
ct.version = "2.29.4";
YP(eo);
ct.fn = qe;
ct.min = FO;
ct.max = VO;
ct.now = $O;
ct.utc = ci;
ct.unix = uj;
ct.months = pj;
ct.isDate = yc;
ct.locale = es;
ct.invalid = Hd;
ct.duration = zr;
ct.isMoment = Br;
ct.weekdays = gj;
ct.parseZone = dj;
ct.localeData = Ai;
ct.isDuration = Iu;
ct.monthsShort = fj;
ct.weekdaysMin = hj;
ct.defineLocale = Of;
ct.updateLocale = dO;
ct.locales = pO;
ct.weekdaysShort = mj;
ct.normalizeUnits = Dr;
ct.relativeTimeRounding = Wj;
ct.relativeTimeThreshold = Gj;
ct.calendarFormat = aD;
ct.prototype = qe;
ct.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Yj = {
  // Year
  Y: "year",
  YY: "year",
  YYYY: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  D: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  DD: "day",
  Do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  // eslint-disable-next-line id-denylist
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  d: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  dd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  dddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  A: "meridiem",
  a: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, Zj = {
  year: "YYYY",
  month: "MMMM",
  monthShort: "MMM",
  dayOfMonth: "D",
  dayOfMonthFull: "Do",
  weekday: "dddd",
  weekdayShort: "ddd",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "A",
  minutes: "mm",
  seconds: "ss",
  fullDate: "ll",
  keyboardDate: "L",
  shortDate: "MMM D",
  normalDate: "D MMMM",
  normalDateWithWeekday: "ddd, MMM D",
  fullTime: "LT",
  fullTime12h: "hh:mm A",
  fullTime24h: "HH:mm",
  keyboardDateTime: "L LT",
  keyboardDateTime12h: "L hh:mm A",
  keyboardDateTime24h: "L HH:mm"
}, m5 = ["Missing timezone plugin", "To be able to use timezones, you have to pass the default export from `moment-timezone` to the `dateLibInstance` prop of `LocalizationProvider`", "Find more information on https://mui.com/x/react-date-pickers/timezone/#moment-and-timezone"].join(`
`);
class lh {
  constructor({
    locale: t,
    formats: n,
    instance: r
  } = {}) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !0, this.lib = "moment", this.moment = void 0, this.locale = void 0, this.formats = void 0, this.escapedCharacters = {
      start: "[",
      end: "]"
    }, this.formatTokenMap = Yj, this.setLocaleToValue = (i) => {
      const s = this.getCurrentLocaleCode();
      return s === i.locale() ? i : i.locale(s);
    }, this.hasTimezonePlugin = () => typeof this.moment.tz < "u", this.createSystemDate = (i) => {
      const s = this.moment(i).local();
      return this.locale === void 0 ? s : s.locale(this.locale);
    }, this.createUTCDate = (i) => {
      const s = this.moment.utc(i);
      return this.locale === void 0 ? s : s.locale(this.locale);
    }, this.createTZDate = (i, s) => {
      if (!this.hasTimezonePlugin())
        throw new Error(m5);
      const a = s === "default" ? this.moment(i) : this.moment.tz(i, s);
      return this.locale === void 0 ? a : a.locale(this.locale);
    }, this.date = (i, s = "default") => i === null ? null : s === "UTC" ? this.createUTCDate(i) : s === "system" || s === "default" && !this.hasTimezonePlugin() ? this.createSystemDate(i) : this.createTZDate(i, s), this.getInvalidDate = () => this.moment(/* @__PURE__ */ new Date("Invalid Date")), this.getTimezone = (i) => {
      var l, c;
      const s = (l = i._z) == null ? void 0 : l.name, a = i.isUTC() ? "UTC" : "system";
      return s ?? ((c = this.moment.defaultZone) == null ? void 0 : c.name) ?? a;
    }, this.setTimezone = (i, s) => {
      var c;
      if (this.getTimezone(i) === s)
        return i;
      if (s === "UTC")
        return i.clone().utc();
      if (s === "system")
        return i.clone().local();
      if (!this.hasTimezonePlugin()) {
        if (s !== "default")
          throw new Error(m5);
        return i;
      }
      const a = s === "default" ? (
        // @ts-ignore
        ((c = this.moment.defaultZone) == null ? void 0 : c.name) ?? "system"
      ) : s;
      if (a === "system")
        return i.clone().local();
      const l = i.clone();
      return l.tz(a), l;
    }, this.toJsDate = (i) => i.toDate(), this.parse = (i, s) => i === "" ? null : this.locale ? this.moment(i, s, this.locale, !0) : this.moment(i, s, !0), this.getCurrentLocaleCode = () => this.locale || ct.locale(), this.is12HourCycleInCurrentLocale = () => /A|a/.test(ct.localeData(this.getCurrentLocaleCode()).longDateFormat("LT")), this.expandFormat = (i) => {
      const s = /(\[[^[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})|./g;
      return i.match(s).map((a) => {
        const l = a[0];
        return l === "L" || l === ";" ? ct.localeData(this.getCurrentLocaleCode()).longDateFormat(a) : a;
      }).join("");
    }, this.isValid = (i) => i == null ? !1 : i.isValid(), this.format = (i, s) => this.formatByString(i, this.formats[s]), this.formatByString = (i, s) => {
      const a = i.clone();
      return a.locale(this.getCurrentLocaleCode()), a.format(s);
    }, this.formatNumber = (i) => i, this.isEqual = (i, s) => i === null && s === null ? !0 : i === null || s === null ? !1 : i.isSame(s), this.isSameYear = (i, s) => i.isSame(s, "year"), this.isSameMonth = (i, s) => i.isSame(s, "month"), this.isSameDay = (i, s) => i.isSame(s, "day"), this.isSameHour = (i, s) => i.isSame(s, "hour"), this.isAfter = (i, s) => i.isAfter(s), this.isAfterYear = (i, s) => i.isAfter(s, "year"), this.isAfterDay = (i, s) => i.isAfter(s, "day"), this.isBefore = (i, s) => i.isBefore(s), this.isBeforeYear = (i, s) => i.isBefore(s, "year"), this.isBeforeDay = (i, s) => i.isBefore(s, "day"), this.isWithinRange = (i, [s, a]) => i.isBetween(s, a, null, "[]"), this.startOfYear = (i) => i.clone().startOf("year"), this.startOfMonth = (i) => i.clone().startOf("month"), this.startOfWeek = (i) => this.setLocaleToValue(i.clone()).startOf("week"), this.startOfDay = (i) => i.clone().startOf("day"), this.endOfYear = (i) => i.clone().endOf("year"), this.endOfMonth = (i) => i.clone().endOf("month"), this.endOfWeek = (i) => this.setLocaleToValue(i.clone()).endOf("week"), this.endOfDay = (i) => i.clone().endOf("day"), this.addYears = (i, s) => s < 0 ? i.clone().subtract(Math.abs(s), "years") : i.clone().add(s, "years"), this.addMonths = (i, s) => s < 0 ? i.clone().subtract(Math.abs(s), "months") : i.clone().add(s, "months"), this.addWeeks = (i, s) => s < 0 ? i.clone().subtract(Math.abs(s), "weeks") : i.clone().add(s, "weeks"), this.addDays = (i, s) => s < 0 ? i.clone().subtract(Math.abs(s), "days") : i.clone().add(s, "days"), this.addHours = (i, s) => s < 0 ? i.clone().subtract(Math.abs(s), "hours") : i.clone().add(s, "hours"), this.addMinutes = (i, s) => s < 0 ? i.clone().subtract(Math.abs(s), "minutes") : i.clone().add(s, "minutes"), this.addSeconds = (i, s) => s < 0 ? i.clone().subtract(Math.abs(s), "seconds") : i.clone().add(s, "seconds"), this.getYear = (i) => i.get("year"), this.getMonth = (i) => i.get("month"), this.getDate = (i) => i.get("date"), this.getHours = (i) => i.get("hours"), this.getMinutes = (i) => i.get("minutes"), this.getSeconds = (i) => i.get("seconds"), this.getMilliseconds = (i) => i.get("milliseconds"), this.setYear = (i, s) => i.clone().year(s), this.setMonth = (i, s) => i.clone().month(s), this.setDate = (i, s) => i.clone().date(s), this.setHours = (i, s) => i.clone().hours(s), this.setMinutes = (i, s) => i.clone().minutes(s), this.setSeconds = (i, s) => i.clone().seconds(s), this.setMilliseconds = (i, s) => i.clone().milliseconds(s), this.getDaysInMonth = (i) => i.daysInMonth(), this.getWeekArray = (i) => {
      const s = this.startOfWeek(this.startOfMonth(i)), a = this.endOfWeek(this.endOfMonth(i));
      let l = 0, c = s, u = c.get("dayOfYear");
      const f = [];
      for (; c.isBefore(a); ) {
        const g = Math.floor(l / 7);
        f[g] = f[g] || [], f[g].push(c);
        const h = u;
        c = this.addDays(c, 1), u = c.get("dayOfYear"), h === u && (c = c.add(12, "h").startOf("day")), l += 1;
      }
      return f;
    }, this.getWeekNumber = (i) => i.week(), this.getDayOfWeek = (i) => i.day() + 1, this.moment = r || ct, this.locale = t, this.formats = Q({}, Zj, n);
  }
  getYearRange([t, n]) {
    const r = this.startOfYear(t), i = this.endOfYear(n), s = [];
    let a = r;
    for (; this.isBefore(a, i); )
      s.push(a), a = this.addYears(a, 1);
    return s;
  }
}
const tp = (e) => {
  const t = No(() => navigator.language, [navigator.language]), n = e.value == null || e.value === "" ? null : ct(e.value), r = {
    ...e.format ? {
      inputFormat: e.format
    } : {}
  };
  return /* @__PURE__ */ p.jsx(Ld, { dateAdapter: lh, adapterLocale: t, children: /* @__PURE__ */ p.jsx(
    bf,
    {
      label: e.label,
      value: n && n.isValid() ? n : null,
      minDate: e.minDate,
      maxDate: e.maxDate,
      onChange: e.onChange,
      disabled: e.disabled,
      disableFuture: e.disableFuture,
      disablePast: e.disablePast,
      sx: (i) => {
        var s;
        return {
          backgroundColor: "#ffffff",
          ".MuiInputBase-input": {
            padding: e.size === "small" ? "3px 6px" : "6px 12px",
            fontSize: 13
          },
          ".MuiButtonBase-root": {
            p: e.size === "small" ? 0 : 0.5
          },
          ".MuiSvgIcon-root": {
            fontSize: 20,
            color: "secondary.main"
          },
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: e.error ? "error.main" : "borderColor.main"
          },
          "&:hover": {
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: e.error ? i.palette.error.main : Vu(0.7, (s = i.palette) == null ? void 0 : s.primary.main)
            }
          }
        };
      },
      ...r
    }
  ) });
}, ch = (e) => {
  var t;
  return {
    padding: 0,
    borderRadius: (((t = e.shape) == null ? void 0 : t.borderRadius) || 0) + "px"
  };
}, uh = (e) => (t) => {
  var n;
  return {
    padding: e ? "6px 12px" : "8px 16px",
    fontSize: "0.9rem",
    fontWeight: 400,
    color: ((n = t.palette) == null ? void 0 : n.grey[800]) || "grey",
    "&:hover": {
      backgroundColor: Jn(0.9, t.palette.info.main)
    },
    "&.Mui-disabled": { backgroundColor: t.palette.grey[100], opacity: 0.9 },
    "&.Mui-disabled *": {
      color: t.palette.grey[800],
      backgroundColor: t.palette.grey[400],
      opacity: 1,
      filter: "grayscale(1)"
    },
    "&.Mui-selected": {
      backgroundColor: Jn(0.92, t.palette.info.main)
    }
  };
}, dh = (e) => {
  var t;
  return {
    borderRadius: (((t = e.shape) == null ? void 0 : t.borderRadius) || 0) + "px"
  };
}, ph = yo.div`
  position: relative;
  top: 3px;
  display: inline-block;
  margin-right: 8px;
`, fh = yo.div`
  border-bottom: 1px solid #c3cad1;
`, Gs = (e) => /* @__PURE__ */ p.jsx(
  Si,
  {
    ref: e.ref,
    ...e,
    size: e.size,
    classes: {
      startIcon: "start-icon start-icon-" + e.size,
      endIcon: "end-icon end-icon-" + e.size
    },
    children: e.children
  }
), h5 = Z(
  ({
    className: e,
    ...t
  }) => /* @__PURE__ */ p.jsx(
    _r,
    {
      ...t,
      classes: {
        popper: e
      }
    }
  )
)(({ theme: e, color: t }) => {
  var n, r;
  return {
    [`& .${so.tooltip}`]: {
      borderRadius: 4,
      fontSize: "0.8rem",
      backgroundColor: Jn(
        0.2,
        e.palette && ((n = e.palette[t]) == null ? void 0 : n.main) || "#5e6b8b"
      )
    },
    [`& .${so.arrow}`]: {
      color: Jn(
        0.2,
        e.palette && ((r = e.palette[t]) == null ? void 0 : r.main) || "#5e6b8b"
      )
    }
  };
}), wc = (e) => {
  const {
    children: t,
    text: n,
    show: r = !1,
    disabled: i,
    placement: s = "top",
    controlled: a,
    arrow: l = !0,
    color: c,
    popperProps: u,
    disableInteractive: f = !1,
    sx: g
  } = e;
  return a ? /* @__PURE__ */ p.jsx(
    h5,
    {
      title: n,
      placement: s,
      open: r,
      arrow: l,
      color: c,
      PopperProps: u,
      disableInteractive: f,
      sx: g,
      children: t
    }
  ) : /* @__PURE__ */ p.jsx(
    h5,
    {
      title: n,
      placement: s,
      arrow: l,
      disableHoverListener: i,
      color: c,
      PopperProps: u,
      disableInteractive: f,
      sx: g,
      children: t
    }
  );
}, gh = (e) => {
  const {
    children: t,
    title: n = "",
    size: r = "medium",
    fullWidth: i,
    disabled: s = !1,
    endIcon: a,
    startIcon: l,
    variant: c = "text",
    options: u,
    placement: f,
    onClick: g,
    className: h,
    color: y = "primary",
    closeOnSelect: v = !1,
    name: m,
    sx: b,
    tooltipPlacement: C,
    iconComponent: E
  } = e, [S, k] = He.useState(!1), T = He.useRef(null), P = (R) => {
    R.stopPropagation(), k((V) => !V);
  }, F = (R) => {
    R && T.current && T.current.contains(R.target) || k(!1);
  };
  function j(R) {
    R.stopPropagation(), R.key === "Tab" && (R.preventDefault(), k(!1));
  }
  const L = He.useRef(S);
  return He.useEffect(() => {
    L.current === !0 && S === !1 && T.current.focus(), L.current = S;
  }, [S]), /* @__PURE__ */ p.jsxs(He.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      Gs,
      {
        disabled: s,
        fullWidth: i,
        endIcon: a,
        startIcon: l,
        size: r,
        variant: c || "text",
        color: y,
        onClick: P,
        ref: T,
        "aria-controls": S ? "menu-list-grow" : void 0,
        "aria-haspopup": "true",
        className: xe(h, "c-dropdown-menu dropdown__button"),
        classes: {
          root: "button-component",
          contained: "button-contained",
          outlined: "button-outlined",
          disabled: "button-disabled",
          text: "button-text"
          // label: 'button-label',
        },
        name: m,
        sx: b,
        children: n
      }
    ),
    /* @__PURE__ */ p.jsx(
      us,
      {
        open: S,
        anchorEl: T.current,
        transition: !0,
        sx: { zIndex: 2e3 },
        placement: f || "bottom",
        disablePortal: e.disablePortal ?? !0,
        modifiers: [
          {
            name: "flip",
            enabled: !1
          },
          {
            name: "preventOverflow",
            ...e.preventOverflow ? {
              enabled: !0,
              options: {
                altAxis: !0,
                altBoundary: !0,
                tether: !0,
                rootBoundary: "document",
                padding: 8
              }
            } : { enabled: !1 }
          }
        ],
        children: ({ TransitionProps: R }) => /* @__PURE__ */ p.jsx(ss, { ...R, children: /* @__PURE__ */ p.jsx(li, { sx: dh, children: /* @__PURE__ */ p.jsx(Ta, { onClickAway: F, children: /* @__PURE__ */ p.jsx(
          Fd,
          {
            autoFocusItem: S,
            id: "menu-list-grow",
            onKeyDown: j,
            sx: ch,
            className: "drop-down-menu",
            children: t || (u == null ? void 0 : u.map((V) => /* @__PURE__ */ p.jsx(
              wc,
              {
                text: V.message || "",
                placement: C || "auto",
                children: /* @__PURE__ */ p.jsxs("div", { children: [
                  /* @__PURE__ */ p.jsxs(
                    xr,
                    {
                      className: "menu-item-" + V.name,
                      onClick: (B) => {
                        B.stopPropagation(), g && g(V), v && F();
                      },
                      sx: uh(!!E),
                      disabled: V == null ? void 0 : V.disabled,
                      selected: V.name === n,
                      children: [
                        /* @__PURE__ */ p.jsx(p.Fragment, { children: E && /* @__PURE__ */ p.jsx(ph, { children: /* @__PURE__ */ p.jsx(E, { value: V.id }) }) }),
                        V.component || V.name
                      ]
                    },
                    V.name
                  ),
                  V.endGroup && /* @__PURE__ */ p.jsx(fh, {})
                ] })
              }
            )))
          }
        ) }) }) })
      }
    )
  ] });
}, qj = Z(Tg)`
  transform: none;
  transform-origin: none;
`, Ca = (e) => /* @__PURE__ */ p.jsx(qj, { ...e }), Kj = Z(
  ng
)`
  font-size: 14px;
  line-height: inherit;
  height: 50px;
  align-items: flex-end;
  display: flex;
  flex-wrap: wrap;
  min-width: 200px;

  .breadcrumbs-separator {
    margin: 0;
    overflow: hidden;
  }
  .favorite-icon {
    display: none;
  }
  :not(.static-link) {
    li.MuiBreadcrumbs-li {
    }
  }
  ol {
    flex-wrap: nowrap;
    height: 100%;
    padding-left: 10px;
    max-width: 100%;
    .breadcrumbs-separator {
      min-width: 8px;
    }
    li.MuiBreadcrumbs-li {
      padding: 0 8px;
      min-width: 50px;
      p {
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`, Xj = Z(vo)`
  font-size: 14px;
  line-height: inherit;
  cursor: pointer;
  & > *:hover {
    color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette) == null ? void 0 : t.secondary.main) || "grey";
}};
    text-decoration: underline;
  }
`, Qj = Z(vo)`
  font-size: 14px;
  font-weight: bold;
  line-height: inherit;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  width: 100%;
`, v5 = Z("span")`
  display: block;
  box-sizing: border-box;
  color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette) == null ? void 0 : t.grey[200]) || "grey";
}};
  border-radius: 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  &.MuiTypography-root,
  .c-breadcrumb-text-current {
    color: #ffffff;
  }
`, J1 = Z(Ca)`
  background-color: ${({ theme: e }) => {
  var t;
  return Jn(0.5, (t = e.palette) == null ? void 0 : t.secondary.main);
}};
`, Jj = Z("div")`
  height: 54px;
  padding: 8px 0;
  > * {
    margin-top: 8px;
  }
`, A_ = (e) => {
  let t = [...e == null ? void 0 : e.items];
  const n = t == null ? void 0 : t.pop();
  return e.isLoading ? /* @__PURE__ */ p.jsxs(Jj, { children: [
    /* @__PURE__ */ p.jsx(J1, { height: 16, width: 100 }),
    /* @__PURE__ */ p.jsx(J1, { height: 26, width: 200 })
  ] }, "loader") : /* @__PURE__ */ p.jsxs(Kj, { classes: { separator: "breadcrumbs-separator" }, children: [
    t.map((r, i) => /* @__PURE__ */ p.jsx(
      Xj,
      {
        onClick: () => e.onClick(r),
        className: "c-breadcrumb-link",
        title: r == null ? void 0 : r.name,
        children: /* @__PURE__ */ p.jsx(v5, { className: "c-breadcrumb-text", children: r == null ? void 0 : r.name })
      },
      (r == null ? void 0 : r.name) + i
    )),
    /* @__PURE__ */ p.jsx(Qj, { title: n == null ? void 0 : n.name, children: n && (n.name ? /* @__PURE__ */ p.jsx(v5, { className: "c-breadcrumb-text-current", children: n == null ? void 0 : n.name }) : /* @__PURE__ */ p.jsx(J1, { height: 24, width: 100 }, "loader")) })
  ] });
};
var np = { exports: {} }, fu = { exports: {} }, y5;
function eF() {
  return y5 || (y5 = 1, function(e, t) {
    (function(n, r) {
      r(t, He);
    })(q5, function(n, r) {
      function i(x, O, $, N, ne, q, ae) {
        try {
          var Ee = x[q](ae), Me = Ee.value;
        } catch (De) {
          return void $(De);
        }
        Ee.done ? O(Me) : Promise.resolve(Me).then(N, ne);
      }
      function s(x) {
        return function() {
          var O = this, $ = arguments;
          return new Promise(function(N, ne) {
            var q = x.apply(O, $);
            function ae(Me) {
              i(q, N, ne, ae, Ee, "next", Me);
            }
            function Ee(Me) {
              i(q, N, ne, ae, Ee, "throw", Me);
            }
            ae(void 0);
          });
        };
      }
      function a() {
        return (a = Object.assign || function(x) {
          for (var O = 1; O < arguments.length; O++) {
            var $ = arguments[O];
            for (var N in $) Object.prototype.hasOwnProperty.call($, N) && (x[N] = $[N]);
          }
          return x;
        }).apply(this, arguments);
      }
      function l(x, O) {
        if (x == null) return {};
        var $, N, ne = {}, q = Object.keys(x);
        for (N = 0; N < q.length; N++) $ = q[N], O.indexOf($) >= 0 || (ne[$] = x[$]);
        return ne;
      }
      function c(x) {
        var O = function($, N) {
          if (typeof $ != "object" || $ === null) return $;
          var ne = $[Symbol.toPrimitive];
          if (ne !== void 0) {
            var q = ne.call($, N);
            if (typeof q != "object") return q;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String($);
        }(x, "string");
        return typeof O == "symbol" ? O : String(O);
      }
      r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
      var u = { init: "init" }, f = function(x) {
        var O = x.value;
        return O === void 0 ? "" : O;
      }, g = function() {
        return r.createElement(r.Fragment, null, " ");
      }, h = { Cell: f, width: 150, minWidth: 0, maxWidth: Number.MAX_SAFE_INTEGER };
      function y() {
        for (var x = arguments.length, O = new Array(x), $ = 0; $ < x; $++) O[$] = arguments[$];
        return O.reduce(function(N, ne) {
          var q = ne.style, ae = ne.className;
          return N = a({}, N, {}, l(ne, ["style", "className"])), q && (N.style = N.style ? a({}, N.style || {}, {}, q || {}) : q), ae && (N.className = N.className ? N.className + " " + ae : ae), N.className === "" && delete N.className, N;
        }, {});
      }
      var v = function(x, O) {
        return O === void 0 && (O = {}), function($) {
          return $ === void 0 && ($ = {}), [].concat(x, [$]).reduce(function(N, ne) {
            return function q(ae, Ee, Me) {
              return typeof Ee == "function" ? q({}, Ee(ae, Me)) : Array.isArray(Ee) ? y.apply(void 0, [ae].concat(Ee)) : y(ae, Ee);
            }(N, ne, a({}, O, { userProps: $ }));
          }, {});
        };
      }, m = function(x, O, $, N) {
        return $ === void 0 && ($ = {}), x.reduce(function(ne, q) {
          return q(ne, $);
        }, O);
      }, b = function(x, O, $) {
        return $ === void 0 && ($ = {}), x.forEach(function(N) {
          N(O, $);
        });
      };
      function C(x, O, $, N) {
        x.findIndex(function(ne) {
          return ne.pluginName === $;
        }), O.forEach(function(ne) {
          x.findIndex(function(q) {
            return q.pluginName === ne;
          });
        });
      }
      function E(x, O) {
        return typeof x == "function" ? x(O) : x;
      }
      function S(x) {
        var O = r.useRef();
        return O.current = x, r.useCallback(function() {
          return O.current;
        }, []);
      }
      var k = typeof document < "u" ? r.useLayoutEffect : r.useEffect;
      function T(x, O) {
        var $ = r.useRef(!1);
        k(function() {
          $.current && x(), $.current = !0;
        }, O);
      }
      function P(x, O, $) {
        return $ === void 0 && ($ = {}), function(N, ne) {
          ne === void 0 && (ne = {});
          var q = typeof N == "string" ? O[N] : N;
          if (q === void 0) throw console.info(O), new Error("Renderer Error ☝️");
          return F(q, a({}, x, { column: O }, $, {}, ne));
        };
      }
      function F(x, O) {
        return function(N) {
          return typeof N == "function" && (ne = Object.getPrototypeOf(N)).prototype && ne.prototype.isReactComponent;
          var ne;
        }($ = x) || typeof $ == "function" || function(N) {
          return typeof N == "object" && typeof N.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(N.$$typeof.description);
        }($) ? r.createElement(x, O) : x;
        var $;
      }
      function j(x, O, $) {
        return $ === void 0 && ($ = 0), x.map(function(N) {
          return R(N = a({}, N, { parent: O, depth: $ })), N.columns && (N.columns = j(N.columns, N, $ + 1)), N;
        });
      }
      function L(x) {
        return H(x, "columns");
      }
      function R(x) {
        var O = x.id, $ = x.accessor, N = x.Header;
        if (typeof $ == "string") {
          O = O || $;
          var ne = $.split(".");
          $ = function(q) {
            return function(ae, Ee, Me) {
              if (!Ee) return ae;
              var De, et = typeof Ee == "function" ? Ee : JSON.stringify(Ee), Ye = W.get(et) || function() {
                var Ze = function(Be) {
                  return function Ue(st, ut) {
                    if (ut === void 0 && (ut = []), Array.isArray(st)) for (var Rt = 0; Rt < st.length; Rt += 1) Ue(st[Rt], ut);
                    else ut.push(st);
                    return ut;
                  }(Be).map(function(Ue) {
                    return String(Ue).replace(".", "_");
                  }).join(".").replace(pe, ".").replace(Ce, "").split(".");
                }(Ee);
                return W.set(et, Ze), Ze;
              }();
              try {
                De = Ye.reduce(function(Ze, Be) {
                  return Ze[Be];
                }, ae);
              } catch {
              }
              return De !== void 0 ? De : Me;
            }(q, ne);
          };
        }
        if (!O && typeof N == "string" && N && (O = N), !O && x.columns) throw console.error(x), new Error('A column ID (or unique "Header" value) is required!');
        if (!O) throw console.error(x), new Error("A column ID (or string accessor) is required!");
        return Object.assign(x, { id: O, accessor: $ }), x;
      }
      function V(x, O) {
        if (!O) throw new Error();
        return Object.assign(x, a({ Header: g, Footer: g }, h, {}, O, {}, x)), Object.assign(x, { originalWidth: x.width }), x;
      }
      function B(x, O, $) {
        $ === void 0 && ($ = function() {
          return {};
        });
        for (var N = [], ne = x, q = 0, ae = function() {
          return q++;
        }, Ee = function() {
          var Me = { headers: [] }, De = [], et = ne.some(function(Ye) {
            return Ye.parent;
          });
          ne.forEach(function(Ye) {
            var Ze, Be = [].concat(De).reverse()[0];
            et && (Ye.parent ? Ze = a({}, Ye.parent, { originalId: Ye.parent.id, id: Ye.parent.id + "_" + ae(), headers: [Ye] }, $(Ye)) : Ze = V(a({ originalId: Ye.id + "_placeholder", id: Ye.id + "_placeholder_" + ae(), placeholderOf: Ye, headers: [Ye] }, $(Ye)), O), Be && Be.originalId === Ze.originalId ? Be.headers.push(Ye) : De.push(Ze)), Me.headers.push(Ye);
          }), N.push(Me), ne = De;
        }; ne.length; ) Ee();
        return N.reverse();
      }
      var W = /* @__PURE__ */ new Map();
      function z() {
        for (var x = arguments.length, O = new Array(x), $ = 0; $ < x; $++) O[$] = arguments[$];
        for (var N = 0; N < O.length; N += 1) if (O[N] !== void 0) return O[N];
      }
      function G(x) {
        if (typeof x == "function") return x;
      }
      function H(x, O) {
        var $ = [];
        return function N(ne) {
          ne.forEach(function(q) {
            q[O] ? N(q[O]) : $.push(q);
          });
        }(x), $;
      }
      function ie(x, O) {
        var $ = O.manualExpandedKey, N = O.expanded, ne = O.expandSubRows, q = ne === void 0 || ne, ae = [];
        return x.forEach(function(Ee) {
          return function Me(De, et) {
            et === void 0 && (et = !0), De.isExpanded = De.original && De.original[$] || N[De.id], De.canExpand = De.subRows && !!De.subRows.length, et && ae.push(De), De.subRows && De.subRows.length && De.isExpanded && De.subRows.forEach(function(Ye) {
              return Me(Ye, q);
            });
          }(Ee);
        }), ae;
      }
      function ce(x, O, $) {
        return G(x) || O[x] || $[x] || $.text;
      }
      function re(x, O, $) {
        return x ? x(O, $) : O === void 0;
      }
      function A() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
      }
      var Y = null, pe = /\[/g, Ce = /\]/g, fe = function(x) {
        return a({ role: "table" }, x);
      }, ee = function(x) {
        return a({ role: "rowgroup" }, x);
      }, te = function(x, O) {
        var $ = O.column;
        return a({ key: "header_" + $.id, colSpan: $.totalVisibleHeaderCount, role: "columnheader" }, x);
      }, ue = function(x, O) {
        var $ = O.column;
        return a({ key: "footer_" + $.id, colSpan: $.totalVisibleHeaderCount }, x);
      }, K = function(x, O) {
        return a({ key: "headerGroup_" + O.index, role: "row" }, x);
      }, oe = function(x, O) {
        return a({ key: "footerGroup_" + O.index }, x);
      }, de = function(x, O) {
        return a({ key: "row_" + O.row.id, role: "row" }, x);
      }, ve = function(x, O) {
        var $ = O.cell;
        return a({ key: "cell_" + $.row.id + "_" + $.column.id, role: "cell" }, x);
      };
      function J() {
        return { useOptions: [], stateReducers: [], useControlledState: [], columns: [], columnsDeps: [], allColumns: [], allColumnsDeps: [], accessValue: [], materializedColumns: [], materializedColumnsDeps: [], useInstanceAfterData: [], visibleColumns: [], visibleColumnsDeps: [], headerGroups: [], headerGroupsDeps: [], useInstanceBeforeDimensions: [], useInstance: [], prepareRow: [], getTableProps: [fe], getTableBodyProps: [ee], getHeaderGroupProps: [K], getFooterGroupProps: [oe], getHeaderProps: [te], getFooterProps: [ue], getRowProps: [de], getCellProps: [ve], useFinalInstance: [] };
      }
      u.resetHiddenColumns = "resetHiddenColumns", u.toggleHideColumn = "toggleHideColumn", u.setHiddenColumns = "setHiddenColumns", u.toggleHideAllColumns = "toggleHideAllColumns";
      var se = function(x) {
        x.getToggleHiddenProps = [ge], x.getToggleHideAllColumnsProps = [Se], x.stateReducers.push(we), x.useInstanceBeforeDimensions.push(me), x.headerGroupsDeps.push(function(O, $) {
          var N = $.instance;
          return [].concat(O, [N.state.hiddenColumns]);
        }), x.useInstance.push(ye);
      };
      se.pluginName = "useColumnVisibility";
      var ge = function(x, O) {
        var $ = O.column;
        return [x, { onChange: function(N) {
          $.toggleHidden(!N.target.checked);
        }, style: { cursor: "pointer" }, checked: $.isVisible, title: "Toggle Column Visible" }];
      }, Se = function(x, O) {
        var $ = O.instance;
        return [x, { onChange: function(N) {
          $.toggleHideAllColumns(!N.target.checked);
        }, style: { cursor: "pointer" }, checked: !$.allColumnsHidden && !$.state.hiddenColumns.length, title: "Toggle All Columns Hidden", indeterminate: !$.allColumnsHidden && $.state.hiddenColumns.length }];
      };
      function we(x, O, $, N) {
        if (O.type === u.init) return a({ hiddenColumns: [] }, x);
        if (O.type === u.resetHiddenColumns) return a({}, x, { hiddenColumns: N.initialState.hiddenColumns || [] });
        if (O.type === u.toggleHideColumn) {
          var ne = (O.value !== void 0 ? O.value : !x.hiddenColumns.includes(O.columnId)) ? [].concat(x.hiddenColumns, [O.columnId]) : x.hiddenColumns.filter(function(q) {
            return q !== O.columnId;
          });
          return a({}, x, { hiddenColumns: ne });
        }
        return O.type === u.setHiddenColumns ? a({}, x, { hiddenColumns: E(O.value, x.hiddenColumns) }) : O.type === u.toggleHideAllColumns ? a({}, x, { hiddenColumns: (O.value !== void 0 ? O.value : !x.hiddenColumns.length) ? N.allColumns.map(function(q) {
          return q.id;
        }) : [] }) : void 0;
      }
      function me(x) {
        var O = x.headers, $ = x.state.hiddenColumns;
        r.useRef(!1).current;
        var N = 0;
        O.forEach(function(ne) {
          return N += function q(ae, Ee) {
            ae.isVisible = Ee && !$.includes(ae.id);
            var Me = 0;
            return ae.headers && ae.headers.length ? ae.headers.forEach(function(De) {
              return Me += q(De, ae.isVisible);
            }) : Me = ae.isVisible ? 1 : 0, ae.totalVisibleHeaderCount = Me, Me;
          }(ne, !0);
        });
      }
      function ye(x) {
        var O = x.columns, $ = x.flatHeaders, N = x.dispatch, ne = x.allColumns, q = x.getHooks, ae = x.state.hiddenColumns, Ee = x.autoResetHiddenColumns, Me = Ee === void 0 || Ee, De = S(x), et = ne.length === ae.length, Ye = r.useCallback(function(ut, Rt) {
          return N({ type: u.toggleHideColumn, columnId: ut, value: Rt });
        }, [N]), Ze = r.useCallback(function(ut) {
          return N({ type: u.setHiddenColumns, value: ut });
        }, [N]), Be = r.useCallback(function(ut) {
          return N({ type: u.toggleHideAllColumns, value: ut });
        }, [N]), Ue = v(q().getToggleHideAllColumnsProps, { instance: De() });
        $.forEach(function(ut) {
          ut.toggleHidden = function(Rt) {
            N({ type: u.toggleHideColumn, columnId: ut.id, value: Rt });
          }, ut.getToggleHiddenProps = v(q().getToggleHiddenProps, { instance: De(), column: ut });
        });
        var st = S(Me);
        T(function() {
          st() && N({ type: u.resetHiddenColumns });
        }, [N, O]), Object.assign(x, { allColumnsHidden: et, toggleHideColumn: Ye, setHiddenColumns: Ze, toggleHideAllColumns: Be, getToggleHideAllColumnsProps: Ue });
      }
      var Ie = {}, je = {}, Te = function(x, O, $) {
        return x;
      }, Fe = function(x, O) {
        return x.subRows || [];
      }, gt = function(x, O, $) {
        return "" + ($ ? [$.id, O].join(".") : O);
      }, Dt = function(x) {
        return x;
      };
      function ke(x) {
        var O = x.initialState, $ = O === void 0 ? Ie : O, N = x.defaultColumn, ne = N === void 0 ? je : N, q = x.getSubRows, ae = q === void 0 ? Fe : q, Ee = x.getRowId, Me = Ee === void 0 ? gt : Ee, De = x.stateReducer, et = De === void 0 ? Te : De, Ye = x.useControlledState, Ze = Ye === void 0 ? Dt : Ye;
        return a({}, l(x, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]), { initialState: $, defaultColumn: ne, getSubRows: ae, getRowId: Me, stateReducer: et, useControlledState: Ze });
      }
      function Ne(x, O) {
        O === void 0 && (O = 0);
        var $ = 0, N = 0, ne = 0, q = 0;
        return x.forEach(function(ae) {
          var Ee = ae.headers;
          if (ae.totalLeft = O, Ee && Ee.length) {
            var Me = Ne(Ee, O), De = Me[0], et = Me[1], Ye = Me[2], Ze = Me[3];
            ae.totalMinWidth = De, ae.totalWidth = et, ae.totalMaxWidth = Ye, ae.totalFlexWidth = Ze;
          } else ae.totalMinWidth = ae.minWidth, ae.totalWidth = Math.min(Math.max(ae.minWidth, ae.width), ae.maxWidth), ae.totalMaxWidth = ae.maxWidth, ae.totalFlexWidth = ae.canResize ? ae.totalWidth : 0;
          ae.isVisible && (O += ae.totalWidth, $ += ae.totalMinWidth, N += ae.totalWidth, ne += ae.totalMaxWidth, q += ae.totalFlexWidth);
        }), [$, N, ne, q];
      }
      function We(x) {
        var O = x.data, $ = x.rows, N = x.flatRows, ne = x.rowsById, q = x.column, ae = x.getRowId, Ee = x.getSubRows, Me = x.accessValueHooks, De = x.getInstance;
        O.forEach(function(et, Ye) {
          return function Ze(Be, Ue, st, ut, Rt) {
            st === void 0 && (st = 0);
            var rn = Be, Tt = ae(Be, Ue, ut), tt = ne[Tt];
            if (tt) tt.subRows && tt.originalSubRows.forEach(function(Ct, qt) {
              return Ze(Ct, qt, st + 1, tt);
            });
            else if ((tt = { id: Tt, original: rn, index: Ue, depth: st, cells: [{}] }).cells.map = A, tt.cells.filter = A, tt.cells.forEach = A, tt.cells[0].getCellProps = A, tt.values = {}, Rt.push(tt), N.push(tt), ne[Tt] = tt, tt.originalSubRows = Ee(Be, Ue), tt.originalSubRows) {
              var en = [];
              tt.originalSubRows.forEach(function(Ct, qt) {
                return Ze(Ct, qt, st + 1, tt, en);
              }), tt.subRows = en;
            }
            q.accessor && (tt.values[q.id] = q.accessor(Be, Ue, tt, Rt, O)), tt.values[q.id] = m(Me, tt.values[q.id], { row: tt, column: q, instance: De() });
          }(et, Ye, 0, void 0, $);
        });
      }
      u.resetExpanded = "resetExpanded", u.toggleRowExpanded = "toggleRowExpanded", u.toggleAllRowsExpanded = "toggleAllRowsExpanded";
      var Ge = function(x) {
        x.getToggleAllRowsExpandedProps = [Qe], x.getToggleRowExpandedProps = [Ve], x.stateReducers.push(Ke), x.useInstance.push(bt), x.prepareRow.push(vt);
      };
      Ge.pluginName = "useExpanded";
      var Qe = function(x, O) {
        var $ = O.instance;
        return [x, { onClick: function(N) {
          $.toggleAllRowsExpanded();
        }, style: { cursor: "pointer" }, title: "Toggle All Rows Expanded" }];
      }, Ve = function(x, O) {
        var $ = O.row;
        return [x, { onClick: function() {
          $.toggleRowExpanded();
        }, style: { cursor: "pointer" }, title: "Toggle Row Expanded" }];
      };
      function Ke(x, O, $, N) {
        if (O.type === u.init) return a({ expanded: {} }, x);
        if (O.type === u.resetExpanded) return a({}, x, { expanded: N.initialState.expanded || {} });
        if (O.type === u.toggleAllRowsExpanded) {
          var ne = O.value, q = N.rowsById, ae = Object.keys(q).length === Object.keys(x.expanded).length;
          if (ne !== void 0 ? ne : !ae) {
            var Ee = {};
            return Object.keys(q).forEach(function(Ue) {
              Ee[Ue] = !0;
            }), a({}, x, { expanded: Ee });
          }
          return a({}, x, { expanded: {} });
        }
        if (O.type === u.toggleRowExpanded) {
          var Me, De = O.id, et = O.value, Ye = x.expanded[De], Ze = et !== void 0 ? et : !Ye;
          if (!Ye && Ze) return a({}, x, { expanded: a({}, x.expanded, (Me = {}, Me[De] = !0, Me)) });
          if (Ye && !Ze) {
            var Be = x.expanded;
            return Be[De], a({}, x, { expanded: l(Be, [De].map(c)) });
          }
          return x;
        }
      }
      function bt(x) {
        var O = x.data, $ = x.rows, N = x.rowsById, ne = x.manualExpandedKey, q = ne === void 0 ? "expanded" : ne, ae = x.paginateExpandedRows, Ee = ae === void 0 || ae, Me = x.expandSubRows, De = Me === void 0 || Me, et = x.autoResetExpanded, Ye = et === void 0 || et, Ze = x.getHooks, Be = x.plugins, Ue = x.state.expanded, st = x.dispatch;
        C(Be, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
        var ut = S(Ye), Rt = !!(Object.keys(N).length && Object.keys(Ue).length);
        Rt && Object.keys(N).some(function(fn) {
          return !Ue[fn];
        }) && (Rt = !1), T(function() {
          ut() && st({ type: u.resetExpanded });
        }, [st, O]);
        var rn = r.useCallback(function(fn, _t) {
          st({ type: u.toggleRowExpanded, id: fn, value: _t });
        }, [st]), Tt = r.useCallback(function(fn) {
          return st({ type: u.toggleAllRowsExpanded, value: fn });
        }, [st]), tt = r.useMemo(function() {
          return Ee ? ie($, { manualExpandedKey: q, expanded: Ue, expandSubRows: De }) : $;
        }, [Ee, $, q, Ue, De]), en = r.useMemo(function() {
          return function(fn) {
            var _t = 0;
            return Object.keys(fn).forEach(function(Ut) {
              var En = Ut.split(".");
              _t = Math.max(_t, En.length);
            }), _t;
          }(Ue);
        }, [Ue]), Ct = S(x), qt = v(Ze().getToggleAllRowsExpandedProps, { instance: Ct() });
        Object.assign(x, { preExpandedRows: $, expandedRows: tt, rows: tt, expandedDepth: en, isAllRowsExpanded: Rt, toggleRowExpanded: rn, toggleAllRowsExpanded: Tt, getToggleAllRowsExpandedProps: qt });
      }
      function vt(x, O) {
        var $ = O.instance.getHooks, N = O.instance;
        x.toggleRowExpanded = function(ne) {
          return N.toggleRowExpanded(x.id, ne);
        }, x.getToggleRowExpandedProps = v($().getToggleRowExpandedProps, { instance: N, row: x });
      }
      var tn = function(x, O, $) {
        return x = x.filter(function(N) {
          return O.some(function(ne) {
            var q = N.values[ne];
            return String(q).toLowerCase().includes(String($).toLowerCase());
          });
        });
      };
      tn.autoRemove = function(x) {
        return !x;
      };
      var hn = function(x, O, $) {
        return x.filter(function(N) {
          return O.some(function(ne) {
            var q = N.values[ne];
            return q === void 0 || String(q).toLowerCase() === String($).toLowerCase();
          });
        });
      };
      hn.autoRemove = function(x) {
        return !x;
      };
      var Je = function(x, O, $) {
        return x.filter(function(N) {
          return O.some(function(ne) {
            var q = N.values[ne];
            return q === void 0 || String(q) === String($);
          });
        });
      };
      Je.autoRemove = function(x) {
        return !x;
      };
      var $t = function(x, O, $) {
        return x.filter(function(N) {
          return O.some(function(ne) {
            return N.values[ne].includes($);
          });
        });
      };
      $t.autoRemove = function(x) {
        return !x || !x.length;
      };
      var nn = function(x, O, $) {
        return x.filter(function(N) {
          return O.some(function(ne) {
            var q = N.values[ne];
            return q && q.length && $.every(function(ae) {
              return q.includes(ae);
            });
          });
        });
      };
      nn.autoRemove = function(x) {
        return !x || !x.length;
      };
      var Nt = function(x, O, $) {
        return x.filter(function(N) {
          return O.some(function(ne) {
            var q = N.values[ne];
            return q && q.length && $.some(function(ae) {
              return q.includes(ae);
            });
          });
        });
      };
      Nt.autoRemove = function(x) {
        return !x || !x.length;
      };
      var cn = function(x, O, $) {
        return x.filter(function(N) {
          return O.some(function(ne) {
            var q = N.values[ne];
            return $.includes(q);
          });
        });
      };
      cn.autoRemove = function(x) {
        return !x || !x.length;
      };
      var Lt = function(x, O, $) {
        return x.filter(function(N) {
          return O.some(function(ne) {
            return N.values[ne] === $;
          });
        });
      };
      Lt.autoRemove = function(x) {
        return x === void 0;
      };
      var jt = function(x, O, $) {
        return x.filter(function(N) {
          return O.some(function(ne) {
            return N.values[ne] == $;
          });
        });
      };
      jt.autoRemove = function(x) {
        return x == null;
      };
      var un = function(x, O, $) {
        var N = $ || [], ne = N[0], q = N[1];
        if ((ne = typeof ne == "number" ? ne : -1 / 0) > (q = typeof q == "number" ? q : 1 / 0)) {
          var ae = ne;
          ne = q, q = ae;
        }
        return x.filter(function(Ee) {
          return O.some(function(Me) {
            var De = Ee.values[Me];
            return De >= ne && De <= q;
          });
        });
      };
      un.autoRemove = function(x) {
        return !x || typeof x[0] != "number" && typeof x[1] != "number";
      };
      var On = Object.freeze({ __proto__: null, text: tn, exactText: hn, exactTextCase: Je, includes: $t, includesAll: nn, includesSome: Nt, includesValue: cn, exact: Lt, equals: jt, between: un });
      u.resetFilters = "resetFilters", u.setFilter = "setFilter", u.setAllFilters = "setAllFilters";
      var Un = function(x) {
        x.stateReducers.push(ro), x.useInstance.push(Ft);
      };
      function ro(x, O, $, N) {
        if (O.type === u.init) return a({ filters: [] }, x);
        if (O.type === u.resetFilters) return a({}, x, { filters: N.initialState.filters || [] });
        if (O.type === u.setFilter) {
          var ne = O.columnId, q = O.filterValue, ae = N.allColumns, Ee = N.filterTypes, Me = ae.find(function(st) {
            return st.id === ne;
          });
          if (!Me) throw new Error("React-Table: Could not find a column with id: " + ne);
          var De = ce(Me.filter, Ee || {}, On), et = x.filters.find(function(st) {
            return st.id === ne;
          }), Ye = E(q, et && et.value);
          return re(De.autoRemove, Ye, Me) ? a({}, x, { filters: x.filters.filter(function(st) {
            return st.id !== ne;
          }) }) : a({}, x, et ? { filters: x.filters.map(function(st) {
            return st.id === ne ? { id: ne, value: Ye } : st;
          }) } : { filters: [].concat(x.filters, [{ id: ne, value: Ye }]) });
        }
        if (O.type === u.setAllFilters) {
          var Ze = O.filters, Be = N.allColumns, Ue = N.filterTypes;
          return a({}, x, { filters: E(Ze, x.filters).filter(function(st) {
            var ut = Be.find(function(Rt) {
              return Rt.id === st.id;
            });
            return !re(ce(ut.filter, Ue || {}, On).autoRemove, st.value, ut);
          }) });
        }
      }
      function Ft(x) {
        var O = x.data, $ = x.rows, N = x.flatRows, ne = x.rowsById, q = x.allColumns, ae = x.filterTypes, Ee = x.manualFilters, Me = x.defaultCanFilter, De = Me !== void 0 && Me, et = x.disableFilters, Ye = x.state.filters, Ze = x.dispatch, Be = x.autoResetFilters, Ue = Be === void 0 || Be, st = r.useCallback(function(Ct, qt) {
          Ze({ type: u.setFilter, columnId: Ct, filterValue: qt });
        }, [Ze]), ut = r.useCallback(function(Ct) {
          Ze({ type: u.setAllFilters, filters: Ct });
        }, [Ze]);
        q.forEach(function(Ct) {
          var qt = Ct.id, fn = Ct.accessor, _t = Ct.defaultCanFilter, Ut = Ct.disableFilters;
          Ct.canFilter = fn ? z(Ut !== !0 && void 0, et !== !0 && void 0, !0) : z(_t, De, !1), Ct.setFilter = function(Jt) {
            return st(Ct.id, Jt);
          };
          var En = Ye.find(function(Jt) {
            return Jt.id === qt;
          });
          Ct.filterValue = En && En.value;
        });
        var Rt = r.useMemo(function() {
          if (Ee || !Ye.length) return [$, N, ne];
          var Ct = [], qt = {};
          return [function fn(_t, Ut) {
            Ut === void 0 && (Ut = 0);
            var En = _t;
            return (En = Ye.reduce(function(Jt, bn) {
              var w = bn.id, M = bn.value, D = q.find(function(U) {
                return U.id === w;
              });
              if (!D) return Jt;
              Ut === 0 && (D.preFilteredRows = Jt);
              var I = ce(D.filter, ae || {}, On);
              return I ? (D.filteredRows = I(Jt, [w], M), D.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + D.id + "."), Jt);
            }, _t)).forEach(function(Jt) {
              Ct.push(Jt), qt[Jt.id] = Jt, Jt.subRows && (Jt.subRows = Jt.subRows && Jt.subRows.length > 0 ? fn(Jt.subRows, Ut + 1) : Jt.subRows);
            }), En;
          }($), Ct, qt];
        }, [Ee, Ye, $, N, ne, q, ae]), rn = Rt[0], Tt = Rt[1], tt = Rt[2];
        r.useMemo(function() {
          q.filter(function(Ct) {
            return !Ye.find(function(qt) {
              return qt.id === Ct.id;
            });
          }).forEach(function(Ct) {
            Ct.preFilteredRows = rn, Ct.filteredRows = rn;
          });
        }, [rn, Ye, q]);
        var en = S(Ue);
        T(function() {
          en() && Ze({ type: u.resetFilters });
        }, [Ze, Ee ? null : O]), Object.assign(x, { preFilteredRows: $, preFilteredFlatRows: N, preFilteredRowsById: ne, filteredRows: rn, filteredFlatRows: Tt, filteredRowsById: tt, rows: rn, flatRows: Tt, rowsById: tt, setFilter: st, setAllFilters: ut });
      }
      Un.pluginName = "useFilters", u.resetGlobalFilter = "resetGlobalFilter", u.setGlobalFilter = "setGlobalFilter";
      var Yn = function(x) {
        x.stateReducers.push(it), x.useInstance.push(ft);
      };
      function it(x, O, $, N) {
        if (O.type === u.resetGlobalFilter) return a({}, x, { globalFilter: N.initialState.globalFilter || void 0 });
        if (O.type === u.setGlobalFilter) {
          var ne = O.filterValue, q = N.userFilterTypes, ae = ce(N.globalFilter, q || {}, On), Ee = E(ne, x.globalFilter);
          return re(ae.autoRemove, Ee) ? (x.globalFilter, l(x, ["globalFilter"])) : a({}, x, { globalFilter: Ee });
        }
      }
      function ft(x) {
        var O = x.data, $ = x.rows, N = x.flatRows, ne = x.rowsById, q = x.allColumns, ae = x.filterTypes, Ee = x.globalFilter, Me = x.manualGlobalFilter, De = x.state.globalFilter, et = x.dispatch, Ye = x.autoResetGlobalFilter, Ze = Ye === void 0 || Ye, Be = x.disableGlobalFilter, Ue = r.useCallback(function(tt) {
          et({ type: u.setGlobalFilter, filterValue: tt });
        }, [et]), st = r.useMemo(function() {
          if (Me || De === void 0) return [$, N, ne];
          var tt = [], en = {}, Ct = ce(Ee, ae || {}, On);
          if (!Ct) return console.warn("Could not find a valid 'globalFilter' option."), $;
          q.forEach(function(fn) {
            var _t = fn.disableGlobalFilter;
            fn.canFilter = z(_t !== !0 && void 0, Be !== !0 && void 0, !0);
          });
          var qt = q.filter(function(fn) {
            return fn.canFilter === !0;
          });
          return [function fn(_t) {
            return (_t = Ct(_t, qt.map(function(Ut) {
              return Ut.id;
            }), De)).forEach(function(Ut) {
              tt.push(Ut), en[Ut.id] = Ut, Ut.subRows = Ut.subRows && Ut.subRows.length ? fn(Ut.subRows) : Ut.subRows;
            }), _t;
          }($), tt, en];
        }, [Me, De, Ee, ae, q, $, N, ne, Be]), ut = st[0], Rt = st[1], rn = st[2], Tt = S(Ze);
        T(function() {
          Tt() && et({ type: u.resetGlobalFilter });
        }, [et, Me ? null : O]), Object.assign(x, { preGlobalFilteredRows: $, preGlobalFilteredFlatRows: N, preGlobalFilteredRowsById: ne, globalFilteredRows: ut, globalFilteredFlatRows: Rt, globalFilteredRowsById: rn, rows: ut, flatRows: Rt, rowsById: rn, setGlobalFilter: Ue, disableGlobalFilter: Be });
      }
      function Xt(x, O) {
        return O.reduce(function($, N) {
          return $ + (typeof N == "number" ? N : 0);
        }, 0);
      }
      Yn.pluginName = "useGlobalFilter";
      var Ae = Object.freeze({ __proto__: null, sum: Xt, min: function(x) {
        var O = x[0] || 0;
        return x.forEach(function($) {
          typeof $ == "number" && (O = Math.min(O, $));
        }), O;
      }, max: function(x) {
        var O = x[0] || 0;
        return x.forEach(function($) {
          typeof $ == "number" && (O = Math.max(O, $));
        }), O;
      }, minMax: function(x) {
        var O = x[0] || 0, $ = x[0] || 0;
        return x.forEach(function(N) {
          typeof N == "number" && (O = Math.min(O, N), $ = Math.max($, N));
        }), O + ".." + $;
      }, average: function(x) {
        return Xt(0, x) / x.length;
      }, median: function(x) {
        if (!x.length) return null;
        var O = Math.floor(x.length / 2), $ = [].concat(x).sort(function(N, ne) {
          return N - ne;
        });
        return x.length % 2 != 0 ? $[O] : ($[O - 1] + $[O]) / 2;
      }, unique: function(x) {
        return Array.from(new Set(x).values());
      }, uniqueCount: function(x) {
        return new Set(x).size;
      }, count: function(x) {
        return x.length;
      } }), St = [], yn = {};
      u.resetGroupBy = "resetGroupBy", u.setGroupBy = "setGroupBy", u.toggleGroupBy = "toggleGroupBy";
      var In = function(x) {
        x.getGroupByToggleProps = [Oo], x.stateReducers.push(Do), x.visibleColumnsDeps.push(function(O, $) {
          var N = $.instance;
          return [].concat(O, [N.state.groupBy]);
        }), x.visibleColumns.push(Xn), x.useInstance.push(Ko), x.prepareRow.push(di);
      };
      In.pluginName = "useGroupBy";
      var Oo = function(x, O) {
        var $ = O.header;
        return [x, { onClick: $.canGroupBy ? function(N) {
          N.persist(), $.toggleGroupBy();
        } : void 0, style: { cursor: $.canGroupBy ? "pointer" : void 0 }, title: "Toggle GroupBy" }];
      };
      function Do(x, O, $, N) {
        if (O.type === u.init) return a({ groupBy: [] }, x);
        if (O.type === u.resetGroupBy) return a({}, x, { groupBy: N.initialState.groupBy || [] });
        if (O.type === u.setGroupBy) return a({}, x, { groupBy: O.value });
        if (O.type === u.toggleGroupBy) {
          var ne = O.columnId, q = O.value, ae = q !== void 0 ? q : !x.groupBy.includes(ne);
          return a({}, x, ae ? { groupBy: [].concat(x.groupBy, [ne]) } : { groupBy: x.groupBy.filter(function(Ee) {
            return Ee !== ne;
          }) });
        }
      }
      function Xn(x, O) {
        var $ = O.instance.state.groupBy, N = $.map(function(q) {
          return x.find(function(ae) {
            return ae.id === q;
          });
        }).filter(Boolean), ne = x.filter(function(q) {
          return !$.includes(q.id);
        });
        return (x = [].concat(N, ne)).forEach(function(q) {
          q.isGrouped = $.includes(q.id), q.groupedIndex = $.indexOf(q.id);
        }), x;
      }
      var fo = {};
      function Ko(x) {
        var O = x.data, $ = x.rows, N = x.flatRows, ne = x.rowsById, q = x.allColumns, ae = x.flatHeaders, Ee = x.groupByFn, Me = Ee === void 0 ? Le : Ee, De = x.manualGroupBy, et = x.aggregations, Ye = et === void 0 ? fo : et, Ze = x.plugins, Be = x.state.groupBy, Ue = x.dispatch, st = x.autoResetGroupBy, ut = st === void 0 || st, Rt = x.disableGroupBy, rn = x.defaultCanGroupBy, Tt = x.getHooks;
        C(Ze, ["useColumnOrder", "useFilters"], "useGroupBy");
        var tt = S(x);
        q.forEach(function(D) {
          var I = D.accessor, U = D.defaultGroupBy, X = D.disableGroupBy;
          D.canGroupBy = I ? z(D.canGroupBy, X !== !0 && void 0, Rt !== !0 && void 0, !0) : z(D.canGroupBy, U, rn, !1), D.canGroupBy && (D.toggleGroupBy = function() {
            return x.toggleGroupBy(D.id);
          }), D.Aggregated = D.Aggregated || D.Cell;
        });
        var en = r.useCallback(function(D, I) {
          Ue({ type: u.toggleGroupBy, columnId: D, value: I });
        }, [Ue]), Ct = r.useCallback(function(D) {
          Ue({ type: u.setGroupBy, value: D });
        }, [Ue]);
        ae.forEach(function(D) {
          D.getGroupByToggleProps = v(Tt().getGroupByToggleProps, { instance: tt(), header: D });
        });
        var qt = r.useMemo(function() {
          if (De || !Be.length) return [$, N, ne, St, yn, N, ne];
          var D = Be.filter(function($e) {
            return q.find(function(nt) {
              return nt.id === $e;
            });
          }), I = [], U = {}, X = [], _ = {}, le = [], he = {}, Re = function $e(nt, ze, Xe) {
            if (ze === void 0 && (ze = 0), ze === D.length) return nt.map(function(ht) {
              return a({}, ht, { depth: ze });
            });
            var rt = D[ze], _e = Me(nt, rt);
            return Object.entries(_e).map(function(ht, It) {
              var Ht = ht[0], lt = ht[1], on = rt + ":" + Ht, pn = $e(lt, ze + 1, on = Xe ? Xe + ">" + on : on), dt = ze ? H(lt, "leafRows") : lt, at = function(Mt, sn, an) {
                var Vn = {};
                return q.forEach(function(wt) {
                  if (D.includes(wt.id)) Vn[wt.id] = sn[0] ? sn[0].values[wt.id] : null;
                  else {
                    var To = typeof wt.aggregate == "function" ? wt.aggregate : Ye[wt.aggregate] || Ae[wt.aggregate];
                    if (To) {
                      var ln = sn.map(function(Kt) {
                        return Kt.values[wt.id];
                      }), Yt = Mt.map(function(Kt) {
                        var Nn = Kt.values[wt.id];
                        if (!an && wt.aggregateValue) {
                          var jo = typeof wt.aggregateValue == "function" ? wt.aggregateValue : Ye[wt.aggregateValue] || Ae[wt.aggregateValue];
                          if (!jo) throw console.info({ column: wt }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                          Nn = jo(Nn, Kt, wt);
                        }
                        return Nn;
                      });
                      Vn[wt.id] = To(Yt, ln);
                    } else {
                      if (wt.aggregate) throw console.info({ column: wt }), new Error("React Table: Invalid column.aggregate option for column listed above");
                      Vn[wt.id] = null;
                    }
                  }
                }), Vn;
              }(dt, lt, ze), pt = { id: on, isGrouped: !0, groupByID: rt, groupByVal: Ht, values: at, subRows: pn, leafRows: dt, depth: ze, index: It };
              return pn.forEach(function(Mt) {
                I.push(Mt), U[Mt.id] = Mt, Mt.isGrouped ? (X.push(Mt), _[Mt.id] = Mt) : (le.push(Mt), he[Mt.id] = Mt);
              }), pt;
            });
          }($);
          return Re.forEach(function($e) {
            I.push($e), U[$e.id] = $e, $e.isGrouped ? (X.push($e), _[$e.id] = $e) : (le.push($e), he[$e.id] = $e);
          }), [Re, I, U, X, _, le, he];
        }, [De, Be, $, N, ne, q, Ye, Me]), fn = qt[0], _t = qt[1], Ut = qt[2], En = qt[3], Jt = qt[4], bn = qt[5], w = qt[6], M = S(ut);
        T(function() {
          M() && Ue({ type: u.resetGroupBy });
        }, [Ue, De ? null : O]), Object.assign(x, { preGroupedRows: $, preGroupedFlatRow: N, preGroupedRowsById: ne, groupedRows: fn, groupedFlatRows: _t, groupedRowsById: Ut, onlyGroupedFlatRows: En, onlyGroupedRowsById: Jt, nonGroupedFlatRows: bn, nonGroupedRowsById: w, rows: fn, flatRows: _t, rowsById: Ut, toggleGroupBy: en, setGroupBy: Ct });
      }
      function di(x) {
        x.allCells.forEach(function(O) {
          var $;
          O.isGrouped = O.column.isGrouped && O.column.id === x.groupByID, O.isPlaceholder = !O.isGrouped && O.column.isGrouped, O.isAggregated = !O.isGrouped && !O.isPlaceholder && (($ = x.subRows) == null ? void 0 : $.length);
        });
      }
      function Le(x, O) {
        return x.reduce(function($, N, ne) {
          var q = "" + N.values[O];
          return $[q] = Array.isArray($[q]) ? $[q] : [], $[q].push(N), $;
        }, {});
      }
      var Pe = /([0-9]+)/gm;
      function ot(x, O) {
        return x === O ? 0 : x > O ? 1 : -1;
      }
      function Qt(x, O, $) {
        return [x.values[$], O.values[$]];
      }
      function dn(x) {
        return typeof x == "number" ? isNaN(x) || x === 1 / 0 || x === -1 / 0 ? "" : String(x) : typeof x == "string" ? x : "";
      }
      var xn = Object.freeze({ __proto__: null, alphanumeric: function(x, O, $) {
        var N = Qt(x, O, $), ne = N[0], q = N[1];
        for (ne = dn(ne), q = dn(q), ne = ne.split(Pe).filter(Boolean), q = q.split(Pe).filter(Boolean); ne.length && q.length; ) {
          var ae = ne.shift(), Ee = q.shift(), Me = parseInt(ae, 10), De = parseInt(Ee, 10), et = [Me, De].sort();
          if (isNaN(et[0])) {
            if (ae > Ee) return 1;
            if (Ee > ae) return -1;
          } else {
            if (isNaN(et[1])) return isNaN(Me) ? -1 : 1;
            if (Me > De) return 1;
            if (De > Me) return -1;
          }
        }
        return ne.length - q.length;
      }, datetime: function(x, O, $) {
        var N = Qt(x, O, $), ne = N[0], q = N[1];
        return ot(ne = ne.getTime(), q = q.getTime());
      }, basic: function(x, O, $) {
        var N = Qt(x, O, $);
        return ot(N[0], N[1]);
      }, string: function(x, O, $) {
        var N = Qt(x, O, $), ne = N[0], q = N[1];
        for (ne = ne.split("").filter(Boolean), q = q.split("").filter(Boolean); ne.length && q.length; ) {
          var ae = ne.shift(), Ee = q.shift(), Me = ae.toLowerCase(), De = Ee.toLowerCase();
          if (Me > De) return 1;
          if (De > Me) return -1;
          if (ae > Ee) return 1;
          if (Ee > ae) return -1;
        }
        return ne.length - q.length;
      }, number: function(x, O, $) {
        var N = Qt(x, O, $), ne = N[0], q = N[1], ae = /[^0-9.]/gi;
        return ot(ne = Number(String(ne).replace(ae, "")), q = Number(String(q).replace(ae, "")));
      } });
      u.resetSortBy = "resetSortBy", u.setSortBy = "setSortBy", u.toggleSortBy = "toggleSortBy", u.clearSortBy = "clearSortBy", h.sortType = "alphanumeric", h.sortDescFirst = !1;
      var Qn = function(x) {
        x.getSortByToggleProps = [Ro], x.stateReducers.push(pi), x.useInstance.push(Va);
      };
      Qn.pluginName = "useSortBy";
      var Ro = function(x, O) {
        var $ = O.instance, N = O.column, ne = $.isMultiSortEvent, q = ne === void 0 ? function(ae) {
          return ae.shiftKey;
        } : ne;
        return [x, { onClick: N.canSort ? function(ae) {
          ae.persist(), N.toggleSortBy(void 0, !$.disableMultiSort && q(ae));
        } : void 0, style: { cursor: N.canSort ? "pointer" : void 0 }, title: N.canSort ? "Toggle SortBy" : void 0 }];
      };
      function pi(x, O, $, N) {
        if (O.type === u.init) return a({ sortBy: [] }, x);
        if (O.type === u.resetSortBy) return a({}, x, { sortBy: N.initialState.sortBy || [] });
        if (O.type === u.clearSortBy) return a({}, x, { sortBy: x.sortBy.filter(function(tt) {
          return tt.id !== O.columnId;
        }) });
        if (O.type === u.setSortBy) return a({}, x, { sortBy: O.sortBy });
        if (O.type === u.toggleSortBy) {
          var ne, q = O.columnId, ae = O.desc, Ee = O.multi, Me = N.allColumns, De = N.disableMultiSort, et = N.disableSortRemove, Ye = N.disableMultiRemove, Ze = N.maxMultiSortColCount, Be = Ze === void 0 ? Number.MAX_SAFE_INTEGER : Ze, Ue = x.sortBy, st = Me.find(function(tt) {
            return tt.id === q;
          }).sortDescFirst, ut = Ue.find(function(tt) {
            return tt.id === q;
          }), Rt = Ue.findIndex(function(tt) {
            return tt.id === q;
          }), rn = ae != null, Tt = [];
          return (ne = !De && Ee ? ut ? "toggle" : "add" : Rt !== Ue.length - 1 || Ue.length !== 1 ? "replace" : ut ? "toggle" : "replace") != "toggle" || et || rn || Ee && Ye || !(ut && ut.desc && !st || !ut.desc && st) || (ne = "remove"), ne === "replace" ? Tt = [{ id: q, desc: rn ? ae : st }] : ne === "add" ? (Tt = [].concat(Ue, [{ id: q, desc: rn ? ae : st }])).splice(0, Tt.length - Be) : ne === "toggle" ? Tt = Ue.map(function(tt) {
            return tt.id === q ? a({}, tt, { desc: rn ? ae : !ut.desc }) : tt;
          }) : ne === "remove" && (Tt = Ue.filter(function(tt) {
            return tt.id !== q;
          })), a({}, x, { sortBy: Tt });
        }
      }
      function Va(x) {
        var O = x.data, $ = x.rows, N = x.flatRows, ne = x.allColumns, q = x.orderByFn, ae = q === void 0 ? ds : q, Ee = x.sortTypes, Me = x.manualSortBy, De = x.defaultCanSort, et = x.disableSortBy, Ye = x.flatHeaders, Ze = x.state.sortBy, Be = x.dispatch, Ue = x.plugins, st = x.getHooks, ut = x.autoResetSortBy, Rt = ut === void 0 || ut;
        C(Ue, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
        var rn = r.useCallback(function(_t) {
          Be({ type: u.setSortBy, sortBy: _t });
        }, [Be]), Tt = r.useCallback(function(_t, Ut, En) {
          Be({ type: u.toggleSortBy, columnId: _t, desc: Ut, multi: En });
        }, [Be]), tt = S(x);
        Ye.forEach(function(_t) {
          var Ut = _t.accessor, En = _t.canSort, Jt = _t.disableSortBy, bn = _t.id, w = Ut ? z(Jt !== !0 && void 0, et !== !0 && void 0, !0) : z(De, En, !1);
          _t.canSort = w, _t.canSort && (_t.toggleSortBy = function(D, I) {
            return Tt(_t.id, D, I);
          }, _t.clearSortBy = function() {
            Be({ type: u.clearSortBy, columnId: _t.id });
          }), _t.getSortByToggleProps = v(st().getSortByToggleProps, { instance: tt(), column: _t });
          var M = Ze.find(function(D) {
            return D.id === bn;
          });
          _t.isSorted = !!M, _t.sortedIndex = Ze.findIndex(function(D) {
            return D.id === bn;
          }), _t.isSortedDesc = _t.isSorted ? M.desc : void 0;
        });
        var en = r.useMemo(function() {
          if (Me || !Ze.length) return [$, N];
          var _t = [], Ut = Ze.filter(function(En) {
            return ne.find(function(Jt) {
              return Jt.id === En.id;
            });
          });
          return [function En(Jt) {
            var bn = ae(Jt, Ut.map(function(w) {
              var M = ne.find(function(U) {
                return U.id === w.id;
              });
              if (!M) throw new Error("React-Table: Could not find a column with id: " + w.id + " while sorting");
              var D = M.sortType, I = G(D) || (Ee || {})[D] || xn[D];
              if (!I) throw new Error("React-Table: Could not find a valid sortType of '" + D + "' for column '" + w.id + "'.");
              return function(U, X) {
                return I(U, X, w.id, w.desc);
              };
            }), Ut.map(function(w) {
              var M = ne.find(function(D) {
                return D.id === w.id;
              });
              return M && M.sortInverted ? w.desc : !w.desc;
            }));
            return bn.forEach(function(w) {
              _t.push(w), w.subRows && w.subRows.length !== 0 && (w.subRows = En(w.subRows));
            }), bn;
          }($), _t];
        }, [Me, Ze, $, N, ne, ae, Ee]), Ct = en[0], qt = en[1], fn = S(Rt);
        T(function() {
          fn() && Be({ type: u.resetSortBy });
        }, [Me ? null : O]), Object.assign(x, { preSortedRows: $, preSortedFlatRows: N, sortedRows: Ct, sortedFlatRows: qt, rows: Ct, flatRows: qt, setSortBy: rn, toggleSortBy: Tt });
      }
      function ds(x, O, $) {
        return [].concat(x).sort(function(N, ne) {
          for (var q = 0; q < O.length; q += 1) {
            var ae = O[q], Ee = $[q] === !1 || $[q] === "desc", Me = ae(N, ne);
            if (Me !== 0) return Ee ? -Me : Me;
          }
          return $[0] ? N.index - ne.index : ne.index - N.index;
        });
      }
      u.resetPage = "resetPage", u.gotoPage = "gotoPage", u.setPageSize = "setPageSize";
      var Hr = function(x) {
        x.stateReducers.push(_i), x.useInstance.push(Sn);
      };
      function _i(x, O, $, N) {
        if (O.type === u.init) return a({ pageSize: 10, pageIndex: 0 }, x);
        if (O.type === u.resetPage) return a({}, x, { pageIndex: N.initialState.pageIndex || 0 });
        if (O.type === u.gotoPage) {
          var ne = N.pageCount, q = N.page, ae = E(O.pageIndex, x.pageIndex), Ee = !1;
          return ae > x.pageIndex ? Ee = ne === -1 ? q.length >= x.pageSize : ae < ne : ae < x.pageIndex && (Ee = ae > -1), Ee ? a({}, x, { pageIndex: ae }) : x;
        }
        if (O.type === u.setPageSize) {
          var Me = O.pageSize, De = x.pageSize * x.pageIndex;
          return a({}, x, { pageIndex: Math.floor(De / Me), pageSize: Me });
        }
      }
      function Sn(x) {
        var O = x.rows, $ = x.autoResetPage, N = $ === void 0 || $, ne = x.manualExpandedKey, q = ne === void 0 ? "expanded" : ne, ae = x.plugins, Ee = x.pageCount, Me = x.paginateExpandedRows, De = Me === void 0 || Me, et = x.expandSubRows, Ye = et === void 0 || et, Ze = x.state, Be = Ze.pageSize, Ue = Ze.pageIndex, st = Ze.expanded, ut = Ze.globalFilter, Rt = Ze.filters, rn = Ze.groupBy, Tt = Ze.sortBy, tt = x.dispatch, en = x.data, Ct = x.manualPagination;
        C(ae, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
        var qt = S(N);
        T(function() {
          qt() && tt({ type: u.resetPage });
        }, [tt, Ct ? null : en, ut, Rt, rn, Tt]);
        var fn = Ct ? Ee : Math.ceil(O.length / Be), _t = r.useMemo(function() {
          return fn > 0 ? [].concat(new Array(fn)).fill(null).map(function(I, U) {
            return U;
          }) : [];
        }, [fn]), Ut = r.useMemo(function() {
          var I;
          if (Ct) I = O;
          else {
            var U = Be * Ue, X = U + Be;
            I = O.slice(U, X);
          }
          return De ? I : ie(I, { manualExpandedKey: q, expanded: st, expandSubRows: Ye });
        }, [Ye, st, q, Ct, Ue, Be, De, O]), En = Ue > 0, Jt = fn === -1 ? Ut.length >= Be : Ue < fn - 1, bn = r.useCallback(function(I) {
          tt({ type: u.gotoPage, pageIndex: I });
        }, [tt]), w = r.useCallback(function() {
          return bn(function(I) {
            return I - 1;
          });
        }, [bn]), M = r.useCallback(function() {
          return bn(function(I) {
            return I + 1;
          });
        }, [bn]), D = r.useCallback(function(I) {
          tt({ type: u.setPageSize, pageSize: I });
        }, [tt]);
        Object.assign(x, { pageOptions: _t, pageCount: fn, page: Ut, canPreviousPage: En, canNextPage: Jt, gotoPage: bn, previousPage: w, nextPage: M, setPageSize: D });
      }
      Hr.pluginName = "usePagination", u.resetPivot = "resetPivot", u.togglePivot = "togglePivot";
      var Lo = function(x) {
        x.getPivotToggleProps = [fi], x.stateReducers.push($a), x.useInstanceAfterData.push(s1), x.allColumns.push(a1), x.accessValue.push(l1), x.materializedColumns.push(Mc), x.materializedColumnsDeps.push(kc), x.visibleColumns.push(c1), x.visibleColumnsDeps.push(u1), x.useInstance.push(d1), x.prepareRow.push(p1);
      };
      Lo.pluginName = "usePivotColumns";
      var rr = [], fi = function(x, O) {
        var $ = O.header;
        return [x, { onClick: $.canPivot ? function(N) {
          N.persist(), $.togglePivot();
        } : void 0, style: { cursor: $.canPivot ? "pointer" : void 0 }, title: "Toggle Pivot" }];
      };
      function $a(x, O, $, N) {
        if (O.type === u.init) return a({ pivotColumns: rr }, x);
        if (O.type === u.resetPivot) return a({}, x, { pivotColumns: N.initialState.pivotColumns || rr });
        if (O.type === u.togglePivot) {
          var ne = O.columnId, q = O.value, ae = q !== void 0 ? q : !x.pivotColumns.includes(ne);
          return a({}, x, ae ? { pivotColumns: [].concat(x.pivotColumns, [ne]) } : { pivotColumns: x.pivotColumns.filter(function(Ee) {
            return Ee !== ne;
          }) });
        }
      }
      function s1(x) {
        x.allColumns.forEach(function(O) {
          O.isPivotSource = x.state.pivotColumns.includes(O.id);
        });
      }
      function a1(x, O) {
        var $ = O.instance;
        return x.forEach(function(N) {
          N.isPivotSource = $.state.pivotColumns.includes(N.id), N.uniqueValues = /* @__PURE__ */ new Set();
        }), x;
      }
      function l1(x, O) {
        var $ = O.column;
        return $.uniqueValues && x !== void 0 && $.uniqueValues.add(x), x;
      }
      function Mc(x, O) {
        var $ = O.instance, N = $.allColumns, ne = $.state;
        if (!ne.pivotColumns.length || !ne.groupBy || !ne.groupBy.length) return x;
        var q = ne.pivotColumns.map(function(Me) {
          return N.find(function(De) {
            return De.id === Me;
          });
        }).filter(Boolean), ae = N.filter(function(Me) {
          return !Me.isPivotSource && !ne.groupBy.includes(Me.id) && !ne.pivotColumns.includes(Me.id);
        }), Ee = L(function Me(De, et, Ye) {
          De === void 0 && (De = 0), Ye === void 0 && (Ye = []);
          var Ze = q[De];
          return Ze ? Array.from(Ze.uniqueValues).sort().map(function(Be) {
            var Ue = a({}, Ze, { Header: Ze.PivotHeader || typeof Ze.header == "string" ? Ze.Header + ": " + Be : Be, isPivotGroup: !0, parent: et, depth: De, id: et ? et.id + "." + Ze.id + "." + Be : Ze.id + "." + Be, pivotValue: Be });
            return Ue.columns = Me(De + 1, Ue, [].concat(Ye, [function(st) {
              return st.values[Ze.id] === Be;
            }])), Ue;
          }) : ae.map(function(Be) {
            return a({}, Be, { canPivot: !1, isPivoted: !0, parent: et, depth: De, id: "" + (et ? et.id + "." + Be.id : Be.id), accessor: function(Ue, st, ut) {
              if (Ye.every(function(Rt) {
                return Rt(ut);
              })) return ut.values[Be.id];
            } });
          });
        }());
        return [].concat(x, Ee);
      }
      function kc(x, O) {
        var $ = O.instance.state, N = $.pivotColumns, ne = $.groupBy;
        return [].concat(x, [N, ne]);
      }
      function c1(x, O) {
        var $ = O.instance.state;
        return x = x.filter(function(N) {
          return !N.isPivotSource;
        }), $.pivotColumns.length && $.groupBy && $.groupBy.length && (x = x.filter(function(N) {
          return N.isGrouped || N.isPivoted;
        })), x;
      }
      function u1(x, O) {
        var $ = O.instance;
        return [].concat(x, [$.state.pivotColumns, $.state.groupBy]);
      }
      function d1(x) {
        var O = x.columns, $ = x.allColumns, N = x.flatHeaders, ne = x.getHooks, q = x.plugins, ae = x.dispatch, Ee = x.autoResetPivot, Me = Ee === void 0 || Ee, De = x.manaulPivot, et = x.disablePivot, Ye = x.defaultCanPivot;
        C(q, ["useGroupBy"], "usePivotColumns");
        var Ze = S(x);
        $.forEach(function(Ue) {
          var st = Ue.accessor, ut = Ue.defaultPivot, Rt = Ue.disablePivot;
          Ue.canPivot = st ? z(Ue.canPivot, Rt !== !0 && void 0, et !== !0 && void 0, !0) : z(Ue.canPivot, ut, Ye, !1), Ue.canPivot && (Ue.togglePivot = function() {
            return x.togglePivot(Ue.id);
          }), Ue.Aggregated = Ue.Aggregated || Ue.Cell;
        }), N.forEach(function(Ue) {
          Ue.getPivotToggleProps = v(ne().getPivotToggleProps, { instance: Ze(), header: Ue });
        });
        var Be = S(Me);
        T(function() {
          Be() && ae({ type: u.resetPivot });
        }, [ae, De ? null : O]), Object.assign(x, { togglePivot: function(Ue, st) {
          ae({ type: u.togglePivot, columnId: Ue, value: st });
        } });
      }
      function p1(x) {
        x.allCells.forEach(function(O) {
          O.isPivoted = O.column.isPivoted;
        });
      }
      u.resetSelectedRows = "resetSelectedRows", u.toggleAllRowsSelected = "toggleAllRowsSelected", u.toggleRowSelected = "toggleRowSelected", u.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
      var Pc = function(x) {
        x.getToggleRowSelectedProps = [La], x.getToggleAllRowsSelectedProps = [ps], x.getToggleAllPageRowsSelectedProps = [Ic], x.stateReducers.push(f1), x.useInstance.push(Oc), x.prepareRow.push(g1);
      };
      Pc.pluginName = "useRowSelect";
      var La = function(x, O) {
        var $ = O.instance, N = O.row, ne = $.manualRowSelectedKey, q = ne === void 0 ? "isSelected" : ne;
        return [x, { onChange: function(ae) {
          N.toggleRowSelected(ae.target.checked);
        }, style: { cursor: "pointer" }, checked: !(!N.original || !N.original[q]) || N.isSelected, title: "Toggle Row Selected", indeterminate: N.isSomeSelected }];
      }, ps = function(x, O) {
        var $ = O.instance;
        return [x, { onChange: function(N) {
          $.toggleAllRowsSelected(N.target.checked);
        }, style: { cursor: "pointer" }, checked: $.isAllRowsSelected, title: "Toggle All Rows Selected", indeterminate: !!(!$.isAllRowsSelected && Object.keys($.state.selectedRowIds).length) }];
      }, Ic = function(x, O) {
        var $ = O.instance;
        return [x, { onChange: function(N) {
          $.toggleAllPageRowsSelected(N.target.checked);
        }, style: { cursor: "pointer" }, checked: $.isAllPageRowsSelected, title: "Toggle All Current Page Rows Selected", indeterminate: !!(!$.isAllPageRowsSelected && $.page.some(function(N) {
          var ne = N.id;
          return $.state.selectedRowIds[ne];
        })) }];
      };
      function f1(x, O, $, N) {
        if (O.type === u.init) return a({ selectedRowIds: {} }, x);
        if (O.type === u.resetSelectedRows) return a({}, x, { selectedRowIds: N.initialState.selectedRowIds || {} });
        if (O.type === u.toggleAllRowsSelected) {
          var ne = O.value, q = N.isAllRowsSelected, ae = N.rowsById, Ee = N.nonGroupedRowsById, Me = Ee === void 0 ? ae : Ee, De = ne !== void 0 ? ne : !q, et = Object.assign({}, x.selectedRowIds);
          return De ? Object.keys(Me).forEach(function(bn) {
            et[bn] = !0;
          }) : Object.keys(Me).forEach(function(bn) {
            delete et[bn];
          }), a({}, x, { selectedRowIds: et });
        }
        if (O.type === u.toggleRowSelected) {
          var Ye = O.id, Ze = O.value, Be = N.rowsById, Ue = N.selectSubRows, st = Ue === void 0 || Ue, ut = N.getSubRows, Rt = x.selectedRowIds[Ye], rn = Ze !== void 0 ? Ze : !Rt;
          if (Rt === rn) return x;
          var Tt = a({}, x.selectedRowIds);
          return function bn(w) {
            var M = Be[w];
            if (M && (M.isGrouped || (rn ? Tt[w] = !0 : delete Tt[w]), st && ut(M))) return ut(M).forEach(function(D) {
              return bn(D.id);
            });
          }(Ye), a({}, x, { selectedRowIds: Tt });
        }
        if (O.type === u.toggleAllPageRowsSelected) {
          var tt = O.value, en = N.page, Ct = N.rowsById, qt = N.selectSubRows, fn = qt === void 0 || qt, _t = N.isAllPageRowsSelected, Ut = N.getSubRows, En = tt !== void 0 ? tt : !_t, Jt = a({}, x.selectedRowIds);
          return en.forEach(function(bn) {
            return function w(M) {
              var D = Ct[M];
              if (D.isGrouped || (En ? Jt[M] = !0 : delete Jt[M]), fn && Ut(D)) return Ut(D).forEach(function(I) {
                return w(I.id);
              });
            }(bn.id);
          }), a({}, x, { selectedRowIds: Jt });
        }
        return x;
      }
      function Oc(x) {
        var O = x.data, $ = x.rows, N = x.getHooks, ne = x.plugins, q = x.rowsById, ae = x.nonGroupedRowsById, Ee = ae === void 0 ? q : ae, Me = x.autoResetSelectedRows, De = Me === void 0 || Me, et = x.state.selectedRowIds, Ye = x.selectSubRows, Ze = Ye === void 0 || Ye, Be = x.dispatch, Ue = x.page, st = x.getSubRows;
        C(ne, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
        var ut = r.useMemo(function() {
          var Ut = [];
          return $.forEach(function(En) {
            var Jt = Ze ? function bn(w, M, D) {
              if (M[w.id]) return !0;
              var I = D(w);
              if (I && I.length) {
                var U = !0, X = !1;
                return I.forEach(function(_) {
                  X && !U || (bn(_, M, D) ? X = !0 : U = !1);
                }), !!U || !!X && null;
              }
              return !1;
            }(En, et, st) : !!et[En.id];
            En.isSelected = !!Jt, En.isSomeSelected = Jt === null, Jt && Ut.push(En);
          }), Ut;
        }, [$, Ze, et, st]), Rt = !!(Object.keys(Ee).length && Object.keys(et).length), rn = Rt;
        Rt && Object.keys(Ee).some(function(Ut) {
          return !et[Ut];
        }) && (Rt = !1), Rt || Ue && Ue.length && Ue.some(function(Ut) {
          var En = Ut.id;
          return !et[En];
        }) && (rn = !1);
        var Tt = S(De);
        T(function() {
          Tt() && Be({ type: u.resetSelectedRows });
        }, [Be, O]);
        var tt = r.useCallback(function(Ut) {
          return Be({ type: u.toggleAllRowsSelected, value: Ut });
        }, [Be]), en = r.useCallback(function(Ut) {
          return Be({ type: u.toggleAllPageRowsSelected, value: Ut });
        }, [Be]), Ct = r.useCallback(function(Ut, En) {
          return Be({ type: u.toggleRowSelected, id: Ut, value: En });
        }, [Be]), qt = S(x), fn = v(N().getToggleAllRowsSelectedProps, { instance: qt() }), _t = v(N().getToggleAllPageRowsSelectedProps, { instance: qt() });
        Object.assign(x, { selectedFlatRows: ut, isAllRowsSelected: Rt, isAllPageRowsSelected: rn, toggleRowSelected: Ct, toggleAllRowsSelected: tt, getToggleAllRowsSelectedProps: fn, getToggleAllPageRowsSelectedProps: _t, toggleAllPageRowsSelected: en });
      }
      function g1(x, O) {
        var $ = O.instance;
        x.toggleRowSelected = function(N) {
          return $.toggleRowSelected(x.id, N);
        }, x.getToggleRowSelectedProps = v($.getHooks().getToggleRowSelectedProps, { instance: $, row: x });
      }
      var Dc = function(x) {
        return {};
      }, jc = function(x) {
        return {};
      };
      u.setRowState = "setRowState", u.setCellState = "setCellState", u.resetRowState = "resetRowState";
      var Aa = function(x) {
        x.stateReducers.push(m1), x.useInstance.push(Fc), x.prepareRow.push(h1);
      };
      function m1(x, O, $, N) {
        var ne = N.initialRowStateAccessor, q = ne === void 0 ? Dc : ne, ae = N.initialCellStateAccessor, Ee = ae === void 0 ? jc : ae, Me = N.rowsById;
        if (O.type === u.init) return a({ rowState: {} }, x);
        if (O.type === u.resetRowState) return a({}, x, { rowState: N.initialState.rowState || {} });
        if (O.type === u.setRowState) {
          var De, et = O.rowId, Ye = O.value, Ze = x.rowState[et] !== void 0 ? x.rowState[et] : q(Me[et]);
          return a({}, x, { rowState: a({}, x.rowState, (De = {}, De[et] = E(Ye, Ze), De)) });
        }
        if (O.type === u.setCellState) {
          var Be, Ue, st, ut, Rt, rn = O.rowId, Tt = O.columnId, tt = O.value, en = x.rowState[rn] !== void 0 ? x.rowState[rn] : q(Me[rn]), Ct = (en == null || (Be = en.cellState) == null ? void 0 : Be[Tt]) !== void 0 ? en.cellState[Tt] : Ee((Ue = Me[rn]) == null || (st = Ue.cells) == null ? void 0 : st.find(function(qt) {
            return qt.column.id === Tt;
          }));
          return a({}, x, { rowState: a({}, x.rowState, (Rt = {}, Rt[rn] = a({}, en, { cellState: a({}, en.cellState || {}, (ut = {}, ut[Tt] = E(tt, Ct), ut)) }), Rt)) });
        }
      }
      function Fc(x) {
        var O = x.autoResetRowState, $ = O === void 0 || O, N = x.data, ne = x.dispatch, q = r.useCallback(function(Me, De) {
          return ne({ type: u.setRowState, rowId: Me, value: De });
        }, [ne]), ae = r.useCallback(function(Me, De, et) {
          return ne({ type: u.setCellState, rowId: Me, columnId: De, value: et });
        }, [ne]), Ee = S($);
        T(function() {
          Ee() && ne({ type: u.resetRowState });
        }, [N]), Object.assign(x, { setRowState: q, setCellState: ae });
      }
      function h1(x, O) {
        var $ = O.instance, N = $.initialRowStateAccessor, ne = N === void 0 ? Dc : N, q = $.initialCellStateAccessor, ae = q === void 0 ? jc : q, Ee = $.state.rowState;
        x && (x.state = Ee[x.id] !== void 0 ? Ee[x.id] : ne(x), x.setState = function(Me) {
          return $.setRowState(x.id, Me);
        }, x.cells.forEach(function(Me) {
          x.state.cellState || (x.state.cellState = {}), Me.state = x.state.cellState[Me.column.id] !== void 0 ? x.state.cellState[Me.column.id] : ae(Me), Me.setState = function(De) {
            return $.setCellState(x.id, Me.column.id, De);
          };
        }));
      }
      Aa.pluginName = "useRowState", u.resetColumnOrder = "resetColumnOrder", u.setColumnOrder = "setColumnOrder";
      var Vc = function(x) {
        x.stateReducers.push($c), x.visibleColumnsDeps.push(function(O, $) {
          var N = $.instance;
          return [].concat(O, [N.state.columnOrder]);
        }), x.visibleColumns.push(Lc), x.useInstance.push(v1);
      };
      function $c(x, O, $, N) {
        return O.type === u.init ? a({ columnOrder: [] }, x) : O.type === u.resetColumnOrder ? a({}, x, { columnOrder: N.initialState.columnOrder || [] }) : O.type === u.setColumnOrder ? a({}, x, { columnOrder: E(O.columnOrder, x.columnOrder) }) : void 0;
      }
      function Lc(x, O) {
        var $ = O.instance.state.columnOrder;
        if (!$ || !$.length) return x;
        for (var N = [].concat($), ne = [].concat(x), q = [], ae = function() {
          var Ee = N.shift(), Me = ne.findIndex(function(De) {
            return De.id === Ee;
          });
          Me > -1 && q.push(ne.splice(Me, 1)[0]);
        }; ne.length && N.length; ) ae();
        return [].concat(q, ne);
      }
      function v1(x) {
        var O = x.dispatch;
        x.setColumnOrder = r.useCallback(function($) {
          return O({ type: u.setColumnOrder, columnOrder: $ });
        }, [O]);
      }
      Vc.pluginName = "useColumnOrder", h.canResize = !0, u.columnStartResizing = "columnStartResizing", u.columnResizing = "columnResizing", u.columnDoneResizing = "columnDoneResizing", u.resetResize = "resetResize";
      var Ac = function(x) {
        x.getResizerProps = [y1], x.getHeaderProps.push({ style: { position: "relative" } }), x.stateReducers.push(b1), x.useInstance.push(x1), x.useInstanceBeforeDimensions.push(C1);
      }, y1 = function(x, O) {
        var $ = O.instance, N = O.header, ne = $.dispatch, q = function(ae, Ee) {
          var Me = !1;
          if (ae.type === "touchstart") {
            if (ae.touches && ae.touches.length > 1) return;
            Me = !0;
          }
          var De, et, Ye = function(Tt) {
            var tt = [];
            return function en(Ct) {
              Ct.columns && Ct.columns.length && Ct.columns.map(en), tt.push(Ct);
            }(Tt), tt;
          }(Ee).map(function(Tt) {
            return [Tt.id, Tt.totalWidth];
          }), Ze = Me ? Math.round(ae.touches[0].clientX) : ae.clientX, Be = function() {
            window.cancelAnimationFrame(De), De = null, ne({ type: u.columnDoneResizing });
          }, Ue = function() {
            window.cancelAnimationFrame(De), De = null, ne({ type: u.columnResizing, clientX: et });
          }, st = function(Tt) {
            et = Tt, De || (De = window.requestAnimationFrame(Ue));
          }, ut = { mouse: { moveEvent: "mousemove", moveHandler: function(Tt) {
            return st(Tt.clientX);
          }, upEvent: "mouseup", upHandler: function(Tt) {
            document.removeEventListener("mousemove", ut.mouse.moveHandler), document.removeEventListener("mouseup", ut.mouse.upHandler), Be();
          } }, touch: { moveEvent: "touchmove", moveHandler: function(Tt) {
            return Tt.cancelable && (Tt.preventDefault(), Tt.stopPropagation()), st(Tt.touches[0].clientX), !1;
          }, upEvent: "touchend", upHandler: function(Tt) {
            document.removeEventListener(ut.touch.moveEvent, ut.touch.moveHandler), document.removeEventListener(ut.touch.upEvent, ut.touch.moveHandler), Be();
          } } }, Rt = Me ? ut.touch : ut.mouse, rn = !!function() {
            if (typeof Y == "boolean") return Y;
            var Tt = !1;
            try {
              var tt = { get passive() {
                return Tt = !0, !1;
              } };
              window.addEventListener("test", null, tt), window.removeEventListener("test", null, tt);
            } catch {
              Tt = !1;
            }
            return Y = Tt;
          }() && { passive: !1 };
          document.addEventListener(Rt.moveEvent, Rt.moveHandler, rn), document.addEventListener(Rt.upEvent, Rt.upHandler, rn), ne({ type: u.columnStartResizing, columnId: Ee.id, columnWidth: Ee.totalWidth, headerIdWidths: Ye, clientX: Ze });
        };
        return [x, { onMouseDown: function(ae) {
          return ae.persist() || q(ae, N);
        }, onTouchStart: function(ae) {
          return ae.persist() || q(ae, N);
        }, style: { cursor: "col-resize" }, draggable: !1, role: "separator" }];
      };
      function b1(x, O) {
        if (O.type === u.init) return a({ columnResizing: { columnWidths: {} } }, x);
        if (O.type === u.resetResize) return a({}, x, { columnResizing: { columnWidths: {} } });
        if (O.type === u.columnStartResizing) {
          var $ = O.clientX, N = O.columnId, ne = O.columnWidth, q = O.headerIdWidths;
          return a({}, x, { columnResizing: a({}, x.columnResizing, { startX: $, headerIdWidths: q, columnWidth: ne, isResizingColumn: N }) });
        }
        if (O.type === u.columnResizing) {
          var ae = O.clientX, Ee = x.columnResizing, Me = Ee.startX, De = Ee.columnWidth, et = Ee.headerIdWidths, Ye = (ae - Me) / De, Ze = {};
          return (et === void 0 ? [] : et).forEach(function(Be) {
            var Ue = Be[0], st = Be[1];
            Ze[Ue] = Math.max(st + st * Ye, 0);
          }), a({}, x, { columnResizing: a({}, x.columnResizing, { columnWidths: a({}, x.columnResizing.columnWidths, {}, Ze) }) });
        }
        return O.type === u.columnDoneResizing ? a({}, x, { columnResizing: a({}, x.columnResizing, { startX: null, isResizingColumn: null }) }) : void 0;
      }
      Ac.pluginName = "useResizeColumns";
      var C1 = function(x) {
        var O = x.flatHeaders, $ = x.disableResizing, N = x.getHooks, ne = x.state.columnResizing, q = S(x);
        O.forEach(function(ae) {
          var Ee = z(ae.disableResizing !== !0 && void 0, $ !== !0 && void 0, !0);
          ae.canResize = Ee, ae.width = ne.columnWidths[ae.id] || ae.originalWidth || ae.width, ae.isResizing = ne.isResizingColumn === ae.id, Ee && (ae.getResizerProps = v(N().getResizerProps, { instance: q(), header: ae }));
        });
      };
      function x1(x) {
        var O = x.plugins, $ = x.dispatch, N = x.autoResetResize, ne = N === void 0 || N, q = x.columns;
        C(O, ["useAbsoluteLayout"], "useResizeColumns");
        var ae = S(ne);
        T(function() {
          ae() && $({ type: u.resetResize });
        }, [q]);
        var Ee = r.useCallback(function() {
          return $({ type: u.resetResize });
        }, [$]);
        Object.assign(x, { resetResizing: Ee });
      }
      var Na = { position: "absolute", top: 0 }, Nc = function(x) {
        x.getTableBodyProps.push(Us), x.getRowProps.push(Us), x.getHeaderGroupProps.push(Us), x.getFooterGroupProps.push(Us), x.getHeaderProps.push(function(O, $) {
          var N = $.column;
          return [O, { style: a({}, Na, { left: N.totalLeft + "px", width: N.totalWidth + "px" }) }];
        }), x.getCellProps.push(function(O, $) {
          var N = $.cell;
          return [O, { style: a({}, Na, { left: N.column.totalLeft + "px", width: N.column.totalWidth + "px" }) }];
        }), x.getFooterProps.push(function(O, $) {
          var N = $.column;
          return [O, { style: a({}, Na, { left: N.totalLeft + "px", width: N.totalWidth + "px" }) }];
        });
      };
      Nc.pluginName = "useAbsoluteLayout";
      var Us = function(x, O) {
        return [x, { style: { position: "relative", width: O.instance.totalColumnsWidth + "px" } }];
      }, Ba = { display: "inline-block", boxSizing: "border-box" }, _a = function(x, O) {
        return [x, { style: { display: "flex", width: O.instance.totalColumnsWidth + "px" } }];
      }, Bc = function(x) {
        x.getRowProps.push(_a), x.getHeaderGroupProps.push(_a), x.getFooterGroupProps.push(_a), x.getHeaderProps.push(function(O, $) {
          var N = $.column;
          return [O, { style: a({}, Ba, { width: N.totalWidth + "px" }) }];
        }), x.getCellProps.push(function(O, $) {
          var N = $.cell;
          return [O, { style: a({}, Ba, { width: N.column.totalWidth + "px" }) }];
        }), x.getFooterProps.push(function(O, $) {
          var N = $.column;
          return [O, { style: a({}, Ba, { width: N.totalWidth + "px" }) }];
        });
      };
      function za(x) {
        x.getTableProps.push(w1), x.getRowProps.push(Ha), x.getHeaderGroupProps.push(Ha), x.getFooterGroupProps.push(Ha), x.getHeaderProps.push(S1), x.getCellProps.push(E1), x.getFooterProps.push(R1);
      }
      Bc.pluginName = "useBlockLayout", za.pluginName = "useFlexLayout";
      var w1 = function(x, O) {
        return [x, { style: { minWidth: O.instance.totalColumnsMinWidth + "px" } }];
      }, Ha = function(x, O) {
        return [x, { style: { display: "flex", flex: "1 0 auto", minWidth: O.instance.totalColumnsMinWidth + "px" } }];
      }, S1 = function(x, O) {
        var $ = O.column;
        return [x, { style: { boxSizing: "border-box", flex: $.totalFlexWidth ? $.totalFlexWidth + " 0 auto" : void 0, minWidth: $.totalMinWidth + "px", width: $.totalWidth + "px" } }];
      }, E1 = function(x, O) {
        var $ = O.cell;
        return [x, { style: { boxSizing: "border-box", flex: $.column.totalFlexWidth + " 0 auto", minWidth: $.column.totalMinWidth + "px", width: $.column.totalWidth + "px" } }];
      }, R1 = function(x, O) {
        var $ = O.column;
        return [x, { style: { boxSizing: "border-box", flex: $.totalFlexWidth ? $.totalFlexWidth + " 0 auto" : void 0, minWidth: $.totalMinWidth + "px", width: $.totalWidth + "px" } }];
      };
      function _c(x) {
        x.stateReducers.push(Gc), x.getTableProps.push(zc), x.getHeaderProps.push(Hc), x.getRowProps.push(Wc);
      }
      u.columnStartResizing = "columnStartResizing", u.columnResizing = "columnResizing", u.columnDoneResizing = "columnDoneResizing", u.resetResize = "resetResize", _c.pluginName = "useGridLayout";
      var zc = function(x, O) {
        var $ = O.instance;
        return [x, { style: { display: "grid", gridTemplateColumns: $.visibleColumns.map(function(N) {
          var ne;
          return $.state.gridLayout.columnWidths[N.id] ? $.state.gridLayout.columnWidths[N.id] + "px" : (ne = $.state.columnResizing) != null && ne.isResizingColumn ? $.state.gridLayout.startWidths[N.id] + "px" : typeof N.width == "number" ? N.width + "px" : N.width;
        }).join(" ") } }];
      }, Hc = function(x, O) {
        var $ = O.column;
        return [x, { id: "header-cell-" + $.id, style: { position: "sticky", gridColumn: "span " + $.totalVisibleHeaderCount } }];
      }, Wc = function(x, O) {
        var $ = O.row;
        return $.isExpanded ? [x, { style: { gridColumn: "1 / " + ($.cells.length + 1) } }] : [x, {}];
      };
      function Gc(x, O, $, N) {
        if (O.type === u.init) return a({ gridLayout: { columnWidths: {} } }, x);
        if (O.type === u.resetResize) return a({}, x, { gridLayout: { columnWidths: {} } });
        if (O.type === u.columnStartResizing) {
          var ne = O.columnId, q = O.headerIdWidths, ae = Wa(ne);
          if (ae !== void 0) {
            var Ee = N.visibleColumns.reduce(function(tt, en) {
              var Ct;
              return a({}, tt, ((Ct = {})[en.id] = Wa(en.id), Ct));
            }, {}), Me = N.visibleColumns.reduce(function(tt, en) {
              var Ct;
              return a({}, tt, ((Ct = {})[en.id] = en.minWidth, Ct));
            }, {}), De = N.visibleColumns.reduce(function(tt, en) {
              var Ct;
              return a({}, tt, ((Ct = {})[en.id] = en.maxWidth, Ct));
            }, {}), et = q.map(function(tt) {
              var en = tt[0];
              return [en, Wa(en)];
            });
            return a({}, x, { gridLayout: a({}, x.gridLayout, { startWidths: Ee, minWidths: Me, maxWidths: De, headerIdGridWidths: et, columnWidth: ae }) });
          }
          return x;
        }
        if (O.type === u.columnResizing) {
          var Ye = O.clientX, Ze = x.columnResizing.startX, Be = x.gridLayout, Ue = Be.columnWidth, st = Be.minWidths, ut = Be.maxWidths, Rt = Be.headerIdGridWidths, rn = (Ye - Ze) / Ue, Tt = {};
          return (Rt === void 0 ? [] : Rt).forEach(function(tt) {
            var en = tt[0], Ct = tt[1];
            Tt[en] = Math.min(Math.max(st[en], Ct + Ct * rn), ut[en]);
          }), a({}, x, { gridLayout: a({}, x.gridLayout, { columnWidths: a({}, x.gridLayout.columnWidths, {}, Tt) }) });
        }
        return O.type === u.columnDoneResizing ? a({}, x, { gridLayout: a({}, x.gridLayout, { startWidths: {}, minWidths: {}, maxWidths: {} }) }) : void 0;
      }
      function Wa(x) {
        var O, $ = (O = document.getElementById("header-cell-" + x)) == null ? void 0 : O.offsetWidth;
        if ($ !== void 0) return $;
      }
      n._UNSTABLE_usePivotColumns = Lo, n.actions = u, n.defaultColumn = h, n.defaultGroupByFn = Le, n.defaultOrderByFn = ds, n.defaultRenderer = f, n.emptyRenderer = g, n.ensurePluginOrder = C, n.flexRender = F, n.functionalUpdate = E, n.loopHooks = b, n.makePropGetter = v, n.makeRenderer = P, n.reduceHooks = m, n.safeUseLayoutEffect = k, n.useAbsoluteLayout = Nc, n.useAsyncDebounce = function(x, O) {
        O === void 0 && (O = 0);
        var $ = r.useRef({}), N = S(x), ne = S(O);
        return r.useCallback(function() {
          var q = s(regeneratorRuntime.mark(function ae() {
            var Ee, Me, De, et = arguments;
            return regeneratorRuntime.wrap(function(Ye) {
              for (; ; ) switch (Ye.prev = Ye.next) {
                case 0:
                  for (Ee = et.length, Me = new Array(Ee), De = 0; De < Ee; De++) Me[De] = et[De];
                  return $.current.promise || ($.current.promise = new Promise(function(Ze, Be) {
                    $.current.resolve = Ze, $.current.reject = Be;
                  })), $.current.timeout && clearTimeout($.current.timeout), $.current.timeout = setTimeout(s(regeneratorRuntime.mark(function Ze() {
                    return regeneratorRuntime.wrap(function(Be) {
                      for (; ; ) switch (Be.prev = Be.next) {
                        case 0:
                          return delete $.current.timeout, Be.prev = 1, Be.t0 = $.current, Be.next = 5, N().apply(void 0, Me);
                        case 5:
                          Be.t1 = Be.sent, Be.t0.resolve.call(Be.t0, Be.t1), Be.next = 12;
                          break;
                        case 9:
                          Be.prev = 9, Be.t2 = Be.catch(1), $.current.reject(Be.t2);
                        case 12:
                          return Be.prev = 12, delete $.current.promise, Be.finish(12);
                        case 15:
                        case "end":
                          return Be.stop();
                      }
                    }, Ze, null, [[1, 9, 12, 15]]);
                  })), ne()), Ye.abrupt("return", $.current.promise);
                case 5:
                case "end":
                  return Ye.stop();
              }
            }, ae);
          }));
          return function() {
            return q.apply(this, arguments);
          };
        }(), [N, ne]);
      }, n.useBlockLayout = Bc, n.useColumnOrder = Vc, n.useExpanded = Ge, n.useFilters = Un, n.useFlexLayout = za, n.useGetLatest = S, n.useGlobalFilter = Yn, n.useGridLayout = _c, n.useGroupBy = In, n.useMountedLayoutEffect = T, n.usePagination = Hr, n.useResizeColumns = Ac, n.useRowSelect = Pc, n.useRowState = Aa, n.useSortBy = Qn, n.useTable = function(x) {
        for (var O = arguments.length, $ = new Array(O > 1 ? O - 1 : 0), N = 1; N < O; N++) $[N - 1] = arguments[N];
        x = ke(x), $ = [se].concat($);
        var ne = r.useRef({}), q = S(ne.current);
        Object.assign(q(), a({}, x, { plugins: $, hooks: J() })), $.filter(Boolean).forEach(function(_) {
          _(q().hooks);
        });
        var ae = S(q().hooks);
        q().getHooks = ae, delete q().hooks, Object.assign(q(), m(ae().useOptions, ke(x)));
        var Ee = q(), Me = Ee.data, De = Ee.columns, et = Ee.initialState, Ye = Ee.defaultColumn, Ze = Ee.getSubRows, Be = Ee.getRowId, Ue = Ee.stateReducer, st = Ee.useControlledState, ut = S(Ue), Rt = r.useCallback(function(_, le) {
          if (!le.type) throw console.info({ action: le }), new Error("Unknown Action 👆");
          return [].concat(ae().stateReducers, Array.isArray(ut()) ? ut() : [ut()]).reduce(function(he, Re) {
            return Re(he, le, _, q()) || he;
          }, _);
        }, [ae, ut, q]), rn = r.useReducer(Rt, void 0, function() {
          return Rt(et, { type: u.init });
        }), Tt = rn[0], tt = rn[1], en = m([].concat(ae().useControlledState, [st]), Tt, { instance: q() });
        Object.assign(q(), { state: en, dispatch: tt });
        var Ct = r.useMemo(function() {
          return j(m(ae().columns, De, { instance: q() }));
        }, [ae, q, De].concat(m(ae().columnsDeps, [], { instance: q() })));
        q().columns = Ct;
        var qt = r.useMemo(function() {
          return m(ae().allColumns, L(Ct), { instance: q() }).map(R);
        }, [Ct, ae, q].concat(m(ae().allColumnsDeps, [], { instance: q() })));
        q().allColumns = qt;
        var fn = r.useMemo(function() {
          for (var _ = [], le = [], he = {}, Re = [].concat(qt); Re.length; ) {
            var $e = Re.shift();
            We({ data: Me, rows: _, flatRows: le, rowsById: he, column: $e, getRowId: Be, getSubRows: Ze, accessValueHooks: ae().accessValue, getInstance: q });
          }
          return [_, le, he];
        }, [qt, Me, Be, Ze, ae, q]), _t = fn[0], Ut = fn[1], En = fn[2];
        Object.assign(q(), { rows: _t, initialRows: [].concat(_t), flatRows: Ut, rowsById: En }), b(ae().useInstanceAfterData, q());
        var Jt = r.useMemo(function() {
          return m(ae().visibleColumns, qt, { instance: q() }).map(function(_) {
            return V(_, Ye);
          });
        }, [ae, qt, q, Ye].concat(m(ae().visibleColumnsDeps, [], { instance: q() })));
        qt = r.useMemo(function() {
          var _ = [].concat(Jt);
          return qt.forEach(function(le) {
            _.find(function(he) {
              return he.id === le.id;
            }) || _.push(le);
          }), _;
        }, [qt, Jt]), q().allColumns = qt;
        var bn = r.useMemo(function() {
          return m(ae().headerGroups, B(Jt, Ye), q());
        }, [ae, Jt, Ye, q].concat(m(ae().headerGroupsDeps, [], { instance: q() })));
        q().headerGroups = bn;
        var w = r.useMemo(function() {
          return bn.length ? bn[0].headers : [];
        }, [bn]);
        q().headers = w, q().flatHeaders = bn.reduce(function(_, le) {
          return [].concat(_, le.headers);
        }, []), b(ae().useInstanceBeforeDimensions, q());
        var M = Jt.filter(function(_) {
          return _.isVisible;
        }).map(function(_) {
          return _.id;
        }).sort().join("_");
        Jt = r.useMemo(function() {
          return Jt.filter(function(_) {
            return _.isVisible;
          });
        }, [Jt, M]), q().visibleColumns = Jt;
        var D = Ne(w), I = D[0], U = D[1], X = D[2];
        return q().totalColumnsMinWidth = I, q().totalColumnsWidth = U, q().totalColumnsMaxWidth = X, b(ae().useInstance, q()), [].concat(q().flatHeaders, q().allColumns).forEach(function(_) {
          _.render = P(q(), _), _.getHeaderProps = v(ae().getHeaderProps, { instance: q(), column: _ }), _.getFooterProps = v(ae().getFooterProps, { instance: q(), column: _ });
        }), q().headerGroups = r.useMemo(function() {
          return bn.filter(function(_, le) {
            return _.headers = _.headers.filter(function(he) {
              return he.headers ? function Re($e) {
                return $e.filter(function(nt) {
                  return nt.headers ? Re(nt.headers) : nt.isVisible;
                }).length;
              }(he.headers) : he.isVisible;
            }), !!_.headers.length && (_.getHeaderGroupProps = v(ae().getHeaderGroupProps, { instance: q(), headerGroup: _, index: le }), _.getFooterGroupProps = v(ae().getFooterGroupProps, { instance: q(), headerGroup: _, index: le }), !0);
          });
        }, [bn, q, ae]), q().footerGroups = [].concat(q().headerGroups).reverse(), q().prepareRow = r.useCallback(function(_) {
          _.getRowProps = v(ae().getRowProps, { instance: q(), row: _ }), _.allCells = qt.map(function(le) {
            var he = _.values[le.id], Re = { column: le, row: _, value: he };
            return Re.getCellProps = v(ae().getCellProps, { instance: q(), cell: Re }), Re.render = P(q(), le, { row: _, cell: Re, value: he }), Re;
          }), _.cells = Jt.map(function(le) {
            return _.allCells.find(function(he) {
              return he.column.id === le.id;
            });
          }), b(ae().prepareRow, _, { instance: q() });
        }, [ae, q, qt, Jt]), q().getTableProps = v(ae().getTableProps, { instance: q() }), q().getTableBodyProps = v(ae().getTableBodyProps, { instance: q() }), b(ae().useFinalInstance, q()), q();
      }, Object.defineProperty(n, "__esModule", { value: !0 });
    });
  }(fu, fu.exports)), fu.exports;
}
var gu = { exports: {} }, b5;
function tF() {
  return b5 || (b5 = 1, function(e, t) {
    (function(n, r) {
      r(t, He);
    })(q5, function(n, r) {
      r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
      function i(w, M, D, I, U, X, _) {
        try {
          var le = w[X](_), he = le.value;
        } catch (Re) {
          D(Re);
          return;
        }
        le.done ? M(he) : Promise.resolve(he).then(I, U);
      }
      function s(w) {
        return function() {
          var M = this, D = arguments;
          return new Promise(function(I, U) {
            var X = w.apply(M, D);
            function _(he) {
              i(X, I, U, _, le, "next", he);
            }
            function le(he) {
              i(X, I, U, _, le, "throw", he);
            }
            _(void 0);
          });
        };
      }
      function a() {
        return a = Object.assign || function(w) {
          for (var M = 1; M < arguments.length; M++) {
            var D = arguments[M];
            for (var I in D)
              Object.prototype.hasOwnProperty.call(D, I) && (w[I] = D[I]);
          }
          return w;
        }, a.apply(this, arguments);
      }
      function l(w, M) {
        if (w == null) return {};
        var D = {}, I = Object.keys(w), U, X;
        for (X = 0; X < I.length; X++)
          U = I[X], !(M.indexOf(U) >= 0) && (D[U] = w[U]);
        return D;
      }
      function c(w, M) {
        if (typeof w != "object" || w === null) return w;
        var D = w[Symbol.toPrimitive];
        if (D !== void 0) {
          var I = D.call(w, M);
          if (typeof I != "object") return I;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(w);
      }
      function u(w) {
        var M = c(w, "string");
        return typeof M == "symbol" ? M : String(M);
      }
      var f = "Renderer Error ☝️", g = {
        init: "init"
      }, h = function(M) {
        var D = M.value, I = D === void 0 ? "" : D;
        return I;
      }, y = function() {
        return r.createElement(r.Fragment, null, " ");
      }, v = {
        Cell: h,
        width: 150,
        minWidth: 0,
        maxWidth: Number.MAX_SAFE_INTEGER
      };
      function m() {
        for (var w = arguments.length, M = new Array(w), D = 0; D < w; D++)
          M[D] = arguments[D];
        return M.reduce(function(I, U) {
          var X = U.style, _ = U.className, le = l(U, ["style", "className"]);
          return I = a({}, I, {}, le), X && (I.style = I.style ? a({}, I.style || {}, {}, X || {}) : X), _ && (I.className = I.className ? I.className + " " + _ : _), I.className === "" && delete I.className, I;
        }, {});
      }
      function b(w, M, D) {
        return typeof M == "function" ? b({}, M(w, D)) : Array.isArray(M) ? m.apply(void 0, [w].concat(M)) : m(w, M);
      }
      var C = function(M, D) {
        return D === void 0 && (D = {}), function(I) {
          return I === void 0 && (I = {}), [].concat(M, [I]).reduce(function(U, X) {
            return b(U, X, a({}, D, {
              userProps: I
            }));
          }, {});
        };
      }, E = function(M, D, I, U) {
        return I === void 0 && (I = {}), M.reduce(function(X, _) {
          var le = _(X, I);
          if (!U && typeof le > "u")
            throw console.info(_), new Error("React Table: A reducer hook ☝️ just returned undefined! This is not allowed.");
          return le;
        }, D);
      }, S = function(M, D, I) {
        return I === void 0 && (I = {}), M.forEach(function(U) {
          var X = U(D, I);
          if (typeof X < "u")
            throw console.info(U, X), new Error("React Table: A loop-type hook ☝️ just returned a value! This is not allowed.");
        });
      };
      function k(w, M, D, I) {
        if (I)
          throw new Error('Defining plugins in the "after" section of ensurePluginOrder is no longer supported (see plugin ' + D + ")");
        var U = w.findIndex(function(X) {
          return X.pluginName === D;
        });
        if (U === -1)
          throw new Error('The plugin "' + D + `" was not found in the plugin list!
This usually means you need to need to name your plugin hook by setting the 'pluginName' property of the hook function, eg:

  ` + D + ".pluginName = '" + D + `'
`);
        M.forEach(function(X) {
          var _ = w.findIndex(function(le) {
            return le.pluginName === X;
          });
          if (_ > -1 && _ > U)
            throw new Error("React Table: The " + D + " plugin hook must be placed after the " + X + " plugin hook!");
        });
      }
      function T(w, M) {
        return typeof w == "function" ? w(M) : w;
      }
      function P(w) {
        var M = r.useRef();
        return M.current = w, r.useCallback(function() {
          return M.current;
        }, []);
      }
      var F = typeof document < "u" ? r.useLayoutEffect : r.useEffect;
      function j(w, M) {
        var D = r.useRef(!1);
        F(function() {
          D.current && w(), D.current = !0;
        }, M);
      }
      function L(w, M) {
        M === void 0 && (M = 0);
        var D = r.useRef({}), I = P(w), U = P(M);
        return r.useCallback(
          /* @__PURE__ */ function() {
            var X = s(
              /* @__PURE__ */ regeneratorRuntime.mark(function _() {
                var le, he, Re, $e = arguments;
                return regeneratorRuntime.wrap(function(ze) {
                  for (; ; )
                    switch (ze.prev = ze.next) {
                      case 0:
                        for (le = $e.length, he = new Array(le), Re = 0; Re < le; Re++)
                          he[Re] = $e[Re];
                        return D.current.promise || (D.current.promise = new Promise(function(Xe, rt) {
                          D.current.resolve = Xe, D.current.reject = rt;
                        })), D.current.timeout && clearTimeout(D.current.timeout), D.current.timeout = setTimeout(
                          /* @__PURE__ */ s(
                            /* @__PURE__ */ regeneratorRuntime.mark(function Xe() {
                              return regeneratorRuntime.wrap(function(_e) {
                                for (; ; )
                                  switch (_e.prev = _e.next) {
                                    case 0:
                                      return delete D.current.timeout, _e.prev = 1, _e.t0 = D.current, _e.next = 5, I().apply(void 0, he);
                                    case 5:
                                      _e.t1 = _e.sent, _e.t0.resolve.call(_e.t0, _e.t1), _e.next = 12;
                                      break;
                                    case 9:
                                      _e.prev = 9, _e.t2 = _e.catch(1), D.current.reject(_e.t2);
                                    case 12:
                                      return _e.prev = 12, delete D.current.promise, _e.finish(12);
                                    case 15:
                                    case "end":
                                      return _e.stop();
                                  }
                              }, Xe, null, [[1, 9, 12, 15]]);
                            })
                          ),
                          U()
                        ), ze.abrupt("return", D.current.promise);
                      case 5:
                      case "end":
                        return ze.stop();
                    }
                }, _);
              })
            );
            return function() {
              return X.apply(this, arguments);
            };
          }(),
          [I, U]
        );
      }
      function R(w, M, D) {
        return D === void 0 && (D = {}), function(I, U) {
          U === void 0 && (U = {});
          var X = typeof I == "string" ? M[I] : I;
          if (typeof X > "u")
            throw console.info(M), new Error(f);
          return V(X, a({}, w, {
            column: M
          }, D, {}, U));
        };
      }
      function V(w, M) {
        return B(w) ? r.createElement(w, M) : w;
      }
      function B(w) {
        return W(w) || typeof w == "function" || z(w);
      }
      function W(w) {
        return typeof w == "function" && function() {
          var M = Object.getPrototypeOf(w);
          return M.prototype && M.prototype.isReactComponent;
        }();
      }
      function z(w) {
        return typeof w == "object" && typeof w.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(w.$$typeof.description);
      }
      function G(w, M, D) {
        return D === void 0 && (D = 0), w.map(function(I) {
          return I = a({}, I, {
            parent: M,
            depth: D
          }), ie(I), I.columns && (I.columns = G(I.columns, I, D + 1)), I;
        });
      }
      function H(w) {
        return fe(w, "columns");
      }
      function ie(w) {
        var M = w.id, D = w.accessor, I = w.Header;
        if (typeof D == "string") {
          M = M || D;
          var U = D.split(".");
          D = function(_) {
            return Y(_, U);
          };
        }
        if (!M && typeof I == "string" && I && (M = I), !M && w.columns)
          throw console.error(w), new Error('A column ID (or unique "Header" value) is required!');
        if (!M)
          throw console.error(w), new Error("A column ID (or string accessor) is required!");
        return Object.assign(w, {
          id: M,
          accessor: D
        }), w;
      }
      function ce(w, M) {
        if (!M)
          throw new Error();
        return Object.assign(w, a({
          // Make sure there is a fallback header, just in case
          Header: y,
          Footer: y
        }, v, {}, M, {}, w)), Object.assign(w, {
          originalWidth: w.width
        }), w;
      }
      function re(w, M, D) {
        D === void 0 && (D = function() {
          return {};
        });
        for (var I = [], U = w, X = 0, _ = function() {
          return X++;
        }, le = function() {
          var Re = {
            headers: []
          }, $e = [], nt = U.some(function(ze) {
            return ze.parent;
          });
          U.forEach(function(ze) {
            var Xe = [].concat($e).reverse()[0], rt;
            if (nt) {
              if (ze.parent)
                rt = a({}, ze.parent, {
                  originalId: ze.parent.id,
                  id: ze.parent.id + "_" + _(),
                  headers: [ze]
                }, D(ze));
              else {
                var _e = ze.id + "_placeholder";
                rt = ce(a({
                  originalId: _e,
                  id: ze.id + "_placeholder_" + _(),
                  placeholderOf: ze,
                  headers: [ze]
                }, D(ze)), M);
              }
              Xe && Xe.originalId === rt.originalId ? Xe.headers.push(ze) : $e.push(rt);
            }
            Re.headers.push(ze);
          }), I.push(Re), U = $e;
        }; U.length; )
          le();
        return I.reverse();
      }
      var A = /* @__PURE__ */ new Map();
      function Y(w, M, D) {
        if (!M)
          return w;
        var I = typeof M == "function" ? M : JSON.stringify(M), U = A.get(I) || function() {
          var _ = se(M);
          return A.set(I, _), _;
        }(), X;
        try {
          X = U.reduce(function(_, le) {
            return _[le];
          }, w);
        } catch {
        }
        return typeof X < "u" ? X : D;
      }
      function pe() {
        for (var w = arguments.length, M = new Array(w), D = 0; D < w; D++)
          M[D] = arguments[D];
        for (var I = 0; I < M.length; I += 1)
          if (typeof M[I] < "u")
            return M[I];
      }
      function Ce(w) {
        if (typeof w == "function")
          return w;
      }
      function fe(w, M) {
        var D = [], I = function U(X) {
          X.forEach(function(_) {
            _[M] ? U(_[M]) : D.push(_);
          });
        };
        return I(w), D;
      }
      function ee(w, M) {
        var D = M.manualExpandedKey, I = M.expanded, U = M.expandSubRows, X = U === void 0 ? !0 : U, _ = [], le = function he(Re, $e) {
          $e === void 0 && ($e = !0), Re.isExpanded = Re.original && Re.original[D] || I[Re.id], Re.canExpand = Re.subRows && !!Re.subRows.length, $e && _.push(Re), Re.subRows && Re.subRows.length && Re.isExpanded && Re.subRows.forEach(function(nt) {
            return he(nt, X);
          });
        };
        return w.forEach(function(he) {
          return le(he);
        }), _;
      }
      function te(w, M, D) {
        return Ce(w) || M[w] || D[w] || D.text;
      }
      function ue(w, M, D) {
        return w ? w(M, D) : typeof M > "u";
      }
      function K() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
      }
      var oe = null;
      function de() {
        if (typeof oe == "boolean") return oe;
        var w = !1;
        try {
          var M = {
            get passive() {
              return w = !0, !1;
            }
          };
          window.addEventListener("test", null, M), window.removeEventListener("test", null, M);
        } catch {
          w = !1;
        }
        return oe = w, oe;
      }
      var ve = /\[/g, J = /\]/g;
      function se(w) {
        return ge(w).map(function(M) {
          return String(M).replace(".", "_");
        }).join(".").replace(ve, ".").replace(J, "").split(".");
      }
      function ge(w, M) {
        if (M === void 0 && (M = []), !Array.isArray(w))
          M.push(w);
        else
          for (var D = 0; D < w.length; D += 1)
            ge(w[D], M);
        return M;
      }
      var Se = function(M) {
        return a({
          role: "table"
        }, M);
      }, we = function(M) {
        return a({
          role: "rowgroup"
        }, M);
      }, me = function(M, D) {
        var I = D.column;
        return a({
          key: "header_" + I.id,
          colSpan: I.totalVisibleHeaderCount,
          role: "columnheader"
        }, M);
      }, ye = function(M, D) {
        var I = D.column;
        return a({
          key: "footer_" + I.id,
          colSpan: I.totalVisibleHeaderCount
        }, M);
      }, Ie = function(M, D) {
        var I = D.index;
        return a({
          key: "headerGroup_" + I,
          role: "row"
        }, M);
      }, je = function(M, D) {
        var I = D.index;
        return a({
          key: "footerGroup_" + I
        }, M);
      }, Te = function(M, D) {
        var I = D.row;
        return a({
          key: "row_" + I.id,
          role: "row"
        }, M);
      }, Fe = function(M, D) {
        var I = D.cell;
        return a({
          key: "cell_" + I.row.id + "_" + I.column.id,
          role: "cell"
        }, M);
      };
      function gt() {
        return {
          useOptions: [],
          stateReducers: [],
          useControlledState: [],
          columns: [],
          columnsDeps: [],
          allColumns: [],
          allColumnsDeps: [],
          accessValue: [],
          materializedColumns: [],
          materializedColumnsDeps: [],
          useInstanceAfterData: [],
          visibleColumns: [],
          visibleColumnsDeps: [],
          headerGroups: [],
          headerGroupsDeps: [],
          useInstanceBeforeDimensions: [],
          useInstance: [],
          prepareRow: [],
          getTableProps: [Se],
          getTableBodyProps: [we],
          getHeaderGroupProps: [Ie],
          getFooterGroupProps: [je],
          getHeaderProps: [me],
          getFooterProps: [ye],
          getRowProps: [Te],
          getCellProps: [Fe],
          useFinalInstance: []
        };
      }
      g.resetHiddenColumns = "resetHiddenColumns", g.toggleHideColumn = "toggleHideColumn", g.setHiddenColumns = "setHiddenColumns", g.toggleHideAllColumns = "toggleHideAllColumns";
      var Dt = function(M) {
        M.getToggleHiddenProps = [ke], M.getToggleHideAllColumnsProps = [Ne], M.stateReducers.push(We), M.useInstanceBeforeDimensions.push(Ge), M.headerGroupsDeps.push(function(D, I) {
          var U = I.instance;
          return [].concat(D, [U.state.hiddenColumns]);
        }), M.useInstance.push(Qe);
      };
      Dt.pluginName = "useColumnVisibility";
      var ke = function(M, D) {
        var I = D.column;
        return [M, {
          onChange: function(X) {
            I.toggleHidden(!X.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: I.isVisible,
          title: "Toggle Column Visible"
        }];
      }, Ne = function(M, D) {
        var I = D.instance;
        return [M, {
          onChange: function(X) {
            I.toggleHideAllColumns(!X.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: !I.allColumnsHidden && !I.state.hiddenColumns.length,
          title: "Toggle All Columns Hidden",
          indeterminate: !I.allColumnsHidden && I.state.hiddenColumns.length
        }];
      };
      function We(w, M, D, I) {
        if (M.type === g.init)
          return a({
            hiddenColumns: []
          }, w);
        if (M.type === g.resetHiddenColumns)
          return a({}, w, {
            hiddenColumns: I.initialState.hiddenColumns || []
          });
        if (M.type === g.toggleHideColumn) {
          var U = typeof M.value < "u" ? M.value : !w.hiddenColumns.includes(M.columnId), X = U ? [].concat(w.hiddenColumns, [M.columnId]) : w.hiddenColumns.filter(function(le) {
            return le !== M.columnId;
          });
          return a({}, w, {
            hiddenColumns: X
          });
        }
        if (M.type === g.setHiddenColumns)
          return a({}, w, {
            hiddenColumns: T(M.value, w.hiddenColumns)
          });
        if (M.type === g.toggleHideAllColumns) {
          var _ = typeof M.value < "u" ? M.value : !w.hiddenColumns.length;
          return a({}, w, {
            hiddenColumns: _ ? I.allColumns.map(function(le) {
              return le.id;
            }) : []
          });
        }
      }
      function Ge(w) {
        var M = w.headers, D = w.state.hiddenColumns, I = r.useRef(!1);
        I.current;
        var U = function _(le, he) {
          le.isVisible = he && !D.includes(le.id);
          var Re = 0;
          return le.headers && le.headers.length ? le.headers.forEach(function($e) {
            return Re += _($e, le.isVisible);
          }) : Re = le.isVisible ? 1 : 0, le.totalVisibleHeaderCount = Re, Re;
        }, X = 0;
        M.forEach(function(_) {
          return X += U(_, !0);
        });
      }
      function Qe(w) {
        var M = w.columns, D = w.flatHeaders, I = w.dispatch, U = w.allColumns, X = w.getHooks, _ = w.state.hiddenColumns, le = w.autoResetHiddenColumns, he = le === void 0 ? !0 : le, Re = P(w), $e = U.length === _.length, nt = r.useCallback(function(ht, It) {
          return I({
            type: g.toggleHideColumn,
            columnId: ht,
            value: It
          });
        }, [I]), ze = r.useCallback(function(ht) {
          return I({
            type: g.setHiddenColumns,
            value: ht
          });
        }, [I]), Xe = r.useCallback(function(ht) {
          return I({
            type: g.toggleHideAllColumns,
            value: ht
          });
        }, [I]), rt = C(X().getToggleHideAllColumnsProps, {
          instance: Re()
        });
        D.forEach(function(ht) {
          ht.toggleHidden = function(It) {
            I({
              type: g.toggleHideColumn,
              columnId: ht.id,
              value: It
            });
          }, ht.getToggleHiddenProps = C(X().getToggleHiddenProps, {
            instance: Re(),
            column: ht
          });
        });
        var _e = P(he);
        j(function() {
          _e() && I({
            type: g.resetHiddenColumns
          });
        }, [I, M]), Object.assign(w, {
          allColumnsHidden: $e,
          toggleHideColumn: nt,
          setHiddenColumns: ze,
          toggleHideAllColumns: Xe,
          getToggleHideAllColumnsProps: rt
        });
      }
      var Ve = {}, Ke = {}, bt = function(M, D, I) {
        return M;
      }, vt = function(M, D) {
        return M.subRows || [];
      }, tn = function(M, D, I) {
        return "" + (I ? [I.id, D].join(".") : D);
      }, hn = function(M) {
        return M;
      };
      function Je(w) {
        var M = w.initialState, D = M === void 0 ? Ve : M, I = w.defaultColumn, U = I === void 0 ? Ke : I, X = w.getSubRows, _ = X === void 0 ? vt : X, le = w.getRowId, he = le === void 0 ? tn : le, Re = w.stateReducer, $e = Re === void 0 ? bt : Re, nt = w.useControlledState, ze = nt === void 0 ? hn : nt, Xe = l(w, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]);
        return a({}, Xe, {
          initialState: D,
          defaultColumn: U,
          getSubRows: _,
          getRowId: he,
          stateReducer: $e,
          useControlledState: ze
        });
      }
      var $t = function(M) {
        for (var D = arguments.length, I = new Array(D > 1 ? D - 1 : 0), U = 1; U < D; U++)
          I[U - 1] = arguments[U];
        M = Je(M), I = [Dt].concat(I);
        var X = r.useRef({}), _ = P(X.current);
        Object.assign(_(), a({}, M, {
          plugins: I,
          hooks: gt()
        })), I.filter(Boolean).forEach(function(zt) {
          zt(_().hooks);
        });
        var le = P(_().hooks);
        _().getHooks = le, delete _().hooks, Object.assign(_(), E(le().useOptions, Je(M)));
        var he = _(), Re = he.data, $e = he.columns, nt = he.initialState, ze = he.defaultColumn, Xe = he.getSubRows, rt = he.getRowId, _e = he.stateReducer, ht = he.useControlledState, It = P(_e), Ht = r.useCallback(function(zt, Zn) {
          if (!Zn.type)
            throw console.info({
              action: Zn
            }), new Error("Unknown Action 👆");
          return [].concat(le().stateReducers, Array.isArray(It()) ? It() : [It()]).reduce(function(wo, Wo) {
            return Wo(wo, Zn, zt, _()) || wo;
          }, zt);
        }, [le, It, _]), lt = r.useReducer(Ht, void 0, function() {
          return Ht(nt, {
            type: g.init
          });
        }), on = lt[0], pn = lt[1], dt = E([].concat(le().useControlledState, [ht]), on, {
          instance: _()
        });
        Object.assign(_(), {
          state: dt,
          dispatch: pn
        });
        var at = r.useMemo(function() {
          return G(E(le().columns, $e, {
            instance: _()
          }));
        }, [le, _, $e].concat(E(le().columnsDeps, [], {
          instance: _()
        })));
        _().columns = at;
        var pt = r.useMemo(function() {
          return E(le().allColumns, H(at), {
            instance: _()
          }).map(ie);
        }, [at, le, _].concat(E(le().allColumnsDeps, [], {
          instance: _()
        })));
        _().allColumns = pt;
        var Mt = r.useMemo(function() {
          for (var zt = [], Zn = [], wo = {}, Wo = [].concat(pt); Wo.length; ) {
            var Mo = Wo.shift();
            Nt({
              data: Re,
              rows: zt,
              flatRows: Zn,
              rowsById: wo,
              column: Mo,
              getRowId: rt,
              getSubRows: Xe,
              accessValueHooks: le().accessValue,
              getInstance: _
            });
          }
          return [zt, Zn, wo];
        }, [pt, Re, rt, Xe, le, _]), sn = Mt[0], an = Mt[1], Vn = Mt[2];
        Object.assign(_(), {
          rows: sn,
          initialRows: [].concat(sn),
          flatRows: an,
          rowsById: Vn
          // materializedColumns,
        }), S(le().useInstanceAfterData, _());
        var wt = r.useMemo(function() {
          return E(le().visibleColumns, pt, {
            instance: _()
          }).map(function(zt) {
            return ce(zt, ze);
          });
        }, [le, pt, _, ze].concat(E(le().visibleColumnsDeps, [], {
          instance: _()
        })));
        pt = r.useMemo(function() {
          var zt = [].concat(wt);
          return pt.forEach(function(Zn) {
            zt.find(function(wo) {
              return wo.id === Zn.id;
            }) || zt.push(Zn);
          }), zt;
        }, [pt, wt]), _().allColumns = pt;
        {
          var To = pt.filter(function(zt, Zn) {
            return pt.findIndex(function(wo) {
              return wo.id === zt.id;
            }) !== Zn;
          });
          if (To.length)
            throw console.info(pt), new Error('Duplicate columns were found with ids: "' + To.map(function(zt) {
              return zt.id;
            }).join(", ") + '" in the columns array above');
        }
        var ln = r.useMemo(function() {
          return E(le().headerGroups, re(wt, ze), _());
        }, [le, wt, ze, _].concat(E(le().headerGroupsDeps, [], {
          instance: _()
        })));
        _().headerGroups = ln;
        var Yt = r.useMemo(function() {
          return ln.length ? ln[0].headers : [];
        }, [ln]);
        _().headers = Yt, _().flatHeaders = ln.reduce(function(zt, Zn) {
          return [].concat(zt, Zn.headers);
        }, []), S(le().useInstanceBeforeDimensions, _());
        var Kt = wt.filter(function(zt) {
          return zt.isVisible;
        }).map(function(zt) {
          return zt.id;
        }).sort().join("_");
        wt = r.useMemo(
          function() {
            return wt.filter(function(zt) {
              return zt.isVisible;
            });
          },
          // eslint-disable-next-line react-hooks/exhaustive-deps
          [wt, Kt]
        ), _().visibleColumns = wt;
        var Nn = nn(Yt), jo = Nn[0], fs = Nn[1], Ga = Nn[2];
        return _().totalColumnsMinWidth = jo, _().totalColumnsWidth = fs, _().totalColumnsMaxWidth = Ga, S(le().useInstance, _()), [].concat(_().flatHeaders, _().allColumns).forEach(function(zt) {
          zt.render = R(_(), zt), zt.getHeaderProps = C(le().getHeaderProps, {
            instance: _(),
            column: zt
          }), zt.getFooterProps = C(le().getFooterProps, {
            instance: _(),
            column: zt
          });
        }), _().headerGroups = r.useMemo(function() {
          return ln.filter(function(zt, Zn) {
            return zt.headers = zt.headers.filter(function(wo) {
              var Wo = function Mo(zi) {
                return zi.filter(function(Fo) {
                  return Fo.headers ? Mo(Fo.headers) : Fo.isVisible;
                }).length;
              };
              return wo.headers ? Wo(wo.headers) : wo.isVisible;
            }), zt.headers.length ? (zt.getHeaderGroupProps = C(le().getHeaderGroupProps, {
              instance: _(),
              headerGroup: zt,
              index: Zn
            }), zt.getFooterGroupProps = C(le().getFooterGroupProps, {
              instance: _(),
              headerGroup: zt,
              index: Zn
            }), !0) : !1;
          });
        }, [ln, _, le]), _().footerGroups = [].concat(_().headerGroups).reverse(), _().prepareRow = r.useCallback(function(zt) {
          zt.getRowProps = C(le().getRowProps, {
            instance: _(),
            row: zt
          }), zt.allCells = pt.map(function(Zn) {
            var wo = zt.values[Zn.id], Wo = {
              column: Zn,
              row: zt,
              value: wo
            };
            return Wo.getCellProps = C(le().getCellProps, {
              instance: _(),
              cell: Wo
            }), Wo.render = R(_(), Zn, {
              row: zt,
              cell: Wo,
              value: wo
            }), Wo;
          }), zt.cells = wt.map(function(Zn) {
            return zt.allCells.find(function(wo) {
              return wo.column.id === Zn.id;
            });
          }), S(le().prepareRow, zt, {
            instance: _()
          });
        }, [le, _, pt, wt]), _().getTableProps = C(le().getTableProps, {
          instance: _()
        }), _().getTableBodyProps = C(le().getTableBodyProps, {
          instance: _()
        }), S(le().useFinalInstance, _()), _();
      };
      function nn(w, M) {
        M === void 0 && (M = 0);
        var D = 0, I = 0, U = 0, X = 0;
        return w.forEach(function(_) {
          var le = _.headers;
          if (_.totalLeft = M, le && le.length) {
            var he = nn(le, M), Re = he[0], $e = he[1], nt = he[2], ze = he[3];
            _.totalMinWidth = Re, _.totalWidth = $e, _.totalMaxWidth = nt, _.totalFlexWidth = ze;
          } else
            _.totalMinWidth = _.minWidth, _.totalWidth = Math.min(Math.max(_.minWidth, _.width), _.maxWidth), _.totalMaxWidth = _.maxWidth, _.totalFlexWidth = _.canResize ? _.totalWidth : 0;
          _.isVisible && (M += _.totalWidth, D += _.totalMinWidth, I += _.totalWidth, U += _.totalMaxWidth, X += _.totalFlexWidth);
        }), [D, I, U, X];
      }
      function Nt(w) {
        var M = w.data, D = w.rows, I = w.flatRows, U = w.rowsById, X = w.column, _ = w.getRowId, le = w.getSubRows, he = w.accessValueHooks, Re = w.getInstance, $e = function nt(ze, Xe, rt, _e, ht) {
          rt === void 0 && (rt = 0);
          var It = ze, Ht = _(ze, Xe, _e), lt = U[Ht];
          if (lt)
            lt.subRows && lt.originalSubRows.forEach(function(pn, dt) {
              return nt(pn, dt, rt + 1, lt);
            });
          else if (lt = {
            id: Ht,
            original: It,
            index: Xe,
            depth: rt,
            cells: [{}]
            // This is a dummy cell
          }, lt.cells.map = K, lt.cells.filter = K, lt.cells.forEach = K, lt.cells[0].getCellProps = K, lt.values = {}, ht.push(lt), I.push(lt), U[Ht] = lt, lt.originalSubRows = le(ze, Xe), lt.originalSubRows) {
            var on = [];
            lt.originalSubRows.forEach(function(pn, dt) {
              return nt(pn, dt, rt + 1, lt, on);
            }), lt.subRows = on;
          }
          X.accessor && (lt.values[X.id] = X.accessor(ze, Xe, lt, ht, M)), lt.values[X.id] = E(he, lt.values[X.id], {
            row: lt,
            column: X,
            instance: Re()
          }, !0);
        };
        M.forEach(function(nt, ze) {
          return $e(nt, ze, 0, void 0, D);
        });
      }
      g.resetExpanded = "resetExpanded", g.toggleRowExpanded = "toggleRowExpanded", g.toggleAllRowsExpanded = "toggleAllRowsExpanded";
      var cn = function(M) {
        M.getToggleAllRowsExpandedProps = [Lt], M.getToggleRowExpandedProps = [jt], M.stateReducers.push(un), M.useInstance.push(On), M.prepareRow.push(Un);
      };
      cn.pluginName = "useExpanded";
      var Lt = function(M, D) {
        var I = D.instance;
        return [M, {
          onClick: function(X) {
            I.toggleAllRowsExpanded();
          },
          style: {
            cursor: "pointer"
          },
          title: "Toggle All Rows Expanded"
        }];
      }, jt = function(M, D) {
        var I = D.row;
        return [M, {
          onClick: function() {
            I.toggleRowExpanded();
          },
          style: {
            cursor: "pointer"
          },
          title: "Toggle Row Expanded"
        }];
      };
      function un(w, M, D, I) {
        if (M.type === g.init)
          return a({
            expanded: {}
          }, w);
        if (M.type === g.resetExpanded)
          return a({}, w, {
            expanded: I.initialState.expanded || {}
          });
        if (M.type === g.toggleAllRowsExpanded) {
          var U = M.value, X = I.rowsById, _ = Object.keys(X).length === Object.keys(w.expanded).length, le = typeof U < "u" ? U : !_;
          if (le) {
            var he = {};
            return Object.keys(X).forEach(function(ht) {
              he[ht] = !0;
            }), a({}, w, {
              expanded: he
            });
          }
          return a({}, w, {
            expanded: {}
          });
        }
        if (M.type === g.toggleRowExpanded) {
          var Re = M.id, $e = M.value, nt = w.expanded[Re], ze = typeof $e < "u" ? $e : !nt;
          if (!nt && ze) {
            var Xe;
            return a({}, w, {
              expanded: a({}, w.expanded, (Xe = {}, Xe[Re] = !0, Xe))
            });
          } else if (nt && !ze) {
            var rt = w.expanded;
            rt[Re];
            var _e = l(rt, [Re].map(u));
            return a({}, w, {
              expanded: _e
            });
          } else
            return w;
        }
      }
      function On(w) {
        var M = w.data, D = w.rows, I = w.rowsById, U = w.manualExpandedKey, X = U === void 0 ? "expanded" : U, _ = w.paginateExpandedRows, le = _ === void 0 ? !0 : _, he = w.expandSubRows, Re = he === void 0 ? !0 : he, $e = w.autoResetExpanded, nt = $e === void 0 ? !0 : $e, ze = w.getHooks, Xe = w.plugins, rt = w.state.expanded, _e = w.dispatch;
        k(Xe, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
        var ht = P(nt), It = !!(Object.keys(I).length && Object.keys(rt).length);
        It && Object.keys(I).some(function(pt) {
          return !rt[pt];
        }) && (It = !1), j(function() {
          ht() && _e({
            type: g.resetExpanded
          });
        }, [_e, M]);
        var Ht = r.useCallback(function(pt, Mt) {
          _e({
            type: g.toggleRowExpanded,
            id: pt,
            value: Mt
          });
        }, [_e]), lt = r.useCallback(function(pt) {
          return _e({
            type: g.toggleAllRowsExpanded,
            value: pt
          });
        }, [_e]), on = r.useMemo(function() {
          return le ? ee(D, {
            manualExpandedKey: X,
            expanded: rt,
            expandSubRows: Re
          }) : D;
        }, [le, D, X, rt, Re]), pn = r.useMemo(function() {
          return ro(rt);
        }, [rt]), dt = P(w), at = C(ze().getToggleAllRowsExpandedProps, {
          instance: dt()
        });
        Object.assign(w, {
          preExpandedRows: D,
          expandedRows: on,
          rows: on,
          expandedDepth: pn,
          isAllRowsExpanded: It,
          toggleRowExpanded: Ht,
          toggleAllRowsExpanded: lt,
          getToggleAllRowsExpandedProps: at
        });
      }
      function Un(w, M) {
        var D = M.instance.getHooks, I = M.instance;
        w.toggleRowExpanded = function(U) {
          return I.toggleRowExpanded(w.id, U);
        }, w.getToggleRowExpandedProps = C(D().getToggleRowExpandedProps, {
          instance: I,
          row: w
        });
      }
      function ro(w) {
        var M = 0;
        return Object.keys(w).forEach(function(D) {
          var I = D.split(".");
          M = Math.max(M, I.length);
        }), M;
      }
      var Ft = function(M, D, I) {
        return M = M.filter(function(U) {
          return D.some(function(X) {
            var _ = U.values[X];
            return String(_).toLowerCase().includes(String(I).toLowerCase());
          });
        }), M;
      };
      Ft.autoRemove = function(w) {
        return !w;
      };
      var Yn = function(M, D, I) {
        return M.filter(function(U) {
          return D.some(function(X) {
            var _ = U.values[X];
            return _ !== void 0 ? String(_).toLowerCase() === String(I).toLowerCase() : !0;
          });
        });
      };
      Yn.autoRemove = function(w) {
        return !w;
      };
      var it = function(M, D, I) {
        return M.filter(function(U) {
          return D.some(function(X) {
            var _ = U.values[X];
            return _ !== void 0 ? String(_) === String(I) : !0;
          });
        });
      };
      it.autoRemove = function(w) {
        return !w;
      };
      var ft = function(M, D, I) {
        return M.filter(function(U) {
          return D.some(function(X) {
            var _ = U.values[X];
            return _.includes(I);
          });
        });
      };
      ft.autoRemove = function(w) {
        return !w || !w.length;
      };
      var Xt = function(M, D, I) {
        return M.filter(function(U) {
          return D.some(function(X) {
            var _ = U.values[X];
            return _ && _.length && I.every(function(le) {
              return _.includes(le);
            });
          });
        });
      };
      Xt.autoRemove = function(w) {
        return !w || !w.length;
      };
      var Ae = function(M, D, I) {
        return M.filter(function(U) {
          return D.some(function(X) {
            var _ = U.values[X];
            return _ && _.length && I.some(function(le) {
              return _.includes(le);
            });
          });
        });
      };
      Ae.autoRemove = function(w) {
        return !w || !w.length;
      };
      var St = function(M, D, I) {
        return M.filter(function(U) {
          return D.some(function(X) {
            var _ = U.values[X];
            return I.includes(_);
          });
        });
      };
      St.autoRemove = function(w) {
        return !w || !w.length;
      };
      var yn = function(M, D, I) {
        return M.filter(function(U) {
          return D.some(function(X) {
            var _ = U.values[X];
            return _ === I;
          });
        });
      };
      yn.autoRemove = function(w) {
        return typeof w > "u";
      };
      var In = function(M, D, I) {
        return M.filter(function(U) {
          return D.some(function(X) {
            var _ = U.values[X];
            return _ == I;
          });
        });
      };
      In.autoRemove = function(w) {
        return w == null;
      };
      var Oo = function(M, D, I) {
        var U = I || [], X = U[0], _ = U[1];
        if (X = typeof X == "number" ? X : -1 / 0, _ = typeof _ == "number" ? _ : 1 / 0, X > _) {
          var le = X;
          X = _, _ = le;
        }
        return M.filter(function(he) {
          return D.some(function(Re) {
            var $e = he.values[Re];
            return $e >= X && $e <= _;
          });
        });
      };
      Oo.autoRemove = function(w) {
        return !w || typeof w[0] != "number" && typeof w[1] != "number";
      };
      var Do = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        text: Ft,
        exactText: Yn,
        exactTextCase: it,
        includes: ft,
        includesAll: Xt,
        includesSome: Ae,
        includesValue: St,
        exact: yn,
        equals: In,
        between: Oo
      });
      g.resetFilters = "resetFilters", g.setFilter = "setFilter", g.setAllFilters = "setAllFilters";
      var Xn = function(M) {
        M.stateReducers.push(fo), M.useInstance.push(Ko);
      };
      Xn.pluginName = "useFilters";
      function fo(w, M, D, I) {
        if (M.type === g.init)
          return a({
            filters: []
          }, w);
        if (M.type === g.resetFilters)
          return a({}, w, {
            filters: I.initialState.filters || []
          });
        if (M.type === g.setFilter) {
          var U = M.columnId, X = M.filterValue, _ = I.allColumns, le = I.filterTypes, he = _.find(function(_e) {
            return _e.id === U;
          });
          if (!he)
            throw new Error("React-Table: Could not find a column with id: " + U);
          var Re = te(he.filter, le || {}, Do), $e = w.filters.find(function(_e) {
            return _e.id === U;
          }), nt = T(X, $e && $e.value);
          return ue(Re.autoRemove, nt, he) ? a({}, w, {
            filters: w.filters.filter(function(_e) {
              return _e.id !== U;
            })
          }) : $e ? a({}, w, {
            filters: w.filters.map(function(_e) {
              return _e.id === U ? {
                id: U,
                value: nt
              } : _e;
            })
          }) : a({}, w, {
            filters: [].concat(w.filters, [{
              id: U,
              value: nt
            }])
          });
        }
        if (M.type === g.setAllFilters) {
          var ze = M.filters, Xe = I.allColumns, rt = I.filterTypes;
          return a({}, w, {
            // Filter out undefined values
            filters: T(ze, w.filters).filter(function(_e) {
              var ht = Xe.find(function(Ht) {
                return Ht.id === _e.id;
              }), It = te(ht.filter, rt || {}, Do);
              return !ue(It.autoRemove, _e.value, ht);
            })
          });
        }
      }
      function Ko(w) {
        var M = w.data, D = w.rows, I = w.flatRows, U = w.rowsById, X = w.allColumns, _ = w.filterTypes, le = w.manualFilters, he = w.defaultCanFilter, Re = he === void 0 ? !1 : he, $e = w.disableFilters, nt = w.state.filters, ze = w.dispatch, Xe = w.autoResetFilters, rt = Xe === void 0 ? !0 : Xe, _e = r.useCallback(function(dt, at) {
          ze({
            type: g.setFilter,
            columnId: dt,
            filterValue: at
          });
        }, [ze]), ht = r.useCallback(function(dt) {
          ze({
            type: g.setAllFilters,
            filters: dt
          });
        }, [ze]);
        X.forEach(function(dt) {
          var at = dt.id, pt = dt.accessor, Mt = dt.defaultCanFilter, sn = dt.disableFilters;
          dt.canFilter = pt ? pe(sn === !0 ? !1 : void 0, $e === !0 ? !1 : void 0, !0) : pe(Mt, Re, !1), dt.setFilter = function(Vn) {
            return _e(dt.id, Vn);
          };
          var an = nt.find(function(Vn) {
            return Vn.id === at;
          });
          dt.filterValue = an && an.value;
        });
        var It = r.useMemo(function() {
          if (le || !nt.length)
            return [D, I, U];
          var dt = [], at = {}, pt = function Mt(sn, an) {
            an === void 0 && (an = 0);
            var Vn = sn;
            return Vn = nt.reduce(function(wt, To) {
              var ln = To.id, Yt = To.value, Kt = X.find(function(jo) {
                return jo.id === ln;
              });
              if (!Kt)
                return wt;
              an === 0 && (Kt.preFilteredRows = wt);
              var Nn = te(Kt.filter, _ || {}, Do);
              return Nn ? (Kt.filteredRows = Nn(wt, [ln], Yt), Kt.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + Kt.id + "."), wt);
            }, sn), Vn.forEach(function(wt) {
              dt.push(wt), at[wt.id] = wt, wt.subRows && (wt.subRows = wt.subRows && wt.subRows.length > 0 ? Mt(wt.subRows, an + 1) : wt.subRows);
            }), Vn;
          };
          return [pt(D), dt, at];
        }, [le, nt, D, I, U, X, _]), Ht = It[0], lt = It[1], on = It[2];
        r.useMemo(function() {
          var dt = X.filter(function(at) {
            return !nt.find(function(pt) {
              return pt.id === at.id;
            });
          });
          dt.forEach(function(at) {
            at.preFilteredRows = Ht, at.filteredRows = Ht;
          });
        }, [Ht, nt, X]);
        var pn = P(rt);
        j(function() {
          pn() && ze({
            type: g.resetFilters
          });
        }, [ze, le ? null : M]), Object.assign(w, {
          preFilteredRows: D,
          preFilteredFlatRows: I,
          preFilteredRowsById: U,
          filteredRows: Ht,
          filteredFlatRows: lt,
          filteredRowsById: on,
          rows: Ht,
          flatRows: lt,
          rowsById: on,
          setFilter: _e,
          setAllFilters: ht
        });
      }
      g.resetGlobalFilter = "resetGlobalFilter", g.setGlobalFilter = "setGlobalFilter";
      var di = function(M) {
        M.stateReducers.push(Le), M.useInstance.push(Pe);
      };
      di.pluginName = "useGlobalFilter";
      function Le(w, M, D, I) {
        if (M.type === g.resetGlobalFilter)
          return a({}, w, {
            globalFilter: I.initialState.globalFilter || void 0
          });
        if (M.type === g.setGlobalFilter) {
          var U = M.filterValue, X = I.userFilterTypes, _ = te(I.globalFilter, X || {}, Do), le = T(U, w.globalFilter);
          if (ue(_.autoRemove, le)) {
            w.globalFilter;
            var he = l(w, ["globalFilter"]);
            return he;
          }
          return a({}, w, {
            globalFilter: le
          });
        }
      }
      function Pe(w) {
        var M = w.data, D = w.rows, I = w.flatRows, U = w.rowsById, X = w.allColumns, _ = w.filterTypes, le = w.globalFilter, he = w.manualGlobalFilter, Re = w.state.globalFilter, $e = w.dispatch, nt = w.autoResetGlobalFilter, ze = nt === void 0 ? !0 : nt, Xe = w.disableGlobalFilter, rt = r.useCallback(function(on) {
          $e({
            type: g.setGlobalFilter,
            filterValue: on
          });
        }, [$e]), _e = r.useMemo(function() {
          if (he || typeof Re > "u")
            return [D, I, U];
          var on = [], pn = {}, dt = te(le, _ || {}, Do);
          if (!dt)
            return console.warn("Could not find a valid 'globalFilter' option."), D;
          X.forEach(function(Mt) {
            var sn = Mt.disableGlobalFilter;
            Mt.canFilter = pe(sn === !0 ? !1 : void 0, Xe === !0 ? !1 : void 0, !0);
          });
          var at = X.filter(function(Mt) {
            return Mt.canFilter === !0;
          }), pt = function Mt(sn) {
            return sn = dt(sn, at.map(function(an) {
              return an.id;
            }), Re), sn.forEach(function(an) {
              on.push(an), pn[an.id] = an, an.subRows = an.subRows && an.subRows.length ? Mt(an.subRows) : an.subRows;
            }), sn;
          };
          return [pt(D), on, pn];
        }, [he, Re, le, _, X, D, I, U, Xe]), ht = _e[0], It = _e[1], Ht = _e[2], lt = P(ze);
        j(function() {
          lt() && $e({
            type: g.resetGlobalFilter
          });
        }, [$e, he ? null : M]), Object.assign(w, {
          preGlobalFilteredRows: D,
          preGlobalFilteredFlatRows: I,
          preGlobalFilteredRowsById: U,
          globalFilteredRows: ht,
          globalFilteredFlatRows: It,
          globalFilteredRowsById: Ht,
          rows: ht,
          flatRows: It,
          rowsById: Ht,
          setGlobalFilter: rt,
          disableGlobalFilter: Xe
        });
      }
      function ot(w, M) {
        return M.reduce(function(D, I) {
          return D + (typeof I == "number" ? I : 0);
        }, 0);
      }
      function Qt(w) {
        var M = w[0] || 0;
        return w.forEach(function(D) {
          typeof D == "number" && (M = Math.min(M, D));
        }), M;
      }
      function dn(w) {
        var M = w[0] || 0;
        return w.forEach(function(D) {
          typeof D == "number" && (M = Math.max(M, D));
        }), M;
      }
      function xn(w) {
        var M = w[0] || 0, D = w[0] || 0;
        return w.forEach(function(I) {
          typeof I == "number" && (M = Math.min(M, I), D = Math.max(D, I));
        }), M + ".." + D;
      }
      function Qn(w) {
        return ot(null, w) / w.length;
      }
      function Ro(w) {
        if (!w.length)
          return null;
        var M = Math.floor(w.length / 2), D = [].concat(w).sort(function(I, U) {
          return I - U;
        });
        return w.length % 2 !== 0 ? D[M] : (D[M - 1] + D[M]) / 2;
      }
      function pi(w) {
        return Array.from(new Set(w).values());
      }
      function Va(w) {
        return new Set(w).size;
      }
      function ds(w) {
        return w.length;
      }
      var Hr = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        sum: ot,
        min: Qt,
        max: dn,
        minMax: xn,
        average: Qn,
        median: Ro,
        unique: pi,
        uniqueCount: Va,
        count: ds
      }), _i = [], Sn = {};
      g.resetGroupBy = "resetGroupBy", g.setGroupBy = "setGroupBy", g.toggleGroupBy = "toggleGroupBy";
      var Lo = function(M) {
        M.getGroupByToggleProps = [rr], M.stateReducers.push(fi), M.visibleColumnsDeps.push(function(D, I) {
          var U = I.instance;
          return [].concat(D, [U.state.groupBy]);
        }), M.visibleColumns.push($a), M.useInstance.push(a1), M.prepareRow.push(l1);
      };
      Lo.pluginName = "useGroupBy";
      var rr = function(M, D) {
        var I = D.header;
        return [M, {
          onClick: I.canGroupBy ? function(U) {
            U.persist(), I.toggleGroupBy();
          } : void 0,
          style: {
            cursor: I.canGroupBy ? "pointer" : void 0
          },
          title: "Toggle GroupBy"
        }];
      };
      function fi(w, M, D, I) {
        if (M.type === g.init)
          return a({
            groupBy: []
          }, w);
        if (M.type === g.resetGroupBy)
          return a({}, w, {
            groupBy: I.initialState.groupBy || []
          });
        if (M.type === g.setGroupBy) {
          var U = M.value;
          return a({}, w, {
            groupBy: U
          });
        }
        if (M.type === g.toggleGroupBy) {
          var X = M.columnId, _ = M.value, le = typeof _ < "u" ? _ : !w.groupBy.includes(X);
          return le ? a({}, w, {
            groupBy: [].concat(w.groupBy, [X])
          }) : a({}, w, {
            groupBy: w.groupBy.filter(function(he) {
              return he !== X;
            })
          });
        }
      }
      function $a(w, M) {
        var D = M.instance.state.groupBy, I = D.map(function(X) {
          return w.find(function(_) {
            return _.id === X;
          });
        }).filter(Boolean), U = w.filter(function(X) {
          return !D.includes(X.id);
        });
        return w = [].concat(I, U), w.forEach(function(X) {
          X.isGrouped = D.includes(X.id), X.groupedIndex = D.indexOf(X.id);
        }), w;
      }
      var s1 = {};
      function a1(w) {
        var M = w.data, D = w.rows, I = w.flatRows, U = w.rowsById, X = w.allColumns, _ = w.flatHeaders, le = w.groupByFn, he = le === void 0 ? Mc : le, Re = w.manualGroupBy, $e = w.aggregations, nt = $e === void 0 ? s1 : $e, ze = w.plugins, Xe = w.state.groupBy, rt = w.dispatch, _e = w.autoResetGroupBy, ht = _e === void 0 ? !0 : _e, It = w.disableGroupBy, Ht = w.defaultCanGroupBy, lt = w.getHooks;
        k(ze, ["useColumnOrder", "useFilters"], "useGroupBy");
        var on = P(w);
        X.forEach(function(Yt) {
          var Kt = Yt.accessor, Nn = Yt.defaultGroupBy, jo = Yt.disableGroupBy;
          Yt.canGroupBy = Kt ? pe(Yt.canGroupBy, jo === !0 ? !1 : void 0, It === !0 ? !1 : void 0, !0) : pe(Yt.canGroupBy, Nn, Ht, !1), Yt.canGroupBy && (Yt.toggleGroupBy = function() {
            return w.toggleGroupBy(Yt.id);
          }), Yt.Aggregated = Yt.Aggregated || Yt.Cell;
        });
        var pn = r.useCallback(function(Yt, Kt) {
          rt({
            type: g.toggleGroupBy,
            columnId: Yt,
            value: Kt
          });
        }, [rt]), dt = r.useCallback(function(Yt) {
          rt({
            type: g.setGroupBy,
            value: Yt
          });
        }, [rt]);
        _.forEach(function(Yt) {
          Yt.getGroupByToggleProps = C(lt().getGroupByToggleProps, {
            instance: on(),
            header: Yt
          });
        });
        var at = r.useMemo(function() {
          if (Re || !Xe.length)
            return [D, I, U, _i, Sn, I, U];
          var Yt = Xe.filter(function(Mo) {
            return X.find(function(zi) {
              return zi.id === Mo;
            });
          }), Kt = function(zi, Fo, Uc) {
            var Hi = {};
            return X.forEach(function(go) {
              if (Yt.includes(go.id)) {
                Hi[go.id] = Fo[0] ? Fo[0].values[go.id] : null;
                return;
              }
              var Yc = typeof go.aggregate == "function" ? go.aggregate : nt[go.aggregate] || Hr[go.aggregate];
              if (Yc) {
                var Ys = Fo.map(function(gs) {
                  return gs.values[go.id];
                }), T1 = zi.map(function(gs) {
                  var Wi = gs.values[go.id];
                  if (!Uc && go.aggregateValue) {
                    var Gi = typeof go.aggregateValue == "function" ? go.aggregateValue : nt[go.aggregateValue] || Hr[go.aggregateValue];
                    if (!Gi)
                      throw console.info({
                        column: go
                      }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                    Wi = Gi(Wi, gs, go);
                  }
                  return Wi;
                });
                Hi[go.id] = Yc(T1, Ys);
              } else {
                if (go.aggregate)
                  throw console.info({
                    column: go
                  }), new Error("React Table: Invalid column.aggregate option for column listed above");
                Hi[go.id] = null;
              }
            }), Hi;
          }, Nn = [], jo = {}, fs = [], Ga = {}, zt = [], Zn = {}, wo = function Mo(zi, Fo, Uc) {
            if (Fo === void 0 && (Fo = 0), Fo === Yt.length)
              return zi.map(function(Ys) {
                return a({}, Ys, {
                  depth: Fo
                });
              });
            var Hi = Yt[Fo], go = he(zi, Hi), Yc = Object.entries(go).map(function(Ys, T1) {
              var gs = Ys[0], Wi = Ys[1], Gi = Hi + ":" + gs;
              Gi = Uc ? Uc + ">" + Gi : Gi;
              var n2 = Mo(Wi, Fo + 1, Gi), o2 = Fo ? fe(Wi, "leafRows") : Wi, I6 = Kt(o2, Wi, Fo), O6 = {
                id: Gi,
                isGrouped: !0,
                groupByID: Hi,
                groupByVal: gs,
                values: I6,
                subRows: n2,
                leafRows: o2,
                depth: Fo,
                index: T1
              };
              return n2.forEach(function(Wr) {
                Nn.push(Wr), jo[Wr.id] = Wr, Wr.isGrouped ? (fs.push(Wr), Ga[Wr.id] = Wr) : (zt.push(Wr), Zn[Wr.id] = Wr);
              }), O6;
            });
            return Yc;
          }, Wo = wo(D);
          return Wo.forEach(function(Mo) {
            Nn.push(Mo), jo[Mo.id] = Mo, Mo.isGrouped ? (fs.push(Mo), Ga[Mo.id] = Mo) : (zt.push(Mo), Zn[Mo.id] = Mo);
          }), [Wo, Nn, jo, fs, Ga, zt, Zn];
        }, [Re, Xe, D, I, U, X, nt, he]), pt = at[0], Mt = at[1], sn = at[2], an = at[3], Vn = at[4], wt = at[5], To = at[6], ln = P(ht);
        j(function() {
          ln() && rt({
            type: g.resetGroupBy
          });
        }, [rt, Re ? null : M]), Object.assign(w, {
          preGroupedRows: D,
          preGroupedFlatRow: I,
          preGroupedRowsById: U,
          groupedRows: pt,
          groupedFlatRows: Mt,
          groupedRowsById: sn,
          onlyGroupedFlatRows: an,
          onlyGroupedRowsById: Vn,
          nonGroupedFlatRows: wt,
          nonGroupedRowsById: To,
          rows: pt,
          flatRows: Mt,
          rowsById: sn,
          toggleGroupBy: pn,
          setGroupBy: dt
        });
      }
      function l1(w) {
        w.allCells.forEach(function(M) {
          var D;
          M.isGrouped = M.column.isGrouped && M.column.id === w.groupByID, M.isPlaceholder = !M.isGrouped && M.column.isGrouped, M.isAggregated = !M.isGrouped && !M.isPlaceholder && ((D = w.subRows) == null ? void 0 : D.length);
        });
      }
      function Mc(w, M) {
        return w.reduce(function(D, I, U) {
          var X = "" + I.values[M];
          return D[X] = Array.isArray(D[X]) ? D[X] : [], D[X].push(I), D;
        }, {});
      }
      var kc = /([0-9]+)/gm, c1 = function(M, D, I) {
        var U = ps(M, D, I), X = U[0], _ = U[1];
        for (X = Ic(X), _ = Ic(_), X = X.split(kc).filter(Boolean), _ = _.split(kc).filter(Boolean); X.length && _.length; ) {
          var le = X.shift(), he = _.shift(), Re = parseInt(le, 10), $e = parseInt(he, 10), nt = [Re, $e].sort();
          if (isNaN(nt[0])) {
            if (le > he)
              return 1;
            if (he > le)
              return -1;
            continue;
          }
          if (isNaN(nt[1]))
            return isNaN(Re) ? -1 : 1;
          if (Re > $e)
            return 1;
          if ($e > Re)
            return -1;
        }
        return X.length - _.length;
      };
      function u1(w, M, D) {
        var I = ps(w, M, D), U = I[0], X = I[1];
        return U = U.getTime(), X = X.getTime(), La(U, X);
      }
      function d1(w, M, D) {
        var I = ps(w, M, D), U = I[0], X = I[1];
        return La(U, X);
      }
      function p1(w, M, D) {
        var I = ps(w, M, D), U = I[0], X = I[1];
        for (U = U.split("").filter(Boolean), X = X.split("").filter(Boolean); U.length && X.length; ) {
          var _ = U.shift(), le = X.shift(), he = _.toLowerCase(), Re = le.toLowerCase();
          if (he > Re)
            return 1;
          if (Re > he)
            return -1;
          if (_ > le)
            return 1;
          if (le > _)
            return -1;
        }
        return U.length - X.length;
      }
      function Pc(w, M, D) {
        var I = ps(w, M, D), U = I[0], X = I[1], _ = /[^0-9.]/gi;
        return U = Number(String(U).replace(_, "")), X = Number(String(X).replace(_, "")), La(U, X);
      }
      function La(w, M) {
        return w === M ? 0 : w > M ? 1 : -1;
      }
      function ps(w, M, D) {
        return [w.values[D], M.values[D]];
      }
      function Ic(w) {
        return typeof w == "number" ? isNaN(w) || w === 1 / 0 || w === -1 / 0 ? "" : String(w) : typeof w == "string" ? w : "";
      }
      var f1 = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        alphanumeric: c1,
        datetime: u1,
        basic: d1,
        string: p1,
        number: Pc
      });
      g.resetSortBy = "resetSortBy", g.setSortBy = "setSortBy", g.toggleSortBy = "toggleSortBy", g.clearSortBy = "clearSortBy", v.sortType = "alphanumeric", v.sortDescFirst = !1;
      var Oc = function(M) {
        M.getSortByToggleProps = [g1], M.stateReducers.push(Dc), M.useInstance.push(jc);
      };
      Oc.pluginName = "useSortBy";
      var g1 = function(M, D) {
        var I = D.instance, U = D.column, X = I.isMultiSortEvent, _ = X === void 0 ? function(le) {
          return le.shiftKey;
        } : X;
        return [M, {
          onClick: U.canSort ? function(le) {
            le.persist(), U.toggleSortBy(void 0, !I.disableMultiSort && _(le));
          } : void 0,
          style: {
            cursor: U.canSort ? "pointer" : void 0
          },
          title: U.canSort ? "Toggle SortBy" : void 0
        }];
      };
      function Dc(w, M, D, I) {
        if (M.type === g.init)
          return a({
            sortBy: []
          }, w);
        if (M.type === g.resetSortBy)
          return a({}, w, {
            sortBy: I.initialState.sortBy || []
          });
        if (M.type === g.clearSortBy) {
          var U = w.sortBy, X = U.filter(function(pt) {
            return pt.id !== M.columnId;
          });
          return a({}, w, {
            sortBy: X
          });
        }
        if (M.type === g.setSortBy) {
          var _ = M.sortBy;
          return a({}, w, {
            sortBy: _
          });
        }
        if (M.type === g.toggleSortBy) {
          var le = M.columnId, he = M.desc, Re = M.multi, $e = I.allColumns, nt = I.disableMultiSort, ze = I.disableSortRemove, Xe = I.disableMultiRemove, rt = I.maxMultiSortColCount, _e = rt === void 0 ? Number.MAX_SAFE_INTEGER : rt, ht = w.sortBy, It = $e.find(function(pt) {
            return pt.id === le;
          }), Ht = It.sortDescFirst, lt = ht.find(function(pt) {
            return pt.id === le;
          }), on = ht.findIndex(function(pt) {
            return pt.id === le;
          }), pn = typeof he < "u" && he !== null, dt = [], at;
          return !nt && Re ? lt ? at = "toggle" : at = "add" : on !== ht.length - 1 || ht.length !== 1 ? at = "replace" : lt ? at = "toggle" : at = "replace", at === "toggle" && // Must be toggling
          !ze && // If disableSortRemove, disable in general
          !pn && // Must not be setting desc
          (!Re || !Xe) && // If multi, don't allow if disableMultiRemove
          (lt && // Finally, detect if it should indeed be removed
          lt.desc && !Ht || !lt.desc && Ht) && (at = "remove"), at === "replace" ? dt = [{
            id: le,
            desc: pn ? he : Ht
          }] : at === "add" ? (dt = [].concat(ht, [{
            id: le,
            desc: pn ? he : Ht
          }]), dt.splice(0, dt.length - _e)) : at === "toggle" ? dt = ht.map(function(pt) {
            return pt.id === le ? a({}, pt, {
              desc: pn ? he : !lt.desc
            }) : pt;
          }) : at === "remove" && (dt = ht.filter(function(pt) {
            return pt.id !== le;
          })), a({}, w, {
            sortBy: dt
          });
        }
      }
      function jc(w) {
        var M = w.data, D = w.rows, I = w.flatRows, U = w.allColumns, X = w.orderByFn, _ = X === void 0 ? Aa : X, le = w.sortTypes, he = w.manualSortBy, Re = w.defaultCanSort, $e = w.disableSortBy, nt = w.flatHeaders, ze = w.state.sortBy, Xe = w.dispatch, rt = w.plugins, _e = w.getHooks, ht = w.autoResetSortBy, It = ht === void 0 ? !0 : ht;
        k(rt, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
        var Ht = r.useCallback(function(Mt) {
          Xe({
            type: g.setSortBy,
            sortBy: Mt
          });
        }, [Xe]), lt = r.useCallback(function(Mt, sn, an) {
          Xe({
            type: g.toggleSortBy,
            columnId: Mt,
            desc: sn,
            multi: an
          });
        }, [Xe]), on = P(w);
        nt.forEach(function(Mt) {
          var sn = Mt.accessor, an = Mt.canSort, Vn = Mt.disableSortBy, wt = Mt.id, To = sn ? pe(Vn === !0 ? !1 : void 0, $e === !0 ? !1 : void 0, !0) : pe(Re, an, !1);
          Mt.canSort = To, Mt.canSort && (Mt.toggleSortBy = function(Yt, Kt) {
            return lt(Mt.id, Yt, Kt);
          }, Mt.clearSortBy = function() {
            Xe({
              type: g.clearSortBy,
              columnId: Mt.id
            });
          }), Mt.getSortByToggleProps = C(_e().getSortByToggleProps, {
            instance: on(),
            column: Mt
          });
          var ln = ze.find(function(Yt) {
            return Yt.id === wt;
          });
          Mt.isSorted = !!ln, Mt.sortedIndex = ze.findIndex(function(Yt) {
            return Yt.id === wt;
          }), Mt.isSortedDesc = Mt.isSorted ? ln.desc : void 0;
        });
        var pn = r.useMemo(function() {
          if (he || !ze.length)
            return [D, I];
          var Mt = [], sn = ze.filter(function(Vn) {
            return U.find(function(wt) {
              return wt.id === Vn.id;
            });
          }), an = function Vn(wt) {
            var To = _(
              wt,
              sn.map(function(ln) {
                var Yt = U.find(function(jo) {
                  return jo.id === ln.id;
                });
                if (!Yt)
                  throw new Error("React-Table: Could not find a column with id: " + ln.id + " while sorting");
                var Kt = Yt.sortType, Nn = Ce(Kt) || (le || {})[Kt] || f1[Kt];
                if (!Nn)
                  throw new Error("React-Table: Could not find a valid sortType of '" + Kt + "' for column '" + ln.id + "'.");
                return function(jo, fs) {
                  return Nn(jo, fs, ln.id, ln.desc);
                };
              }),
              // Map the directions
              sn.map(function(ln) {
                var Yt = U.find(function(Kt) {
                  return Kt.id === ln.id;
                });
                return Yt && Yt.sortInverted ? ln.desc : !ln.desc;
              })
            );
            return To.forEach(function(ln) {
              Mt.push(ln), !(!ln.subRows || ln.subRows.length === 0) && (ln.subRows = Vn(ln.subRows));
            }), To;
          };
          return [an(D), Mt];
        }, [he, ze, D, I, U, _, le]), dt = pn[0], at = pn[1], pt = P(It);
        j(function() {
          pt() && Xe({
            type: g.resetSortBy
          });
        }, [he ? null : M]), Object.assign(w, {
          preSortedRows: D,
          preSortedFlatRows: I,
          sortedRows: dt,
          sortedFlatRows: at,
          rows: dt,
          flatRows: at,
          setSortBy: Ht,
          toggleSortBy: lt
        });
      }
      function Aa(w, M, D) {
        return [].concat(w).sort(function(I, U) {
          for (var X = 0; X < M.length; X += 1) {
            var _ = M[X], le = D[X] === !1 || D[X] === "desc", he = _(I, U);
            if (he !== 0)
              return le ? -he : he;
          }
          return D[0] ? I.index - U.index : U.index - I.index;
        });
      }
      var m1 = "usePagination";
      g.resetPage = "resetPage", g.gotoPage = "gotoPage", g.setPageSize = "setPageSize";
      var Fc = function(M) {
        M.stateReducers.push(h1), M.useInstance.push(Vc);
      };
      Fc.pluginName = m1;
      function h1(w, M, D, I) {
        if (M.type === g.init)
          return a({
            pageSize: 10,
            pageIndex: 0
          }, w);
        if (M.type === g.resetPage)
          return a({}, w, {
            pageIndex: I.initialState.pageIndex || 0
          });
        if (M.type === g.gotoPage) {
          var U = I.pageCount, X = I.page, _ = T(M.pageIndex, w.pageIndex), le = !1;
          return _ > w.pageIndex ? le = U === -1 ? X.length >= w.pageSize : _ < U : _ < w.pageIndex && (le = _ > -1), le ? a({}, w, {
            pageIndex: _
          }) : w;
        }
        if (M.type === g.setPageSize) {
          var he = M.pageSize, Re = w.pageSize * w.pageIndex, $e = Math.floor(Re / he);
          return a({}, w, {
            pageIndex: $e,
            pageSize: he
          });
        }
      }
      function Vc(w) {
        var M = w.rows, D = w.autoResetPage, I = D === void 0 ? !0 : D, U = w.manualExpandedKey, X = U === void 0 ? "expanded" : U, _ = w.plugins, le = w.pageCount, he = w.paginateExpandedRows, Re = he === void 0 ? !0 : he, $e = w.expandSubRows, nt = $e === void 0 ? !0 : $e, ze = w.state, Xe = ze.pageSize, rt = ze.pageIndex, _e = ze.expanded, ht = ze.globalFilter, It = ze.filters, Ht = ze.groupBy, lt = ze.sortBy, on = w.dispatch, pn = w.data, dt = w.manualPagination;
        k(_, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
        var at = P(I);
        j(function() {
          at() && on({
            type: g.resetPage
          });
        }, [on, dt ? null : pn, ht, It, Ht, lt]);
        var pt = dt ? le : Math.ceil(M.length / Xe), Mt = r.useMemo(function() {
          return pt > 0 ? [].concat(new Array(pt)).fill(null).map(function(Kt, Nn) {
            return Nn;
          }) : [];
        }, [pt]), sn = r.useMemo(function() {
          var Kt;
          if (dt)
            Kt = M;
          else {
            var Nn = Xe * rt, jo = Nn + Xe;
            Kt = M.slice(Nn, jo);
          }
          return Re ? Kt : ee(Kt, {
            manualExpandedKey: X,
            expanded: _e,
            expandSubRows: nt
          });
        }, [nt, _e, X, dt, rt, Xe, Re, M]), an = rt > 0, Vn = pt === -1 ? sn.length >= Xe : rt < pt - 1, wt = r.useCallback(function(Kt) {
          on({
            type: g.gotoPage,
            pageIndex: Kt
          });
        }, [on]), To = r.useCallback(function() {
          return wt(function(Kt) {
            return Kt - 1;
          });
        }, [wt]), ln = r.useCallback(function() {
          return wt(function(Kt) {
            return Kt + 1;
          });
        }, [wt]), Yt = r.useCallback(function(Kt) {
          on({
            type: g.setPageSize,
            pageSize: Kt
          });
        }, [on]);
        Object.assign(w, {
          pageOptions: Mt,
          pageCount: pt,
          page: sn,
          canPreviousPage: an,
          canNextPage: Vn,
          gotoPage: wt,
          previousPage: To,
          nextPage: ln,
          setPageSize: Yt
        });
      }
      g.resetPivot = "resetPivot", g.togglePivot = "togglePivot";
      var $c = function(M) {
        M.getPivotToggleProps = [v1], M.stateReducers.push(Ac), M.useInstanceAfterData.push(y1), M.allColumns.push(b1), M.accessValue.push(C1), M.materializedColumns.push(x1), M.materializedColumnsDeps.push(Na), M.visibleColumns.push(Nc), M.visibleColumnsDeps.push(Us), M.useInstance.push(Ba), M.prepareRow.push(_a);
      };
      $c.pluginName = "usePivotColumns";
      var Lc = [], v1 = function(M, D) {
        var I = D.header;
        return [M, {
          onClick: I.canPivot ? function(U) {
            U.persist(), I.togglePivot();
          } : void 0,
          style: {
            cursor: I.canPivot ? "pointer" : void 0
          },
          title: "Toggle Pivot"
        }];
      };
      function Ac(w, M, D, I) {
        if (M.type === g.init)
          return a({
            pivotColumns: Lc
          }, w);
        if (M.type === g.resetPivot)
          return a({}, w, {
            pivotColumns: I.initialState.pivotColumns || Lc
          });
        if (M.type === g.togglePivot) {
          var U = M.columnId, X = M.value, _ = typeof X < "u" ? X : !w.pivotColumns.includes(U);
          return _ ? a({}, w, {
            pivotColumns: [].concat(w.pivotColumns, [U])
          }) : a({}, w, {
            pivotColumns: w.pivotColumns.filter(function(le) {
              return le !== U;
            })
          });
        }
      }
      function y1(w) {
        w.allColumns.forEach(function(M) {
          M.isPivotSource = w.state.pivotColumns.includes(M.id);
        });
      }
      function b1(w, M) {
        var D = M.instance;
        return w.forEach(function(I) {
          I.isPivotSource = D.state.pivotColumns.includes(I.id), I.uniqueValues = /* @__PURE__ */ new Set();
        }), w;
      }
      function C1(w, M) {
        var D = M.column;
        return D.uniqueValues && typeof w < "u" && D.uniqueValues.add(w), w;
      }
      function x1(w, M) {
        var D = M.instance, I = D.allColumns, U = D.state;
        if (!U.pivotColumns.length || !U.groupBy || !U.groupBy.length)
          return w;
        var X = U.pivotColumns.map(function(Re) {
          return I.find(function($e) {
            return $e.id === Re;
          });
        }).filter(Boolean), _ = I.filter(function(Re) {
          return !Re.isPivotSource && !U.groupBy.includes(Re.id) && !U.pivotColumns.includes(Re.id);
        }), le = function Re($e, nt, ze) {
          $e === void 0 && ($e = 0), ze === void 0 && (ze = []);
          var Xe = X[$e];
          if (!Xe)
            return _.map(function(_e) {
              return a({}, _e, {
                canPivot: !1,
                isPivoted: !0,
                parent: nt,
                depth: $e,
                id: "" + (nt ? nt.id + "." + _e.id : _e.id),
                accessor: function(It, Ht, lt) {
                  if (ze.every(function(on) {
                    return on(lt);
                  }))
                    return lt.values[_e.id];
                }
              });
            });
          var rt = Array.from(Xe.uniqueValues).sort();
          return rt.map(function(_e) {
            var ht = a({}, Xe, {
              Header: Xe.PivotHeader || typeof Xe.header == "string" ? Xe.Header + ": " + _e : _e,
              isPivotGroup: !0,
              parent: nt,
              depth: $e,
              id: nt ? nt.id + "." + Xe.id + "." + _e : Xe.id + "." + _e,
              pivotValue: _e
            });
            return ht.columns = Re($e + 1, ht, [].concat(ze, [function(It) {
              return It.values[Xe.id] === _e;
            }])), ht;
          });
        }, he = H(le());
        return [].concat(w, he);
      }
      function Na(w, M) {
        var D = M.instance.state, I = D.pivotColumns, U = D.groupBy;
        return [].concat(w, [I, U]);
      }
      function Nc(w, M) {
        var D = M.instance.state;
        return w = w.filter(function(I) {
          return !I.isPivotSource;
        }), D.pivotColumns.length && D.groupBy && D.groupBy.length && (w = w.filter(function(I) {
          return I.isGrouped || I.isPivoted;
        })), w;
      }
      function Us(w, M) {
        var D = M.instance;
        return [].concat(w, [D.state.pivotColumns, D.state.groupBy]);
      }
      function Ba(w) {
        var M = w.columns, D = w.allColumns, I = w.flatHeaders, U = w.getHooks, X = w.plugins, _ = w.dispatch, le = w.autoResetPivot, he = le === void 0 ? !0 : le, Re = w.manaulPivot, $e = w.disablePivot, nt = w.defaultCanPivot;
        k(X, ["useGroupBy"], "usePivotColumns");
        var ze = P(w);
        D.forEach(function(_e) {
          var ht = _e.accessor, It = _e.defaultPivot, Ht = _e.disablePivot;
          _e.canPivot = ht ? pe(_e.canPivot, Ht === !0 ? !1 : void 0, $e === !0 ? !1 : void 0, !0) : pe(_e.canPivot, It, nt, !1), _e.canPivot && (_e.togglePivot = function() {
            return w.togglePivot(_e.id);
          }), _e.Aggregated = _e.Aggregated || _e.Cell;
        });
        var Xe = function(ht, It) {
          _({
            type: g.togglePivot,
            columnId: ht,
            value: It
          });
        };
        I.forEach(function(_e) {
          _e.getPivotToggleProps = C(U().getPivotToggleProps, {
            instance: ze(),
            header: _e
          });
        });
        var rt = P(he);
        j(function() {
          rt() && _({
            type: g.resetPivot
          });
        }, [_, Re ? null : M]), Object.assign(w, {
          togglePivot: Xe
        });
      }
      function _a(w) {
        w.allCells.forEach(function(M) {
          M.isPivoted = M.column.isPivoted;
        });
      }
      var Bc = "useRowSelect";
      g.resetSelectedRows = "resetSelectedRows", g.toggleAllRowsSelected = "toggleAllRowsSelected", g.toggleRowSelected = "toggleRowSelected", g.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
      var za = function(M) {
        M.getToggleRowSelectedProps = [w1], M.getToggleAllRowsSelectedProps = [Ha], M.getToggleAllPageRowsSelectedProps = [S1], M.stateReducers.push(E1), M.useInstance.push(R1), M.prepareRow.push(_c);
      };
      za.pluginName = Bc;
      var w1 = function(M, D) {
        var I = D.instance, U = D.row, X = I.manualRowSelectedKey, _ = X === void 0 ? "isSelected" : X, le = !1;
        return U.original && U.original[_] ? le = !0 : le = U.isSelected, [M, {
          onChange: function(Re) {
            U.toggleRowSelected(Re.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: le,
          title: "Toggle Row Selected",
          indeterminate: U.isSomeSelected
        }];
      }, Ha = function(M, D) {
        var I = D.instance;
        return [M, {
          onChange: function(X) {
            I.toggleAllRowsSelected(X.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: I.isAllRowsSelected,
          title: "Toggle All Rows Selected",
          indeterminate: !!(!I.isAllRowsSelected && Object.keys(I.state.selectedRowIds).length)
        }];
      }, S1 = function(M, D) {
        var I = D.instance;
        return [M, {
          onChange: function(X) {
            I.toggleAllPageRowsSelected(X.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: I.isAllPageRowsSelected,
          title: "Toggle All Current Page Rows Selected",
          indeterminate: !!(!I.isAllPageRowsSelected && I.page.some(function(U) {
            var X = U.id;
            return I.state.selectedRowIds[X];
          }))
        }];
      };
      function E1(w, M, D, I) {
        if (M.type === g.init)
          return a({
            selectedRowIds: {}
          }, w);
        if (M.type === g.resetSelectedRows)
          return a({}, w, {
            selectedRowIds: I.initialState.selectedRowIds || {}
          });
        if (M.type === g.toggleAllRowsSelected) {
          var U = M.value, X = I.isAllRowsSelected, _ = I.rowsById, le = I.nonGroupedRowsById, he = le === void 0 ? _ : le, Re = typeof U < "u" ? U : !X, $e = Object.assign({}, w.selectedRowIds);
          return Re ? Object.keys(he).forEach(function(ln) {
            $e[ln] = !0;
          }) : Object.keys(he).forEach(function(ln) {
            delete $e[ln];
          }), a({}, w, {
            selectedRowIds: $e
          });
        }
        if (M.type === g.toggleRowSelected) {
          var nt = M.id, ze = M.value, Xe = I.rowsById, rt = I.selectSubRows, _e = rt === void 0 ? !0 : rt, ht = I.getSubRows, It = w.selectedRowIds[nt], Ht = typeof ze < "u" ? ze : !It;
          if (It === Ht)
            return w;
          var lt = a({}, w.selectedRowIds), on = function ln(Yt) {
            var Kt = Xe[Yt];
            if (Kt && (Kt.isGrouped || (Ht ? lt[Yt] = !0 : delete lt[Yt]), _e && ht(Kt)))
              return ht(Kt).forEach(function(Nn) {
                return ln(Nn.id);
              });
          };
          return on(nt), a({}, w, {
            selectedRowIds: lt
          });
        }
        if (M.type === g.toggleAllPageRowsSelected) {
          var pn = M.value, dt = I.page, at = I.rowsById, pt = I.selectSubRows, Mt = pt === void 0 ? !0 : pt, sn = I.isAllPageRowsSelected, an = I.getSubRows, Vn = typeof pn < "u" ? pn : !sn, wt = a({}, w.selectedRowIds), To = function ln(Yt) {
            var Kt = at[Yt];
            if (Kt.isGrouped || (Vn ? wt[Yt] = !0 : delete wt[Yt]), Mt && an(Kt))
              return an(Kt).forEach(function(Nn) {
                return ln(Nn.id);
              });
          };
          return dt.forEach(function(ln) {
            return To(ln.id);
          }), a({}, w, {
            selectedRowIds: wt
          });
        }
        return w;
      }
      function R1(w) {
        var M = w.data, D = w.rows, I = w.getHooks, U = w.plugins, X = w.rowsById, _ = w.nonGroupedRowsById, le = _ === void 0 ? X : _, he = w.autoResetSelectedRows, Re = he === void 0 ? !0 : he, $e = w.state.selectedRowIds, nt = w.selectSubRows, ze = nt === void 0 ? !0 : nt, Xe = w.dispatch, rt = w.page, _e = w.getSubRows;
        k(U, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
        var ht = r.useMemo(function() {
          var sn = [];
          return D.forEach(function(an) {
            var Vn = ze ? zc(an, $e, _e) : !!$e[an.id];
            an.isSelected = !!Vn, an.isSomeSelected = Vn === null, Vn && sn.push(an);
          }), sn;
        }, [D, ze, $e, _e]), It = !!(Object.keys(le).length && Object.keys($e).length), Ht = It;
        It && Object.keys(le).some(function(sn) {
          return !$e[sn];
        }) && (It = !1), It || rt && rt.length && rt.some(function(sn) {
          var an = sn.id;
          return !$e[an];
        }) && (Ht = !1);
        var lt = P(Re);
        j(function() {
          lt() && Xe({
            type: g.resetSelectedRows
          });
        }, [Xe, M]);
        var on = r.useCallback(function(sn) {
          return Xe({
            type: g.toggleAllRowsSelected,
            value: sn
          });
        }, [Xe]), pn = r.useCallback(function(sn) {
          return Xe({
            type: g.toggleAllPageRowsSelected,
            value: sn
          });
        }, [Xe]), dt = r.useCallback(function(sn, an) {
          return Xe({
            type: g.toggleRowSelected,
            id: sn,
            value: an
          });
        }, [Xe]), at = P(w), pt = C(I().getToggleAllRowsSelectedProps, {
          instance: at()
        }), Mt = C(I().getToggleAllPageRowsSelectedProps, {
          instance: at()
        });
        Object.assign(w, {
          selectedFlatRows: ht,
          isAllRowsSelected: It,
          isAllPageRowsSelected: Ht,
          toggleRowSelected: dt,
          toggleAllRowsSelected: on,
          getToggleAllRowsSelectedProps: pt,
          getToggleAllPageRowsSelectedProps: Mt,
          toggleAllPageRowsSelected: pn
        });
      }
      function _c(w, M) {
        var D = M.instance;
        w.toggleRowSelected = function(I) {
          return D.toggleRowSelected(w.id, I);
        }, w.getToggleRowSelectedProps = C(D.getHooks().getToggleRowSelectedProps, {
          instance: D,
          row: w
        });
      }
      function zc(w, M, D) {
        if (M[w.id])
          return !0;
        var I = D(w);
        if (I && I.length) {
          var U = !0, X = !1;
          return I.forEach(function(_) {
            X && !U || (zc(_, M, D) ? X = !0 : U = !1);
          }), U ? !0 : X ? null : !1;
        }
        return !1;
      }
      var Hc = function(M) {
        return {};
      }, Wc = function(M) {
        return {};
      };
      g.setRowState = "setRowState", g.setCellState = "setCellState", g.resetRowState = "resetRowState";
      var Gc = function(M) {
        M.stateReducers.push(Wa), M.useInstance.push(x), M.prepareRow.push(O);
      };
      Gc.pluginName = "useRowState";
      function Wa(w, M, D, I) {
        var U = I.initialRowStateAccessor, X = U === void 0 ? Hc : U, _ = I.initialCellStateAccessor, le = _ === void 0 ? Wc : _, he = I.rowsById;
        if (M.type === g.init)
          return a({
            rowState: {}
          }, w);
        if (M.type === g.resetRowState)
          return a({}, w, {
            rowState: I.initialState.rowState || {}
          });
        if (M.type === g.setRowState) {
          var Re, $e = M.rowId, nt = M.value, ze = typeof w.rowState[$e] < "u" ? w.rowState[$e] : X(he[$e]);
          return a({}, w, {
            rowState: a({}, w.rowState, (Re = {}, Re[$e] = T(nt, ze), Re))
          });
        }
        if (M.type === g.setCellState) {
          var Xe, rt, _e, ht, It, Ht = M.rowId, lt = M.columnId, on = M.value, pn = typeof w.rowState[Ht] < "u" ? w.rowState[Ht] : X(he[Ht]), dt = typeof (pn == null || (Xe = pn.cellState) == null ? void 0 : Xe[lt]) < "u" ? pn.cellState[lt] : le((rt = he[Ht]) == null || (_e = rt.cells) == null ? void 0 : _e.find(function(at) {
            return at.column.id === lt;
          }));
          return a({}, w, {
            rowState: a({}, w.rowState, (It = {}, It[Ht] = a({}, pn, {
              cellState: a({}, pn.cellState || {}, (ht = {}, ht[lt] = T(on, dt), ht))
            }), It))
          });
        }
      }
      function x(w) {
        var M = w.autoResetRowState, D = M === void 0 ? !0 : M, I = w.data, U = w.dispatch, X = r.useCallback(function(he, Re) {
          return U({
            type: g.setRowState,
            rowId: he,
            value: Re
          });
        }, [U]), _ = r.useCallback(function(he, Re, $e) {
          return U({
            type: g.setCellState,
            rowId: he,
            columnId: Re,
            value: $e
          });
        }, [U]), le = P(D);
        j(function() {
          le() && U({
            type: g.resetRowState
          });
        }, [I]), Object.assign(w, {
          setRowState: X,
          setCellState: _
        });
      }
      function O(w, M) {
        var D = M.instance, I = D.initialRowStateAccessor, U = I === void 0 ? Hc : I, X = D.initialCellStateAccessor, _ = X === void 0 ? Wc : X, le = D.state.rowState;
        w && (w.state = typeof le[w.id] < "u" ? le[w.id] : U(w), w.setState = function(he) {
          return D.setRowState(w.id, he);
        }, w.cells.forEach(function(he) {
          w.state.cellState || (w.state.cellState = {}), he.state = typeof w.state.cellState[he.column.id] < "u" ? w.state.cellState[he.column.id] : _(he), he.setState = function(Re) {
            return D.setCellState(w.id, he.column.id, Re);
          };
        }));
      }
      g.resetColumnOrder = "resetColumnOrder", g.setColumnOrder = "setColumnOrder";
      var $ = function(M) {
        M.stateReducers.push(N), M.visibleColumnsDeps.push(function(D, I) {
          var U = I.instance;
          return [].concat(D, [U.state.columnOrder]);
        }), M.visibleColumns.push(ne), M.useInstance.push(q);
      };
      $.pluginName = "useColumnOrder";
      function N(w, M, D, I) {
        if (M.type === g.init)
          return a({
            columnOrder: []
          }, w);
        if (M.type === g.resetColumnOrder)
          return a({}, w, {
            columnOrder: I.initialState.columnOrder || []
          });
        if (M.type === g.setColumnOrder)
          return a({}, w, {
            columnOrder: T(M.columnOrder, w.columnOrder)
          });
      }
      function ne(w, M) {
        var D = M.instance.state.columnOrder;
        if (!D || !D.length)
          return w;
        for (var I = [].concat(D), U = [].concat(w), X = [], _ = function() {
          var he = I.shift(), Re = U.findIndex(function($e) {
            return $e.id === he;
          });
          Re > -1 && X.push(U.splice(Re, 1)[0]);
        }; U.length && I.length; )
          _();
        return [].concat(X, U);
      }
      function q(w) {
        var M = w.dispatch;
        w.setColumnOrder = r.useCallback(function(D) {
          return M({
            type: g.setColumnOrder,
            columnOrder: D
          });
        }, [M]);
      }
      v.canResize = !0, g.columnStartResizing = "columnStartResizing", g.columnResizing = "columnResizing", g.columnDoneResizing = "columnDoneResizing", g.resetResize = "resetResize";
      var ae = function(M) {
        M.getResizerProps = [Ee], M.getHeaderProps.push({
          style: {
            position: "relative"
          }
        }), M.stateReducers.push(Me), M.useInstance.push(et), M.useInstanceBeforeDimensions.push(De);
      }, Ee = function(M, D) {
        var I = D.instance, U = D.header, X = I.dispatch, _ = function(he, Re) {
          var $e = !1;
          if (he.type === "touchstart") {
            if (he.touches && he.touches.length > 1)
              return;
            $e = !0;
          }
          var nt = Ye(Re), ze = nt.map(function(dt) {
            return [dt.id, dt.totalWidth];
          }), Xe = $e ? Math.round(he.touches[0].clientX) : he.clientX, rt, _e, ht = function() {
            window.cancelAnimationFrame(rt), rt = null, X({
              type: g.columnDoneResizing
            });
          }, It = function() {
            window.cancelAnimationFrame(rt), rt = null, X({
              type: g.columnResizing,
              clientX: _e
            });
          }, Ht = function(at) {
            _e = at, rt || (rt = window.requestAnimationFrame(It));
          }, lt = {
            mouse: {
              moveEvent: "mousemove",
              moveHandler: function(at) {
                return Ht(at.clientX);
              },
              upEvent: "mouseup",
              upHandler: function(at) {
                document.removeEventListener("mousemove", lt.mouse.moveHandler), document.removeEventListener("mouseup", lt.mouse.upHandler), ht();
              }
            },
            touch: {
              moveEvent: "touchmove",
              moveHandler: function(at) {
                return at.cancelable && (at.preventDefault(), at.stopPropagation()), Ht(at.touches[0].clientX), !1;
              },
              upEvent: "touchend",
              upHandler: function(at) {
                document.removeEventListener(lt.touch.moveEvent, lt.touch.moveHandler), document.removeEventListener(lt.touch.upEvent, lt.touch.moveHandler), ht();
              }
            }
          }, on = $e ? lt.touch : lt.mouse, pn = de() ? {
            passive: !1
          } : !1;
          document.addEventListener(on.moveEvent, on.moveHandler, pn), document.addEventListener(on.upEvent, on.upHandler, pn), X({
            type: g.columnStartResizing,
            columnId: Re.id,
            columnWidth: Re.totalWidth,
            headerIdWidths: ze,
            clientX: Xe
          });
        };
        return [M, {
          onMouseDown: function(he) {
            return he.persist() || _(he, U);
          },
          onTouchStart: function(he) {
            return he.persist() || _(he, U);
          },
          style: {
            cursor: "col-resize"
          },
          draggable: !1,
          role: "separator"
        }];
      };
      ae.pluginName = "useResizeColumns";
      function Me(w, M) {
        if (M.type === g.init)
          return a({
            columnResizing: {
              columnWidths: {}
            }
          }, w);
        if (M.type === g.resetResize)
          return a({}, w, {
            columnResizing: {
              columnWidths: {}
            }
          });
        if (M.type === g.columnStartResizing) {
          var D = M.clientX, I = M.columnId, U = M.columnWidth, X = M.headerIdWidths;
          return a({}, w, {
            columnResizing: a({}, w.columnResizing, {
              startX: D,
              headerIdWidths: X,
              columnWidth: U,
              isResizingColumn: I
            })
          });
        }
        if (M.type === g.columnResizing) {
          var _ = M.clientX, le = w.columnResizing, he = le.startX, Re = le.columnWidth, $e = le.headerIdWidths, nt = $e === void 0 ? [] : $e, ze = _ - he, Xe = ze / Re, rt = {};
          return nt.forEach(function(_e) {
            var ht = _e[0], It = _e[1];
            rt[ht] = Math.max(It + It * Xe, 0);
          }), a({}, w, {
            columnResizing: a({}, w.columnResizing, {
              columnWidths: a({}, w.columnResizing.columnWidths, {}, rt)
            })
          });
        }
        if (M.type === g.columnDoneResizing)
          return a({}, w, {
            columnResizing: a({}, w.columnResizing, {
              startX: null,
              isResizingColumn: null
            })
          });
      }
      var De = function(M) {
        var D = M.flatHeaders, I = M.disableResizing, U = M.getHooks, X = M.state.columnResizing, _ = P(M);
        D.forEach(function(le) {
          var he = pe(le.disableResizing === !0 ? !1 : void 0, I === !0 ? !1 : void 0, !0);
          le.canResize = he, le.width = X.columnWidths[le.id] || le.originalWidth || le.width, le.isResizing = X.isResizingColumn === le.id, he && (le.getResizerProps = C(U().getResizerProps, {
            instance: _(),
            header: le
          }));
        });
      };
      function et(w) {
        var M = w.plugins, D = w.dispatch, I = w.autoResetResize, U = I === void 0 ? !0 : I, X = w.columns;
        k(M, ["useAbsoluteLayout"], "useResizeColumns");
        var _ = P(U);
        j(function() {
          _() && D({
            type: g.resetResize
          });
        }, [X]);
        var le = r.useCallback(function() {
          return D({
            type: g.resetResize
          });
        }, [D]);
        Object.assign(w, {
          resetResizing: le
        });
      }
      function Ye(w) {
        var M = [], D = function I(U) {
          U.columns && U.columns.length && U.columns.map(I), M.push(U);
        };
        return D(w), M;
      }
      var Ze = {
        position: "absolute",
        top: 0
      }, Be = function(M) {
        M.getTableBodyProps.push(Ue), M.getRowProps.push(Ue), M.getHeaderGroupProps.push(Ue), M.getFooterGroupProps.push(Ue), M.getHeaderProps.push(function(D, I) {
          var U = I.column;
          return [D, {
            style: a({}, Ze, {
              left: U.totalLeft + "px",
              width: U.totalWidth + "px"
            })
          }];
        }), M.getCellProps.push(function(D, I) {
          var U = I.cell;
          return [D, {
            style: a({}, Ze, {
              left: U.column.totalLeft + "px",
              width: U.column.totalWidth + "px"
            })
          }];
        }), M.getFooterProps.push(function(D, I) {
          var U = I.column;
          return [D, {
            style: a({}, Ze, {
              left: U.totalLeft + "px",
              width: U.totalWidth + "px"
            })
          }];
        });
      };
      Be.pluginName = "useAbsoluteLayout";
      var Ue = function(M, D) {
        var I = D.instance;
        return [M, {
          style: {
            position: "relative",
            width: I.totalColumnsWidth + "px"
          }
        }];
      }, st = {
        display: "inline-block",
        boxSizing: "border-box"
      }, ut = function(M, D) {
        var I = D.instance;
        return [M, {
          style: {
            display: "flex",
            width: I.totalColumnsWidth + "px"
          }
        }];
      }, Rt = function(M) {
        M.getRowProps.push(ut), M.getHeaderGroupProps.push(ut), M.getFooterGroupProps.push(ut), M.getHeaderProps.push(function(D, I) {
          var U = I.column;
          return [D, {
            style: a({}, st, {
              width: U.totalWidth + "px"
            })
          }];
        }), M.getCellProps.push(function(D, I) {
          var U = I.cell;
          return [D, {
            style: a({}, st, {
              width: U.column.totalWidth + "px"
            })
          }];
        }), M.getFooterProps.push(function(D, I) {
          var U = I.column;
          return [D, {
            style: a({}, st, {
              width: U.totalWidth + "px"
            })
          }];
        });
      };
      Rt.pluginName = "useBlockLayout";
      function rn(w) {
        w.getTableProps.push(Tt), w.getRowProps.push(tt), w.getHeaderGroupProps.push(tt), w.getFooterGroupProps.push(tt), w.getHeaderProps.push(en), w.getCellProps.push(Ct), w.getFooterProps.push(qt);
      }
      rn.pluginName = "useFlexLayout";
      var Tt = function(M, D) {
        var I = D.instance;
        return [M, {
          style: {
            minWidth: I.totalColumnsMinWidth + "px"
          }
        }];
      }, tt = function(M, D) {
        var I = D.instance;
        return [M, {
          style: {
            display: "flex",
            flex: "1 0 auto",
            minWidth: I.totalColumnsMinWidth + "px"
          }
        }];
      }, en = function(M, D) {
        var I = D.column;
        return [M, {
          style: {
            boxSizing: "border-box",
            flex: I.totalFlexWidth ? I.totalFlexWidth + " 0 auto" : void 0,
            minWidth: I.totalMinWidth + "px",
            width: I.totalWidth + "px"
          }
        }];
      }, Ct = function(M, D) {
        var I = D.cell;
        return [M, {
          style: {
            boxSizing: "border-box",
            flex: I.column.totalFlexWidth + " 0 auto",
            minWidth: I.column.totalMinWidth + "px",
            width: I.column.totalWidth + "px"
          }
        }];
      }, qt = function(M, D) {
        var I = D.column;
        return [M, {
          style: {
            boxSizing: "border-box",
            flex: I.totalFlexWidth ? I.totalFlexWidth + " 0 auto" : void 0,
            minWidth: I.totalMinWidth + "px",
            width: I.totalWidth + "px"
          }
        }];
      };
      g.columnStartResizing = "columnStartResizing", g.columnResizing = "columnResizing", g.columnDoneResizing = "columnDoneResizing", g.resetResize = "resetResize";
      function fn(w) {
        w.stateReducers.push(Jt), w.getTableProps.push(_t), w.getHeaderProps.push(Ut), w.getRowProps.push(En);
      }
      fn.pluginName = "useGridLayout";
      var _t = function(M, D) {
        var I = D.instance, U = I.visibleColumns.map(function(X) {
          var _;
          return I.state.gridLayout.columnWidths[X.id] ? I.state.gridLayout.columnWidths[X.id] + "px" : (_ = I.state.columnResizing) != null && _.isResizingColumn ? I.state.gridLayout.startWidths[X.id] + "px" : typeof X.width == "number" ? X.width + "px" : X.width;
        });
        return [M, {
          style: {
            display: "grid",
            gridTemplateColumns: U.join(" ")
          }
        }];
      }, Ut = function(M, D) {
        var I = D.column;
        return [M, {
          id: "header-cell-" + I.id,
          style: {
            position: "sticky",
            //enables a scroll wrapper to be placed around the table and have sticky headers
            gridColumn: "span " + I.totalVisibleHeaderCount
          }
        }];
      }, En = function(M, D) {
        var I = D.row;
        return I.isExpanded ? [M, {
          style: {
            gridColumn: "1 / " + (I.cells.length + 1)
          }
        }] : [M, {}];
      };
      function Jt(w, M, D, I) {
        if (M.type === g.init)
          return a({
            gridLayout: {
              columnWidths: {}
            }
          }, w);
        if (M.type === g.resetResize)
          return a({}, w, {
            gridLayout: {
              columnWidths: {}
            }
          });
        if (M.type === g.columnStartResizing) {
          var U = M.columnId, X = M.headerIdWidths, _ = bn(U);
          if (_ !== void 0) {
            var le = I.visibleColumns.reduce(function(dt, at) {
              var pt;
              return a({}, dt, (pt = {}, pt[at.id] = bn(at.id), pt));
            }, {}), he = I.visibleColumns.reduce(function(dt, at) {
              var pt;
              return a({}, dt, (pt = {}, pt[at.id] = at.minWidth, pt));
            }, {}), Re = I.visibleColumns.reduce(function(dt, at) {
              var pt;
              return a({}, dt, (pt = {}, pt[at.id] = at.maxWidth, pt));
            }, {}), $e = X.map(function(dt) {
              var at = dt[0];
              return [at, bn(at)];
            });
            return a({}, w, {
              gridLayout: a({}, w.gridLayout, {
                startWidths: le,
                minWidths: he,
                maxWidths: Re,
                headerIdGridWidths: $e,
                columnWidth: _
              })
            });
          } else
            return w;
        }
        if (M.type === g.columnResizing) {
          var nt = M.clientX, ze = w.columnResizing.startX, Xe = w.gridLayout, rt = Xe.columnWidth, _e = Xe.minWidths, ht = Xe.maxWidths, It = Xe.headerIdGridWidths, Ht = It === void 0 ? [] : It, lt = nt - ze, on = lt / rt, pn = {};
          return Ht.forEach(function(dt) {
            var at = dt[0], pt = dt[1];
            pn[at] = Math.min(Math.max(_e[at], pt + pt * on), ht[at]);
          }), a({}, w, {
            gridLayout: a({}, w.gridLayout, {
              columnWidths: a({}, w.gridLayout.columnWidths, {}, pn)
            })
          });
        }
        if (M.type === g.columnDoneResizing)
          return a({}, w, {
            gridLayout: a({}, w.gridLayout, {
              startWidths: {},
              minWidths: {},
              maxWidths: {}
            })
          });
      }
      function bn(w) {
        var M, D = (M = document.getElementById("header-cell-" + w)) == null ? void 0 : M.offsetWidth;
        if (D !== void 0)
          return D;
      }
      n._UNSTABLE_usePivotColumns = $c, n.actions = g, n.defaultColumn = v, n.defaultGroupByFn = Mc, n.defaultOrderByFn = Aa, n.defaultRenderer = h, n.emptyRenderer = y, n.ensurePluginOrder = k, n.flexRender = V, n.functionalUpdate = T, n.loopHooks = S, n.makePropGetter = C, n.makeRenderer = R, n.reduceHooks = E, n.safeUseLayoutEffect = F, n.useAbsoluteLayout = Be, n.useAsyncDebounce = L, n.useBlockLayout = Rt, n.useColumnOrder = $, n.useExpanded = cn, n.useFilters = Xn, n.useFlexLayout = rn, n.useGetLatest = P, n.useGlobalFilter = di, n.useGridLayout = fn, n.useGroupBy = Lo, n.useMountedLayoutEffect = j, n.usePagination = Fc, n.useResizeColumns = ae, n.useRowSelect = za, n.useRowState = Gc, n.useSortBy = Oc, n.useTable = $t, Object.defineProperty(n, "__esModule", { value: !0 });
    });
  }(gu, gu.exports)), gu.exports;
}
process.env.NODE_ENV === "production" ? np.exports = eF() : np.exports = tF();
var ul = np.exports;
const nF = Z("div")`
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme: e }) => {
  var t;
  return Jn(0.5, (t = e.palette) == null ? void 0 : t.primary.main);
}};
`, mh = ({
  addButtonText: e,
  onAdd: t,
  className: n = "",
  size: r = "small",
  noDataText: i,
  dark: s,
  buttonName: a
}) => /* @__PURE__ */ p.jsxs(
  Tn,
  {
    container: !0,
    justifyContent: "space-around",
    p: 4,
    className: n + " empty-table-stub",
    children: [
      /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, textAlign: "center", children: /* @__PURE__ */ p.jsx(
        qn,
        {
          iconName: "emptyTable",
          sx: { fontSize: r === "small" ? 70 : 160 },
          color: s ? "primary" : void 0
        }
      ) }),
      /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, textAlign: "center", mt: 1, children: /* @__PURE__ */ p.jsx(nF, { children: i || "" }) }),
      e && t && /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, textAlign: "center", mt: 1, children: /* @__PURE__ */ p.jsx(
        Gs,
        {
          size: "small",
          variant: "outlined",
          onClick: t,
          color: s ? "primary" : "info",
          startIcon: /* @__PURE__ */ p.jsx(qn, { iconName: "add" }),
          className: "create-" + a,
          sx: (l) => ({
            fontSize: { small: 14, medium: 16 }[r] || 14,
            px: 1.5,
            height: 32,
            fontWeight: 700,
            borderColor: l.palette.borderColor.main,
            ...s && { color: l.palette.primary.main }
          }),
          children: e
        }
      ) })
    ]
  }
), oF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        fill: "evenodd",
        d: "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
      }
    )
  }
), rF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "folder",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        d: `M147.4,77.4c-1.6-1.7-3.9-2.7-6.3-2.7h-33.7V20.5c0-2.9-1.2-5.6-3-7.4c-1.8-1.9-4.4-3.1-7.2-3.1H50.5
	c-2.1,0-4.2,0.9-5.7,2.5L12.4,46.7c-1.1,1.2-1.9,2.7-2.2,4.3c0,0.2-0.1,0.4-0.1,0.6C10,51.9,10,52.3,10,52.7v74.5
	c0,2.8,1.1,5.4,2.9,7.2c1.8,1.9,4.3,3,7.1,3h8.5v1.9c0,2.9,1.2,5.6,3,7.5c1.9,1.9,4.5,3.1,7.3,3.1h101.9c2.6,0,4.9-1.1,6.6-2.8
	c1.7-1.7,2.7-4.1,2.7-6.7V83.9C150,81.3,149,79,147.4,77.4L147.4,77.4z M46.9,49.6H21.2l25.6-27V49.6z M20,129.5
	c-0.6,0-1.1-0.2-1.5-0.7c-0.4-0.4-0.6-1-0.6-1.6V57.6h31.6c1.5,0,2.8-0.6,3.7-1.6c1-1,1.5-2.3,1.5-3.8V18h42.5
	c0.7,0,1.3,0.3,1.8,0.7c0.4,0.5,0.7,1.1,0.7,1.8v54.2h-8.5l-9.7-10l0,0c-1.3-1.4-3.2-2.2-5.1-2.2h0l-35.1,0.2c-3.5,0-6.7,1.5-9,3.9
	c-2.3,2.4-3.7,5.7-3.7,9.3v53.6H20L20,129.5z M142.2,140.5c0,0.4-0.2,0.8-0.4,1.1c-0.3,0.3-0.6,0.4-1.1,0.4H38.8
	c-0.7,0-1.3-0.3-1.8-0.8c-0.5-0.5-0.8-1.1-0.8-1.9V76c0-1.4,0.6-2.7,1.5-3.7c0.9-0.9,2.2-1.5,3.5-1.5l34.9-0.2l9.7,9.9
	c1.4,1.4,3.3,2.2,5.2,2.2h50.1c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.3,0.5,0.3,0.8L142.2,140.5L142.2,140.5z`
      }
    )
  }
), iF = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M8 2V14", stroke: "currentColor", strokeWidth: 2.78571, strokeLinecap: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M14 8L2 8", stroke: "currentColor", strokeWidth: 2.78571, strokeLinecap: "round" })), e0 = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M9.50006 15.9687C7.68564 15.9687 6.04651 15.2178 4.87428 14.0094C4.8565 14.0255 2.73589 16.1559 2.7179 16.1689C6.23794 19.9354 12.7307 19.9449 16.2619 16.1899L14.1056 14.0302C12.9348 15.2263 11.3041 15.9687 9.50006 15.9687Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M3.04837 9.50255C3.04837 6.13073 5.62352 3.36217 8.91017 3.06352L8.9088 0C1.42263 0.371836 -2.66178 9.38117 1.94255 15.2716L4.13337 13.0922C3.44818 12.0653 3.04837 10.8308 3.04837 9.50255Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M10.0912 0C10.0898 0.0352962 10.0938 3.03016 10.0898 3.06352C14.8983 3.43703 17.6036 9.1367 14.8533 13.1125L17.0396 15.2949C21.6716 9.40681 17.5881 0.371799 10.0912 0Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8.41724 8.47984V11.8948H10.1514V8.47984C10.1514 8.29013 9.99778 8.13635 9.80832 8.13635H8.76031C8.57082 8.13635 8.41724 8.29013 8.41724 8.47984Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M12.9519 11.5447V6.5803C12.9519 6.3906 12.7984 6.23682 12.6089 6.23682H11.5609C11.3715 6.23682 11.2179 6.3906 11.2179 6.5803V11.8947H12.6024C12.7954 11.8947 12.9519 11.738 12.9519 11.5447Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M5.99758 9.84534C5.80812 9.84534 5.65454 9.99912 5.65454 10.1888V11.5446C5.65454 11.738 5.81105 11.8947 6.00415 11.8947H7.35156V10.1888C7.35156 9.99912 7.19798 9.84534 7.00852 9.84534H5.99758Z", fill: "currentColor" })), sF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    "data-testid": "ChatBubbleIcon",
    ref: t,
    ...n,
    children: /* @__PURE__ */ p.jsx("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" })
  }
), aF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "selected-checkbox",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        fill: "evenodd",
        d: `M127.6,48.4c0.3,0.6,0.4,1,0.4,1.3s-0.1,0.7-0.4,1.3l-53.9,69.2c-0.9,0.9-1.5,1.3-1.9,1.3
	c-0.7,0-1.4-0.4-2.2-1.1L39.1,91l-0.7-0.7c-0.3-0.6-0.4-1-0.4-1.3c0-0.1,0.1-0.5,0.4-1.1l0.4-0.4c4-4.3,7.2-7.6,9.5-9.9
	c0.9-0.9,1.4-1.3,1.7-1.3c0.6,0,1.3,0.4,2.2,1.3l17.3,16.9l43.3-55.6c0.3-0.3,0.7-0.4,1.3-0.4c0.4,0,0.9,0.1,1.5,0.4L127.6,48.4
	L127.6,48.4z`
      }
    )
  }
), lF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "empty-checkbox",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: [
      /* @__PURE__ */ p.jsx(
        "path",
        {
          fill: "#AEBBD4",
          d: `M141.2,18.7H18.8v122.5h122.5V18.7z M141.2,10c4.8,0,8.8,3.9,8.8,8.7v122.5c0,4.8-3.9,8.8-8.8,8.8H18.8
	c-4.8,0-8.8-3.9-8.8-8.8V18.7c0-4.8,3.9-8.7,8.8-8.7H141.2z`
        }
      ),
      /* @__PURE__ */ p.jsx("rect", { x: "18.8", y: "18.7", fill: "#FFFFFF", width: "122.5", height: "122.5" })
    ]
  }
), cF = ({
  plain: e,
  ref: t,
  ...n
}) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "indeterminate-checkbox",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: [
      /* @__PURE__ */ p.jsx(
        "path",
        {
          fill: "#AEBBD4",
          d: `M141.2,18.7H18.8v122.5h122.5V18.7z M141.2,10c4.8,0,8.8,3.9,8.8,8.7v122.5c0,4.8-3.9,8.8-8.8,8.8H18.8
	c-4.8,0-8.8-3.9-8.8-8.8V18.7c0-4.8,3.9-8.7,8.8-8.7H141.2z`
        }
      ),
      /* @__PURE__ */ p.jsx("rect", { x: "18.8", y: "18.8", fill: "#FFFFFF", width: "122.5", height: "122.5" }),
      /* @__PURE__ */ p.jsx(
        "path",
        {
          fill: "#5C75A8",
          d: `M36.3,70.5h87.3c1.1,0,2,0.9,2,2v15c0,1.1-0.9,2-2,2H36.3c-1.1,0-2-0.9-2-2v-15C34.3,71.4,35.2,70.5,36.3,70.5z
	`
        }
      )
    ]
  }
), uF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "selected-checkbox",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: [
      /* @__PURE__ */ p.jsx(
        "path",
        {
          fill: "#AEBBD4",
          d: `M143.8,18.7H21.3v122.5h122.5V18.7z M143.8,10c4.8,0,8.8,3.9,8.8,8.7v122.5c0,4.8-3.9,8.8-8.8,8.8H21.3
	c-4.8,0-8.8-3.9-8.8-8.8V18.7c0-4.8,3.9-8.7,8.8-8.7H143.8z`
        }
      ),
      /* @__PURE__ */ p.jsx("rect", { x: "21.3", y: "18.8", fill: "#FFFFFF", width: "122.5", height: "122.5" }),
      /* @__PURE__ */ p.jsx(
        "path",
        {
          fill: "#5C75A8",
          d: `M127.6,48.4c0.3,0.6,0.4,1,0.4,1.3s-0.1,0.7-0.4,1.3l-53.9,69.2c-0.9,0.9-1.5,1.3-1.9,1.3
	c-0.7,0-1.4-0.4-2.2-1.1L39.1,91l-0.7-0.7c-0.3-0.6-0.4-1-0.4-1.3c0-0.1,0.1-0.5,0.4-1.1l0.4-0.4c4-4.3,7.2-7.6,9.5-9.9
	c0.9-0.9,1.4-1.3,1.7-1.3c0.6,0,1.3,0.4,2.2,1.3l17.3,16.9l43.3-55.6c0.3-0.3,0.7-0.4,1.3-0.4c0.4,0,0.9,0.1,1.5,0.4L127.6,48.4
	L127.6,48.4z`
        }
      )
    ]
  }
), dF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "chevron",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        fill: "evenodd",
        d: `M148.6,43.9c-1.9-1.9-4.9-1.9-6.7,0c0,0,0,0,0,0l-61.7,62l-62-61.7c-1.7-2-4.7-2.2-6.7-0.5
	c-2,1.7-2.2,4.7-0.5,6.7c0.2,0.2,0.3,0.4,0.5,0.5l65.3,65c0,0,0,0.1,0.1,0.1c0.7,0.7,1.5,1.1,2.5,1.3c1.6,0.3,3.2-0.2,4.3-1.3
	l0.1-0.1l65-65.2C150.5,48.8,150.5,45.8,148.6,43.9C148.6,43.9,148.6,43.9,148.6,43.9z`
      }
    )
  }
), pF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: `M147.1,42.9c-3.8-3.8-10-3.8-13.8,0L80.1,96.4L26.6,43.2c-3.8-3.8-10-3.8-13.8,0s-3.8,10,0,13.8l60.2,60
   l0.1,0.1c3.8,3.8,10,3.8,13.8,0l0.2-0.2l59.9-60.2C151,52.9,150.9,46.7,147.1,42.9z`
      }
    )
  }
), fF = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 8", fill: "none", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M7.40107 2.63201L4.38269 5.83904C4.17519 6.05951 3.82482 6.05951 3.61732 5.83904L0.598915 2.63201C0.37214 2.39104 0.542965 1.99564 0.873865 1.99564H7.12609C7.45702 1.99564 7.62784 2.39104 7.40107 2.63201Z", fill: "currentColor" })), gF = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 9 9", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M2.9,4.315l-2.51,-2.51c-0.39,-0.391 -0.39,-1.024 0,-1.415c0.391,-0.39 1.024,-0.39 1.414,0l2.511,2.51l2.607,-2.607c0.391,-0.391 1.024,-0.391 1.415,-0c0.39,0.39 0.39,1.024 -0,1.414l-2.608,2.608l2.51,2.51c0.39,0.39 0.39,1.024 0,1.414c-0.39,0.39 -1.024,0.39 -1.414,0l-2.51,-2.51l-2.608,2.608c-0.39,0.39 -1.024,0.39 -1.414,-0c-0.391,-0.391 -0.391,-1.024 -0,-1.415l2.607,-2.607Z" })), mF = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M9.50012 4.35962C10.704 4.35962 11.6799 3.38368 11.6799 2.17981C11.6799 0.975934 10.704 0 9.50012 0C8.29625 0 7.32031 0.975934 7.32031 2.17981C7.32031 3.38368 8.29625 4.35962 9.50012 4.35962Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M12.1613 5.25708H9.50021H6.83909C5.98093 5.25708 5.28528 5.95273 5.28528 6.81089V10.0813V12.616C5.28528 13.1173 5.69166 13.5237 6.19298 13.5237C6.69429 13.5237 7.10067 13.1173 7.10067 12.616V19H8.94357V13.1548H10.0568V19H11.8997V12.616C11.8997 13.1173 12.3061 13.5237 12.8074 13.5237C13.3088 13.5237 13.7151 13.1173 13.7151 12.616V10.0813V6.81089C13.7151 5.95273 13.0195 5.25708 12.1613 5.25708Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M3.92809 5.35581C5.05005 5.35581 5.95957 4.44629 5.95957 3.32433C5.95957 2.20237 5.05005 1.29285 3.92809 1.29285C2.80613 1.29285 1.89661 2.20237 1.89661 3.32433C1.89661 4.44629 2.80613 5.35581 3.92809 5.35581Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.17177 12.6161V10.0814V6.81093C4.17177 6.72191 4.17637 6.63392 4.18491 6.54712H3.92815H1.44809C0.648339 6.54708 0 7.19542 0 7.99517V11.0431V13.4054C0 13.8726 0.378739 14.2513 0.845947 14.2513C1.31316 14.2513 1.69189 13.8726 1.69189 13.4054V19.0001H3.37151V13.6988H4.48479V19.0001H5.9872V14.6267C4.96899 14.5234 4.17177 13.6611 4.17177 12.6161Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M15.072 5.35581C16.194 5.35581 17.1035 4.44629 17.1035 3.32433C17.1035 2.20237 16.194 1.29285 15.072 1.29285C13.9501 1.29285 13.0405 2.20237 13.0405 3.32433C13.0405 4.44629 13.9501 5.35581 15.072 5.35581Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M17.5519 6.54712H15.0719H14.8151C14.8237 6.63392 14.8282 6.7219 14.8282 6.81093V10.0814V12.6161C14.8282 13.6611 14.031 14.5234 13.0128 14.6267V19.0001H14.5152V13.6988H15.6285V19.0001H17.3081V13.4054C17.3081 13.8726 17.6869 14.2513 18.1541 14.2513C18.6213 14.2513 19 13.8726 19 13.4054V11.0432V7.9952C19 7.19546 18.3517 6.54712 17.5519 6.54712Z", fill: "currentColor" })), hF = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 22 23", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("g", { transform: "matrix(1,0,0,1,-2.78737,-2.74489)" }, /* @__PURE__ */ d.createElement("g", { transform: "matrix(0.0299496,0,0,0.0299496,-6.73321,2.42777)" }, /* @__PURE__ */ d.createElement("path", { d: "M602.24,246.72C602.205,239.322 597.422,232.729 590.4,230.4L547.52,216C520.779,207.258 499.584,186.537 490.24,160L475.84,117.12C473.193,110.631 466.849,106.367 459.84,106.367C452.831,106.367 446.487,110.631 443.84,117.12L428.8,160C419.793,187.024 398.544,208.273 371.52,217.28L328.64,231.68C322.151,234.327 317.887,240.671 317.887,247.68C317.887,254.689 322.151,261.033 328.64,263.68L371.52,278.08C398.544,287.087 419.793,308.336 428.8,335.36L443.2,378.24C445.847,384.729 452.191,388.993 459.2,388.993C466.209,388.993 472.553,384.729 475.2,378.24L489.6,335.36C498.607,308.336 519.856,287.087 546.88,278.08L589.76,263.68C597.258,261.514 602.402,254.523 602.24,246.72Z" })), /* @__PURE__ */ d.createElement("g", { transform: "matrix(0.0299496,0,0,0.0299496,-3.4275,-7.032)" }, /* @__PURE__ */ d.createElement("path", { d: "M903.36,468.48L855.04,452.48C824.867,442.381 801.139,418.653 791.04,388.48L775.04,340.16C772.621,332.046 765.107,326.445 756.64,326.445C748.173,326.445 740.659,332.046 738.24,340.16L722.24,388.48C712.141,418.653 688.413,442.381 658.24,452.48L609.92,468.48C601.806,470.899 596.205,478.413 596.205,486.88C596.205,495.347 601.806,502.861 609.92,505.28L658.24,521.28C688.413,531.379 712.141,555.107 722.24,585.28L738.24,633.6C740.659,641.714 748.173,647.315 756.64,647.315C765.107,647.315 772.621,641.714 775.04,633.6L791.04,585.28C801.139,555.107 824.867,531.379 855.04,521.28L903.36,505.28C911.474,502.861 917.075,495.347 917.075,486.88C917.075,478.413 911.474,470.899 903.36,468.48Z" })), /* @__PURE__ */ d.createElement("g", { transform: "matrix(0.0299496,0,0,0.0299496,3.89281,-1.79927)" }, /* @__PURE__ */ d.createElement("path", { d: "M526.72,664L462.72,643.2C423.299,630.096 392.304,599.101 379.2,559.68L358.4,495.68C354.842,485.596 345.254,478.81 334.56,478.81C323.866,478.81 314.278,485.596 310.72,495.68L289.92,559.68C277.08,598.817 246.614,629.757 207.68,643.2L143.68,664C133.596,667.558 126.81,677.146 126.81,687.84C126.81,698.534 133.596,708.122 143.68,711.68L207.68,732.48C247.173,745.65 278.181,776.777 291.2,816.32L312,880.32C315.558,890.404 325.146,897.19 335.84,897.19C346.534,897.19 356.122,890.404 359.68,880.32L380.48,816.32C393.584,776.899 424.579,745.904 464,732.8L528,712C538.084,708.442 544.87,698.854 544.87,688.16C544.87,677.466 538.084,667.878 528,664.32L526.72,664Z" })))), vF = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 3", fill: "none", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0 1.5C0 0.671573 0.623603 0 1.39286 0H11.6071C12.3764 0 13 0.671573 13 1.5C13 2.32843 12.3764 3 11.6071 3H1.39286C0.623604 3 0 2.32843 0 1.5Z", fill: "currentColor" })), yF = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 17 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M4.90851 7.50536C4.81352 7.39136 4.67279 7.32544 4.52439 7.32544H0.5C0.223858 7.32544 0 7.5493 0 7.82544V17.5C0 17.7762 0.223858 18 0.5 18H15.5503C15.8265 18 16.0503 17.7762 16.0503 17.5V9.86063C16.0503 9.58449 15.8265 9.36063 15.5503 9.36063H6.68867C6.54028 9.36063 6.39955 9.29471 6.30455 9.18071L4.90851 7.50536ZM10.7777 15.6445C10.7777 15.3684 11.0016 15.1445 11.2777 15.1445H13.756C14.0322 15.1445 14.256 15.3684 14.256 15.6445V15.7032C14.256 15.9793 14.0322 16.2032 13.756 16.2032H11.2777C11.0016 16.2032 10.7777 15.9793 10.7777 15.7032V15.6445Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M6.80052 8.12201C6.89551 8.23601 7.03624 8.30193 7.18464 8.30193H11.5482C11.8244 8.30193 12.0482 8.07807 12.0482 7.80193V0.499999C12.0482 0.223857 11.8244 0 11.5482 0H2.57593C2.29979 0 2.07593 0.223858 2.07593 0.5V5.76674C2.07593 6.04288 2.29979 6.26674 2.57593 6.26674H5.02036C5.16875 6.26674 5.30948 6.33266 5.40448 6.44666L6.80052 8.12201ZM4.56691 2.74375C4.56691 2.46761 4.79077 2.24375 5.06691 2.24375H9.25437C9.53051 2.24375 9.75437 2.46761 9.75437 2.74375V2.80242C9.75437 3.07856 9.53051 3.30242 9.25437 3.30242H5.06691C4.79077 3.30242 4.56691 3.07856 4.56691 2.80242V2.74375ZM4.56691 4.86124C4.56691 4.58509 4.79077 4.36124 5.06691 4.36124H9.25437C9.53051 4.36124 9.75437 4.58509 9.75437 4.86124V4.91991C9.75437 5.19605 9.53051 5.41991 9.25437 5.41991H5.06691C4.79077 5.41991 4.56691 5.19605 4.56691 4.91991V4.86124Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M13.8771 1.03577H13.6068C13.3307 1.03577 13.1068 1.25962 13.1068 1.53577V7.80193C13.1068 8.07807 13.3307 8.30193 13.6068 8.30193H13.8771C14.1533 8.30193 14.3771 8.07807 14.3771 7.80193V1.53577C14.3771 1.25962 14.1533 1.03577 13.8771 1.03577Z", fill: "currentColor" })), bF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "dataCatalog",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: `M24,80c0-14.9,0-29.9,0-44.9c0-3,1.1-5.7,2.9-8.2c2.6-3.6,6-6.1,9.9-8.1c2.4-1.2,4.8-2.3,7.3-3.2
	c2.4-0.9,4.8-1.5,7.3-2.2c1.8-0.5,3.5-0.9,5.3-1.3c2.1-0.4,4.2-0.8,6.3-1c3.2-0.4,6.5-0.5,9.8-0.9c4.2-0.5,8.5-0.2,12.7-0.2
	c2,0,4,0.4,6,0.6c1.4,0.1,2.9,0.3,4.3,0.4c1.6,0.2,3.1,0.4,4.7,0.7c3.6,0.8,7.2,1.5,10.7,2.4c5.4,1.4,10.5,3.5,15.3,6.6
	c3,2,5.7,4.4,7.6,7.5c1.3,2.2,2.1,4.6,2.1,7.2c0,16.1,0,32.2,0,48.3c0,13.5,0,27,0,40.5c0,3.6-1.3,6.9-3.6,9.7
	c-2.2,2.7-4.9,4.8-7.9,6.5c-3.4,2-6.9,3.5-10.7,4.7c-3,1-6.1,1.7-9.2,2.4c-2.6,0.6-5.3,1-7.9,1.4c-2.3,0.3-4.6,0.5-6.9,0.6
	c-4.2,0.2-8.4,0.4-12.6,0.4c-3,0-6-0.3-9-0.5c-2.4-0.2-4.9-0.4-7.3-0.9c-3.1-0.5-6.2-1.1-9.3-1.9c-3-0.8-6-1.7-9-2.8
	c-3.5-1.3-6.9-3-10-5.3c-2.4-1.7-4.5-3.7-6.1-6.2c-1.5-2.4-2.4-4.9-2.4-7.8C24,109.8,24,94.9,24,80 M83.9,50.8v-0.3
	c1.5,0,3,0.1,4.5,0c2.8-0.2,5.5-0.5,8.2-0.9c3.5-0.6,6.9-1.3,10.4-2c3.1-0.7,6.1-1.8,9.1-3.1c3.1-1.3,6-3,8.2-5.5
	c0.8-0.9,1.6-1.9,1.6-3.3c0.1-1.6-0.9-2.7-1.9-3.7c-2.2-2.3-5-3.8-7.9-5.1c-2.9-1.3-5.9-2.4-8.9-3.1c-2.8-0.7-5.7-1.4-8.6-1.9
	c-2.4-0.4-4.9-0.6-7.3-0.9c-2.9-0.3-5.9-0.5-8.8-0.6c-3.7,0-7.4,0.1-11,0.3c-2.1,0.1-4.1,0.3-6.2,0.6c-2.7,0.4-5.5,0.8-8.2,1.4
	c-3.1,0.7-6.3,1.5-9.3,2.5c-3,1-5.8,2.3-8.5,4c-1.9,1.2-3.7,2.6-4.8,4.7c-0.7,1.2-0.6,2.3,0,3.5c0.9,1.7,2.3,2.9,3.9,4
	c2.3,1.6,4.7,2.8,7.3,3.8c2.7,0.9,5.3,1.9,8,2.7c2.3,0.6,4.7,1,7.1,1.4c3.1,0.5,6.2,1,9.3,1.2c3.2,0.3,6.3,0.3,9.5,0.4
	C81,50.9,82.5,50.8,83.9,50.8 M34.1,50.7v1c0,4.7,0,9.3,0,14c0,0.9,0.2,1.7,0.7,2.5c1.1,1.8,2.8,3,4.5,4.1c3.6,2.4,7.6,3.9,11.8,5.1
	c3.4,1,6.8,1.7,10.2,2.3c2,0.4,4,0.5,6,0.7c2.7,0.3,5.4,0.6,8.1,0.7c5.1,0.1,10.2,0.1,15.3-0.4c1.9-0.2,3.7-0.4,5.6-0.7
	c1.8-0.3,3.6-0.6,5.4-1c2.2-0.4,4.3-0.9,6.4-1.5c1.9-0.5,3.8-1.2,5.7-1.9c3.3-1.3,6.5-2.8,9.2-5.1c1.3-1.1,2.5-2.3,2.8-4.1
	c0.2-0.9,0.2-1.8,0.2-2.7c0-4.2,0-8.4,0-12.6c0-0.1-0.1-0.3-0.2-0.4c-0.5,0.3-1,0.6-1.4,0.8c-3,1.7-6.2,3-9.4,4.2
	c-3.9,1.4-7.9,2.5-12,3.2c-4.3,0.7-8.6,1.2-12.9,1.7c-2.7,0.3-5.3,0.2-8,0.3c-0.9,0-1.8,0-2.6,0c-1.4,0-2.9,0-4.3,0
	c-2.4-0.1-4.7-0.3-7.1-0.5c-1.5-0.1-3-0.2-4.4-0.4c-1.8-0.2-3.6-0.5-5.3-0.9c-2.4-0.5-4.7-0.9-7.1-1.5c-1.9-0.5-3.7-1-5.5-1.7
	c-3.7-1.3-7.3-2.9-10.7-4.9C34.6,50.9,34.4,50.8,34.1,50.7 M34.2,81.1c0,0.2,0,0.4,0,0.6c0,4.9,0,9.9,0,14.8c0,0.2,0.1,0.5,0.1,0.8
	c0.5,1.7,1.8,2.8,3.1,3.9c2.6,2.1,5.5,3.6,8.7,4.8c2.6,0.9,5.2,1.8,7.9,2.5c2.3,0.6,4.7,1.1,7,1.5c2,0.4,4.1,0.6,6.2,0.8
	c2.8,0.3,5.6,0.6,8.5,0.7c2.7,0.1,5.3-0.1,8-0.1c4.1,0,8.1-0.3,12.1-1c2.9-0.5,5.9-0.9,8.8-1.5c2.2-0.5,4.4-1.2,6.6-1.9
	c3-0.9,5.9-2.2,8.7-3.8c2.3-1.3,4.5-2.8,5.7-5.3c0.2-0.4,0.4-1,0.4-1.5c0.1-1.8,0.1-3.7,0.1-5.5c0-3.2-0.1-6.4-0.1-9.6
	c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.5,0.3-0.8,0.4c-3.7,2.2-7.6,3.8-11.6,5.1c-2,0.6-4,1.1-6,1.6
	c-1.9,0.5-3.9,1-5.8,1.3c-1.9,0.3-3.8,0.5-5.7,0.8c-2.7,0.3-5.4,0.6-8.1,0.8c-2.8,0.2-5.6,0.2-8.3,0.2c-3.1,0-6.1-0.2-9.1-0.4
	c-2.4-0.2-4.8-0.4-7.2-0.7c-2.5-0.3-5.1-0.8-7.6-1.3c-3.8-0.8-7.7-1.8-11.3-3.1c-3.3-1.2-6.6-2.6-9.5-4.6
	C34.4,81.1,34.3,81.1,34.2,81.1 M126,111.3c-0.3,0.2-0.5,0.2-0.6,0.3c-2.7,1.3-5.4,2.8-8.2,3.9c-2.5,1-5.1,1.8-7.7,2.6
	c-1.7,0.5-3.4,0.8-5.2,1.2c-1.6,0.3-3.1,0.7-4.7,0.9c-2.7,0.4-5.4,0.7-8.2,1c-3.1,0.3-6.3,0.5-9.4,0.5c-4.4,0-8.8-0.2-13.2-0.4
	c-1.5-0.1-2.9-0.2-4.4-0.4c-1.8-0.3-3.7-0.6-5.5-0.9c-2-0.3-3.9-0.6-5.9-1.1c-2.7-0.7-5.3-1.5-7.9-2.3c-3.2-1-6.3-2.3-9.3-4
	c-0.6-0.3-1.2-0.7-1.9-1.1c0,0.2-0.1,0.3-0.1,0.4c0,4.4,0,8.8,0,13.2c0,0.2,0.1,0.4,0.1,0.6c0.5,1.7,1.7,2.8,2.9,3.9
	c1.6,1.4,3.4,2.5,5.3,3.4c2.2,0.9,4.4,1.9,6.7,2.7c2.2,0.7,4.4,1.3,6.6,1.8c1.9,0.5,3.9,0.9,5.9,1.2c2.2,0.4,4.5,0.6,6.8,0.8
	c2.7,0.2,5.3,0.5,8,0.6c2.4,0.1,4.7,0,7.1,0c0.7,0,1.3,0,2,0c2.1-0.2,4.2-0.4,6.3-0.6c2.9-0.3,5.8-0.7,8.7-1.1
	c1.9-0.3,3.9-0.8,5.8-1.3c2.1-0.6,4.2-1.1,6.2-1.9c2-0.7,4-1.6,5.9-2.6c2.3-1.1,4.4-2.5,6.1-4.5c0.8-0.9,1.5-1.9,1.5-3.2
	c0.1-3.5,0.1-7,0.1-10.5C126,113.3,126,112.4,126,111.3`
      }
    )
  }
), CF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "deactivate",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        d: `M132.6,20c-2.1,0-3.8,0.7-5.1,2.2L80,69.6L32.5,22.2c-1.4-1.5-3.1-2.2-5.1-2.2s-3.8,0.7-5.2,2.1c-1.4,1.4-2.1,3.2-2.1,5.2
	s0.7,3.8,2.2,5.1L69.6,80l-47.3,47.5c-1.5,1.4-2.2,3.1-2.2,5.1s0.7,3.8,2.1,5.2c1.4,1.4,3.2,2.1,5.2,2.1s3.8-0.7,5.1-2.2L80,90.2
	l47.5,47.5c1.4,1.5,3.1,2.2,5.1,2.2s3.8-0.7,5.2-2.1c1.4-1.4,2.1-3.2,2.1-5.2s-0.8-3.8-2.2-5.1L90.4,80l47.3-47.5
	c1.5-1.4,2.2-3.1,2.2-5.1s-0.7-3.8-2.1-5.2C136.4,20.7,134.7,20,132.6,20`
      }
    )
  }
), xF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "documents",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: [
      /* @__PURE__ */ p.jsx(
        "path",
        {
          d: `M147.1,35.5c-1.8-1.9-4.4-3.2-7.3-3.2H106V20.5c0-2.9-1.1-5.5-2.9-7.4c-1.8-1.9-4.4-3.1-7.3-3.1H50c-2.2,0-4.3,0.9-5.8,2.5
	l0,0L12.4,46.8c-1.1,1.2-1.9,2.7-2.2,4.3c0,0.2-0.1,0.4-0.1,0.6C10,52,10,52.4,10,52.8v64.6c0,2.8,1.1,5.3,2.9,7.2
	c1.8,1.9,4.3,3.1,7.1,3.1h34v12.1c0,2.8,1.1,5.3,2.9,7.2c1.8,1.9,4.3,3.1,7.1,3.1h75.8c2.9,0,5.5-1.2,7.3-3.1
	c1.8-1.9,2.9-4.5,2.9-7.4V42.9C150,40.1,148.9,37.4,147.1,35.5z M46.2,22.9v26.7H21.3C21.3,49.7,46.2,22.9,46.2,22.9z M20,119.6
	c-0.5,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-1-0.6-1.7V57.6h30.8c1.5,0,2.9-0.7,3.8-1.7c1-1,1.5-2.3,1.5-3.8V18h41.6c0.6,0,1.1,0.2,1.5,0.7
	c0.4,0.5,0.7,1.1,0.7,1.9v11.8h-4c-2.2,0-4.3,0.9-5.8,2.5l0,0L56.3,69.1c-1.1,1.2-1.9,2.7-2.2,4.3c0,0.2-0.1,0.4-0.1,0.6
	c0,0.4-0.1,0.8-0.1,1.2v44.5L20,119.6L20,119.6z M90.2,45.3V72H65.3L90.2,45.3z M142,139.5c0,0.8-0.3,1.4-0.7,1.9
	c-0.4,0.4-1,0.7-1.5,0.7H64c-0.5,0-1-0.2-1.3-0.6c-0.4-0.4-0.6-1-0.6-1.6V80h30.8c1.5,0,2.9-0.7,3.8-1.7c0.9-1,1.5-2.3,1.5-3.8V40.4
	h41.6c0.6,0,1.1,0.2,1.5,0.7c0.4,0.5,0.7,1.1,0.7,1.9L142,139.5L142,139.5z`
        }
      ),
      /* @__PURE__ */ p.jsx("path", { d: "M132.1,95.2H72c-2.2,0-4,1.8-4,4s1.8,4,4,4h60.1c2.2,0,4-1.8,4-4S134.3,95.2,132.1,95.2z" }),
      /* @__PURE__ */ p.jsx("path", { d: "M132.1,108.8H72c-2.2,0-4,1.8-4,4s1.8,4,4,4h60.1c2.2,0,4-1.8,4-4S134.3,108.8,132.1,108.8z" }),
      /* @__PURE__ */ p.jsx("path", { d: "M132.1,122.5H72c-2.2,0-4,1.8-4,4s1.8,4,4,4h60.1c2.2,0,4-1.8,4-4S134.3,122.5,132.1,122.5z" })
    ]
  }
), wF = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "pdf",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: { fill: "#E9E9E0" },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: { fill: "#D9D7CA" },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: { fill: "#CC4B4C" },
              d: "M19.514,33.324L19.514,33.324c-0.348,0-0.682-0.113-0.967-0.326 c-1.041-0.781-1.181-1.65-1.115-2.242c0.182-1.628,2.195-3.332,5.985-5.068c1.504-3.296,2.935-7.357,3.788-10.75 c-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215c0.228-0.076,0.804-0.172,1.016-0.172 c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802c1.348,2.784,3.258,5.62,5.088,7.562 c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117c0.32,0.622,0.189,1.349-0.39,2.16 c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285c-2.837,0.593-6.15,1.651-8.828,2.822 c-0.836,1.774-1.637,3.203-2.383,4.251C21.273,32.654,20.389,33.324,19.514,33.324z M22.176,28.198 c-2.137,1.201-3.008,2.188-3.071,2.744c-0.01,0.092-0.037,0.334,0.431,0.692C19.685,31.587,20.555,31.19,22.176,28.198z  M35.813,23.756c0.815,0.627,1.014,0.944,1.547,0.944c0.234,0,0.901-0.01,1.21-0.441c0.149-0.209,0.207-0.343,0.23-0.415 c-0.123-0.065-0.286-0.197-1.175-0.197C37.12,23.648,36.485,23.67,35.813,23.756z M28.343,17.174 c-0.715,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02C30.815,21.15,29.466,19.192,28.343,17.174z  M27.736,8.712c-0.098,0.033-1.33,1.757,0.096,3.216C28.781,9.813,27.779,8.698,27.736,8.712z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: { fill: "#CC4B4C" },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: { fill: "#FFFFFF" },
                d: "M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032 c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492 c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: { fill: "#FFFFFF" },
                d: "M32.219,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937 s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C28.222,52.984,28.026,53,27.898,53h-3.814V42.924h3.035 c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C32.114,46.494,32.219,47.08,32.219,47.682z  M27.352,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244 c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H27.352z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: { fill: "#FFFFFF" },
                d: "M36.266,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244H36.266z"
              }
            )
          ] })
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, SF = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "txt",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#95A5A5"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M21.867,42.924v1.121h-3.008V53h-1.654v-8.955h-3.008v-1.121H21.867z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M28.443,48.105L31,53h-1.9l-1.6-3.801h-0.137L25.641,53h-1.9l2.557-4.895l-2.721-5.182h1.873 l1.777,4.102h0.137l1.928-4.102h1.873L28.443,48.105z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M40.529,42.924v1.121h-3.008V53h-1.654v-8.955h-3.008v-1.121H40.529z"
              }
            )
          ] }),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M18.5,13h-6c-0.553,0-1-0.448-1-1s0.447-1,1-1h6c0.553,0,1,0.448,1,1S19.053,13,18.5,13z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M21.5,18h-9c-0.553,0-1-0.448-1-1s0.447-1,1-1h9c0.553,0,1,0.448,1,1S22.053,18,21.5,18z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M25.5,18c-0.26,0-0.521-0.11-0.71-0.29c-0.181-0.19-0.29-0.44-0.29-0.71s0.109-0.52,0.3-0.71 c0.36-0.37,1.04-0.37,1.41,0c0.18,0.19,0.29,0.45,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C26.02,17.89,25.76,18,25.5,18z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M37.5,18h-8c-0.553,0-1-0.448-1-1s0.447-1,1-1h8c0.553,0,1,0.448,1,1S38.053,18,37.5,18z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M12.5,33c-0.26,0-0.521-0.11-0.71-0.29c-0.181-0.19-0.29-0.45-0.29-0.71 c0-0.26,0.109-0.52,0.29-0.71c0.37-0.37,1.05-0.37,1.42,0.01c0.18,0.18,0.29,0.44,0.29,0.7c0,0.26-0.11,0.52-0.29,0.71 C13.02,32.89,12.76,33,12.5,33z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M24.5,33h-8c-0.553,0-1-0.448-1-1s0.447-1,1-1h8c0.553,0,1,0.448,1,1S25.053,33,24.5,33z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M43.5,18h-2c-0.553,0-1-0.448-1-1s0.447-1,1-1h2c0.553,0,1,0.448,1,1S44.053,18,43.5,18z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M34.5,23h-22c-0.553,0-1-0.448-1-1s0.447-1,1-1h22c0.553,0,1,0.448,1,1S35.053,23,34.5,23z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M43.5,23h-6c-0.553,0-1-0.448-1-1s0.447-1,1-1h6c0.553,0,1,0.448,1,1S44.053,23,43.5,23z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M16.5,28h-4c-0.553,0-1-0.448-1-1s0.447-1,1-1h4c0.553,0,1,0.448,1,1S17.053,28,16.5,28z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M30.5,28h-10c-0.553,0-1-0.448-1-1s0.447-1,1-1h10c0.553,0,1,0.448,1,1S31.053,28,30.5,28z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M43.5,28h-9c-0.553,0-1-0.448-1-1s0.447-1,1-1h9c0.553,0,1,0.448,1,1S44.053,28,43.5,28z"
            }
          )
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, EF = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "doc",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M18.5,13h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1S19.052,13,18.5,13z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M21.5,18h-9c-0.552,0-1-0.448-1-1s0.448-1,1-1h9c0.552,0,1,0.448,1,1S22.052,18,21.5,18z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M25.5,18c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71 c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.45,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C26.02,17.89,25.76,18,25.5,18z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M37.5,18h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S38.052,18,37.5,18z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M12.5,33c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71 c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.44,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C13.02,32.89,12.76,33,12.5,33z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M24.5,33h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S25.052,33,24.5,33z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M43.5,18h-2c-0.552,0-1-0.448-1-1s0.448-1,1-1h2c0.552,0,1,0.448,1,1S44.052,18,43.5,18z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M34.5,23h-22c-0.552,0-1-0.448-1-1s0.448-1,1-1h22c0.552,0,1,0.448,1,1S35.052,23,34.5,23z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M43.5,23h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1S44.052,23,43.5,23z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M16.5,28h-4c-0.552,0-1-0.448-1-1s0.448-1,1-1h4c0.552,0,1,0.448,1,1S17.052,28,16.5,28z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M30.5,28h-10c-0.552,0-1-0.448-1-1s0.448-1,1-1h10c0.552,0,1,0.448,1,1S31.052,28,30.5,28z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#8697CB"
              },
              d: "M43.5,28h-9c-0.552,0-1-0.448-1-1s0.448-1,1-1h9c0.552,0,1,0.448,1,1S44.052,28,43.5,28z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#0096E6"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M23.5,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937 s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C19.503,52.984,19.307,53,19.18,53h-3.814V42.924H18.4 c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C23.395,46.494,23.5,47.08,23.5,47.682z  M18.633,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244 c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H18.633z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M33.475,47.914c0,0.848-0.107,1.595-0.321,2.242c-0.214,0.647-0.511,1.185-0.889,1.613 c-0.378,0.429-0.82,0.752-1.326,0.971s-1.06,0.328-1.661,0.328s-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971 c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235 c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.82-0.754,1.326-0.978s1.06-0.335,1.661-0.335s1.155,0.111,1.661,0.335 s0.948,0.549,1.326,0.978c0.378,0.429,0.674,0.964,0.889,1.606C33.367,46.321,33.475,47.066,33.475,47.914z M29.236,51.729 c0.337,0,0.658-0.066,0.964-0.198c0.305-0.132,0.579-0.349,0.82-0.649c0.241-0.301,0.431-0.695,0.567-1.183 s0.209-1.082,0.219-1.784c-0.009-0.684-0.08-1.265-0.212-1.743c-0.132-0.479-0.314-0.873-0.547-1.183s-0.497-0.533-0.793-0.67 c-0.296-0.137-0.608-0.205-0.937-0.205c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649 c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75 c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67C28.596,51.658,28.908,51.729,29.236,51.729z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M42.607,51.975c-0.374,0.364-0.798,0.638-1.271,0.82c-0.474,0.183-0.984,0.273-1.531,0.273 c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971c-0.378-0.429-0.675-0.966-0.889-1.613 c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235c0.214-0.643,0.51-1.178,0.889-1.606 c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335c0.547,0,1.057,0.091,1.531,0.273 c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.228-0.265-0.481-0.456-0.759-0.574c-0.278-0.118-0.567-0.178-0.868-0.178 c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649c-0.242,0.306-0.431,0.699-0.567,1.183 s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67 c0.296,0.142,0.608,0.212,0.937,0.212s0.636-0.06,0.923-0.178s0.549-0.31,0.786-0.574L42.607,51.975z"
              }
            )
          ] })
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, RF = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "doc",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "circle",
            {
              style: {
                fill: "#FFFFFF"
              },
              cx: 18.5,
              cy: 47,
              r: 3
            }
          ),
          /* @__PURE__ */ p.jsx(
            "circle",
            {
              style: {
                fill: "#FFFFFF"
              },
              cx: 28.5,
              cy: 47,
              r: 3
            }
          ),
          /* @__PURE__ */ p.jsx(
            "circle",
            {
              style: {
                fill: "#FFFFFF"
              },
              cx: 38.5,
              cy: 47,
              r: 3
            }
          )
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, TF = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "excel",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#91CDA0"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M20.379,48.105L22.936,53h-1.9l-1.6-3.801h-0.137L17.576,53h-1.9l2.557-4.895l-2.721-5.182h1.873 l1.777,4.102h0.137l1.928-4.102H23.1L20.379,48.105z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M27.037,42.924v8.832h4.635V53h-6.303V42.924H27.037z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M39.041,50.238c0,0.364-0.075,0.718-0.226,1.06S38.453,51.94,38.18,52.2s-0.611,0.467-1.012,0.622 c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116 c-0.237-0.055-0.463-0.13-0.677-0.226c-0.214-0.096-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212 c0.196,0.068,0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055 c0.556,0,0.982-0.13,1.278-0.39c0.296-0.26,0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793 c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533c-0.365-0.178-0.707-0.388-1.025-0.629 c-0.319-0.241-0.583-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23c0-0.446,0.082-0.843,0.246-1.189 s0.385-0.641,0.663-0.882c0.278-0.241,0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191c0.419,0,0.843,0.039,1.271,0.116 c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39c-0.073,0.142-0.142,0.273-0.205,0.396 c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109 s-0.167-0.091-0.294-0.137c-0.128-0.046-0.296-0.077-0.506-0.096c-0.21-0.019-0.479-0.014-0.807,0.014 c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321c-0.128,0.128-0.228,0.271-0.301,0.431 c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882c0.209,0.224,0.469,0.419,0.779,0.588 c0.31,0.169,0.647,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854 C38.936,49.261,39.041,49.7,39.041,50.238z"
              }
            )
          ] }),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M23.5,16v-4h-12v4v2v2v2v2v2v2v2v4h10h2h21v-4v-2v-2v-2v-2v-2v-4H23.5z M13.5,14h8v2h-8V14z  M13.5,18h8v2h-8V18z M13.5,22h8v2h-8V22z M13.5,26h8v2h-8V26z M21.5,32h-8v-2h8V32z M42.5,32h-19v-2h19V32z M42.5,28h-19v-2h19V28 z M42.5,24h-19v-2h19V24z M23.5,20v-2h19v2H23.5z"
            }
          )
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, MF = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "code",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#EEAF4B"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#EEAF4B"
                },
                d: "M19.5,19v-4c0-0.551,0.448-1,1-1c0.553,0,1-0.448,1-1s-0.447-1-1-1c-1.654,0-3,1.346-3,3v4 c0,1.103-0.897,2-2,2c-0.553,0-1,0.448-1,1s0.447,1,1,1c1.103,0,2,0.897,2,2v4c0,1.654,1.346,3,3,3c0.553,0,1-0.448,1-1 s-0.447-1-1-1c-0.552,0-1-0.449-1-1v-4c0-1.2-0.542-2.266-1.382-3C18.958,21.266,19.5,20.2,19.5,19z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "circle",
              {
                style: {
                  fill: "#EEAF4B"
                },
                cx: 27.5,
                cy: 18.5,
                r: 1.5
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#EEAF4B"
                },
                d: "M39.5,21c-1.103,0-2-0.897-2-2v-4c0-1.654-1.346-3-3-3c-0.553,0-1,0.448-1,1s0.447,1,1,1 c0.552,0,1,0.449,1,1v4c0,1.2,0.542,2.266,1.382,3c-0.84,0.734-1.382,1.8-1.382,3v4c0,0.551-0.448,1-1,1c-0.553,0-1,0.448-1,1 s0.447,1,1,1c1.654,0,3-1.346,3-3v-4c0-1.103,0.897-2,2-2c0.553,0,1-0.448,1-1S40.053,21,39.5,21z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#EEAF4B"
                },
                d: "M27.5,24c-0.553,0-1,0.448-1,1v3c0,0.552,0.447,1,1,1s1-0.448,1-1v-3 C28.5,24.448,28.053,24,27.5,24z"
              }
            )
          ] }),
          /* @__PURE__ */ p.jsx(
            "text",
            {
              x: 28,
              y: 48,
              fontFamily: "Arial, sans-serif",
              fontSize: 12,
              fill: "#FFFFFF",
              textAnchor: "middle",
              dominantBaseline: "middle",
              children: "JSON"
            }
          )
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, C5 = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "code",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#0096E6"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsx("g", { children: /* @__PURE__ */ p.jsx(
            "text",
            {
              x: 28,
              y: 25,
              fontFamily: "Arial, sans-serif",
              fontSize: 28,
              fill: "#0096E6",
              textAnchor: "middle",
              dominantBaseline: "middle",
              children: "R"
            }
          ) })
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, kF = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "code",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#90BAE1"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M12.5,13h6c0.553,0,1-0.448,1-1s-0.447-1-1-1h-6c-0.553,0-1,0.448-1,1S11.947,13,12.5,13z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M12.5,18h9c0.553,0,1-0.448,1-1s-0.447-1-1-1h-9c-0.553,0-1,0.448-1,1S11.947,18,12.5,18z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M25.5,18c0.26,0,0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.26-0.11-0.52-0.29-0.71 c-0.38-0.37-1.04-0.37-1.42,0c-0.181,0.19-0.29,0.44-0.29,0.71s0.109,0.52,0.29,0.71C24.979,17.89,25.24,18,25.5,18z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M29.5,18h8c0.553,0,1-0.448,1-1s-0.447-1-1-1h-8c-0.553,0-1,0.448-1,1S28.947,18,29.5,18z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M11.79,31.29c-0.181,0.19-0.29,0.44-0.29,0.71s0.109,0.52,0.29,0.71 C11.979,32.89,12.229,33,12.5,33c0.27,0,0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.26-0.11-0.52-0.29-0.71 C12.84,30.92,12.16,30.92,11.79,31.29z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M24.5,31h-8c-0.553,0-1,0.448-1,1s0.447,1,1,1h8c0.553,0,1-0.448,1-1S25.053,31,24.5,31z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M41.5,18h2c0.553,0,1-0.448,1-1s-0.447-1-1-1h-2c-0.553,0-1,0.448-1,1S40.947,18,41.5,18z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M12.5,23h22c0.553,0,1-0.448,1-1s-0.447-1-1-1h-22c-0.553,0-1,0.448-1,1S11.947,23,12.5,23z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M43.5,21h-6c-0.553,0-1,0.448-1,1s0.447,1,1,1h6c0.553,0,1-0.448,1-1S44.053,21,43.5,21z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M12.5,28h4c0.553,0,1-0.448,1-1s-0.447-1-1-1h-4c-0.553,0-1,0.448-1,1S11.947,28,12.5,28z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M30.5,26h-10c-0.553,0-1,0.448-1,1s0.447,1,1,1h10c0.553,0,1-0.448,1-1S31.053,26,30.5,26z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M43.5,26h-9c-0.553,0-1,0.448-1,1s0.447,1,1,1h9c0.553,0,1-0.448,1-1S44.053,26,43.5,26z"
              }
            )
          ] }),
          /* @__PURE__ */ p.jsx(
            "text",
            {
              x: 28,
              y: 48,
              fontFamily: "Arial, sans-serif",
              fontSize: 12,
              fill: "#FFFFFF",
              textAnchor: "middle",
              dominantBaseline: "middle",
              children: "SQL"
            }
          )
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, PF = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "code",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56 ",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#556080"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M25.266,42.924v1.326l-4.799,7.205l-0.273,0.219h5.072V53h-6.699v-1.326l4.799-7.205l0.287-0.219 h-5.086v-1.326H25.266z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M29.271,53h-1.668V42.924h1.668V53z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M33.414,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M33.414,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H33.414z"
              }
            )
          ] }),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M28.5,24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2 h-4v5c0,2.757,2.243,5,5,5s5-2.243,5-5v-5H28.5z M30.5,29c0,1.654-1.346,3-3,3s-3-1.346-3-3v-3h6V29z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M26.5,30h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S25.948,30,26.5,30z"
              }
            )
          ] })
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, IF = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "code",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#F36FA0"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M21.58,51.975c-0.374,0.364-0.798,0.638-1.271,0.82c-0.474,0.183-0.984,0.273-1.531,0.273 c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971c-0.378-0.429-0.675-0.966-0.889-1.613 c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235c0.214-0.643,0.51-1.178,0.889-1.606 c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335c0.547,0,1.057,0.091,1.531,0.273 c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.228-0.265-0.481-0.456-0.759-0.574c-0.278-0.118-0.567-0.178-0.868-0.178 c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649c-0.242,0.306-0.431,0.699-0.567,1.183 s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67 c0.296,0.142,0.608,0.212,0.937,0.212s0.636-0.06,0.923-0.178s0.549-0.31,0.786-0.574L21.58,51.975z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M29.633,50.238c0,0.364-0.075,0.718-0.226,1.06s-0.362,0.643-0.636,0.902s-0.611,0.467-1.012,0.622 c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116 c-0.237-0.055-0.463-0.13-0.677-0.226c-0.214-0.096-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212 c0.196,0.068,0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055 c0.556,0,0.982-0.13,1.278-0.39c0.296-0.26,0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793 c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533c-0.365-0.178-0.707-0.388-1.025-0.629 c-0.319-0.241-0.583-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23c0-0.446,0.082-0.843,0.246-1.189 s0.385-0.641,0.663-0.882c0.278-0.241,0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191c0.419,0,0.843,0.039,1.271,0.116 c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39c-0.073,0.142-0.142,0.273-0.205,0.396 c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109 s-0.167-0.091-0.294-0.137c-0.128-0.046-0.296-0.077-0.506-0.096c-0.21-0.019-0.479-0.014-0.807,0.014 c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321c-0.128,0.128-0.228,0.271-0.301,0.431 c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882c0.209,0.224,0.469,0.419,0.779,0.588 c0.31,0.169,0.647,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854 C29.528,49.261,29.633,49.7,29.633,50.238z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M34.035,53.055l-3.131-10.131h1.873l2.338,8.695l2.475-8.695h1.859l-3.281,10.131H34.035z"
              }
            )
          ] }),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M23.5,16v-4h-12v4v2v2v2v2v2v2v2v4h10h2h21v-4v-2v-2v-2v-2v-2v-4H23.5z M13.5,14h8v2h-8V14z  M13.5,18h8v2h-8V18z M13.5,22h8v2h-8V22z M13.5,26h8v2h-8V26z M21.5,32h-8v-2h8V32z M42.5,32h-19v-2h19V32z M42.5,28h-19v-2h19V28 z M42.5,24h-19v-2h19V24z M23.5,20v-2h19v2H23.5z"
            }
          )
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, mu = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "mp4",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#F36FA0"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M21.58,51.975c-0.374,0.364-0.798,0.638-1.271,0.82c-0.474,0.183-0.984,0.273-1.531,0.273 c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971c-0.378-0.429-0.675-0.966-0.889-1.613 c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235c0.214-0.643,0.51-1.178,0.889-1.606 c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335c0.547,0,1.057,0.091,1.531,0.273 c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.228-0.265-0.481-0.456-0.759-0.574c-0.278-0.118-0.567-0.178-0.868-0.178 c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649c-0.242,0.306-0.431,0.699-0.567,1.183 s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67 c0.296,0.142,0.608,0.212,0.937,0.212s0.636-0.06,0.923-0.178s0.549-0.31,0.786-0.574L21.58,51.975z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M29.633,50.238c0,0.364-0.075,0.718-0.226,1.06s-0.362,0.643-0.636,0.902s-0.611,0.467-1.012,0.622 c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116 c-0.237-0.055-0.463-0.13-0.677-0.226c-0.214-0.096-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212 c0.196,0.068,0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055 c0.556,0,0.982-0.13,1.278-0.39c0.296-0.26,0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793 c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533c-0.365-0.178-0.707-0.388-1.025-0.629 c-0.319-0.241-0.583-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23c0-0.446,0.082-0.843,0.246-1.189 s0.385-0.641,0.663-0.882c0.278-0.241,0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191c0.419,0,0.843,0.039,1.271,0.116 c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39c-0.073,0.142-0.142,0.273-0.205,0.396 c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109 s-0.167-0.091-0.294-0.137c-0.128-0.046-0.296-0.077-0.506-0.096c-0.21-0.019-0.479-0.014-0.807,0.014 c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321c-0.128,0.128-0.228,0.271-0.301,0.431 c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882c0.209,0.224,0.469,0.419,0.779,0.588 c0.31,0.169,0.647,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854 C29.528,49.261,29.633,49.7,29.633,50.238z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FFFFFF"
                },
                d: "M34.035,53.055l-3.131-10.131h1.873l2.338,8.695l2.475-8.695h1.859l-3.281,10.131H34.035z"
              }
            )
          ] }),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M23.5,16v-4h-12v4v2v2v2v2v2v2v2v4h10h2h21v-4v-2v-2v-2v-2v-2v-4H23.5z M13.5,14h8v2h-8V14z  M13.5,18h8v2h-8V18z M13.5,22h8v2h-8V22z M13.5,26h8v2h-8V26z M21.5,32h-8v-2h8V32z M42.5,32h-19v-2h19V32z M42.5,28h-19v-2h19V28 z M42.5,24h-19v-2h19V24z M23.5,20v-2h19v2H23.5z"
            }
          ),
          /* @__PURE__ */ p.jsxs("g", { children: [
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#E9E9E0"
                },
                d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#FF5364"
                },
                d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
              }
            ),
            /* @__PURE__ */ p.jsx("g", {}),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M24.5,28c-0.166,0-0.331-0.041-0.481-0.123C23.699,27.701,23.5,27.365,23.5,27V13 c0-0.365,0.199-0.701,0.519-0.877c0.321-0.175,0.71-0.162,1.019,0.033l11,7C36.325,19.34,36.5,19.658,36.5,20 s-0.175,0.66-0.463,0.844l-11,7C24.874,27.947,24.687,28,24.5,28z M25.5,14.821v10.357L33.637,20L25.5,14.821z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "path",
              {
                style: {
                  fill: "#C8BDB8"
                },
                d: "M28.5,35c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S36.771,35,28.5,35z M28.5,7 c-7.168,0-13,5.832-13,13s5.832,13,13,13s13-5.832,13-13S35.668,7,28.5,7z"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "polygon",
              {
                style: {
                  fill: "#D9D7CA"
                },
                points: "37.5,0.151 37.5,12 49.349,12  "
              }
            ),
            /* @__PURE__ */ p.jsx(
              "text",
              {
                x: 28,
                y: 48,
                fontFamily: "Arial, sans-serif",
                fontSize: 12,
                fill: "#FFFFFF",
                textAnchor: "middle",
                dominantBaseline: "middle",
                children: "VIDEO"
              }
            )
          ] })
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, t0 = ({ plain: e, iconStatus: t, ref: n, ...r }) => {
  var s;
  const i = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "mp4",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 56 56",
      enableBackground: "new 0 0 56 56",
      xmlSpace: "preserve",
      ...r,
      children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#E9E9E0"
              },
              d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#7D6599"
              },
              d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              style: {
                fill: "#C8BDB8"
              },
              d: "M35.67,14.986c-0.567-0.796-1.3-1.543-2.308-2.351c-3.914-3.131-4.757-6.277-4.862-6.738V5 c0-0.553-0.447-1-1-1s-1,0.447-1,1v1v8.359v9.053h-3.706c-3.882,0-6.294,1.961-6.294,5.117c0,3.466,2.24,5.706,5.706,5.706 c3.471,0,6.294-2.823,6.294-6.294V16.468l0.298,0.243c0.34,0.336,0.861,0.72,1.521,1.205c2.318,1.709,6.2,4.567,5.224,7.793 C35.514,25.807,35.5,25.904,35.5,26c0,0.43,0.278,0.826,0.71,0.957C36.307,26.986,36.404,27,36.5,27c0.43,0,0.826-0.278,0.957-0.71 C39.084,20.915,37.035,16.9,35.67,14.986z M26.5,27.941c0,2.368-1.926,4.294-4.294,4.294c-2.355,0-3.706-1.351-3.706-3.706 c0-2.576,2.335-3.117,4.294-3.117H26.5V27.941z M31.505,16.308c-0.571-0.422-1.065-0.785-1.371-1.081l-1.634-1.34v-3.473 c0.827,1.174,1.987,2.483,3.612,3.783c0.858,0.688,1.472,1.308,1.929,1.95c0.716,1.003,1.431,2.339,1.788,3.978 C34.502,18.515,32.745,17.221,31.505,16.308z"
            }
          ),
          /* @__PURE__ */ p.jsx("g", {}),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              style: {
                fill: "#D9D7CA"
              },
              points: "37.5,0.151 37.5,12 49.349,12  "
            }
          ),
          /* @__PURE__ */ p.jsx(
            "text",
            {
              x: 28,
              y: 48,
              fontFamily: "Arial, sans-serif",
              fontSize: 12,
              fill: "#FFFFFF",
              textAnchor: "middle",
              dominantBaseline: "middle",
              children: "AUDIO"
            }
          )
        ] }),
        t && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              id: "shield",
              fill: (s = i.palette[t || "primary"]) == null ? void 0 : s.main,
              d: "M44.135,24.465c0.385,0.21,0.84,0.21,1.19,0C55.3,19.11,56,8.645,56,5.67c0-0.49-0.28-0.945-0.735-1.12L45.22,0.105          c-0.315-0.14-0.7-0.14-1.015,0L34.265,4.55c-0.455,0.21-0.735,0.63-0.735,1.12c0,3.61,0.595,12.81,10.554,18.745L44.135,24.465z           M40.635,10.22l2.87,2.87l8.765-8.77l1.75,1.75l-7.105,7.105L38.85,11.975C38.85,11.975,40.635,10.22,40.635,10.22z"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "polygon",
            {
              id: "checked",
              fill: "#ffffff",
              points: "40.635,10.22 43.505,13.09 52.27,4.32 54.02,6.07 43.47,16.59 38.85,11.975"
            }
          )
        ] })
      ]
    }
  );
}, OF = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6497 13.4576H1.46959C1.02529 13.4576 0.661743 13.0941 0.661743 12.6498V9.25098C0.661743 9.07474 0.805483 8.93103 0.981725 8.93103H2.11754C2.29378 8.93103 2.43749 9.07477 2.43749 9.25098V11.6819H11.6818V9.25098C11.6818 9.07474 11.8256 8.93103 12.0018 8.93103H13.1376C13.3138 8.93103 13.4576 9.07477 13.4576 9.25098V12.6498C13.4576 13.0941 13.094 13.4576 12.6497 13.4576ZM8.01725 0.661758H6.10208C5.82345 0.661758 5.59545 0.889724 5.59545 1.16836V5.83643H4.0738C3.93828 5.83643 3.82223 5.90931 3.76337 6.03138C3.70451 6.15345 3.71972 6.28963 3.80415 6.39566L6.78999 10.1477C6.85761 10.2326 6.95107 10.2777 7.05967 10.2777C7.16826 10.2777 7.26173 10.2326 7.32935 10.1477L10.3152 6.39566C10.3996 6.28963 10.4148 6.15345 10.356 6.03138C10.2971 5.90931 10.1811 5.83643 10.0455 5.83643H8.52385V1.16836C8.52385 0.889752 8.29589 0.661758 8.01725 0.661758Z", fill: "currentColor" })), DF = (e) => /* @__PURE__ */ d.createElement("svg", { id: "extension", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 160 160", enableBackground: "new 0 0 160 160", xmlSpace: "preserve", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M148.4,101.6c-1-1.1-2.3-1.6-3.8-1.6s-2.8,0.6-3.8,1.6c-1,1.1-1.6,2.4-1.6,3.8v30.5c0,0.9-0.3,1.7-0.9,2.3 c-0.6,0.6-1.4,0.9-2.3,0.9H24.1c-0.9,0-1.7-0.3-2.3-0.9s-0.9-1.4-0.9-2.3v-30.5c0-1.5-0.5-2.7-1.6-3.8c-1-1.1-2.3-1.6-3.8-1.6 s-2.8,0.6-3.8,1.6S10,104,10,105.5v34.8c0,2.7,0.9,5,2.8,6.9c1.9,1.9,4.2,2.8,6.9,2.8h120.6c2.7,0,5-1,6.9-2.9 c1.9-1.9,2.8-4.2,2.8-6.8v-34.8C150,104,149.5,102.7,148.4,101.6z" }), /* @__PURE__ */ d.createElement("path", { d: "M56.4,45.8c1.4,0,2.6-0.6,3.7-1.7l14.7-14.6v87.7c0,1.5,0.5,2.8,1.6,3.8c1.1,1,2.3,1.5,3.7,1.5s2.6-0.5,3.7-1.5 c1-1,1.5-2.3,1.5-3.8V29.5L100,44.2c1.1,1,2.4,1.5,3.8,1.5s2.6-0.5,3.7-1.6c1-1.1,1.5-2.3,1.5-3.7s-0.5-2.6-1.5-3.7L83.7,13.1 c-1-1-2.2-1.5-3.7-1.5s-2.6,0.5-3.7,1.5L52.7,36.8c-1.1,1-1.7,2.2-1.7,3.7s0.5,2.7,1.6,3.7C53.7,45.2,55,45.8,56.4,45.8z" })), jF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: [
      /* @__PURE__ */ p.jsx("polygon", { points: "10,120.9 96.1,34.8 125.2,64 39.1,150 10,150 " }),
      /* @__PURE__ */ p.jsx(
        "path",
        {
          d: `M147.8,41.4l-14.2,14.2l-29.1-29.1l14.2-14.2c1.5-1.5,3.3-2.2,5.5-2.2s4,0.8,5.5,2.2l18.1,18.1c1.5,1.5,2.2,3.3,2.2,5.5
	S149.3,39.9,147.8,41.4L147.8,41.4z`
        }
      )
    ]
  }
), FF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "view",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx("path", { d: "M12,4.5C7,4.5,2.73,7.61,1,12c1.73,4.39,6,7.5,11,7.5s9.27-3.11,11-7.5c-1.73-4.39-6-7.5-11-7.5z M12,17c-2.76,0-5-2.24-5-5s2.24-5,5-5s5,2.24,5,5S14.76,17,12,17z M12,9c-1.66,0-3,1.34-3,3s1.34,3,3,3s3-1.34,3-3S13.66,9,12,9z" })
  }
), hh = ({ plain: e, color: t, ref: n, ...r }) => {
  const i = to();
  return /* @__PURE__ */ p.jsx(
    "svg",
    {
      ref: n,
      version: "1.1",
      id: "empty-table",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 500 500",
      enableBackground: "new 0 0 500 500",
      xmlSpace: "preserve",
      ...r,
      children: /* @__PURE__ */ p.jsxs("g", { children: [
        /* @__PURE__ */ p.jsx(
          "circle",
          {
            fill: i.palette.backgroundColor.main,
            cx: "250",
            cy: "250",
            r: "250"
          }
        ),
        /* @__PURE__ */ p.jsx("rect", { x: "106.4", y: "150.2", fill: "#D5DEEC", width: "87.2", height: "24.8" }),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: i.palette.borderColor.main,
            d: `M347.4,215h11.8c3.5,0,6.1,2.2,6.1,5.1s-2.5,5.2-6,5.2c-8,0-15.9,0-23.9,0c-3.5,0-6-2.2-6-5.2s2.5-5.1,5.9-5.1
			C339.3,215,343.4,215,347.4,215`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: i.palette.borderColor.main,
            d: `M147.6,251.1c3.9,0,7.8,0,11.8,0c3.6,0,6.1,2.3,6.1,5.3c0,3-2.7,5-6.2,5c-7.8,0-15.7,0-23.5,0
			c-3.6,0-6.2-2.2-6.2-5.2s2.6-5.1,6.1-5.1C139.7,251.1,143.7,251.1,147.6,251.1`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: i.palette.borderColor.main,
            d: `M147.6,302.7c-3.9,0-7.8,0-11.8,0c-3.6,0-6.2-2.2-6.2-5.2s2.6-5.1,6.2-5.1h23.5c3.5,0,6.1,2.2,6.1,5.1
			s-2.5,5.2-6.1,5.2C155.4,302.7,151.5,302.7,147.6,302.7`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: i.palette.borderColor.main,
            d: `M147.4,338.9c-3.9,0-7.8,0-11.8,0c-3.5,0-6.1-2.2-6.1-5.1s2.6-5.2,6.2-5.2c7.8,0,15.7,0,23.5,0
			c3.6,0,6.2,2.2,6.2,5.2s-2.6,5.1-6.3,5.1H147.4`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: i.palette.borderColor.main,
            d: `M147.4,225.3c-3.9,0-7.8,0-11.8,0c-3.5,0-6-2.2-6-5.2s2.6-5.1,6-5.1c7.9,0,15.8,0,23.7,0
			c3.5,0,6.1,2.2,6.1,5.1s-2.6,5.2-6.1,5.2C155.3,225.3,151.3,225.3,147.4,225.3`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: i.palette.borderColor.main,
            d: `M250,225.3c-3.9,0-7.8,0-11.8,0c-3.6,0-6.2-2.2-6.2-5.2s2.6-5.1,6.2-5.1c7.8,0,15.5,0,23.3,0
			c3.7,0,6.3,2.2,6.3,5.2s-2.7,5.1-6.3,5.1L250,225.3`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: i.palette.borderColor.main,
            d: `M249.9,302.7c-3.9,0-7.8,0-11.8,0c-3.5,0-6.1-2.2-6.1-5.1s2.5-5.1,6-5.1c8,0,15.9,0,23.9,0c3.4,0,5.9,2.2,6,5
			s-2.5,5.2-5.9,5.2C258,302.7,253.9,302.7,249.9,302.7`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: i.palette.borderColor.main,
            d: `M250,338.9h-11.7c-3.6,0-6.2-2.2-6.2-5.2s2.6-5.1,6.2-5.1c7.8,0,15.7,0,23.5,0c3.5,0,6.1,2.2,6.1,5.1
			s-2.5,5.2-6.1,5.2C257.9,338.8,253.9,338.8,250,338.9`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: i.palette.borderColor.main,
            d: `M249.9,261.4c-3.9,0-7.8,0-11.8,0c-3.5,0-6.1-2.2-6.1-5.1s2.5-5.2,6-5.2c8,0,15.9,0,23.9,0c3.4,0,6,2.3,6,5.2
			s-2.6,5.1-5.9,5.1C258,261.4,253.9,261.4,249.9,261.4`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: i.palette.borderColor.main,
            d: `M270.8,362.3h-64.5V187.6h87.2v70.5c4-3.4,8.3-6.4,12.8-9v-61.5h87.2v61.5c4.4,2.6,8.7,5.5,12.6,8.8
			c0-37.7,0-75.3,0.1-113c0.2-3.9-2.7-7.2-6.6-7.4c-0.3,0-0.6,0-0.9,0c-49.6,0.1-99.2,0.1-148.7,0.1h-69.3c-26.7,0-53.3,0-80,0.1
			c-1.7,0.1-3.3,0.6-4.7,1.5c-2,1.2-2.2,3.4-2.2,5.7c0,74.3,0,148.6,0,222.9c-0.2,3.9,2.8,7.1,6.7,7.3c0.2,0,0.5,0,0.7,0
			c59-0.1,118-0.1,177.1-0.1C275.4,371,273,366.7,270.8,362.3z M306.3,150.2h87.2V175h-87.2V150.2z M206.4,150.2h87.2V175h-87.2
			V150.2z M106.4,150.2h87.2V175h-87.2L106.4,150.2z M193.6,362.3h-87.2V187.7h87.2L193.6,362.3z`
          }
        ),
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "path",
            {
              fill: i.palette.borderColor.main,
              d: `M378.4,296.6c-15.7-15.9-41.2-16-57.1-0.3c-15.9,15.7-16,41.2-0.3,57.1c15.7,15.9,41.2,16,57.1,0.3
				c10.2-10.1,14.3-25,10.7-38.9C387,307.9,383.4,301.6,378.4,296.6z M371.2,339.3l-7,7L350,332l-14.3,14.3l-7-7L343,325l-14.3-14.3
				l7-7L350,318l14.3-14.3l7,7L357,325L371.2,339.3z`
            }
          ),
          /* @__PURE__ */ p.jsx(
            "path",
            {
              fill: i.palette.borderColor.main,
              d: `M350,256.2c-38,0-68.8,30.8-68.8,68.8s30.8,68.8,68.8,68.8s68.8-30.8,68.8-68.8l0,0
				C418.8,287,388,256.2,350,256.2z M398.4,337.6c-4.6,17.5-18.3,31.2-35.9,35.9c-8.3,2.2-17,2.2-25.2-0.1c-26.7-7-42.8-34.3-35.8-61
				c4.6-17.6,18.3-31.3,35.9-35.8c8.2-2.3,16.9-2.3,25.2,0c17.5,4.6,31.2,18.3,35.9,35.9C400.7,320.7,400.7,329.3,398.4,337.6
				L398.4,337.6z`
            }
          )
        ] }),
        /* @__PURE__ */ p.jsx("rect", { x: "106.2", y: "150", fill: "none", width: "87.5", height: "25" })
      ] })
    }
  );
}, VF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "expand",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: [
      /* @__PURE__ */ p.jsx(
        "path",
        {
          d: `M146.6,13.3c-2.1-2.1-5-3.3-8-3.3H21.2c-3-0.1-5.9,1.1-8,3.3c-2.2,2.1-3.3,5-3.3,8v117.5c0,3,1.2,5.8,3.3,7.9
	c2.1,2.2,5,3.4,8,3.4h117.5c6.2-0.1,11.1-5.1,11.2-11.2V21.2C150,18.2,148.8,15.3,146.6,13.3z M138.6,138.8H21.2V21.2h117.4
	L138.6,138.8z`
        }
      ),
      /* @__PURE__ */ p.jsx(
        "path",
        {
          d: `M118.2,76c1,1,1.6,2.4,1.6,3.9c0,3.1-2.5,5.6-5.6,5.6c0,0,0,0,0,0H85.5v28.6c0,3.1-2.4,5.6-5.5,5.6c-1.5,0-3-0.6-4-1.6
	c-1.1-1-1.7-2.5-1.7-4V85.5H45.6c-3.1,0-5.6-2.5-5.6-5.6c0,0,0,0,0,0c0-1.5,0.6-2.9,1.6-3.9c1-1.1,2.5-1.7,4-1.7h28.7V45.7
	c0-1.5,0.6-3,1.7-4c1-1,2.4-1.6,3.9-1.6c3.1,0,5.6,2.5,5.6,5.6c0,0,0,0,0,0v28.6h28.7C115.8,74.3,117.2,74.9,118.2,76z`
        }
      )
    ]
  }
), $F = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_88_127)" }, /* @__PURE__ */ d.createElement("path", { d: "M11.0879 11.6412C10.6152 11.9563 10.0661 12.1229 9.5 12.1229C8.93393 12.1229 8.38486 11.9563 7.91216 11.6412L0.126506 6.45057C0.0833105 6.42177 0.0412285 6.39175 0 6.36088V14.8662C0 15.8414 0.791357 16.6153 1.74908 16.6153H17.2509C18.226 16.6153 19 15.824 19 14.8662V6.36084C18.9587 6.39179 18.9165 6.42189 18.8732 6.45072L11.0879 11.6412Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M0.744043 5.52392L8.5297 10.7146C8.82442 10.9111 9.16219 11.0093 9.49996 11.0093C9.83777 11.0093 10.1756 10.911 10.4703 10.7146L18.256 5.52392C18.7219 5.2135 19 4.69397 19 4.13325C19 3.16911 18.2156 2.38477 17.2515 2.38477H1.74848C0.784381 2.3848 0 3.16915 0 4.13418C0 4.69397 0.278172 5.2135 0.744043 5.52392Z", fill: "currentColor" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_88_127" }, /* @__PURE__ */ d.createElement("rect", { width: 19, height: 19, fill: "white" })))), LF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "list",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        d: `M90,33.5v13.4H10V33.5H90z M90,59.9v13.4H10V59.9H90z M10,99.8V86.7h53.1v13.1H10z M140.1,69.8l9.9,10l-46.6,46.7L73.2,96.6
	l9.9-9.9l20.3,19.9L140.1,69.8z`
      }
    )
  }
), AF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "logout",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsxs("g", { children: [
      /* @__PURE__ */ p.jsx(
        "path",
        {
          d: `M119.2,127.7c-1.3-0.2-2.6,0.1-3.7,0.9c-10.3,7.6-22.8,11.7-35.5,11.6c-8,0-16-1.5-23.4-4.6c-7.2-3.1-13.6-7.5-19.1-13
       c-5.5-5.5-9.9-12-12.9-19.1C21.4,96,19.8,88,19.8,80c0-8,1.5-16,4.6-23.4c3.1-7.2,7.5-13.6,13-19.1c5.5-5.5,12-9.9,19.1-12.9
       c19.5-8.3,41.9-5.7,58.9,6.8c1,0.8,2.3,1.1,3.6,0.9c1.3-0.2,2.4-0.9,3.2-2c0.8-1,1.2-2.3,1-3.6c-0.2-1.3-0.9-2.5-1.9-3.2
       C109.5,14.6,94.9,9.9,80,10C41.4,9.9,10.1,41.2,10,79.8c0,0.1,0,0.1,0,0.2c-0.1,38.6,31.2,69.9,69.8,70c0.1,0,0.1,0,0.2,0
       c14.9,0.1,29.5-4.6,41.4-13.5c1.1-0.8,1.7-1.9,1.9-3.2c0.2-1.3-0.1-2.6-0.9-3.6C121.7,128.6,120.5,127.8,119.2,127.7z`
        }
      ),
      /* @__PURE__ */ p.jsx(
        "path",
        {
          d: `M148.6,76.4L130,58c-0.9-1-2.2-1.5-3.6-1.5c-2.7,0-4.9,2.2-4.9,4.9c0,0,0,0,0,0c0,1.4,0.6,2.7,1.5,3.6l10.1,10.1H67.4
       c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9h65.8l-10.1,10c-1,0.9-1.5,2.2-1.5,3.6c0,2.7,2.2,4.9,4.9,4.9c0,0,0,0,0,0
       c1.3,0,2.6-0.5,3.5-1.5l18.6-18.5C150.4,81.5,150.4,78.5,148.6,76.4L148.6,76.4z`
        }
      )
    ] })
  }
), NF = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M9.74541 21.0001C10.9441 21.0001 11.9294 20.0867 12.0436 18.918H7.44727C7.56145 20.0867 8.54669 21.0001 9.74541 21.0001Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M17.7809 14.2677C17.0764 14.2677 16.5054 13.6966 16.5054 12.9922V8.77353C16.5054 5.78185 14.5619 3.24446 11.8686 2.35413C11.8761 2.2819 11.8799 2.20869 11.8799 2.13453C11.8799 0.957551 10.9223 0 9.74535 0C8.56837 0 7.61082 0.957551 7.61082 2.13453C7.61082 2.20869 7.61467 2.2819 7.62205 2.35413C4.92885 3.24446 2.98532 5.78185 2.98532 8.77353V12.9922C2.98532 13.6966 2.41426 14.2677 1.70986 14.2677C0.765516 14.2677 0 15.0332 0 15.9775C0 16.9219 0.765557 17.6874 1.70986 17.6874H17.7809C18.7252 17.6874 19.4907 16.9219 19.4907 15.9775C19.4907 15.0332 18.7252 14.2677 17.7809 14.2677ZM9.74535 1.23047C10.2233 1.23047 10.6156 1.60338 10.6471 2.0735C10.3521 2.03417 10.0512 2.0135 9.74535 2.0135C9.43954 2.0135 9.13861 2.03417 8.84358 2.0735C8.87508 1.60338 9.26735 1.23047 9.74535 1.23047Z", fill: "currentColor" })), BF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "participants",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: [
      /* @__PURE__ */ p.jsx("path", { d: "M86.8,99.2H73.2c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3h13.6c2.4,0,4.3-1.9,4.3-4.3S89.2,99.2,86.8,99.2z" }),
      /* @__PURE__ */ p.jsx("path", { d: "M86.8,113.3H73.2c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3h13.6c2.4,0,4.3-1.9,4.3-4.3S89.2,113.3,86.8,113.3z" }),
      /* @__PURE__ */ p.jsx(
        "path",
        {
          d: `M80.1,32.9h-0.1C70,32.9,61.9,41,61.8,51l0,0v0.1l0,0v0c0,4.9,2,9.4,5.3,12.7c3.2,3.3,7.7,5.4,12.6,5.5c0.1,0,0.2,0,0.3,0
	c4.9,0,9.5-2,12.9-5.3c3.3-3.2,5.4-7.8,5.4-12.7v-0.9l0,0C97.8,40.7,89.8,32.9,80.1,32.9L80.1,32.9z M87.3,58.5
	c-1.9,1.9-4.5,3-7.3,3h0c-2.9,0-5.5-1.2-7.4-3.1c-1.9-1.9-3-4.6-3.1-7.5v0c0-2.7,1.2-5.2,3.1-7.1c1.9-1.9,4.5-3,7.3-3h0l0,0
	c2.9,0,5.5,1.2,7.3,3.1c1.9,1.9,3,4.5,3,7.5v0C90.4,54,89.2,56.6,87.3,58.5L87.3,58.5z`
        }
      ),
      /* @__PURE__ */ p.jsx(
        "path",
        {
          d: `M129.5,30.5C116.8,17.8,99.3,10,80,10s-36.8,7.8-49.5,20.5C17.8,43.2,10,60.7,10,80s7.8,36.8,20.5,49.5
	C43.2,142.2,60.7,150,80,150s36.8-7.8,49.5-20.5C142.2,116.8,150,99.3,150,80C150,60.7,142.2,43.2,129.5,30.5z M49.8,133.4V94.2l0,0
	c0-2.2,0-4.5,0-6.7c0-1.6,0-3.2,0-4.9l0,0c0-1.7,0.7-3.5,1.9-4.9c1.2-1.4,2.8-2.3,4.5-2.6c1-0.1,2.1-0.2,3.3-0.2c0.9,0,1.8,0,2.7,0
	l0,0l0.1,0l0,0h0c4.9,4.1,9.8,8.2,14.6,12.2l0,0c0.4,0.4,0.9,0.7,1.4,0.9c0.5,0.2,1.1,0.4,1.6,0.4s1.2-0.2,1.6-0.4
	c0.5-0.2,0.9-0.6,1.4-0.9c4.9-4.1,9.8-8.2,14.7-12.3c1.1,0,2.2-0.1,3.2-0.1c0.8,0,1.6,0,2.3,0.1c2.2,0.3,3.9,1.3,5.1,2.7
	c1.2,1.4,1.9,3.3,1.9,5.5v50c-8.9,5.1-19.3,8.1-30.4,8.1C69,141.3,58.7,138.4,49.8,133.4L49.8,133.4z M123.4,123.4
	c-1.6,1.6-3.4,3.2-5.2,4.6V83.3h-0.1c0-0.8-0.1-1.5-0.1-2.3c-0.3-3.4-1.9-6.6-4.2-9s-5.4-4.1-8.8-4.6c-2.5-0.3-4.9-0.2-7.1-0.3
	c-0.2,0-0.3,0-0.5,0c-0.9,0-1.8,0.2-2.7,0.5c-0.8,0.3-1.6,0.8-2.2,1.4c-2.8,2.5-5.6,4.9-8.5,7.3c-1.3,1.1-2.7,2.2-4.1,3.3
	c-1.8-1.4-3.6-2.8-5.3-4.3c-2.7-2.2-5.3-4.6-7.9-6.9l0,0c-0.4-0.4-0.9-0.7-1.5-1c-0.6-0.3-1.2-0.4-1.9-0.4l0,0c-0.1,0-0.2,0-0.4,0
	c-1.1,0-2.2,0-3.3,0c-1.4,0-2.8,0-4.2,0.2c-4,0.5-7.4,2.4-9.9,5.2c-2.5,2.8-3.9,6.5-3.9,10.5l0,0c0,0.8,0,1.7,0,2.6l0,0v42.4
	c-1.8-1.4-3.5-2.9-5.1-4.6c-11.1-11.1-18-26.4-18-43.4s6.9-32.2,18-43.4c11.1-11.1,26.4-18,43.4-18s32.2,6.9,43.4,18
	c11.1,11.1,18,26.4,18,43.4S134.5,112.3,123.4,123.4L123.4,123.4z`
        }
      )
    ]
  }
), _F = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "reload",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: `M141.9,92.2c-0.2,1.5-0.4,3.1-0.6,4.6c-1.2,9.5-4.5,18.2-10,26.1c-9,13.1-21.3,21.8-36.9,25.2
	c-23.1,5.1-43.2-0.9-59.7-17.7c-8.6-8.8-13.7-19.4-15.8-31.4c-1-5.8-1.1-11.6-0.4-17.4c0.4-3.1,3.6-5.6,6.7-5.2c3.6,0.5,6,3.4,5.6,7
	c-2.6,23.1,11.8,44.9,34.2,51.8c6.5,2,13.2,2.7,19.9,2.1c20.9-2.1,38.1-16.8,43.1-37.1c6.2-25.1-8.3-50.5-33.2-58.1
	c-13.8-4.2-27-2.7-39.6,4.3c-0.2,0.1-0.3,0.2-0.5,0.3c0,0-0.1,0.1-0.3,0.2c0.7,0.2,1.3,0.4,1.9,0.5c0.6,0.2,1.2,0.3,1.9,0.5
	c5.3,1.3,10.7,2.7,16.1,4c2.7,0.7,4.4,2.3,5,5.1c0.8,4.1-3.2,7.9-7.2,6.9c-6.5-1.5-13-3.2-19.5-4.9c-6.8-1.7-13.5-3.4-20.3-5.1
	c-0.2,0-0.3-0.1-0.5-0.2c0.6-2.3,1.2-4.6,1.8-6.9c2.8-10.6,5.5-21.3,8.2-31.9c0.8-3.1,2.7-4.9,5.7-5.2c4.1-0.4,7.6,3.4,6.6,7.4
	c-1.4,5.7-2.9,11.4-4.4,17.2c-0.1,0.3-0.2,0.7-0.3,1.1c1.7-0.8,3.3-1.7,5-2.4c6.4-2.9,13.2-4.6,20.2-5.2
	c30.8-2.8,59.1,17.5,65.9,47.4c0.7,3,0.9,6.2,1.4,9.2c0.1,0.3,0.1,0.6,0.2,0.9L141.9,92.2L141.9,92.2z`
      }
    )
  }
), zF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        fill: "evenodd",
        d: `M148.7,142.4l-34.8-34.8c21.3-24.8,18.5-62.1-6.3-83.4S45.5,5.7,24.2,30.5s-18.5,62.1,6.3,83.4
   c22.2,19.1,54.9,19.1,77.1,0l34.8,34.8c1.7,1.8,4.5,1.9,6.3,0.2s1.9-4.5,0.2-6.3C148.8,142.5,148.8,142.5,148.7,142.4L148.7,142.4z
	M33.6,104.6C14,85,14,53.2,33.6,33.6s51.4-19.6,71,0c19.5,19.5,19.6,51.1,0.2,70.8l-0.2,0.2l-0.2,0.2
   C84.7,124.2,53.1,124.1,33.6,104.6L33.6,104.6z`
      }
    )
  }
), HF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "save",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    enableBackground: "new 0 0 160 160",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        d: `M128.5,15.4c-0.7,0-1.5,0.2-2,0.7l-67.3,86.5L32.2,76.3c-1.3-1.3-2.5-2-3.4-2c-0.5,0-1.4,0.7-2.7,2
	c-3.6,3.6-8.5,8.8-14.8,15.5l-0.7,0.7c-0.3,0.5-0.5,1.1-0.7,1.7c0.1,0.7,0.3,1.4,0.7,2l1,1l47.5,45.8c0.8,1,2.1,1.6,3.4,1.7
	c0.7,0,1.7-0.7,3-2l83.8-107.7c0.4-0.6,0.6-1.3,0.7-2c-0.1-0.7-0.3-1.4-0.7-2l-18.5-14.8C130.1,15.7,129.3,15.4,128.5,15.4`
      }
    )
  }
), WF = ({ plain: e, ref: t, ...n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    ref: t,
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    enableBackground: "new 0 0 56 56",
    xmlSpace: "preserve",
    ...n,
    children: /* @__PURE__ */ p.jsxs("g", { children: [
      /* @__PURE__ */ p.jsx(
        "path",
        {
          style: {
            fill: "#E9E9E0"
          },
          d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "polygon",
        {
          style: {
            fill: "#D9D7CA"
          },
          points: "37.5,0.151 37.5,12 49.349,12  "
        }
      ),
      /* @__PURE__ */ p.jsx(
        "path",
        {
          style: {
            fill: "#C8BDB8"
          },
          d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "circle",
        {
          style: {
            fill: "#FFFFFF"
          },
          cx: 18.5,
          cy: 47,
          r: 3
        }
      ),
      /* @__PURE__ */ p.jsx(
        "circle",
        {
          style: {
            fill: "#FFFFFF"
          },
          cx: 28.5,
          cy: 47,
          r: 3
        }
      ),
      /* @__PURE__ */ p.jsx(
        "circle",
        {
          style: {
            fill: "#FFFFFF"
          },
          cx: 38.5,
          cy: 47,
          r: 3
        }
      )
    ] })
  }
), GF = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M6.71781 11.8709C5.92061 11.8709 5.14132 11.6299 4.47848 11.1784C3.81563 10.7268 3.29901 10.0851 2.99394 9.33423C2.68887 8.58338 2.60905 7.75717 2.76457 6.96007C2.9201 6.16298 3.30398 5.43079 3.86768 4.85612C4.43138 4.28145 5.14958 3.89009 5.93146 3.73153C6.71333 3.57298 7.52377 3.65436 8.26028 3.96537C8.99679 4.27638 9.6263 4.80306 10.0692 5.47881C10.5121 6.15455 10.7485 6.94901 10.7485 7.76173C10.7473 8.85117 10.3223 9.89565 9.56662 10.666C8.81098 11.4364 7.78645 11.8697 6.71781 11.8709ZM6.71781 5.47887C6.27492 5.47887 5.84198 5.61275 5.47373 5.8636C5.10549 6.11444 4.81848 6.47098 4.64899 6.88811C4.47951 7.30525 4.43516 7.76426 4.52156 8.20709C4.60797 8.64992 4.82124 9.05669 5.1344 9.37595C5.44757 9.69522 5.84657 9.91264 6.28095 10.0007C6.71532 10.0888 7.16556 10.0436 7.57474 9.87082C7.98391 9.69803 8.33364 9.40543 8.57969 9.03002C8.82574 8.6546 8.95707 8.21323 8.95707 7.76173C8.95707 7.15627 8.72115 6.57562 8.30121 6.1475C7.88126 5.71938 7.3117 5.47887 6.71781 5.47887ZM13.4356 18.2629C13.4342 17.0524 12.9619 15.892 12.1223 15.036C11.2827 14.1801 10.1444 13.6986 8.95707 13.6972H4.47854C3.29119 13.6986 2.15288 14.1801 1.3133 15.036C0.473723 15.892 0.00142226 17.0524 0 18.2629L0 21.9155H1.79141V18.2629C1.79141 17.5363 2.07452 16.8396 2.57845 16.3258C3.08239 15.8121 3.76587 15.5235 4.47854 15.5235H8.95707C9.66974 15.5235 10.3532 15.8121 10.8572 16.3258C11.3611 16.8396 11.6442 17.5363 11.6442 18.2629V21.9155H13.4356V18.2629ZM15.6749 8.2183C14.8777 8.2183 14.0984 7.9773 13.4356 7.52578C12.7727 7.07426 12.2561 6.4325 11.951 5.68165C11.6459 4.9308 11.5661 4.10459 11.7216 3.3075C11.8772 2.5104 12.2611 1.77822 12.8248 1.20354C13.3885 0.628869 14.1067 0.23751 14.8885 0.078958C15.6704 -0.0795944 16.4808 0.00178044 17.2174 0.312792C17.9539 0.623804 18.5834 1.15048 19.0263 1.82623C19.4692 2.50198 19.7056 3.29644 19.7056 4.10915C19.7044 5.19859 19.2793 6.24307 18.5237 7.01342C17.7681 7.78378 16.7435 8.21709 15.6749 8.2183ZM15.6749 1.82629C15.232 1.82629 14.7991 1.96018 14.4308 2.21102C14.0626 2.46187 13.7755 2.8184 13.6061 3.23554C13.4366 3.65268 13.3922 4.11168 13.4786 4.55451C13.565 4.99735 13.7783 5.40411 14.0915 5.72338C14.4046 6.04264 14.8036 6.26006 15.238 6.34815C15.6724 6.43623 16.1226 6.39102 16.5318 6.21824C16.941 6.04545 17.2907 5.75285 17.5368 5.37744C17.7828 5.00203 17.9141 4.56066 17.9141 4.10915C17.9141 3.5037 17.6782 2.92304 17.2583 2.49492C16.8383 2.06681 16.2688 1.82629 15.6749 1.82629ZM21.497 14.6103C21.4956 13.3998 21.0233 12.2394 20.1837 11.3835C19.3441 10.5275 18.2058 10.046 17.0184 10.0446H13.4356V11.8709H17.0184C17.7311 11.8709 18.4146 12.1595 18.9185 12.6732C19.4225 13.187 19.7056 13.8838 19.7056 14.6103V18.2629H21.497V14.6103Z", fill: "currentColor" }))), UF = ({ plain: e, ref: t, ...n }) => {
  const r = to();
  return /* @__PURE__ */ p.jsxs(
    "svg",
    {
      ref: t,
      version: "1.1",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 160 160",
      enableBackground: "new 0 0 160 160",
      xmlSpace: "preserve",
      ...n,
      children: [
        /* @__PURE__ */ p.jsx("circle", { fill: "#F0F8FE", cx: "66.3", cy: "68.2", r: "56.3" }),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: r.palette.primary.main || "#A9BAD4",
            d: `M152.8,145.2l-39.4-39.4c20.8-26,16.6-64-9.5-84.8s-64-16.6-84.8,9.5s-16.6,64,9.5,84.8
   c23.6,18.9,57.6,17.3,79.4-3.6l39.2,39.2c1.6,1.6,4.1,1.6,5.7,0S154.4,146.8,152.8,145.2z M66.3,120.5C37.4,120.5,14,97.1,14,68.2
   c0-28.9,23.4-52.3,52.3-52.3c28.9,0,52.3,23.4,52.3,52.3c0,13.9-5.5,27.2-15.3,37C93.5,115,80.2,120.5,66.3,120.5z`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: r.palette.primary.main || "#A9BAD4",
            d: `M66.3,34.2c18.8,0,34,15.2,34,34c0,2.2,1.8,4,4,4s4-1.8,4-4c0-23.2-18.8-42-42-42c-2.2,0-4,1.8-4,4
   S64.1,34.2,66.3,34.2z`
          }
        )
      ]
    }
  );
}, YF = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 17 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { width: 7, height: 11, rx: 1, fill: "currentColor" }), /* @__PURE__ */ d.createElement("rect", { y: 13, width: 7, height: 5, rx: 1, fill: "currentColor" }), /* @__PURE__ */ d.createElement("rect", { x: 9, width: 8, height: 6, rx: 1, fill: "currentColor" }), /* @__PURE__ */ d.createElement("rect", { x: 9, y: 8, width: 8, height: 10, rx: 1, fill: "currentColor" })), ZF = (e) => /* @__PURE__ */ d.createElement("svg", { id: "extension", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 160 160", enableBackground: "new 0 0 160 160", xmlSpace: "preserve", ...e }, /* @__PURE__ */ d.createElement("path", { fill: "evenodd", d: "M131.8,67.6c-3.4-3.4-7.5-5.1-12.4-5.1H115V45.8c0-10.1-3.3-18.6-9.9-25.5S90.1,10,79.9,10c-6.8,0-12.8,1.6-18.2,4.9 c-5.4,3.2-9.5,7.6-12.4,13S45,39.3,45,45.8v16.7h-4.4c-4.8,0-9,1.7-12.4,5.1c-3.4,3.4-5.1,7.5-5.1,12.4v52.5c0,4.8,1.7,9,5.1,12.4 s7.5,5.1,12.4,5.1h78.8c4.8,0,9-1.7,12.4-5.1s5.1-7.5,5.1-12.4V80C136.9,75.2,135.2,71,131.8,67.6L131.8,67.6z M85.1,106.3v16.8 c0,1.4-0.5,2.6-1.5,3.6c-1,1-2.2,1.5-3.6,1.5s-2.6-0.5-3.6-1.5c-1-1-1.5-2.2-1.5-3.6v-16.8c-3.4-2-5.1-5-5.1-8.8c0-2.9,1-5.3,3-7.3 c2-2,4.4-3,7.3-3s5.3,1,7.3,3c2,2,3,4.4,3,7.3C90.3,101.3,88.6,104.3,85.1,106.3L85.1,106.3z M105,62.5L105,62.5l-50,0l0,0V45.8 c0-5,1-9.3,3.1-13.3c2-3.8,4.9-6.8,8.7-9.1c3.8-2.3,8.1-3.4,13-3.4c7.4,0,13.3,2.4,18,7.2c4.8,5,7.1,11.1,7.1,18.6V62.5z" })), qF = (e) => /* @__PURE__ */ d.createElement("svg", { id: "extension", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 160 160", enableBackground: "new 0 0 160 160", xmlSpace: "preserve", ...e }, /* @__PURE__ */ d.createElement("path", { fill: "evenodd", d: "M90.3,97.5c0,3.8-1.7,6.8-5.1,8.8v16.8c0,1.4-0.5,2.6-1.5,3.6c-1,1-2.2,1.5-3.6,1.5s-2.6-0.5-3.6-1.5c-1-1-1.5-2.2-1.5-3.6 v-16.8c-3.4-2-5.1-5-5.1-8.8c0-2.9,1-5.3,3-7.3s4.4-3,7.3-3s5.3,1,7.3,3C89.3,92.2,90.3,94.6,90.3,97.5L90.3,97.5L90.3,97.5z" }), /* @__PURE__ */ d.createElement("path", { fill: "evenodd", d: "M131.8,67.6c-3.4-3.4-7.5-5.1-12.4-5.1H55l0,0V45.8c0-5,1-9.3,3.1-13.3c2-3.8,4.9-6.8,8.7-9.1c3.8-2.3,8.1-3.4,13-3.4 c7.4,0,13.3,2.4,18,7.2c1.1,1.1,2,2.3,2.8,3.5l0,0c0.9,1.3,2.4,2.2,4.1,2.2c2.8,0,5-2.3,5-5c0-0.8-0.2-1.6-0.6-2.3 c0,0-0.1-0.1-0.1-0.2c-0.1-0.2-2.7-3.7-4.1-5.1C98.5,13.4,90.1,10,79.9,10c-6.8,0-12.8,1.6-18.2,4.9c-5.4,3.2-9.5,7.6-12.4,13 S45,39.3,45,45.8v16.7h-4.4c-4.8,0-9,1.7-12.4,5.1c-3.4,3.4-5.1,7.5-5.1,12.4v52.5c0,4.8,1.7,9,5.1,12.4s7.5,5.1,12.4,5.1h78.8 c4.8,0,9-1.7,12.4-5.1s5.1-7.5,5.1-12.4V80C136.9,75.2,135.1,71,131.8,67.6L131.8,67.6z M126.9,132.5c0,2.2-0.7,3.8-2.2,5.3 c-1.5,1.5-3.1,2.2-5.3,2.2H40.6c-2.2,0-3.8-0.7-5.3-2.2s-2.2-3.1-2.2-5.3V80c0-2.2,0.7-3.8,2.2-5.3s3.1-2.2,5.3-2.2h78.8 c2.2,0,3.8,0.7,5.3,2.2c1.5,1.5,2.2,3.1,2.2,5.3C126.9,80,126.9,132.5,126.9,132.5z" })), KF = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 15 19", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M15,16.121l0,1c0,0.552 -0.448,1 -1,1l-13,0c-0.552,0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l13,0c0.552,0 1,0.448 1,1Z" }), /* @__PURE__ */ d.createElement("path", { d: "M13.561,6.061l-6.061,-6.061l-6.061,6.061l2.122,2.121l1.939,-1.939l-0,5.878c-0,0.552 0.448,1 1,1l2,0c0.552,0 1,-0.448 1,-1l-0,-5.878l1.939,1.939l2.122,-2.121Z" })), XF = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 15 19", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0,18l0,-1c0,-0.552 0.448,-1 1,-1l13,0c0.552,0 1,0.448 1,1l0,1c0,0.552 -0.448,1 -1,1l-13,0c-0.552,0 -1,-0.448 -1,-1Z" }), /* @__PURE__ */ d.createElement("path", { d: "M1.439,7.939l6.061,6.061l6.061,-6.061l-2.122,-2.121l-1.939,1.939l0,-5.878c0,-0.552 -0.448,-1 -1,-1l-2,0c-0.552,0 -1,0.448 -1,1l0,5.879l-1.939,-1.94l-2.122,2.121Z" })), QF = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 11 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0.958679 4.7681V9.42195C1.02712 10.3116 1.09556 11.4751 1.164 12.2964C1.23244 13.2545 2.05371 14.0074 3.01185 14.0074H8.07631C9.03445 14.0074 9.85574 13.2545 9.92421 12.2964C9.9926 11.4751 10.0611 10.3116 10.1295 9.42195C10.1979 8.39533 10.1295 6.27372 10.1295 4.7681H0.958679Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M10.3348 2.71493H8.62387L8.07637 1.68834C7.73419 1.0724 7.11822 0.661758 6.43379 0.661758H4.79129C4.10689 0.661758 3.4225 1.0724 3.14875 1.68834L2.46436 2.71493H0.753381C0.47963 2.71493 0.205872 2.98868 0.205872 3.26244C0.205872 3.53619 0.47963 3.80995 0.753381 3.80995H10.3348C10.6086 3.80995 10.8823 3.60464 10.8823 3.26244C10.8823 2.92025 10.6086 2.71493 10.3348 2.71493ZM3.62782 2.71493L3.97002 2.16742C4.10689 1.89366 4.38064 1.68834 4.72282 1.68834H6.3654C6.70758 1.68834 6.9813 1.82522 7.11822 2.16742L7.46041 2.71493H3.62782Z", fill: "currentColor" })), JF = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M16.6195 0H6.66977C5.96065 0 5.38379 0.576897 5.38379 1.28598V4.30425C5.65711 4.30425 11.0213 4.30425 11.2354 4.30425C12.5919 4.30425 13.6954 5.40776 13.6954 6.76417C13.6954 7.01809 13.6954 12.4573 13.6954 12.5218H16.6195C17.3286 12.5218 17.9055 11.9449 17.9055 11.2357V1.28598C17.9054 0.576897 17.3286 0 16.6195 0Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M11.2357 5.47852H1.28602C0.576936 5.47852 0 6.05541 0 6.76453V16.7143C3.91302e-05 17.4234 0.576897 18.0003 1.28602 18.0003H11.2357C11.9449 18.0003 12.5218 17.4234 12.5218 16.7143V6.76453C12.5218 6.05541 11.9448 5.47852 11.2357 5.47852Z", fill: "currentColor" })), eV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ d.createElement("path", { fill: "currentColor", d: "M12 3C7.58 3 4 4.79 4 7v10c0 2.21 3.58 4 8 4s8-1.79 8-4V7c0-2.21-3.58-4-8-4Zm0 2c3.87 0 6 1.5 6 2s-2.13 2-6 2-6-1.5-6-2 2.13-2 6-2Zm0 14c-3.87 0-6-1.5-6-2v-1.63C7.48 16.37 9.63 17 12 17s4.52-.63 6-1.63V17c0 .5-2.13 2-6 2Zm0-4c-3.87 0-6-1.5-6-2v-1.63C7.48 12.37 9.63 13 12 13s4.52-.63 6-1.63V13c0 .5-2.13 2-6 2Z" })), tV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 17 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M13.7109 11.6719C12.709 11.6719 11.825 12.1489 11.2449 12.878L6.13983 10.0352C6.2537 9.70914 6.32812 9.36443 6.32812 9C6.32812 8.63557 6.25377 8.29086 6.1399 7.96482L11.2449 5.12205C11.825 5.85105 12.709 6.32812 13.7109 6.32812C15.4557 6.32812 16.875 4.90883 16.875 3.16406C16.875 1.41929 15.4557 0 13.7109 0C11.9662 0 10.5469 1.41929 10.5469 3.16406C10.5469 3.52849 10.6213 3.8732 10.7352 4.19924L5.63013 7.04201C5.04998 6.31301 4.16602 5.83594 3.16406 5.83594C1.41929 5.83594 0 7.25523 0 9C0 10.7448 1.41929 12.1641 3.16406 12.1641C4.16602 12.1641 5.04998 11.687 5.63013 10.958L10.7352 13.8007C10.6213 14.1268 10.5469 14.4715 10.5469 14.8359C10.5469 16.5807 11.9662 18 13.7109 18C15.4557 18 16.875 16.5807 16.875 14.8359C16.875 13.0912 15.4557 11.6719 13.7109 11.6719Z", fill: "currentColor" })), nV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M13.09 13.0913H4.9082V14.7276H13.09V13.0913Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.9082 16.3638V17.1819V18.0001H13.09V17.1819V16.3638H4.9082Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M17.836 4.70539L14.5484 0.326951C14.3939 0.121148 14.1515 0 13.8941 0H12.5454V0.818186V1.63637V6.81816C12.5454 7.26995 12.1791 7.63634 11.7272 7.63634H4.0909C3.63903 7.63634 3.27271 7.26995 3.27271 6.81816V1.63634V0.818186V0H0.818186C0.366326 0 0 0.366396 0 0.818186V17.1817C0 17.6335 0.366326 17.9999 0.818186 17.9999H3.27271V17.1817V16.3635V15.5453V12.2726C3.27271 11.8207 3.63903 11.4544 4.0909 11.4544H13.909C14.3609 11.4544 14.7272 11.8207 14.7272 12.2726V15.5453V16.3635V17.1817V17.9999H17.1817C17.6336 17.9999 17.9999 17.6335 17.9999 17.1817V5.19666C17.9999 5.01951 17.9423 4.84703 17.836 4.70539Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.9082 0V0.818186V1.63634V5.99997H10.9082V1.63634V0.818186V0H4.9082Z", fill: "currentColor" })), oV = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M17.5 2.5L8.75 11.25M17.5 2.5L11.875 17.5L8.75 11.25M17.5 2.5L2.5 8.125L8.75 11.25", stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round" })), rV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" }), /* @__PURE__ */ d.createElement("path", { d: "m9 12 2 2 4-4" })), iV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", stroke: "#5f6368", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", ...e }, /* @__PURE__ */ d.createElement("rect", { width: 18, height: 18, x: 3, y: 3, rx: 2 }), /* @__PURE__ */ d.createElement("path", { d: "M9 3v18" }), /* @__PURE__ */ d.createElement("path", { d: "m16 15-3-3 3-3" })), sV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }), /* @__PURE__ */ d.createElement("path", { d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" })), aV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M21 5H3" }), /* @__PURE__ */ d.createElement("path", { d: "M15 12H3" }), /* @__PURE__ */ d.createElement("path", { d: "M17 19H3" })), lV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 13 14", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 1, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M11.373,7l-9.746,-5.627l-0,11.254l9.746,-5.627Z", stroke: "currentColor", strokeWidth: "1.86px" })), cV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 18 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.4094 5.73359C17.4094 5.89518 17.3363 6.04822 17.2099 6.15121L11.2421 11.016C11.0783 11.1495 10.8516 11.1776 10.6594 11.0883C10.4676 10.999 10.3449 10.8081 10.3449 10.5985V8.64946C6.52595 8.88035 3.25489 11.5091 2.28137 15.2009C2.21865 15.4393 2.00048 15.6058 1.75111 15.6058C1.50173 15.6058 1.28343 15.4393 1.22084 15.2009C1.00703 14.39 0.898438 13.5506 0.898438 12.7064C0.898438 10.0695 1.93821 7.59045 3.82589 5.72577C5.58384 3.98936 7.88142 2.97932 10.3449 2.84868V0.868689C10.3449 0.659081 10.4676 0.468387 10.6594 0.379062C10.8517 0.289772 11.0783 0.317719 11.2421 0.451198L17.2099 5.31613C17.3364 5.41896 17.4094 5.57213 17.4094 5.73359Z", fill: "white" })), uV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M12 5.99L19.53 19H4.47L12 5.99M2.74 18c-.77 1.33.19 3 1.73 3h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18zM11 11v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zm0 5h2v2h-2z" })), vh = (e) => /* @__PURE__ */ d.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 500 500", enableBackground: "new 0 0 500 500", xmlSpace: "preserve", ...e }, /* @__PURE__ */ d.createElement("style", { type: "text/css" }, `
	.st0{fill:#FFFFFF;}
	.st1{fill:#EEF7FE;}
	.st2{fill:#BABABA;}
	.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#676766;}
	.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#EEF7FE;}
	.st5{fill:#5BA0D8;}
`), /* @__PURE__ */ d.createElement("circle", { className: "st0", cx: 250, cy: 250, r: 250 }), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { className: "st1", d: "M86.8,176.5h326.4c11.4,0,20.6,9.2,20.6,20.6v70.4c0,11.4-9.2,20.6-20.6,20.6H86.8 c-11.4,0-20.6-9.2-20.6-20.6v-70.4C66.2,185.7,75.4,176.5,86.8,176.5z" }), /* @__PURE__ */ d.createElement("path", { className: "st2", d: "M413.2,181.5c8.6,0,15.6,7,15.6,15.6v70.4c0,8.6-7,15.6-15.6,15.6H86.8c-8.6,0-15.6-7-15.6-15.6v-70.4 c0-8.6,7-15.6,15.6-15.6H413.2 M413.2,171.5H86.8c-14.1,0-25.6,11.5-25.6,25.6v70.4c0,14.1,11.5,25.6,25.6,25.6h326.4 c14.1,0,25.6-11.5,25.6-25.6v-70.4C438.8,182.9,427.3,171.5,413.2,171.5L413.2,171.5z" })), /* @__PURE__ */ d.createElement("path", { className: "st2", d: "M406.8,200.7c1.5,0,2.8,1.3,2.8,2.8v57.6c0,1.5-1.3,2.8-2.8,2.8H93.2c-1.5,0-2.8-1.3-2.8-2.8v-57.6 c0-1.5,1.3-2.8,2.8-2.8H406.8 M406.8,190.7H93.2c-7.1,0-12.8,5.7-12.8,12.8v57.6c0,7.1,5.7,12.8,12.8,12.8h313.6 c7.1,0,12.8-5.7,12.8-12.8v-57.6C419.6,196.4,413.9,190.7,406.8,190.7L406.8,190.7z" }), /* @__PURE__ */ d.createElement("path", { className: "st3", d: "M115.2,232.2c0,4,0,8,0,12c0,3.7-2.2,6.4-5.3,6.4c-3.1,0-5.3-2.6-5.3-6.4c0-8,0-15.9,0-23.9 c0-3.8,2.2-6.5,5.4-6.5c3,0,5.2,2.7,5.2,6.5C115.2,224.3,115.2,228.3,115.2,232.2" }), /* @__PURE__ */ d.createElement("path", { className: "st3", d: "M135.5,232.2c0,4,0,8,0,12c0,3.7-2.2,6.4-5.3,6.4c-3.1,0-5.3-2.6-5.3-6.4c0-8,0-15.9,0-23.9 c0-3.8,2.2-6.5,5.4-6.5c3,0,5.2,2.7,5.2,6.5C135.5,224.3,135.5,228.3,135.5,232.2" }), /* @__PURE__ */ d.createElement("path", { className: "st3", d: "M155.9,232.2c0,4,0,8,0,12c0,3.7-2.2,6.4-5.3,6.4c-3.1,0-5.3-2.6-5.3-6.4c0-8,0-15.9,0-23.9 c0-3.8,2.2-6.5,5.4-6.5c3,0,5.2,2.7,5.2,6.5C155.9,224.3,155.9,228.3,155.9,232.2" }), /* @__PURE__ */ d.createElement("path", { className: "st3", d: "M176.3,232.2c0,4,0,8,0,12c0,3.7-2.2,6.4-5.3,6.4c-3.1,0-5.3-2.6-5.3-6.4c0-8,0-15.9,0-23.9 c0-3.8,2.2-6.5,5.4-6.5c3,0,5.2,2.7,5.2,6.5C176.3,224.3,176.3,228.3,176.3,232.2" }), /* @__PURE__ */ d.createElement("path", { className: "st3", d: "M196.7,232.2c0,4,0,8,0,12c0,3.7-2.2,6.4-5.3,6.4c-3.1,0-5.3-2.6-5.3-6.4c0-8,0-15.9,0-23.9 c0-3.8,2.2-6.5,5.4-6.5c3,0,5.2,2.7,5.2,6.5C196.7,224.3,196.7,228.3,196.7,232.2" }), /* @__PURE__ */ d.createElement("path", { className: "st4", d: "M301,154.7c-43.2,0-78.4,35.1-78.4,78.4s35.2,78.4,78.4,78.4s78.4-35.1,78.4-78.4S344.3,154.7,301,154.7 L301,154.7z M301,299.4c-36.6,0-66.3-29.7-66.3-66.3s29.7-66.3,66.3-66.3s66.3,29.7,66.3,66.3S337.7,299.4,301,299.4z" }), /* @__PURE__ */ d.createElement("path", { className: "st5", d: "M301,171.7c33.8,0,61.3,27.5,61.3,61.3s-27.5,61.3-61.3,61.3s-61.3-27.5-61.3-61.3S267.2,171.7,301,171.7  M301,166.7c-36.6,0-66.3,29.7-66.3,66.3s29.7,66.3,66.3,66.3s66.3-29.7,66.3-66.3S337.7,166.7,301,166.7L301,166.7z" }), /* @__PURE__ */ d.createElement("path", { className: "st5", d: "M385.5,233c0-46.6-37.8-84.4-84.4-84.4s-84.4,37.8-84.4,84.4s34.5,81,78.3,84.2v25.1c-3.6,2.1-6.1,6-6.1,10.6 v48.9c0,6.8,5.5,12.2,12.2,12.2s12.2-5.5,12.2-12.2v-48.9c0-4.5-2.5-8.5-6.1-10.6v-25.1C350.9,314.1,385.5,277.6,385.5,233 L385.5,233z M228.7,233c0-39.9,32.4-72.3,72.3-72.3s72.3,32.4,72.3,72.3s-32.4,72.3-72.3,72.3S228.7,272.9,228.7,233L228.7,233z" }))), dV = (e) => /* @__PURE__ */ d.createElement("svg", { focusable: "false", "aria-hidden": "true", viewBox: "0 0 24 24", "data-testid": "ChatBubbleOutlinedIcon", tabIndex: -1, title: "ChatBubbleOutlined", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" })), pV = (e) => /* @__PURE__ */ d.createElement("svg", { id: "extension", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm4.3 14.3c-.39.39-1.02.39-1.41 0L12 13.41 9.11 16.3c-.39.39-1.02.39-1.41 0a.9959.9959 0 0 1 0-1.41L10.59 12 7.7 9.11a.9959.9959 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L12 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z" })), fV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 18 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M17.5818 0.942043C17.0248 0.384378 16.1205 0.384729 15.5628 0.942043L6.47616 10.029L2.43754 5.99045C1.87988 5.43279 0.975913 5.43279 0.418249 5.99045C-0.139416 6.54812 -0.139416 7.45208 0.418249 8.00975L5.46631 13.0578C5.74496 13.3365 6.11035 13.4761 6.47578 13.4761C6.8412 13.4761 7.20694 13.3368 7.4856 13.0578L17.5818 2.9613C18.1394 2.40402 18.1394 1.49967 17.5818 0.942043Z", fill: "currentColor" })), gV = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 10 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M5 5L0 0H10L5 5Z", fill: "currentColor" })), mV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 9, cy: 9, r: 9, fill: "currentColor", fillOpacity: 0.3 }), /* @__PURE__ */ d.createElement("path", { d: "M8 8.10138V13.0783C8 13.5874 8.41968 14 8.9375 14C9.45532 14 9.875 13.5874 9.875 13.0783V8.10138C9.875 7.59231 9.45532 7.17972 8.9375 7.17972C8.41968 7.17972 8 7.59231 8 8.10138Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M9.875 4.92166C9.875 4.41259 9.45532 4 8.9375 4C8.41968 4 8 4.41259 8 4.92166C8 5.43073 8.41968 5.84332 8.9375 5.84332C9.45532 5.84332 9.875 5.43073 9.875 4.92166Z", fill: "currentColor" })), hV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 28 25", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M19.842,0l1.938,0l0,4.306c-0.617,-0.265 -1.255,-0.419 -1.938,-0.486l0,-3.82Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M0,1.06c0,-0.309 0.11,-0.552 0.308,-0.751c0.199,-0.199 0.463,-0.309 0.749,-0.309l17.067,-0l0,3.843c-1.541,0.22 -2.929,0.927 -3.964,1.987c-1.277,1.281 -2.048,3.026 -2.048,4.969c0,1.943 0.793,3.71 2.048,4.969c1.057,1.06 2.423,1.766 3.964,1.987l0,3.048l-16.979,-0c-0.418,-0 -0.793,0.088 -1.145,0.243l0,-19.986Zm2.755,6.026l5.758,-0c0.505,-0 0.895,-0.39 0.895,-0.895c0,-0.504 -0.39,-0.894 -0.895,-0.894l-5.758,-0c-0.481,-0 -0.894,0.39 -0.894,0.894c-0,0.505 0.413,0.895 0.894,0.895Zm0,-3.349l5.758,-0c0.505,-0 0.895,-0.39 0.895,-0.895c0,-0.504 -0.413,-0.894 -0.895,-0.894l-5.758,-0c-0.481,-0 -0.894,0.39 -0.894,0.894c-0,0.505 0.413,0.895 0.894,0.895Zm0,6.722l5.758,-0c0.505,-0 0.895,-0.39 0.895,-0.895c0,-0.505 -0.39,-0.895 -0.895,-0.895l-5.758,0c-0.481,0 -0.894,0.39 -0.894,0.895c-0,0.482 0.413,0.895 0.894,0.895Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M21.78,24.822l-20.635,0c-0.33,0 -0.616,-0.133 -0.815,-0.331c-0.22,-0.221 -0.33,-0.486 -0.33,-0.817c0,-0.332 0.132,-0.619 0.33,-0.817c0.221,-0.221 0.485,-0.332 0.815,-0.332l17.838,0c0.221,0 0.441,-0.088 0.617,-0.243c0.176,-0.154 0.242,-0.375 0.242,-0.618l0,-3.864c0.683,-0.067 1.344,-0.243 1.938,-0.486l0,7.508Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M22.49,15.395c-0.896,0.617 -1.982,0.979 -3.152,0.979c-3.072,-0 -5.567,-2.495 -5.567,-5.568c-0,-3.072 2.495,-5.567 5.567,-5.567c3.073,-0 5.568,2.495 5.568,5.567c-0,1.267 -0.424,2.435 -1.138,3.371l3.977,3.988c0.34,0.341 0.34,0.909 0,1.25c-0.34,0.341 -0.907,0.341 -1.247,-0l-4.008,-4.02Zm-3.12,-8.774c-2.277,0 -4.126,1.849 -4.126,4.127c-0,2.277 1.849,4.126 4.126,4.126c2.278,0 4.127,-1.849 4.127,-4.126c-0,-2.278 -1.849,-4.127 -4.127,-4.127Z", fill: "currentColor" }))), vV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", enableBackground: "new 0 0 24 24", viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M19.42,4.71L19.42,4.71c-0.39-0.39-1.02-0.39-1.41,0l-8.48,8.49L5.99,9.66c-0.39-0.39-1.02-0.39-1.41,0l0,0 c-0.39,0.39-0.39,1.02,0,1.41l4.24,4.24c0.39,0.39,1.02,0.39,1.41,0l9.19-9.19C19.82,5.73,19.82,5.1,19.42,4.71z" }), /* @__PURE__ */ d.createElement("path", { d: "M6,20h12c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H6c-0.55,0-1,0.45-1,1v0C5,19.55,5.45,20,6,20z" })))), yV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 6 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 3, cy: 3, r: 3, fill: "currentColor" })), bV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 13 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M11.457,2.495l-2.096,-1.938c-0.38,-0.361 -0.881,-0.557 -1.406,-0.557l-5.884,-0c-1.14,-0 -2.071,0.931 -2.071,2.071l0,11.058c0,1.14 0.931,2.071 2.071,2.071l7.974,0c1.14,0 2.071,-0.931 2.071,-2.071l-0,-9.114c-0,-0.576 -0.241,-1.127 -0.659,-1.52Zm-7.467,2.711c1.712,-1.712 1.653,-1.661 1.716,-1.704c0.102,-0.069 0.228,-0.107 0.349,-0.107l0.006,-0c0.165,-0 0.323,0.069 0.443,0.183c0.66,0.663 1.688,1.695 1.622,1.628c0.247,0.247 0.247,0.646 -0,0.893c-0.247,0.247 -0.646,0.247 -0.893,0l-0.539,-0.538l0,2.235c0,0.355 -0.285,0.634 -0.633,0.634c-0.355,-0 -0.633,-0.279 -0.633,-0.634l-0,-2.235l-0.545,0.544c-0.237,0.237 -0.641,0.252 -0.893,0c-0.247,-0.247 -0.247,-0.652 -0,-0.899Zm4.522,6.599l-4.908,0c-0.349,0 -0.634,-0.285 -0.634,-0.633c0,-0.348 0.285,-0.633 0.634,-0.633l4.908,-0c0.348,-0 0.633,0.285 0.633,0.633c0,0.348 -0.285,0.633 -0.633,0.633Z", fill: "currentColor", fillRule: "nonzero" })), yh = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 46 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M5.271 11.5C5.271 8.05973 8.05988 5.27084 11.5002 5.27084H26.8335C27.6274 5.27084 28.271 4.62725 28.271 3.83334C28.271 3.03944 27.6274 2.39584 26.8335 2.39584H11.5002C6.47208 2.39584 2.396 6.47192 2.396 11.5V34.5C2.396 39.5282 6.47208 43.6042 11.5002 43.6042H34.5002C39.5284 43.6042 43.6043 39.5282 43.6043 34.5V19.1667C43.6043 18.3728 42.9607 17.7292 42.1668 17.7292C41.373 17.7292 40.7293 18.3728 40.7293 19.1667V25.8925C40.6429 25.8233 40.553 25.7575 40.4599 25.6954L35.8965 22.6531C32.8557 20.6258 28.8067 21.0268 26.2225 23.611L19.7779 30.0556C17.1936 32.6399 13.1447 33.0409 10.1039 31.0136L5.271 27.7917V11.5ZM37.8543 3.83334C37.8543 3.03944 37.2107 2.39584 36.4168 2.39584C35.623 2.39584 34.9793 3.03944 34.9793 3.83334V8.14584H30.6668C29.873 8.14584 29.2293 8.78944 29.2293 9.58334C29.2293 10.3772 29.873 11.0208 30.6668 11.0208H34.9793V15.3333C34.9793 16.1272 35.623 16.7708 36.4168 16.7708C37.2107 16.7708 37.8543 16.1272 37.8543 15.3333V11.0208H42.1668C42.9607 11.0208 43.6043 10.3772 43.6043 9.58334C43.6043 8.78944 42.9607 8.14584 42.1668 8.14584H37.8543V3.83334ZM16.2918 21.0833C18.9382 21.0833 21.0835 18.938 21.0835 16.2917C21.0835 13.6453 18.9382 11.5 16.2918 11.5C13.6455 11.5 11.5002 13.6453 11.5002 16.2917C11.5002 18.938 13.6455 21.0833 16.2918 21.0833Z", fill: "url(#paint0_linear_38_223)" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_38_223", x1: 43.6412, y1: -7.66666, x2: 17.1027, y2: 35.9744, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#71BDFF" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#085CA5" })))), bh = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 46 46", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("g", { opacity: 0.5 }, /* @__PURE__ */ d.createElement("path", { id: "Vector", d: "M16.292,21.083c2.646,0 4.791,-2.145 4.791,-4.791c0,-2.647 -2.145,-4.792 -4.791,-4.792c-2.647,-0 -4.792,2.145 -4.792,4.792c0,2.646 2.145,4.791 4.792,4.791Z", fill: "url(#_Linear1)" }), /* @__PURE__ */ d.createElement("path", { id: "Vector1", "serif:id": "Vector", d: "M2.396,34.5l0,-23c0,-5.028 4.076,-9.104 9.104,-9.104l23,-0c5.028,-0 9.104,4.076 9.104,9.104l0,23c0,5.028 -4.076,9.104 -9.104,9.104l-23,0c-5.028,0 -9.104,-4.076 -9.104,-9.104Zm32.104,-29.229l-23,-0c-3.44,-0 -6.229,2.789 -6.229,6.229l0,16.292l4.833,3.222c3.041,2.027 7.09,1.626 9.674,-0.958l6.445,-6.445c2.584,-2.584 6.633,-2.985 9.674,-0.958l4.563,3.042c0.093,0.062 0.183,0.128 0.269,0.197l0,-14.392c0,-3.44 -2.789,-6.229 -6.229,-6.229Z", fill: "url(#_Linear2)" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "_Linear1", x1: 0, y1: 0, x2: 1, y2: 0, gradientUnits: "userSpaceOnUse", gradientTransform: "matrix(-26.5385,43.6411,-43.6411,-26.5385,43.6412,-7.66666)" }, /* @__PURE__ */ d.createElement("stop", { offset: 0, stopColor: "#71bdff", stopOpacity: 1 }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#085ca5", stopOpacity: 1 })), /* @__PURE__ */ d.createElement("linearGradient", { id: "_Linear2", x1: 0, y1: 0, x2: 1, y2: 0, gradientUnits: "userSpaceOnUse", gradientTransform: "matrix(-26.5385,43.6411,-43.6411,-26.5385,43.6412,-7.66666)" }, /* @__PURE__ */ d.createElement("stop", { offset: 0, stopColor: "#71bdff", stopOpacity: 1 }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#085ca5", stopOpacity: 1 })))), CV = (e) => /* @__PURE__ */ d.createElement("svg", { className: "icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ d.createElement("title", null, "Zoom In"), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" }), /* @__PURE__ */ d.createElement("path", { d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z" }))), xV = (e) => /* @__PURE__ */ d.createElement("svg", { className: "icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ d.createElement("title", null, "Zoom Out"), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z" }), `{'
        '} `)), wV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" })), SV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z" })), EV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 64l0 256 160 0 0-256L64 160zm384 0l-160 0 0 256 160 0 0-256z" })), RV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" })), TV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z" })), MV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 791 791", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("g", { transform: "matrix(1,0,0,1,-126.81,-106.367)" }, /* @__PURE__ */ d.createElement("path", { d: "M602.24,246.72C602.205,239.322 597.422,232.729 590.4,230.4L547.52,216C520.779,207.258 499.584,186.537 490.24,160L475.84,117.12C473.193,110.631 466.849,106.367 459.84,106.367C452.831,106.367 446.487,110.631 443.84,117.12L428.8,160C419.793,187.024 398.544,208.273 371.52,217.28L328.64,231.68C322.151,234.327 317.887,240.671 317.887,247.68C317.887,254.689 322.151,261.033 328.64,263.68L371.52,278.08C398.544,287.087 419.793,308.336 428.8,335.36L443.2,378.24C445.847,384.729 452.191,388.993 459.2,388.993C466.209,388.993 472.553,384.729 475.2,378.24L489.6,335.36C498.607,308.336 519.856,287.087 546.88,278.08L589.76,263.68C597.258,261.514 602.402,254.523 602.24,246.72ZM903.36,468.48L855.04,452.48C824.867,442.381 801.139,418.653 791.04,388.48L775.04,340.16C772.621,332.046 765.107,326.445 756.64,326.445C748.173,326.445 740.659,332.046 738.24,340.16L722.24,388.48C712.141,418.653 688.413,442.381 658.24,452.48L609.92,468.48C601.806,470.899 596.205,478.413 596.205,486.88C596.205,495.347 601.806,502.861 609.92,505.28L658.24,521.28C688.413,531.379 712.141,555.107 722.24,585.28L738.24,633.6C740.659,641.714 748.173,647.315 756.64,647.315C765.107,647.315 772.621,641.714 775.04,633.6L791.04,585.28C801.139,555.107 824.867,531.379 855.04,521.28L903.36,505.28C911.474,502.861 917.075,495.347 917.075,486.88C917.075,478.413 911.474,470.899 903.36,468.48ZM526.72,664L462.72,643.2C423.299,630.096 392.304,599.101 379.2,559.68L358.4,495.68C354.842,485.596 345.254,478.81 334.56,478.81C323.866,478.81 314.278,485.596 310.72,495.68L289.92,559.68C277.08,598.817 246.614,629.757 207.68,643.2L143.68,664C133.596,667.558 126.81,677.146 126.81,687.84C126.81,698.534 133.596,708.122 143.68,711.68L207.68,732.48C247.173,745.65 278.181,776.777 291.2,816.32L312,880.32C315.558,890.404 325.146,897.19 335.84,897.19C346.534,897.19 356.122,890.404 359.68,880.32L380.48,816.32C393.584,776.899 424.579,745.904 464,732.8L528,712C538.084,708.442 544.87,698.854 544.87,688.16C544.87,677.466 538.084,667.878 528,664.32L526.72,664Z", fill: "currentColor", fillRule: "nonzero" }))), kV = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z" })), PV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 1712 1733", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M238.728,1460.92l-45.337,45.337c-11.078,11.077 -26.282,17.376 -41.921,17.376c-32.798,0 -59.297,-26.499 -59.297,-59.297l0,-218.725c0,-19.115 15.639,-34.753 34.753,-34.753l218.726,0.217c32.798,-0 59.297,26.499 59.297,59.297c-0,15.639 -6.299,30.843 -17.377,41.921l-54.373,54.373c133.643,142.793 323.963,232.224 535.302,232.224c340,0 625.833,-231.25 708.75,-545c8.333,-31.666 36.25,-55 68.75,-55c41.667,0 73.333,37.084 63.333,77.5c-94.166,376.667 -435,655.834 -840.833,655.834c-247.957,-0 -471.57,-104.396 -629.773,-271.304Z" }), /* @__PURE__ */ d.createElement("path", { d: "M1377.99,365.558c-133.643,-142.794 -323.963,-232.225 -535.302,-232.225c-340,0 -625.833,231.25 -708.75,545c-8.333,31.667 -36.25,55 -68.75,55c-41.666,0 -73.333,-37.083 -63.333,-77.5c94.167,-376.666 435,-655.833 840.833,-655.833c247.958,-0 471.57,104.396 629.774,271.304l45.337,-45.337c11.077,-11.078 26.281,-17.377 41.92,-17.377c32.798,0 59.297,26.499 59.297,59.297l0,218.726c0,19.114 -15.639,34.753 -34.753,34.753l-218.725,-0.217c-32.798,-0 -59.297,-26.499 -59.297,-59.297c-0,-15.639 6.298,-30.843 17.376,-41.921l54.373,-54.373Z" })), /* @__PURE__ */ d.createElement("path", { d: "M1330.99,688.594c6.411,17.43 1.002,36.863 -12.822,49.284l-86.748,78.935c2.204,16.629 3.406,33.658 3.406,50.888c-0,17.229 -1.202,34.258 -3.406,50.887l86.748,78.935c13.824,12.421 19.233,31.854 12.822,49.284c-8.815,23.841 -19.433,46.68 -31.654,68.718l-9.416,16.228c-13.223,22.037 -28.048,42.873 -44.276,62.507c-11.82,14.424 -31.454,19.233 -49.084,13.623l-111.591,-35.461c-26.846,20.636 -56.496,37.865 -88.151,50.887l-25.043,114.396c-4.006,18.231 -18.03,32.656 -36.462,35.661c-27.647,4.608 -56.096,7.012 -85.146,7.012c-29.049,0 -57.498,-2.404 -85.145,-7.012c-18.432,-3.005 -32.456,-17.43 -36.463,-35.661l-25.043,-114.396c-31.654,-13.022 -61.305,-30.251 -88.151,-50.887l-111.39,35.661c-17.631,5.61 -37.264,0.601 -49.084,-13.623c-16.228,-19.634 -31.054,-40.469 -44.276,-62.507l-9.416,-16.228c-12.221,-22.038 -22.839,-44.877 -31.654,-68.717c-6.411,-17.43 -1.002,-36.864 12.821,-49.285l86.749,-78.935c-2.204,-16.829 -3.406,-33.858 -3.406,-51.087c0,-17.23 1.202,-34.259 3.406,-50.888l-86.749,-78.935c-13.823,-12.421 -19.232,-31.854 -12.821,-49.284c8.815,-23.841 19.433,-46.68 31.654,-68.718l9.416,-16.227c13.222,-22.038 28.048,-42.874 44.276,-62.507c11.82,-14.425 31.453,-19.233 49.084,-13.624l111.591,35.461c26.846,-20.635 56.496,-37.865 88.151,-50.887l25.042,-114.396c4.007,-18.231 18.031,-32.656 36.463,-35.661c27.647,-4.808 56.096,-7.212 85.146,-7.212c29.049,-0 57.498,2.404 85.145,7.012c18.432,3.005 32.456,17.429 36.463,35.661l25.043,114.395c31.654,13.023 61.305,30.252 88.151,50.888l111.591,-35.461c17.63,-5.61 37.263,-0.601 49.084,13.623c16.227,19.634 31.053,40.469 44.275,62.507l9.417,16.228c12.221,22.038 22.839,44.877 31.654,68.718l-0.201,0.2Zm-480.622,339.381c87.924,-0 160.274,-72.351 160.274,-160.274c0,-87.924 -72.35,-160.275 -160.274,-160.275c-87.924,0 -160.275,72.351 -160.275,160.275c0,87.923 72.351,160.274 160.275,160.274Z", fillRule: "nonzero" })), IV = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 30 22", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2
}, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M14.495,16.087l-12.331,0.051c-1.19,0.004 -2.159,-0.957 -2.164,-2.146c-0.005,-1.19 0.957,-2.159 2.146,-2.164l12.349,-0.05l0,4.309Zm0,-5.873l-7.867,0.032c-1.308,0.005 -2.374,-1.053 -2.38,-2.361c-0.005,-1.308 1.053,-2.374 2.361,-2.38l7.886,-0.032l0,4.741Zm0,-6.296l-4.765,0.02c-1.071,0.004 -1.943,-0.861 -1.948,-1.932c-0.004,-1.07 0.861,-1.943 1.932,-1.947l4.781,-0.019l0,3.878Zm1.035,-3.883l8.678,-0.035c1.07,-0.004 1.943,0.861 1.947,1.931c0.005,1.071 -0.861,1.943 -1.931,1.948l-8.694,0.035l-0,-3.879Zm-0,5.434l12.09,-0.049c1.308,-0.006 2.375,1.052 2.38,2.36c0.005,1.309 -1.052,2.375 -2.361,2.38l-12.109,0.05l-0,-4.741Zm-0,6.305l7.959,-0.033c1.189,-0.005 2.158,0.957 2.163,2.146c0.005,1.19 -0.957,2.159 -2.146,2.164l-7.976,0.032l-0,-4.309Zm-0,5.809l11.207,-0.045c1.07,-0.005 1.943,0.861 1.947,1.931c0.005,1.07 -0.861,1.943 -1.931,1.947l-11.223,0.046l-0,-3.879Zm-1.035,3.883l-4.241,0.017c-1.071,0.005 -1.943,-0.861 -1.947,-1.931c-0.005,-1.07 0.861,-1.943 1.931,-1.947l4.257,-0.018l0,3.879Z" })), OV = {
  add: iF,
  analysis: e0,
  analysisSubmission: e0,
  arrowDown: gV,
  bookmark: oF,
  chatBubble: sF,
  chart: e0,
  check: aF,
  checkboxEmpty: lF,
  checkboxIndeterminate: cF,
  checkboxSelected: uF,
  checkmark: fV,
  chevron: dF,
  chevronRight: RV,
  chevronLeft: TV,
  chevronSorting: pF,
  chevronFilled: fF,
  close: gF,
  compare: IV,
  cohort: mF,
  aiStars: hF,
  collapse: vF,
  columns: EV,
  conceptSets: yF,
  copy: JF,
  csv: IF,
  dataSources: bF,
  database: eV,
  deactivate: CF,
  delete: QF,
  doc: EF,
  documents: xF,
  dot: yV,
  download: OF,
  downloadDone: vV,
  edit: jF,
  view: FF,
  emptyTable: hh,
  expand: VF,
  export: KF,
  fileUpload: bV,
  filter: SV,
  folder: rF,
  import: XF,
  play: lV,
  invitation: $F,
  json: MF,
  list: LF,
  logout: AF,
  message: dV,
  notification: NF,
  optimize: PV,
  participants: BF,
  pdf: wF,
  private: ZF,
  public: qF,
  publish: tV,
  r: C5,
  reload: _F,
  rProfile: C5,
  save: nV,
  send: oV,
  shieldCheck: rV,
  sidebarClose: iV,
  squarePen: sV,
  textAlignStart: aV,
  search: zF,
  searchPlaceholder: vh,
  settings: wV,
  sliders: kV,
  sql: kF,
  submit: HF,
  terminated: pV,
  txt: SF,
  upload: DF,
  uploadFiles: WF,
  users: GF,
  vocabulary: UF,
  warning: uV,
  workspace: YF,
  xls: TF,
  zip: PF,
  zoomIn: CV,
  zoomOut: xV,
  unknown: RF,
  info: mV,
  study: hV,
  share: cV,
  imagePlaceholder: bh,
  imageAdd: yh,
  stars: MV,
  mp4: mu,
  avi: mu,
  mov: mu,
  flv: mu,
  mp3: t0,
  wav: t0,
  wma: t0
}, qn = ({
  iconName: e,
  iconStatus: t,
  plain: n = !1,
  ref: r,
  ...i
}) => {
  const s = OV[e] || (() => /* @__PURE__ */ p.jsx(p.Fragment, {}));
  return /* @__PURE__ */ p.jsx(or, { ...i, ref: r, inheritViewBox: !0, children: /* @__PURE__ */ p.jsx(
    s,
    {
      ...t ? { iconStatus: t } : {},
      color: i.color,
      ...i.width ? {
        width: i.width,
        height: i.height
      } : {}
    }
  ) });
}, n0 = (e, t) => t ? /* @__PURE__ */ p.jsx(Vd, { size: 16, sx: { mt: 0.25 } }) : /* @__PURE__ */ p.jsx(qn, { iconName: e }), ii = (e) => {
  const { stopPropagation: t, onClick: n, loading: r, ...i } = e;
  return /* @__PURE__ */ p.jsx(
    Hp,
    {
      icon: n0("checkboxEmpty", r),
      checkedIcon: n0("checkboxSelected", r),
      indeterminateIcon: n0("checkboxIndeterminate", r),
      ...i,
      onClick: (s) => {
        n && n(s), t && s.stopPropagation();
      },
      classes: {
        root: "app-checkbox"
      },
      sx: [
        (s) => ({
          padding: 0,
          ...e.disabled ? {
            opacity: 0.5,
            svg: {
              filter: "brightness(0.97)",
              rect: {
                fill: s.palette.backgroundColor.dark
              }
            }
          } : {}
        }),
        ...Array.isArray(i.sx) ? i.sx : [i.sx]
      ]
    }
  );
}, x5 = {
  padding: 0
}, w5 = {
  fontWeight: 300,
  display: "flex",
  alignItems: "center",
  width: "100%",
  padding: "2px 12px",
  "& div": {
    marginLeft: "10px",
    display: "inline-block"
  }
}, DV = {
  minWidth: "auto",
  padding: "2px 4px"
}, jV = ({
  allColumns: e,
  showColumnToggle: t,
  getToggleHideAllColumnsProps: n,
  immutableColumns: r = ["actions", "selection"]
}) => {
  const { t: i } = ec(), s = He.useMemo(
    () => e.filter(
      (a) => !["actions", "selection", ...r].includes(a.id)
    ),
    [r, e]
  );
  return t ? /* @__PURE__ */ p.jsx(
    gh,
    {
      size: "small",
      title: i("tables.base.columns"),
      fullWidth: !1,
      sx: DV,
      preventOverflow: !0,
      children: /* @__PURE__ */ p.jsxs(An, { sx: { p: 0, m: 0 }, children: [
        /* @__PURE__ */ p.jsx(xr, { sx: x5, children: /* @__PURE__ */ p.jsxs(An, { component: "label", sx: w5, children: [
          /* @__PURE__ */ p.jsx(ii, { size: "small", ...n() }),
          /* @__PURE__ */ p.jsx(An, { sx: { marginLeft: "8px" }, children: "Show All" })
        ] }) }, "select-all"),
        s.map((a) => /* @__PURE__ */ p.jsx(xr, { sx: x5, children: /* @__PURE__ */ p.jsxs(An, { component: "label", sx: w5, children: [
          /* @__PURE__ */ p.jsx(ii, { size: "small", ...a.getToggleHiddenProps() }),
          /* @__PURE__ */ p.jsx(An, { sx: { marginLeft: "8px" }, children: a.id !== "selection" ? a.render("Header") : "Selection" })
        ] }) }, a.id))
      ] })
    }
  ) : /* @__PURE__ */ p.jsx("span", {});
}, FV = ({
  page: e,
  tileComponent: t,
  prepareRow: n,
  onRowClick: r
}) => /* @__PURE__ */ p.jsx(Tn, { container: !0, spacing: 1, py: 2, minWidth: "100%", children: e.map((i, s) => (n(i), /* @__PURE__ */ p.jsx(
  t,
  {
    className: "tile tile-" + s,
    value: i.original,
    onClick: () => r(i),
    row: i
  },
  "tile-" + i.original.id + s
))) }), VV = yo.div`
  text-align: right;
  font-family: ${({ theme: e }) => {
  var t;
  return ((t = e.typography) == null ? void 0 : t.fontFamily) || "sans-serif";
}};
  font-size: ${({ theme: e }) => {
  var t;
  return ((t = e.typography) == null ? void 0 : t.fontSize) || 13;
}}px;
  line-height: 22px;
  & .dots {
    display: inline-block;
    cursor: default;
    padding: 2px 8px;
  }
  & span {
    font-size: 0.8rem;
  }
`, o0 = yo(Gs)`
  min-width: auto;
  padding: 0 4px;
  min-width: 22px;
  height: 22px;
  margin: 0 2px;
  font-weight: 400;
  &.active {
    background-color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette) == null ? void 0 : t.info.main) + 15;
}};
  }
`, Ch = yo(Fg)`
  margin-left: 10;
`, $V = ({
  pageCount: e,
  pageOptions: t,
  canPreviousPage: n,
  canNextPage: r,
  gotoPage: i,
  previousPage: s,
  nextPage: a,
  setPageSize: l,
  pageIndex: c,
  pageSize: u,
  className: f,
  totalElements: g,
  numberOfElements: h,
  disablePageSize: y
}) => {
  const { t: v } = ec(), m = () => {
    const C = [];
    let E = [];
    if (e > 5)
      E = [1, 2, 3, "...", e], c > 1 && c + 2 < e ? E = [
        1,
        "...",
        c,
        c + 1,
        c + 2,
        "...",
        e
      ] : c >= e - 3 && c + 1 <= e && (E = [1, "...", e - 2, e - 1, e]);
    else
      for (let S = 0; S < e; S++)
        E[S] = S + 1;
    return E.forEach(
      (S, k) => C.push(
        typeof S == "string" ? /* @__PURE__ */ p.jsx("div", { className: "dots", children: S }, k + "-pagination-dots") : /* @__PURE__ */ p.jsx(
          o0,
          {
            onClick: () => i(S - 1),
            disabled: e < S,
            size: "small",
            fullWidth: !1,
            variant: "text",
            className: `pagination-button ${S === c + 1 ? "active" : ""}`,
            children: S
          },
          k + "-pagination-btn"
        )
      )
    ), C;
  }, b = No(() => v("tables.base.showing", {
    minRow: c * u + 1,
    maxRow: c * u + h,
    totalRow: g
  }), [c, h, g, v]);
  return /* @__PURE__ */ p.jsxs(VV, { className: xe(f, "table-pagination"), children: [
    /* @__PURE__ */ p.jsx(
      o0,
      {
        size: "small",
        variant: "text",
        fullWidth: !1,
        onClick: () => s(),
        disabled: !n,
        children: "<"
      }
    ),
    m(),
    /* @__PURE__ */ p.jsx(
      o0,
      {
        size: "small",
        variant: "text",
        fullWidth: !1,
        onClick: () => a(),
        disabled: !r,
        children: ">"
      }
    ),
    /* @__PURE__ */ p.jsx("span", { children: v("tables.base.pagination", {
      currentPage: c + 1,
      totalPage: t.length
    }) }),
    /* @__PURE__ */ p.jsx(ko, { component: "span", sx: { marginRight: 10, marginLeft: 5 }, children: h > 0 && b }),
    !y && /* @__PURE__ */ p.jsx(
      Ch,
      {
        size: "small",
        value: u,
        onChange: (C) => {
          l && l(C);
        },
        options: [10, 15, 20, 25, 50, 75, 100].map((C) => ({
          name: v("tables.base.show") + " " + C,
          value: C
        })),
        name: "pageSize",
        fullWidth: !1
      }
    )
  ] });
}, LV = Z("table")`
  border-collapse: collapse;
  font-family: ${({ theme: e }) => {
  var t;
  return ((t = e.typography) == null ? void 0 : t.fontFamily) || "sans-serif";
}};
  font-size: ${({ theme: e }) => {
  var t;
  return (t = e.typography) == null ? void 0 : t.fontSize;
}}px;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[500];
}};
  width: 100%;
`, S5 = Z("tr", {
  shouldForwardProp: (e) => e !== "tileView" && e !== "error"
})`
  border-bottom: 1px solid
    ${({ theme: e }) => Kr(0.05, e.palette.borderColor.light)};
  td {
    color: ${({ theme: e, error: t }) => t ? e.palette.error.main : e.palette.textColor.secondary};
    font-weight: 400;
    font-size: 14px;
    z-index: 1;
    position: relative;
    /* height: 44px; */
  }
  ${({ theme: e, disabled: t }) => t && ` 
    filter: grayscale(100%) brightness(1) opacity(0.6);
    pointer-events: none;
    background-color: ${Jn(0.85, e.palette.info.main)};

  `}
  position: relative;
  :hover,
  &.hover {
    background-color: ${({ theme: e }) => Jn(0.9, e.palette.info.main)};
    transition: all 300ms;
  }
  ${({ tileView: e, theme: t }) => e && `border: none;
    :hover {
      td { 
        background-color: ${Jn(0.9, t.palette.info.main)};
      }
    }
    td {
        border-top: 4px solid white;
        border-bottom: 4px solid white;
        background: #f1f3f7;
    
        z-index: 0;
        &:last-of-type {
          border-top-right-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        &:first-of-type {
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
        }
    }
  }`}
`, AV = Z("tr")`
  background-color: inherit;
  border-bottom: 1px solid ${({ theme: e }) => e.palette.borderColor.main};
  /* border-bottom: 1px solid ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.borderColor.main;
}}; */
  & th {
    font-weight: 800;
    white-space: nowrap;
    color: ${({ theme: e }) => e.palette.textColor.label};
    font-size: 12px;
    padding: 12px;
    text-align: left;
    &:first-of-type {
      padding-left: 16px;
    }
    &:last-of-type {
      padding-right: 16px;
    }
  }
`, NV = Z("div")`
  display: inline-block;
  text-align: center;
  width: 14px;
`, E5 = Z("div")`
  min-height: ${({ isLoading: e }) => e ? "108px" : ""};
  overflow-x: auto;
`, BV = Z("div")`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme: e, ...t }) => t.paginationPosition === "top" ? "0 0 10px 0" : t.paginationPosition === "bottom" ? "10px 0 0 0" : "10px "};
`, _V = Z("div")`
  position: relative;
  margin: ${({ theme: e, ...t }) => t.paginationPosition === "both" ? "-10px 0" : ""};
`, zV = Z("div")`
  position: absolute;
  width: 100%;
  height: calc(100% - 30px);
  text-align: center;
  padding-bottom: 30px;
  z-index: 2;
  font-family: ${({ theme: e }) => {
  var t;
  return ((t = e == null ? void 0 : e.typography) == null ? void 0 : t.fontFamily) || "sans-serif";
}};
  font-size: ${({ theme: e }) => {
  var t;
  return ((t = e == null ? void 0 : e.typography) == null ? void 0 : t.fontSize) || 14;
}}px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  top: 0;
  background: ${Jn(0.5, "#ffffff")};
`, xh = Z("div")`
  font-family: ${({ theme: e }) => {
  var t;
  return ((t = e.typography) == null ? void 0 : t.fontFamily) || "sans-serif";
}};
  font-size: ${({ theme: e }) => {
  var t;
  return (t = e.typography) == null ? void 0 : t.fontSize;
}}px;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[900];
}};
  text-align: center;
`, HV = yo.td`
  padding: 8px 12px;
  /* text-align: left; */
  font-weight: 400;
  font-size: 0.875rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
  box-sizing: border-box;
  cursor: ${({ cursor: e }) => e || "left"};
  text-align: ${({ textAlign: e }) => e || "left"};
  ${({ maxWidth: e, isCropped: t }) => t && e ? `max-width: ${e}px;` : "max-width: auto;"};
  ${({ minWidth: e }) => e ? `min-width: ${e}px;` : ""}
  &:first-of-type {
    padding-left: 16px;
  }
  &:last-of-type {
    padding-right: 16px;
  }
`, WV = ({
  cell: e,
  cursor: t,
  className: n,
  textAlign: r
}) => {
  const i = e.column.maxWidth, s = e.column.minWidth, a = e.column.width, l = e.column.isCropped, c = typeof e.column.showTooltip == "boolean" ? e.column.showTooltip : !0, [u, f] = So(!1), g = ns(
    (h) => {
      f(h === null ? !1 : (h == null ? void 0 : h.offsetWidth) < (h == null ? void 0 : h.scrollWidth));
    },
    [e]
  );
  return /* @__PURE__ */ p.jsx(
    wc,
    {
      text: c && u ? e.render("Cell") : "",
      arrow: !0,
      color: "primary",
      placement: "bottom-end",
      sx: { span: { color: "#ffffff" } },
      children: /* @__PURE__ */ p.jsx(
        HV,
        {
          minWidth: s,
          maxWidth: i,
          width: a,
          ref: g,
          isCropped: l,
          cursor: t,
          textAlign: r,
          className: n || "",
          children: e.render("Cell")
        }
      )
    }
  );
}, GV = () => {
  const [e, t] = So([0, 0]);
  return Y5(() => {
    const n = () => {
      t([window.innerWidth, window.innerHeight]);
    };
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}, UV = ({
  getTableProps: e,
  getTableBodyProps: t,
  headerGroups: n,
  prepareRow: r,
  page: i,
  onRowClick: s,
  disableRowClick: a,
  columnsCnt: l,
  noDataText: c,
  enableSorting: u,
  tileView: f = !1,
  getRowError: g,
  disableRowSelect: h
}) => {
  const [y] = GV(), v = He.useCallback((m, b) => `table-cell-${m == null ? void 0 : m.column.id}-${b}`, []);
  return /* @__PURE__ */ p.jsxs(LV, { ...e(), className: "table", tileView: f, children: [
    !f && /* @__PURE__ */ p.jsx("thead", { className: "table-head", children: n.map((m, b) => /* @__PURE__ */ Cr(
      AV,
      {
        ...m.getHeaderGroupProps(),
        key: "table-header-" + b,
        className: "table-row"
      },
      m.headers.map((C, E) => {
        var k;
        const S = C.rowSpan > 1 && ((k = C.columns) != null && k[0]) ? C.columns[0] : C;
        return /* @__PURE__ */ Cr(
          ko,
          {
            component: "th",
            ...S.getHeaderProps(S.getSortByToggleProps()),
            key: "table-header-cell-" + E,
            className: "table-header-cell-" + E,
            rowSpan: C.rowSpan,
            sx: {
              textAlign: S.align || "left",
              cursor: C.disableSortBy || !u ? "default" : "pointer",
              ...C.invisible ? { display: "none" } : {}
            }
          },
          C.render("Header"),
          S.canSort && /* @__PURE__ */ p.jsx(NV, { children: YV(S) })
        );
      })
    )) }),
    /* @__PURE__ */ p.jsx("tbody", { ...t(), className: "table-body", children: i.length ? /* @__PURE__ */ p.jsx(p.Fragment, { children: i.map((m, b) => (r(m), /* @__PURE__ */ Cr(
      S5,
      {
        ...m.getRowProps(),
        key: "table-row-" + b,
        onClick: (C) => {
          C.preventDefault(), a != null && a(m) || s == null || s(m);
        },
        className: "table-row-" + b,
        tileView: f,
        error: !!(g != null && g(m.original)),
        disabled: !!(h != null && h(m))
      },
      m.cells.map((C, E) => /* @__PURE__ */ Cr(
        WV,
        {
          ...C.getCellProps(),
          key: "table-row-cell-" + E,
          className: v(C, b),
          cell: C,
          width: y,
          textAlign: C == null ? void 0 : C.column.align,
          cursor: !s || a != null && a(m) ? "default" : "pointer"
        }
      ))
    ))) }) : /* @__PURE__ */ p.jsx(S5, { className: "table-no-data-text", children: /* @__PURE__ */ p.jsx(ko, { component: "td", colSpan: l, sx: { padding: "8px" }, children: /* @__PURE__ */ p.jsx(xh, { children: c }) }) }) })
  ] });
}, YV = (e) => e.isSorted ? e.isSortedDesc ? /* @__PURE__ */ p.jsx(
  qn,
  {
    iconName: "chevronSorting",
    sx: { fontSize: "0.5rem", color: "#CDCDCD" }
  }
) : /* @__PURE__ */ p.jsx(
  qn,
  {
    iconName: "chevronSorting",
    sx: {
      fontSize: "0.5rem",
      color: "#CDCDCD",
      transform: "rotate(180deg)"
    }
  }
) : "", wh = ({ isLoading: e = !1, loadingMessage: t = "" }) => /* @__PURE__ */ p.jsx(p.Fragment, { children: e && /* @__PURE__ */ p.jsx(
  zV,
  {
    className: "table-loader",
    onClick: (n) => {
      n.stopPropagation();
    },
    children: /* @__PURE__ */ p.jsxs("div", { children: [
      /* @__PURE__ */ p.jsx(Vd, { size: 50, color: "secondary", thickness: 6 }),
      t && /* @__PURE__ */ p.jsx("div", { className: "table-loader-message", children: t })
    ] })
  }
) }), ZV = (e, t) => {
  switch (e) {
    case "icon":
      return 18;
    case "type-icon":
      return 28;
    case "double-text":
      return "80%";
    default:
      return t ? "100%" : "72%";
  }
}, qV = (e) => {
  switch (e) {
    case "center":
      return "center";
    case "right":
      return "flex-end";
    default:
      return "flex-start";
  }
}, Sh = ({
  rows: e,
  columns: t,
  columnWidths: n = [],
  columnKinds: r = [],
  columnAlignments: i = [],
  headerCells: s = [],
  showHeader: a = !0,
  className: l,
  fullWidthText: c
}) => {
  const u = Math.max(t, 1), f = Math.max(e, 1), g = Array.from(
    { length: u },
    (v, m) => m
  ), h = Array.from({ length: f }, (v, m) => m), y = n.every((v) => typeof v == "number") ? n.reduce((v, m) => v + m, 0) : "100%";
  return /* @__PURE__ */ p.jsxs(
    "table",
    {
      className: xe("divTable", l),
      style: { width: "100%", minWidth: y, tableLayout: "fixed" },
      children: [
        a && /* @__PURE__ */ p.jsx("thead", { className: "thead", children: /* @__PURE__ */ p.jsx("tr", { className: "tr table-header-row-0", children: g.map((v) => {
          const m = n[v];
          return /* @__PURE__ */ p.jsx(
            "th",
            {
              className: xe("th", `table-header-cell-${v}`),
              style: {
                width: m,
                minWidth: m,
                maxWidth: m,
                textAlign: i[v] || "left"
              },
              children: s[v] ?? ""
            },
            `header-${v}`
          );
        }) }) }),
        /* @__PURE__ */ p.jsx("tbody", { className: "tbody", children: h.map((v) => /* @__PURE__ */ p.jsx(
          "tr",
          {
            className: xe("tr", `table-row-${v}`),
            children: g.map((m) => {
              const b = r[m] || "text", C = i[m] || "left", E = n[m];
              return /* @__PURE__ */ p.jsx(
                "td",
                {
                  className: xe("td", `table-cell-${m}`),
                  style: {
                    width: E,
                    minWidth: E,
                    maxWidth: E,
                    textAlign: C
                  },
                  children: /* @__PURE__ */ p.jsxs(
                    "div",
                    {
                      className: "cell-wrapper",
                      style: {
                        display: "flex",
                        flexDirection: b === "double-text" ? "column" : "row",
                        gap: b === "double-text" ? 6 : void 0,
                        justifyContent: qV(C),
                        alignItems: b === "double-text" ? "flex-start" : "center",
                        width: "100%"
                      },
                      children: [
                        /* @__PURE__ */ p.jsx(
                          Ca,
                          {
                            variant: "rounded",
                            width: ZV(b, c),
                            height: b === "icon" ? 18 : 24
                          }
                        ),
                        b === "double-text" && /* @__PURE__ */ p.jsx(Ca, { variant: "rounded", width: "56%", height: 18 })
                      ]
                    }
                  )
                },
                `cell-${v}-${m}`
              );
            })
          },
          `row-${v}`
        )) })
      ]
    }
  );
}, KV = (e) => e && typeof e == "object" ? Array.isArray(e) ? e : Object.entries(e).reduce((t, [n, r]) => (r === !1 && t.push(n), t), []) : [], N_ = (e) => {
  var Xt;
  const {
    enableSorting: t = !1,
    enablePagination: n = !1,
    disablePageSize: r = !1,
    paginationPosition: i = "bottom",
    manualPagination: s = !1,
    manualSortBy: a = !1,
    pageCount: l,
    pageSize: c,
    pageNumber: u,
    isLoading: f = !1,
    loadingMessage: g = "",
    fetchData: h,
    onEdit: y,
    showColumnToggle: v = !1,
    enableRowSelect: m = !1,
    rowIdSelector: b,
    onRowSelect: C,
    onRowClick: E,
    disableRowClick: S,
    getRowError: k,
    setPageSize: T,
    setPageNumber: P,
    setSort: F,
    setCurrentPage: j,
    setVisibleColumns: L,
    noDataText: R = "No data currently available",
    className: V,
    totalElements: B,
    numberOfElements: W,
    initialSort: z,
    selectedRowIds: G,
    immutableColumns: H,
    tileComponent: ie,
    isInitial: ce,
    hiddenColumns: re,
    tileView: A,
    disableRowSelect: Y,
    customTable: pe,
    skeletonRows: Ce,
    skeletonShowHeader: fe = !0,
    skeletonVariant: ee = "default",
    skeletonColumnWidths: te,
    skeletonColumnKinds: ue,
    skeletonColumnAlignments: K,
    skeletonHeaderCells: oe
  } = e, de = (Ae, St) => St.type === "deselectAllRows" ? { ...Ae, selectedRowIds: {} } : Ae, ve = He.useMemo(() => {
    const Ae = G ? Object.keys(G) : void 0;
    return Ae != null && Ae.length ? Ae.map((St) => ({ [St]: !0 })) : void 0;
  }, [G]), J = He.useMemo(() => z, [z]), se = {
    stateReducer: de,
    columns: e.columns,
    data: e.data,
    disableSortBy: !t,
    onEdit: y,
    initialState: {
      pageIndex: u || 0,
      pageSize: c || 10,
      ...J && { sortBy: [J] },
      ...ve && { selectedRowIds: ve },
      hiddenColumns: KV(re)
    },
    manualPagination: s,
    manualSortBy: a,
    getRowId: (Ae, St, yn) => b ? Ae[b] != null ? Ae[b] : Ae.id || St : yn ? [yn.id, St].join(".") : St,
    autoResetSelectedRows: !1,
    ...l && { pageCount: l },
    autoResetPage: !1
  }, ge = (Ae) => {
    Ae.visibleColumns.push((St) => [
      // selection column
      {
        id: "selection",
        Header: ({ getToggleAllPageRowsSelectedProps: yn }) => /* @__PURE__ */ p.jsx(
          ii,
          {
            stopPropagation: !0,
            size: "small",
            ...yn()
          }
        ),
        width: "2%",
        Cell: ({ row: yn }) => {
          let In = yn.getToggleRowSelectedProps();
          return /* @__PURE__ */ p.jsx(
            ii,
            {
              stopPropagation: !0,
              size: "small",
              ...In,
              checked: Y && In.checked ? !Y(yn) : In.checked
            }
          );
        }
      },
      ...St
    ]);
  }, Se = [
    ul.useSortBy,
    ul.useExpanded,
    ul.usePagination,
    ...m ? [ul.useRowSelect, ge] : []
  ], {
    dispatch: we,
    getTableProps: me,
    getTableBodyProps: ye,
    headerGroups: Ie,
    prepareRow: je,
    page: Te,
    rows: Fe,
    canPreviousPage: gt,
    canNextPage: Dt,
    pageOptions: ke,
    pageCount: Ne,
    gotoPage: We,
    setPageSize: Ge,
    allColumns: Qe,
    visibleColumns: Ve,
    getToggleHideAllColumnsProps: Ke,
    state: { pageIndex: bt, pageSize: vt, sortBy: tn, selectedRowIds: hn },
    selectedFlatRows: Je,
    setSortBy: $t
  } = ul.useTable(se, ...Se);
  Rn(() => {
    ve || we({ type: "deselectAllRows" });
  }, [ve]), Rn(() => {
    if (Te.length > 0) {
      const Ae = Ve.map((St) => St.id);
      L == null || L(
        Qe.filter((St) => !Ae.includes(St.id))
      );
    }
  }, [Ve]), Rn(() => {
    !a && J && !b0([J], [tn]) && $t([J]);
  }, [J]), Rn(() => {
    Te && (j == null || j(Te == null ? void 0 : Te.map((Ae) => Ae.original)));
  }, [bt, vt, j, e.data]), Rn(() => {
    const [Ae] = tn;
    F == null || F(Ae), h == null || h(bt, vt, Ae);
  }, [h, bt, vt, ...a ? [tn] : []]), Rn(() => {
    c && Ge(c);
  }, [c]), Rn(() => {
    const Ae = Je == null ? void 0 : Je.filter((St) => !(Y != null && Y(St))).map((St) => St.original);
    C == null || C(Ae, hn);
  }, [C, hn]);
  const nn = ns((Ae) => {
    We(Ae), P == null || P(Ae);
  }, []), Nt = ns((Ae) => {
    Ge(Ae), T == null || T(Ae);
  }, []);
  Rn(() => {
    var Ae;
    B > 0 && ((Ae = e.data) == null ? void 0 : Ae.length) === 0 && bt > 0 && We(0);
  }, [bt, vt, e.data]);
  const cn = () => {
    const Ae = pe || UV, St = /* @__PURE__ */ p.jsx(E5, { isLoading: f, children: ie ? /* @__PURE__ */ p.jsx(
      FV,
      {
        prepareRow: je,
        page: Te,
        onRowClick: E,
        tileComponent: ie
      }
    ) : /* @__PURE__ */ p.jsx(
      Ae,
      {
        getTableProps: me,
        getTableBodyProps: ye,
        headerGroups: Ie,
        prepareRow: je,
        page: Te,
        onRowClick: E,
        disableRowClick: S,
        columnsCnt: Ve.length,
        noDataText: R,
        enableSorting: t,
        tileView: A,
        getRowError: k,
        disableRowSelect: Y
      }
    ) }, "table-template"), yn = (Oo) => /* @__PURE__ */ p.jsxs(BV, { className: "table-actions", children: [
      /* @__PURE__ */ p.jsx("div", { children: !ie && /* @__PURE__ */ p.jsx(
        jV,
        {
          allColumns: Qe,
          immutableColumns: H,
          showColumnToggle: v,
          getToggleHideAllColumnsProps: Ke
        }
      ) }),
      /* @__PURE__ */ p.jsx(
        $V,
        {
          canPreviousPage: gt,
          canNextPage: Dt,
          pageOptions: ke,
          pageCount: Ne,
          gotoPage: nn,
          nextPage: () => Dt && nn(bt + 1),
          previousPage: () => gt && nn(bt - 1),
          setPageSize: Nt,
          pageIndex: bt,
          pageSize: vt,
          totalElements: B,
          numberOfElements: Te == null ? void 0 : Te.length,
          disablePageSize: r
        }
      )
    ] }, "table-actions" + Oo), In = [St];
    return n && (In.unshift(yn(1)), In.push(yn(2)), i === "top" && In.pop(), i === "bottom" && In.shift()), In;
  }, Lt = f && !ie && !A && (Te == null ? void 0 : Te.length) === 0, jt = He.useMemo(
    () => Ve.map((Ae) => (Ae == null ? void 0 : Ae.width) ?? (Ae == null ? void 0 : Ae.totalWidth) ?? (Ae == null ? void 0 : Ae.minWidth)),
    [Ve]
  ), un = He.useMemo(
    () => Ve.map((Ae) => {
      const St = String((Ae == null ? void 0 : Ae.id) || "").toLowerCase(), yn = (Ae == null ? void 0 : Ae.width) ?? (Ae == null ? void 0 : Ae.totalWidth) ?? (Ae == null ? void 0 : Ae.minWidth), In = St === "actions" || St.includes("action") || St.includes("delete"), Oo = St === "icon" || St === "type" || St === "typeicon" || St === "select" || St === "selection" || St.includes("icon"), Do = typeof yn == "number" && yn <= 48;
      return In || Oo || Do ? "icon" : "text";
    }),
    [Ve]
  ), On = He.useMemo(
    () => Ve.map((Ae, St) => {
      const yn = Ae == null ? void 0 : Ae.align;
      if (yn === "left" || yn === "center" || yn === "right")
        return yn;
      const In = String((Ae == null ? void 0 : Ae.id) || "").toLowerCase();
      return In === "actions" || In.includes("action") || In.includes("delete") ? "right" : (un[St] === "icon", "left");
    }),
    [Ve, un]
  ), Un = He.useMemo(
    () => te && te.length ? te : jt,
    [te, jt]
  ), ro = He.useMemo(
    () => ue && ue.length ? ue : un,
    [ue, un]
  ), Ft = He.useMemo(
    () => K && K.length ? K : On,
    [K, On]
  ), Yn = He.useMemo(
    () => Ve.map((Ae) => typeof (Ae == null ? void 0 : Ae.render) == "function" ? Ae.render("Header") : (Ae == null ? void 0 : Ae.Header) ?? ""),
    [Ve]
  ), it = He.useMemo(
    () => oe && oe.length ? oe : Yn,
    [oe, Yn]
  ), ft = (Un == null ? void 0 : Un.length) || Ve.length || ((Xt = e.columns) == null ? void 0 : Xt.length) || 5;
  return /* @__PURE__ */ p.jsxs(
    _V,
    {
      className: "c-table " + (V || ""),
      paginationPosition: i,
      children: [
        /* @__PURE__ */ p.jsx(
          wh,
          {
            isLoading: f && !Lt,
            loadingMessage: g
          }
        ),
        Lt ? /* @__PURE__ */ p.jsx(E5, { isLoading: f, children: /* @__PURE__ */ p.jsx(
          Sh,
          {
            rows: Ce ?? vt,
            columns: ft,
            columnWidths: Un,
            columnKinds: ro,
            columnAlignments: Ft,
            headerCells: it,
            variant: ee,
            showHeader: fe
          }
        ) }) : (ce || (Te == null ? void 0 : Te.length) === 0) && !f ? /* @__PURE__ */ p.jsx(mh, { noDataText: R }) : cn()
      ]
    }
  );
}, B_ = (e) => {
  var m;
  const {
    value: t,
    row: n,
    column: r,
    onEdit: i,
    disabled: s,
    indeterminate: a = !1,
    cell: l,
    align: c,
    sx: u,
    ...f
  } = e, g = typeof t == "boolean" ? t : !!((m = f.getValue) != null && m.call(f)), [h, y] = He.useState(g), v = (b) => {
    y(b.target.checked), i && i({
      rowIndex: n.index,
      row: n.original || (l == null ? void 0 : l.row.original),
      columnId: r.id,
      value: b.target.checked
    });
  };
  return He.useEffect(() => {
    y(g);
  }, [g, n == null ? void 0 : n.id]), /* @__PURE__ */ p.jsx(
    ko,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: c === "right" ? "flex-end" : c === "left" ? "flex-start" : "center",
        width: "100%",
        maxWidth: `calc(100% - ${r.canSort ? "14px" : ""})`,
        ...u
      },
      onClick: (b) => b == null ? void 0 : b.stopPropagation(),
      children: /* @__PURE__ */ p.jsx(
        ii,
        {
          checked: h,
          onChange: v,
          stopPropagation: !0,
          disableRipple: !0,
          size: "small",
          disabled: s,
          indeterminate: a
        }
      )
    }
  );
}, __ = (e) => {
  const {
    value: t = !1,
    row: n,
    column: r,
    onEdit: i,
    disabled: s,
    indeterminate: a = !1,
    ...l
  } = e, [c, u] = He.useState(t), f = (g) => {
    u(g.target.value), i && i({
      rowIndex: n.index,
      row: n.original,
      columnId: r.id,
      value: g.target.value
    });
  };
  return He.useEffect(() => {
    u(t);
  }, [t, n.id]), /* @__PURE__ */ p.jsx(
    ko,
    {
      sx: {
        textAlign: "center",
        maxWidth: `calc(100% - ${r.canSort ? "14px" : ""})`
      },
      children: /* @__PURE__ */ p.jsx(
        of,
        {
          value: c,
          onChange: f,
          size: "small",
          disabled: s
        }
      )
    }
  );
}, XV = yo.div`
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  margin-top: -10px;
`, z_ = yo.div`
  display: flex;
  flex-direction: column;
  width: calc(50% - 52px);
  min-width: 260px;
  margin: 10px 10px 0;
  padding: 15px 20px;
  border: 1px solid ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.borderColor.main;
}};
  background-color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.backgroundColor.dark;
}};
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[800];
}};
  font-family: ${({ theme: e }) => {
  var t;
  return (t = e.typography) == null ? void 0 : t.fontFamily;
}};
  font-size: 14px;
  :hover {
    cursor: pointer;
    border: 1px solid ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
    background-color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.backgroundColor.main;
}};
  }
  :nth-child(2n + 1) {
    margin-left: 0;
  }
  :nth-child(2n) {
    margin-right: 0;
  }
  @media (max-width: 1200px) {
    width: 100%;
    margin: 10px 0;
  }
`, H_ = yo.div`
  display: flex;
  justify-content: ${({ justify: e }) => e || "flex-start"};
  align-items: ${({ alignItems: e }) => e || "center"};
  :not(:last-of-type) {
    margin-bottom: 8px;
  }
  :last-of-type {
    height: 100%;
  }
`, W_ = yo.div`
  font-size: 16px;
  display: flex;
  font-weight: 700;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
`, G_ = yo.div`
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[500];
}};
  font-size: 13px;
  > span {
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[800];
}};
  }
  :not(:last-of-type) {
    margin-bottom: 6px;
  }
`, U_ = yo.span`
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  font-size: 14px;
  font-weight: 400;
  margin-right: 5px;
  :hover {
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.dark;
}};
    background: ${({ theme: e }) => {
  var t;
  return Jn(0.9, ((t = e.palette) == null ? void 0 : t.primary.main) || "#000000");
}};
    box-shadow: 0px 0px 0px 3px
      ${({ theme: e }) => {
  var t;
  return Jn(0.9, ((t = e.palette) == null ? void 0 : t.primary.main) || "#000000");
}};
    border-radius: 4px;
  }
`, Y_ = yo.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  align-self: flex-end;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 12px;
  }
`, Z_ = yo.div`
  display: flex;
  align-items: center;
  align-self: flex-end;
  .c-icon {
    margin-right: 5px;
  }
`, q_ = ({
  prepareRow: e,
  page: t,
  onRowClick: n,
  noDataText: r,
  tileComponent: i
}) => {
  const s = i;
  return t.length ? /* @__PURE__ */ p.jsx(XV, { className: "tiles-container", children: t.map((a, l) => (e(a), /* @__PURE__ */ p.jsx(
    s,
    {
      item: a.original,
      onClick: () => n && n(a)
    },
    "tile" + a.id
  ))) }) : /* @__PURE__ */ p.jsx(xh, { children: r });
}, QV = yo("div", {
  shouldForwardProp: (e) => e !== "action" && e !== "light" && e !== "minWidth"
})`
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  height: 24px;
  min-width: 64px;
  justify-content: ${({ align: e }) => e === "center" ? "space-around" : "flex-start"};
  border-radius: 2px;
  background-color: ${({ color: e, theme: t, light: n }) => {
  var r, i, s;
  if (typeof e == "string") {
    const a = ((i = (r = t.palette) == null ? void 0 : r[e]) == null ? void 0 : i.main) || e || ((s = t.palette) == null ? void 0 : s.grey[700]);
    return n ? Vu(0.92, a) : a;
  } else
    return e.backgroundColor;
}};
  color: ${({ color: e, theme: t, light: n }) => {
  var r, i, s;
  if (typeof e == "string") {
    const a = ((i = (r = t.palette) == null ? void 0 : r[e]) == null ? void 0 : i.main) || e || ((s = t.palette) == null ? void 0 : s.grey[700]);
    return n ? a : "#ffffff !important";
  } else
    return e.color;
}};
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
  min-width: ${({ minWidth: e }) => e || 76}px;
  cursor: ${({ action: e }) => e ? "pointer" : "default"};
  &:hover {
    background-color: ${({ color: e, theme: t, action: n, light: r }) => {
  var s, a, l;
  const i = typeof e == "string" ? ((a = (s = t.palette) == null ? void 0 : s[e]) == null ? void 0 : a.main) || e || ((l = t.palette) == null ? void 0 : l.grey[700]) : e.color;
  return r ? Vu(n ? 0.8 : 0.9, i) : i;
}};
  }
`, JV = yo("div", {
  shouldForwardProp: (e) => e !== "minWidth"
})`
  color: ${({ theme: e }) => e.palette.grey[800]};
  font-size: 12px;
  font-weight: 700;
  min-width: ${({ minWidth: e }) => e}px;
`, e$ = Z("div")`
  width: ${({ size: e }) => e || 24}px;
  height: ${({ size: e }) => e || 24}px;
  display: flex;
  opacity: 0.8;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0;
  justify-content: center;
  color: ${({ color: e, theme: t }) => {
  var n;
  return e || ((n = t.palette) == null ? void 0 : n.primary.main) || "grey";
}};
  .icon {
    display: inline-block;
    stroke-width: 0;
    stroke: currentColor;
    fill: currentColor;
  }
`, K_ = (e) => {
  const t = e.iconName ? r$[e.iconName] : () => /* @__PURE__ */ p.jsx(p.Fragment, {});
  return /* @__PURE__ */ p.jsx(
    e$,
    {
      ...e,
      className: xe(e.className, "c-icon"),
      color: e.color,
      size: e.size,
      ref: e.ref,
      children: /* @__PURE__ */ p.jsx(
        t,
        {
          size: e.size || 24,
          name: e.name,
          fillColor: e.fillColor,
          color: e.color
        }
      )
    }
  );
}, t$ = ({ name: e, size: t }) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    className: "icon",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    width: t,
    height: t,
    children: [
      /* @__PURE__ */ p.jsx("title", { children: e || "Warning" }),
      /* @__PURE__ */ p.jsxs("g", { children: [
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: "none",
            clipRule: "evenodd",
            strokeMiterlimit: 10,
            strokeWidth: 1.8,
            d: `M28.7,27.4l-23.4,0c-1.5,0-2.1-1.1-1.4-2.4L15.6,4.8c0.8-1.3,2-1.3,2.7,0l11.7,20.3
		C30.8,26.4,30.2,27.4,28.7,27.4z`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: "currentColor",
            clipRule: "evenodd",
            d: `M18.2,18.5V13c0-0.6-0.5-1.1-1.1-1.1h-0.2c-0.6,0-1.1,0.5-1.1,1.1v5.4c0,0.6,0.5,1.1,1.1,1.1h0.2
		C17.7,19.5,18.2,19.1,18.2,18.5z`
          }
        ),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: "currentColor",
            clipRule: "evenodd",
            d: "M18.4,23c0-0.7-0.6-1.4-1.4-1.4c-0.7,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4C17.7,24.4,18.4,23.8,18.4,23z"
          }
        )
      ] })
    ]
  }
), n$ = ({ name: e, size: t }) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    className: "icon",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    width: t,
    height: t,
    children: [
      /* @__PURE__ */ p.jsx("title", { children: e || "Info" }),
      /* @__PURE__ */ p.jsxs("g", { children: [
        /* @__PURE__ */ p.jsx("g", { children: /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: "none",
            stroke: "currentColor",
            strokeWidth: 1.8,
            strokeMiterlimit: 10,
            d: `M29.4,16.2c0,6.5-5.3,11.8-11.8,11.8c-1.5,0-3-0.3-4.3-0.8c-1.1-0.4-4.3,1.8-5.2,1.1c-0.7-0.6,0.9-4,0.3-4.7
			c-1.6-2-2.5-4.5-2.5-7.3c0-6.5,5.3-11.8,11.8-11.8S29.4,9.7,29.4,16.2z`
          }
        ) }),
        /* @__PURE__ */ p.jsx("g", { children: /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: "currentColor",
            d: `M19.5,13.6l-2,6.8c-0.1,0.4-0.2,0.6-0.2,0.8c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1
			c0.1,0,0.2,0,0.3-0.1c0.3-0.2,0.6-0.7,1-1.3l0.3,0.2c-1,1.7-2,2.5-3.1,2.5c-0.4,0-0.7-0.1-1-0.3c-0.2-0.2-0.4-0.5-0.4-0.9
			c0-0.2,0.1-0.5,0.2-0.9l1.3-4.6c0.1-0.4,0.2-0.8,0.2-1c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.1,0-0.2,0-0.3,0
			l0.1-0.4l3.2-0.5H19.5z M18.9,9.2c0.4,0,0.7,0.1,1,0.4c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.6,0.4-1,0.4
			c-0.4,0-0.7-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.1-0.7,0.4-1C18.2,9.4,18.5,9.2,18.9,9.2z`
          }
        ) })
      ] })
    ]
  }
), o$ = ({ name: e, size: t }) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    className: "icon",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    width: t,
    height: t,
    children: [
      /* @__PURE__ */ p.jsx("title", { children: e || "Critical" }),
      /* @__PURE__ */ p.jsxs("g", { children: [
        /* @__PURE__ */ p.jsxs("g", { children: [
          /* @__PURE__ */ p.jsx(
            "line",
            {
              fill: "none",
              strokeWidth: 1.8,
              stroke: "currentColor",
              x1: "12",
              y1: "10.5",
              x2: "22",
              y2: "20.5"
            }
          ),
          /* @__PURE__ */ p.jsx(
            "line",
            {
              fill: "none",
              strokeWidth: 1.8,
              stroke: "currentColor",
              x1: "22",
              y1: "10.5",
              x2: "12",
              y2: "20.5"
            }
          )
        ] }),
        /* @__PURE__ */ p.jsx(
          "path",
          {
            fill: "none",
            clipRule: "evenodd",
            strokeMiterlimit: 10,
            strokeWidth: 1.8,
            stroke: "currentColor",
            d: `M24.6,26.4h-3.4L17,30.7l-3.7-4.2H9.4c-2.1,0-3.9-1.7-3.9-3.9V8.3c0-2.1,1.7-3.9,3.9-3.9h15.3
        c2.1,0,3.9,1.7,3.9,3.9v14.3C28.5,24.7,26.8,26.4,24.6,26.4z`
          }
        )
      ] })
    ]
  }
), r$ = {
  info: n$,
  warning: t$,
  critical: o$
}, i$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M24.9712 12.4795H20.6514V14.1777C20.6514 15.0683 19.8972 15.7937 18.9712 15.7937H9.02843C8.10278 15.7937 7.34861 15.0683 7.34861 14.1777V12.4795H3.02848C2.82279 12.4795 2.65137 12.6441 2.65137 12.8586V24.0877C2.65137 24.2857 2.82279 24.467 3.02848 24.467H24.9712C25.1772 24.467 25.3486 24.3021 25.3486 24.0877V12.8422C25.3486 12.6441 25.1772 12.4795 24.9712 12.4795ZM17.9256 21.9442H10.2284V18.4651H17.9256V21.9442Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M18.5262 17.6235H9.47461V21.614C9.47461 22.1582 9.93759 22.6033 10.5031 22.6033H17.4974C18.0632 22.6033 18.5262 22.1582 18.5262 21.614V17.6235Z", fill: "#C6E2FD" }), /* @__PURE__ */ d.createElement("path", { d: "M17.2404 18.8603V21.3667H10.7604V18.8603H17.2404ZM18.5262 17.6235H9.47461V21.614C9.47461 22.1582 9.93759 22.6033 10.5031 22.6033H17.4974C18.0632 22.6033 18.5262 22.1582 18.5262 21.614V17.6235Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M25.9486 12.5121L21.3886 2.37117C21.2513 2.0579 20.8743 1.90951 20.5486 2.0579C20.2229 2.20646 20.0686 2.55263 20.2229 2.8659L24.2684 11.8525H20V14.1774C20 14.7216 19.5371 15.1669 18.9712 15.1669H9.02845C8.46269 15.1669 8.00002 14.7216 8.00002 14.1774V11.8525H3.74847L7.79433 2.8659C7.93137 2.55263 7.79433 2.18989 7.45141 2.0579C7.10849 1.92608 6.7486 2.07447 6.61137 2.37117L2.05142 12.5121C2.01697 12.5945 2 12.6936 2 12.7925V24.0874C2 24.6317 2.46267 25.0769 3.0285 25.0769H24.9712C25.5371 25.0769 26 24.6317 26 24.0874V12.7759C26 12.6936 25.9828 12.5945 25.9486 12.5121ZM24.7142 23.8402H3.28555V13.0892H6.71422V14.1611C6.71422 15.3976 7.75988 16.3871 9.02852 16.3871H18.9712C20.2399 16.3871 21.2855 15.3813 21.2855 14.1611V13.0892H24.7142V23.8402Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M18.8685 3.24512H9.1828C8.61728 3.24512 8.1543 3.69045 8.1543 4.2344V5.32284H9.4401V4.48188H18.6115V5.32284H19.8973V4.2344C19.8973 3.69045 19.4343 3.24512 18.8685 3.24512Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M20.1965 6.14697H7.87079C7.30527 6.14697 6.84229 6.5923 6.84229 7.13625V8.12578H8.12815V7.38374H19.9222V8.12578H21.208V7.13625C21.2253 6.5923 20.7623 6.14697 20.1965 6.14697Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M22.5193 11.0284V9.95657C22.5193 9.41232 22.0563 8.96729 21.4908 8.96729H6.55926C5.9935 8.96729 5.53076 9.41232 5.53076 9.95657V11.0284H6.81631V10.2041H21.2335V11.0284H22.5193V11.0284Z", fill: "#17294C" })), s$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M23.7909 10.2441H22.252C22.1734 10.2441 22.1106 10.197 22.0949 10.1342C22.0007 9.85153 21.8751 9.56888 21.7495 9.30193C21.7181 9.23911 21.7338 9.1606 21.7809 9.09779L22.8644 8.01428C23.3355 7.54318 23.3355 6.78944 22.8644 6.31834L20.6817 4.13562C20.2106 3.66453 19.4568 3.66453 18.9857 4.13562L17.9022 5.21913C17.8551 5.26624 17.7766 5.28194 17.6981 5.25054C17.4311 5.12491 17.1485 5.01499 16.8658 4.90507C16.803 4.88936 16.7559 4.81085 16.7559 4.74804V3.20914C16.7559 2.54961 16.222 2 15.5468 2H12.4532C11.7937 2 11.2441 2.5339 11.2441 3.20914V4.74804C11.2441 4.82655 11.197 4.88936 11.1342 4.90507C10.8515 4.99929 10.5689 5.12491 10.3019 5.25054C10.2391 5.28194 10.1606 5.26624 10.0978 5.21913L9.01428 4.13562C8.54318 3.66453 7.78944 3.66453 7.31834 4.13562L5.13562 6.31834C4.66453 6.78944 4.66453 7.54318 5.13562 8.01428L6.21913 9.09779C6.26624 9.1449 6.28194 9.22341 6.25054 9.30193C6.12491 9.56888 6.01499 9.85153 5.90507 10.1342C5.88936 10.197 5.81085 10.2441 5.74804 10.2441H4.20914C3.54961 10.2441 3 10.778 3 11.4532V14.5468C3 15.2063 3.5339 15.7559 4.20914 15.7559H5.74804C5.82655 15.7559 5.88936 15.803 5.90507 15.8658C5.99929 16.1485 6.12491 16.4311 6.25054 16.6981C6.28194 16.7609 6.26624 16.8394 6.21913 16.9022L5.13562 17.9857C4.66453 18.4568 4.66453 19.2106 5.13562 19.6817L7.31834 21.8644C7.78944 22.3355 8.54318 22.3355 9.01428 21.8644L10.0978 20.7809C10.1449 20.7338 10.2234 20.7181 10.3019 20.7495C10.5689 20.8751 10.8515 21.0007 11.1342 21.0949C11.197 21.1106 11.2441 21.1892 11.2441 21.252V22.7909C11.2441 23.4504 11.778 24 12.4532 24H15.5468C16.2063 24 16.7559 23.4661 16.7559 22.7909V21.252C16.7559 21.1734 16.803 21.1106 16.8658 21.0949C17.1485 21.0007 17.4311 20.8751 17.6981 20.7495C17.7609 20.7181 17.8394 20.7338 17.9022 20.7809L18.9857 21.8644C19.4568 22.3355 20.2106 22.3355 20.6817 21.8644L22.8644 19.6817C23.3355 19.2106 23.3355 18.4568 22.8644 17.9857L21.7809 16.9022C21.7338 16.8551 21.7181 16.7766 21.7495 16.6981C21.8751 16.4311 22.0007 16.1485 22.0949 15.8658C22.1106 15.803 22.1891 15.7559 22.252 15.7559H23.7909C24.4504 15.7559 25 15.222 25 14.5468V11.4532C25 10.778 24.4661 10.2441 23.7909 10.2441Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M23.79 10.2441H22.25C22.1714 10.2441 22.1086 10.197 22.0929 10.1342C21.9986 9.85153 21.8729 9.56888 21.7471 9.30193C21.7157 9.23911 21.7314 9.1606 21.7786 9.09779L22.8629 8.01428C23.3343 7.54318 23.3343 6.78944 22.8629 6.31834L20.6786 4.13562C20.4429 3.90007 20.1443 3.79015 19.83 3.79015C19.5157 3.79015 19.2171 3.91577 18.9814 4.13562L17.8971 5.21913C17.8657 5.25054 17.8186 5.26624 17.7714 5.26624C17.74 5.26624 17.7243 5.26624 17.6929 5.25054C17.4257 5.12491 17.1429 5.01499 16.86 4.90507C16.7971 4.88936 16.75 4.81085 16.75 4.74804V3.20914C16.75 2.54961 16.2157 2 15.54 2H12.46C11.8 2 11.25 2.5339 11.25 3.20914V4.74804C11.25 4.82655 11.2029 4.88936 11.14 4.90507C10.8571 4.99929 10.5743 5.12491 10.3071 5.25054C10.2757 5.26624 10.26 5.26624 10.2286 5.26624C10.1814 5.26624 10.1343 5.25054 10.1029 5.21913L9.01857 4.13562C8.78286 3.90007 8.46857 3.79015 8.17 3.79015C7.87143 3.79015 7.55714 3.91577 7.32143 4.13562L5.13714 6.31834C4.66571 6.78944 4.66571 7.54318 5.13714 8.01428L6.22143 9.09779C6.26857 9.1449 6.28429 9.22341 6.25286 9.30193C6.12714 9.56888 6.01714 9.85153 5.90714 10.1342C5.89143 10.197 5.81286 10.2441 5.75 10.2441H4.21C3.55 10.2441 3 10.778 3 11.4532V14.5468C3 15.2063 3.53429 15.7559 4.21 15.7559H5.75C5.82857 15.7559 5.89143 15.803 5.90714 15.8658C6.00143 16.1485 6.12714 16.4311 6.25286 16.6981C6.28429 16.7609 6.26857 16.8394 6.22143 16.9022L5.13714 17.9857C4.66571 18.4568 4.66571 19.2106 5.13714 19.6817L7.32143 21.8644C7.55714 22.0999 7.87143 22.2098 8.17 22.2098C8.46857 22.2098 8.78286 22.0842 9.01857 21.8644L10.1029 20.7809C10.1343 20.7495 10.1814 20.7338 10.2286 20.7338C10.26 20.7338 10.2757 20.7338 10.3071 20.7495C10.5743 20.8751 10.8571 21.0007 11.14 21.0949C11.2029 21.1106 11.25 21.1892 11.25 21.252V22.7909C11.25 23.4504 11.7843 24 12.46 24H15.5557C16.2 24 16.7343 23.4818 16.75 22.838C16.75 22.8223 16.75 22.8066 16.75 22.7752V21.2363C16.7657 21.1734 16.7971 21.1106 16.86 21.0949C17.1429 21.0007 17.4257 20.8751 17.6929 20.7495C17.7243 20.7338 17.74 20.7338 17.7714 20.7338C17.8186 20.7338 17.8657 20.7495 17.8971 20.7809L18.9814 21.8644C19.2171 22.0999 19.5157 22.2098 19.83 22.2098C20.1443 22.2098 20.4429 22.0842 20.6786 21.8644L22.8629 19.6817C23.3343 19.2106 23.3343 18.4568 22.8629 17.9857L21.7786 16.9022C21.7314 16.8551 21.7157 16.7766 21.7471 16.6981C21.8729 16.4311 21.9986 16.1485 22.0929 15.8658C22.1086 15.803 22.1871 15.7559 22.25 15.7559H23.79C24.45 15.7559 25 15.222 25 14.5468V11.4532C25 10.7937 24.4657 10.2441 23.79 10.2441ZM17.7714 19.5403C17.5671 19.5403 17.3629 19.5874 17.19 19.6817C17.0486 19.7445 16.9071 19.8073 16.75 19.8701V17.9543C16.75 17.7188 16.5614 17.5303 16.3257 17.5303H15.9957C15.76 17.5303 15.5714 17.7188 15.5714 17.9543V22.7752L15.54 22.8066H12.46L12.4286 22.7752V21.2363C12.4286 21.1891 12.4286 21.142 12.4129 21.0949C12.4129 21.0792 12.4129 21.0478 12.4129 21.0321V17.9543C12.4129 17.7188 12.2243 17.5303 11.9886 17.5303H11.6586C11.4229 17.5303 11.2343 17.7188 11.2343 17.9543V19.8701C11.0929 19.8073 10.9514 19.7445 10.81 19.6817C10.6214 19.5874 10.4171 19.5403 10.2129 19.5403C9.96143 19.5403 9.71 19.6188 9.49 19.7445V16.4468C9.49 16.1485 9.74143 15.8972 10.04 15.8972H17.9286C18.2271 15.8972 18.4786 16.1485 18.4786 16.4468V19.7602C18.2743 19.6188 18.0386 19.556 17.7714 19.5403ZM11.5171 11.7045C11.5171 10.3069 12.6486 9.1763 14.0471 9.1763C15.4457 9.1763 16.5614 10.3226 16.5614 11.7045C16.5614 13.0864 15.43 14.2327 14.0314 14.2327C12.6329 14.2327 11.5171 13.1021 11.5171 11.7045ZM23.8214 14.531L23.79 14.5625H22.25C21.6843 14.5625 21.1657 14.9236 20.9771 15.4732C20.8986 15.7088 20.7886 15.96 20.6786 16.1799C20.4271 16.6981 20.5371 17.3105 20.93 17.7188L20.9457 17.7345L22.03 18.818L22.0457 18.8337L22.03 18.8494L19.8457 21.0321L19.83 21.0478L19.8143 21.0321L19.6729 20.8908V16.4468C19.6729 15.4889 18.9029 14.7195 17.9443 14.7195H16.2157C17.1429 14.0443 17.7557 12.9607 17.7557 11.7202C17.7557 9.6788 16.09 8.01428 14.0471 8.01428C12.0043 8.01428 10.3386 9.6631 10.3386 11.7045C10.3386 12.9293 10.9357 14.0286 11.8786 14.7038H10.0714C9.11286 14.7038 8.34286 15.4732 8.34286 16.4311V20.8751L8.20143 21.0164L8.18571 21.0321L8.17 21.0164L5.98571 18.8337V18.818V18.8023L7.07 17.7188C7.46286 17.3105 7.57286 16.6981 7.32143 16.1799C7.21143 15.9443 7.11714 15.7088 7.02286 15.4732C6.83429 14.9393 6.33143 14.5625 5.76571 14.5625H4.22571L4.19429 14.531V11.4532L4.22571 11.4218H5.76571C6.33143 11.4218 6.85 11.0607 7.02286 10.5111C7.10143 10.2755 7.21143 10.04 7.32143 9.80443C7.57286 9.28622 7.47857 8.6738 7.07 8.26552L5.97 7.18201V7.15061L8.15429 4.96788H8.17H8.18571L9.27 6.05139C9.52143 6.30264 9.86714 6.44397 10.2129 6.44397C10.4171 6.44397 10.6214 6.39686 10.81 6.30264C11.0457 6.19272 11.2814 6.0985 11.5171 6.00428C12.0514 5.81585 12.4286 5.31335 12.4286 4.74804V3.20914L12.46 3.17773H15.5557L15.5871 3.20914V4.74804C15.5871 5.31335 15.9486 5.83155 16.4986 6.01999C16.7343 6.0985 16.9857 6.20842 17.2057 6.31834C17.3943 6.41256 17.5986 6.45967 17.8029 6.45967C18.1643 6.45967 18.4943 6.31834 18.7457 6.06709H18.7614L19.8457 4.98358H19.8614H19.8771L22.0614 7.16631V7.18201L20.9771 8.26552C20.5686 8.6738 20.4743 9.28622 20.7257 9.80443C20.8357 10.04 20.93 10.2755 21.0243 10.5111C21.2129 11.045 21.7157 11.4218 22.2971 11.4218H23.8371L23.8686 11.4532L23.8214 14.531Z", fill: "#17294C" })), a$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M23.2995 12.1232C23.2995 10.7663 22.6925 9.55221 21.7462 8.73093V2.69629H4.24937C3.39238 2.69629 2.67822 3.39259 2.67822 4.26744V22.6034C2.67822 23.4783 3.37453 24.1746 4.24937 24.1746H21.7284V15.5154C22.6925 14.6941 23.2995 13.4801 23.2995 12.1232Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M5.48146 6.24905H9.9628C10.3556 6.24905 10.6591 5.94554 10.6591 5.55275C10.6591 5.15996 10.3377 4.85645 9.9628 4.85645H5.48146C5.10653 4.85645 4.78516 5.15996 4.78516 5.55275C4.78516 5.94554 5.10653 6.24905 5.48146 6.24905Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M5.48146 8.8555H9.9628C10.3556 8.8555 10.6591 8.55198 10.6591 8.1592C10.6591 7.76641 10.3556 7.46289 9.9628 7.46289H5.48146C5.10653 7.46289 4.78516 7.76641 4.78516 8.1592C4.78516 8.55198 5.10653 8.8555 5.48146 8.8555Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M5.48146 11.4805H9.9628C10.3556 11.4805 10.6591 11.177 10.6591 10.7842C10.6591 10.3914 10.3556 10.0879 9.9628 10.0879H5.48146C5.10653 10.0879 4.78516 10.3914 4.78516 10.7842C4.78516 11.1591 5.10653 11.4805 5.48146 11.4805Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M25.8072 18.0875L22.6535 14.925C23.2876 14.0312 23.6647 12.9312 23.6647 11.7453C23.6647 10.2328 23.0477 8.85781 22.0707 7.87812C21.9336 7.74062 21.7793 7.60313 21.6251 7.48281V2.67031C21.6251 2.49844 21.5565 2.32656 21.4365 2.18906C21.3166 2.06875 21.1452 2 20.9566 2H4.15961C3.55972 2 3.01125 2.24063 2.63417 2.63594C2.23996 3.03125 2 3.58125 2 4.16563V21.8172C2 22.4187 2.23996 22.9688 2.63417 23.3641C3.02839 23.7594 3.57686 24 4.17675 24H20.9566C21.128 24 21.2994 23.9312 21.4365 23.8109C21.5736 23.6906 21.6251 23.5188 21.6251 23.3297V16.0078C21.6593 15.9734 21.7108 15.9391 21.745 15.9047L24.8645 19.0328C25.1216 19.2906 25.5501 19.2906 25.8072 19.0328C26.0643 18.775 26.0643 18.3453 25.8072 18.0875ZM18.7799 3.34062H20.2882V6.69219C19.8082 6.48594 19.3112 6.36562 18.7799 6.31406C18.7799 6.29687 18.7799 3.34062 18.7799 3.34062ZM3.3369 4.16563C3.3369 3.925 3.4226 3.73594 3.57686 3.58125C3.73112 3.42656 3.9368 3.34062 4.15961 3.34062H17.443V6.33125C16.2432 6.50313 15.1634 7.05312 14.3578 7.87812C13.3637 8.875 12.7638 10.2328 12.7638 11.7453C12.7638 13.2578 13.3808 14.6328 14.3578 15.6125C15.1805 16.4375 16.2432 16.9875 17.443 17.1594V19.5312H4.22817C3.90252 19.5312 3.61114 19.6 3.3369 19.7203V4.16563ZM20.2882 22.6594H4.22817C3.97108 22.6594 3.74826 22.5562 3.594 22.4016C3.4226 22.2297 3.3369 22.0234 3.3369 21.7656C3.3369 21.5078 3.43974 21.2844 3.594 21.1297C3.7654 20.9578 3.97108 20.8719 4.22817 20.8719H18.1114C18.2828 20.8719 18.4542 20.8031 18.5913 20.6828C18.7284 20.5625 18.7799 20.3906 18.7799 20.2016V17.1938C19.3112 17.1422 19.8254 17.0047 20.2882 16.8156V22.6594ZM22.3278 11.7453C22.3278 11.8484 22.3278 11.9344 22.3107 12.0203C22.3107 12.0547 22.3107 12.0719 22.3107 12.0891C22.3107 12.175 22.2935 12.2609 22.2764 12.3641V12.3813C22.2592 12.4672 22.2421 12.5703 22.225 12.6562C22.225 12.6734 22.2078 12.6906 22.2078 12.7078C21.7793 14.5469 20.1339 15.9219 18.1628 15.9219C15.8661 15.9219 13.9979 14.0484 13.9979 11.7453C13.9979 9.44219 15.8661 7.56875 18.1628 7.56875C20.4596 7.56875 22.1393 9.25312 22.3107 11.4016C22.3107 11.4187 22.3107 11.4359 22.3107 11.4531C22.3278 11.5391 22.3278 11.6422 22.3278 11.7453Z", fill: "#17294C" })), l$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M4.96484 5.22303V16.67C4.96484 17.2794 5.45896 17.7735 6.06837 17.7735H24.3177C24.8283 17.7735 25.2236 17.3618 25.2236 16.8677V6.5242C25.2236 6.06303 24.8447 5.66773 24.3836 5.66773H14.8966C14.7318 5.66773 14.5836 5.60185 14.4848 5.48656L12.8213 3.83951C12.7224 3.74069 12.5742 3.6748 12.426 3.6748L6.48013 3.70775C5.64013 3.70775 4.96484 4.38304 4.96484 5.22303Z", fill: "#E3F1FF" }), /* @__PURE__ */ d.createElement("path", { d: "M25.4373 5.4541C25.1573 5.1741 24.7785 5.0094 24.3667 5.0094H14.9291L13.2821 3.36235C13.0515 3.13176 12.7386 3 12.4256 3L6.47977 3.03294C5.27742 3.03294 4.30566 4.0047 4.30566 5.20705V16.654C4.30566 17.6258 5.09625 18.4164 6.06801 18.4164H24.3173C25.1903 18.4164 25.882 17.7081 25.882 16.8517V6.52468C25.882 6.12939 25.7173 5.75057 25.4373 5.4541ZM24.5479 16.8682C24.5479 16.934 24.515 16.9999 24.482 17.0493C24.4326 17.0987 24.3667 17.1152 24.3008 17.1152H6.05154C5.93624 17.1152 5.82095 17.0658 5.7386 16.9834C5.65624 16.9011 5.60683 16.7858 5.60683 16.6705V5.22352C5.60683 4.74587 5.98565 4.36705 6.4633 4.36705L12.3762 4.33411L14.0068 5.96469C14.2374 6.19528 14.5668 6.32704 14.8962 6.32704H24.3667C24.4161 6.32704 24.4655 6.34351 24.4985 6.37645C24.5314 6.40939 24.5479 6.4588 24.5479 6.50821V16.8682Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M2.64258 10.7904V22.2374C2.64258 22.8468 3.13669 23.3409 3.7461 23.3409H21.9954C22.506 23.3409 22.9013 22.9292 22.9013 22.4351V12.0916C22.9013 11.6304 22.5225 11.2516 22.0613 11.2351H12.5908C12.4425 11.2351 12.2943 11.1692 12.179 11.0539L10.499 9.40689C10.4002 9.30807 10.2519 9.24219 10.1037 9.24219L4.15786 9.2916C3.33434 9.2916 2.65905 9.96689 2.64258 10.7904Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M23.1152 11.0376C22.8352 10.7576 22.4564 10.5929 22.0611 10.5929H12.6235L10.9764 8.94585C10.7458 8.71526 10.4329 8.5835 10.12 8.5835L4.15763 8.61644C2.97176 8.61644 2 9.5882 2 10.7741V22.2375C2 23.2093 2.79058 23.9999 3.76234 23.9999H22.0117C22.8846 23.9999 23.5763 23.2916 23.5763 22.4352V12.0917C23.5599 11.6964 23.4116 11.3176 23.1152 11.0376ZM22.2422 22.4352C22.2422 22.5011 22.2093 22.5669 22.1764 22.6164C22.1269 22.6658 22.0611 22.6987 21.9952 22.6822H3.74587C3.63058 22.6822 3.51529 22.6328 3.43293 22.5505C3.35058 22.4681 3.30117 22.3528 3.30117 22.2375V10.7905C3.30117 10.3294 3.67999 9.95055 4.15763 9.95055L10.0705 9.91761L11.7011 11.5482C11.9317 11.7788 12.2611 11.9105 12.5905 11.9105H22.0611C22.1599 11.9105 22.2422 11.9929 22.2422 12.0917V22.4352Z", fill: "#17294C" })), c$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 28 27", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M9.969,14.413c-0.797,0 -1.576,-0.241 -2.239,-0.692c-0.663,-0.452 -1.179,-1.094 -1.485,-1.845c-0.305,-0.75 -0.384,-1.577 -0.229,-2.374c0.156,-0.797 0.539,-1.529 1.103,-2.104c0.564,-0.574 1.282,-0.966 2.064,-1.124c0.782,-0.159 1.592,-0.077 2.329,0.234c0.736,0.311 1.366,0.837 1.809,1.513c0.443,0.676 0.679,1.47 0.679,2.283c-0.001,1.089 -0.426,2.134 -1.182,2.904c-0.756,0.771 -1.78,1.204 -2.849,1.205Zm0,-6.392c-0.443,0 -0.876,0.134 -1.244,0.385c-0.368,0.251 -0.655,0.607 -0.825,1.024c-0.169,0.417 -0.213,0.877 -0.127,1.319c0.086,0.443 0.3,0.85 0.613,1.169c0.313,0.319 0.712,0.537 1.146,0.625c0.435,0.088 0.885,0.043 1.294,-0.13c0.409,-0.173 0.759,-0.465 1.005,-0.841c0.246,-0.375 0.378,-0.817 0.378,-1.268c-0,-0.605 -0.236,-1.186 -0.656,-1.614c-0.42,-0.428 -0.99,-0.669 -1.584,-0.669Zm6.718,12.784c-0.001,-1.21 -0.474,-2.371 -1.313,-3.227c-0.84,-0.856 -1.978,-1.337 -3.165,-1.339l-4.479,0c-1.187,0.002 -2.326,0.483 -3.165,1.339c-0.84,0.856 -1.312,2.017 -1.313,3.227l-0,3.653l1.791,-0l-0,-3.653c-0,-0.726 0.283,-1.423 0.787,-1.937c0.504,-0.514 1.187,-0.802 1.9,-0.802l4.479,-0c0.712,-0 1.396,0.288 1.9,0.802c0.504,0.514 0.787,1.211 0.787,1.937l-0,3.653l1.791,-0l0,-3.653Zm2.239,-10.044c-0.797,-0 -1.576,-0.241 -2.239,-0.693c-0.663,-0.451 -1.179,-1.093 -1.485,-1.844c-0.305,-0.751 -0.384,-1.577 -0.229,-2.374c0.156,-0.797 0.54,-1.53 1.103,-2.104c0.564,-0.575 1.282,-0.966 2.064,-1.125c0.782,-0.158 1.592,-0.077 2.329,0.234c0.736,0.311 1.366,0.838 1.809,1.513c0.443,0.676 0.679,1.471 0.679,2.283c-0.001,1.09 -0.426,2.134 -1.182,2.905c-0.755,0.77 -1.78,1.203 -2.849,1.205Zm0,-6.392c-0.443,-0 -0.875,0.133 -1.244,0.384c-0.368,0.251 -0.655,0.608 -0.824,1.025c-0.17,0.417 -0.214,0.876 -0.128,1.319c0.086,0.443 0.3,0.849 0.613,1.169c0.313,0.319 0.712,0.536 1.146,0.624c0.435,0.088 0.885,0.043 1.294,-0.13c0.409,-0.172 0.759,-0.465 1.005,-0.84c0.246,-0.376 0.378,-0.817 0.378,-1.269c-0,-0.605 -0.236,-1.186 -0.656,-1.614c-0.42,-0.428 -0.99,-0.668 -1.584,-0.668Zm5.822,12.784c-0.001,-1.211 -0.473,-2.371 -1.313,-3.227c-0.839,-0.856 -1.978,-1.338 -3.165,-1.339l-3.583,-0l0,1.826l3.583,0c0.713,0 1.396,0.289 1.9,0.802c0.504,0.514 0.787,1.211 0.787,1.938l0,3.652l1.791,0l0,-3.652Z", fillRule: "nonzero" })), u$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 12.3077, cy: 11.3077, r: 8.46149, fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M12.2931 2C7.16885 2 3 6.16885 3 11.2931C3 16.4173 7.16885 20.5861 12.2931 20.5861C17.4173 20.5861 21.5861 16.4173 21.5861 11.2931C21.5861 6.16885 17.4172 2 12.2931 2ZM12.2931 18.9605C8.06513 18.9605 4.62563 15.521 4.62563 11.2931C4.62563 7.06513 8.06513 3.62563 12.2931 3.62563C16.5207 3.62563 19.9605 7.06513 19.9605 11.2931C19.9605 15.521 16.521 18.9605 12.2931 18.9605Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M24.7617 22.6123L18.8552 16.7059C18.5377 16.3884 18.0235 16.3884 17.7059 16.7059C17.3884 17.0232 17.3884 17.538 17.7059 17.8552L23.6123 23.7616C23.7711 23.9204 23.9789 23.9997 24.187 23.9997C24.3951 23.9997 24.6029 23.9204 24.7617 23.7616C25.0792 23.4443 25.0792 22.9296 24.7617 22.6123Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M16.9602 10.3976C17.3938 10.2816 17.6512 9.83577 17.5349 9.40223C17.1037 7.79302 15.972 6.47106 14.4298 5.77499C14.0456 5.60164 13.5982 5.75131 13.3919 6.10866C13.3783 6.13214 13.3658 6.15649 13.3546 6.18132C13.1699 6.5906 13.3522 7.07214 13.7612 7.25668C14.8572 7.7512 15.6604 8.68673 15.9649 9.82293C16.0809 10.2565 16.5267 10.514 16.9602 10.3976Z", fill: "#17294C" })), d$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M2.8002 2.4502H11.4802C11.6727 2.4502 11.8302 2.6077 11.8302 2.8002V15.1377C11.8302 15.3302 11.6727 15.4877 11.4802 15.4877H2.8002C2.6077 15.4877 2.4502 15.3302 2.4502 15.1377V2.8002C2.4502 2.6077 2.6077 2.4502 2.8002 2.4502Z", fill: "#E2F1FF" }), /* @__PURE__ */ d.createElement("path", { d: "M16.5199 12.4248H25.1999C25.3924 12.4248 25.5499 12.5823 25.5499 12.7748V25.1123C25.5499 25.3048 25.3924 25.4623 25.1999 25.4623H16.5199C16.3274 25.4623 16.1699 25.3048 16.1699 25.1123V12.7748C16.1699 12.5823 16.3274 12.4248 16.5199 12.4248Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M16.5199 2.4502H25.1999C25.3924 2.4502 25.5499 2.6077 25.5499 2.8002V7.9102C25.5499 8.1027 25.3924 8.2602 25.1999 8.2602H16.5199C16.3274 8.2602 16.1699 8.1027 16.1699 7.9102V2.8002C16.1699 2.6077 16.3274 2.4502 16.5199 2.4502Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M2.8002 19.7402H11.4802C11.6727 19.7402 11.8302 19.8977 11.8302 20.0902V25.2002C11.8302 25.3927 11.6727 25.5502 11.4802 25.5502H2.8002C2.6077 25.5502 2.4502 25.3927 2.4502 25.2002V20.0902C2.4502 19.8977 2.6077 19.7402 2.8002 19.7402Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M11.6884 2.3457H2.99092C2.41342 2.3457 1.94092 2.8182 1.94092 3.3957V15.7332C1.94092 16.3107 2.41342 16.7832 2.99092 16.7832H11.6884C12.2659 16.7832 12.7384 16.3107 12.7384 15.7332V3.3957C12.7384 2.8182 12.2659 2.3457 11.6884 2.3457ZM11.3384 15.3832H3.34092V3.7457H11.3384V15.3832Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M25.2002 12.2876H16.5202C15.9427 12.2876 15.4702 12.7601 15.4702 13.3376V25.6751C15.4702 26.2526 15.9427 26.7251 16.5202 26.7251H25.2002C25.7777 26.7251 26.2502 26.2526 26.2502 25.6751V13.3376C26.2502 12.7601 25.7777 12.2876 25.2002 12.2876ZM24.8502 25.3251H16.8702V13.6876H24.8502V25.3251Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M25.2002 2.3457H16.5202C15.9427 2.3457 15.4702 2.8182 15.4702 3.3957V8.5057C15.4702 9.0832 15.9427 9.5557 16.5202 9.5557H25.2002C25.7777 9.5557 26.2502 9.0832 26.2502 8.5057V3.3957C26.2502 2.8182 25.7777 2.3457 25.2002 2.3457ZM24.8502 8.1557H16.8702V3.7457H24.8502V8.1557Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M11.6709 19.5151H2.99092C2.41342 19.5151 1.94092 19.9876 1.94092 20.5651V25.6751C1.94092 26.2526 2.41342 26.7251 2.99092 26.7251H11.6709C12.2484 26.7251 12.7209 26.2526 12.7209 25.6751V20.5651C12.7209 19.9876 12.2484 19.5151 11.6709 19.5151ZM11.3209 25.3251H3.34092V20.9151H11.3209V25.3251Z", fill: "#17294C" })), p$ = {
  admin: s$,
  dataCatalog: l$,
  library: i$,
  study: a$,
  users: c$,
  vocabulary: u$,
  workspace: d$
}, X_ = ({
  iconName: e,
  iconStatus: t,
  ref: n,
  ...r
}) => {
  const i = p$[e] || (() => /* @__PURE__ */ p.jsx(p.Fragment, {}));
  return /* @__PURE__ */ p.jsx(or, { ...r, ref: n, inheritViewBox: !0, component: i });
}, f$ = (e) => /* @__PURE__ */ d.createElement("svg", { id: "extension", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 160 160", enableBackground: "new 0 0 160 160", xmlSpace: "preserve", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M80,22.3h0.2l15.8,32.8l2.3,4.8l5.3,0.8l36.1,5.3l-26.3,26.3l-3.6,3.6l0.8,5.1l6.1,36.6h0h-0.1l0,0l-31.6-17.1L80,118 l-4.7,2.5l-31.8,17l-0.1,0h0l6.1-36.6l0.8-5.1l-3.6-3.6L20.4,66l36.1-5.3l5.3-0.8l2.3-4.8l15.8-32.8L80,22.3 M80,12.4 c-2,0-3.8,0.5-5.5,1.5s-2.9,2.4-3.7,4.1L55,50.8l-36.4,5.3c-1.8,0.3-3.5,1-4.9,2.2c-1.5,1.2-2.5,2.7-3.1,4.5 c-1.3,3.7-0.5,7.1,2.5,10l26.6,26.6l-6.1,37c-0.4,1.8-0.2,3.6,0.6,5.3c0.8,1.7,1.9,3.1,3.5,4.2c0.3,0.2,0.6,0.4,0.9,0.6 c0.3,0.2,0.6,0.3,1,0.5s0.6,0.2,1,0.3s0.6,0.2,1,0.3c0.3,0.1,0.7,0.1,1,0.1h1.1c1.7,0,3.3-0.4,4.8-1.2L80,129.4l31.6,17.1 c0.8,0.4,1.6,0.8,2.5,0.9s1.6,0.3,2.4,0.3c2.2,0,4.1-0.6,5.9-1.8c1.5-1.1,2.7-2.5,3.5-4.2c0.8-1.7,1-3.5,0.6-5.3l-6.1-37l26.6-26.6 c2.9-2.9,3.7-6.2,2.5-10c-0.6-1.8-1.7-3.3-3.1-4.5s-3.1-1.9-4.9-2.2l-36.4-5.3L89.1,18c-0.2-0.5-0.4-0.9-0.7-1.2 c-0.3-0.4-0.6-0.7-0.9-1.1c-0.3-0.4-0.7-0.7-1-1c-0.4-0.3-0.8-0.6-1.2-0.8s-0.8-0.4-1.2-0.6c-0.4-0.2-0.8-0.3-1.3-0.5 c-0.5-0.1-0.9-0.2-1.4-0.3C80.9,12.4,80.4,12.4,80,12.4L80,12.4z" })), g$ = (e) => /* @__PURE__ */ d.createElement("svg", { id: "extension", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 160 160", enableBackground: "new 0 0 160 160", xmlSpace: "preserve", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M81.4,12.4c0.5,0.1,1,0.1,1.4,0.3c0.4,0.1,0.9,0.3,1.3,0.5c0.4,0.2,0.8,0.4,1.2,0.6c0.4,0.2,0.8,0.5,1.2,0.8 c0.4,0.3,0.7,0.7,1,1s0.6,0.7,0.9,1.1c0.3,0.4,0.5,0.8,0.7,1.2L105,50.8l36.4,5.3c1.8,0.3,3.4,1,4.9,2.2c1.4,1.2,2.5,2.7,3.1,4.5 c1.3,3.7,0.4,7.1-2.4,10l-26.6,26.6l6.1,37c0.4,1.8,0.2,3.6-0.6,5.3c-0.8,1.7-1.9,3.1-3.5,4.2c-1.7,1.2-3.7,1.8-5.9,1.8 c-0.8,0-1.6-0.1-2.4-0.3c-0.8-0.2-1.6-0.5-2.4-0.9L80,129.4l-31.8,17.1c-1.5,0.8-3,1.2-4.8,1.2h-1.1c-0.4,0-0.7-0.1-1-0.1 c-0.3-0.1-0.6-0.2-1-0.3c-0.3-0.1-0.6-0.2-1-0.3c-0.3-0.1-0.6-0.3-1-0.5c-0.3-0.2-0.6-0.4-0.9-0.6c-1.5-1.1-2.7-2.5-3.5-4.2 s-1-3.5-0.6-5.3l6.1-37L13.1,72.8c-2.9-2.9-3.7-6.2-2.4-10c0.6-1.8,1.7-3.3,3.1-4.5c1.4-1.2,3.1-1.9,4.9-2.2l36.4-5.3l15.8-32.9 c0.8-1.7,2.1-3.1,3.7-4.1c1.6-1,3.4-1.5,5.5-1.5C80.5,12.3,81,12.4,81.4,12.4L81.4,12.4z" })), m$ = {
  icon: f$,
  iconSelected: g$
}, Q_ = ({
  selected: e,
  ref: t,
  ...n
}) => {
  const r = m$[e ? "iconSelected" : "icon"];
  return /* @__PURE__ */ p.jsx(
    or,
    {
      ...n,
      ref: t,
      sx: {
        color: n.color || "info",
        fontSize: n.size
      },
      children: /* @__PURE__ */ p.jsx(r, { color: n.color })
    }
  );
}, h$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: 78, height: 77, viewBox: "0 0 78 77", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { opacity: 0.3, x: 6, y: 5, width: 72, height: 72, rx: 11, fill: "#386FF0", fillOpacity: 0.64 }), /* @__PURE__ */ d.createElement("rect", { width: 72, height: 72, rx: 11, fill: "#F2F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M57.086 34.4346H48.9834V37.746C48.9834 39.4827 47.5689 40.8974 45.8321 40.8974H27.183C25.4468 40.8974 24.0323 39.4827 24.0323 37.746V34.4346H15.9293C15.5435 34.4346 15.2219 34.7556 15.2219 35.1737V57.0705C15.2219 57.4568 15.5435 57.8101 15.9293 57.8101H57.086C57.4722 57.8101 57.7938 57.4886 57.7938 57.0705V35.1419C57.7938 34.7556 57.4722 34.4346 57.086 34.4346ZM43.8708 52.8908H29.4338V46.1064H43.8708V52.8908Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M44.9965 44.4663H28.019V52.2477C28.019 53.309 28.8874 54.1768 29.9481 54.1768H43.067C44.1281 54.1768 44.9965 53.309 44.9965 52.2477V44.4663Z", fill: "#C6E2FD" }), /* @__PURE__ */ d.createElement("path", { d: "M42.5848 46.878V51.7655H30.4307V46.878H42.5848ZM44.9965 44.4663H28.019V52.2477C28.019 53.309 28.8874 54.1768 29.9481 54.1768H43.067C44.1281 54.1768 44.9965 53.309 44.9965 52.2477V44.4663Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M58.9189 34.4987L50.3661 14.7238C50.1086 14.1129 49.4014 13.8236 48.7905 14.1129C48.1796 14.4026 47.8903 15.0776 48.1796 15.6885L55.7676 33.2123H47.7615V37.746C47.7615 38.8071 46.8932 39.6755 45.8319 39.6755H27.1829C26.1217 39.6755 25.2539 38.8071 25.2539 37.746V33.2123H17.2795L24.8681 15.6885C25.1251 15.0776 24.8681 14.3703 24.2249 14.1129C23.5817 13.8559 22.9067 14.1452 22.6493 14.7238L14.0964 34.4987C14.0318 34.6592 14 34.8525 14 35.0454V57.0704C14 58.1317 14.8678 59 15.9291 59H57.0858C58.1471 59 59.0154 58.1317 59.0154 57.0704V35.0131C59.0154 34.8525 58.9831 34.6592 58.9189 34.4987ZM56.6037 56.5883H16.4112V35.624H22.8422V37.7141C22.8422 40.1254 24.8035 42.0549 27.183 42.0549H45.8319C48.2114 42.0549 50.1727 40.0935 50.1727 37.7141V35.624H56.6037V56.5883Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M45.6393 16.4282H27.4723C26.4116 16.4282 25.5432 17.2966 25.5432 18.3573V20.4798H27.9549V18.8399H45.1571V20.4798H47.5688V18.3573C47.5688 17.2966 46.7004 16.4282 45.6393 16.4282Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M48.1307 22.0869H25.0121C23.9514 22.0869 23.083 22.9553 23.083 24.016V25.9456H25.4948V24.4986H47.6163V25.9456H50.028V24.016C50.0603 22.9553 49.1919 22.0869 48.1307 22.0869Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M52.4881 31.6047V29.5145C52.4881 28.4533 51.6198 27.5854 50.559 27.5854H22.5529C21.4917 27.5854 20.6238 28.4533 20.6238 29.5145V31.6046H23.035V29.9971H50.0764V31.6046H52.4881V31.6047Z", fill: "#17294C" })), v$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 325 321", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2
}, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M325,66.667l0,208.333c0,25.296 -20.537,45.833 -45.833,45.833l-208.334,0c-25.296,0 -45.833,-20.537 -45.833,-45.833l-0,-208.333c-0,-25.296 20.537,-45.834 45.833,-45.834l208.334,0c25.296,0 45.833,20.538 45.833,45.834Z", style: {
  fill: "#f0f8fe",
  fillOpacity: 0.19
} }), /* @__PURE__ */ d.createElement("path", { d: "M325,66.667l0,208.333c0,25.296 -20.537,45.833 -45.833,45.833l-208.334,0c-25.296,0 -45.833,-20.537 -45.833,-45.833l-0,-208.333c-0,-25.296 20.537,-45.834 45.833,-45.834l208.334,0c25.296,0 45.833,20.538 45.833,45.834Z", style: {
  fill: "#386ff0",
  fillOpacity: 0.19
} }), /* @__PURE__ */ d.createElement("path", { d: "M300,45.833l0,208.334c0,25.296 -20.537,45.833 -45.833,45.833l-208.334,0c-25.295,0 -45.833,-20.537 -45.833,-45.833l0,-208.334c0,-25.295 20.538,-45.833 45.833,-45.833l208.334,0c25.296,0 45.833,20.538 45.833,45.833Z", style: {
  fill: "#f2f8fe"
} }), /* @__PURE__ */ d.createElement("g", { id: "Layer1" }, /* @__PURE__ */ d.createElement("path", { d: "M233.079,127.696l-13.071,-0c-0.666,-0 -1.2,-0.4 -1.333,-0.933c-0.8,-2.405 -1.867,-4.805 -2.933,-7.071c-0.267,-0.534 -0.134,-1.2 0.266,-1.734l9.205,-9.2c4,-4 4,-10.4 -0,-14.404l-18.538,-18.533c-2,-2 -4.533,-2.934 -7.2,-2.934c-2.667,0 -5.204,1.067 -7.204,2.934l-9.2,9.2c-0.267,0.266 -0.667,0.4 -1.067,0.4c-0.266,-0 -0.4,-0 -0.666,-0.134c-2.267,-1.066 -4.667,-2 -7.067,-2.933c-0.533,-0.133 -0.933,-0.8 -0.933,-1.333l-0,-13.067c-0,-5.604 -4.534,-10.271 -10.271,-10.271l-26.134,0c-5.604,0 -10.27,4.534 -10.27,10.271l-0,13.067c-0,0.666 -0.4,1.2 -0.934,1.333c-2.4,0.8 -4.8,1.867 -7.066,2.933c-0.267,0.134 -0.4,0.134 -0.667,0.134c-0.4,-0 -0.8,-0.134 -1.067,-0.4l-9.2,-9.2c-2,-2 -4.671,-2.934 -7.204,-2.934c-2.533,0 -5.2,1.067 -7.2,2.934l-18.537,18.533c-4,4.004 -4,10.404 -0,14.404l9.204,9.2c0.4,0.4 0.533,1.067 0.266,1.734c-1.066,2.266 -2,4.666 -2.933,7.07c-0.133,0.534 -0.8,0.934 -1.333,0.934l-13.071,-0c-5.6,-0 -10.267,4.533 -10.267,10.267l0,26.27c0,5.6 4.534,10.267 10.267,10.267l13.071,0c0.666,0 1.2,0.4 1.333,0.933c0.8,2.4 1.867,4.8 2.933,7.067c0.267,0.533 0.134,1.2 -0.266,1.733l-9.204,9.204c-4,4 -4,10.4 -0,14.4l18.537,18.538c2,2 4.667,2.933 7.2,2.933c2.533,0 5.204,-1.066 7.204,-2.933l9.2,-9.2c0.267,-0.267 0.667,-0.4 1.067,-0.4c0.267,-0 0.4,-0 0.667,0.133c2.266,1.067 4.666,2.134 7.066,2.934c0.534,0.133 0.934,0.8 0.934,1.333l-0,13.067c-0,5.6 4.533,10.266 10.27,10.266l26.267,0c5.471,0 10.004,-4.4 10.138,-9.866l-0,-13.6c0.133,-0.534 0.4,-1.067 0.933,-1.2c2.4,-0.8 4.8,-1.867 7.067,-2.934c0.266,-0.133 0.4,-0.133 0.666,-0.133c0.4,-0 0.8,0.133 1.067,0.4l9.2,9.2c2,2 4.537,2.933 7.204,2.933c2.667,0 5.2,-1.066 7.2,-2.933l18.538,-18.538c4,-4 4,-10.4 -0,-14.4l-9.205,-9.204c-0.4,-0.4 -0.533,-1.066 -0.266,-1.733c1.066,-2.267 2.133,-4.667 2.933,-7.067c0.133,-0.533 0.8,-0.933 1.333,-0.933l13.071,-0c5.6,-0 10.267,-4.533 10.267,-10.267l-0,-26.271c-0,-5.6 -4.534,-10.266 -10.267,-10.266Zm-51.075,78.941c-1.733,0 -3.467,0.4 -4.933,1.2c-1.2,0.534 -2.4,1.067 -3.734,1.6l0,-16.266c0,-2 -1.6,-3.6 -3.6,-3.6l-2.799,-0c-2.005,-0 -3.605,1.6 -3.605,3.6l0,40.937l-0.266,0.267l-26.134,0l-0.266,-0.267l-0,-13.066c-0,-0.4 -0,-0.8 -0.134,-1.2l0,-26.671c0,-2 -1.604,-3.6 -3.604,-3.6l-2.8,-0c-2,-0 -3.6,1.6 -3.6,3.6l0,16.266c-1.2,-0.533 -2.4,-1.066 -3.6,-1.6c-1.6,-0.8 -3.333,-1.2 -5.067,-1.2c-2.133,0 -4.266,0.667 -6.133,1.734l0,-28.004c0,-2.534 2.133,-4.667 4.667,-4.667l66.941,-0c2.534,-0 4.667,2.133 4.667,4.667l0,28.137c-1.733,-1.2 -3.733,-1.733 -6,-1.867Zm-53.075,-66.541c0,-11.867 9.604,-21.471 21.471,-21.471c11.867,-0 21.337,9.737 21.337,21.471c0,11.733 -9.604,21.471 -21.47,21.471c-11.867,-0 -21.338,-9.605 -21.338,-21.471Zm104.417,24.004l-0.267,0.267l-13.071,-0c-4.8,-0 -9.2,3.066 -10.8,7.733c-0.666,2 -1.6,4.133 -2.533,6c-2.133,4.4 -1.2,9.604 2.133,13.071l9.467,9.466l-18.8,18.805l-1.333,-1.334l-0,-37.741c-0,-8.134 -6.538,-14.667 -14.671,-14.667l-14.667,-0c7.867,-5.733 13.067,-14.938 13.067,-25.471c-0,-17.337 -14.134,-31.471 -31.471,-31.471c-17.338,0 -31.471,14 -31.471,31.338c0,10.4 5.067,19.737 13.067,25.471l-15.334,-0c-8.133,-0 -14.67,6.533 -14.67,14.666l-0,37.742l-1.334,1.333l-18.666,-18.671l-0,-0.266l9.2,-9.2c3.333,-3.467 4.266,-8.671 2.133,-13.071c-0.933,-2 -1.733,-4 -2.533,-6c-1.6,-4.533 -5.867,-7.733 -10.667,-7.733l-13.071,-0l-0.267,-0.267l0,-26.138l0.267,-0.266l13.071,-0c4.8,-0 9.2,-3.067 10.667,-7.734c0.666,-2 1.6,-4.004 2.533,-6.004c2.133,-4.4 1.333,-9.6 -2.133,-13.066l-9.334,-9.2l0,-0.267l18.534,-18.538l0.266,0l9.204,9.2c2.134,2.134 5.067,3.334 8,3.334c1.734,-0 3.467,-0.4 5.067,-1.2c2,-0.934 4,-1.734 6,-2.534c4.533,-1.6 7.738,-5.866 7.738,-10.666l-0,-13.067l0.266,-0.267l26.267,0l0.267,0.267l-0,13.067c-0,4.8 3.071,9.2 7.737,10.8c2,0.666 4.133,1.6 6,2.533c1.6,0.8 3.333,1.2 5.067,1.2c3.066,0 5.867,-1.2 8,-3.333l0.133,-0l9.204,-9.2l0.267,-0l18.533,18.537l0,0.134l-9.2,9.2c-3.466,3.466 -4.266,8.666 -2.133,13.066c0.933,2 1.733,4.004 2.533,6.004c1.6,4.534 5.867,7.734 10.8,7.734l13.071,-0l0.267,0.266l-0.4,26.138Z", style: {
  fill: "#21304f",
  fillRule: "nonzero"
} }), /* @__PURE__ */ d.createElement("path", { d: "M128.929,140.096c0,-11.867 9.604,-21.471 21.471,-21.471c11.867,0 21.338,9.738 21.338,21.471c-0,11.733 -9.605,21.471 -21.471,21.471c-11.867,-0 -21.338,-9.605 -21.338,-21.471Z", style: {
  fill: "#c6e2fd",
  fillOpacity: 0.6,
  fillRule: "nonzero"
} }), /* @__PURE__ */ d.createElement("path", { d: "M182.004,206.638c-1.733,-0 -3.466,0.4 -4.933,1.2c-1.2,0.533 -2.4,1.066 -3.733,1.6l-0,-16.267c-0,-2 -1.6,-3.6 -3.6,-3.6l-2.8,-0c-2.005,-0 -3.605,1.6 -3.605,3.6l0,40.937l-0.266,0.267l-26.134,0l-0.266,-0.267l-0,-13.066c-0,-0.4 -0,-0.8 -0.134,-1.2l0,-26.671c0,-2 -1.604,-3.6 -3.604,-3.6l-2.8,-0c-2,-0 -3.6,1.6 -3.6,3.6l0,16.267c-1.2,-0.534 -2.4,-1.067 -3.6,-1.601c-1.6,-0.799 -3.333,-1.2 -5.066,-1.2c-2.134,0 -4.267,0.667 -6.134,1.734l0,-28.004c0,-2.534 2.134,-4.667 4.667,-4.667l66.942,-0c2.533,-0 4.666,2.133 4.666,4.667l0,28.137c-1.733,-1.2 -3.733,-1.733 -6,-1.867Z", style: {
  fill: "#c6e2fd",
  fillOpacity: 0.6,
  fillRule: "nonzero"
} }))), y$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: 78, height: 77, viewBox: "0 0 78 77", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { opacity: 0.3, x: 6, y: 5, width: 72, height: 72, rx: 11, fill: "#386FF0", fillOpacity: 0.64 }), /* @__PURE__ */ d.createElement("rect", { width: 72, height: 72, rx: 11, fill: "#F2F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M18.7175 20.096V41.3804C18.7175 42.5135 19.6363 43.4323 20.7694 43.4323H54.7019C55.6513 43.4323 56.3863 42.6667 56.3863 41.7479V22.5154C56.3863 21.6579 55.6819 20.9229 54.8244 20.9229H37.1844C36.8782 20.9229 36.6025 20.8004 36.4188 20.586L33.3257 17.5235C33.1419 17.3398 32.8663 17.2173 32.5907 17.2173L21.535 17.2785C19.9732 17.2785 18.7175 18.5342 18.7175 20.096Z", fill: "#E3F1FF" }), /* @__PURE__ */ d.createElement("path", { d: "M56.7846 20.5246C56.2639 20.0039 55.5596 19.6977 54.7939 19.6977H37.2458L34.1833 16.6352C33.7545 16.2064 33.1727 15.9614 32.5908 15.9614L21.5352 16.0227C19.2996 16.0227 17.4927 17.8296 17.4927 20.0652V41.3495C17.4927 43.1564 18.9627 44.6264 20.7696 44.6264H54.7021C56.3252 44.6264 57.6114 43.3096 57.6114 41.7171V22.5152C57.6114 21.7802 57.3052 21.0758 56.7846 20.5246ZM55.1308 41.7477C55.1308 41.8702 55.0696 41.9927 55.0083 42.0845C54.9164 42.1764 54.7939 42.207 54.6714 42.207H20.7389C20.5246 42.207 20.3102 42.1152 20.1571 41.962C20.0039 41.8089 19.9121 41.5945 19.9121 41.3802V20.0958C19.9121 19.2077 20.6164 18.5033 21.5046 18.5033L32.4989 18.4421L35.5308 21.4739C35.9596 21.9027 36.5721 22.1477 37.1846 22.1477H54.7939C54.8858 22.1477 54.9777 22.1783 55.0389 22.2396C55.1002 22.3008 55.1308 22.3927 55.1308 22.4845V41.7477Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M14.3994 30.4471V51.7315C14.3994 52.8646 15.3182 53.7834 16.4513 53.7834H50.3838C51.3332 53.7834 52.0682 53.0177 52.0682 52.099V32.8665C52.0682 32.009 51.3638 31.3046 50.5063 31.274H32.8969C32.6213 31.274 32.3457 31.1515 32.1313 30.9371L29.0075 27.8746C28.8238 27.6909 28.5482 27.5684 28.2725 27.5684L17.2169 27.6602C15.6857 27.6602 14.43 28.9159 14.3994 30.4471Z", fill: "#E2F1FF" }), /* @__PURE__ */ d.createElement("path", { d: "M52.4663 30.9064C51.9457 30.3858 51.2413 30.0795 50.5063 30.0795H32.9582L29.8957 27.017C29.467 26.5883 28.8851 26.3433 28.3032 26.3433L17.217 26.4045C15.012 26.4045 13.2051 28.2114 13.2051 30.4164V51.7314C13.2051 53.5383 14.6751 55.0083 16.482 55.0083H50.4145C52.0376 55.0083 53.3238 53.6914 53.3238 52.0989V32.8664C53.2932 32.1314 53.0176 31.427 52.4663 30.9064ZM50.8432 52.0989C50.8432 52.2214 50.782 52.3439 50.7207 52.4358C50.6288 52.5276 50.5063 52.5889 50.3838 52.5583H16.4513C16.237 52.5583 16.0226 52.4664 15.8695 52.3133C15.7163 52.1601 15.6245 51.9458 15.6245 51.7314V30.447C15.6245 29.5895 16.3288 28.8851 17.217 28.8851L28.2113 28.8239L31.2432 31.8558C31.672 32.2845 32.2845 32.5295 32.897 32.5295H50.5063C50.6901 32.5295 50.8432 32.6826 50.8432 32.8664V52.0989Z", fill: "#17294C" })), b$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: 78, height: 77, viewBox: "0 0 78 77", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { opacity: 0.3, x: 6, y: 5, width: 72, height: 72, rx: 11, fill: "#386FF0", fillOpacity: 0.64 }), /* @__PURE__ */ d.createElement("rect", { width: 72, height: 72, rx: 11, fill: "#F2F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M54.0226 33.6273C54.0226 31.1573 52.9176 28.9473 51.1951 27.4523V16.4673H19.3451C17.7851 16.4673 16.4851 17.7348 16.4851 19.3273V52.7048C16.4851 54.2973 17.7526 55.5648 19.3451 55.5648H51.1626V39.8023C52.9176 38.3073 54.0226 36.0973 54.0226 33.6273Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M45.8001 49.5848H19.4751C17.8501 49.5848 16.5176 50.9173 16.5176 52.5748C16.5176 54.2323 17.8501 55.5323 19.4751 55.5323H51.1951V16.4673H45.8001V49.5848Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M21.5876 22.9349H29.7451C30.4601 22.9349 31.0126 22.3824 31.0126 21.6674C31.0126 20.9524 30.4276 20.3999 29.7451 20.3999H21.5876C20.9051 20.3999 20.3201 20.9524 20.3201 21.6674C20.3201 22.3824 20.9051 22.9349 21.5876 22.9349Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M21.5876 27.68H29.7451C30.4601 27.68 31.0126 27.1275 31.0126 26.4125C31.0126 25.6975 30.4601 25.145 29.7451 25.145H21.5876C20.9051 25.145 20.3201 25.6975 20.3201 26.4125C20.3201 27.1275 20.9051 27.68 21.5876 27.68Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M21.5876 32.4574H29.7451C30.4601 32.4574 31.0126 31.9049 31.0126 31.1899C31.0126 30.4749 30.4601 29.9224 29.7451 29.9224H21.5876C20.9051 29.9224 20.3201 30.4749 20.3201 31.1899C20.3201 31.8724 20.9051 32.4574 21.5876 32.4574Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M60.3925 45.6202L54.4125 39.6402C55.615 37.9502 56.33 35.8702 56.33 33.6277C56.33 30.7677 55.16 28.1677 53.3075 26.3152C53.0475 26.0552 52.755 25.7952 52.4625 25.5677V16.4677C52.4625 16.1427 52.3325 15.8177 52.105 15.5577C51.8775 15.3302 51.5525 15.2002 51.195 15.2002H19.345C18.2075 15.2002 17.1675 15.6552 16.4525 16.4027C15.705 17.1502 15.25 18.1902 15.25 19.2952V52.6727C15.25 53.8102 15.705 54.8502 16.4525 55.5977C17.2 56.3452 18.24 56.8002 19.3775 56.8002H51.195C51.52 56.8002 51.845 56.6702 52.105 56.4427C52.365 56.2152 52.4625 55.8902 52.4625 55.5327V41.6877C52.5275 41.6227 52.625 41.5577 52.69 41.4927L58.605 47.4077C59.0925 47.8952 59.905 47.8952 60.3925 47.4077C60.88 46.9202 60.88 46.1077 60.3925 45.6202ZM47.0675 17.7352H49.9275V24.0727C49.0175 23.6827 48.075 23.4552 47.0675 23.3577C47.0675 23.3252 47.0675 17.7352 47.0675 17.7352ZM17.785 19.2952C17.785 18.8402 17.9475 18.4827 18.24 18.1902C18.5325 17.8977 18.9225 17.7352 19.345 17.7352H44.5325V23.3902C42.2575 23.7152 40.21 24.7552 38.6825 26.3152C36.7975 28.2002 35.66 30.7677 35.66 33.6277C35.66 36.4877 36.83 39.0877 38.6825 40.9402C40.2425 42.5002 42.2575 43.5402 44.5325 43.8652V48.3502H19.475C18.8575 48.3502 18.305 48.4802 17.785 48.7077V19.2952ZM49.9275 54.2652H19.475C18.9875 54.2652 18.565 54.0702 18.2725 53.7777C17.9475 53.4527 17.785 53.0627 17.785 52.5752C17.785 52.0877 17.98 51.6652 18.2725 51.3727C18.5975 51.0477 18.9875 50.8852 19.475 50.8852H45.8C46.125 50.8852 46.45 50.7552 46.71 50.5277C46.97 50.3002 47.0675 49.9752 47.0675 49.6177V43.9302C48.075 43.8327 49.05 43.5727 49.9275 43.2152V54.2652ZM53.795 33.6277C53.795 33.8227 53.795 33.9852 53.7625 34.1477C53.7625 34.2127 53.7625 34.2452 53.7625 34.2777C53.7625 34.4402 53.73 34.6027 53.6975 34.7977V34.8302C53.665 34.9927 53.6325 35.1877 53.6 35.3502C53.6 35.3827 53.5675 35.4152 53.5675 35.4477C52.755 38.9252 49.635 41.5252 45.8975 41.5252C41.5425 41.5252 38 37.9827 38 33.6277C38 29.2727 41.5425 25.7302 45.8975 25.7302C50.2525 25.7302 53.4375 28.9152 53.7625 32.9777C53.7625 33.0102 53.7625 33.0427 53.7625 33.0752C53.795 33.2377 53.795 33.4327 53.795 33.6277Z", fill: "#17294C" })), C$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: 78, height: 77, viewBox: "0 0 78 77", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { opacity: 0.3, x: 6, y: 5, width: 72, height: 72, rx: 11, fill: "#386FF0", fillOpacity: 0.64 }), /* @__PURE__ */ d.createElement("rect", { width: 72, height: 72, rx: 11, fill: "#F2F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M16.7 16.1123H31.27C31.5932 16.1123 31.8575 16.3767 31.8575 16.6998V37.4092C31.8575 37.7323 31.5932 37.9967 31.27 37.9967H16.7C16.3769 37.9967 16.1125 37.7323 16.1125 37.4092V16.6998C16.1125 16.3767 16.3769 16.1123 16.7 16.1123Z", fill: "#E2F1FF" }), /* @__PURE__ */ d.createElement("path", { d: "M39.7301 32.8564H54.3001C54.6232 32.8564 54.8876 33.1208 54.8876 33.4439V54.1533C54.8876 54.4764 54.6232 54.7408 54.3001 54.7408H39.7301C39.407 54.7408 39.1426 54.4764 39.1426 54.1533V33.4439C39.1426 33.1208 39.407 32.8564 39.7301 32.8564Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M39.7301 16.1123H54.3001C54.6232 16.1123 54.8876 16.3767 54.8876 16.6998V25.2773C54.8876 25.6004 54.6232 25.8648 54.3001 25.8648H39.7301C39.407 25.8648 39.1426 25.6004 39.1426 25.2773V16.6998C39.1426 16.3767 39.407 16.1123 39.7301 16.1123Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M16.7 45.1348H31.27C31.5932 45.1348 31.8575 45.3991 31.8575 45.7223V54.2998C31.8575 54.6229 31.5932 54.8873 31.27 54.8873H16.7C16.3769 54.8873 16.1125 54.6229 16.1125 54.2998V45.7223C16.1125 45.3991 16.3769 45.1348 16.7 45.1348Z", fill: "#F0F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M31.6194 15.9375H17.0201C16.0507 15.9375 15.2576 16.7306 15.2576 17.7V38.4094C15.2576 39.3787 16.0507 40.1719 17.0201 40.1719H31.6194C32.5888 40.1719 33.3819 39.3787 33.3819 38.4094V17.7C33.3819 16.7306 32.5888 15.9375 31.6194 15.9375ZM31.0319 37.8219H17.6076V18.2875H31.0319V37.8219Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M54.3 32.6255H39.73C38.7607 32.6255 37.9675 33.4186 37.9675 34.388V55.0974C37.9675 56.0667 38.7607 56.8599 39.73 56.8599H54.3C55.2694 56.8599 56.0625 56.0667 56.0625 55.0974V34.388C56.0625 33.4186 55.2694 32.6255 54.3 32.6255ZM53.7125 54.5099H40.3175V34.9755H53.7125V54.5099Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M54.3 15.9375H39.73C38.7607 15.9375 37.9675 16.7306 37.9675 17.7V26.2775C37.9675 27.2469 38.7607 28.04 39.73 28.04H54.3C55.2694 28.04 56.0625 27.2469 56.0625 26.2775V17.7C56.0625 16.7306 55.2694 15.9375 54.3 15.9375ZM53.7125 25.69H40.3175V18.2875H53.7125V25.69Z", fill: "#17294C" }), /* @__PURE__ */ d.createElement("path", { d: "M31.5901 44.7573H17.0201C16.0507 44.7573 15.2576 45.5504 15.2576 46.5198V55.0973C15.2576 56.0667 16.0507 56.8598 17.0201 56.8598H31.5901C32.5594 56.8598 33.3526 56.0667 33.3526 55.0973V46.5198C33.3526 45.5504 32.5594 44.7573 31.5901 44.7573ZM31.0026 54.5098H17.6076V47.1073H31.0026V54.5098Z", fill: "#17294C" })), x$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: 58, height: 58, viewBox: "0 0 58 58", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_246_691)" }, /* @__PURE__ */ d.createElement("rect", { width: 58, height: 58, rx: 11, fill: "#F2F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M29 41.2565C25.5621 41.2565 22.4564 39.8336 20.2353 37.5441C20.2016 37.5746 16.1836 41.611 16.1495 41.6358C22.8191 48.7722 35.1211 48.7903 41.8118 41.6754L37.7263 37.5834C35.5079 39.8498 32.418 41.2565 29 41.2565Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M16.7759 29.0048C16.7759 22.6161 21.6551 17.3704 27.8824 16.8046L27.8798 11C13.6955 11.7045 5.95662 28.7748 14.6806 39.9357L18.8316 35.8064C17.5334 33.8605 16.7759 31.5215 16.7759 29.0048Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M30.1203 11C30.1177 11.0669 30.1252 16.7414 30.1177 16.8046C39.2284 17.5123 44.3543 28.3116 39.1432 35.8448L43.2857 39.9798C52.062 28.8234 44.3248 11.7045 30.1203 11Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M26.9484 27.0671V33.5375H30.2341V27.0671C30.2341 26.7076 29.9431 26.4163 29.5841 26.4163H27.5984C27.2394 26.4163 26.9484 26.7076 26.9484 27.0671Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M35.5406 32.874V23.4678C35.5406 23.1084 35.2496 22.817 34.8906 22.817H32.905C32.546 22.817 32.255 23.1084 32.255 23.4678V33.5373H34.8782C35.244 33.5373 35.5406 33.2403 35.5406 32.874Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M22.3638 29.6543C22.0049 29.6543 21.7139 29.9457 21.7139 30.3051V32.874C21.7139 33.2403 22.0104 33.5372 22.3763 33.5372H24.9293V30.3051C24.9293 29.9457 24.6383 29.6543 24.2793 29.6543H22.3638Z", fill: "#51A4ED" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_246_691" }, /* @__PURE__ */ d.createElement("rect", { width: 58, height: 58, fill: "white" })))), w$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: 58, height: 58, viewBox: "0 0 58 58", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_246_690)" }, /* @__PURE__ */ d.createElement("rect", { width: 58, height: 58, rx: 11, fill: "#F2F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M22.5172 25.6509H13V47.0001H45.1006V29.7213H25.909L22.5172 25.6509ZM34.5555 41.289H41.5121V43.4064H34.5555V41.289Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M26.9008 27.6039H37.0963V11H17.1517V23.5335H23.509L26.9008 27.6039ZM22.1337 15.4875H32.5086V17.6048H22.1337V15.4875ZM22.1337 19.7225H32.5086V21.8398H22.1337V19.7225Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M41.7543 13.0715H39.2136V27.6039H41.7543V13.0715Z", fill: "#51A4ED" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_246_690" }, /* @__PURE__ */ d.createElement("rect", { width: 58, height: 58, fill: "white" })))), S$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: 58, height: 58, viewBox: "0 0 58 58", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_246_688)" }, /* @__PURE__ */ d.createElement("rect", { width: 58, height: 58, rx: 11, fill: "#F2F8FE" }), /* @__PURE__ */ d.createElement("path", { d: "M29.0002 19.2603C31.2812 19.2603 33.1303 17.4112 33.1303 15.1302C33.1303 12.8491 31.2812 11 29.0002 11C26.7191 11 24.87 12.8491 24.87 15.1302C24.87 17.4112 26.7191 19.2603 29.0002 19.2603Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M34.0425 20.9609H29.0003H23.9582C22.3322 20.9609 21.0142 22.279 21.0142 23.9049V30.1016V34.9042C21.0142 35.854 21.7842 36.624 22.734 36.624C23.6839 36.624 24.4539 35.854 24.4539 34.9042V47.0002H27.9457V35.925H30.055V47.0002H33.5468V34.9042C33.5468 35.854 34.3168 36.624 35.2667 36.624C36.2165 36.624 36.9865 35.854 36.9865 34.9042V30.1016V23.9049C36.9865 22.279 35.6684 20.9609 34.0425 20.9609Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M18.4428 21.1478C20.5686 21.1478 22.2919 19.4245 22.2919 17.2987C22.2919 15.1729 20.5686 13.4496 18.4428 13.4496C16.3169 13.4496 14.5936 15.1729 14.5936 17.2987C14.5936 19.4245 16.3169 21.1478 18.4428 21.1478Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M18.9044 34.904V30.1015V23.9048C18.9044 23.7361 18.9131 23.5694 18.9293 23.405H18.4428H13.7437C12.2284 23.4049 11 24.6333 11 26.1486V31.9237V36.3995C11 37.2848 11.7176 38.0024 12.6028 38.0024C13.4881 38.0024 14.2057 37.2848 14.2057 36.3995V47.0001H17.3881V36.9555H19.4975V47.0001H22.3442V38.7136C20.4149 38.5178 18.9044 36.884 18.9044 34.904Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M39.5575 21.1478C41.6833 21.1478 43.4066 19.4245 43.4066 17.2987C43.4066 15.1729 41.6833 13.4496 39.5575 13.4496C37.4317 13.4496 35.7084 15.1729 35.7084 17.2987C35.7084 19.4245 37.4317 21.1478 39.5575 21.1478Z", fill: "#51A4ED" }), /* @__PURE__ */ d.createElement("path", { d: "M44.2563 23.405H39.5573H39.0708C39.087 23.5694 39.0956 23.7361 39.0956 23.9048V30.1015V34.904C39.0956 36.884 37.5851 38.5179 35.6559 38.7136V47.0001H38.5026V36.9556H40.6119V47.0001H43.7944V36.3996C43.7944 37.2848 44.512 38.0024 45.3972 38.0024C46.2824 38.0024 47.0001 37.2848 47.0001 36.3996V31.9238V26.1487C47.0001 24.6334 45.7716 23.405 44.2563 23.405Z", fill: "#51A4ED" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_246_688" }, /* @__PURE__ */ d.createElement("rect", { width: 58, height: 58, fill: "white" })))), E$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 78 77", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M78,16l0,50c0,6.071 -4.929,11 -11,11l-50,0c-6.071,0 -11,-4.929 -11,-11l0,-50c0,-6.071 4.929,-11 11,-11l50,0c6.071,0 11,4.929 11,11Z", fill: "#f0f8fe", fillOpacity: 0.19 }), /* @__PURE__ */ d.createElement("path", { d: "M72,11l0,50c0,6.071 -4.929,11 -11,11l-50,0c-6.071,0 -11,-4.929 -11,-11l0,-50c0,-6.071 4.929,-11 11,-11l50,0c6.071,0 11,4.929 11,11Z", fill: "#f2f8fe" }), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("ellipse", { cx: 32.554, cy: 32.554, rx: 17.231, ry: 17.231, fill: "#f0f8fe" }), /* @__PURE__ */ d.createElement("path", { d: "M32.524,13.6c-10.435,-0 -18.924,8.489 -18.924,18.924c-0,10.435 8.489,18.925 18.924,18.925c10.435,-0 18.924,-8.49 18.924,-18.925c0,-10.435 -8.489,-18.924 -18.924,-18.924Zm0,34.538c-8.609,0 -15.614,-7.004 -15.614,-15.614c0,-8.609 7.005,-15.614 15.614,-15.614c8.609,0 15.614,7.005 15.614,15.614c0,8.61 -7.004,15.614 -15.614,15.614Z", fill: "#17294c", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M57.915,55.575l-12.028,-12.028c-0.646,-0.647 -1.693,-0.647 -2.34,-0c-0.647,0.646 -0.647,1.694 -0,2.34l12.027,12.028c0.324,0.324 0.747,0.485 1.171,0.485c0.424,0 0.847,-0.161 1.17,-0.485c0.647,-0.646 0.647,-1.694 0,-2.34Z", fill: "#17294c", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M42.028,30.701c0.883,-0.236 1.407,-1.144 1.171,-2.027c-0.879,-3.277 -3.183,-5.969 -6.324,-7.387c-0.782,-0.353 -1.693,-0.048 -2.113,0.68c-0.028,0.048 -0.053,0.097 -0.076,0.148c-0.376,0.833 -0.005,1.814 0.828,2.19c2.232,1.007 3.867,2.912 4.487,5.226c0.237,0.882 1.144,1.407 2.027,1.17Z", fill: "#17294c", fillRule: "nonzero" }))), R$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 325 321", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2
}, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M325,66.667l0,208.333c0,25.296 -20.537,45.833 -45.833,45.833l-208.334,0c-25.296,0 -45.833,-20.537 -45.833,-45.833l-0,-208.333c-0,-25.296 20.537,-45.834 45.833,-45.834l208.334,0c25.296,0 45.833,20.538 45.833,45.834Z", style: {
  fill: "#386ff0",
  fillOpacity: 0.19
} }), /* @__PURE__ */ d.createElement("path", { d: "M300,45.833l0,208.334c0,25.296 -20.537,45.833 -45.833,45.833l-208.334,0c-25.296,0 -45.833,-20.537 -45.833,-45.833l0,-208.334c0,-25.296 20.537,-45.833 45.833,-45.833l208.334,0c25.296,0 45.833,20.537 45.833,45.833Z", style: {
  fill: "#f2f8fe"
} }), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M210.906,210.122l-8.575,-0l-0,8.575c-0,1.674 -1.357,3.03 -3.031,3.03l-8.575,0l0,8.576c0,1.674 -1.356,3.03 -3.03,3.03l-98.601,0c-1.674,0 -3.03,-1.357 -3.03,-3.03l-0,-137.395c-0,-1.674 1.356,-3.03 3.03,-3.03l8.575,-0l0,-8.575c0,-1.674 1.357,-3.031 3.031,-3.031l8.575,0l-0,-8.575c-0,-1.674 1.356,-3.03 3.03,-3.03l98.601,-0c1.674,-0 3.03,1.357 3.03,3.03l0,137.394c0.001,1.674 -1.356,3.031 -3.03,3.031Z", style: {
  fill: "#17294c"
} }), /* @__PURE__ */ d.createElement("rect", { x: 92.125, y: 95.939, width: 92.539, height: 131.333, style: {
  fill: "#e2f1ff"
} }), /* @__PURE__ */ d.createElement("path", { d: "M103.731,84.333l-0,5.545l83.963,-0c1.675,-0 3.031,1.357 3.031,3.03l0,122.758l5.545,-0l-0,-131.333l-92.539,0Z", style: {
  fill: "#e2f1ff"
} }), /* @__PURE__ */ d.createElement("path", { d: "M207.875,72.728l-92.539,-0l0,5.544l83.964,-0c1.674,-0 3.031,1.357 3.031,3.03l-0,122.758l5.544,0l0,-131.332Z", style: {
  fill: "#e2f1ff"
} })), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M154.978,202.216l-33.167,0c-1.674,0 -3.031,-1.357 -3.031,-3.031c0,-1.673 1.357,-3.03 3.031,-3.03l33.167,-0c1.674,-0 3.03,1.357 3.03,3.03c0,1.674 -1.356,3.031 -3.03,3.031Z", style: {
  fill: "#17294c"
} })), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M168.701,187.184l-60.613,-0c-1.674,-0 -3.03,-1.357 -3.03,-3.031c-0,-1.673 1.356,-3.03 3.03,-3.03l60.613,-0c1.674,-0 3.03,1.357 3.03,3.03c0,1.674 -1.357,3.031 -3.03,3.031Z", style: {
  fill: "#17294c"
} })), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M168.701,172.152l-60.613,0c-1.674,0 -3.03,-1.357 -3.03,-3.031c-0,-1.673 1.356,-3.03 3.03,-3.03l60.613,-0c1.674,-0 3.03,1.357 3.03,3.03c0,1.674 -1.357,3.031 -3.03,3.031Z", style: {
  fill: "#17294c"
} })), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M168.701,157.12l-60.613,0c-1.674,0 -3.03,-1.357 -3.03,-3.03c-0,-1.674 1.356,-3.031 3.03,-3.031l60.613,0c1.674,0 3.03,1.357 3.03,3.031c0,1.673 -1.357,3.03 -3.03,3.03Z", style: {
  fill: "#17294c"
} })), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M168.701,142.089l-60.613,-0c-1.674,-0 -3.03,-1.358 -3.03,-3.031c-0,-1.674 1.356,-3.031 3.03,-3.031l60.613,0c1.674,0 3.03,1.357 3.03,3.031c0,1.673 -1.357,3.031 -3.03,3.031Z", style: {
  fill: "#17294c"
} })), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M168.701,127.057l-60.613,-0c-1.674,-0 -3.03,-1.357 -3.03,-3.031c-0,-1.673 1.356,-3.03 3.03,-3.03l60.613,-0c1.674,-0 3.03,1.357 3.03,3.03c0,1.674 -1.357,3.031 -3.03,3.031Z", style: {
  fill: "#17294c"
} })))), T$ = {
  admin: v$,
  dataCatalog: y$,
  library: h$,
  study: b$,
  workspace: C$,
  analyses: x$,
  cohorts: S$,
  conceptSets: w$,
  vocabulary: E$,
  documentation: R$
  // TODO get a correct icon
}, J_ = ({
  iconName: e,
  ref: t,
  ...n
}) => {
  const r = T$[e] || (() => /* @__PURE__ */ p.jsx(p.Fragment, {}));
  return /* @__PURE__ */ p.jsx(or, { ...n, ref: t, inheritViewBox: !0, component: r });
}, M$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M16.7578 0H15.8789V14.1211H30V13.2422C30 5.97234 24.0277 0 16.7578 0Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.5752 26.6676C6.89516 28.6992 9.92305 30 13.2421 30C20.512 30 26.4257 24.0277 26.4257 16.7578V15.8789H15.3639L4.5752 26.6676Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M14.1211 3.57422H13.2422C10.372 3.57422 7.72136 4.50633 5.55444 6.06943L14.1211 14.6361V3.57422Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.19391 7.19455C1.65375 9.59912 0 12.992 0 16.7578C0 20.0769 1.30078 23.1047 3.3324 25.4248L12.8783 15.8789L4.19391 7.19455Z", fill: "currentColor" }))), k$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M17 17H12.75C11.5764 17 10.625 17.9514 10.625 19.125V27.625C10.625 28.7986 11.5764 29.75 12.75 29.75H17C18.1736 29.75 19.125 28.7986 19.125 27.625V19.125C19.125 17.9514 18.1736 17 17 17Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M6.375 20.1875H2.125C0.951395 20.1875 0 21.1389 0 22.3125V27.625C0 28.7986 0.951395 29.75 2.125 29.75H6.375C7.5486 29.75 8.5 28.7986 8.5 27.625V22.3125C8.5 21.1389 7.5486 20.1875 6.375 20.1875Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M27.625 11.6875H23.375C22.2014 11.6875 21.25 12.6389 21.25 13.8125V27.625C21.25 28.7986 22.2014 29.75 23.375 29.75H27.625C28.7986 29.75 29.75 28.7986 29.75 27.625V13.8125C29.75 12.6389 28.7986 11.6875 27.625 11.6875Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.24992 15.9375C4.33843 15.9374 4.42658 15.9264 4.51236 15.9046C8.31533 14.9357 11.9744 13.4711 15.3955 11.5483C19.1199 9.4437 22.5228 6.81517 25.4999 3.74319V6.375C25.4999 6.65679 25.6119 6.92704 25.8111 7.1263C26.0104 7.32556 26.2806 7.4375 26.5624 7.4375C26.8442 7.4375 27.1145 7.32556 27.3137 7.1263C27.513 6.92704 27.6249 6.65679 27.6249 6.375V1.0625C27.6249 0.780707 27.513 0.510456 27.3137 0.311199C27.1145 0.111942 26.8442 0 26.5624 0H21.2499C20.9681 0 20.6979 0.111942 20.4986 0.311199C20.2994 0.510456 20.1874 0.780707 20.1874 1.0625C20.1874 1.34429 20.2994 1.61454 20.4986 1.8138C20.6979 2.01306 20.9681 2.125 21.2499 2.125H24.0932C21.2323 5.10945 17.9515 7.66079 14.3543 9.6985C11.0953 11.5283 7.60983 12.9215 3.98749 13.8422C3.7336 13.9035 3.51118 14.0562 3.3627 14.2711C3.21423 14.4859 3.1501 14.748 3.18256 15.0071C3.21502 15.2663 3.34179 15.5044 3.53868 15.676C3.73557 15.8476 3.98876 15.9407 4.24992 15.9375Z", fill: "currentColor" })), P$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 30 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M15.2148 5.06575C16.6136 5.06575 17.7476 3.93174 17.7476 2.53288C17.7476 1.13401 16.6136 0 15.2148 0C13.8159 0 12.6819 1.13401 12.6819 2.53288C12.6819 3.93174 13.8159 5.06575 15.2148 5.06575Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M3.46134 15.5828C4.86021 15.5828 5.99422 14.4488 5.99422 13.0499C5.99422 11.6511 4.86021 10.5171 3.46134 10.5171C2.06247 10.5171 0.928467 11.6511 0.928467 13.0499C0.928467 14.4488 2.06247 15.5828 3.46134 15.5828Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M26.8203 13.8942C28.0637 13.8942 29.0717 12.8862 29.0717 11.6428C29.0717 10.3994 28.0637 9.39137 26.8203 9.39137C25.5768 9.39137 24.5688 10.3994 24.5688 11.6428C24.5688 12.8862 25.5768 13.8942 26.8203 13.8942Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M19.2683 31.7333V13.0599C19.2683 12.9126 19.1489 12.7932 19.0016 12.7932H10.9987C10.8514 12.7932 10.7319 12.9126 10.7319 13.0599V31.7332C10.7319 31.8805 10.8514 31.9999 10.9987 31.9999H19.0015C19.1489 32 19.2683 31.8806 19.2683 31.7333Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M20.6022 32H28.605C28.7523 32 28.8718 31.8806 28.8718 31.7333V18.6619C28.8718 18.5146 28.7523 18.3952 28.605 18.3952H20.6022C20.4549 18.3952 20.3354 18.5146 20.3354 18.6619V31.7333C20.3354 31.8806 20.4548 32 20.6022 32Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M9.39798 21.0628H1.39517C1.24786 21.0628 1.12842 21.1823 1.12842 21.3296V31.7332C1.12842 31.8806 1.24786 32 1.39517 32H9.39798C9.54529 32 9.66473 31.8806 9.66473 31.7332V21.3296C9.66473 21.1823 9.54535 21.0628 9.39798 21.0628Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M6.02922 10.8529L12.1327 4.74944C11.9062 4.38656 11.7384 3.98369 11.6418 3.554L5.18604 10.0098C5.50847 10.2459 5.79304 10.5305 6.02922 10.8529Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M24.1439 9.75456C24.3569 9.41425 24.6254 9.11225 24.9369 8.86125L18.8293 2.75362C18.8229 3.24937 18.7231 3.72275 18.5466 4.15731L24.1439 9.75456Z", fill: "currentColor" })), I$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M9.50006 15.9687C7.68564 15.9687 6.04651 15.2178 4.87428 14.0094C4.8565 14.0255 2.73589 16.1559 2.7179 16.1689C6.23794 19.9354 12.7307 19.9449 16.2619 16.1899L14.1056 14.0302C12.9348 15.2263 11.3041 15.9687 9.50006 15.9687Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M3.04837 9.50255C3.04837 6.13073 5.62352 3.36217 8.91017 3.06352L8.9088 0C1.42263 0.371836 -2.66178 9.38117 1.94255 15.2716L4.13337 13.0922C3.44818 12.0653 3.04837 10.8308 3.04837 9.50255Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M10.0912 0C10.0898 0.0352962 10.0938 3.03016 10.0898 3.06352C14.8983 3.43703 17.6036 9.1367 14.8533 13.1125L17.0396 15.2949C21.6716 9.40681 17.5881 0.371799 10.0912 0Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8.41724 8.47984V11.8948H10.1514V8.47984C10.1514 8.29013 9.99778 8.13635 9.80832 8.13635H8.76031C8.57082 8.13635 8.41724 8.29013 8.41724 8.47984Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M12.9519 11.5447V6.5803C12.9519 6.3906 12.7984 6.23682 12.6089 6.23682H11.5609C11.3715 6.23682 11.2179 6.3906 11.2179 6.5803V11.8947H12.6024C12.7954 11.8947 12.9519 11.738 12.9519 11.5447Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M5.99758 9.84534C5.80812 9.84534 5.65454 9.99912 5.65454 10.1888V11.5446C5.65454 11.738 5.81105 11.8947 6.00415 11.8947H7.35156V10.1888C7.35156 9.99912 7.19798 9.84534 7.00852 9.84534H5.99758Z", fill: "currentColor" })), O$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 34 38", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M12.498,9.54c6.21,0 12.497,-1.652 12.497,-4.807c0,-6.311 -24.995,-6.311 -24.995,0c0,3.155 6.287,4.807 12.498,4.807Z", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M16.069,21.953l0,2.97c-5.469,0.56 -11.294,-0.154 -16.03,-2.262c-0.013,-0.006 -0.025,-0.014 -0.039,-0.019l0,-5.675c5.546,2.246 12.13,2.786 18.093,1.856l-1.243,1.244c-0.5,0.5 -0.781,1.179 -0.781,1.886Z", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M16.069,32.628c-1.163,0.123 -2.368,0.184 -3.571,0.184c-6.211,0.001 -12.498,-1.651 -12.498,-4.806l0,-3.285c4.704,1.904 10.439,2.686 16.069,2.124l0,5.783Z", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M18.069,21.953c0,-0.177 0.07,-0.347 0.195,-0.472l4.286,-4.286c0.125,-0.124 0.294,-0.195 0.472,-0.195l0.047,0l0,4.238c0,0.421 -0.341,0.762 -0.762,0.762l-4.247,0c0.006,-0.017 0.009,-0.033 0.009,-0.047Z", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M25.069,17l5.891,0c1.171,0 2.109,0.947 2.109,2.105l0,15.79c0,1.171 -0.951,2.105 -2.109,2.105l-10.782,0c-1.162,0 -2.109,-0.943 -2.109,-2.105l0,-10.895l4.238,0c1.525,0 2.762,-1.238 2.762,-2.762l0,-4.238Z", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M20.524,16.393c-6.651,1.658 -14.578,1.159 -20.485,-1.487c-0.013,-0.005 -0.025,-0.013 -0.039,-0.019l-0,-6.466c2.719,2.187 7.875,3.041 12.498,3.041c4.622,0 9.778,-0.854 12.497,-3.041l0,6.43c-0.013,0.005 -0.026,0.012 -0.039,0.017c-0.098,0.044 -0.197,0.089 -0.296,0.132l-1.601,0c-0.013,0 -0.025,0.001 -0.037,0.002l0,-0.002c-0.708,0 -1.386,0.282 -1.886,0.781l-0.612,0.612Z", fillRule: "nonzero" }))), D$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 32 37", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.746 0C13.4167 0 15.5817 1.53759 15.5817 5.08362C15.5817 8.62965 13.4167 11.5042 10.746 11.5042C8.07521 11.5042 5.91025 8.62958 5.91025 5.08362C5.91025 1.53766 8.07528 0 10.746 0ZM22.0826 15.7523C27.4266 16.0511 31.7069 20.377 32 25.7763C30.3327 25.7763 28.6655 25.7765 26.9981 25.7756C26.7223 23.1642 24.668 21.0901 22.0826 20.8131V15.7523ZM31.9998 26.9655C31.8108 30.4095 29.9993 33.4161 27.3246 35.2186L24.7933 30.8683C26.0039 29.9587 26.8342 28.5616 26.9995 26.9646C28.6663 26.9653 30.3331 26.9655 31.9998 26.9655ZM26.3107 35.8222L23.7797 31.4725C23.0823 31.7926 22.3077 31.9708 21.4919 31.9708C18.4333 31.9708 15.9538 29.466 15.9538 26.3761C15.9538 23.546 18.0619 21.1172 20.9011 20.813V15.7522C15.3634 16.0618 10.9672 20.6958 10.9672 26.3676C10.9672 32.2398 15.6793 37 21.4919 37C23.2285 37 24.8669 36.5749 26.3107 35.8222ZM0 27.6407V17.7792C0 15.3619 2.13564 14.012 4.55335 13.3842C8.74413 12.2956 12.8694 12.3645 16.9385 13.3842C18.0101 13.6527 19.0241 14.0709 19.8221 14.6626C14.1178 15.4845 9.78567 20.4431 9.78567 26.3678C9.78567 26.7979 9.809 27.2225 9.85338 27.6408H5.47371V20.0461C5.47371 19.7165 5.20921 19.4493 4.88298 19.4493C4.55674 19.4493 4.29224 19.7165 4.29224 20.0461V27.6407H0Z", fill: "currentColor" })), j$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M31.0873 5.64187C28.0308 2.4068 23.7881 0.272813 19.0547 0V6.09539C21.9298 6.34711 24.5123 7.61625 26.441 9.5407L31.0873 5.64187Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M32.4436 7.25696L27.7973 11.1558C29.1544 13.0943 29.9503 15.454 29.9503 18C29.9503 24.2445 25.1606 29.3702 19.0547 29.9046V36C28.5047 35.4544 36 27.5864 36 18C36 13.9732 34.6774 10.2558 32.4436 7.25696Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M6.04969 18C6.04969 11.7555 10.8394 6.62977 16.9453 6.09539V0C7.49531 0.545625 0 8.41359 0 18C0 27.5864 7.49531 35.4544 16.9453 36V29.9046C10.8394 29.3702 6.04969 24.2445 6.04969 18Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M15.2683 14.0512C15.2683 15.5573 16.4939 16.7829 18 16.7829C19.506 16.7829 20.7309 15.5573 20.7309 14.0512C20.7309 12.5459 19.506 11.3203 18 11.3203C16.4939 11.3203 15.2683 12.5459 15.2683 14.0512Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M16.4721 18.8923C14.7917 18.8923 13.4241 20.2591 13.4241 21.9396V24.2578H22.5759V21.9396C22.5759 20.2591 21.2084 18.8923 19.5279 18.8923H16.4721Z", fill: "currentColor" })), F$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M31.05 5.63818C30.1925 6.77743 28.8294 7.51562 27.2969 7.51562C25.7644 7.51562 24.4013 6.77743 23.5438 5.63818C22.9479 6.42631 22.5938 7.40681 22.5938 8.46875V10.3516C22.5938 10.8693 23.0135 11.2891 23.5312 11.2891H31.0625C31.5802 11.2891 32 10.8693 32 10.3516V8.46875C32 7.40681 31.6459 6.42631 31.05 5.63818Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M16 11.2812C14.4675 11.2812 13.1044 10.5431 12.2469 9.40381C11.651 10.1919 11.2969 11.1724 11.2969 12.2344V14.1172C11.2969 14.6349 11.7166 15.0547 12.2344 15.0547H19.7656C20.2834 15.0547 20.7031 14.6349 20.7031 14.1172V12.2344C20.7031 11.1724 20.349 10.1919 19.7531 9.40381C18.8956 10.5431 17.5325 11.2812 16 11.2812Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.70312 15.0469C3.17062 15.0469 1.8075 14.3087 0.95 13.1694C0.354125 13.9576 0 14.9381 0 16V17.8828C0 18.4006 0.41975 18.8203 0.9375 18.8203H8.46875C8.9865 18.8203 9.40625 18.4006 9.40625 17.8828V16C9.40625 14.9381 9.05212 13.9576 8.45625 13.1694C7.59875 14.3087 6.23563 15.0469 4.70312 15.0469Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M31.0625 13.1797H23.5312C23.0135 13.1797 22.5938 13.5994 22.5938 14.1172V31.0625C22.5938 31.5802 23.0135 32 23.5312 32H31.0625C31.5802 32 32 31.5802 32 31.0625V14.1172C32 13.5994 31.5802 13.1797 31.0625 13.1797Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M19.7656 16.9453H12.2344C11.7166 16.9453 11.2969 17.3651 11.2969 17.8828V31.0625C11.2969 31.5802 11.7166 32 12.2344 32H19.7656C20.2834 32 20.7031 31.5802 20.7031 31.0625V17.8828C20.7031 17.3651 20.2834 16.9453 19.7656 16.9453Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8.46875 20.7109H0.9375C0.41975 20.7109 0 21.1307 0 21.6484V31.0625C0 31.5802 0.41975 32 0.9375 32H8.46875C8.9865 32 9.40625 31.5802 9.40625 31.0625V21.6484C9.40625 21.1307 8.9865 20.7109 8.46875 20.7109Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M27.2969 5.64062C28.8545 5.64062 30.1172 4.37793 30.1172 2.82031C30.1172 1.2627 28.8545 0 27.2969 0C25.7393 0 24.4766 1.2627 24.4766 2.82031C24.4766 4.37793 25.7393 5.64062 27.2969 5.64062Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M16 9.40625C17.5576 9.40625 18.8203 8.14355 18.8203 6.58594C18.8203 5.02832 17.5576 3.76562 16 3.76562C14.4424 3.76562 13.1797 5.02832 13.1797 6.58594C13.1797 8.14355 14.4424 9.40625 16 9.40625Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M4.70312 13.1719C6.26074 13.1719 7.52344 11.9092 7.52344 10.3516C7.52344 8.79395 6.26074 7.53125 4.70312 7.53125C3.14551 7.53125 1.88281 8.79395 1.88281 10.3516C1.88281 11.9092 3.14551 13.1719 4.70312 13.1719Z", fill: "currentColor" })), V$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 33 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M21.3259 21.9292H11.6741C11.948 23.1952 12.2808 24.3746 12.6687 25.4408C13.7531 28.4211 15.1854 30.1792 16.5 30.1792C17.8146 30.1792 19.2469 28.4212 20.3313 25.4408C20.7192 24.3746 21.052 23.1952 21.3259 21.9292Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M9.69976 21.9292H2.18994C4.40075 25.7538 8.15153 28.6731 12.6784 29.7375C11.1588 27.6144 10.2262 24.51 9.69976 21.9292Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M20.3215 29.7375C24.8314 28.6771 28.5919 25.7665 30.81 21.9292H23.3001C22.7737 24.5098 21.8411 27.6144 20.3215 29.7375Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M8.83008 12.7446H0.966797C0.432867 12.7446 0 13.1775 0 13.7114C0 15.9038 0.425391 18.0297 1.23653 19.9956H9.3566C9.01126 17.7247 8.83008 15.2709 8.83008 12.7446Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M32.0331 12.7446H24.1698C24.1698 15.2709 23.9887 17.7247 23.6433 19.9956H31.7634C32.5745 18.0297 32.9999 15.9038 32.9999 13.7114C32.9999 13.1775 32.567 12.7446 32.0331 12.7446Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M21.6878 19.9956C22.0473 17.7446 22.2363 15.2869 22.2363 12.7446H10.7637C10.7637 15.2869 10.9528 17.7446 11.3122 19.9956H21.6878Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M21.6562 10.4243C21.6562 8.5301 20.379 6.93515 18.6391 6.45104C19.3032 5.86026 19.7227 5.00013 19.7227 4.04346C19.7227 2.26648 18.277 0.820801 16.5 0.820801C14.723 0.820801 13.2773 2.26648 13.2773 4.04346C13.2773 5.00013 13.6968 5.86026 14.3609 6.45104C12.621 6.93515 11.3438 8.5301 11.3438 10.4243V10.811H21.6562V10.4243Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M23.5898 10.4243V10.811H31.0663V10.4243C31.0663 8.5301 29.7891 6.93515 28.0492 6.45104C28.7133 5.86026 29.1327 5.00013 29.1327 4.04346C29.1327 2.26648 27.6871 0.820801 25.9101 0.820801C24.1331 0.820801 22.6874 2.26648 22.6874 4.04346C22.6874 5.00013 23.1069 5.86026 23.771 6.45104C23.3264 6.57479 22.9122 6.77144 22.5415 7.02673C23.2069 8.00687 23.5898 9.18289 23.5898 10.4243Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M9.41016 10.4243C9.41016 9.18289 9.79307 8.00694 10.4584 7.02673C10.0878 6.77144 9.67364 6.57472 9.22891 6.45104C9.89304 5.86026 10.3125 5.00013 10.3125 4.04346C10.3125 2.26648 8.86682 0.820801 7.08984 0.820801C5.31287 0.820801 3.86719 2.26648 3.86719 4.04346C3.86719 5.00013 4.28665 5.86026 4.95077 6.45104C3.21086 6.93515 1.93359 8.5301 1.93359 10.4243V10.811H9.41016V10.4243Z", fill: "currentColor" })), $$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 36 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M15.4473 14.685H20.5524C21.1349 14.685 21.6071 14.2128 21.6071 13.6303C21.6071 13.0479 21.1349 12.5757 20.5524 12.5757H15.4473C14.8648 12.5757 14.3926 13.0479 14.3926 13.6303C14.3926 14.2128 14.8648 14.685 15.4473 14.685Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M23.7166 17.8491C23.7166 17.2666 23.2444 16.7944 22.6619 16.7944H13.3379C12.7554 16.7944 12.2832 17.2666 12.2832 17.8491C12.2832 18.4316 12.7554 18.9038 13.3379 18.9038H22.6618C23.2444 18.9038 23.7166 18.4316 23.7166 17.8491Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M21.6074 22.0679C21.6074 21.4854 21.1352 21.0132 20.5527 21.0132H15.4475C14.865 21.0132 14.3928 21.4854 14.3928 22.0679C14.3928 22.6503 14.865 23.1226 15.4475 23.1226H20.5527C21.1352 23.1226 21.6074 22.6503 21.6074 22.0679Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M17.0106 7.82508L17.0106 1.99878C13.4827 2.2268 10.1761 3.59649 7.52026 5.92981L11.643 10.0525C13.184 8.7961 15.0366 8.02737 17.0106 7.82508Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M28.2065 19.0209C27.9686 21.3422 26.9477 23.496 25.2715 25.1722C23.344 27.0998 20.7846 28.1615 18.0655 28.1615C18.0653 28.1615 18.0655 28.1615 18.0653 28.1615C15.6336 28.1615 13.3984 27.3051 11.6442 25.8789L7.52051 30.0026C10.4395 32.5672 14.1445 33.9687 18.0654 33.9687C22.3399 33.9687 26.3584 32.3041 29.3809 29.2816C32.1534 26.5091 33.7822 22.8982 34.0329 19.0208H28.2065V19.0209Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M30.8393 5.19208C28.0086 2.3613 24.2723 0.531629 20.3187 0.0400037C20.0097 0.00112085 19.7109 0.0935818 19.4781 0.299316C19.2471 0.503363 19.1199 0.785527 19.1199 1.09371V7.82507C23.9008 8.31881 27.7126 12.1304 28.2063 16.9114L34.9377 16.9116C35.2458 16.9116 35.528 16.7843 35.732 16.5533C35.9377 16.3204 36.0297 16.022 35.9913 15.7127C35.9913 15.7127 35.9913 15.7127 35.9913 15.7127C35.4998 11.7591 33.6701 8.02279 30.8393 5.19208Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M10.1482 24.3918C8.67227 22.5802 7.87001 20.3349 7.87001 17.9663C7.86994 15.6009 8.67333 13.3565 10.1512 11.5436L5.38952 6.78193C5.1866 6.57901 4.92202 6.4696 4.63824 6.4696C4.61538 6.4696 4.59253 6.47031 4.5694 6.47171C4.26396 6.49063 3.99284 6.63308 3.80595 6.87299C1.31611 10.0687 0 13.9046 0 17.9662C0 22.0278 1.31611 25.8637 3.80602 29.0594C3.99291 29.2993 4.2641 29.4417 4.56947 29.4607C4.87877 29.4797 5.17029 29.3696 5.38952 29.1504L10.1482 24.3918Z", fill: "currentColor" })), L$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 27 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M7.2 6.10298V0H7.13187C6.87707 0 6.633 0.101317 6.45282 0.281242L0.281252 6.4526C0.101071 6.63277 0 6.87683 0 7.13162V7.2H6.10319C6.70812 7.2 7.2 6.70789 7.2 6.10298Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M22.5 26.5735V3.12647C22.5 1.40744 21.0939 0 19.3369 0H9.5612V6.32378C9.5612 8.04772 8.14198 9.45025 6.39785 9.45025H0V26.5735C0 28.2975 1.41895 29.7 3.16309 29.7H19.3369C21.0761 29.7 22.5 28.3101 22.5 26.5735ZM11.789 23.3054H6.39785C5.84194 23.3054 5.39119 22.8598 5.39119 22.3104C5.39119 21.7609 5.84194 21.3154 6.39785 21.3154H11.789C12.3452 21.3154 12.7957 21.7609 12.7957 22.3104C12.7957 22.8598 12.3452 23.3054 11.789 23.3054ZM16.1021 19.0422H6.39785C5.84194 19.0422 5.39119 18.5969 5.39119 18.0472C5.39119 17.4977 5.84194 17.0522 6.39785 17.0522H16.1021C16.6581 17.0522 17.1088 17.4977 17.1088 18.0472C17.1088 18.5969 16.6581 19.0422 16.1021 19.0422Z", fill: "currentColor" }), /* @__PURE__ */ d.createElement("path", { d: "M24.6857 4.5V26.8519C24.6857 29.6843 22.349 31.9889 19.4767 31.9889H4.5C4.90226 33.2682 6.11324 34.2 7.54114 34.2H23.8167C25.5671 34.2 27 32.8046 27 31.061V7.52008C27 6.08883 26.0265 4.87358 24.6857 4.5Z", fill: "currentColor" })), A$ = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 512", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M384 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L398.4 96c-5.2 25.8-22.9 47.1-46.4 57.3L352 448l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-23.5-10.3-41.2-31.6-46.4-57.3L128 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288l144.9 0L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320l144.9 0L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z" })), N$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 2134 2134", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2
}, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M1379.51,809.126c17.882,-1.484 35.956,-2.241 54.193,-2.241c361.548,0 659.057,297.509 659.057,659.058c0,68.055 -10.541,133.841 -30.067,195.802c-4.765,15.123 -10.066,30.018 -15.88,44.663c-20.567,51.81 -47.55,100.483 -79.946,145.018l-2.217,3.03c-120.409,163.587 -314.167,270.544 -530.947,270.544c-216.781,0 -410.539,-106.957 -530.948,-270.544c-44.088,-59.898 -78.343,-127.388 -100.293,-200c-18.084,-59.822 -27.817,-123.12 -27.817,-188.513c0,-82.906 15.644,-162.444 44.116,-235.799c25.52,-65.751 61.347,-126.536 105.453,-180.326c42.087,-51.328 91.713,-96.288 147.117,-133.118c4.431,-2.945 8.898,-5.838 13.402,-8.679c65.755,-41.471 139.195,-71.667 217.516,-87.784c25.277,-5.201 51.062,-8.936 77.261,-11.111Zm358.474,845.33c11.286,-26.831 2.302,-58.44 -22.895,-75.238l-219.6,-146.228l0,-317.172c0,-34.24 -27.546,-61.786 -61.786,-61.786c-34.24,-0 -61.787,27.546 -61.787,61.786l0,350.125c0,20.595 10.298,39.904 27.547,51.489l247.146,164.764c28.319,19.051 66.678,11.327 85.729,-17.249c2.253,-3.38 4.132,-6.892 5.646,-10.491Zm-1077.19,8.333c21.951,72.612 56.205,140.102 100.293,200l-427.75,0c-184.166,0 -333.333,-149.166 -333.333,-333.333l0,-1433.33c0,-55.417 44.583,-100 100,-100c55.417,-0 100,44.583 100,100l0,1433.33c0,73.75 59.583,133.333 133.333,133.333l327.457,0Zm76.752,-537.188c-423.638,-304.524 -385.644,-781.852 -385.644,-781.852c-5.57,-57.22 36.364,-108.198 93.585,-113.768c57.221,-5.569 108.199,36.365 113.768,93.586c0,-0 -18.327,159.019 63.829,343.077c42.173,94.484 110.826,195.567 222.03,285.123c-44.106,53.791 -82.048,108.083 -107.568,173.834Zm539.702,-388.697c-142.407,28.172 -230.395,96.765 -230.918,96.463c-196.411,-113.406 -310.169,-308.497 -310.169,-308.497c-34.638,-45.886 -25.506,-111.26 20.379,-145.898c45.886,-34.637 111.26,-25.506 145.898,20.38c-0,-0 96.725,127.872 234.855,240.634c43.134,35.213 90.334,69.423 139.955,96.918Z" })), B$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 2134 1867", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2
}, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M800,200c0,-110.417 89.583,-200 200,-200l133.333,0c110.417,0 200,89.583 200,200l0,1466.67c0,110.416 -89.583,200 -200,200l-133.333,-0c-110.417,-0 -200,-89.584 -200,-200l-0,-1466.67Zm313.707,1082.81c-0,-26.068 -20.972,-47.04 -47.04,-47.04c-26.068,0 -47.04,20.972 -47.04,47.04l-0,16.268c-61.74,6.468 -109.76,58.604 -109.76,121.912c-0,60.956 44.884,112.7 105.252,121.324l89.768,12.74c14.112,1.96 24.5,14.112 24.5,28.224c-0,15.68 -12.74,28.616 -28.616,28.616l-128.184,0.196c-26.068,0 -47.04,20.972 -47.04,47.04c-0,26.068 20.972,47.04 47.04,47.04l47.04,0l-0,15.68c-0,26.068 20.972,47.04 47.04,47.04c26.068,0 47.04,-20.972 47.04,-47.04l-0,-16.268c61.74,-6.468 109.76,-58.604 109.76,-121.912c-0,-60.956 -44.884,-112.7 -105.252,-121.324l-89.768,-12.936c-14.112,-1.96 -24.5,-14.112 -24.5,-28.224c-0,-15.68 12.74,-28.616 28.616,-28.616l112.504,0c26.068,0 47.04,-20.972 47.04,-47.04c-0,-26.068 -20.972,-47.04 -47.04,-47.04l-31.36,0l-0,-15.68Z" }), /* @__PURE__ */ d.createElement("path", { d: "M0,1000c0,-110.417 89.583,-200 200,-200l133.333,0c110.417,0 200,89.583 200,200l0,666.667c0,110.416 -89.583,200 -200,200l-133.333,-0c-110.417,-0 -200,-89.584 -200,-200l0,-666.667Zm312.173,282.81c0,-26.068 -20.972,-47.04 -47.04,-47.04c-26.068,0 -47.04,20.972 -47.04,47.04l0,16.268c-61.74,6.468 -109.76,58.604 -109.76,121.912c0,60.956 44.884,112.7 105.252,121.324l89.768,12.74c14.112,1.96 24.5,14.112 24.5,28.224c0,15.68 -12.74,28.616 -28.616,28.616l-128.184,0.196c-26.068,0 -47.04,20.972 -47.04,47.04c0,26.068 20.972,47.04 47.04,47.04l47.04,0l0,15.68c0,26.068 20.972,47.04 47.04,47.04c26.068,0 47.04,-20.972 47.04,-47.04l0,-16.268c61.74,-6.468 109.76,-58.604 109.76,-121.912c0,-60.956 -44.884,-112.7 -105.252,-121.324l-89.768,-12.936c-14.112,-1.96 -24.5,-14.112 -24.5,-28.224c0,-15.68 12.74,-28.616 28.616,-28.616l112.504,0c26.068,0 47.04,-20.972 47.04,-47.04c0,-26.068 -20.972,-47.04 -47.04,-47.04l-31.36,0l0,-15.68Z" }), /* @__PURE__ */ d.createElement("path", { d: "M1800,266.667l133.333,-0c110.417,-0 200,89.583 200,200l0,1200c0,110.416 -89.583,200 -200,200l-133.333,-0c-110.417,-0 -200,-89.584 -200,-200l0,-1200c0,-110.417 89.583,-200 200,-200Zm122.173,1016.14c0,-26.068 -20.972,-47.04 -47.04,-47.04c-26.068,0 -47.04,20.972 -47.04,47.04l0,16.268c-61.74,6.468 -109.76,58.604 -109.76,121.912c0,60.956 44.884,112.7 105.252,121.324l89.768,12.74c14.112,1.96 24.5,14.112 24.5,28.224c0,15.68 -12.74,28.616 -28.616,28.616l-128.184,0.196c-26.068,0 -47.04,20.972 -47.04,47.04c0,26.068 20.972,47.04 47.04,47.04l47.04,0l0,15.68c0,26.068 20.972,47.04 47.04,47.04c26.068,0 47.04,-20.972 47.04,-47.04l0,-16.268c61.74,-6.468 109.76,-58.604 109.76,-121.912c0,-60.956 -44.884,-112.7 -105.252,-121.324l-89.768,-12.936c-14.112,-1.96 -24.5,-14.112 -24.5,-28.224c0,-15.68 12.74,-28.616 28.616,-28.616l112.504,0c26.068,0 47.04,-20.972 47.04,-47.04c0,-26.068 -20.972,-47.04 -47.04,-47.04l-31.36,0l0,-15.68Z" })), _$ = {
  analysisCharacterization: M$,
  analysisDataCut: O$,
  analysisIncidence: k$,
  analysisPathway: P$,
  analysisSimpleCount: D$,
  analysisCountsWithDemographics: j$,
  analysisCountsWithDemographicsMulti: F$,
  analysisPopulationLevelEstimation: V$,
  analysisStrategus: $$,
  analysisCustom: L$,
  analysis: I$,
  analysisFeasibility: A$,
  analysisTimeToEvent: N$,
  analysisCost: B$
}, z$ = ({
  iconName: e,
  plain: t = !1,
  ref: n,
  ...r
}) => {
  const i = _$[e] || (() => /* @__PURE__ */ p.jsx(p.Fragment, {}));
  return /* @__PURE__ */ p.jsx(or, { ...r, ref: n, inheritViewBox: !0, children: /* @__PURE__ */ p.jsx(
    i,
    {
      ...t ? { plain: t } : {},
      color: r.color,
      ...r.width ? {
        width: r.width,
        height: r.height
      } : {}
    }
  ) });
}, H$ = (e) => /* @__PURE__ */ d.createElement("svg", { id: "Layer_1", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 467, height: 553, viewBox: "0 0 467 553", fill: "none", xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", x: "0px", y: "0px", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M399.352 189.237C378.626 120.443 316.231 76.9777 241.619 76.9777C150.208 76.9777 76.0317 152.075 76.0317 244.868C76.0317 319.966 124.573 383.45 191.659 404.907C192.423 405.128 193.841 405.57 193.841 405.57C193.95 405.57 194.059 405.681 194.277 405.681C195.041 405.681 195.586 405.128 195.586 404.354C195.586 403.801 195.15 403.248 194.604 403.026C194.604 403.026 192.641 402.252 191.768 401.92C132.536 378.694 90.4306 320.408 90.4306 252.168C90.4306 163.467 161.334 91.6875 248.709 91.6875C314.704 91.6875 370.772 126.969 394.552 185.034C395.316 187.025 396.952 191.117 397.061 191.117C397.279 191.559 397.607 191.891 398.152 191.891C398.916 191.891 399.57 191.227 399.461 190.564C399.461 190.011 399.352 189.568 399.352 189.237Z", fill: "#6C81B1", fillOpacity: 0.05 }), /* @__PURE__ */ d.createElement("path", { d: "M465.891 189.347C445.274 78.7472 350.482 0 235.509 0C105.374 0 0 106.84 0 238.785C0 351.044 80.9391 445.165 183.913 470.714C186.749 471.377 192.53 472.704 192.53 472.704C192.64 472.704 192.749 472.704 192.858 472.704C193.621 472.704 194.167 472.151 194.167 471.377C194.167 470.824 193.839 470.271 193.294 470.161C193.185 470.161 191.549 469.718 190.894 469.497C95.338 443.064 20.5075 354.473 20.5075 249.182C20.5075 123.098 121.3 20.7928 245.763 20.7928C349.173 20.7928 435.348 87.7058 461.746 183.817C462.4 186.14 463.6 190.674 463.6 190.674C463.818 191.117 464.146 191.559 464.691 191.559C465.455 191.559 466.109 190.896 466 190.232C466 189.79 465.891 189.568 465.891 189.347Z", fill: "#6C81B1", fillOpacity: 0.05 }), /* @__PURE__ */ d.createElement("path", { d: "M240.633 329.035C240.633 329.035 207.363 309.57 208.89 290.878C213.472 295.855 215.653 296.851 218.162 297.183C210.745 275.947 212.272 261.569 221.98 241.44C231.689 221.311 245.978 220.647 245.978 220.647C245.978 220.647 244.997 235.689 249.687 245.532C254.814 256.039 269.104 263.118 269.104 263.118C269.104 263.118 266.595 247.744 279.685 237.459C283.721 257.477 299.865 250.288 303.028 268.648C305.974 285.459 298.229 294.196 280.994 314.436C309.792 294.307 336.517 280.04 337.826 246.307C339.244 209.587 325.609 207.375 313.828 191.228C304.556 178.509 309.246 167.117 309.246 167.117C309.246 167.117 302.156 166.564 295.502 181.937C289.502 195.762 297.683 207.818 297.683 207.818C297.683 207.818 284.921 205.716 276.303 188.352C268.013 171.762 275.54 145.882 275.54 145.882C275.54 145.882 246.524 171.541 228.525 195.32C217.29 210.14 200.709 249.182 200.709 249.182C200.709 249.182 195.8 239.781 197.109 225.403C196.346 226.509 179.656 255.818 180.311 279.376C181.074 305.256 197.982 320.298 240.633 329.035Z", fill: "#6C81B1", fillOpacity: 0.05 }), /* @__PURE__ */ d.createElement("path", { d: "M283.29 410.105C283.835 410.769 284.272 411.432 284.817 412.096L336.413 388.98C336.304 388.317 336.195 387.653 336.086 386.99L329.432 338.768C327.032 330.031 318.414 324.832 311.433 327.929L257.001 352.261C250.02 355.358 247.947 365.312 252.747 373.054L283.29 410.105Z", fill: "#6C81B1", fillOpacity: 0.05 }), /* @__PURE__ */ d.createElement("path", { d: "M300.85 435.543C302.159 437.755 303.468 439.967 304.668 442.289L358.664 544.926C363.464 552.779 370.881 554.438 376.554 551.894C382.117 549.35 385.935 542.714 383.535 533.756L345.247 424.483C344.374 421.939 343.502 419.395 342.738 416.741L300.85 435.543Z", fill: "#6C81B1", fillOpacity: 0.05 })), W$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 49 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { id: "Group" }, /* @__PURE__ */ d.createElement("g", { id: "Group_2" }, /* @__PURE__ */ d.createElement("path", { id: "Vector", d: "M37.5849 35H29.8104H27.7169H27.2648V24.5717H30.6754C31.5403 24.5717 32.0514 23.5889 31.5403 22.8812L24.9059 13.7012C24.4833 13.1115 23.6085 13.1115 23.1859 13.7012L16.5515 22.8812C16.0404 23.5889 16.5417 24.5717 17.4165 24.5717H20.827V35H20.3749H18.2814H9.26846C4.1084 34.715 0 29.8891 0 24.6602C0 21.0531 1.95591 17.9079 4.85538 16.2075C4.59 15.49 4.4524 14.7234 4.4524 13.9174C4.4524 10.2317 7.4305 7.25358 11.1163 7.25358C11.9124 7.25358 12.679 7.39118 13.3965 7.65656C15.5293 3.13536 20.1292 0 25.476 0C32.3954 0.0098287 38.096 5.3075 38.7447 12.0598C44.0621 12.9739 48.1017 17.8981 48.1017 23.4709C48.1017 29.4271 43.4625 34.5872 37.5849 35Z", fill: "url(#paint0_linear_181_34)" }))), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_181_34", x1: 48.1447, y1: -8.54651, x2: 29.3572, y2: 33.9136, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#71BDFF" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#085CA5" })))), G$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 38 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { id: "_x35_6" }, /* @__PURE__ */ d.createElement("path", { id: "Vector", d: "M35.9342 8.15263L29.3591 2.07422C28.1673 0.941954 26.598 0.326172 24.9493 0.326172H6.49559C2.91996 0.326172 0 3.24613 0 6.82177V41.5044C0 45.0799 2.91996 48 6.49559 48H31.5044C35.0799 48 38 45.0799 38 41.5044V12.9199C38 11.1124 37.2452 9.38419 35.9342 8.15263ZM12.5143 16.6544C17.8846 11.2842 17.6982 11.444 17.8976 11.3109C18.2153 11.0925 18.6126 10.9733 18.9901 10.9733H19.0099C19.5264 10.9733 20.023 11.1918 20.4005 11.5494C22.4707 13.6277 25.6938 16.8634 25.4857 16.6544C26.2603 17.4291 26.2603 18.6806 25.4857 19.4553C24.7109 20.23 23.4595 20.23 22.6847 19.4553L20.9963 17.7668V24.7789C20.9963 25.8912 20.1024 26.7653 19.0099 26.7653C17.8976 26.7653 17.0235 25.8912 17.0235 24.7789V17.7668L15.3153 19.4752C14.5719 20.2185 13.3045 20.2653 12.5143 19.4752C11.7396 18.7004 11.7396 17.4291 12.5143 16.6544ZM26.6973 37.3529H11.3027C10.2102 37.3529 9.31626 36.4589 9.31626 35.3664C9.31626 34.2738 10.2102 33.38 11.3027 33.38H26.6973C27.7898 33.38 28.6837 34.2738 28.6837 35.3664C28.6837 36.4589 27.7898 37.3529 26.6973 37.3529Z", fill: "url(#paint0_linear_181_22)" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_181_22", x1: 38.034, y1: -11.3151, x2: 4.68333, y2: 32.3996, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#71BDFF" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "#085CA5" })))), U$ = {
  emptyTable: hh,
  searchPlaceholder: vh,
  imagePlaceholder: bh,
  imageAdd: yh,
  cloudPlaceholder: W$,
  filePlaceholder: G$
}, ez = ({
  name: e,
  ref: t,
  ...n
}) => {
  const r = U$[e] || (() => /* @__PURE__ */ p.jsx(p.Fragment, {}));
  return /* @__PURE__ */ p.jsx(or, { ...n, ref: t, inheritViewBox: !0, children: /* @__PURE__ */ p.jsx(
    r,
    {
      color: n.color,
      ...n.width ? {
        width: n.width,
        height: n.height
      } : {}
    }
  ) });
}, Y$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("circle", { cx: 9, cy: 9, r: 9, fill: "#73bf27" }), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M10.522,5.421l2.332,0c0.634,0 1.146,0.583 1.146,1.303l0,1.084l-4.9,1.857c-0.033,0.014 -0.067,0.019 -0.1,0.019c-0.033,0 -0.067,-0.005 -0.1,-0.019l-4.9,-1.857l0,-1.084c0,-0.72 0.513,-1.303 1.146,-1.303l2.332,0l0,-0.579c0,-0.464 0.342,-0.842 0.761,-0.842l1.522,0c0.42,0 0.761,0.378 0.761,0.842l-0,0.579Zm-2.283,0l1.522,0l-0,-0.579l-1.522,0l0,0.579Z", fill: "#fff" }), /* @__PURE__ */ d.createElement("path", { d: "M9.296,9.979c-0.075,0.032 -0.183,0.055 -0.296,0.055c-0.113,-0 -0.221,-0.023 -0.321,-0.064l-4.679,-1.707l0,3.482c0,0.694 0.513,1.255 1.146,1.255l7.708,-0c0.634,-0 1.146,-0.561 1.146,-1.255l0,-3.482l-4.704,1.716Z", fill: "#ffffff", fillRule: "nonzero" })))), Z$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M9,0c4.967,0 9,4.033 9,9c0,4.967 -4.033,9 -9,9c-4.967,0 -9,-4.033 -9,-9c0,-4.967 4.033,-9 9,-9Zm-4.503,7.572l0,5.116c0,0.176 0.173,0.312 0.37,0.312l8.254,-0c0.208,-0 0.37,-0.146 0.37,-0.312l0,-5.116l-8.994,-0Zm6.37,1.959c0,0.175 -0.173,0.312 -0.37,0.312l-3.006,0c-0.208,0 -0.37,-0.146 -0.37,-0.312l0,-0.633c0,-0.176 0.174,-0.312 0.37,-0.312l3.006,0c0.208,0 0.37,0.146 0.37,0.312l0,0.633Zm2.752,-4.531l-9.249,0c-0.208,0 -0.37,0.146 -0.37,0.312l0,1.841l10,0l0,-1.831c-0.012,-0.176 -0.173,-0.322 -0.381,-0.322Z", fill: "#6f7583" }), /* @__PURE__ */ d.createElement("path", { d: "M13.619,5c0.208,0 0.369,0.146 0.381,0.322l0,1.831l-10,0l-0,-1.841c-0,-0.166 0.162,-0.312 0.37,-0.312l9.249,0Zm-9.122,2.572l8.994,0l0,5.116c0,0.166 -0.162,0.312 -0.37,0.312l-8.254,0c-0.197,0 -0.37,-0.136 -0.37,-0.312l-0,-5.116Zm6.37,1.959l0,-0.633c0,-0.166 -0.162,-0.312 -0.37,-0.312l-3.006,0c-0.196,0 -0.37,0.136 -0.37,0.312l-0,0.633c-0,0.166 0.162,0.312 0.37,0.312l3.006,0c0.197,0 0.37,-0.137 0.37,-0.312Z", fill: "#fff" }))), q$ = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("circle", { cx: 9, cy: 9, r: 9, fill: "#20bdd3" }), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M6.695,10.782c-0.077,0.075 -0.126,0.172 -0.14,0.276l-0.355,2.39c-0.037,0.286 0.145,0.552 0.57,0.552l2.47,-0.344c0.108,-0.013 0.208,-0.061 0.285,-0.135l3.285,-3.179l-2.83,-2.739l-3.285,3.179Z", fill: "#ffffff", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M10.695,6.921l2.82,2.729c0.314,-0.35 0.487,-0.799 0.485,-1.263c-0.004,-0.369 -0.116,-0.729 -0.323,-1.039c-0.208,-0.309 -0.502,-0.555 -0.849,-0.709c-0.346,-0.154 -0.731,-0.209 -1.109,-0.159c-0.377,0.05 -0.733,0.203 -1.024,0.441Z", fill: "#ffffff", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M5.5,5.968l4.5,-0c0.133,-0 0.26,-0.051 0.354,-0.142c0.093,-0.091 0.146,-0.214 0.146,-0.342c0,-0.128 -0.053,-0.252 -0.146,-0.342c-0.094,-0.091 -0.221,-0.142 -0.354,-0.142l-4.5,0c-0.133,0 -0.26,0.051 -0.354,0.142c-0.093,0.09 -0.146,0.214 -0.146,0.342c0,0.128 0.053,0.251 0.146,0.342c0.094,0.091 0.221,0.142 0.354,0.142Z", fill: "#ffffff", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M5.5,7.903l3,0c0.133,0 0.26,-0.051 0.354,-0.142c0.093,-0.09 0.146,-0.213 0.146,-0.342c0,-0.128 -0.053,-0.251 -0.146,-0.342c-0.094,-0.091 -0.221,-0.142 -0.354,-0.142l-3,0c-0.133,0 -0.26,0.051 -0.354,0.142c-0.093,0.091 -0.146,0.214 -0.146,0.342c0,0.129 0.053,0.252 0.146,0.342c0.094,0.091 0.221,0.142 0.354,0.142Z", fill: "#ffffff", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M6.5,8.871l-1,-0c-0.133,-0 -0.26,0.051 -0.354,0.142c-0.093,0.09 -0.146,0.214 -0.146,0.342c0,0.128 0.053,0.251 0.146,0.342c0.094,0.091 0.221,0.142 0.354,0.142l1,-0c0.133,-0 0.26,-0.051 0.354,-0.142c0.093,-0.091 0.146,-0.214 0.146,-0.342c0,-0.128 -0.053,-0.252 -0.146,-0.342c-0.094,-0.091 -0.221,-0.142 -0.354,-0.142Z", fill: "#ffffff", fillRule: "nonzero" })))), K$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("circle", { cx: 9, cy: 9, r: 9, fill: "#F68523" }), /* @__PURE__ */ d.createElement("path", { d: "M5.05739 11.2347C4.64447 11.6476 4.06888 13.537 4.00632 13.7498C3.98129 13.8499 4.03134 13.9625 4.14396 13.9875C4.15647 13.9875 4.18149 14 4.19401 14C4.20652 14 4.23154 14 4.24406 13.9875C4.45677 13.9249 6.3462 13.3494 6.75912 12.9364C7.2346 12.461 7.2346 11.6977 6.75912 11.2347C6.29615 10.7717 5.53287 10.7717 5.05739 11.2347Z", fill: "white" }), /* @__PURE__ */ d.createElement("path", { d: "M13.8788 4.35268C13.8538 4.24006 13.7662 4.16499 13.6536 4.12745C13.1656 4.02735 12.6526 3.98981 12.152 4.00232C10.2751 4.00232 9.14899 5.00334 8.31064 6.32969H6.42122C6.09588 6.3422 5.80809 6.5299 5.64543 6.80518L4.74451 8.60701C4.71948 8.66957 4.70697 8.73214 4.69446 8.80721C4.69446 9.04496 4.89466 9.24516 5.1324 9.24516H7.02183L6.62142 9.64557C6.39619 9.8708 6.39619 10.2337 6.62142 10.4714L7.54736 11.3973C7.77259 11.6226 8.13546 11.6226 8.3732 11.3973L8.78612 10.9844V12.8739C8.78612 13.1116 8.97381 13.3118 9.22407 13.3118C9.28663 13.3118 9.3492 13.2993 9.41176 13.2743L11.2011 12.3733C11.4889 12.2107 11.6641 11.9229 11.6766 11.5976V9.6831C13.0029 8.84475 14.0039 7.71861 14.0039 5.85421C14.0164 5.3537 13.9789 4.85319 13.8788 4.35268ZM11.6766 7.05543C11.2762 7.05543 10.9508 6.7301 10.9508 6.32969C10.9508 5.92928 11.2762 5.60395 11.6766 5.60395C12.077 5.60395 12.4023 5.92928 12.4023 6.32969C12.4023 6.7301 12.077 7.05543 11.6766 7.05543Z", fill: "white" }))), X$ = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 9, cy: 9, r: 9, fill: "#2183D9" }), /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_170_143)" }, /* @__PURE__ */ d.createElement("path", { d: "M9 4C6.24311 4 4 6.24311 4 9C4 11.7569 6.24311 14 9 14C11.7569 14 14 11.7569 14 9C14 6.24311 11.7569 4 9 4ZM11.7945 7.68421L8.599 10.8546C8.41103 11.0426 8.11028 11.0551 7.90977 10.8672L6.21804 9.32581C6.01754 9.13784 6.00501 8.82456 6.18045 8.62406C6.36842 8.42356 6.6817 8.41103 6.88221 8.599L8.22306 9.82707L11.0802 6.96992C11.2807 6.76942 11.594 6.76942 11.7945 6.96992C11.995 7.17043 11.995 7.48371 11.7945 7.68421Z", fill: "white" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_170_143" }, /* @__PURE__ */ d.createElement("rect", { width: 10, height: 10, fill: "white", transform: "translate(4 4)" })))), Q$ = {
  active: Y$,
  archived: Z$,
  draft: q$,
  initiate: K$,
  completed: X$
}, J$ = ({
  name: e,
  ref: t,
  ...n
}) => {
  const r = Q$[e] || (() => /* @__PURE__ */ p.jsx(p.Fragment, {}));
  return /* @__PURE__ */ p.jsx(or, { ...n, ref: t, inheritViewBox: !0, children: /* @__PURE__ */ p.jsx(
    r,
    {
      color: n.color,
      ...n.width ? {
        width: n.width,
        height: n.height
      } : {}
    }
  ) });
}, eL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#FFECDB" }), /* @__PURE__ */ d.createElement("path", { d: "M9.76989 14.6425C9.43873 14.5454 9.0951 14.4974 8.75 14.5C7.80559 14.5 6.89594 14.8563 6.20282 15.4978C5.50969 16.1392 5.08415 17.0186 5.01121 17.9602C4.93827 18.9018 5.22331 19.8363 5.80937 20.5768C6.39543 21.3174 7.23935 21.8096 8.1725 21.955C8.36352 21.9852 8.55661 22.0002 8.75 22C9.65532 22.0002 10.5301 21.6727 11.2129 21.0782C11.8956 20.4837 12.3402 19.6622 12.4645 18.7655C12.5888 17.8687 12.3844 16.9573 11.8892 16.1995C11.3939 15.4416 10.6411 14.8886 9.76989 14.6425ZM9.6725 20.0875C9.57631 20.1335 9.47163 20.159 9.36507 20.1625C9.2383 20.1613 9.11437 20.1249 9.00709 20.0573C8.89982 19.9898 8.81341 19.8938 8.7575 19.78L8.14245 18.5575C8.09228 18.4628 8.06655 18.3571 8.06757 18.25V17.02C8.06757 16.839 8.13948 16.6654 8.26747 16.5374C8.39547 16.4094 8.56908 16.3375 8.75009 16.3375C8.93111 16.3375 9.10471 16.4094 9.23271 16.5374C9.36071 16.6654 9.43262 16.839 9.43262 17.02V18.0925L9.97241 19.1725C10.0532 19.3337 10.0671 19.5204 10.0109 19.6918C9.95471 19.8631 9.83308 20.0054 9.6725 20.0875Z", fill: "#F56F52" }), /* @__PURE__ */ d.createElement("path", { d: "M19.2499 7H10.2499C9.65368 7.00175 9.0824 7.23937 8.66083 7.66095C8.23925 8.08253 8.00163 8.6538 7.99988 9.25V13.8175C8.24728 13.7721 8.49834 13.7495 8.74988 13.75C9.71691 13.7495 10.6583 14.0608 11.4346 14.6375C12.2108 15.2142 12.7805 16.0258 13.0591 16.9518C13.3378 17.8778 13.3105 18.869 12.9815 19.7783C12.6525 20.6876 12.0391 21.4667 11.2324 22H19.2499C19.8461 21.9982 20.4173 21.7606 20.8389 21.3391C21.2605 20.9175 21.4981 20.3462 21.4999 19.75V9.25C21.4981 8.6538 21.2605 8.08253 20.8389 7.66095C20.4173 7.23937 19.8461 7.00175 19.2499 7ZM18.4999 17.5H15.8749C15.676 17.5 15.4852 17.421 15.3445 17.2803C15.2039 17.1397 15.1249 16.9489 15.1249 16.75C15.1249 16.5511 15.2039 16.3603 15.3445 16.2197C15.4852 16.079 15.676 16 15.8749 16H18.4999C18.6988 16 18.8896 16.079 19.0302 16.2197C19.1709 16.3603 19.2499 16.5511 19.2499 16.75C19.2499 16.9489 19.1709 17.1397 19.0302 17.2803C18.8896 17.421 18.6988 17.5 18.4999 17.5ZM18.4999 14.875H13.9999C13.801 14.875 13.6102 14.796 13.4695 14.6553C13.3289 14.5147 13.2499 14.3239 13.2499 14.125C13.2499 13.9261 13.3289 13.7353 13.4695 13.5947C13.6102 13.454 13.801 13.375 13.9999 13.375H18.4999C18.6988 13.375 18.8896 13.454 19.0302 13.5947C19.1709 13.7353 19.2499 13.9261 19.2499 14.125C19.2499 14.3239 19.1709 14.5147 19.0302 14.6553C18.8896 14.796 18.6988 14.875 18.4999 14.875ZM18.4999 12.25H10.9999C10.801 12.25 10.6102 12.171 10.4695 12.0303C10.3289 11.8897 10.2499 11.6989 10.2499 11.5C10.2499 11.3011 10.3289 11.1103 10.4695 10.9697C10.6102 10.829 10.801 10.75 10.9999 10.75H18.4999C18.6988 10.75 18.8896 10.829 19.0302 10.9697C19.1709 11.1103 19.2499 11.3011 19.2499 11.5C19.2499 11.6989 19.1709 11.8897 19.0302 12.0303C18.8896 12.171 18.6988 12.25 18.4999 12.25Z", fill: "#F56F52" })), tL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#E8F2EA" }), /* @__PURE__ */ d.createElement("path", { d: "M20.9286 8.07143H19.8571V7.53571C19.8571 7.39363 19.8007 7.25737 19.7002 7.15691C19.5998 7.05644 19.4635 7 19.3214 7C19.1793 7 19.0431 7.05644 18.9426 7.15691C18.8422 7.25737 18.7857 7.39363 18.7857 7.53571V8.07143H16.6429V7.53571C16.6429 7.39363 16.5864 7.25737 16.486 7.15691C16.3855 7.05644 16.2492 7 16.1071 7C15.9651 7 15.8288 7.05644 15.7283 7.15691C15.6279 7.25737 15.5714 7.39363 15.5714 7.53571V8.07143H13.4286V7.53571C13.4286 7.39363 13.3721 7.25737 13.2717 7.15691C13.1712 7.05644 13.0349 7 12.8929 7C12.7508 7 12.6145 7.05644 12.5141 7.15691C12.4136 7.25737 12.3571 7.39363 12.3571 7.53571V8.07143H10.2143V7.53571C10.2143 7.39363 10.1578 7.25737 10.0574 7.15691C9.95691 7.05644 9.82065 7 9.67857 7C9.53649 7 9.40023 7.05644 9.29976 7.15691C9.1993 7.25737 9.14286 7.39363 9.14286 7.53571V8.07143H8.07143C7.78727 8.07143 7.51475 8.18431 7.31381 8.38524C7.11288 8.58617 7 8.8587 7 9.14286V11.2857H22V9.14286C22 8.8587 21.8871 8.58617 21.6862 8.38524C21.4853 8.18431 21.2127 8.07143 20.9286 8.07143Z", fill: "#88A78E" }), /* @__PURE__ */ d.createElement("path", { d: "M7 20.9286C7 21.2128 7.11288 21.4853 7.31381 21.6862C7.51475 21.8871 7.78727 22 8.07143 22H20.9286C21.2127 22 21.4853 21.8871 21.6862 21.6862C21.8871 21.4853 22 21.2128 22 20.9286V12.3572H7V20.9286ZM17.5589 15.7268L18.6304 16.7982C18.6806 16.848 18.7204 16.9073 18.7476 16.9726C18.7748 17.0378 18.7888 17.1079 18.7888 17.1786C18.7888 17.2493 18.7748 17.3193 18.7476 17.3846C18.7204 17.4499 18.6806 17.5091 18.6304 17.5589C18.5806 17.6092 18.5213 17.649 18.456 17.6762C18.3907 17.7034 18.3207 17.7174 18.25 17.7174C18.1793 17.7174 18.1093 17.7034 18.044 17.6762C17.9787 17.649 17.9194 17.6092 17.8696 17.5589L17.7143 17.3875C17.679 17.9256 17.5088 18.4462 17.2196 18.9013C16.9303 19.3564 16.5312 19.7314 16.059 19.9917C15.5868 20.2521 15.0566 20.3895 14.5174 20.3913C13.9781 20.393 13.4471 20.2591 12.9732 20.0018C12.8482 19.9308 12.7565 19.813 12.7183 19.6743C12.6801 19.5357 12.6986 19.3876 12.7696 19.2625C12.8407 19.1375 12.9585 19.0458 13.0971 19.0076C13.2358 18.9694 13.3839 18.9879 13.5089 19.0589C13.8119 19.2285 14.1528 19.3188 14.5 19.3214C15.0281 19.325 15.5389 19.1333 15.9344 18.7833C16.3298 18.4333 16.5821 17.9496 16.6429 17.425L16.5143 17.5589C16.4134 17.6598 16.2766 17.7165 16.1339 17.7165C15.9913 17.7165 15.8544 17.6598 15.7536 17.5589C15.6527 17.4581 15.596 17.3213 15.596 17.1786C15.596 17.0359 15.6527 16.8991 15.7536 16.7982L16.825 15.7268C16.9244 15.6334 17.0556 15.5814 17.192 15.5814C17.3283 15.5814 17.4596 15.6334 17.5589 15.7268ZM10.3696 16.7982C10.4194 16.748 10.4787 16.7082 10.544 16.681C10.6093 16.6538 10.6793 16.6398 10.75 16.6398C10.8207 16.6398 10.8907 16.6538 10.956 16.681C11.0213 16.7082 11.0806 16.748 11.1304 16.7982L11.2964 16.9697C11.3317 16.4316 11.5019 15.911 11.7911 15.4559C12.0804 15.0008 12.4795 14.6258 12.9517 14.3654C13.424 14.1051 13.9541 13.9677 14.4933 13.9659C15.0326 13.9641 15.5636 14.0981 16.0375 14.3554C16.1625 14.4264 16.2542 14.5442 16.2924 14.6829C16.3306 14.8215 16.3121 14.9696 16.2411 15.0947C16.17 15.2197 16.0522 15.3114 15.9136 15.3496C15.7749 15.3877 15.6268 15.3693 15.5018 15.2982C15.1944 15.1336 14.8515 15.0465 14.5028 15.0444C14.154 15.0424 13.8101 15.1254 13.5008 15.2864C13.1915 15.4474 12.9261 15.6815 12.7278 15.9683C12.5294 16.2551 12.404 16.5859 12.3625 16.9322L12.4911 16.7982C12.541 16.7483 12.6003 16.7087 12.6656 16.6816C12.7308 16.6546 12.8008 16.6407 12.8714 16.6407C12.9421 16.6407 13.012 16.6546 13.0773 16.6816C13.1425 16.7087 13.2018 16.7483 13.2518 16.7982C13.3017 16.8482 13.3414 16.9075 13.3684 16.9727C13.3954 17.038 13.4093 17.108 13.4093 17.1786C13.4093 17.2492 13.3954 17.3192 13.3684 17.3844C13.3414 17.4497 13.3017 17.509 13.2518 17.5589L12.1804 18.6304C12.1306 18.6806 12.0713 18.7204 12.006 18.7476C11.9407 18.7748 11.8707 18.7888 11.8 18.7888C11.7293 18.7888 11.6593 18.7748 11.594 18.7476C11.5287 18.7204 11.4694 18.6806 11.4196 18.6304L10.3482 17.5589C10.2994 17.5077 10.2612 17.4474 10.2358 17.3813C10.2104 17.3153 10.1984 17.2449 10.2004 17.1741C10.2024 17.1034 10.2184 17.0338 10.2474 16.9692C10.2765 16.9047 10.318 16.8466 10.3696 16.7982Z", fill: "#88A78E" })), nL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#FFF0EB" }), /* @__PURE__ */ d.createElement("path", { d: "M11.845 12.0159C11.9199 11.9178 11.9574 11.792 11.9574 11.6386C11.9574 11.4817 11.9146 11.3568 11.829 11.2641C11.7434 11.1713 11.6506 11.1249 11.5507 11.1249H10.7748V12.163H11.5774C11.6809 12.163 11.7701 12.114 11.845 12.0159Z", fill: "#F56F52" }), /* @__PURE__ */ d.createElement("path", { d: "M16.9336 11.248C16.8944 11.2051 16.8498 11.174 16.7999 11.1543C16.7499 11.1347 16.7 11.1249 16.65 11.1249H15.9651V12.163H16.6821C16.7856 12.163 16.8748 12.1184 16.9497 12.0292C17.0246 11.9401 17.0621 11.8098 17.0621 11.6386C17.0621 11.5495 17.0505 11.4727 17.0273 11.4085C17.004 11.3443 16.9729 11.2908 16.9336 11.248Z", fill: "#F56F52" }), /* @__PURE__ */ d.createElement("path", { d: "M21.4837 19.5657H6V22.1047H21.4837V19.5657Z", fill: "#F56F52" }), /* @__PURE__ */ d.createElement("path", { d: "M20.0807 11.3388C20.0807 7.84359 17.2371 5 13.7419 5C10.2466 5 7.40308 7.84359 7.40308 11.3388V18.5635H20.0807V11.3388ZM13.4824 10.3543H14.3599V14.1536H13.4824V10.3543ZM9.89712 10.3543H11.6095C11.7878 10.3543 11.9528 10.3918 12.1045 10.4667C12.2561 10.5416 12.3872 10.6398 12.4978 10.761C12.6083 10.8823 12.6948 11.0197 12.7573 11.173C12.8197 11.3265 12.851 11.4816 12.851 11.6386C12.851 11.7563 12.8367 11.8696 12.8081 11.9784C12.7795 12.0873 12.7386 12.1897 12.6851 12.2861C12.6315 12.3824 12.5664 12.4689 12.4897 12.5456C12.413 12.6223 12.3266 12.6874 12.2302 12.7409L13.065 14.1536H12.075L11.3472 12.9282H10.7747V14.1536H9.89709V10.3543H9.89712ZM17.6004 16.1581H9.88329V15.1559H17.6004V16.1581ZM17.8622 12.1202C17.8033 12.2736 17.7212 12.411 17.616 12.5322C17.5108 12.6535 17.3833 12.7499 17.2334 12.8212C17.0836 12.8926 16.9177 12.9282 16.7358 12.9282H15.9652V14.1536H15.0877V10.3543H16.7091C16.891 10.3543 17.0577 10.3918 17.2094 10.4667C17.361 10.5416 17.4912 10.6398 17.6 10.761C17.7088 10.8823 17.7944 11.0197 17.8569 11.173C17.9193 11.3265 17.9505 11.4816 17.9505 11.6386C17.9505 11.8063 17.9211 11.9669 17.8622 12.1202Z", fill: "#F56F52" })), oL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#EDF2FF" }), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M20.5436 7.82094C19.0154 6.2034 16.8941 5.13641 14.5273 5V8.0477C15.9649 8.17355 17.2562 8.80813 18.2205 9.77035L20.5436 7.82094Z", fill: "#66AEED" }), /* @__PURE__ */ d.createElement("path", { d: "M21.2218 8.62848L18.8987 10.5779C19.5772 11.5472 19.9752 12.727 19.9752 14C19.9752 17.1222 17.5803 19.6851 14.5273 19.9523V23C19.2523 22.7272 23 18.7932 23 14C23 11.9866 22.3387 10.1279 21.2218 8.62848Z", fill: "#66AEED" }), /* @__PURE__ */ d.createElement("path", { d: "M8.02484 14C8.02484 10.8778 10.4197 8.31488 13.4727 8.0477V5C8.74766 5.27281 5 9.2068 5 14C5 18.7932 8.74766 22.7272 13.4727 23V19.9523C10.4197 19.6851 8.02484 17.1222 8.02484 14Z", fill: "#66AEED" }), /* @__PURE__ */ d.createElement("path", { d: "M12.6342 12.0256C12.6342 12.7787 13.2469 13.3914 14 13.3914C14.753 13.3914 15.3654 12.7787 15.3654 12.0256C15.3654 11.2729 14.753 10.6602 14 10.6602C13.2469 10.6602 12.6342 11.2729 12.6342 12.0256Z", fill: "#66AEED" }), /* @__PURE__ */ d.createElement("path", { d: "M13.2361 14.4461C12.3958 14.4461 11.712 15.1296 11.712 15.9698V17.1289H16.288V15.9698C16.288 15.1296 15.6042 14.4461 14.764 14.4461H13.2361Z", fill: "#66AEED" }))), rL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#DBFAFC" }), /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M16.153 10H11.847C10.2771 10 9 11.1431 9 12.5481V19.4519C9 20.8569 10.2771 22 11.847 22H16.153C17.7229 22 19 20.8569 19 19.4519V12.5481C19 11.1431 17.7229 10 16.153 10ZM16.7778 16.4972H15.6667V15.5028H16.7778V16.4972ZM14.5556 15.5028V16.4972H13.4444V15.5028H14.5556ZM12.3333 15.5028V16.4972H11.2222V15.5028H12.3333Z", fill: "#74D5C9" }), /* @__PURE__ */ d.createElement("path", { d: "M14 5.92098C15.2088 5.92098 16.3453 6.30417 17.2 6.99997L18 6.34874C16.9315 5.479 15.511 5 14 5C12.489 5 11.0685 5.479 10 6.34878L10.8 7C11.6547 6.30417 12.7912 5.92098 14 5.92098Z", fill: "#74D5C9" }), /* @__PURE__ */ d.createElement("path", { d: "M12.6667 9C13.0228 8.5236 13.4963 8.26122 14 8.26122C14.5036 8.26122 14.9772 8.5236 15.3333 9L16 8.10819C15.4658 7.39354 14.7555 7 14 7C13.2445 7 12.5342 7.39354 12 8.10819L12.6667 9Z", fill: "#74D5C9" }))), iL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#E6F4E2" }), /* @__PURE__ */ d.createElement("path", { d: "M19.5116 14.6603H14.8232C14.0012 14.6603 13.3348 15.3266 13.3348 16.1486V22.5115C13.3348 23.3335 14.0012 23.9999 14.8232 23.9999H19.5116C20.3336 23.9999 21 23.3335 21 22.5115V16.1486C21 15.3266 20.3336 14.6603 19.5116 14.6603ZM18.0605 21.6557H16.2744C15.9662 21.6557 15.7163 21.4058 15.7163 21.0975C15.7163 20.7893 15.9662 20.5394 16.2744 20.5394H18.0605C18.3687 20.5394 18.6186 20.7893 18.6186 21.0975C18.6186 21.4058 18.3687 21.6557 18.0605 21.6557ZM18.0605 18.6789H17.7256V19.0138C17.7256 19.322 17.4757 19.5719 17.1674 19.5719C16.8592 19.5719 16.6093 19.322 16.6093 19.0138V18.6789H16.2744C15.9662 18.6789 15.7163 18.429 15.7163 18.1208C15.7163 17.8125 15.9662 17.5626 16.2744 17.5626H16.6093V17.2277C16.6093 16.9195 16.8592 16.6696 17.1674 16.6696C17.4757 16.6696 17.7256 16.9195 17.7256 17.2277V17.5626H18.0605C18.3687 17.5626 18.6186 17.8125 18.6186 18.1208C18.6186 18.429 18.3687 18.6789 18.0605 18.6789Z", fill: "#70D48C" }), /* @__PURE__ */ d.createElement("path", { d: "M15.4187 12.0928V13.544H18.9164V12.0928C18.9164 11.7846 18.6665 11.5347 18.3583 11.5347H15.9768C15.6686 11.5347 15.4187 11.7846 15.4187 12.0928Z", fill: "#70D48C" }), /* @__PURE__ */ d.createElement("path", { d: "M14.3024 12.0929C14.3024 11.1696 15.0535 10.4185 15.9768 10.4185H17.9396C17.4394 7.32149 14.7477 4.94867 11.5117 4.94867C7.92114 4.94867 5 7.86981 5 11.4604C5 15.3324 8.36918 18.3512 12.2187 17.9335V16.1488C12.2187 14.8909 13.115 13.8385 14.3024 13.5965V12.0929ZM12.0698 11.4604C12.0698 11.6718 11.9504 11.865 11.7613 11.9596L8.78451 13.4479C8.50939 13.5856 8.17379 13.4745 8.03571 13.1983C7.89785 12.9226 8.00959 12.5874 8.28531 12.4495L10.9535 11.1154V7.88823C10.9535 7.57998 11.2034 7.33008 11.5117 7.33008C11.8199 7.33008 12.0698 7.57998 12.0698 7.88823V11.4604Z", fill: "#70D48C" })), sL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#FFF0EB" }), /* @__PURE__ */ d.createElement("path", { d: "M19.7631 7.23466C18.116 5.58845 15.4368 5.58845 13.7896 7.23466L10.3071 10.7172L14.261 14.671C15.0748 13.9934 16.1065 13.5691 17.2457 13.5691C17.8991 13.5691 18.5209 13.7048 19.0867 13.9472L19.7631 13.2082C21.4098 11.5615 21.4098 8.88182 19.7631 7.23466Z", fill: "#FFA082" }), /* @__PURE__ */ d.createElement("path", { d: "M13.6028 15.34L9.64342 11.3807L6.23499 14.7925C4.58834 16.4391 4.58834 19.1188 6.23499 20.7659C7.88209 22.412 10.5926 22.4435 12.2397 20.7972L12.9307 20.1029C12.6883 19.5371 12.5526 18.9153 12.5526 18.2619C12.5526 17.152 12.9562 16.1444 13.6028 15.34Z", fill: "#FFA082" }), /* @__PURE__ */ d.createElement("path", { d: "M13.4913 18.262C13.4913 20.1747 14.927 21.7357 16.7764 21.9691V14.5549C14.927 14.7883 13.4913 16.3492 13.4913 18.262Z", fill: "#FFA082" }), /* @__PURE__ */ d.createElement("path", { d: "M17.715 14.5549V21.9691C19.5644 21.7357 21.0001 20.1747 21.0001 18.262C21.0001 16.3492 19.5645 14.7883 17.715 14.5549Z", fill: "#FFA082" })), aL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#DBFAFC" }), /* @__PURE__ */ d.createElement("path", { d: "M13.625 7C12.1338 7.00198 10.7042 7.59524 9.64971 8.64971C8.59524 9.70417 8.00198 11.1338 8 12.625C8 16.6633 13.2406 21.7211 13.4633 21.9344C13.5066 21.9765 13.5646 22 13.625 22C13.6854 22 13.7434 21.9765 13.7867 21.9344C14.0094 21.7211 19.25 16.6633 19.25 12.625C19.248 11.1338 18.6547 9.70417 17.6003 8.64971C16.5458 7.59524 15.1162 7.00198 13.625 7ZM13.625 15.2031C13.1151 15.2031 12.6166 15.0519 12.1927 14.7686C11.7687 14.4853 11.4383 14.0827 11.2431 13.6116C11.048 13.1405 10.9969 12.6221 11.0964 12.122C11.1959 11.6219 11.4414 11.1625 11.802 10.802C12.1625 10.4414 12.6219 10.1959 13.122 10.0964C13.6221 9.99693 14.1405 10.048 14.6116 10.2431C15.0827 10.4383 15.4853 10.7687 15.7686 11.1927C16.0519 11.6166 16.2031 12.1151 16.2031 12.625C16.2027 13.3086 15.931 13.9641 15.4475 14.4475C14.9641 14.931 14.3086 15.2027 13.625 15.2031Z", fill: "#81D9D0" })), lL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#EDECFF" }), /* @__PURE__ */ d.createElement("path", { d: "M7.37439 8.48225L10.6882 11.7961C11.4404 11.1944 12.354 10.8033 13.3602 10.6901V6C11.0687 6.13427 8.98808 7.04676 7.37439 8.48225Z", fill: "#A49EE7" }), /* @__PURE__ */ d.createElement("path", { d: "M6.55061 9.30606C4.99366 11.0562 4 13.3532 4 15.8745C4 16.1965 4.26057 16.4571 4.58259 16.4571H8.11696C8.43897 16.4571 8.69954 16.1965 8.69954 15.8745C8.69954 14.6389 9.14685 13.517 9.86445 12.6199L6.55061 9.30606Z", fill: "#A49EE7" }), /* @__PURE__ */ d.createElement("path", { d: "M18.4442 11.3191C18.2479 11.1478 17.9634 11.1256 17.7467 11.2662L12.6906 14.4914C12.0152 14.9226 11.6124 15.6571 11.6124 16.4571C11.6124 17.7423 12.6576 18.7874 13.9428 18.7874C14.8463 18.7874 15.6757 18.2583 16.0558 17.4396L18.5881 12.0029C18.6974 11.7685 18.6387 11.4897 18.4442 11.3191Z", fill: "#A49EE7" }), /* @__PURE__ */ d.createElement("path", { d: "M21.3352 9.30606L19.6228 11.0184C19.8385 11.4787 19.8668 12.0175 19.6442 12.495L18.8782 14.1396C19.0754 14.6814 19.1862 15.2637 19.1862 15.8745C19.1862 16.1965 19.4468 16.4571 19.7688 16.4571H23.3032C23.6252 16.4571 23.8858 16.1965 23.8858 15.8745C23.8858 13.3532 22.8921 11.0562 21.3352 9.30606Z", fill: "#A49EE7" }), /* @__PURE__ */ d.createElement("path", { d: "M14.5254 6V10.6901C15.0159 10.7453 15.4832 10.8687 15.9218 11.0481L17.1203 10.2835C17.6005 9.97236 18.1873 9.90559 18.7984 10.1951L20.5112 8.48225C18.8975 7.04676 16.8169 6.13427 14.5254 6Z", fill: "#A49EE7" })), cL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#EDF2FF" }), /* @__PURE__ */ d.createElement("path", { d: "M16.4957 13.7504C16.4957 12.5095 15.4897 11.5035 14.2488 11.5035C13.0078 11.5035 12.0018 12.5095 12.0018 13.7504C12.0018 14.9913 13.0078 15.9973 14.2488 15.9973H14.2489C15.4892 15.9959 16.4943 14.9907 16.4957 13.7504Z", fill: "#66AEED" }), /* @__PURE__ */ d.createElement("path", { d: "M12.5826 16.9303C14.3368 17.8482 16.503 17.1702 17.4209 15.4159C18.3388 13.6617 17.6608 11.4954 15.9066 10.5775C14.1523 9.65966 11.9861 10.3376 11.0682 12.0919C10.532 13.1167 10.5232 14.3374 11.0445 15.3699C11.0535 15.3893 12.5751 16.9258 12.5826 16.9303ZM11.4055 13.7504C11.4055 12.1799 12.6787 10.9067 14.2492 10.9067C15.8197 10.9067 17.0928 12.1799 17.0928 13.7504C17.0928 15.3209 15.8197 16.594 14.2492 16.594C14.2491 16.594 14.249 16.594 14.2489 16.594C12.6792 16.5921 11.4073 15.32 11.4055 13.7504Z", fill: "#66AEED" }), /* @__PURE__ */ d.createElement("path", { d: "M10.1301 10.4425V8.01392L7.33899 10.8334H9.73926C9.95479 10.8326 10.1294 10.6581 10.1301 10.4425Z", fill: "#66AEED" }), /* @__PURE__ */ d.createElement("path", { d: "M9.71985 16.6513L5.11771 20.7746C4.95458 20.9508 4.96189 21.225 5.13412 21.3922L6.60651 22.8661C6.77385 23.0387 7.04863 23.0453 7.2241 22.881L11.3608 18.2938L9.71985 16.6513Z", fill: "#66AEED" }), /* @__PURE__ */ d.createElement("path", { d: "M9.95471 15.9376L10.2923 15.6001C10.3214 15.571 10.3686 15.571 10.3977 15.6001L12.3987 17.601C12.4278 17.6301 12.4278 17.6773 12.3987 17.7064L12.0611 18.044C12.032 18.0731 11.9848 18.0731 11.9557 18.044L9.95471 16.0431C9.92558 16.014 9.92558 15.9668 9.95471 15.9376Z", fill: "#66AEED" }), /* @__PURE__ */ d.createElement("path", { d: "M20.1921 6H9.00675C8.67717 6 8.41003 6.26714 8.41003 6.59671V8.9045L9.9227 7.37691C10.1346 7.16448 10.4222 7.04484 10.7223 7.04425H18.8077C19.4669 7.04425 20.0012 7.57857 20.0012 8.23767V20.9163H20.1921C20.5215 20.9159 20.7884 20.649 20.7888 20.3196V6.59671C20.7888 6.26714 20.5217 6 20.1921 6Z", fill: "#66AEED" }), /* @__PURE__ */ d.createElement("path", { d: "M18.8077 7.64096H10.7268V10.4425C10.7261 10.9877 10.2843 11.4294 9.73921 11.4301H7.02417V18.2654L9.34091 16.1889C9.26427 15.9723 9.31883 15.7309 9.48113 15.5683L9.9227 15.1267C10.0092 15.0403 10.1201 14.9825 10.2404 14.9611C9.57194 12.7477 10.8243 10.4115 13.0378 9.74295C15.2512 9.07445 17.5874 10.3268 18.2559 12.5403C18.9244 14.7537 17.6721 17.0899 15.4586 17.7584C15.0663 17.8769 14.6587 17.9372 14.2489 17.9372C13.8385 17.9368 13.4304 17.8765 13.0375 17.7582C13.0174 17.879 12.9594 17.9903 12.872 18.076L12.4304 18.519C12.3185 18.6309 12.0049 18.7577 11.8277 18.6667L8.72331 22.1083H18.8077C19.1371 22.1078 19.404 21.8409 19.4045 21.5115V8.23767C19.404 7.90829 19.1371 7.64137 18.8077 7.64096Z", fill: "#66AEED" })), uL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#FFEDED" }), /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_1281_3302)" }, /* @__PURE__ */ d.createElement("path", { d: "M9.5 16V19H6.5V16C6.50078 15.735 6.60638 15.4811 6.79375 15.2938C6.98112 15.1064 7.23502 15.0008 7.5 15H8.5C8.76498 15.0008 9.01888 15.1064 9.20625 15.2938C9.39362 15.4811 9.49922 15.735 9.5 16Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M13.5 15V19H10.5V15C10.5008 14.735 10.6064 14.4811 10.7938 14.2938C10.9811 14.1064 11.235 14.0008 11.5 14H12.5C12.765 14.0008 13.0189 14.1064 13.2062 14.2938C13.3936 14.4811 13.4992 14.735 13.5 15Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M17.5 16V19H14.5V16C14.5008 15.735 14.6064 15.4811 14.7938 15.2938C14.9811 15.1064 15.235 15.0008 15.5 15H16.5C16.765 15.0008 17.0189 15.1064 17.2062 15.2938C17.3936 15.4811 17.4992 15.735 17.5 16Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M21.5 14V19H18.5V14C18.5008 13.735 18.6064 13.4811 18.7938 13.2938C18.9811 13.1064 19.235 13.0008 19.5 13H20.5C20.765 13.0008 21.0189 13.1064 21.2062 13.2938C21.3936 13.4811 21.4992 13.735 21.5 14Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M21.5 21H6.5C6.36739 21 6.24021 20.9473 6.14645 20.8536C6.05268 20.7598 6 20.6326 6 20.5C6 20.3674 6.05268 20.2402 6.14645 20.1464C6.24021 20.0527 6.36739 20 6.5 20H21.5C21.6326 20 21.7598 20.0527 21.8536 20.1464C21.9473 20.2402 22 20.3674 22 20.5C22 20.6326 21.9473 20.7598 21.8536 20.8536C21.7598 20.9473 21.6326 21 21.5 21Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M8 14C7.80222 14 7.60888 13.9414 7.44443 13.8315C7.27998 13.7216 7.15181 13.5654 7.07612 13.3827C7.00043 13.2 6.98063 12.9989 7.01922 12.8049C7.0578 12.6109 7.15304 12.4327 7.29289 12.2929C7.43275 12.153 7.61093 12.0578 7.80491 12.0192C7.99889 11.9806 8.19996 12.0004 8.38268 12.0761C8.56541 12.1518 8.72159 12.28 8.83147 12.4444C8.94135 12.6089 9 12.8022 9 13C8.99964 13.2651 8.89417 13.5193 8.70671 13.7067C8.51925 13.8942 8.26511 13.9996 8 14Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M12 13C11.8022 13 11.6089 12.9414 11.4444 12.8315C11.28 12.7216 11.1518 12.5654 11.0761 12.3827C11.0004 12.2 10.9806 11.9989 11.0192 11.8049C11.0578 11.6109 11.153 11.4327 11.2929 11.2929C11.4327 11.153 11.6109 11.0578 11.8049 11.0192C11.9989 10.9806 12.2 11.0004 12.3827 11.0761C12.5654 11.1518 12.7216 11.28 12.8315 11.4444C12.9414 11.6089 13 11.8022 13 12C12.9996 12.2651 12.8942 12.5193 12.7067 12.7067C12.5193 12.8942 12.2651 12.9996 12 13Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M16 14C15.8022 14 15.6089 13.9414 15.4444 13.8315C15.28 13.7216 15.1518 13.5654 15.0761 13.3827C15.0004 13.2 14.9806 12.9989 15.0192 12.8049C15.0578 12.6109 15.153 12.4327 15.2929 12.2929C15.4327 12.153 15.6109 12.0578 15.8049 12.0192C15.9989 11.9806 16.2 12.0004 16.3827 12.0761C16.5654 12.1518 16.7216 12.28 16.8315 12.4444C16.9414 12.6089 17 12.8022 17 13C16.9996 13.2651 16.8942 13.5193 16.7067 13.7067C16.5193 13.8942 16.2651 13.9996 16 14Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M20 12.5C19.8022 12.5 19.6089 12.4414 19.4444 12.3315C19.28 12.2216 19.1518 12.0654 19.0761 11.8827C19.0004 11.7 18.9806 11.4989 19.0192 11.3049C19.0578 11.1109 19.153 10.9327 19.2929 10.7929C19.4327 10.653 19.6109 10.5578 19.8049 10.5192C19.9989 10.4806 20.2 10.5004 20.3827 10.5761C20.5654 10.6518 20.7216 10.78 20.8315 10.9444C20.9414 11.1089 21 11.3022 21 11.5C20.9996 11.7651 20.8942 12.0193 20.7067 12.2067C20.5193 12.3942 20.2651 12.4996 20 12.5Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M7.99954 13.5C7.87762 13.4998 7.75998 13.455 7.66876 13.3741C7.57754 13.2932 7.51901 13.1818 7.5042 13.0608C7.48938 12.9398 7.51929 12.8175 7.5883 12.717C7.65732 12.6165 7.76068 12.5446 7.87894 12.515L11.8789 11.515C11.9584 11.4945 12.0417 11.4945 12.1211 11.515L15.97 12.4771L19.824 11.0318C19.9482 10.9851 20.0859 10.9898 20.2066 11.0446C20.3274 11.0994 20.4215 11.2 20.4681 11.3242C20.5147 11.4484 20.5101 11.586 20.4553 11.7068C20.4004 11.8276 20.2998 11.9216 20.1756 11.9683L16.1756 13.4683C16.0806 13.5037 15.9771 13.5094 15.8787 13.4849L12 12.5156L8.12114 13.485C8.08138 13.495 8.04054 13.5 7.99954 13.5Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M14 8.655C14.6379 8.655 15.155 8.13789 15.155 7.5C15.155 6.86211 14.6379 6.345 14 6.345C13.3621 6.345 12.845 6.86211 12.845 7.5C12.845 8.13789 13.3621 8.655 14 8.655Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M18.84 7.1333C18.7516 7.05175 16.651 5.1333 14 5.1333C11.3489 5.1333 9.24853 7.05175 9.15998 7.1333C9.10948 7.18011 9.0692 7.23684 9.04165 7.29994C9.0141 7.36304 8.99988 7.43115 8.99988 7.5C8.99988 7.56885 9.0141 7.63696 9.04165 7.70006C9.0692 7.76316 9.10948 7.8199 9.15998 7.8667C9.24838 7.94825 11.3489 9.8667 14 9.8667C16.651 9.8667 18.7514 7.94825 18.84 7.8667C18.8905 7.8199 18.9308 7.76316 18.9583 7.70006C18.9859 7.63696 19.0001 7.56885 19.0001 7.5C19.0001 7.43115 18.9859 7.36304 18.9583 7.29994C18.9308 7.23684 18.8905 7.18011 18.84 7.1333ZM14 9.5C13.6044 9.5 13.2177 9.3827 12.8888 9.16294C12.5599 8.94318 12.3036 8.63082 12.1522 8.26537C12.0008 7.89992 11.9612 7.49778 12.0384 7.10982C12.1156 6.72186 12.3061 6.36549 12.5858 6.08579C12.8655 5.80608 13.2218 5.6156 13.6098 5.53843C13.9978 5.46126 14.3999 5.50087 14.7653 5.65224C15.1308 5.80362 15.4432 6.05996 15.6629 6.38886C15.8827 6.71776 16 7.10444 16 7.5C15.9994 8.03026 15.7885 8.53865 15.4136 8.9136C15.0386 9.28855 14.5302 9.49945 14 9.5Z", fill: "#FF7575" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_1281_3302" }, /* @__PURE__ */ d.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(6 5)" })))), dL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#ECEFF6" }), /* @__PURE__ */ d.createElement("path", { d: "M8.30133 11.8404C9.33984 12.2229 10.6406 12.47 12.0469 12.5586C13.1663 10.291 15.5027 8.72656 18.1992 8.72656C18.9164 8.72615 19.6292 8.83862 20.3114 9.05984C20.1005 8.51316 19.5155 7.88738 18.1127 7.37234C16.793 6.88473 15.052 6.61719 13.207 6.61719C11.362 6.61719 9.62109 6.88473 8.30133 7.37059C6.39938 8.07125 6 8.97266 6 9.60547C6 10.2383 6.39938 11.1397 8.30133 11.8404Z", fill: "#91A4CC" }), /* @__PURE__ */ d.createElement("path", { d: "M8.30133 16.2349C9.19676 16.5647 10.2873 16.7939 11.4728 16.9071C11.2557 15.8029 11.3132 14.6622 11.6405 13.5855C10.2613 13.4727 8.98195 13.2153 7.93676 12.83C7.13238 12.5336 6.4841 12.1719 6 11.7472V14C6 14.6328 6.39938 15.5342 8.30133 16.2349Z", fill: "#91A4CC" }), /* @__PURE__ */ d.createElement("path", { d: "M11.7811 17.9909C10.3485 17.8855 9.01746 17.6229 7.93676 17.2245C7.13238 16.9282 6.4841 16.5664 6 16.1417V18.3945C6 19.0273 6.39938 19.9288 8.30133 20.6294C9.62109 21.1153 11.362 21.3828 13.207 21.3828C13.6388 21.3828 14.0648 21.3681 14.4814 21.3392C13.2471 20.5399 12.3009 19.3666 11.7811 17.9909Z", fill: "#91A4CC" }), /* @__PURE__ */ d.createElement("path", { d: "M18.1992 9.78125C15 9.78125 12.3984 12.3828 12.3984 15.582C12.3984 18.7812 15 21.3828 18.1992 21.3828C21.3984 21.3828 24 18.7812 24 15.582C24 12.3828 21.3984 9.78125 18.1992 9.78125ZM17.7703 15.0547H18.6281C19.0689 15.0598 19.4906 15.2352 19.805 15.5442C20.1194 15.8532 20.302 16.2719 20.3147 16.7125C20.3275 17.1531 20.1693 17.5816 19.8732 17.9082C19.5772 18.2348 19.1663 18.4343 18.7266 18.4648V18.7461C18.7266 18.886 18.671 19.0201 18.5721 19.119C18.4732 19.2179 18.3391 19.2734 18.1992 19.2734C18.0594 19.2734 17.9252 19.2179 17.8263 19.119C17.7274 19.0201 17.6719 18.886 17.6719 18.7461V18.4691H16.5905C16.4506 18.4691 16.3165 18.4135 16.2176 18.3146C16.1187 18.2157 16.0631 18.0816 16.0631 17.9417C16.0631 17.8019 16.1187 17.6677 16.2176 17.5688C16.3165 17.4699 16.4506 17.4144 16.5905 17.4144H18.6295C18.8026 17.4144 18.9686 17.3456 19.0909 17.2233C19.2133 17.1009 19.282 16.9349 19.282 16.7619C19.282 16.5888 19.2133 16.4229 19.0909 16.3005C18.9686 16.1781 18.8026 16.1094 18.6295 16.1094H17.7703C17.3295 16.1042 16.9078 15.9288 16.5934 15.6198C16.2791 15.3108 16.0964 14.8922 16.0837 14.4516C16.071 14.0109 16.2292 13.5825 16.5252 13.2558C16.8212 12.9292 17.2321 12.7298 17.6719 12.6992V12.418C17.6719 12.2781 17.7274 12.144 17.8263 12.0451C17.9252 11.9462 18.0594 11.8906 18.1992 11.8906C18.3391 11.8906 18.4732 11.9462 18.5721 12.0451C18.671 12.144 18.7266 12.2781 18.7266 12.418V12.695H19.808C19.9478 12.695 20.082 12.7506 20.1809 12.8495C20.2798 12.9484 20.3353 13.0825 20.3353 13.2223C20.3353 13.3622 20.2798 13.4963 20.1809 13.5952C20.082 13.6941 19.9478 13.7497 19.808 13.7497H17.7689C17.5959 13.7497 17.4299 13.8184 17.3075 13.9408C17.1852 14.0632 17.1164 14.2291 17.1164 14.4022C17.1164 14.5752 17.1852 14.7412 17.3075 14.8636C17.4299 14.9859 17.5959 15.0547 17.7689 15.0547H17.7703Z", fill: "#91A4CC" })), pL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#DBFAFC" }), /* @__PURE__ */ d.createElement("path", { d: "M14.5312 14V13.2188H13.4688V14C13.4688 14.2589 13.2589 14.4688 13 14.4688H12.2188V15.5312H13C13.2589 15.5312 13.4688 15.7411 13.4688 16V16.7812H14.5312V16C14.5312 15.7411 14.7411 15.5312 15 15.5312H15.7812V14.4688H15C14.7411 14.4688 14.5312 14.2589 14.5312 14Z", fill: "#74D5C9" }), /* @__PURE__ */ d.createElement("path", { d: "M18.1875 10.75H19C19.2589 10.75 19.4688 10.5401 19.4688 10.2812V8.75C19.4688 8.49112 19.2589 8.28125 19 8.28125H18.1875C17.9286 8.28125 17.7188 8.49112 17.7188 8.75V10.2812C17.7188 10.5401 17.9286 10.75 18.1875 10.75Z", fill: "#74D5C9" }), /* @__PURE__ */ d.createElement("path", { d: "M9 10.75H9.8125C10.0714 10.75 10.2812 10.5401 10.2812 10.2812V8.75C10.2812 8.49112 10.0714 8.28125 9.8125 8.28125H9C8.74112 8.28125 8.53125 8.49112 8.53125 8.75V10.2812C8.53125 10.5401 8.74112 10.75 9 10.75Z", fill: "#74D5C9" }), /* @__PURE__ */ d.createElement("path", { d: "M20.4062 9.03125V10.2812C20.4062 11.0567 19.7754 11.6875 19 11.6875H18.1875C17.4121 11.6875 16.7812 11.0567 16.7812 10.2812V9.03125H15.9688V8.5C15.9688 7.68881 15.3112 7.03125 14.5 7.03125H13.5C12.6888 7.03125 12.0312 7.68881 12.0312 8.5V9.03125H11.2188V10.2812C11.2188 11.0567 10.5879 11.6875 9.8125 11.6875H9C8.22459 11.6875 7.59375 11.0567 7.59375 10.2812V9.03125C6.71353 9.03125 6 9.74478 6 10.625V19.375C6 20.2552 6.71353 20.9688 7.59375 20.9688H20.4062C21.2865 20.9688 22 20.2552 22 19.375V10.625C22 9.74478 21.2865 9.03125 20.4062 9.03125ZM12.9688 8.5C12.9688 8.20706 13.2071 7.96875 13.5 7.96875H14.5C14.7929 7.96875 15.0312 8.20706 15.0312 8.5V9.03125H12.9688V8.5ZM16.7188 16C16.7188 16.2589 16.5089 16.4688 16.25 16.4688H15.4688V17.25C15.4688 17.5089 15.2589 17.7188 15 17.7188H13C12.7411 17.7188 12.5312 17.5089 12.5312 17.25V16.4688H11.75C11.4911 16.4688 11.2812 16.2589 11.2812 16V14C11.2812 13.7411 11.4911 13.5312 11.75 13.5312H12.5312V12.75C12.5312 12.4911 12.7411 12.2812 13 12.2812H15C15.2589 12.2812 15.4688 12.4911 15.4688 12.75V13.5312H16.25C16.5089 13.5312 16.7188 13.7411 16.7188 14V16Z", fill: "#74D5C9" })), fL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#FFDCD4" }), /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_1281_3302)" }, /* @__PURE__ */ d.createElement("path", { d: "M19.9884 7.41052L19.3907 10.9766H20.3968L20.9646 7.5699L19.9884 7.41052Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M6 20.5059C6 21.3298 6.67024 22 7.49414 22H11.4785C12.3024 22 12.9727 21.3298 12.9727 20.5059V18.9453H6V20.5059Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M10.9805 17.4512C10.9805 16.8145 10.2222 15.6482 9.89635 15.1759L9.48633 14.5826L9.0763 15.1759C8.75045 15.6482 7.99219 16.8145 7.99219 17.4512C7.99219 18.2751 8.66243 18.9453 9.48633 18.9453C10.3102 18.9453 10.9805 18.2751 10.9805 17.4512Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M9.98438 13.9648V12.6445C10.6118 11.9361 10.9805 11.0167 10.9805 10.07V9.98047H7.99219V10.07C7.99219 11.0167 8.36088 11.9361 8.98828 12.6445V13.9648H9.98438Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M9.48633 5C8.66243 5 7.99219 5.67024 7.99219 6.49414V7.98828H6.99609V8.98438H11.9766V7.98828H10.9805V6.49414C10.9805 5.67024 10.3102 5 9.48633 5Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M19.4008 16.9531H21.9707V11.9727H23V10.9766H20.3969L19.4008 16.9531Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M14.002 17.9492V20.5059C14.002 21.3326 14.6693 22 15.4961 22H20.4766C21.3034 22 21.9707 21.3326 21.9707 20.5059V17.9492H19.2347L18.9725 19.523L17.9963 19.3637L18.2315 17.9492H14.002Z", fill: "#FF7575" }), /* @__PURE__ */ d.createElement("path", { d: "M12.9727 11.9727H14.002V12.9688H16.9902V13.9648H14.002V14.9609H16.9902V15.957H14.002V16.9531H18.3971L19.3908 10.9766H12.9727V11.9727Z", fill: "#FF7575" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_1281_3302" }, /* @__PURE__ */ d.createElement("rect", { width: 17, height: 17, fill: "white", transform: "translate(6 5)" })))), gL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#ECEFF6" }), /* @__PURE__ */ d.createElement("path", { d: "M19.0001 7.00165V6H11.6669V7.00675H9.63367V10.8078C11.2096 11.4025 12.3335 12.9262 12.3335 14.7077C12.3335 15.6488 11.7122 17.1918 10.4341 19.4248C10.2557 19.7366 10.0768 20.0395 9.90423 20.3254H14.8671V17.2588H15.867V20.3254H20.9999V7.00844L19.0001 7.00165ZM14.767 16.2182H12.8671V15.2183H14.767V16.2182ZM14.767 14.2182H12.8671V13.2183H14.767V14.2182ZM14.767 12.2643H12.8671V11.2644H14.767V12.2643ZM14.767 10.2643H12.8671V9.26437H14.767V10.2643ZM17.867 16.2182H15.9671V15.2183H17.867V16.2182ZM17.867 14.2182H15.9671V13.2183H17.867V14.2182ZM17.867 12.2643H15.9671V11.2644H17.867V12.2643ZM17.867 10.2643H15.9671V9.26437H17.867V10.2643Z", fill: "#91A4CC" }), /* @__PURE__ */ d.createElement("path", { d: "M8.16678 13.7077C7.61534 13.7077 7.16675 14.1563 7.16675 14.7077C7.16675 15.2592 7.61534 15.7078 8.16678 15.7078C8.71821 15.7078 9.16681 15.2592 9.16681 14.7077C9.16681 14.1563 8.71821 13.7077 8.16678 13.7077Z", fill: "#91A4CC" }), /* @__PURE__ */ d.createElement("path", { d: "M8.16681 11.5409C6.42062 11.5409 5 12.9615 5 14.7077C5 16.0611 7.00884 19.4374 8.16681 21.2216C9.32474 19.4371 11.3336 16.0603 11.3336 14.7077C11.3336 12.9615 9.91302 11.5409 8.16681 11.5409ZM8.16684 16.7076C7.06406 16.7076 6.1669 15.8105 6.1669 14.7077C6.1669 13.6049 7.06406 12.7078 8.16684 12.7078C9.26962 12.7078 10.1668 13.6049 10.1668 14.7077C10.1668 15.8105 9.26962 16.7076 8.16684 16.7076Z", fill: "#91A4CC" })), mL = (e) => /* @__PURE__ */ d.createElement("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#EDF2FF" }), /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_1281_3302)" }, /* @__PURE__ */ d.createElement("path", { d: "M22.1877 8.40448H6.81226C6.36374 8.40448 6 8.76822 6 9.21674V19.7833C6 20.2318 6.36374 20.5955 6.81226 20.5955H22.1877C22.6363 20.5955 23 20.2318 23 19.7833V9.21674C23 8.76822 22.6363 8.40448 22.1877 8.40448ZM9.40377 12.3779C9.45669 11.4333 10.2654 10.7103 11.2099 10.7632C12.1545 10.8161 12.8775 11.6248 12.8246 12.5694C12.7717 13.5139 11.963 14.2369 11.0184 14.184C10.0738 14.1311 9.35084 13.3224 9.40377 12.3779ZM13.7817 17.5712H8.44664V15.9404C8.44664 15.5426 8.69287 15.186 9.06469 15.0447L10.1627 14.6285H10.2645C10.5152 14.772 10.8045 14.855 11.1139 14.855C11.4234 14.855 11.7127 14.772 11.9634 14.6285H12.0652L13.1632 15.0447C13.5355 15.186 13.7813 15.5426 13.7813 15.9404V17.5712H13.7817ZM19.3182 15.9803H16.4445C16.2458 15.9803 16.0844 15.8189 16.0844 15.6202C16.0844 15.4215 16.2454 15.26 16.4445 15.26H19.3182C19.5168 15.26 19.6783 15.4215 19.6783 15.6202C19.6783 15.8189 19.5173 15.9803 19.3182 15.9803ZM20.6978 13.9961H16.4445C16.2458 13.9961 16.0844 13.8346 16.0844 13.6359C16.0844 13.4372 16.2454 13.2758 16.4445 13.2758H20.6978C20.8965 13.2758 21.0579 13.4372 21.0579 13.6359C21.0579 13.8346 20.8969 13.9961 20.6978 13.9961Z", fill: "#66AEED" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_1281_3302" }, /* @__PURE__ */ d.createElement("rect", { width: 17, height: 17, fill: "white", transform: "translate(6 6)" })))), hL = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "#fce7ed" }), /* @__PURE__ */ d.createElement("path", { d: "M19.764,7.227c-1.647,-1.647 -4.326,-1.647 -5.973,-0l-3.483,3.482l3.954,3.954c0.814,-0.678 1.845,-1.102 2.985,-1.102c0.653,-0 1.275,0.136 1.841,0.378l0.676,-0.739c1.647,-1.647 1.647,-4.326 0,-5.973Z", fill: "#f3a3b1", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M13.604,15.332l-3.96,-3.959l-3.408,3.411c-1.647,1.647 -1.647,4.327 -0,5.974c1.647,1.646 4.358,1.677 6.005,0.031l0.691,-0.694c-0.243,-0.566 -0.378,-1.188 -0.378,-1.841c-0,-1.11 0.403,-2.118 1.05,-2.922Z", fill: "#f3a3b1", fillRule: "nonzero" }), /* @__PURE__ */ d.createElement("path", { d: "M17.139,14.45c1.952,0 3.536,1.585 3.536,3.536c-0,1.951 -1.584,3.535 -3.536,3.535c-1.951,0 -3.535,-1.584 -3.535,-3.535c-0,-1.951 1.584,-3.536 3.535,-3.536Zm0.505,3.837l0,-2.042c0,-0.176 -0.143,-0.319 -0.319,-0.319c-0.176,-0 -0.319,0.143 -0.319,0.319l0,1.844l-1.525,0.763c-0.157,0.079 -0.221,0.27 -0.142,0.428c0.079,0.158 0.27,0.221 0.428,0.142l1.701,-0.85c0.108,-0.054 0.176,-0.165 0.176,-0.285Z", fill: "#f3a3b1" })), vL = {
  ConditionEra: eL,
  ConditionOccurrence: tL,
  Death: nL,
  Demographic: oL,
  DeviceExposure: rL,
  DoseEra: iL,
  DrugEra: hL,
  DrugExposure: sL,
  LocationRegion: aL,
  Observation: cL,
  Measurement: lL,
  ObservationPeriod: uL,
  PayerPlanPeriod: dL,
  ProcedureOccurrence: pL,
  Specimen: fL,
  VisitOccurrence: gL,
  VisitDetail: mL
}, tz = ({
  iconName: e,
  iconStatus: t,
  plain: n = !1,
  ref: r,
  ...i
}) => {
  const s = vL[e] || (() => /* @__PURE__ */ p.jsx(p.Fragment, {}));
  return /* @__PURE__ */ p.jsx(or, { ...i, ref: r, inheritViewBox: !0, children: /* @__PURE__ */ p.jsx(
    s,
    {
      ...t ? { iconStatus: t } : {},
      ...n ? { plain: n } : {},
      color: i.color,
      ...i.width ? {
        width: i.width,
        height: i.height
      } : {}
    }
  ) });
}, yL = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 30 28", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("g", null, /* @__PURE__ */ d.createElement("path", { d: "M5.241,11.533c0.489,0.536 0.787,1.249 0.787,2.031c0,1.664 -1.35,3.014 -3.014,3.014c-1.663,0 -3.014,-1.35 -3.014,-3.014c0,-1.664 1.351,-3.014 3.014,-3.014c0.336,-0 0.659,0.055 0.961,0.156l4.35,-5.659c-0.49,-0.536 -0.789,-1.25 -0.789,-2.033c-0,-1.663 1.35,-3.014 3.014,-3.014c1.663,-0 3.014,1.351 3.014,3.014c0,0.703 -0.241,1.351 -0.645,1.863l4.285,5.804c0.279,-0.085 0.575,-0.131 0.881,-0.131c1.664,-0 3.015,1.35 3.015,3.014c-0,0.764 -0.285,1.461 -0.754,1.993l4.387,5.676c0.281,-0.087 0.579,-0.133 0.888,-0.133c1.664,-0 3.014,1.35 3.014,3.014c0,1.663 -1.35,3.014 -3.014,3.014c-1.664,0 -3.014,-1.351 -3.014,-3.014c-0,-0.808 0.319,-1.543 0.837,-2.084l-4.348,-5.626c-0.316,0.113 -0.656,0.174 -1.011,0.174c-0.366,0 -0.716,-0.065 -1.041,-0.185l-4.369,5.584c0.549,0.546 0.889,1.302 0.889,2.137c0,1.663 -1.351,3.014 -3.014,3.014c-1.664,0 -3.014,-1.351 -3.014,-3.014c-0,-1.664 1.35,-3.014 3.014,-3.014c0.281,-0 0.553,0.038 0.812,0.11l4.442,-5.677c-0.457,-0.529 -0.733,-1.217 -0.733,-1.969c0,-0.812 0.322,-1.549 0.844,-2.091l-4.194,-5.681c-0.36,0.152 -0.756,0.236 -1.171,0.236c-0.335,0 -0.657,-0.054 -0.958,-0.155l-4.351,5.66Zm20.38,11.074c-0.832,-0 -1.507,0.675 -1.507,1.507c-0,0.832 0.675,1.507 1.507,1.507c0.832,-0 1.507,-0.675 1.507,-1.507c0,-0.832 -0.675,-1.507 -1.507,-1.507Zm-15.071,-0c-0.832,-0 -1.507,0.675 -1.507,1.507c-0,0.832 0.675,1.507 1.507,1.507c0.832,-0 1.507,-0.675 1.507,-1.507c-0,-0.832 -0.675,-1.507 -1.507,-1.507Zm7.535,-10.55c-0.831,-0 -1.507,0.675 -1.507,1.507c0,0.832 0.676,1.507 1.507,1.507c0.832,0 1.508,-0.675 1.508,-1.507c-0,-0.832 -0.676,-1.507 -1.508,-1.507Z", fill: "#234589" })), /* @__PURE__ */ d.createElement("path", { d: "M18.085,20.452l-10.692,6.873l-1.222,-1.901l9.824,-6.316l-8.317,-5.347l1.222,-1.901l9.185,5.904l9.185,-5.904l1.223,1.901l-8.317,5.347l9.824,6.316l-1.222,1.901l-10.693,-6.873Z", fill: "#f33" }))), bL = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 30 29", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M23.053,25.588l-16.106,0c0.073,-0.282 0.112,-0.577 0.112,-0.882c-0,-0.305 -0.039,-0.6 -0.112,-0.882l16.106,-0c-0.073,0.282 -0.112,0.577 -0.112,0.882c0,0.305 0.039,0.6 0.112,0.882Z", fill: "#808080" }), /* @__PURE__ */ d.createElement("path", { d: "M6.948,13.238c7.923,0.062 13.492,1.082 16.722,2.978c2.207,1.295 3.403,2.993 3.639,5.061c-0.269,-0.066 -0.549,-0.101 -0.838,-0.101c-0.326,0 -0.642,0.045 -0.942,0.128c-0.308,-1.926 -1.83,-3.353 -4.453,-4.379c-3.181,-1.245 -7.892,-1.875 -14.129,-1.922c0.073,-0.283 0.112,-0.58 0.112,-0.885c-0,-0.304 -0.039,-0.599 -0.111,-0.88Z", fill: "#808080" }), /* @__PURE__ */ d.createElement("path", { d: "M6.947,4.415c-0.393,1.52 -1.775,2.644 -3.418,2.644c-1.948,-0 -3.529,-1.582 -3.529,-3.53c0,-1.948 1.581,-3.529 3.529,-3.529c1.645,0 3.028,1.127 3.419,2.65c0.072,0.281 0.111,0.576 0.111,0.879c-0,0.306 -0.039,0.603 -0.112,0.886Z", fill: "#fb4242" }), /* @__PURE__ */ d.createElement("path", { d: "M6.947,25.588c-0.392,1.522 -1.774,2.647 -3.418,2.647c-1.948,0 -3.529,-1.581 -3.529,-3.529c0,-1.948 1.581,-3.53 3.529,-3.53c1.644,0 3.026,1.126 3.418,2.648c0.073,0.282 0.112,0.577 0.112,0.882c-0,0.305 -0.039,0.6 -0.112,0.882Z", fill: "#fb4242" }), /* @__PURE__ */ d.createElement("path", { d: "M6.947,15.003c-0.394,1.52 -1.775,2.644 -3.418,2.644c-1.948,0 -3.529,-1.581 -3.529,-3.529c0,-1.948 1.581,-3.53 3.529,-3.53c1.645,0 3.028,1.127 3.419,2.65c0.072,0.281 0.111,0.576 0.111,0.88c-0,0.305 -0.039,0.602 -0.112,0.885Z", fill: "#fb4242" }), /* @__PURE__ */ d.createElement("path", { d: "M27.309,21.277c1.544,0.377 2.691,1.77 2.691,3.429c0,1.948 -1.581,3.529 -3.529,3.529c-1.644,0 -3.026,-1.125 -3.418,-2.647c-0.073,-0.282 -0.112,-0.577 -0.112,-0.882c0,-0.305 0.039,-0.6 0.112,-0.882c0.314,-1.22 1.265,-2.186 2.476,-2.52c0.3,-0.083 0.616,-0.128 0.942,-0.128c0.289,0 0.569,0.035 0.838,0.101Z", fill: "#234589" }), /* @__PURE__ */ d.createElement("path", { d: "M6.948,2.65l16.089,0.059c-0.063,0.263 -0.096,0.538 -0.096,0.82c0,0.328 0.045,0.644 0.128,0.945l-16.122,-0.059c0.073,-0.283 0.112,-0.58 0.112,-0.886c-0,-0.303 -0.039,-0.598 -0.111,-0.879Z", fill: "#808080" }), /* @__PURE__ */ d.createElement("path", { d: "M23.069,4.474c-0.083,-0.301 -0.128,-0.617 -0.128,-0.945c0,-0.282 0.033,-0.557 0.096,-0.82c0.37,-1.553 1.768,-2.709 3.434,-2.709c1.948,0 3.529,1.581 3.529,3.529c0,1.948 -1.581,3.53 -3.529,3.53c-1.621,-0 -2.988,-1.095 -3.402,-2.585Z", fill: "#234589" })), CL = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 30 29", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M20.007,17.186c-0.332,0.118 -0.688,0.182 -1.06,0.182c-0.383,0 -0.751,-0.068 -1.091,-0.193l-4.577,5.85c0.575,0.572 0.932,1.364 0.932,2.238c-0,1.743 -1.415,3.158 -3.158,3.158c-1.743,0 -3.158,-1.415 -3.158,-3.158c-0,-1.743 1.415,-3.158 3.158,-3.158c0.294,0 0.58,0.041 0.85,0.116l4.654,-5.948c-0.478,-0.553 -0.768,-1.274 -0.768,-2.062c0,-0.851 0.337,-1.623 0.885,-2.191l-4.395,-5.952c-0.377,0.16 -0.791,0.248 -1.226,0.248c-0.351,-0 -0.689,-0.058 -1.004,-0.163l-4.559,5.93c0.513,0.561 0.826,1.308 0.826,2.128c-0,1.742 -1.415,3.157 -3.158,3.157c-1.743,0 -3.158,-1.415 -3.158,-3.157c-0,-1.743 1.415,-3.158 3.158,-3.158c0.352,-0 0.69,0.057 1.007,0.164l4.557,-5.929c-0.514,-0.562 -0.827,-1.31 -0.827,-2.13c-0,-1.743 1.415,-3.158 3.158,-3.158c1.743,0 3.158,1.415 3.158,3.158c-0,0.737 -0.253,1.415 -0.677,1.952l4.49,6.08c0.292,-0.089 0.602,-0.137 0.923,-0.137c1.743,-0 3.158,1.415 3.158,3.158c0,0.8 -0.298,1.531 -0.789,2.087l4.596,5.947c0.294,-0.091 0.606,-0.14 0.93,-0.14c1.743,0 3.158,1.415 3.158,3.158c-0,1.743 -1.415,3.158 -3.158,3.158c-1.743,0 -3.158,-1.415 -3.158,-3.158c0,-0.847 0.334,-1.616 0.878,-2.183l-4.555,-5.894Z", fill: "#234589" })), xL = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 30 29", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, ...e }, /* @__PURE__ */ d.createElement("path", { d: "M5.49,12.083c0.513,0.561 0.826,1.308 0.826,2.128c-0,1.742 -1.415,3.157 -3.158,3.157c-1.743,0 -3.158,-1.415 -3.158,-3.157c-0,-1.743 1.415,-3.158 3.158,-3.158c0.352,-0 0.69,0.057 1.007,0.164l4.557,-5.929c-0.514,-0.562 -0.827,-1.31 -0.827,-2.13c-0,-1.743 1.415,-3.158 3.158,-3.158c1.743,-0 3.158,1.415 3.158,3.158c-0,0.737 -0.253,1.415 -0.677,1.952l4.49,6.08c0.292,-0.089 0.602,-0.137 0.923,-0.137c1.743,-0 3.158,1.415 3.158,3.158c0,0.795 -0.295,1.523 -0.781,2.079l4.589,5.954c0.294,-0.09 0.606,-0.139 0.929,-0.139c1.743,0 3.158,1.415 3.158,3.158c-0,1.743 -1.415,3.158 -3.158,3.158c-1.743,0 -3.158,-1.415 -3.158,-3.158c0,-0.847 0.335,-1.617 0.878,-2.184l-4.544,-5.897c-0.334,0.121 -0.695,0.186 -1.071,0.186c-0.383,0 -0.751,-0.068 -1.091,-0.193l-4.577,5.85c0.575,0.572 0.932,1.364 0.932,2.238c-0,1.743 -1.415,3.158 -3.158,3.158c-1.743,0 -3.158,-1.415 -3.158,-3.158c-0,-1.743 1.415,-3.158 3.158,-3.158c0.294,0 0.58,0.041 0.85,0.116l4.654,-5.948c-0.478,-0.553 -0.768,-1.274 -0.768,-2.062c0,-0.851 0.337,-1.623 0.885,-2.191l-4.395,-5.952c-0.377,0.16 -0.791,0.248 -1.226,0.248c-0.351,-0 -0.689,-0.058 -1.004,-0.163l-4.559,5.93Z", fill: "#fb4242" })), wL = {
  Exclude: yL,
  Mapped: bL,
  Descendants: CL,
  Hierarchy: xL
}, SL = ({
  iconName: e,
  ref: t,
  ...n
}) => {
  const r = wL[e] || (() => /* @__PURE__ */ p.jsx(p.Fragment, {}));
  return /* @__PURE__ */ p.jsx(or, { ...n, ref: t, inheritViewBox: !0, children: /* @__PURE__ */ p.jsx(
    r,
    {
      color: n.color,
      ...n.width ? {
        width: n.width,
        height: n.height
      } : {}
    }
  ) });
}, EL = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 640", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z" })), RL = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 640", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M128 480C110.3 480 96 494.3 96 512C96 529.7 110.3 544 128 544C145.7 544 160 529.7 160 512C160 494.3 145.7 480 128 480zM256 96C238.3 96 224 110.3 224 128C224 145.7 238.3 160 256 160C273.7 160 288 145.7 288 128C288 110.3 273.7 96 256 96zM384 480C366.3 480 352 494.3 352 512C352 529.7 366.3 544 384 544C401.7 544 416 529.7 416 512C416 494.3 401.7 480 384 480zM256 544C273.7 544 288 529.7 288 512C288 494.3 273.7 480 256 480C238.3 480 224 494.3 224 512C224 529.7 238.3 544 256 544zM384 96C366.3 96 352 110.3 352 128C352 145.7 366.3 160 384 160C401.7 160 416 145.7 416 128C416 110.3 401.7 96 384 96zM512 544C529.7 544 544 529.7 544 512C544 494.3 529.7 480 512 480C494.3 480 480 494.3 480 512C480 529.7 494.3 544 512 544zM512 160C529.7 160 544 145.7 544 128C544 110.3 529.7 96 512 96C494.3 96 480 110.3 480 128C480 145.7 494.3 160 512 160zM128 96C110.3 96 96 110.3 96 128C96 145.7 110.3 160 128 160C145.7 160 160 145.7 160 128C160 110.3 145.7 96 128 96zM512 416C529.7 416 544 401.7 544 384C544 366.3 529.7 352 512 352C494.3 352 480 366.3 480 384C480 401.7 494.3 416 512 416zM128 224C110.3 224 96 238.3 96 256C96 273.7 110.3 288 128 288C145.7 288 160 273.7 160 256C160 238.3 145.7 224 128 224zM128 416C145.7 416 160 401.7 160 384C160 366.3 145.7 352 128 352C110.3 352 96 366.3 96 384C96 401.7 110.3 416 128 416zM512 224C494.3 224 480 238.3 480 256C480 273.7 494.3 288 512 288C529.7 288 544 273.7 544 256C544 238.3 529.7 224 512 224z" })), TL = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 640", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" })), ML = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ d.createElement("path", { fill: "currentColor", d: "M0 256c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z" })), kL = {
  check: EL,
  border: RL,
  cross: TL,
  minus: ML
}, nz = ({
  iconName: e,
  iconStatus: t,
  ref: n,
  ...r
}) => {
  const i = kL[e] || (() => /* @__PURE__ */ p.jsx(p.Fragment, {}));
  return /* @__PURE__ */ p.jsx(or, { ...r, ref: n, inheritViewBox: !0, component: i });
}, oz = H$, Eh = (e) => {
  const {
    text: t,
    color: n,
    light: r,
    iconName: i,
    iconSize: s,
    minWidth: a,
    action: l = !1,
    align: c
  } = e;
  return /* @__PURE__ */ p.jsxs(
    QV,
    {
      color: n,
      light: r,
      className: "status-tag",
      minWidth: a,
      action: l,
      align: c,
      children: [
        i && /* @__PURE__ */ p.jsx(qn, { iconName: i, sx: { fontSize: s || 16, mr: 0.75 } }),
        t
      ]
    }
  );
}, rz = (e) => {
  const { text: t, iconName: n, iconSize: r, minWidth: i = 0, tooltipText: s } = e;
  return /* @__PURE__ */ p.jsx(wc, { text: s, children: /* @__PURE__ */ p.jsxs(JV, { className: "status-tag", minWidth: i, children: [
    n && /* @__PURE__ */ p.jsx(
      J$,
      {
        name: n,
        sx: { fontSize: r || 22, mr: t ? 0.75 : 0 }
      }
    ),
    t || ""
  ] }) });
}, PL = Z(Og)`
  width: ${({ size: e }) => e === "small" ? 30 : 44}px;
  height: ${({ size: e }) => e === "small" ? 16 : 24}px;
  padding: 0;
  .switch {
    &-base {
      padding: 2px;
      color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette.grey) == null ? void 0 : t[500]) || "#9e9e9e";
}};
      opacity: 1;
      &.switch-checked {
        transform: translateX(14px);
        color: ${({ theme: e, color: t }) => e.palette[t || "primary"].main};
        & + .switch-track {
          background-color: ${({ theme: e, color: t }) => e.palette[t || "primary"].main};
          border-color: ${({ theme: e, color: t }) => e.palette[t || "primary"].main};
        }
      }
    }
    &-thumb {
      width: ${({ size: e }) => e === "small" ? 12 : 22}px;
      height: ${({ size: e }) => e === "small" ? 12 : 22}px;
      box-shadow: none;
    }
    &-track {
      height: calc(100% - 2px);
      border-radius: 13px;
      background-color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette) == null ? void 0 : t.backgroundColor.main) || "grey";
}};
      border: 1px solid
        ${({ theme: e }) => Jn(0.2, e.palette.borderColor.main)};
      opacity: 1;
    }
    &-small {
    }
  }
  &.square {
    .switch {
      &-base {
        padding: 2px;
      }
      &-track {
        border-radius: 3px;
      }
      &-thumb {
        width: ${({ size: e }) => e == "small" ? 16 : 22}px;
        height: ${({ size: e }) => e == "small" ? 16 : 22}px;
        border-radius: 2px;
        box-shadow: none;
      }
    }
  }
`, IL = (e) => /* @__PURE__ */ p.jsx(
  PL,
  {
    id: e.id,
    className: xe(e.className, e.type),
    focusVisibleClassName: xe("c-switch", e.className),
    disableRipple: !0,
    classes: {
      root: "switch-root",
      switchBase: xe("switch-base", {
        "switch-base-small": e.size === "small"
      }),
      thumb: "switch-thumb",
      track: "switch-track",
      checked: "switch-checked"
    },
    size: e.size,
    checked: e.checked,
    disabled: e.disabled,
    onChange: (t) => e.onChange && e.onChange(t),
    required: e.required,
    value: e.value,
    color: e.color || "primary",
    name: e.name
  }
), OL = Z(xg)`
  padding: 0;
  &.radio {
    &-checked {
      color: ${({ theme: e, color: t }) => $s(e)(0.6, t)};
    }
    &-disabled {
      color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette) == null ? void 0 : t.action.disabledBackground) || "lightgrey";
}};
    }
  }
`, DL = (e) => {
  const {
    value: t,
    checked: n,
    onChange: r,
    name: i = "radio",
    size: s = "medium",
    disabled: a,
    required: l,
    color: c = "primary",
    className: u = "",
    sx: f
  } = e;
  return /* @__PURE__ */ p.jsx(
    OL,
    {
      name: i,
      disableRipple: !0,
      checked: n,
      onChange: r,
      inputProps: { "aria-label": "radio" },
      size: s,
      disabled: a,
      required: l,
      color: c,
      value: t,
      className: u + " c-radio",
      classes: {
        root: "radio-root",
        checked: "radio-checked",
        disabled: "radio-disabled"
      },
      sx: f
    }
  );
}, jL = Z("div")`
  font-family: ${({ theme: e }) => {
  var t;
  return ((t = e.typography) == null ? void 0 : t.fontFamily) || "sans-serif";
}};
  font-weight: ${({ theme: e }) => {
  var t;
  return ((t = e.typography) == null ? void 0 : t.fontWeightLight) || 300;
}};
  .c-filter-panel {
    padding-bottom: 8px;
    /* border-bottom: 1px solid ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.borderColor.light;
}}; */
  }
  .filter-block__head {
    font-size: 12px;
    padding: 8px 0;
    font-weight: 700;
    background-color: transparent;
    border-bottom: none;
  }

  width: 100%;

  &.dense {
    width: 240px;
    .backdrop {
      padding: 0;
    }

    .c-filter-panel {
      padding-bottom: 12px;
    }
    .filter-block__head {
      padding: 4px 0;
    }
    .filter-block__option {
      font-size: 13px;
      padding: 0 5px;
      .checkbox-root {
        padding: 0 5px;
      }
    }
    .filter-block__content {
      padding: 5px 0;
      background-color: transparent;
      .filter-block__option {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-right: 5px;
        :hover {
          background-color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.secondary.main;
}};
        }
      }
    }
  }
`, Bi = Z("div")`
  display: flex;
  flex-direction: column;
  margin-top: 0px;

  .search-field__container {
    padding: 5px 10px;
  }
  span.c-checkbox {
    padding: 2px 5px 2px 2px;
  }
  &.c-switch-item {
    padding: 8px 0;
    margin-top: 0;
  }
  & .filter-block__head {
    font-weight: 500;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
    /* text-transform: uppercase; */
    padding: 8px 0;

    font-weight: bold;
    border-radius: 4px;

    &:hover {
      cursor: pointer;
    }
    .filter-block__head-title {
      display: flex;
      justify-content: flex-start;
      line-height: 18px;
      .filter-block__head-icon {
        margin-right: 5px;
        color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[800];
}};
      }
    }
  }
  & .filter-block__content {
    max-height: auto;
    height: auto;
    overflow-y: initial;
    /* padding: 5px 5px 0; */
  }

  .filter-block__option span {
    line-height: 24px;
  }
`, Bf = Z("label")`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[800];
}};
  & .switch-item-label {
    padding: 0 8px;
    font-size: 14px;
    font-weight: 400;
  }
  &.switch-item-wrapper {
    /* background-color: #eff2f8; */
    border-radius: 4px;
    padding: 0;
  }
`, FL = Z("div")`
  display: flex;
  & > div:first-child {
    margin-right: 10px;
  }
  & > div:last-child {
    margin-left: 10px;
  }
`, VL = Z(ii)`
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[500];
}};

  &[class*='MuiCheckbox-root'] {
    padding: 5px;
  }
`, $L = Z(DL)`
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[500];
}};
  padding: 5px 5px 5px 0;
`;
Z("div")`
  text-align: center;
  padding: 0px;
`;
const Rh = Z("div")`
  /* background-color: ${({ theme: e }) => e.palette && e.palette.grey[200] || "lightgrey"}; */
  border-radius: 10px;
  padding: 2px 10px;
  margin-left: 10px;
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 400;
  min-width: 15px;
  text-align: center;
`, LL = Z("div")`
  padding: 0 5px 8px;
  .input .input-root.input-small {
    padding-left: 0;
    .input-base {
      font-size: 14px;
    }
  }
`, AL = Z(of)`
  .input-notched-outline {
    border-left: none;
    border-right: none;
    border-top: none;
  }
  &.input {
    background-color: transparent;
    .input-root:hover,
    .input-focused {
      .input-notched-outline {
        border-left: none;
        border-right: none;
        border-top: none;
      }
    }
  }
`, R5 = Z("button")`
  cursor: pointer;
  background-color: transparent;
  border: none;
  min-width: auto !important;
  &:hover {
    background-color: ${(e) => {
  var t;
  return Jn(0.85, (t = e.theme.palette) == null ? void 0 : t.secondary.main);
}};
  }
`, NL = Z(Ia)(
  ({ theme: e }) => ({
    height: 18,
    borderRadius: 4,
    fontSize: 10,
    fontWeight: 500,
    color: e.palette.textColor.secondary,
    backgroundColor: Jn(0.9, e.palette.info.main),
    ".MuiChip-label": {
      py: 0.5,
      px: 1
    }
  })
), BL = (e) => {
  const { name: t, value: n, label: r, options: i, className: s, onChange: a, showLabel: l } = e, [c, u] = He.useState(""), [f, g] = He.useState(i), h = (v) => (m) => {
    const b = m.indexOf(v);
    return b > -1 ? [...m.slice(0, b), ...m.slice(b + 1)] : [...m, v];
  };
  Rn(() => (g(
    c ? i.filter(
      (v) => v.name.toLowerCase().includes(c.toLowerCase())
    ) : i
  ), () => {
    g([]);
  }), [c]);
  const y = (v) => () => a((v.onChange || h(v.value))(n));
  return /* @__PURE__ */ p.jsxs(Bi, { className: s + " c-checkbox-item", children: [
    l && /* @__PURE__ */ p.jsx("label", { className: "filter-block__head", children: r }),
    /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      i.length > 5 && /* @__PURE__ */ p.jsx(LL, { className: "search-field__container", children: /* @__PURE__ */ p.jsx(
        AL,
        {
          type: "text",
          value: c,
          size: "small",
          fullWidth: !0,
          placeholder: "Search...",
          onChange: (v) => u(v.target.value)
        }
      ) }),
      /* @__PURE__ */ p.jsx("div", { className: "filter-block__content", children: f != null && f.length ? f.map((v) => {
        var m;
        return /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsxs(Bf, { children: [
          /* @__PURE__ */ p.jsxs("div", { className: "filter-block__option", children: [
            /* @__PURE__ */ p.jsx(
              VL,
              {
                checked: (m = v.active) == null ? void 0 : m.call(v, n),
                value: v.value,
                onChange: y(v),
                size: "small"
              }
            ),
            v.color != null ? /* @__PURE__ */ p.jsx(Eh, { text: v.name, color: v.color }) : /* @__PURE__ */ p.jsx("span", { children: v.name })
          ] }),
          v.tag != null && /* @__PURE__ */ p.jsx(Rh, { children: v.tag })
        ] }) }, t + "_" + v.name + "_" + v.value);
      }) : /* @__PURE__ */ p.jsx(
        ko,
        {
          sx: {
            color: "lightgrey",
            fontSize: "14px",
            textAlign: "center"
          },
          children: "List is empty"
        }
      ) })
    ] })
  ] });
}, _L = (e) => {
  const { value: t, onChange: n, label: r, className: i, classes: s, name: a, showLabel: l } = e, [c, u] = He.useState(
    t || {
      startDate: null,
      endDate: null
    }
  ), f = (g) => (h) => {
    u({ ...c, [g]: h }), n({ ...c, [g]: h });
  };
  return /* @__PURE__ */ p.jsxs(Bi, { className: i + " c-date-range-item", children: [
    l && /* @__PURE__ */ p.jsx("label", { className: "filter-block__head", children: r }),
    /* @__PURE__ */ p.jsxs(FL, { children: [
      /* @__PURE__ */ p.jsx(
        tp,
        {
          value: c.startDate || null,
          onChange: f("startDate"),
          fullWidth: !1,
          size: "medium",
          maxDate: c.endDate
        }
      ),
      "_",
      /* @__PURE__ */ p.jsx(
        tp,
        {
          value: c.endDate || null,
          onChange: f("endDate"),
          fullWidth: !1,
          size: "medium",
          minDate: c.startDate
        }
      )
    ] })
  ] });
};
function _f(e) {
  return /* @__PURE__ */ p.jsx(_r, { title: e.tooltipTitle, arrow: !0, placement: "top", children: /* @__PURE__ */ p.jsx(ko, { sx: { display: "inline-block" }, children: /* @__PURE__ */ p.jsxs(
    gh,
    {
      variant: e.variant || "text",
      startIcon: e.startIcon,
      title: e.title,
      fullWidth: !1,
      placement: "top-start",
      disabled: e.disabled,
      sx: (t) => ({
        minWidth: "0",
        px: 1,
        bgcolor: Kr(0.05, t.palette.backgroundColor.light),
        "&:hover": {
          bgcolor: Kr(0.1, t.palette.backgroundColor.dark)
        },
        ...e.sx
      }),
      preventOverflow: !0,
      disablePortal: !1,
      children: [
        e.canSelectAll && /* @__PURE__ */ p.jsxs(xr, { sx: { p: 0, fontSize: "14px" }, children: [
          /* @__PURE__ */ p.jsxs(
            vo,
            {
              component: "label",
              variant: "body1",
              sx: {
                fontWeight: 300,
                display: "flex",
                alignItems: "center",
                width: "100%",
                padding: "2px 8px",
                fontSize: 13
              },
              children: [
                /* @__PURE__ */ p.jsx(
                  ii,
                  {
                    size: "small",
                    checked: e.selectAllOption.checked,
                    onChange: e.selectAllOption.onChange,
                    indeterminate: e.selectAllOption.indeterminate,
                    sx: { svg: { fontSize: 18 } }
                  }
                ),
                /* @__PURE__ */ p.jsx(ko, { sx: { marginLeft: "8px" }, children: e.selectAllOption.title || "Select All" })
              ]
            }
          ),
          /* @__PURE__ */ p.jsx(
            Gl,
            {
              sx: {
                "&.MuiDivider-root": {
                  margin: 0,
                  borderColor: "borderColor.light"
                }
              }
            }
          )
        ] }, "select-all"),
        e.options.map((t) => {
          var n;
          return /* @__PURE__ */ p.jsx(
            xr,
            {
              sx: {
                p: 0,
                fontSize: "14px"
              },
              children: /* @__PURE__ */ p.jsxs(
                ko,
                {
                  component: "label",
                  sx: {
                    fontWeight: 300,
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    padding: "2px 8px"
                  },
                  children: [
                    /* @__PURE__ */ p.jsx(
                      ii,
                      {
                        size: "small",
                        checked: t.checked,
                        onChange: t.onChange,
                        sx: { svg: { fontSize: 18 } }
                      }
                    ),
                    /* @__PURE__ */ p.jsx(ko, { sx: { marginLeft: "8px" }, children: t.value })
                  ]
                }
              )
            },
            Array.isArray(t.id) ? (n = t.id) == null ? void 0 : n.join("") : t.id
          );
        })
      ]
    }
  ) }) });
}
const Th = (e) => {
  var h;
  const {
    value: t,
    onChange: n,
    inputType: r,
    className: i,
    parseFilter: s = (y) => y
  } = e, a = No(
    () => typeof t == "string" ? t : t == null ? void 0 : t.join(" "),
    [t]
  ), [l, c] = So(a || ""), u = (y, v) => {
    e.extendedSearchEnabled ? e.toggleExtendedSearch(v, s(y)) : n(s(y));
  }, f = (y) => {
    y.preventDefault(), u(l, e.extendedSearchValue);
  }, g = (y) => {
    y.preventDefault(), c(""), u("", !1);
  };
  return /* @__PURE__ */ p.jsx(Bi, { className: i + " c-input-item", children: /* @__PURE__ */ p.jsx(
    "form",
    {
      onSubmit: f,
      className: "filter-block__content filter-block__search-content",
      children: /* @__PURE__ */ p.jsxs(
        zp,
        {
          fullWidth: !0,
          sx: e.extendedSearchEnabled && {
            "& div:first-child": {
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0
            }
          },
          children: [
            /* @__PURE__ */ p.jsx(
              of,
              {
                type: r || "text",
                value: l,
                onChange: (y) => {
                  c(y.target.value);
                },
                fullWidth: !0,
                size: "medium",
                placeholder: "Filter search...",
                name: r || "textFilter",
                className: "filter-panel__search",
                InputProps: {
                  endAdornment: /* @__PURE__ */ p.jsxs(jd, { position: "end", sx: { mr: -1 }, children: [
                    l && /* @__PURE__ */ p.jsx(R5, { type: "reset", onClick: g, children: /* @__PURE__ */ p.jsx(
                      qn,
                      {
                        iconName: "deactivate",
                        name: "reset",
                        sx: { fontSize: 16, pt: 0.2 },
                        color: "primary"
                      }
                    ) }),
                    /* @__PURE__ */ p.jsx(R5, { type: "submit", children: /* @__PURE__ */ p.jsx(
                      qn,
                      {
                        iconName: "search",
                        name: "search",
                        sx: { fontSize: 18, pt: 0.2 },
                        color: "primary"
                      }
                    ) })
                  ] })
                }
              }
            ),
            e.extendedSearchEnabled && /* @__PURE__ */ p.jsx(
              _f,
              {
                title: /* @__PURE__ */ p.jsx(
                  Np,
                  {
                    badgeContent: e.extendedSearchValue ? " " : 0,
                    color: "warning",
                    anchorOrigin: {
                      vertical: "top",
                      horizontal: "right"
                    },
                    variant: "dot",
                    children: /* @__PURE__ */ p.jsx(qn, { iconName: "sliders", sx: { fontSize: 16 } })
                  }
                ),
                tooltipTitle: "Settings",
                variant: "outlined",
                sx: {
                  width: 36,
                  borderColor: "#c3cad2 !important",
                  height: "100%"
                },
                disabled: !((h = l == null ? void 0 : l.trim()) != null && h.length),
                options: [
                  {
                    id: "search-scope",
                    checked: e.extendedSearchValue,
                    onChange: (y, v) => {
                      e.toggleExtendedSearch(v, s(l));
                    },
                    value: "Extended search"
                  }
                ]
              }
            )
          ]
        }
      )
    }
  ) });
}, Mh = Z(Ia)`
  &.chip {
    height: 28px;
    line-height: 22px;
    &-outlined {
      background-color: #f6f7f9;
      border-radius: ${({ theme: e }) => {
  var t;
  return ((t = e.shape) == null ? void 0 : t.borderRadius) || 0;
}}px;
      border-color: ${({ theme: e }) => e.palette.borderColor.main};
      color: ${({ theme: e }) => e.palette.grey[800]};
      font-size: 12px;
      font-weight: 700;
    }
    .chip-delete-outlined {
      font-size: 10px;
      padding: 4px;
    }
  }
`, kh = Z(Lp, {
  shouldForwardProp: (e) => e !== "isDense" && e !== "renderValue"
})(
  ({ isDense: e, theme: t }) => {
    var n, r, i, s, a;
    return ki`
    &.autocomplete {
      .autocomplete-input {
        height: 14px;
        padding: 8px 10px;
        font-size: 14px;
        &-root {
          min-height: 30px;
          background-color: #ffffff;
        }
      }
      .autocomplete-input-container {
        &.autocomplete-input-root {
          padding: 2px;
          padding-right: 60px;
        }
        &.autocomplete-free-solo-root {
          min-height: 24px;
          /* padding-right: 2px; */
          padding: 0px;
          input {
            font-size: 12px;
            height: 14px;
          }
        }
      }
    }
    .autocomplete-input-container {
      &.autocomplete-focused,
      &.autocomplete-input-container:hover {
        .autocomplete-notched-outline {
          border: 1px solid ${(n = t.palette) == null ? void 0 : n.borderColor.main};
        }
      }
    }
    .autocomplete-notched-outline {
      border-radius: ${((r = t.shape) == null ? void 0 : r.borderRadius) || 0}px;
      border-color: ${(i = t.palette) == null ? void 0 : i.borderColor.main};
    }
    .autocomplete-end-adornment {
      right: 2px !important;
      & > * {
        border-radius: ${((s = t.shape) == null ? void 0 : s.borderRadius) || 0}px;
        color: ${$s(t)(0.6)};
      }
    }
    .MuiAutocomplete-tag[role='button'] {
      background-color: ${t.palette.backgroundColor.main};
      border-radius: 2px;
      color: ${(a = t.palette) == null ? void 0 : a.textColor.primary};
    }

    ${e && ki`
      &.autocomplete {
        height: 24px;
        .autocomplete-input {
          padding: 6px 8px;
          font-size: 12px;
          .autocomplete-input-root {
            min-height: 22px;
            font-size: 12px;
          }
        }
        .autocomplete-input-container {
          min-height: 24px;
        }
      }
    `}
  `;
  }
), Ph = (e) => {
  var i;
  const t = No(() => {
    const s = e.options || [], a = e.multiple && Array.isArray(e.value) ? e.value : [e.value], l = e.isOptionEqualToValue || ((u, f) => u === f), c = a.filter((u) => u == null || u === "" || typeof u != "object" ? !1 : !s.some((f) => l(f, u)));
    return c.length ? [...c, ...s] : s;
  }, [e.isOptionEqualToValue, e.multiple, e.options, e.value]), n = {
    sx: {
      ".MuiListSubheader-root": {
        lineHeight: 2.5,
        my: 0,
        px: 1,
        color: "#0d1b40"
      },
      ...(i = e.ListboxProps) == null ? void 0 : i.sx
    },
    ...e.ListboxProps
  }, r = No(
    () => typeof e.filterOptions == "function" ? e.filterOptions : H4(e.filterOptions),
    [e.filterOptions]
  );
  return /* @__PURE__ */ p.jsx(He.Fragment, { children: /* @__PURE__ */ p.jsx(
    kh,
    {
      multiple: e.multiple,
      id: e.id,
      value: e.value,
      inputValue: e.inputValue,
      onChange: e.onChange,
      onInputChange: e.onInputChange,
      options: t,
      getOptionLabel: e.getOptionLabel,
      renderOption: e.OptionComponent,
      isOptionEqualToValue: e.isOptionEqualToValue,
      disableCloseOnSelect: e.disableCloseOnSelect,
      groupBy: e.groupBy,
      renderGroup: e.renderGroup,
      filterOptions: r,
      getOptionKey: e.getOptionKey,
      PaperComponent: e.PaperComponent,
      renderValue: e.renderValue,
      ListboxProps: n,
      classes: {
        option: "autocomplete-menu-item",
        root: "autocomplete",
        input: "autocomplete-input",
        inputRoot: "autocomplete-input-root",
        endAdornment: "autocomplete-end-adornment",
        popupIndicator: "autocomplete-open-" + e.className,
        clearIndicator: "autocomplete-clear-" + e.className,
        listbox: "autocomplete-options-" + e.className
      },
      renderTags: e == null ? void 0 : e.renderTags,
      size: "small",
      isDense: e.size == "small",
      renderInput: (s) => {
        var a;
        return /* @__PURE__ */ p.jsx(
          gc,
          {
            ...s,
            variant: "outlined",
            className: e.className,
            placeholder: e.placeholder,
            InputProps: {
              ...s.InputProps,
              classes: {
                notchedOutline: "autocomplete-notched-outline",
                root: "autocomplete-input-container",
                focused: "autocomplete-focused"
              },
              name: e.name,
              endAdornment: /* @__PURE__ */ p.jsxs(He.Fragment, { children: [
                e.loading ? /* @__PURE__ */ p.jsx(zs, { color: "secondary", size: 18 }) : null,
                ((a = e.InputProps) == null ? void 0 : a.endAdornment) || s.InputProps.endAdornment
              ] })
            }
          }
        );
      },
      getOptionDisabled: e.getOptionDisabled,
      disableClearable: e.disableClearable,
      loading: e.loading,
      loadingText: e.loadingText,
      noOptionsText: e.noOptionsText,
      disabled: e.disabled,
      limitTags: e.limitTags
    }
  ) });
}, zL = (e) => {
  const {
    options: t,
    name: n,
    value: r,
    onChange: i,
    label: s,
    className: a,
    showLabel: l,
    hiddenTags: c = !1,
    isLoading: u
  } = e, { t: f } = ec(), g = He.useCallback(
    (m) => t == null ? void 0 : t.find(
      (b) => (b == null ? void 0 : b.value) === m || (b == null ? void 0 : b.value) === (m == null ? void 0 : m.value)
    ),
    [t]
  ), h = He.useCallback(
    (m) => {
      const b = g(m), C = (b == null ? void 0 : b.name) ?? (m == null ? void 0 : m.name) ?? m ?? "";
      return typeof C == "object" ? "" : String(C);
    },
    [g]
  ), y = He.useCallback(
    (m) => {
      const b = g(m), C = (b == null ? void 0 : b.tag) != null ? "(" + (b == null ? void 0 : b.tag) + ")" : "";
      return b ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        /* @__PURE__ */ p.jsx(
          An,
          {
            component: "span",
            sx: {
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "inline-block",
              whiteSpace: "nowrap"
            },
            children: b == null ? void 0 : b.name
          }
        ),
        " ",
        /* @__PURE__ */ p.jsx(
          An,
          {
            component: "span",
            sx: {
              display: "inline-block",
              width: `${(C.length || 0) * 7.5}px`,
              textAlign: "right"
            },
            children: C
          }
        )
      ] }) : (
        // this option is critical to display predefined filters (for ex in concepts Search "M05")
        h(m)
      );
    },
    [g, h]
  ), v = He.useCallback(
    (m, b, C, E) => {
      var k, T;
      const S = "";
      (k = E == null ? void 0 : E.option) != null && k.disabled || (((T = E == null ? void 0 : E.option) == null ? void 0 : T.value) === S ? i([]) : i(
        b.filter((P) => !(P != null && P.disabled)).map((P) => (P == null ? void 0 : P.value) != null ? P.value : P).filter((P) => P !== S)
      ));
    },
    [i]
  );
  return /* @__PURE__ */ p.jsxs(Bi, { className: a + " c-multi-select-item", children: [
    l && /* @__PURE__ */ p.jsx("label", { className: "filter-block__head", children: s }),
    /* @__PURE__ */ p.jsx(
      Ph,
      {
        className: n,
        multiple: !0,
        options: u ? [] : t,
        isOptionEqualToValue: (m, b) => (m == null ? void 0 : m.value) === b || m === b,
        value: r || [],
        onChange: v,
        getOptionDisabled: (m) => !!(m != null && m.disabled),
        getOptionLabel: h,
        fullWidth: !0,
        loading: u,
        loadingText: f("filters.base.loading_options"),
        filterOptions: {
          matchFrom: "any",
          stringify: h
        },
        renderTags: (m, b) => /* @__PURE__ */ p.jsxs(
          An,
          {
            sx: {
              px: 1,
              fontSize: 14,
              color: "#AAAAAA"
            },
            children: [
              (m == null ? void 0 : m.length) || f("filters.base.none"),
              " ",
              f("filters.base.selected_end")
            ]
          },
          "tag-props"
        ),
        name: "multiselectFilter",
        placeholder: r != null && r.length ? "" : `${f("filters.base.select")} ${typeof s == "string" ? s.toLowerCase() : s}...`,
        OptionComponent: (m, b) => /* @__PURE__ */ Cr(
          "li",
          {
            ...m,
            key: b.value,
            className: `menu-option-${(b == null ? void 0 : b.value) || b} ${m.className}`
          },
          y(b)
        )
      }
    ),
    !c && /* @__PURE__ */ p.jsx(Tn, { container: !0, spacing: 1, pt: 1, className: "filter-options-selected", children: r.map((m, b) => /* @__PURE__ */ p.jsx(Tn, { item: !0, maxWidth: "100%", children: /* @__PURE__ */ p.jsx(
      Mh,
      {
        label: y(m),
        variant: "outlined",
        size: "small",
        color: "primary",
        classes: {
          root: "chip selected-filter-option",
          outlined: "chip-outlined",
          deleteIcon: "chip-delete-outlined remove-item-" + ((m == null ? void 0 : m.value) || m)
        },
        onDelete: () => {
          i(r.filter((C, E) => E != b));
        },
        deleteIcon: /* @__PURE__ */ p.jsx(qn, { iconName: "close", sx: { fontSize: 14 } }),
        sx: {
          ".MuiChip-label": {
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            maxWidth: "100%",
            justifyContent: "space-between"
          }
        }
      }
    ) }, "select-option-" + b)) })
  ] });
}, HL = (e) => {
  const { options: t, name: n, value: r, onChange: i, label: s, className: a, showLabel: l } = e;
  return /* @__PURE__ */ p.jsxs(Bi, { className: a + " c-radio-item", children: [
    l && /* @__PURE__ */ p.jsx("label", { className: "filter-block__head", children: /* @__PURE__ */ p.jsx("div", { className: "filter-block__head-title", children: s }) }),
    /* @__PURE__ */ p.jsx("div", { className: "filter-block__content", children: t && t.map((c) => /* @__PURE__ */ p.jsx(
      "div",
      {
        className: "filter-block__option",
        children: /* @__PURE__ */ p.jsxs(Bf, { children: [
          /* @__PURE__ */ p.jsx(
            $L,
            {
              checked: c.active(r),
              value: c.value,
              onChange: (u) => i(
                c.onChange ? c.onChange(r) : [c.value]
              ),
              size: "small"
            }
          ),
          c.color ? /* @__PURE__ */ p.jsx(Eh, { text: c.name, color: c.color }) : /* @__PURE__ */ p.jsx("span", { children: c.name }),
          c.tag != null && /* @__PURE__ */ p.jsx(Rh, { children: c.tag })
        ] })
      },
      n + "_" + c.value
    )) })
  ] });
}, WL = (e) => {
  const { options: t, name: n, value: r, onChange: i, label: s, className: a, showLabel: l } = e;
  return /* @__PURE__ */ p.jsxs(Bi, { className: a + " c-select-item", children: [
    l && /* @__PURE__ */ p.jsx("label", { className: "filter-block__head", children: s }),
    /* @__PURE__ */ p.jsx(
      Fg,
      {
        options: t,
        value: r || "",
        onChange: i,
        size: "medium",
        fullWidth: !0,
        name: "selectFilter"
      }
    )
  ] });
}, GL = (e) => {
  const { value: t, onChange: n, label: r, className: i, showLabel: s, parseFilter: a, options: l } = e, c = No(
    () => (t == null ? void 0 : t[0]) === "filter.boolean.true",
    [t]
  ), u = No(
    () => {
      var f;
      return (f = l == null ? void 0 : l.find((g) => (g == null ? void 0 : g.value) === "filter.boolean.true")) == null ? void 0 : f.tag;
    },
    [l]
  );
  return /* @__PURE__ */ p.jsx(Bi, { className: i + " c-switch-item", children: /* @__PURE__ */ p.jsxs(Bf, { className: " switch-item-wrapper", children: [
    /* @__PURE__ */ p.jsx(
      IL,
      {
        value: c,
        checked: c,
        onChange: (f) => n(a(f.target.checked)),
        size: "small",
        color: "info"
      }
    ),
    s && /* @__PURE__ */ p.jsx("div", { className: "switch-item-label", children: r }),
    u != null && /* @__PURE__ */ p.jsx(NL, { label: u, size: "small" })
  ] }) });
}, UL = ({
  size: e = 6
}) => {
  var i;
  const t = to(), n = Jn(0.7, (i = t.palette) == null ? void 0 : i.secondary.main), r = [];
  for (let s = 0; s < e; s++)
    r.push(
      /* @__PURE__ */ p.jsxs(Tn, { item: !0, xs: 12, container: !0, spacing: 1, children: [
        /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(
          Ca,
          {
            animation: "wave",
            height: 12,
            width: "40%",
            sx: { bgcolor: n }
          }
        ) }),
        /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(
          Ca,
          {
            animation: "wave",
            height: 28,
            width: "100%",
            sx: { bgcolor: n }
          }
        ) })
      ] }, "backdrop" + s)
    );
  return /* @__PURE__ */ p.jsxs(Tn, { container: !0, spacing: 2, direction: "column", mt: 1, children: [
    /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, children: /* @__PURE__ */ p.jsx(
      Ca,
      {
        animation: "wave",
        height: 28,
        width: "100%",
        sx: { bgcolor: n }
      }
    ) }) }),
    r
  ] });
}, YL = (e) => {
  const { value: t, onChange: n, label: r, className: i, classes: s, name: a, showLabel: l } = e, [c, u] = He.useState(t[0]), f = (g) => {
    if (g) {
      const h = W6(g, z6.ISO_DATE_TIME);
      h !== "Invalid date" ? (u(h), n([h])) : (u(null), n([]));
    }
  };
  return /* @__PURE__ */ p.jsxs(Bi, { className: i + " c-date-range-item", children: [
    l && /* @__PURE__ */ p.jsx("label", { className: "filter-block__head", children: r }),
    /* @__PURE__ */ p.jsx(
      tp,
      {
        value: c || null,
        onChange: f,
        fullWidth: !1,
        size: "medium",
        disableFuture: !0
      }
    )
  ] });
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Qi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ur(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: Qi(n, r[e])
    }));
  };
}
function t1(e) {
  return e instanceof Function;
}
function ZL(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function qL(e, t) {
  const n = [], r = (i) => {
    i.forEach((s) => {
      n.push(s);
      const a = t(s);
      a != null && a.length && r(a);
    });
  };
  return r(e), n;
}
function Wt(e, t, n) {
  let r = [], i;
  return (s) => {
    let a;
    n.key && n.debug && (a = Date.now());
    const l = e(s);
    if (!(l.length !== r.length || l.some((f, g) => r[g] !== f)))
      return i;
    r = l;
    let u;
    if (n.key && n.debug && (u = Date.now()), i = t(...l), n == null || n.onChange == null || n.onChange(i), n.key && n.debug && n != null && n.debug()) {
      const f = Math.round((Date.now() - a) * 100) / 100, g = Math.round((Date.now() - u) * 100) / 100, h = g / 16, y = (v, m) => {
        for (v = String(v); v.length < m; )
          v = " " + v;
        return v;
      };
      console.info(`%c⏱ ${y(g, 5)} /${y(f, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * h, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return i;
  };
}
function Gt(e, t, n, r) {
  return {
    debug: () => {
      var i;
      return (i = e == null ? void 0 : e.debugAll) != null ? i : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function KL(e, t, n, r) {
  const i = () => {
    var a;
    return (a = s.getValue()) != null ? a : e.options.renderFallbackValue;
  }, s = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: i,
    getContext: Wt(() => [e, n, t, s], (a, l, c, u) => ({
      table: a,
      column: l,
      row: c,
      cell: u,
      getValue: u.getValue,
      renderValue: u.renderValue
    }), Gt(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((a) => {
    a.createCell == null || a.createCell(s, n, t, e);
  }, {}), s;
}
function XL(e, t, n, r) {
  var i, s;
  const l = {
    ...e._getDefaultColumnDef(),
    ...t
  }, c = l.accessorKey;
  let u = (i = (s = l.id) != null ? s : c ? typeof String.prototype.replaceAll == "function" ? c.replaceAll(".", "_") : c.replace(/\./g, "_") : void 0) != null ? i : typeof l.header == "string" ? l.header : void 0, f;
  if (l.accessorFn ? f = l.accessorFn : c && (c.includes(".") ? f = (h) => {
    let y = h;
    for (const m of c.split(".")) {
      var v;
      y = (v = y) == null ? void 0 : v[m], process.env.NODE_ENV !== "production" && y === void 0 && console.warn(`"${m}" in deeply nested key "${c}" returned undefined.`);
    }
    return y;
  } : f = (h) => h[l.accessorKey]), !u)
    throw process.env.NODE_ENV !== "production" ? new Error(l.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let g = {
    id: `${String(u)}`,
    accessorFn: f,
    parent: r,
    depth: n,
    columnDef: l,
    columns: [],
    getFlatColumns: Wt(() => [!0], () => {
      var h;
      return [g, ...(h = g.columns) == null ? void 0 : h.flatMap((y) => y.getFlatColumns())];
    }, Gt(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: Wt(() => [e._getOrderColumnsFn()], (h) => {
      var y;
      if ((y = g.columns) != null && y.length) {
        let v = g.columns.flatMap((m) => m.getLeafColumns());
        return h(v);
      }
      return [g];
    }, Gt(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const h of e._features)
    h.createColumn == null || h.createColumn(g, e);
  return g;
}
const Ao = "debugHeaders";
function T5(e, t, n) {
  var r;
  let s = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const a = [], l = (c) => {
        c.subHeaders && c.subHeaders.length && c.subHeaders.map(l), a.push(c);
      };
      return l(s), a;
    },
    getContext: () => ({
      table: e,
      header: s,
      column: t
    })
  };
  return e._features.forEach((a) => {
    a.createHeader == null || a.createHeader(s, e);
  }), s;
}
const QL = {
  createTable: (e) => {
    e.getHeaderGroups = Wt(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, i) => {
      var s, a;
      const l = (s = r == null ? void 0 : r.map((g) => n.find((h) => h.id === g)).filter(Boolean)) != null ? s : [], c = (a = i == null ? void 0 : i.map((g) => n.find((h) => h.id === g)).filter(Boolean)) != null ? a : [], u = n.filter((g) => !(r != null && r.includes(g.id)) && !(i != null && i.includes(g.id)));
      return hu(t, [...l, ...u, ...c], e);
    }, Gt(e.options, Ao, "getHeaderGroups")), e.getCenterHeaderGroups = Wt(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, i) => (n = n.filter((s) => !(r != null && r.includes(s.id)) && !(i != null && i.includes(s.id))), hu(t, n, e, "center")), Gt(e.options, Ao, "getCenterHeaderGroups")), e.getLeftHeaderGroups = Wt(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var i;
      const s = (i = r == null ? void 0 : r.map((a) => n.find((l) => l.id === a)).filter(Boolean)) != null ? i : [];
      return hu(t, s, e, "left");
    }, Gt(e.options, Ao, "getLeftHeaderGroups")), e.getRightHeaderGroups = Wt(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var i;
      const s = (i = r == null ? void 0 : r.map((a) => n.find((l) => l.id === a)).filter(Boolean)) != null ? i : [];
      return hu(t, s, e, "right");
    }, Gt(e.options, Ao, "getRightHeaderGroups")), e.getFooterGroups = Wt(() => [e.getHeaderGroups()], (t) => [...t].reverse(), Gt(e.options, Ao, "getFooterGroups")), e.getLeftFooterGroups = Wt(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), Gt(e.options, Ao, "getLeftFooterGroups")), e.getCenterFooterGroups = Wt(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), Gt(e.options, Ao, "getCenterFooterGroups")), e.getRightFooterGroups = Wt(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), Gt(e.options, Ao, "getRightFooterGroups")), e.getFlatHeaders = Wt(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Gt(e.options, Ao, "getFlatHeaders")), e.getLeftFlatHeaders = Wt(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Gt(e.options, Ao, "getLeftFlatHeaders")), e.getCenterFlatHeaders = Wt(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Gt(e.options, Ao, "getCenterFlatHeaders")), e.getRightFlatHeaders = Wt(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Gt(e.options, Ao, "getRightFlatHeaders")), e.getCenterLeafHeaders = Wt(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Gt(e.options, Ao, "getCenterLeafHeaders")), e.getLeftLeafHeaders = Wt(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Gt(e.options, Ao, "getLeftLeafHeaders")), e.getRightLeafHeaders = Wt(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Gt(e.options, Ao, "getRightLeafHeaders")), e.getLeafHeaders = Wt(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var i, s, a, l, c, u;
      return [...(i = (s = t[0]) == null ? void 0 : s.headers) != null ? i : [], ...(a = (l = n[0]) == null ? void 0 : l.headers) != null ? a : [], ...(c = (u = r[0]) == null ? void 0 : u.headers) != null ? c : []].map((f) => f.getLeafHeaders()).flat();
    }, Gt(e.options, Ao, "getLeafHeaders"));
  }
};
function hu(e, t, n, r) {
  var i, s;
  let a = 0;
  const l = function(h, y) {
    y === void 0 && (y = 1), a = Math.max(a, y), h.filter((v) => v.getIsVisible()).forEach((v) => {
      var m;
      (m = v.columns) != null && m.length && l(v.columns, y + 1);
    }, 0);
  };
  l(e);
  let c = [];
  const u = (h, y) => {
    const v = {
      depth: y,
      id: [r, `${y}`].filter(Boolean).join("_"),
      headers: []
    }, m = [];
    h.forEach((b) => {
      const C = [...m].reverse()[0], E = b.column.depth === v.depth;
      let S, k = !1;
      if (E && b.column.parent ? S = b.column.parent : (S = b.column, k = !0), C && (C == null ? void 0 : C.column) === S)
        C.subHeaders.push(b);
      else {
        const T = T5(n, S, {
          id: [r, y, S.id, b == null ? void 0 : b.id].filter(Boolean).join("_"),
          isPlaceholder: k,
          placeholderId: k ? `${m.filter((P) => P.column === S).length}` : void 0,
          depth: y,
          index: m.length
        });
        T.subHeaders.push(b), m.push(T);
      }
      v.headers.push(b), b.headerGroup = v;
    }), c.push(v), y > 0 && u(m, y - 1);
  }, f = t.map((h, y) => T5(n, h, {
    depth: a,
    index: y
  }));
  u(f, a - 1), c.reverse();
  const g = (h) => h.filter((v) => v.column.getIsVisible()).map((v) => {
    let m = 0, b = 0, C = [0];
    v.subHeaders && v.subHeaders.length ? (C = [], g(v.subHeaders).forEach((S) => {
      let {
        colSpan: k,
        rowSpan: T
      } = S;
      m += k, C.push(T);
    })) : m = 1;
    const E = Math.min(...C);
    return b = b + E, v.colSpan = m, v.rowSpan = b, {
      colSpan: m,
      rowSpan: b
    };
  });
  return g((i = (s = c[0]) == null ? void 0 : s.headers) != null ? i : []), c;
}
const zf = (e, t, n, r, i, s, a) => {
  let l = {
    id: t,
    index: r,
    original: n,
    depth: i,
    parentId: a,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (c) => {
      if (l._valuesCache.hasOwnProperty(c))
        return l._valuesCache[c];
      const u = e.getColumn(c);
      if (u != null && u.accessorFn)
        return l._valuesCache[c] = u.accessorFn(l.original, r), l._valuesCache[c];
    },
    getUniqueValues: (c) => {
      if (l._uniqueValuesCache.hasOwnProperty(c))
        return l._uniqueValuesCache[c];
      const u = e.getColumn(c);
      if (u != null && u.accessorFn)
        return u.columnDef.getUniqueValues ? (l._uniqueValuesCache[c] = u.columnDef.getUniqueValues(l.original, r), l._uniqueValuesCache[c]) : (l._uniqueValuesCache[c] = [l.getValue(c)], l._uniqueValuesCache[c]);
    },
    renderValue: (c) => {
      var u;
      return (u = l.getValue(c)) != null ? u : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => qL(l.subRows, (c) => c.subRows),
    getParentRow: () => l.parentId ? e.getRow(l.parentId, !0) : void 0,
    getParentRows: () => {
      let c = [], u = l;
      for (; ; ) {
        const f = u.getParentRow();
        if (!f) break;
        c.push(f), u = f;
      }
      return c.reverse();
    },
    getAllCells: Wt(() => [e.getAllLeafColumns()], (c) => c.map((u) => KL(e, l, u, u.id)), Gt(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: Wt(() => [l.getAllCells()], (c) => c.reduce((u, f) => (u[f.column.id] = f, u), {}), Gt(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let c = 0; c < e._features.length; c++) {
    const u = e._features[c];
    u == null || u.createRow == null || u.createRow(l, e);
  }
  return l;
}, JL = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Ih = (e, t, n) => {
  var r, i;
  const s = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((i = e.getValue(t)) == null || (i = i.toString()) == null || (i = i.toLowerCase()) == null) && i.includes(s));
};
Ih.autoRemove = (e) => $r(e);
const Oh = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
Oh.autoRemove = (e) => $r(e);
const Dh = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
Dh.autoRemove = (e) => $r(e);
const jh = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
jh.autoRemove = (e) => $r(e);
const Fh = (e, t, n) => !n.some((r) => {
  var i;
  return !((i = e.getValue(t)) != null && i.includes(r));
});
Fh.autoRemove = (e) => $r(e) || !(e != null && e.length);
const Vh = (e, t, n) => n.some((r) => {
  var i;
  return (i = e.getValue(t)) == null ? void 0 : i.includes(r);
});
Vh.autoRemove = (e) => $r(e) || !(e != null && e.length);
const $h = (e, t, n) => e.getValue(t) === n;
$h.autoRemove = (e) => $r(e);
const Lh = (e, t, n) => e.getValue(t) == n;
Lh.autoRemove = (e) => $r(e);
const Hf = (e, t, n) => {
  let [r, i] = n;
  const s = e.getValue(t);
  return s >= r && s <= i;
};
Hf.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, i = typeof n != "number" ? parseFloat(n) : n, s = t === null || Number.isNaN(r) ? -1 / 0 : r, a = n === null || Number.isNaN(i) ? 1 / 0 : i;
  if (s > a) {
    const l = s;
    s = a, a = l;
  }
  return [s, a];
};
Hf.autoRemove = (e) => $r(e) || $r(e[0]) && $r(e[1]);
const xi = {
  includesString: Ih,
  includesStringSensitive: Oh,
  equalsString: Dh,
  arrIncludes: jh,
  arrIncludesAll: Fh,
  arrIncludesSome: Vh,
  equals: $h,
  weakEquals: Lh,
  inNumberRange: Hf
};
function $r(e) {
  return e == null || e === "";
}
const eA = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: ur("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? xi.includesString : typeof r == "number" ? xi.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? xi.equals : Array.isArray(r) ? xi.arrIncludes : xi.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return t1(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : xi[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, i;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((i = t.options.enableFilters) != null ? i : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((i) => i.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const i = e.getFilterFn(), s = r == null ? void 0 : r.find((f) => f.id === e.id), a = Qi(n, s ? s.value : void 0);
        if (M5(i, a, e)) {
          var l;
          return (l = r == null ? void 0 : r.filter((f) => f.id !== e.id)) != null ? l : [];
        }
        const c = {
          id: e.id,
          value: a
        };
        if (s) {
          var u;
          return (u = r == null ? void 0 : r.map((f) => f.id === e.id ? c : f)) != null ? u : [];
        }
        return r != null && r.length ? [...r, c] : [c];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (i) => {
        var s;
        return (s = Qi(t, i)) == null ? void 0 : s.filter((a) => {
          const l = n.find((c) => c.id === a.id);
          if (l) {
            const c = l.getFilterFn();
            if (M5(c, a.value, l))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function M5(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const tA = (e, t, n) => n.reduce((r, i) => {
  const s = i.getValue(e);
  return r + (typeof s == "number" ? s : 0);
}, 0), nA = (e, t, n) => {
  let r;
  return n.forEach((i) => {
    const s = i.getValue(e);
    s != null && (r > s || r === void 0 && s >= s) && (r = s);
  }), r;
}, oA = (e, t, n) => {
  let r;
  return n.forEach((i) => {
    const s = i.getValue(e);
    s != null && (r < s || r === void 0 && s >= s) && (r = s);
  }), r;
}, rA = (e, t, n) => {
  let r, i;
  return n.forEach((s) => {
    const a = s.getValue(e);
    a != null && (r === void 0 ? a >= a && (r = i = a) : (r > a && (r = a), i < a && (i = a)));
  }), [r, i];
}, iA = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((i) => {
    let s = i.getValue(e);
    s != null && (s = +s) >= s && (++n, r += s);
  }), n) return r / n;
}, sA = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((s) => s.getValue(e));
  if (!ZL(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), i = n.sort((s, a) => s - a);
  return n.length % 2 !== 0 ? i[r] : (i[r - 1] + i[r]) / 2;
}, aA = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), lA = (e, t) => new Set(t.map((n) => n.getValue(e))).size, cA = (e, t) => t.length, r0 = {
  sum: tA,
  min: nA,
  max: oA,
  extent: rA,
  mean: iA,
  median: sA,
  unique: aA,
  uniqueCount: lA,
  count: cA
}, uA = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: ur("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return r0.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return r0.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return t1(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : r0[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var i;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((i = n.subRows) != null && i.length);
    };
  }
};
function dA(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((s) => !t.includes(s.id));
  return n === "remove" ? r : [...t.map((s) => e.find((a) => a.id === s)).filter(Boolean), ...r];
}
const pA = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: ur("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = Wt((n) => [Vl(t, n)], (n) => n.findIndex((r) => r.id === e.id), Gt(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = Vl(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const i = Vl(t, n);
      return ((r = i[i.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = Wt(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (i) => {
      let s = [];
      if (!(t != null && t.length))
        s = i;
      else {
        const a = [...t], l = [...i];
        for (; l.length && a.length; ) {
          const c = a.shift(), u = l.findIndex((f) => f.id === c);
          u > -1 && s.push(l.splice(u, 1)[0]);
        }
        s = [...s, ...l];
      }
      return dA(s, n, r);
    }, Gt(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, i0 = () => ({
  left: [],
  right: []
}), fA = {
  getInitialState: (e) => ({
    columnPinning: i0(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: ur("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((i) => i.id).filter(Boolean);
      t.setColumnPinning((i) => {
        var s, a;
        if (n === "right") {
          var l, c;
          return {
            left: ((l = i == null ? void 0 : i.left) != null ? l : []).filter((g) => !(r != null && r.includes(g))),
            right: [...((c = i == null ? void 0 : i.right) != null ? c : []).filter((g) => !(r != null && r.includes(g))), ...r]
          };
        }
        if (n === "left") {
          var u, f;
          return {
            left: [...((u = i == null ? void 0 : i.left) != null ? u : []).filter((g) => !(r != null && r.includes(g))), ...r],
            right: ((f = i == null ? void 0 : i.right) != null ? f : []).filter((g) => !(r != null && r.includes(g)))
          };
        }
        return {
          left: ((s = i == null ? void 0 : i.left) != null ? s : []).filter((g) => !(r != null && r.includes(g))),
          right: ((a = i == null ? void 0 : i.right) != null ? a : []).filter((g) => !(r != null && r.includes(g)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var i, s, a;
      return ((i = r.columnDef.enablePinning) != null ? i : !0) && ((s = (a = t.options.enableColumnPinning) != null ? a : t.options.enablePinning) != null ? s : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((l) => l.id), {
        left: r,
        right: i
      } = t.getState().columnPinning, s = n.some((l) => r == null ? void 0 : r.includes(l)), a = n.some((l) => i == null ? void 0 : i.includes(l));
      return s ? "left" : a ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const i = e.getIsPinned();
      return i ? (n = (r = t.getState().columnPinning) == null || (r = r[i]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = Wt(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, i) => {
      const s = [...r ?? [], ...i ?? []];
      return n.filter((a) => !s.includes(a.column.id));
    }, Gt(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = Wt(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((s) => n.find((a) => a.column.id === s)).filter(Boolean).map((s) => ({
      ...s,
      position: "left"
    })), Gt(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = Wt(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((s) => n.find((a) => a.column.id === s)).filter(Boolean).map((s) => ({
      ...s,
      position: "right"
    })), Gt(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? i0() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : i0());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var i, s;
        return !!((i = r.left) != null && i.length || (s = r.right) != null && s.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = Wt(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((i) => i.id === r)).filter(Boolean), Gt(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = Wt(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((i) => i.id === r)).filter(Boolean), Gt(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = Wt(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const i = [...n ?? [], ...r ?? []];
      return t.filter((s) => !i.includes(s.id));
    }, Gt(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function gA(e) {
  return e || (typeof document < "u" ? document : null);
}
const vu = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, s0 = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), mA = {
  getDefaultColumnDef: () => vu,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: s0(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: ur("columnSizing", e),
    onColumnSizingInfoChange: ur("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, i;
      const s = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : vu.minSize, (r = s ?? e.columnDef.size) != null ? r : vu.size), (i = e.columnDef.maxSize) != null ? i : vu.maxSize);
    }, e.getStart = Wt((n) => [n, Vl(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((i, s) => i + s.getSize(), 0), Gt(t.options, "debugColumns", "getStart")), e.getAfter = Wt((n) => [n, Vl(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((i, s) => i + s.getSize(), 0), Gt(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...i
        } = n;
        return i;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (i) => {
        if (i.subHeaders.length)
          i.subHeaders.forEach(r);
        else {
          var s;
          n += (s = i.column.getSize()) != null ? s : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), i = r == null ? void 0 : r.getCanResize();
      return (s) => {
        if (!r || !i || (s.persist == null || s.persist(), a0(s) && s.touches && s.touches.length > 1))
          return;
        const a = e.getSize(), l = e ? e.getLeafHeaders().map((C) => [C.column.id, C.column.getSize()]) : [[r.id, r.getSize()]], c = a0(s) ? Math.round(s.touches[0].clientX) : s.clientX, u = {}, f = (C, E) => {
          typeof E == "number" && (t.setColumnSizingInfo((S) => {
            var k, T;
            const P = t.options.columnResizeDirection === "rtl" ? -1 : 1, F = (E - ((k = S == null ? void 0 : S.startOffset) != null ? k : 0)) * P, j = Math.max(F / ((T = S == null ? void 0 : S.startSize) != null ? T : 0), -0.999999);
            return S.columnSizingStart.forEach((L) => {
              let [R, V] = L;
              u[R] = Math.round(Math.max(V + V * j, 0) * 100) / 100;
            }), {
              ...S,
              deltaOffset: F,
              deltaPercentage: j
            };
          }), (t.options.columnResizeMode === "onChange" || C === "end") && t.setColumnSizing((S) => ({
            ...S,
            ...u
          })));
        }, g = (C) => f("move", C), h = (C) => {
          f("end", C), t.setColumnSizingInfo((E) => ({
            ...E,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, y = gA(n), v = {
          moveHandler: (C) => g(C.clientX),
          upHandler: (C) => {
            y == null || y.removeEventListener("mousemove", v.moveHandler), y == null || y.removeEventListener("mouseup", v.upHandler), h(C.clientX);
          }
        }, m = {
          moveHandler: (C) => (C.cancelable && (C.preventDefault(), C.stopPropagation()), g(C.touches[0].clientX), !1),
          upHandler: (C) => {
            var E;
            y == null || y.removeEventListener("touchmove", m.moveHandler), y == null || y.removeEventListener("touchend", m.upHandler), C.cancelable && (C.preventDefault(), C.stopPropagation()), h((E = C.touches[0]) == null ? void 0 : E.clientX);
          }
        }, b = hA() ? {
          passive: !1
        } : !1;
        a0(s) ? (y == null || y.addEventListener("touchmove", m.moveHandler, b), y == null || y.addEventListener("touchend", m.upHandler, b)) : (y == null || y.addEventListener("mousemove", v.moveHandler, b), y == null || y.addEventListener("mouseup", v.upHandler, b)), t.setColumnSizingInfo((C) => ({
          ...C,
          startOffset: c,
          startSize: a,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: l,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? s0() : (n = e.initialState.columnSizingInfo) != null ? n : s0());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    };
  }
};
let yu = null;
function hA() {
  if (typeof yu == "boolean") return yu;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return yu = e, yu;
}
function a0(e) {
  return e.type === "touchstart";
}
const vA = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: ur("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const i = e.columns;
      return (n = i.length ? i.some((s) => s.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = Wt(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), Gt(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = Wt(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, i) => [...n, ...r, ...i], Gt(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => Wt(() => [r(), r().filter((i) => i.getIsVisible()).map((i) => i.id).join("_")], (i) => i.filter((s) => s.getIsVisible == null ? void 0 : s.getIsVisible()), Gt(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((i, s) => ({
        ...i,
        [s.id]: n || !(s.getCanHide != null && s.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function Vl(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const yA = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, bA = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: ur("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, i, s;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((i = t.options.enableFilters) != null ? i : !0) && ((s = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? s : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => xi.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return t1(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : xi[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, CA = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: ur("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, i;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (i = e.options.autoResetAll) != null ? i : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var i, s;
      e.setExpanded(r ? {} : (i = (s = e.initialState) == null ? void 0 : s.expanded) != null ? i : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((i) => !i.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((s) => {
        const a = s.split(".");
        r = Math.max(r, a.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var i;
        const s = r === !0 ? !0 : !!(r != null && r[e.id]);
        let a = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((l) => {
          a[l] = !0;
        }) : a = r, n = (i = n) != null ? i : !s, !s && n)
          return {
            ...a,
            [e.id]: !0
          };
        if (s && !n) {
          const {
            [e.id]: l,
            ...c
          } = a;
          return c;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, i;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((i = e.subRows) != null && i.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, op = 0, rp = 10, l0 = () => ({
  pageIndex: op,
  pageSize: rp
}), xA = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...l0(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: ur("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, i;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (i = e.options.autoResetAll) != null ? i : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const i = (s) => Qi(r, s);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(i);
    }, e.resetPagination = (r) => {
      var i;
      e.setPagination(r ? l0() : (i = e.initialState.pagination) != null ? i : l0());
    }, e.setPageIndex = (r) => {
      e.setPagination((i) => {
        let s = Qi(r, i.pageIndex);
        const a = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return s = Math.max(0, Math.min(s, a)), {
          ...i,
          pageIndex: s
        };
      });
    }, e.resetPageIndex = (r) => {
      var i, s;
      e.setPageIndex(r ? op : (i = (s = e.initialState) == null || (s = s.pagination) == null ? void 0 : s.pageIndex) != null ? i : op);
    }, e.resetPageSize = (r) => {
      var i, s;
      e.setPageSize(r ? rp : (i = (s = e.initialState) == null || (s = s.pagination) == null ? void 0 : s.pageSize) != null ? i : rp);
    }, e.setPageSize = (r) => {
      e.setPagination((i) => {
        const s = Math.max(1, Qi(r, i.pageSize)), a = i.pageSize * i.pageIndex, l = Math.floor(a / s);
        return {
          ...i,
          pageIndex: l,
          pageSize: s
        };
      });
    }, e.setPageCount = (r) => e.setPagination((i) => {
      var s;
      let a = Qi(r, (s = e.options.pageCount) != null ? s : -1);
      return typeof a == "number" && (a = Math.max(-1, a)), {
        ...i,
        pageCount: a
      };
    }), e.getPageOptions = Wt(() => [e.getPageCount()], (r) => {
      let i = [];
      return r && r > 0 && (i = [...new Array(r)].fill(null).map((s, a) => a)), i;
    }, Gt(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, i = e.getPageCount();
      return i === -1 ? !0 : i === 0 ? !1 : r < i - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, c0 = () => ({
  top: [],
  bottom: []
}), wA = {
  getInitialState: (e) => ({
    rowPinning: c0(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: ur("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, i) => {
      const s = r ? e.getLeafRows().map((c) => {
        let {
          id: u
        } = c;
        return u;
      }) : [], a = i ? e.getParentRows().map((c) => {
        let {
          id: u
        } = c;
        return u;
      }) : [], l = /* @__PURE__ */ new Set([...a, e.id, ...s]);
      t.setRowPinning((c) => {
        var u, f;
        if (n === "bottom") {
          var g, h;
          return {
            top: ((g = c == null ? void 0 : c.top) != null ? g : []).filter((m) => !(l != null && l.has(m))),
            bottom: [...((h = c == null ? void 0 : c.bottom) != null ? h : []).filter((m) => !(l != null && l.has(m))), ...Array.from(l)]
          };
        }
        if (n === "top") {
          var y, v;
          return {
            top: [...((y = c == null ? void 0 : c.top) != null ? y : []).filter((m) => !(l != null && l.has(m))), ...Array.from(l)],
            bottom: ((v = c == null ? void 0 : c.bottom) != null ? v : []).filter((m) => !(l != null && l.has(m)))
          };
        }
        return {
          top: ((u = c == null ? void 0 : c.top) != null ? u : []).filter((m) => !(l != null && l.has(m))),
          bottom: ((f = c == null ? void 0 : c.bottom) != null ? f : []).filter((m) => !(l != null && l.has(m)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: i
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? i) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: i
      } = t.getState().rowPinning, s = n.some((l) => r == null ? void 0 : r.includes(l)), a = n.some((l) => i == null ? void 0 : i.includes(l));
      return s ? "top" : a ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const i = e.getIsPinned();
      if (!i) return -1;
      const s = (n = i === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((a) => {
        let {
          id: l
        } = a;
        return l;
      });
      return (r = s == null ? void 0 : s.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? c0() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : c0());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var i, s;
        return !!((i = r.top) != null && i.length || (s = r.bottom) != null && s.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var i;
      return ((i = e.options.keepPinnedRows) == null || i ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((a) => {
          const l = e.getRow(a, !0);
          return l.getIsAllParentsExpanded() ? l : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((a) => t.find((l) => l.id === a))
      )).filter(Boolean).map((a) => ({
        ...a,
        position: r
      }));
    }, e.getTopRows = Wt(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), Gt(e.options, "debugRows", "getTopRows")), e.getBottomRows = Wt(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), Gt(e.options, "debugRows", "getBottomRows")), e.getCenterRows = Wt(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const i = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((s) => !i.has(s.id));
    }, Gt(e.options, "debugRows", "getCenterRows"));
  }
}, SA = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: ur("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, i = e.getPreGroupedRowModel().flatRows;
        return t ? i.forEach((s) => {
          s.getCanSelect() && (r[s.id] = !0);
        }) : i.forEach((s) => {
          delete r[s.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), i = {
        ...n
      };
      return e.getRowModel().rows.forEach((s) => {
        ip(i, s.id, r, !0, e);
      }), i;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = Wt(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? u0(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Gt(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = Wt(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? u0(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Gt(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = Wt(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? u0(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Gt(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((i) => i.getCanSelect() && !n[i.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((i) => i.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((i) => !n[i.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const i = e.getIsSelected();
      t.setRowSelection((s) => {
        var a;
        if (n = typeof n < "u" ? n : !i, e.getCanSelect() && i === n)
          return s;
        const l = {
          ...s
        };
        return ip(l, e.id, n, (a = r == null ? void 0 : r.selectChildren) != null ? a : !0, t), l;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Wf(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return sp(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return sp(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var i;
        n && e.toggleSelected((i = r.target) == null ? void 0 : i.checked);
      };
    };
  }
}, ip = (e, t, n, r, i) => {
  var s;
  const a = i.getRow(t, !0);
  n ? (a.getCanMultiSelect() || Object.keys(e).forEach((l) => delete e[l]), a.getCanSelect() && (e[t] = !0)) : delete e[t], r && (s = a.subRows) != null && s.length && a.getCanSelectSubRows() && a.subRows.forEach((l) => ip(e, l.id, n, r, i));
};
function u0(e, t) {
  const n = e.getState().rowSelection, r = [], i = {}, s = function(a, l) {
    return a.map((c) => {
      var u;
      const f = Wf(c, n);
      if (f && (r.push(c), i[c.id] = c), (u = c.subRows) != null && u.length && (c = {
        ...c,
        subRows: s(c.subRows)
      }), f)
        return c;
    }).filter(Boolean);
  };
  return {
    rows: s(t.rows),
    flatRows: r,
    rowsById: i
  };
}
function Wf(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function sp(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let i = !0, s = !1;
  return e.subRows.forEach((a) => {
    if (!(s && !i) && (a.getCanSelect() && (Wf(a, t) ? s = !0 : i = !1), a.subRows && a.subRows.length)) {
      const l = sp(a, t);
      l === "all" ? s = !0 : (l === "some" && (s = !0), i = !1);
    }
  }), i ? "all" : s ? "some" : !1;
}
const ap = /([0-9]+)/gm, EA = (e, t, n) => Ah(as(e.getValue(n)).toLowerCase(), as(t.getValue(n)).toLowerCase()), RA = (e, t, n) => Ah(as(e.getValue(n)), as(t.getValue(n))), TA = (e, t, n) => Gf(as(e.getValue(n)).toLowerCase(), as(t.getValue(n)).toLowerCase()), MA = (e, t, n) => Gf(as(e.getValue(n)), as(t.getValue(n))), kA = (e, t, n) => {
  const r = e.getValue(n), i = t.getValue(n);
  return r > i ? 1 : r < i ? -1 : 0;
}, PA = (e, t, n) => Gf(e.getValue(n), t.getValue(n));
function Gf(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function as(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Ah(e, t) {
  const n = e.split(ap).filter(Boolean), r = t.split(ap).filter(Boolean);
  for (; n.length && r.length; ) {
    const i = n.shift(), s = r.shift(), a = parseInt(i, 10), l = parseInt(s, 10), c = [a, l].sort();
    if (isNaN(c[0])) {
      if (i > s)
        return 1;
      if (s > i)
        return -1;
      continue;
    }
    if (isNaN(c[1]))
      return isNaN(a) ? -1 : 1;
    if (a > l)
      return 1;
    if (l > a)
      return -1;
  }
  return n.length - r.length;
}
const dl = {
  alphanumeric: EA,
  alphanumericCaseSensitive: RA,
  text: TA,
  textCaseSensitive: MA,
  datetime: kA,
  basic: PA
}, IA = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: ur("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const i of n) {
        const s = i == null ? void 0 : i.getValue(e.id);
        if (Object.prototype.toString.call(s) === "[object Date]")
          return dl.datetime;
        if (typeof s == "string" && (r = !0, s.split(ap).length > 1))
          return dl.alphanumeric;
      }
      return r ? dl.text : dl.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return t1(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : dl[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const i = e.getNextSortingOrder(), s = typeof n < "u" && n !== null;
      t.setSorting((a) => {
        const l = a == null ? void 0 : a.find((y) => y.id === e.id), c = a == null ? void 0 : a.findIndex((y) => y.id === e.id);
        let u = [], f, g = s ? n : i === "desc";
        if (a != null && a.length && e.getCanMultiSort() && r ? l ? f = "toggle" : f = "add" : a != null && a.length && c !== a.length - 1 ? f = "replace" : l ? f = "toggle" : f = "replace", f === "toggle" && (s || i || (f = "remove")), f === "add") {
          var h;
          u = [...a, {
            id: e.id,
            desc: g
          }], u.splice(0, u.length - ((h = t.options.maxMultiSortColCount) != null ? h : Number.MAX_SAFE_INTEGER));
        } else f === "toggle" ? u = a.map((y) => y.id === e.id ? {
          ...y,
          desc: g
        } : y) : f === "remove" ? u = a.filter((y) => y.id !== e.id) : u = [{
          id: e.id,
          desc: g
        }];
        return u;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, i;
      const s = e.getFirstSortDir(), a = e.getIsSorted();
      return a ? a !== s && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (i = t.options.enableMultiRemove) != null) || i) ? !1 : a === "desc" ? "asc" : "desc" : s;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((i) => i.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((i) => i.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, OA = [
  QL,
  vA,
  pA,
  fA,
  JL,
  eA,
  yA,
  //depends on ColumnFaceting
  bA,
  //depends on ColumnFiltering
  IA,
  uA,
  //depends on RowSorting
  CA,
  xA,
  wA,
  SA,
  mA
];
function DA(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...OA, ...(t = e._features) != null ? t : []];
  let i = {
    _features: r
  };
  const s = i._features.reduce((h, y) => Object.assign(h, y.getDefaultOptions == null ? void 0 : y.getDefaultOptions(i)), {}), a = (h) => i.options.mergeOptions ? i.options.mergeOptions(s, h) : {
    ...s,
    ...h
  };
  let c = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  i._features.forEach((h) => {
    var y;
    c = (y = h.getInitialState == null ? void 0 : h.getInitialState(c)) != null ? y : c;
  });
  const u = [];
  let f = !1;
  const g = {
    _features: r,
    options: {
      ...s,
      ...e
    },
    initialState: c,
    _queue: (h) => {
      u.push(h), f || (f = !0, Promise.resolve().then(() => {
        for (; u.length; )
          u.shift()();
        f = !1;
      }).catch((y) => setTimeout(() => {
        throw y;
      })));
    },
    reset: () => {
      i.setState(i.initialState);
    },
    setOptions: (h) => {
      const y = Qi(h, i.options);
      i.options = a(y);
    },
    getState: () => i.options.state,
    setState: (h) => {
      i.options.onStateChange == null || i.options.onStateChange(h);
    },
    _getRowId: (h, y, v) => {
      var m;
      return (m = i.options.getRowId == null ? void 0 : i.options.getRowId(h, y, v)) != null ? m : `${v ? [v.id, y].join(".") : y}`;
    },
    getCoreRowModel: () => (i._getCoreRowModel || (i._getCoreRowModel = i.options.getCoreRowModel(i)), i._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => i.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (h, y) => {
      let v = (y ? i.getPrePaginationRowModel() : i.getRowModel()).rowsById[h];
      if (!v && (v = i.getCoreRowModel().rowsById[h], !v))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${h}`) : new Error();
      return v;
    },
    _getDefaultColumnDef: Wt(() => [i.options.defaultColumn], (h) => {
      var y;
      return h = (y = h) != null ? y : {}, {
        header: (v) => {
          const m = v.header.column.columnDef;
          return m.accessorKey ? m.accessorKey : m.accessorFn ? m.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (v) => {
          var m, b;
          return (m = (b = v.renderValue()) == null || b.toString == null ? void 0 : b.toString()) != null ? m : null;
        },
        ...i._features.reduce((v, m) => Object.assign(v, m.getDefaultColumnDef == null ? void 0 : m.getDefaultColumnDef()), {}),
        ...h
      };
    }, Gt(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => i.options.columns,
    getAllColumns: Wt(() => [i._getColumnDefs()], (h) => {
      const y = function(v, m, b) {
        return b === void 0 && (b = 0), v.map((C) => {
          const E = XL(i, C, b, m), S = C;
          return E.columns = S.columns ? y(S.columns, E, b + 1) : [], E;
        });
      };
      return y(h);
    }, Gt(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: Wt(() => [i.getAllColumns()], (h) => h.flatMap((y) => y.getFlatColumns()), Gt(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: Wt(() => [i.getAllFlatColumns()], (h) => h.reduce((y, v) => (y[v.id] = v, y), {}), Gt(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: Wt(() => [i.getAllColumns(), i._getOrderColumnsFn()], (h, y) => {
      let v = h.flatMap((m) => m.getLeafColumns());
      return y(v);
    }, Gt(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (h) => {
      const y = i._getAllFlatColumnsById()[h];
      return process.env.NODE_ENV !== "production" && !y && console.error(`[Table] Column with id '${h}' does not exist.`), y;
    }
  };
  Object.assign(i, g);
  for (let h = 0; h < i._features.length; h++) {
    const y = i._features[h];
    y == null || y.createTable == null || y.createTable(i);
  }
  return i;
}
function Nh() {
  return (e) => Wt(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(i, s, a) {
      s === void 0 && (s = 0);
      const l = [];
      for (let u = 0; u < i.length; u++) {
        const f = zf(e, e._getRowId(i[u], u, a), i[u], u, s, void 0, a == null ? void 0 : a.id);
        if (n.flatRows.push(f), n.rowsById[f.id] = f, l.push(f), e.options.getSubRows) {
          var c;
          f.originalSubRows = e.options.getSubRows(i[u], u), (c = f.originalSubRows) != null && c.length && (f.subRows = r(f.originalSubRows, s + 1, f));
        }
      }
      return l;
    };
    return n.rows = r(t), n;
  }, Gt(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function Bh() {
  return (e) => Wt(() => [e.getState().expanded, e.getPreExpandedRowModel(), e.options.paginateExpandedRows], (t, n, r) => !n.rows.length || t !== !0 && !Object.keys(t ?? {}).length || !r ? n : _h(n), Gt(e.options, "debugTable", "getExpandedRowModel"));
}
function _h(e) {
  const t = [], n = (r) => {
    var i;
    t.push(r), (i = r.subRows) != null && i.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function zh(e, t, n) {
  return n.options.filterFromLeafRows ? jA(e, t, n) : FA(e, t, n);
}
function jA(e, t, n) {
  var r;
  const i = [], s = {}, a = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, l = function(c, u) {
    u === void 0 && (u = 0);
    const f = [];
    for (let h = 0; h < c.length; h++) {
      var g;
      let y = c[h];
      const v = zf(n, y.id, y.original, y.index, y.depth, void 0, y.parentId);
      if (v.columnFilters = y.columnFilters, (g = y.subRows) != null && g.length && u < a) {
        if (v.subRows = l(y.subRows, u + 1), y = v, t(y) && !v.subRows.length) {
          f.push(y), s[y.id] = y, i.push(y);
          continue;
        }
        if (t(y) || v.subRows.length) {
          f.push(y), s[y.id] = y, i.push(y);
          continue;
        }
      } else
        y = v, t(y) && (f.push(y), s[y.id] = y, i.push(y));
    }
    return f;
  };
  return {
    rows: l(e),
    flatRows: i,
    rowsById: s
  };
}
function FA(e, t, n) {
  var r;
  const i = [], s = {}, a = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, l = function(c, u) {
    u === void 0 && (u = 0);
    const f = [];
    for (let h = 0; h < c.length; h++) {
      let y = c[h];
      if (t(y)) {
        var g;
        if ((g = y.subRows) != null && g.length && u < a) {
          const m = zf(n, y.id, y.original, y.index, y.depth, void 0, y.parentId);
          m.subRows = l(y.subRows, u + 1), y = m;
        }
        f.push(y), i.push(y), s[y.id] = y;
      }
    }
    return f;
  };
  return {
    rows: l(e),
    flatRows: i,
    rowsById: s
  };
}
function VA() {
  return (e, t) => Wt(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter, e.getFilteredRowModel()], (n, r, i) => {
    if (!n.rows.length || !(r != null && r.length) && !i)
      return n;
    const s = [...r.map((l) => l.id).filter((l) => l !== t), i ? "__global__" : void 0].filter(Boolean), a = (l) => {
      for (let c = 0; c < s.length; c++)
        if (l.columnFilters[s[c]] === !1)
          return !1;
      return !0;
    };
    return zh(n.rows, a, e);
  }, Gt(e.options, "debugTable", "getFacetedRowModel"));
}
function $A() {
  return (e, t) => Wt(() => {
    var n;
    return [(n = e.getColumn(t)) == null ? void 0 : n.getFacetedRowModel()];
  }, (n) => {
    if (!n) return /* @__PURE__ */ new Map();
    let r = /* @__PURE__ */ new Map();
    for (let s = 0; s < n.flatRows.length; s++) {
      const a = n.flatRows[s].getUniqueValues(t);
      for (let l = 0; l < a.length; l++) {
        const c = a[l];
        if (r.has(c)) {
          var i;
          r.set(c, ((i = r.get(c)) != null ? i : 0) + 1);
        } else
          r.set(c, 1);
      }
    }
    return r;
  }, Gt(e.options, "debugTable", `getFacetedUniqueValues_${t}`));
}
function LA() {
  return (e) => Wt(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (t, n, r) => {
    if (!t.rows.length || !(n != null && n.length) && !r) {
      for (let h = 0; h < t.flatRows.length; h++)
        t.flatRows[h].columnFilters = {}, t.flatRows[h].columnFiltersMeta = {};
      return t;
    }
    const i = [], s = [];
    (n ?? []).forEach((h) => {
      var y;
      const v = e.getColumn(h.id);
      if (!v)
        return;
      const m = v.getFilterFn();
      if (!m) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${v.id}.`);
        return;
      }
      i.push({
        id: h.id,
        filterFn: m,
        resolvedValue: (y = m.resolveFilterValue == null ? void 0 : m.resolveFilterValue(h.value)) != null ? y : h.value
      });
    });
    const a = (n ?? []).map((h) => h.id), l = e.getGlobalFilterFn(), c = e.getAllLeafColumns().filter((h) => h.getCanGlobalFilter());
    r && l && c.length && (a.push("__global__"), c.forEach((h) => {
      var y;
      s.push({
        id: h.id,
        filterFn: l,
        resolvedValue: (y = l.resolveFilterValue == null ? void 0 : l.resolveFilterValue(r)) != null ? y : r
      });
    }));
    let u, f;
    for (let h = 0; h < t.flatRows.length; h++) {
      const y = t.flatRows[h];
      if (y.columnFilters = {}, i.length)
        for (let v = 0; v < i.length; v++) {
          u = i[v];
          const m = u.id;
          y.columnFilters[m] = u.filterFn(y, m, u.resolvedValue, (b) => {
            y.columnFiltersMeta[m] = b;
          });
        }
      if (s.length) {
        for (let v = 0; v < s.length; v++) {
          f = s[v];
          const m = f.id;
          if (f.filterFn(y, m, f.resolvedValue, (b) => {
            y.columnFiltersMeta[m] = b;
          })) {
            y.columnFilters.__global__ = !0;
            break;
          }
        }
        y.columnFilters.__global__ !== !0 && (y.columnFilters.__global__ = !1);
      }
    }
    const g = (h) => {
      for (let y = 0; y < a.length; y++)
        if (h.columnFilters[a[y]] === !1)
          return !1;
      return !0;
    };
    return zh(t.rows, g, e);
  }, Gt(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function AA(e) {
  return (t) => Wt(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (n, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: i,
      pageIndex: s
    } = n;
    let {
      rows: a,
      flatRows: l,
      rowsById: c
    } = r;
    const u = i * s, f = u + i;
    a = a.slice(u, f);
    let g;
    t.options.paginateExpandedRows ? g = {
      rows: a,
      flatRows: l,
      rowsById: c
    } : g = _h({
      rows: a,
      flatRows: l,
      rowsById: c
    }), g.flatRows = [];
    const h = (y) => {
      g.flatRows.push(y), y.subRows.length && y.subRows.forEach(h);
    };
    return g.rows.forEach(h), g;
  }, Gt(t.options, "debugTable", "getPaginationRowModel"));
}
function NA() {
  return (e) => Wt(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
    if (!n.rows.length || !(t != null && t.length))
      return n;
    const r = e.getState().sorting, i = [], s = r.filter((c) => {
      var u;
      return (u = e.getColumn(c.id)) == null ? void 0 : u.getCanSort();
    }), a = {};
    s.forEach((c) => {
      const u = e.getColumn(c.id);
      u && (a[c.id] = {
        sortUndefined: u.columnDef.sortUndefined,
        invertSorting: u.columnDef.invertSorting,
        sortingFn: u.getSortingFn()
      });
    });
    const l = (c) => {
      const u = c.map((f) => ({
        ...f
      }));
      return u.sort((f, g) => {
        for (let y = 0; y < s.length; y += 1) {
          var h;
          const v = s[y], m = a[v.id], b = m.sortUndefined, C = (h = v == null ? void 0 : v.desc) != null ? h : !1;
          let E = 0;
          if (b) {
            const S = f.getValue(v.id), k = g.getValue(v.id), T = S === void 0, P = k === void 0;
            if (T || P) {
              if (b === "first") return T ? -1 : 1;
              if (b === "last") return T ? 1 : -1;
              E = T && P ? 0 : T ? b : -b;
            }
          }
          if (E === 0 && (E = m.sortingFn(f, g, v.id)), E !== 0)
            return C && (E *= -1), m.invertSorting && (E *= -1), E;
        }
        return f.index - g.index;
      }), u.forEach((f) => {
        var g;
        i.push(f), (g = f.subRows) != null && g.length && (f.subRows = l(f.subRows));
      }), u;
    };
    return {
      rows: l(n.rows),
      flatRows: i,
      rowsById: n.rowsById
    };
  }, Gt(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Ma(e, t) {
  return e ? BA(e) ? /* @__PURE__ */ d.createElement(e, t) : e : null;
}
function BA(e) {
  return _A(e) || typeof e == "function" || zA(e);
}
function _A(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function zA(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function Hh(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = d.useState(() => ({
    current: DA(t)
  })), [r, i] = d.useState(() => n.current.initialState);
  return n.current.setOptions((s) => ({
    ...s,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (a) => {
      i(a), e.onStateChange == null || e.onStateChange(a);
    }
  })), n.current;
}
const bu = (e) => ({
  padding: "6px 16px",
  fontSize: "0.9rem",
  fontWeight: 400,
  "&:hover": {
    backgroundColor: Jn(0.9, e.palette.info.main)
  },
  "&.Mui-disabled": {
    backgroundColor: e.palette.grey[100],
    opacity: 0.9,
    color: e.palette.grey[400]
  },
  "&.Mui-disabled *": {
    color: e.palette.grey[800],
    backgroundColor: e.palette.grey[400],
    opacity: 1,
    filter: "grayscale(1)"
  },
  "&.Mui-selected.Mui-focusVisible": {
    backgroundColor: Jn(0.85, e.palette.info.main)
  },
  "&.Mui-focusVisible": {
    backgroundColor: "transparent"
  }
}), Wh = (e) => {
  const { showModeMenu: t = !0 } = e, [n, r] = So(e.defaultMode || "all"), [i, s] = He.useState(null), a = !!i, l = (f) => {
    s(f.currentTarget);
  }, c = (f, g) => (h) => {
    f && (g && e.state[n].checked || e.onChange(f)({ target: { checked: g } }, g)), s(null);
  }, u = (...f) => {
    e.onChange(n)(...f);
  };
  return Rn(() => {
    e.defaultMode && r(e.defaultMode);
  }, [e.defaultMode]), /* @__PURE__ */ p.jsxs(An, { display: "flex", alignItems: "center", width: "100%", ml: -0.25, children: [
    /* @__PURE__ */ p.jsx(
      An,
      {
        sx: {
          width: 24,
          minWidth: 24,
          height: 24,
          textAlign: "center",
          boxSizing: "border-box",
          borderRadius: 0.5,
          padding: 0.25,
          cursor: "pointer",
          ":hover": {
            bgcolor: "backgroundColor.main"
          }
        },
        component: "label",
        children: /* @__PURE__ */ p.jsx(
          _r,
          {
            arrow: !0,
            title: e.canSelectAll ? n === "all" ? "Select All" : "Select Page" : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
              /* @__PURE__ */ p.jsx("b", { children: "Select Page" }),
              /* @__PURE__ */ p.jsx("br", {}),
              /* @__PURE__ */ p.jsx(Gl, { sx: { my: 0.5 } }),
              /* @__PURE__ */ p.jsx(
                An,
                {
                  component: "sup",
                  sx: {
                    color: "red",
                    marginLeft: "-4px",
                    marginRight: "4px"
                  },
                  children: "*"
                }
              ),
              "Select all is ",
              /* @__PURE__ */ p.jsx("b", { children: "disabled" }),
              " for large tables exceeding",
              " ",
              /* @__PURE__ */ p.jsx("b", { children: "100,000 rows" })
            ] }),
            placement: "top",
            componentsProps: {
              tooltip: {
                sx: {
                  maxWidth: "13rem"
                }
              }
            },
            children: /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx(
              ii,
              {
                stopPropagation: !0,
                loading: e.loading,
                size: "small",
                onChange: u,
                ...e.state[n]
              }
            ) })
          }
        )
      }
    ),
    t ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(
        Gs,
        {
          variant: "text",
          id: "basic-button",
          "aria-controls": a ? "basic-menu" : void 0,
          "aria-haspopup": "true",
          "aria-expanded": a ? "true" : void 0,
          onClick: l,
          sx: {
            minWidth: 16,
            width: 16,
            height: 22,
            textAlign: "center",
            borderRadius: 0.5,
            cursor: "pointer",
            ":hover": {
              bgcolor: "backgroundColor.main"
            }
          },
          children: /* @__PURE__ */ p.jsx(
            qn,
            {
              iconName: "arrowDown",
              sx: { width: 9, height: 22, color: "textColor.label" }
            }
          )
        }
      ),
      /* @__PURE__ */ p.jsxs(
        Jp,
        {
          id: "basic-menu",
          anchorEl: i,
          open: a,
          onClose: c(),
          MenuListProps: {
            "aria-labelledby": "basic-button"
          },
          sx: { ul: { padding: 0 }, li: {} },
          children: [
            /* @__PURE__ */ p.jsx(
              xr,
              {
                onClick: c("all", !0),
                selected: !1,
                autoFocus: !1,
                disabled: !e.canSelectAll,
                sx: bu,
                children: "Select All"
              }
            ),
            /* @__PURE__ */ p.jsx(
              xr,
              {
                onClick: c("all", !1),
                selected: !1,
                autoFocus: !1,
                disabled: !e.canSelectAll,
                sx: bu,
                children: "Unselect All"
              }
            ),
            /* @__PURE__ */ p.jsx(
              xr,
              {
                onClick: c("page", !0),
                selected: !1,
                autoFocus: !1,
                sx: bu,
                children: "Select Page"
              }
            ),
            /* @__PURE__ */ p.jsx(
              xr,
              {
                onClick: c("page", !1),
                selected: !1,
                autoFocus: !1,
                sx: bu,
                children: "Unselect Page"
              }
            )
          ]
        }
      )
    ] }) : ""
  ] });
}, HA = ({
  table: e
}) => {
  const { variant: t, selectAll: n, selectedElements: r, totalElements: i } = e.options.meta, [s, a] = So(
    () => n || t === "uncontrolled" ? "all" : "page"
  ), [l, c] = So(Zs.INITIAL), u = (e.options.meta.totalElements || e.getRowCount()) > 1e5, f = (h) => h === "page" ? e.getToggleAllPageRowsSelectedHandler() : t === "uncontrolled" || i == e.getRowCount() ? e.getToggleAllRowsSelectedHandler() : async function(y, v) {
    c(Zs.IN_PROGRESS), await n(y, v), c(Zs.SUCCESS);
  };
  Rn(() => {
    a(
      u || !n && t !== "uncontrolled" ? "page" : "all"
    );
  }, [u]);
  const g = r ? Object.keys(r).length : -1;
  return /* @__PURE__ */ p.jsx(
    Wh,
    {
      defaultMode: s,
      state: {
        page: {
          checked: e.getIsAllPageRowsSelected(),
          indeterminate: e.getIsSomePageRowsSelected(),
          disabled: l === Zs.IN_PROGRESS
        },
        all: {
          checked: t === "controlled" ? g > 0 && g === i : e.getIsAllRowsSelected(),
          indeterminate: t === "controlled" ? g < i && g > 0 : e.getIsSomeRowsSelected(),
          disabled: l === Zs.IN_PROGRESS
        }
      },
      loading: l === Zs.IN_PROGRESS,
      onChange: f,
      canSelectAll: (e.options.meta.totalElements || e.getRowCount()) <= 1e5,
      showModeMenu: !!(n || t === "uncontrolled")
    }
  );
}, nd = {
  id: "select",
  size: 60,
  enableResizing: !1,
  enableHiding: !1,
  meta: {
    columnType: "action",
    align: "left",
    headerAlign: "left"
  },
  header: HA,
  cell: ({ row: e }) => /* @__PURE__ */ p.jsx(
    ii,
    {
      stopPropagation: !0,
      size: "small",
      checked: e.getIsSelected(),
      disabled: !e.getCanSelect(),
      indeterminate: e.getIsSomeSelected(),
      onChange: e.getToggleSelectedHandler()
    }
  )
}, od = {
  header: ({ table: e }) => /* @__PURE__ */ p.jsx(_r, { title: "Expand all", placement: "top", children: /* @__PURE__ */ p.jsx(
    Ar,
    {
      onClick: e.getToggleAllRowsExpandedHandler(),
      size: "small",
      sx: {
        p: 0.25,
        display: "block",
        borderRadius: "2px",
        width: "24px",
        height: "24px"
      },
      children: /* @__PURE__ */ p.jsx(
        qn,
        {
          iconName: "arrowDown",
          sx: {
            width: 9,
            height: 22,
            color: "textColor.label",
            transform: e.getIsAllRowsExpanded() ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 300ms"
          }
        }
      )
    }
  ) }),
  id: "collapse",
  size: 30,
  enableResizing: !1,
  enableHiding: !1,
  meta: {
    columnType: "action",
    align: "center"
  },
  cell: ({ row: e }) => e.getCanExpand() ? /* @__PURE__ */ p.jsx(
    Ar,
    {
      onClick: e.getToggleExpandedHandler(),
      size: "small",
      sx: {
        p: 0.25,
        display: "block",
        borderRadius: "2px",
        width: "24px",
        height: "24px"
      },
      children: /* @__PURE__ */ p.jsx(
        qn,
        {
          iconName: "arrowDown",
          sx: {
            width: 9,
            height: 22,
            color: "textColor.label",
            transform: e.getIsExpanded() ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 300ms"
          }
        }
      )
    }
  ) : ""
};
function iz(e) {
  return e.map((t) => ({
    ...t,
    header: t.header || t.Header,
    ...t.accessor && {
      ...typeof t.accessor == "function" ? { accessorFn: t.accessor } : { accessorKey: t.accessor }
    },
    minSize: t.minSize || t.minWidth,
    maxSize: t.maxSize || t.maxWidth,
    enableSorting: !t.disableSortBy,
    ...t.Cell ? {
      cell: (n) => {
        const r = t == null ? void 0 : t.Cell;
        return /* @__PURE__ */ p.jsx(r, { ...n, value: n.renderValue() });
      }
    } : {}
  }));
}
function WA(e, t, n) {
  return n != null && n.length ? n.includes(e.getValue(t)) : !0;
}
const rd = {
  md: 250,
  lg: 260,
  xl: 280
};
function GA(e, t, n) {
  return n != null && n.length ? n.some(
    (r) => Gh(e.getValue(t)) == r
  ) : !0;
}
const Gh = (e) => e > 0;
function UA(e) {
  const t = { otherFilters: [], searchFilter: null };
  return e != null && e.length && e.filter(
    (n) => n.getCanFilter() && n.getFacetedUniqueValues().size
  ).forEach((n) => {
    var l, c;
    const r = ((l = n.columnDef.meta) == null ? void 0 : l.filterVariant) || "multiselect", i = n.columnDef.filterFn, s = {
      type: r,
      onChangeFilter: n.setFilterValue,
      label: Ma(n.columnDef.header, {}),
      name: n.id,
      order: ((c = n.columnDef.meta) == null ? void 0 : c.filterOrder) ?? 1 / 0
    }, a = Array.from(n.getFacetedUniqueValues());
    switch (r) {
      case "value":
        t.searchFilter = s;
        break;
      case "boolean":
        if (i === "greaterThanZero") {
          const u = a.reduce(
            (f, g) => (Gh(g[0]) && (f[0].tag += g[1]), f),
            [
              { name: "true", value: !0, tag: 0 }
              // { name: 'false', value: false, tag: 0 },
            ]
          );
          t.otherFilters.push({
            ...s,
            label: n.columnDef.meta.filterHeader,
            options: u
          });
          break;
        }
      default: {
        const u = a.sort().map(([f, g]) => {
          var h, y;
          return {
            name: (h = n.columnDef.meta) != null && h.renderFilter ? (y = n.columnDef.meta) == null ? void 0 : y.renderFilter(f) : f,
            value: f,
            tag: g
          };
        });
        t.otherFilters.push({
          ...s,
          options: u
        });
      }
    }
  }), t.otherFilters.sort((n, r) => n.order - r.order), t;
}
function YA(...e) {
  return (t) => {
    e.forEach((n) => {
      n && (typeof n == "function" ? n(t) : n.current = t);
    });
  };
}
yd("div")({
  position: "relative"
});
const ZA = yd("div")({
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
  gap: 8,
  minWidth: 0
}), qA = yd(An)((e) => ({
  // maxWidth: 310,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...e.open ? {
    flex: "0 0 100%",
    width: "100%",
    minWidth: 0,
    opacity: 1,
    height: "auto"
  } : {
    flex: "0 0 0",
    width: 0,
    minWidth: 0,
    overflow: "hidden",
    opacity: 0.4,
    visibility: "hidden",
    paddingRight: 0,
    height: 0
  },
  // Выезд панели анимируется только тогда, когда её сворачивает или
  // разворачивает сам пользователь. На открытии страницы класса нет:
  // фильтры приезжают асинхронно, и без этого панель «выезжала» сама.
  "&.filters-animated": {
    transition: e.open ? "all 500ms ease-in" : "all 500ms"
  },
  ".filters-container": {
    paddingRight: 24,
    boxSizing: "border-box"
  }
})), KA = yd(Gs)(
  ({ theme: e }) => ({
    // border: '1px solid ' + theme.palette?.info.main,
    minWidth: 0,
    boxSizing: "border-box"
  })
), XA = yo("div")(
  ({ overflowX: e, whiteSpace: t }) => ({
    "&.cell-wrapper": {
      overflowX: e,
      whiteSpace: t
    }
  })
), QA = ({
  table: e,
  disableRowClick: t,
  onRowClick: n,
  options: r,
  disabled: i,
  disableRowSelect: s,
  CustomTableRow: a,
  onRowHover: l,
  onScroll: c,
  className: u,
  renderExpandedRow: f,
  ref: g
}) => {
  const h = Fs(null);
  Rn(() => {
    var m;
    if (h.current)
      return (m = h.current) == null || m.addEventListener("scroll", c), () => {
        var b;
        return (b = h.current) == null ? void 0 : b.removeEventListener("scroll", c);
      };
  }, [h]);
  const y = He.useCallback((m, b, C) => {
    const E = m == null ? void 0 : m.column.id;
    return `table${C || ""}-cell-${E}-${b}`;
  }, []), v = (m) => {
    const b = m.getIsPinned();
    return {
      left: b === "left" ? `${m.getStart("left")}px` : void 0,
      right: b === "right" ? `${m.getAfter("right")}px` : void 0,
      opacity: b ? 0.95 : 1,
      position: b ? "sticky" : "relative",
      width: m.getSize(),
      zIndex: b ? 2 : 0,
      backgroundColor: b ? "var(--table-row-background, #fff)" : "inherit"
    };
  };
  return /* @__PURE__ */ p.jsx(
    An,
    {
      sx: { overflowX: "auto", width: "100%", maxWidth: "100%", minWidth: 0 },
      className: "table-component__container",
      ref: YA(g, h),
      children: /* @__PURE__ */ p.jsxs(
        "table",
        {
          className: xe("divTable", u),
          style: { width: "100%", minWidth: e.getTotalSize() },
          children: [
            /* @__PURE__ */ p.jsx("thead", { className: "thead", children: e.getHeaderGroups().map((m, b) => /* @__PURE__ */ p.jsx("tr", { className: "tr table-header-row-" + b, children: m.headers.map((C, E) => {
              var S, k, T;
              return (S = C.column.columnDef.meta) != null && S.invisible ? "" : /* @__PURE__ */ p.jsx(
                "th",
                {
                  className: xe(
                    C.isPlaceholder ? "th placeholder" : "th table-header-cell-" + E,
                    y(C, E, "-header"),
                    C.column.getCanResize() ? "can-resize" : "",
                    C.column.getIsPinned() ? "pinned" : "",
                    C.column.getIsPinned() ? `pinned-${C.column.getIsPinned()}` : ""
                  ),
                  colSpan: C.colSpan,
                  style: {
                    maxWidth: C.getSize(),
                    ...C.column.getCanResize() ? {
                      width: "auto",
                      minWidth: C.getSize()
                    } : {
                      width: C.getSize()
                    },
                    textAlign: ((k = C.column.columnDef.meta) == null ? void 0 : k.align) || "left",
                    cursor: C.column.getCanSort() ? "pointer" : "default",
                    ...v(C.column)
                  },
                  children: C.isPlaceholder ? null : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
                    /* @__PURE__ */ p.jsxs(
                      An,
                      {
                        sx: {
                          cursor: C.column.getCanSort() ? "pointer" : "default",
                          display: "flex",
                          alignItems: "center",
                          whiteSpace: "nowrap",
                          justifyContent: {
                            center: "center",
                            left: "start",
                            right: "end"
                          }[(T = C.column.columnDef.meta) == null ? void 0 : T.headerAlign] || "left"
                        },
                        title: C.column.getCanSort() ? C.column.getNextSortingOrder() === "asc" ? "Sort ascending" : C.column.getNextSortingOrder() === "desc" ? "Sort descending" : "Clear sort" : void 0,
                        onClick: C.column.getToggleSortingHandler(),
                        children: [
                          C.isPlaceholder ? null : Ma(C.column.columnDef.header, {
                            ...C.getContext(),
                            disabled: i
                          }),
                          {
                            desc: /* @__PURE__ */ p.jsx(
                              qn,
                              {
                                iconName: "chevronSorting",
                                sx: {
                                  fontSize: "0.5rem",
                                  color: "#CDCDCD",
                                  ml: 1
                                }
                              }
                            ),
                            asc: /* @__PURE__ */ p.jsx(
                              qn,
                              {
                                iconName: "chevronSorting",
                                sx: {
                                  fontSize: "0.5rem",
                                  ml: 1,
                                  color: "#CDCDCD",
                                  transform: "rotate(180deg)"
                                }
                              }
                            )
                          }[C.column.getIsSorted()] ?? null
                        ]
                      }
                    ),
                    C.column.getCanResize() && /* @__PURE__ */ p.jsx(
                      "div",
                      {
                        className: "resizer",
                        onDoubleClick: () => C.column.resetSize(),
                        onMouseDown: (P) => {
                          P.preventDefault(), P.button === 0 && (window.getSelection().removeAllRanges(), C.getResizeHandler()(P));
                        },
                        // onTouchStart: e => {
                        //   e.preventDefault();
                        //   header.getResizeHandler();
                        // },
                        className: xe(
                          "resizer allow-resize",
                          e.options.columnResizeDirection,
                          C.column.getIsResizing() ? "isResizing" : ""
                        )
                      }
                    )
                  ] })
                },
                C.id
              );
            }) }, m.id)) }),
            a ? e.getRowModel().rows.map((m, b) => {
              const C = {
                className: xe(
                  "tr table-row-" + b,
                  m.getIsSelected() && "selected__table-row",
                  !!(s != null && s(m)) && "disabled__table-row",
                  n && !(t != null && t(m)) && "tr clickable__table-row"
                ),
                ...n && !(t != null && t(m)) && {
                  onClick: () => n == null ? void 0 : n(m)
                },
                ...l && {
                  onMouseOver: () => l == null ? void 0 : l(m),
                  onMouseLeave: () => l == null ? void 0 : l(null)
                  // Clear hover state
                }
              };
              return /* @__PURE__ */ p.jsx(
                a,
                {
                  ...C,
                  data: m.original,
                  row: m,
                  index: b
                },
                m.id + b
              );
            }) : /* @__PURE__ */ p.jsx("tbody", { className: "tbody", children: e.getRowModel().rows.map((m, b) => {
              const C = {
                className: xe(
                  "tr table-row-" + b,
                  m.getIsSelected() && "selected__table-row",
                  !!(s != null && s(m)) && "disabled__table-row",
                  n && !(t != null && t(m)) && "tr clickable__table-row"
                ),
                ...n && !(t != null && t(m)) && {
                  onClick: () => n == null ? void 0 : n(m)
                },
                ...l && {
                  onMouseOver: () => l == null ? void 0 : l(m),
                  onMouseLeave: () => l == null ? void 0 : l(null)
                  // Clear hover state
                }
              }, E = [
                /* @__PURE__ */ p.jsx("tr", { ...C, children: m.getVisibleCells().map((S, k) => {
                  var j, L, R, V;
                  if ((j = S.column.columnDef.meta) != null && j.invisible) return "";
                  const T = S.getValue(), P = typeof T == "string" || typeof T == "number" ? T : "", F = {
                    width: S.column.getCanResize() ? "auto" : S.column.getSize(),
                    maxWidth: S.column.getSize(),
                    minWidth: S.column.getSize()
                  };
                  return /* @__PURE__ */ p.jsx(
                    "td",
                    {
                      key: S.id,
                      className: xe(
                        y(S, k),
                        S.column.getIsPinned() ? "pinned" : "",
                        S.column.getIsPinned() ? `pinned-${S.column.getIsPinned()}` : "",
                        "td"
                      ),
                      // width: cell.column.getSize(),
                      style: {
                        textAlign: ((L = S.column.columnDef.meta) == null ? void 0 : L.align) || "left",
                        ...F,
                        ...v(S.column)
                        // maxWidth: cell.column.getCanResize()
                        //   ? cell.column.getSize()
                        //   : cell.column.columnDef.size,
                      },
                      children: /* @__PURE__ */ p.jsx(
                        XA,
                        {
                          className: "cell-wrapper",
                          overflowX: ((R = S.column.columnDef.meta) == null ? void 0 : R.columnType) === "action" ? "visible" : "hidden",
                          whiteSpace: r.textWrap ? "normal" : "nowrap",
                          title: String(P),
                          children: Ma(S.column.columnDef.cell, {
                            ...S.getContext(),
                            onEdit: (V = e.options.meta) == null ? void 0 : V.updateData,
                            disabled: i
                          })
                        }
                      )
                    }
                  );
                }) }, m.id + 1)
              ];
              return m.getIsExpanded() && E.push(
                /* @__PURE__ */ p.jsx("tr", { children: /* @__PURE__ */ p.jsx("td", { colSpan: m.getVisibleCells().length, children: f({ row: m }) }) }, m.id + 1 + "expanded")
              ), E;
            }) })
          ]
        }
      )
    }
  );
}, JA = (e) => {
  const [t, n] = So(
    () => e.initialOptions || {
      textWrap: !1
    }
  ), r = (i) => (s) => {
    n((a) => {
      const l = { ...a, [i]: s };
      return e.onChange(l), l;
    });
  };
  return /* @__PURE__ */ p.jsx(
    _f,
    {
      title: /* @__PURE__ */ p.jsx(qn, { iconName: "settings", sx: { fontSize: 14 } }),
      tooltipTitle: "Settings",
      options: [
        {
          id: "textWrap",
          checked: t.textWrap,
          onChange: (i) => r("textWrap")(i.target.checked),
          value: "Enable Text Wrap"
        }
      ]
    }
  );
}, xl = yo(Gs)`
  min-width: auto;
  padding: 0 4px;
  min-width: 22px;
  height: 22px;
  margin: 0 2px;
  font-weight: 400;
  &.active {
    background-color: ${({ theme: e }) => {
  var t;
  return ((t = e.palette) == null ? void 0 : t.info.main) + 15;
}};
  }
`, eN = (e, t, n, r) => /* @__PURE__ */ p.jsx(
  xl,
  {
    onClick: t,
    disabled: n < e,
    size: "small",
    variant: "text",
    className: `pagination-button ${r + 1 === e ? "active" : ""}`,
    children: e
  },
  e + "-pagination-btn"
), tN = ({
  table: e,
  totalElements: t,
  disablePageSize: n,
  children: r
}) => {
  var c, u;
  const { pageIndex: i, pageSize: s } = e.getState().pagination, a = e.getPageCount(), l = () => {
    const f = [];
    let g = [];
    if (a > 5)
      g = [1, 2, 3, "...", a], i > 1 && i + 2 < a ? g = [
        1,
        "...",
        i,
        i + 1,
        i + 2,
        "...",
        a
      ] : i >= a - 3 && i + 1 <= a && (g = [1, "...", a - 2, a - 1, a]);
    else
      for (let h = 0; h < a; h++)
        g[h] = h + 1;
    return g.forEach(
      (h, y) => f.push(
        typeof h == "string" ? /* @__PURE__ */ p.jsx(
          ko,
          {
            className: "dots",
            sx: { padding: "6px" },
            children: h
          },
          y + "-pagination-dots"
        ) : eN(
          h,
          () => e.setPageIndex(h - 1),
          a,
          i
        )
      )
    ), f;
  };
  return /* @__PURE__ */ p.jsxs(Tn, { container: !0, fontSize: 12, className: "table-pagination", children: [
    /* @__PURE__ */ p.jsx(Tn, { item: !0, display: "flex", sx: { "& :not(:last-of-type)": { mr: 1 } }, children: r }),
    /* @__PURE__ */ p.jsxs(
      Tn,
      {
        item: !0,
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        children: [
          /* @__PURE__ */ p.jsx(
            xl,
            {
              onClick: () => e.firstPage(),
              disabled: !e.getCanPreviousPage(),
              size: "small",
              variant: "text",
              className: "pagination-button",
              children: "<<"
            },
            "back-to-start-pagination-btn"
          ),
          /* @__PURE__ */ p.jsx(
            xl,
            {
              onClick: () => e.previousPage(),
              disabled: !e.getCanPreviousPage(),
              size: "small",
              variant: "text",
              className: "pagination-button",
              children: "<"
            },
            "back-pagination-btn"
          ),
          l(),
          /* @__PURE__ */ p.jsx(
            xl,
            {
              onClick: () => e.nextPage(),
              disabled: !e.getCanNextPage(),
              size: "small",
              variant: "text",
              className: "pagination-button",
              children: ">"
            },
            "forward-pagination-btn"
          ),
          /* @__PURE__ */ p.jsx(
            xl,
            {
              onClick: () => e.lastPage(),
              disabled: !e.getCanNextPage(),
              size: "small",
              variant: "text",
              className: "pagination-button",
              children: ">>"
            },
            "forward-to-end-pagination-btn"
          ),
          /* @__PURE__ */ p.jsx(Tn, { item: !0, px: 1, children: M1("tables.base.pagination", {
            currentPage: i + 1,
            totalPage: e.getPageCount().toLocaleString()
          }) }),
          /* @__PURE__ */ p.jsx(Tn, { item: !0, px: 1, children: M1("tables.base.showing", {
            minRow: i * s + 1,
            maxRow: i * s + ((u = (c = e.getRowModel()) == null ? void 0 : c.flatRows) == null ? void 0 : u.length),
            totalRow: t
          }) }),
          !n && /* @__PURE__ */ p.jsx(
            Ch,
            {
              size: "small",
              value: s,
              onChange: (f) => {
                e.setPageSize(f);
              },
              options: [10, 15, 20, 25, 50, 75, 100].map((f) => ({
                name: M1("tables.base.show") + " " + f,
                value: f
              })),
              name: "pageSize",
              fullWidth: !1
            }
          )
        ]
      }
    )
  ] });
}, nN = ({ table: e, showColumnToggle: t = !0, withDuplicates: n = !1 }) => {
  const { t: r } = ec(), i = n ? Object.values(
    e.getAllLeafColumns().filter((a) => a.getCanHide()).reduce((a, l) => {
      var u;
      const c = l.id.match(/^[^___]*/)[0];
      return a[c] ? (a[c].id.push(l.id), a[c].checked.push(l.getIsVisible()), a[c].onChange.push(() => l.toggleVisibility())) : a[c] = {
        id: [l.id],
        value: ((u = l.columnDef.meta) == null ? void 0 : u.columnName) || Ma(l.columnDef.header, {}) || l.id,
        checked: [l.getIsVisible()],
        onChange: [() => l.toggleVisibility()]
      }, a;
    }, {})
  ).map((a) => ({
    ...a,
    onChange: () => a.onChange.forEach((l) => l()),
    checked: a.checked.every((l) => l)
  })) : e.getAllLeafColumns().filter((a) => a.getCanHide()).map((a) => ({
    id: a.id,
    value: Ma(a.columnDef.header, {}) || a.id,
    checked: a.getIsVisible(),
    onChange: a.getToggleVisibilityHandler()
  })), s = {
    title: "Show All",
    checked: e.getIsAllColumnsVisible(),
    indeterminate: e.getAllFlatColumns().filter((a) => a.getCanHide()).some((a) => a.getIsVisible()) && !e.getIsAllColumnsVisible(),
    onChange: e.getToggleAllColumnsVisibilityHandler()
  };
  return t ? /* @__PURE__ */ p.jsx(
    _f,
    {
      title: /* @__PURE__ */ p.jsx(qn, { iconName: "columns", sx: { fontSize: 14 } }),
      tooltipTitle: r("tables.base.columns"),
      canSelectAll: !0,
      options: i,
      selectAllOption: s
    }
  ) : /* @__PURE__ */ p.jsx("span", {});
}, oN = ({
  table: e,
  rows: t,
  columnKinds: n = [],
  columnAlignments: r = [],
  className: i
}) => {
  const s = No(
    () => e.getVisibleLeafColumns().filter((u) => {
      var f;
      return !((f = u.columnDef.meta) != null && f.invisible);
    }),
    [e]
  ), a = e.getFlatHeaders(), l = No(
    () => s.map((u) => u.getSize()),
    [s]
  ), c = No(
    () => s.map((u) => {
      const f = a.find((g) => g.column.id === u.id);
      return f ? Ma(u.columnDef.header, f.getContext()) : "";
    }),
    [a, s]
  );
  return /* @__PURE__ */ p.jsx(
    Sh,
    {
      rows: t,
      columns: s.length,
      columnWidths: l,
      columnKinds: n,
      columnAlignments: r,
      headerCells: c,
      className: i,
      fullWidthText: !0
    }
  );
}, rN = ({ hasFilters: e, onClick: t, open: n }) => /* @__PURE__ */ p.jsx(_r, { title: "Filters", arrow: !0, placement: "top", children: /* @__PURE__ */ p.jsx(An, { sx: { display: "inline-block" }, children: /* @__PURE__ */ p.jsx(
  KA,
  {
    variant: n ? "contained" : "text",
    color: "info",
    onClick: t,
    sx: (r) => ({
      px: 1.5,
      ...!n && {
        backgroundColor: Jn(0.9, r.palette.info.main)
      },
      // color: theme.palette.primary.main,
      ".MuiButton-endIcon": {
        marginLeft: 0
      }
    }),
    endIcon: /* @__PURE__ */ p.jsx(qn, { iconName: n ? "chevronLeft" : "chevronRight" }),
    startIcon: /* @__PURE__ */ p.jsx(
      Np,
      {
        badgeContent: e ? " " : 0,
        color: "warning",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        variant: "dot",
        children: /* @__PURE__ */ p.jsx(qn, { iconName: "filter" })
      }
    )
  }
) }) }), k5 = (e) => "accessorKey" in e ? String(e.accessorKey || "") : "", Uh = ({
  hasNoData: e,
  table: t,
  noDataText: n,
  disabled: r = !1,
  showFilterToggle: i = !1,
  hidePagination: s = !1,
  totalElements: a,
  children: l,
  filtersDefaultClosed: c = !1,
  hasFilters: u,
  loading: f,
  loadingMessage: g,
  disableRowClick: h,
  disableRowSelect: y,
  onRowClick: v,
  onRowHover: m,
  searchComponent: b,
  hideSettings: C,
  hideTableOptions: E = !1,
  tableOptionsActions: S,
  settingsOptions: k,
  onSettingsChange: T,
  CustomTableRow: P,
  withDuplicates: F = !1,
  onScroll: j,
  ref: L,
  className: R,
  renderExpandedRow: V
}) => {
  var ee;
  const [B, W] = So(!c), [z, G] = So(!1), [H, ie] = So(
    () => k || {
      textWrap: !1
    }
  ), ce = k || H, re = T || ie, A = t.getVisibleLeafColumns().filter((te) => {
    var ue;
    return !((ue = te.columnDef.meta) != null && ue.invisible);
  }), Y = f && t.getRowModel().rows.length === 0, pe = ((ee = t.getState().pagination) == null ? void 0 : ee.pageSize) || 10, Ce = A.map((te) => {
    var ge;
    const ue = (ge = te.columnDef.meta) == null ? void 0 : ge.skeletonKind;
    if (ue)
      return ue;
    const K = String(te.id || "").toLowerCase(), oe = k5(te.columnDef).toLowerCase(), de = K === "actions" || oe === "actions" || K.includes("action") || K.includes("delete") || oe.includes("action") || oe.includes("delete"), ve = K === "select" || oe === "select", J = K === "type" || K === "icon" || K === "typeicon" || K.includes("icon") || oe.includes("icon"), se = te.getSize() <= 48;
    return de || ve ? "icon" : J || se ? "type-icon" : "text";
  }), fe = A.map((te, ue) => {
    var J, se, ge;
    const K = (J = te.columnDef.meta) == null ? void 0 : J.skeletonAlign;
    if (K === "left" || K === "center" || K === "right")
      return K;
    const oe = (ge = (se = te.columnDef) == null ? void 0 : se.meta) == null ? void 0 : ge.align;
    if (oe === "left" || oe === "center" || oe === "right")
      return oe;
    const de = String(te.id || "").toLowerCase(), ve = k5(te.columnDef).toLowerCase();
    return de === "actions" || ve === "actions" ? "right" : (Ce[ue] === "icon", "left");
  });
  return /* @__PURE__ */ p.jsxs(An, { sx: { position: "relative", minWidth: 0, maxWidth: "100%" }, children: [
    /* @__PURE__ */ p.jsxs(
      An,
      {
        pb: C ? 0 : 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ p.jsx(ZA, { className: "table-actions__container", children: !C && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
            i && /* @__PURE__ */ p.jsx(
              rN,
              {
                open: B,
                onClick: () => {
                  G(!0), W((te) => !te);
                },
                hasFilters: u
              }
            ),
            !E && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
              /* @__PURE__ */ p.jsx(
                JA,
                {
                  initialOptions: ce,
                  onChange: re
                }
              ),
              S,
              /* @__PURE__ */ p.jsx(
                nN,
                {
                  table: t,
                  showColumnToggle: !0,
                  withDuplicates: F
                }
              )
            ] })
          ] }) }),
          b && /* @__PURE__ */ p.jsx(An, { width: rd, children: b })
        ]
      }
    ),
    /* @__PURE__ */ p.jsxs(Tn, { container: !0, flexWrap: "nowrap", sx: { width: "100%", minWidth: 0 }, children: [
      /* @__PURE__ */ p.jsx(
        qA,
        {
          open: B,
          className: z ? "filters-animated" : void 0,
          sx: {
            maxWidth: l ? rd : 0
          },
          children: l
        }
      ),
      e ? /* @__PURE__ */ p.jsx(mh, { noDataText: n }) : Y ? /* @__PURE__ */ p.jsx(
        Tn,
        {
          container: !0,
          item: !0,
          sx: {
            flex: "1 1 0",
            minWidth: 0,
            maxWidth: "100%",
            overflowX: "auto"
          },
          alignContent: "flex-start",
          children: /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, sx: { minWidth: 0, maxWidth: "100%" }, children: /* @__PURE__ */ p.jsx(
            oN,
            {
              table: t,
              rows: pe,
              columnKinds: Ce,
              columnAlignments: fe,
              disabled: r,
              className: R
            }
          ) })
        }
      ) : /* @__PURE__ */ p.jsxs(
        Tn,
        {
          container: !0,
          item: !0,
          sx: {
            flex: "1 1 0",
            minWidth: 0,
            maxWidth: "100%",
            overflowX: "auto"
          },
          alignContent: "flex-start",
          children: [
            /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, sx: { minWidth: 0, maxWidth: "100%" }, children: /* @__PURE__ */ p.jsx(
              QA,
              {
                onScroll: j,
                table: t,
                disableRowClick: h,
                onRowClick: v,
                onRowHover: m,
                options: ce,
                disabled: r,
                disableRowSelect: y,
                CustomTableRow: P,
                className: R,
                renderExpandedRow: V,
                ref: L
              }
            ) }),
            !s && /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, pt: 1, className: "table-pagination__container", children: /* @__PURE__ */ p.jsx(tN, { table: t, totalElements: a }) })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ p.jsx(
      wh,
      {
        isLoading: f && !Y,
        loadingMessage: g
      }
    )
  ] });
};
function iN(e) {
  var me;
  const {
    columns: t = [],
    data: n = [],
    pageCount: r,
    pageIndex: i,
    pageSize: s,
    resetPaginationKey: a,
    defaultSorting: l,
    totalElements: c,
    onRowSelect: u,
    onRowClick: f,
    disableRowClick: g,
    disableRowSelect: h,
    getRowId: y,
    fetchData: v,
    onEdit: m,
    onSelectAll: b,
    onRowHover: C,
    enableRowSelection: E,
    selectedRowIds: S = {},
    loading: k = !1,
    columnVisibility: T,
    loadingMessage: P,
    noDataText: F = "No data found",
    filtersDefaultClosed: j = !1,
    showFilterToggle: L,
    hasFilters: R,
    searchComponent: V,
    hideSettings: B,
    hideTableOptions: W,
    tableOptionsActions: z,
    settingsOptions: G,
    onSettingsChange: H,
    pinnedColumns: ie,
    isExpandable: ce,
    getRowCanExpand: re,
    renderExpandedRow: A,
    className: Y,
    ref: pe
  } = e, Ce = e.customTableRow, [fe, ee] = He.useState(() => ({
    pageIndex: i ?? 0,
    pageSize: s ?? 10
  })), [te, ue] = He.useState(
    () => l ? [l] : []
  ), [K, oe] = He.useState(S), [de, ve] = He.useState(
    () => T || {}
  ), [J, se] = He.useState(
    () => ie || {
      left: [],
      right: []
    }
  ), ge = He.useRef(a), Se = No(() => {
    const ye = [...t], Ie = ye.some(
      (Te) => (Te == null ? void 0 : Te.id) === nd.id
    ), je = ye.some(
      (Te) => (Te == null ? void 0 : Te.id) === od.id
    );
    return E && !Ie && ye.unshift(nd), ce && !je && ye.unshift(od), ye;
  }, [t, ce, E]), we = Hh({
    data: n,
    columns: Se,
    pageCount: r,
    state: {
      pagination: fe,
      sorting: te,
      rowSelection: K,
      columnVisibility: de,
      columnPinning: J
    },
    defaultColumn: {
      minSize: 40,
      maxSize: 800
    },
    enableRowSelection: (ye) => h ? !h(ye) : E,
    columnResizeMode: "onChange",
    columnResizeDirection: "ltr",
    onRowSelectionChange: oe,
    onPaginationChange: ee,
    onSortingChange: ue,
    onColumnPinningChange: se,
    getCoreRowModel: Nh(),
    getRowId: y,
    onColumnVisibilityChange: ve,
    ...ce && {
      getExpandedRowModel: Bh(),
      getRowCanExpand: re
    },
    manualPagination: !0,
    manualSorting: !0,
    meta: {
      updateData: m,
      selectAll: b,
      variant: "controlled",
      totalElements: c,
      selectedElements: e.selectedElements
    },
    // debugTable: true,
    sortDescFirst: !0
  });
  return Rn(() => {
    if (ge.current !== a && fe.pageIndex > 0) {
      ge.current = a, ee((ye) => ({
        ...ye,
        pageIndex: 0
      }));
      return;
    }
    if (ge.current = a, v) {
      const [ye] = te;
      v(fe.pageIndex, fe.pageSize, ye);
    }
  }, [te, fe, v, a]), Rn(() => {
    const ye = we.getSelectedRowModel().rows, Ie = ye == null ? void 0 : ye.filter((je) => !(h != null && h(je))).map((je) => je.original);
    u == null || u(Ie, K);
  }, [u, K]), Rn(() => {
    var ye, Ie;
    (ye = e.setPagination) == null || ye.call(e, fe), (Ie = e.persistSettings) == null || Ie.call(e, "pageSize", fe.pageSize);
  }, [fe]), Rn(() => {
    if (e.persistSettings) {
      const [ye] = te;
      e.persistSettings("sort", ye);
    }
  }, [te]), Rn(() => {
    e.persistSettings && e.persistSettings("columns", de);
  }, [de]), Rn(() => {
    !b0(S, K) && oe(S);
  }, [S]), Rn(() => {
    !b0(T, de) && ve(T || {});
  }, [T]), Rn(() => {
    var ye;
    c > 0 && ((ye = e.data) == null ? void 0 : ye.length) === 0 && fe.pageIndex > 0 && we.firstPage();
  }, [fe, e.data]), /* @__PURE__ */ p.jsx(
    Uh,
    {
      hasFilters: R,
      hasNoData: (e.isInitial || ((me = e.data) == null ? void 0 : me.length) === 0) && !k,
      noDataText: F,
      table: we,
      totalElements: c,
      filtersDefaultClosed: j,
      showFilterToggle: L,
      disableRowClick: g,
      disableRowSelect: h,
      onRowClick: f,
      onRowHover: C,
      loading: k,
      loadingMessage: P,
      searchComponent: V,
      hideSettings: B,
      hideTableOptions: W,
      tableOptionsActions: z,
      settingsOptions: G,
      onSettingsChange: H,
      renderExpandedRow: A,
      CustomTableRow: Ce,
      className: Y,
      ref: pe,
      children: e.children
    }
  );
}
const sN = (e) => {
  var ye, Ie;
  const {
    columns: t = [],
    data: n = [],
    pageIndex: r,
    pageSize: i,
    defaultSorting: s,
    onRowSelect: a,
    onRowClick: l,
    onRowHover: c,
    disableRowClick: u,
    disableRowSelect: f,
    getRowId: g,
    onEdit: h,
    enableRowSelection: y,
    enableFiltering: v,
    selectedRowIds: m = {},
    loading: b = !1,
    columnVisibility: C,
    loadingMessage: E,
    noDataText: S = "No data found",
    filtersDefaultClosed: k = !1,
    showFilterToggle: T = !1,
    hideSettings: P = !1,
    hideTableOptions: F = !1,
    tableOptionsActions: j,
    settingsOptions: L,
    onSettingsChange: R,
    hidePagination: V = !1,
    pinnedColumns: B,
    withDuplicates: W,
    ref: z,
    className: G,
    isExpandable: H,
    renderExpandedRow: ie,
    getRowCanExpand: ce
  } = e, re = e.customTableRow, [A, Y] = So(() => ({
    pageIndex: r ?? 0,
    pageSize: i ?? 10
  })), [pe, Ce] = So(
    () => s ? [s] : []
  ), [fe, ee] = So(m), [te, ue] = So(
    () => C || {}
  ), [K, oe] = So([]), [de, ve] = So(
    () => B || {
      left: [],
      right: []
    }
  ), J = No(() => {
    const je = [...t], Te = je.some(
      (gt) => (gt == null ? void 0 : gt.id) === nd.id
    ), Fe = je.some(
      (gt) => (gt == null ? void 0 : gt.id) === od.id
    );
    return y && !Te && je.unshift(nd), H && !Fe && je.unshift(od), je;
  }, [t, H, y]), se = Hh({
    data: n,
    columns: J,
    state: {
      pagination: A,
      sorting: pe,
      rowSelection: fe,
      columnVisibility: te,
      columnFilters: K,
      columnPinning: de
    },
    defaultColumn: {
      minSize: 40,
      maxSize: 800
    },
    enableRowSelection: (je) => f ? !f(je) : y,
    enableColumnFilters: v,
    columnResizeMode: "onChange",
    columnResizeDirection: "ltr",
    getRowId: g,
    onRowSelectionChange: ee,
    onPaginationChange: Y,
    onSortingChange: Ce,
    onColumnVisibilityChange: ue,
    onColumnFiltersChange: oe,
    getCoreRowModel: Nh(),
    getSortedRowModel: NA(),
    getPaginationRowModel: AA(),
    onColumnPinningChange: ve,
    ...v && {
      getFilteredRowModel: LA(),
      getFacetedRowModel: VA(),
      // client-side faceting
      getFacetedUniqueValues: $A()
    },
    // generate unique values for select filter/autocomplete
    ...H && {
      getExpandedRowModel: Bh(),
      getRowCanExpand: ce
    },
    autoResetPageIndex: !1,
    meta: {
      updateData: h,
      variant: "uncontrolled"
    },
    // debugTable: true,
    sortDescFirst: !0,
    filterFns: {
      arrIncludesSomeEqual: WA,
      greaterThanZero: GA
    }
  });
  Rn(() => {
    const je = se.getSelectedRowModel().rows, Te = je == null ? void 0 : je.filter((Fe) => !(f != null && f(Fe))).map((Fe) => Fe.original);
    a == null || a(Te, fe);
  }, [a, fe]), Rn(() => {
    var je, Te;
    (je = e.setPagination) == null || je.call(e, A), (Te = e.persistSettings) == null || Te.call(e, "pageSize", A.pageSize);
  }, [A]), Rn(() => {
    if (e.persistSettings) {
      const [je] = pe;
      e.persistSettings("sort", je);
    }
  }, [pe]), Rn(() => {
    e.persistSettings && e.persistSettings("columns", te);
  }, [te]), Rn(() => {
    var je;
    ((je = se.getRowModel().rows) == null ? void 0 : je.length) === 0 && A.pageIndex > 0 && se.firstPage();
  }, [se.getRowModel().rows, A]), Rn(() => {
    !_6.isEqual(m, fe) && ee(m);
  }, [m]), Rn(() => {
    var je;
    if (e.getCurrentPage) {
      const Te = (je = se.getRowModel()) == null ? void 0 : je.flatRows;
      Te && e.getCurrentPage(Te == null ? void 0 : Te.map((Fe) => Fe.original));
    }
  }, [
    A.pageIndex,
    i,
    e.getCurrentPage,
    K,
    n,
    pe
  ]);
  const ge = !!((ye = K == null ? void 0 : K.map((je) => je.value).flat()) != null && ye.length), { searchFilter: Se, otherFilters: we } = UA(
    se.getAllFlatColumns()
  ), me = No(
    () => K.reduce((je, Te) => (je[Te.id] = Te.value, je), {}),
    [K]
  );
  return /* @__PURE__ */ p.jsx(
    Uh,
    {
      hasFilters: ge,
      hasNoData: (e.isInitial || ((Ie = e.data) == null ? void 0 : Ie.length) === 0 || se.getRowModel().rows.length === 0) && !b,
      CustomTableRow: re,
      noDataText: S,
      table: se,
      totalElements: se.getRowCount(),
      filtersDefaultClosed: k,
      showFilterToggle: T,
      disableRowClick: u,
      disableRowSelect: f,
      onRowClick: l,
      onRowHover: c,
      loading: b,
      loadingMessage: E,
      hideSettings: P,
      hideTableOptions: F,
      tableOptionsActions: j,
      settingsOptions: L,
      onSettingsChange: R,
      hidePagination: V,
      withDuplicates: W,
      onScroll: e.onScroll,
      searchComponent: v && Se && /* @__PURE__ */ p.jsx(
        Th,
        {
          ...Se,
          value: me[Se.name],
          onChange: (je) => Se.onChangeFilter([je])
        }
      ),
      className: G,
      renderExpandedRow: ie,
      ref: z,
      children: v && (we == null ? void 0 : we.length) > 0 && /* @__PURE__ */ p.jsx(
        cN,
        {
          width: rd,
          value: me,
          filters: we
        }
      )
    }
  );
};
function sz(e) {
  const {
    table: t,
    title: n,
    disableAllActions: r,
    getDisabledCheckboxCondition: i,
    accessor: s,
    disabled: a,
    // all table actins disabled
    iconMode: l = !1,
    description: c
  } = e, { updateData: u, variant: f, selectedElements: g, totalElements: h } = t.options.meta, y = f === "uncontrolled" ? t.getIsAllRowsSelected() || t.getIsSomeRowsSelected() : !!Object.keys(g || {}).length, v = t.getIsAllPageRowsSelected() || t.getIsSomePageRowsSelected(), m = f === "uncontrolled" ? t.options.data : Object.values(g), b = t.getRowModel().flatRows, C = m.every(
    (F) => i(F)
  ), E = b.every(
    (F) => i(F.original)
  ), S = f === "uncontrolled" || (h || t.getRowCount()) <= 1e5, k = {
    checked: b.every(
      (F) => F.original[s] || i(F.original)
    ) && !E,
    get indeterminate() {
      return b.some((F) => F.original[s]) && !E && !this.checked;
    },
    disabled: a || // all actions in table disabled
    E || // all cells on page are not selectable due to condition in getDisabledCheckboxCondition
    r && !v
    // if there is a prerequisite for updating table row
  }, T = {
    checked: m.every(
      (F) => F[s] || i(F)
    ) && !C,
    get indeterminate() {
      return m.some((F) => F[s]) && !C && !this.checked;
    },
    disabled: a || C || r && !y
  }, P = (F = "all") => (j, L) => {
    let R = [];
    F === "page" ? R = b : R = m, u(
      R.reduce((V, B) => (i(B.original || B) || V.push({
        row: B.original || B,
        columnId: s,
        value: L
      }), V), [])
    );
  };
  return /* @__PURE__ */ p.jsxs(ko, { display: "flex", alignItems: "center", children: [
    l && /* @__PURE__ */ p.jsx(
      _r,
      {
        arrow: !0,
        title: /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(ko, { sx: { paddingBottom: "4px", fontWeight: "bold" }, children: n }),
          /* @__PURE__ */ p.jsx(ko, { component: "text", sx: { whiteSpace: "pre-line" }, children: c })
        ] }),
        placement: "top",
        children: /* @__PURE__ */ p.jsx(SL, { iconName: n, width: 20, sx: { mr: 0.5 } })
      }
    ),
    /* @__PURE__ */ p.jsx(ko, { sx: { display: "inline-block" }, children: /* @__PURE__ */ p.jsx(
      Wh,
      {
        state: {
          page: k,
          all: T
        },
        canSelectAll: S,
        onChange: P
      }
    ) }),
    !l && n
  ] });
}
const az = (e) => e.variant === "controlled" ? /* @__PURE__ */ p.jsx(iN, { ...e, ref: e.ref }) : /* @__PURE__ */ p.jsx(sN, { ...e, ref: e.ref }), aN = (e) => {
  const {
    options: t,
    name: n,
    value: r,
    onChange: i,
    label: s,
    className: a,
    showLabel: l,
    hiddenTags: c = !1,
    isLoading: u
  } = e, { t: f } = ec(), g = He.useCallback(
    (y) => {
      const v = t == null ? void 0 : t.find(
        (b) => (b == null ? void 0 : b.value) === y || (b == null ? void 0 : b.value) === (y == null ? void 0 : y.value)
      ), m = (v == null ? void 0 : v.tag) != null ? "(" + (v == null ? void 0 : v.tag) + ")" : "";
      return v ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        /* @__PURE__ */ p.jsx(
          An,
          {
            component: "span",
            sx: {
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "inline-block",
              whiteSpace: "nowrap"
            },
            children: v == null ? void 0 : v.name
          }
        ),
        " ",
        /* @__PURE__ */ p.jsx(
          An,
          {
            component: "span",
            sx: {
              display: "inline-block",
              width: `${(m.length || 0) * 7.5}px`,
              textAlign: "right"
            },
            children: m
          }
        )
      ] }) : (
        // this option is critical to display predefined filters (for ex in concepts Search "M05")
        y
      );
    },
    [t]
  ), h = He.useCallback(
    (y, v, m, b) => {
      var E;
      const C = "";
      ((E = b == null ? void 0 : b.option) == null ? void 0 : E.value) === C ? i([]) : i(
        v.map((S) => (S == null ? void 0 : S.value) != null ? S.value : S).filter((S) => S !== C)
      );
    },
    [i]
  );
  return /* @__PURE__ */ p.jsxs(Bi, { className: a + " c-multi-select-item", children: [
    l && /* @__PURE__ */ p.jsx("label", { className: "filter-block__head", children: s }),
    /* @__PURE__ */ p.jsx(
      Ph,
      {
        className: n,
        multiple: !0,
        options: u ? [] : t,
        isOptionEqualToValue: (y, v) => (y == null ? void 0 : y.value) === v || y === v,
        value: r || [],
        onChange: h,
        getOptionLabel: (y) => y.name,
        fullWidth: !0,
        loading: u,
        loadingText: f("filters.base.loading_options"),
        filterOptions: {
          matchFrom: "any",
          stringify: (y) => y.name
        },
        renderTags: (y, v) => /* @__PURE__ */ p.jsxs(
          An,
          {
            sx: {
              px: 1,
              fontSize: 14,
              color: "#AAAAAA"
            },
            children: [
              (y == null ? void 0 : y.length) || f("filters.base.none"),
              " ",
              f("filters.base.selected_end")
            ]
          },
          "tag-props"
        ),
        name: "multiselectFilter",
        placeholder: r != null && r.length ? "" : `${f("filters.base.select")} ${typeof s == "string" ? s.toLowerCase() : s}...`,
        OptionComponent: (y, v) => /* @__PURE__ */ Cr(
          "li",
          {
            ...y,
            key: v.value,
            className: `menu-option-${(v == null ? void 0 : v.value) || v} ${y.className}`
          },
          g(v)
        )
      }
    ),
    !c && /* @__PURE__ */ p.jsx(Tn, { container: !0, spacing: 1, pt: 1, className: "filter-options-selected", children: r.map((y, v) => /* @__PURE__ */ p.jsx(Tn, { item: !0, maxWidth: "100%", children: /* @__PURE__ */ p.jsx(
      Mh,
      {
        label: g(y),
        variant: "outlined",
        size: "small",
        color: "primary",
        classes: {
          root: "chip selected-filter-option",
          outlined: "chip-outlined",
          deleteIcon: "chip-delete-outlined remove-item-" + String(y)
        },
        onDelete: () => {
          i(r.filter((m, b) => b != v));
        },
        deleteIcon: /* @__PURE__ */ p.jsx(qn, { iconName: "close", sx: { fontSize: 14 } }),
        sx: {
          ".MuiChip-label": {
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            maxWidth: "100%",
            justifyContent: "space-between"
          }
        }
      }
    ) }, "select-option-" + v)) })
  ] });
}, lN = {
  select: WL,
  radio: HL,
  checkbox: BL,
  value: Th,
  switch: GL,
  multiselect: zL,
  date: _L,
  datetime: YL,
  boolean: aN
}, cN = Jl((e) => {
  const {
    filters: t,
    isLoading: n = !1,
    isReloading: r = !1,
    onChange: i,
    showLabel: s = !0,
    hiddenTags: a = !1,
    value: l = {},
    placeholderSize: c = 6,
    width: u = rd
  } = e;
  return /* @__PURE__ */ p.jsx(
    jL,
    {
      className: e.className + " filters-container",
      sx: {
        width: u
      },
      children: n ? /* @__PURE__ */ p.jsx("div", { className: "backdrop", children: /* @__PURE__ */ p.jsx(UL, { size: c }) }) : t == null ? void 0 : t.map((f) => {
        const g = lN[f.type];
        return g ? /* @__PURE__ */ p.jsx(
          g,
          {
            options: f.options,
            name: f.name,
            label: f.label,
            hiddenTags: a,
            value: l[f.name] || [],
            isLoading: r,
            onChange: (h) => {
              f.onChangeFilter ? f.onChangeFilter(h) : i && i(f.name, h);
            },
            className: "c-filter-panel",
            showLabel: s,
            parseFilter: f.parseFilter
          },
          f.name
        ) : /* @__PURE__ */ p.jsx(He.Fragment, {}, f.name);
      })
    }
  );
}), uN = Z(zp)`
  &.button-group {
    .button-outlined {
      &:hover {
        border-color: ${({ theme: e }) => $s(e)(0.5)};
        z-index: 2;
      }
      &:not(:last-of-type) {
        margin: 0 -1px 0 0;
      }
    }
    .button-text,
    .button-contained {
      border-right: none;
    }
  }
`, lz = (e) => {
  const {
    children: t = "",
    size: n = "small",
    fullWidth: r,
    disabled: i = !1,
    variant: s,
    className: a = "",
    sx: l
  } = e;
  return /* @__PURE__ */ p.jsx(
    uN,
    {
      size: n,
      fullWidth: r,
      disabled: i,
      variant: s,
      className: a,
      classes: {
        root: "button-group",
        contained: "button-group-contained",
        outlined: "button-group-outlined",
        text: "button-group-text",
        disabled: "button-group-disabled",
        groupedContainedHorizontal: "button-group-contained-horizontal",
        groupedOutlinedHorizontal: "button-group-outlined-horizontal"
      },
      sx: l,
      children: t
    }
  );
}, cz = (e) => {
  const {
    id: t,
    name: n = "auto-select",
    options: r,
    value: i,
    onChange: s,
    placeholder: a = "Enter value",
    disabled: l,
    loading: c,
    dontResetOnEnter: u,
    disableClearable: f = !0
  } = e, g = Array.isArray(r) ? r : [], h = (T) => g.find((P) => P.value === T), y = (T) => T == null ? "" : `${T}`, v = (T, P) => (P == null ? void 0 : P.name) ?? y(T), m = (T) => T === "all" || T === "undefined" || isNaN(+T) ? void 0 : +T, [b, C] = He.useState(() => {
    if ([void 0, null, ""].includes(i))
      return g[0] || null;
    {
      const T = h(i);
      return T || {
        name: `${i}`,
        value: i
      };
    }
  }), [E, S] = He.useState(
    () => v(i, b)
  ), k = He.useRef(!1);
  return Rn(() => {
    if (!k.current) {
      k.current = !0;
      return;
    }
    s(m(E));
  }, [E]), /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx(
    kh,
    {
      freeSolo: !0,
      value: b,
      disableClearable: f,
      onChange: (T, P) => {
        T == null || T.code, C(P);
      },
      inputValue: E,
      onInputChange: (T, P) => {
        T == null || T.code, S(y(P));
      },
      id: t,
      name: n,
      placeholder: a,
      disabled: l,
      options: g,
      getOptionLabel: (T) => typeof T == "string" ? T : (T == null ? void 0 : T.name) || "",
      size: e.size,
      isDense: e.size == "small",
      sx: e.sx,
      classes: {
        option: "autocomplete-menu-item",
        root: "autocomplete",
        input: "autocomplete-input",
        inputRoot: "autocomplete-input-root autocomplete-free-solo-root",
        endAdornment: "autocomplete-end-adornment",
        popupIndicator: "autocomplete-open-" + e.className,
        clearIndicator: "autocomplete-clear-" + e.className,
        listbox: "autocomplete-options-" + e.className
      },
      renderInput: (T) => /* @__PURE__ */ p.jsx(
        gc,
        {
          ...T,
          placeholder: a,
          disabled: l,
          onSubmit: (P) => P.preventDefault(),
          InputProps: {
            ...T.InputProps,
            classes: {
              notchedOutline: "autocomplete-notched-outline",
              root: "autocomplete-input-container",
              focused: "autocomplete-focused"
            },
            name: n,
            endAdornment: /* @__PURE__ */ p.jsxs(He.Fragment, { children: [
              c ? /* @__PURE__ */ p.jsx(zs, { color: "secondary", size: 18 }) : null,
              T.InputProps.endAdornment
            ] })
          }
        }
      )
    }
  ) });
};
let dN = { data: "" }, pN = (e) => typeof window == "object" ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : e || dN, fN = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, gN = /\/\*[^]*?\*\/|  +/g, P5 = /\n+/g, Es = (e, t) => {
  let n = "", r = "", i = "";
  for (let s in e) {
    let a = e[s];
    s[0] == "@" ? s[1] == "i" ? n = s + " " + a + ";" : r += s[1] == "f" ? Es(a, s) : s + "{" + Es(a, s[1] == "k" ? "" : t) + "}" : typeof a == "object" ? r += Es(a, t ? t.replace(/([^,])+/g, (l) => s.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (c) => /&/.test(c) ? c.replace(/&/g, l) : l ? l + " " + c : c)) : s) : a != null && (s = /^--/.test(s) ? s : s.replace(/[A-Z]/g, "-$&").toLowerCase(), i += Es.p ? Es.p(s, a) : s + ":" + a + ";");
  }
  return n + (t && i ? t + "{" + i + "}" : i) + r;
}, vi = {}, Yh = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let n in e) t += n + Yh(e[n]);
    return t;
  }
  return e;
}, mN = (e, t, n, r, i) => {
  let s = Yh(e), a = vi[s] || (vi[s] = ((c) => {
    let u = 0, f = 11;
    for (; u < c.length; ) f = 101 * f + c.charCodeAt(u++) >>> 0;
    return "go" + f;
  })(s));
  if (!vi[a]) {
    let c = s !== e ? e : ((u) => {
      let f, g, h = [{}];
      for (; f = fN.exec(u.replace(gN, "")); ) f[4] ? h.shift() : f[3] ? (g = f[3].replace(P5, " ").trim(), h.unshift(h[0][g] = h[0][g] || {})) : h[0][f[1]] = f[2].replace(P5, " ").trim();
      return h[0];
    })(e);
    vi[a] = Es(i ? { ["@keyframes " + a]: c } : c, n ? "" : "." + a);
  }
  let l = n && vi.g ? vi.g : null;
  return n && (vi.g = vi[a]), ((c, u, f, g) => {
    g ? u.data = u.data.replace(g, c) : u.data.indexOf(c) === -1 && (u.data = f ? c + u.data : u.data + c);
  })(vi[a], t, r, l), a;
}, hN = (e, t, n) => e.reduce((r, i, s) => {
  let a = t[s];
  if (a && a.call) {
    let l = a(n), c = l && l.props && l.props.className || /^go/.test(l) && l;
    a = c ? "." + c : l && typeof l == "object" ? l.props ? "" : Es(l, "") : l === !1 ? "" : l;
  }
  return r + i + (a ?? "");
}, "");
function Uf(e) {
  let t = this || {}, n = e.call ? e(t.p) : e;
  return mN(n.unshift ? n.raw ? hN(n, [].slice.call(arguments, 1), t.p) : n.reduce((r, i) => Object.assign(r, i && i.call ? i(t.p) : i), {}) : n, pN(t.target), t.g, t.o, t.k);
}
Uf.bind({ g: 1 });
Uf.bind({ k: 1 });
function vN(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Zh(e, t, n) {
  return t && vN(e.prototype, t), e;
}
function zn() {
  return zn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zn.apply(this, arguments);
}
function qh(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function Sc(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function I5(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var O5 = function() {
  return "";
}, Kh = /* @__PURE__ */ He.createContext({
  enqueueSnackbar: O5,
  closeSnackbar: O5
}), ws = {
  downXs: "@media (max-width:599.95px)",
  upSm: "@media (min-width:600px)"
}, D5 = function(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Yf = function(t) {
  return "" + D5(t.vertical) + D5(t.horizontal);
}, Cu = function(t) {
  return !!t || t === 0;
}, xu = "unmounted", ra = "exited", ia = "entering", pl = "entered", j5 = "exiting", Zf = /* @__PURE__ */ function(e) {
  qh(t, e);
  function t(r) {
    var i;
    i = e.call(this, r) || this;
    var s = r.appear, a;
    return i.appearStatus = null, r.in ? s ? (a = ra, i.appearStatus = ia) : a = pl : r.unmountOnExit || r.mountOnEnter ? a = xu : a = ra, i.state = {
      status: a
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(i, s) {
    var a = i.in;
    return a && s.status === xu ? {
      status: ra
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(i) {
    var s = null;
    if (i !== this.props) {
      var a = this.state.status;
      this.props.in ? a !== ia && a !== pl && (s = ia) : (a === ia || a === pl) && (s = j5);
    }
    this.updateStatus(!1, s);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var i = this.props.timeout, s = i, a = i;
    return i != null && typeof i != "number" && typeof i != "string" && (a = i.exit, s = i.enter), {
      exit: a,
      enter: s
    };
  }, n.updateStatus = function(i, s) {
    i === void 0 && (i = !1), s !== null ? (this.cancelNextCallback(), s === ia ? this.performEnter(i) : this.performExit()) : this.props.unmountOnExit && this.state.status === ra && this.setState({
      status: xu
    });
  }, n.performEnter = function(i) {
    var s = this, a = this.props.enter, l = i, c = this.getTimeouts();
    if (!i && !a) {
      this.safeSetState({
        status: pl
      }, function() {
        s.props.onEntered && s.props.onEntered(s.node, l);
      });
      return;
    }
    this.props.onEnter && this.props.onEnter(this.node, l), this.safeSetState({
      status: ia
    }, function() {
      s.props.onEntering && s.props.onEntering(s.node, l), s.onTransitionEnd(c.enter, function() {
        s.safeSetState({
          status: pl
        }, function() {
          s.props.onEntered && s.props.onEntered(s.node, l);
        });
      });
    });
  }, n.performExit = function() {
    var i = this, s = this.props.exit, a = this.getTimeouts();
    if (!s) {
      this.safeSetState({
        status: ra
      }, function() {
        i.props.onExited && i.props.onExited(i.node);
      });
      return;
    }
    this.props.onExit && this.props.onExit(this.node), this.safeSetState({
      status: j5
    }, function() {
      i.props.onExiting && i.props.onExiting(i.node), i.onTransitionEnd(a.exit, function() {
        i.safeSetState({
          status: ra
        }, function() {
          i.props.onExited && i.props.onExited(i.node);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && this.nextCallback.cancel && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(i, s) {
    s = this.setNextCallback(s), this.setState(i, s);
  }, n.setNextCallback = function(i) {
    var s = this, a = !0;
    return this.nextCallback = function() {
      a && (a = !1, s.nextCallback = null, i());
    }, this.nextCallback.cancel = function() {
      a = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(i, s) {
    this.setNextCallback(s);
    var a = i == null && !this.props.addEndListener;
    if (!this.node || a) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    this.props.addEndListener && this.props.addEndListener(this.node, this.nextCallback), i != null && setTimeout(this.nextCallback, i);
  }, n.render = function() {
    var i = this.state.status;
    if (i === xu)
      return null;
    var s = this.props, a = s.children, l = Sc(s, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return a(i, l);
  }, Zh(t, [{
    key: "node",
    get: function() {
      var i, s = (i = this.props.nodeRef) === null || i === void 0 ? void 0 : i.current;
      if (!s)
        throw new Error("notistack - Custom snackbar is not refForwarding");
      return s;
    }
  }]), t;
}(He.Component);
function sa() {
}
Zf.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: sa,
  onEntering: sa,
  onEntered: sa,
  onExit: sa,
  onExiting: sa,
  onExited: sa
};
function F5(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function lp(e, t) {
  return No(function() {
    return e == null && t == null ? null : function(n) {
      F5(e, n), F5(t, n);
    };
  }, [e, t]);
}
function id(e) {
  var t = e.timeout, n = e.style, r = n === void 0 ? {} : n, i = e.mode;
  return {
    duration: typeof t == "object" ? t[i] || 0 : t,
    easing: r.transitionTimingFunction,
    delay: r.transitionDelay
  };
}
var cp = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Xh = function(t) {
  t.scrollTop = t.scrollTop;
}, V5 = function(t) {
  return Math.round(t) + "ms";
};
function pa(e, t) {
  e === void 0 && (e = ["all"]);
  var n = t || {}, r = n.duration, i = r === void 0 ? 300 : r, s = n.easing, a = s === void 0 ? cp.easeInOut : s, l = n.delay, c = l === void 0 ? 0 : l, u = Array.isArray(e) ? e : [e];
  return u.map(function(f) {
    var g = typeof i == "string" ? i : V5(i), h = typeof c == "string" ? c : V5(c);
    return f + " " + g + " " + a + " " + h;
  }).join(",");
}
function yN(e) {
  return e && e.ownerDocument || document;
}
function Qh(e) {
  var t = yN(e);
  return t.defaultView || window;
}
function bN(e, t) {
  t === void 0 && (t = 166);
  var n;
  function r() {
    for (var i = this, s = arguments.length, a = new Array(s), l = 0; l < s; l++)
      a[l] = arguments[l];
    var c = function() {
      e.apply(i, a);
    };
    clearTimeout(n), n = setTimeout(c, t);
  }
  return r.clear = function() {
    clearTimeout(n);
  }, r;
}
function CN(e, t) {
  var n = t.getBoundingClientRect(), r = Qh(t), i;
  if (t.fakeTransform)
    i = t.fakeTransform;
  else {
    var s = r.getComputedStyle(t);
    i = s.getPropertyValue("-webkit-transform") || s.getPropertyValue("transform");
  }
  var a = 0, l = 0;
  if (i && i !== "none" && typeof i == "string") {
    var c = i.split("(")[1].split(")")[0].split(",");
    a = parseInt(c[4], 10), l = parseInt(c[5], 10);
  }
  switch (e) {
    case "left":
      return "translateX(" + (r.innerWidth + a - n.left) + "px)";
    case "right":
      return "translateX(-" + (n.left + n.width - a) + "px)";
    case "up":
      return "translateY(" + (r.innerHeight + l - n.top) + "px)";
    default:
      return "translateY(-" + (n.top + n.height - l) + "px)";
  }
}
function wu(e, t) {
  if (t) {
    var n = CN(e, t);
    n && (t.style.webkitTransform = n, t.style.transform = n);
  }
}
var Jh = /* @__PURE__ */ Ns(function(e, t) {
  var n = e.children, r = e.direction, i = r === void 0 ? "down" : r, s = e.in, a = e.style, l = e.timeout, c = l === void 0 ? 0 : l, u = e.onEnter, f = e.onEntered, g = e.onExit, h = e.onExited, y = Sc(e, ["children", "direction", "in", "style", "timeout", "onEnter", "onEntered", "onExit", "onExited"]), v = Fs(null), m = lp(n.ref, v), b = lp(m, t), C = function(F, j) {
    wu(i, F), Xh(F), u && u(F, j);
  }, E = function(F) {
    var j = (a == null ? void 0 : a.transitionTimingFunction) || cp.easeOut, L = id({
      timeout: c,
      mode: "enter",
      style: zn({}, a, {
        transitionTimingFunction: j
      })
    });
    F.style.webkitTransition = pa("-webkit-transform", L), F.style.transition = pa("transform", L), F.style.webkitTransform = "none", F.style.transform = "none";
  }, S = function(F) {
    var j = (a == null ? void 0 : a.transitionTimingFunction) || cp.sharp, L = id({
      timeout: c,
      mode: "exit",
      style: zn({}, a, {
        transitionTimingFunction: j
      })
    });
    F.style.webkitTransition = pa("-webkit-transform", L), F.style.transition = pa("transform", L), wu(i, F), g && g(F);
  }, k = function(F) {
    F.style.webkitTransition = "", F.style.transition = "", h && h(F);
  }, T = ns(function() {
    v.current && wu(i, v.current);
  }, [i]);
  return Rn(function() {
    if (!(s || i === "down" || i === "right")) {
      var P = bN(function() {
        v.current && wu(i, v.current);
      }), F = Qh(v.current);
      return F.addEventListener("resize", P), function() {
        P.clear(), F.removeEventListener("resize", P);
      };
    }
  }, [i, s]), Rn(function() {
    s || T();
  }, [s, T]), Cr(Zf, Object.assign({
    appear: !0,
    nodeRef: v,
    onEnter: C,
    onEntered: f,
    onEntering: E,
    onExit: S,
    onExited: k,
    in: s,
    timeout: c
  }, y), function(P, F) {
    return Sl(n, zn({
      ref: b,
      style: zn({
        visibility: P === "exited" && !s ? "hidden" : void 0
      }, a, {}, n.props.style)
    }, F));
  });
});
Jh.displayName = "Slide";
var n1 = function(t) {
  return He.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    focusable: "false",
    style: {
      fontSize: 20,
      marginInlineEnd: 8,
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0
    }
  }, t));
}, xN = function() {
  return He.createElement(n1, null, He.createElement("path", {
    d: `M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41
        10.59L10 14.17L17.59 6.58L19 8L10 17Z`
  }));
}, wN = function() {
  return He.createElement(n1, null, He.createElement("path", {
    d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
  }));
}, SN = function() {
  return He.createElement(n1, null, He.createElement("path", {
    d: `M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,
        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,
        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z`
  }));
}, EN = function() {
  return He.createElement(n1, null, He.createElement("path", {
    d: `M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,
        0 22,12A10,10 0 0,0 12,2Z`
  }));
}, RN = {
  default: void 0,
  success: /* @__PURE__ */ He.createElement(xN, null),
  warning: /* @__PURE__ */ He.createElement(wN, null),
  error: /* @__PURE__ */ He.createElement(SN, null),
  info: /* @__PURE__ */ He.createElement(EN, null)
}, js = {
  maxSnack: 3,
  persist: !1,
  hideIconVariant: !1,
  disableWindowBlurListener: !1,
  variant: "default",
  autoHideDuration: 5e3,
  iconVariant: RN,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  TransitionComponent: Jh,
  transitionDuration: {
    enter: 225,
    exit: 195
  }
}, TN = function(t, n) {
  var r = function(s) {
    return typeof s == "number" || s === null;
  };
  return r(t) ? t : r(n) ? n : js.autoHideDuration;
}, MN = function(t, n) {
  var r = function(s, a) {
    return a.some(function(l) {
      return typeof s === l;
    });
  };
  return r(t, ["string", "number"]) ? t : r(t, ["object"]) ? zn({}, js.transitionDuration, {}, r(n, ["object"]) && n, {}, t) : r(n, ["string", "number"]) ? n : r(n, ["object"]) ? zn({}, js.transitionDuration, {}, n) : js.transitionDuration;
}, kN = function(t, n) {
  return function(r, i) {
    return i === void 0 && (i = !1), i ? zn({}, js[r], {}, n[r], {}, t[r]) : r === "autoHideDuration" ? TN(t.autoHideDuration, n.autoHideDuration) : r === "transitionDuration" ? MN(t.transitionDuration, n.transitionDuration) : t[r] || n[r] || js[r];
  };
};
function Ec(e) {
  return Object.entries(e).reduce(function(t, n) {
    var r, i = n[0], s = n[1];
    return zn({}, t, (r = {}, r[i] = Uf(s), r));
  }, {});
}
var ka = {
  SnackbarContainer: "notistack-SnackbarContainer",
  Snackbar: "notistack-Snackbar",
  CollapseWrapper: "notistack-CollapseWrapper",
  MuiContent: "notistack-MuiContent",
  MuiContentVariant: function(t) {
    return "notistack-MuiContent-" + t;
  }
}, $5 = /* @__PURE__ */ Ec({
  root: {
    height: 0
  },
  entered: {
    height: "auto"
  }
}), d0 = "0px", p0 = 175, e6 = /* @__PURE__ */ Ns(function(e, t) {
  var n = e.children, r = e.in, i = e.onExited, s = Fs(null), a = Fs(null), l = lp(t, a), c = function() {
    return s.current ? s.current.clientHeight : 0;
  }, u = function(m) {
    m.style.height = d0;
  }, f = function(m) {
    var b = c(), C = id({
      timeout: p0,
      mode: "enter"
    }), E = C.duration, S = C.easing;
    m.style.transitionDuration = typeof E == "string" ? E : E + "ms", m.style.height = b + "px", m.style.transitionTimingFunction = S || "";
  }, g = function(m) {
    m.style.height = "auto";
  }, h = function(m) {
    m.style.height = c() + "px";
  }, y = function(m) {
    Xh(m);
    var b = id({
      timeout: p0,
      mode: "exit"
    }), C = b.duration, E = b.easing;
    m.style.transitionDuration = typeof C == "string" ? C : C + "ms", m.style.height = d0, m.style.transitionTimingFunction = E || "";
  };
  return Cr(Zf, {
    in: r,
    unmountOnExit: !0,
    onEnter: u,
    onEntered: g,
    onEntering: f,
    onExit: h,
    onExited: i,
    onExiting: y,
    nodeRef: a,
    timeout: p0
  }, function(v, m) {
    return Cr("div", Object.assign({
      ref: l,
      className: xe($5.root, v === "entered" && $5.entered),
      style: zn({
        pointerEvents: "all",
        overflow: "hidden",
        minHeight: d0,
        transition: pa("height")
      }, v === "entered" && {
        overflow: "visible"
      }, {}, v === "exited" && !r && {
        visibility: "hidden"
      })
    }, m), Cr("div", {
      ref: s,
      className: ka.CollapseWrapper,
      // Hack to get children with a negative margin to not falsify the height computation.
      style: {
        display: "flex",
        width: "100%"
      }
    }, n));
  });
});
e6.displayName = "Collapse";
var L5 = {
  right: "left",
  left: "right",
  bottom: "up",
  top: "down"
}, PN = function(t) {
  return t.horizontal !== "center" ? L5[t.horizontal] : L5[t.vertical];
}, IN = function(t) {
  return "anchorOrigin" + Yf(t);
}, ON = function(t) {
  t === void 0 && (t = {});
  var n = {
    containerRoot: !0,
    containerAnchorOriginTopCenter: !0,
    containerAnchorOriginBottomCenter: !0,
    containerAnchorOriginTopRight: !0,
    containerAnchorOriginBottomRight: !0,
    containerAnchorOriginTopLeft: !0,
    containerAnchorOriginBottomLeft: !0
  };
  return Object.keys(t).filter(function(r) {
    return !n[r];
  }).reduce(function(r, i) {
    var s;
    return zn({}, r, (s = {}, s[i] = t[i], s));
  }, {});
}, DN = function() {
};
function $l(e, t) {
  return e.reduce(function(n, r) {
    return r == null ? n : function() {
      for (var s = arguments.length, a = new Array(s), l = 0; l < s; l++)
        a[l] = arguments[l];
      var c = [].concat(a);
      t && c.indexOf(t) === -1 && c.push(t), n.apply(this, c), r.apply(this, c);
    };
  }, DN);
}
var jN = typeof window < "u" ? Y5 : Rn;
function A5(e) {
  var t = Fs(e);
  return jN(function() {
    t.current = e;
  }), ns(function() {
    return (
      // @ts-expect-error hide `this`
      t.current.apply(void 0, arguments)
    );
  }, []);
}
var t6 = /* @__PURE__ */ Ns(function(e, t) {
  var n = e.children, r = e.className, i = e.autoHideDuration, s = e.disableWindowBlurListener, a = s === void 0 ? !1 : s, l = e.onClose, c = e.id, u = e.open, f = e.SnackbarProps, g = f === void 0 ? {} : f, h = Fs(), y = A5(function() {
    l && l.apply(void 0, arguments);
  }), v = A5(function(S) {
    !l || S == null || (h.current && clearTimeout(h.current), h.current = setTimeout(function() {
      y(null, "timeout", c);
    }, S));
  });
  Rn(function() {
    return u && v(i), function() {
      h.current && clearTimeout(h.current);
    };
  }, [u, i, v]);
  var m = function() {
    h.current && clearTimeout(h.current);
  }, b = ns(function() {
    i != null && v(i * 0.5);
  }, [i, v]), C = function(k) {
    g.onMouseEnter && g.onMouseEnter(k), m();
  }, E = function(k) {
    g.onMouseLeave && g.onMouseLeave(k), b();
  };
  return Rn(function() {
    if (!a && u)
      return window.addEventListener("focus", b), window.addEventListener("blur", m), function() {
        window.removeEventListener("focus", b), window.removeEventListener("blur", m);
      };
  }, [a, b, u]), Cr("div", Object.assign({
    ref: t
  }, g, {
    className: xe(ka.Snackbar, r),
    onMouseEnter: C,
    onMouseLeave: E
  }), n);
});
t6.displayName = "Snackbar";
var f0, FN = /* @__PURE__ */ Ec({
  root: (f0 = {
    display: "flex",
    flexWrap: "wrap",
    flexGrow: 1
  }, f0[ws.upSm] = {
    flexGrow: "initial",
    minWidth: "288px"
  }, f0)
}), n6 = /* @__PURE__ */ Ns(function(e, t) {
  var n = e.className, r = Sc(e, ["className"]);
  return He.createElement("div", Object.assign({
    ref: t,
    className: xe(FN.root, n)
  }, r));
});
n6.displayName = "SnackbarContent";
var fl = /* @__PURE__ */ Ec({
  root: {
    backgroundColor: "#313131",
    fontSize: "0.875rem",
    lineHeight: 1.43,
    letterSpacing: "0.01071em",
    color: "#fff",
    alignItems: "center",
    padding: "6px 16px",
    borderRadius: "4px",
    boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
  },
  lessPadding: {
    paddingLeft: 8 * 2.5 + "px"
  },
  default: {
    backgroundColor: "#313131"
  },
  success: {
    backgroundColor: "#43a047"
  },
  error: {
    backgroundColor: "#d32f2f"
  },
  warning: {
    backgroundColor: "#ff9800"
  },
  info: {
    backgroundColor: "#2196f3"
  },
  message: {
    display: "flex",
    alignItems: "center",
    padding: "8px 0"
  },
  action: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: "16px",
    marginRight: "-8px"
  }
}), N5 = "notistack-snackbar", o6 = /* @__PURE__ */ Ns(function(e, t) {
  var n = e.id, r = e.message, i = e.action, s = e.iconVariant, a = e.variant, l = e.hideIconVariant, c = e.style, u = e.className, f = s[a], g = i;
  return typeof g == "function" && (g = g(n)), He.createElement(n6, {
    ref: t,
    role: "alert",
    "aria-describedby": N5,
    style: c,
    className: xe(ka.MuiContent, ka.MuiContentVariant(a), fl.root, fl[a], u, !l && f && fl.lessPadding)
  }, He.createElement("div", {
    id: N5,
    className: fl.message
  }, l ? null : f, r), g && He.createElement("div", {
    className: fl.action
  }, g));
});
o6.displayName = "MaterialDesignContent";
var VN = /* @__PURE__ */ Jl(o6), $N = /* @__PURE__ */ Ec({
  wrappedRoot: {
    width: "100%",
    position: "relative",
    transform: "translateX(0)",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    minWidth: "288px"
  }
}), LN = function(t) {
  var n = Fs(), r = So(!0), i = r[0], s = r[1], a = $l([t.snack.onClose, t.onClose]), l = function() {
    t.snack.requestClose && a(null, "instructed", t.snack.id);
  }, c = ns(function() {
    n.current = setTimeout(function() {
      s(function(L) {
        return !L;
      });
    }, 125);
  }, []);
  Rn(function() {
    return function() {
      n.current && clearTimeout(n.current);
    };
  }, []);
  var u = t.snack, f = t.classes, g = t.Component, h = g === void 0 ? VN : g, y = No(function() {
    return ON(f);
  }, [f]), v = u.open, m = u.SnackbarProps, b = u.TransitionComponent, C = u.TransitionProps, E = u.transitionDuration, S = u.disableWindowBlurListener, k = u.content, T = Sc(u, ["open", "SnackbarProps", "TransitionComponent", "TransitionProps", "transitionDuration", "disableWindowBlurListener", "content", "entered", "requestClose", "onEnter", "onEntered", "onExit", "onExited"]), P = zn({
    direction: PN(T.anchorOrigin),
    timeout: E
  }, C), F = k;
  typeof F == "function" && (F = F(T.id, T.message));
  var j = ["onEnter", "onEntered", "onExit", "onExited"].reduce(function(L, R) {
    var V;
    return zn({}, L, (V = {}, V[R] = $l([t.snack[R], t[R]], T.id), V));
  }, {});
  return He.createElement(e6, {
    in: i,
    onExited: j.onExited
  }, He.createElement(t6, {
    open: v,
    id: T.id,
    disableWindowBlurListener: S,
    autoHideDuration: T.autoHideDuration,
    className: xe($N.wrappedRoot, y.root, y[IN(T.anchorOrigin)]),
    SnackbarProps: m,
    onClose: a
  }, He.createElement(b, Object.assign({}, P, {
    appear: !0,
    in: v,
    onExit: j.onExit,
    onExited: c,
    onEnter: j.onEnter,
    // order matters. first callbacks.onEntered to set entered: true,
    // then handleEntered to check if there's a request for closing
    onEntered: $l([j.onEntered, l], T.id)
  }), F || He.createElement(h, Object.assign({}, T)))));
}, gl, g0, Su, Eu, m0, yi = {
  view: {
    default: 20
  },
  snackbar: {
    default: 6,
    dense: 2
  }
}, B5 = "." + ka.CollapseWrapper, h0 = 16, Ru = /* @__PURE__ */ Ec({
  root: (gl = {
    boxSizing: "border-box",
    display: "flex",
    maxHeight: "100%",
    position: "fixed",
    zIndex: 1400,
    height: "auto",
    width: "auto",
    transition: /* @__PURE__ */ pa(["top", "right", "bottom", "left", "max-width"], {
      duration: 300,
      easing: "ease"
    }),
    // container itself is invisible and should not block clicks, clicks should be passed to its children
    // a pointerEvents: all is applied in the collapse component
    pointerEvents: "none"
  }, gl[B5] = {
    padding: yi.snackbar.default + "px 0px",
    transition: "padding 300ms ease 0ms"
  }, gl.maxWidth = "calc(100% - " + yi.view.default * 2 + "px)", gl[ws.downXs] = {
    width: "100%",
    maxWidth: "calc(100% - " + h0 * 2 + "px)"
  }, gl),
  rootDense: (g0 = {}, g0[B5] = {
    padding: yi.snackbar.dense + "px 0px"
  }, g0),
  top: {
    top: yi.view.default - yi.snackbar.default + "px",
    flexDirection: "column"
  },
  bottom: {
    bottom: yi.view.default - yi.snackbar.default + "px",
    flexDirection: "column-reverse"
  },
  left: (Su = {
    left: yi.view.default + "px"
  }, Su[ws.upSm] = {
    alignItems: "flex-start"
  }, Su[ws.downXs] = {
    left: h0 + "px"
  }, Su),
  right: (Eu = {
    right: yi.view.default + "px"
  }, Eu[ws.upSm] = {
    alignItems: "flex-end"
  }, Eu[ws.downXs] = {
    right: h0 + "px"
  }, Eu),
  center: (m0 = {
    left: "50%",
    transform: "translateX(-50%)"
  }, m0[ws.upSm] = {
    alignItems: "center"
  }, m0)
}), AN = function(t) {
  var n = t.classes, r = n === void 0 ? {} : n, i = t.anchorOrigin, s = t.dense, a = t.children, l = xe(
    ka.SnackbarContainer,
    Ru[i.vertical],
    Ru[i.horizontal],
    Ru.root,
    // root should come after others to override maxWidth
    r.containerRoot,
    r["containerAnchorOrigin" + Yf(i)],
    s && Ru.rootDense
  );
  return He.createElement("div", {
    className: l
  }, a);
}, NN = /* @__PURE__ */ Jl(AN), BN = process.env.NODE_ENV !== "production", _N = {
  NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
}, zN = function(e) {
  if (BN) {
    var t = _N[e];
    typeof console < "u" && console.error("WARNING - notistack: " + t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}, _5 = function(t) {
  var n = typeof t == "string" || wl(t);
  return !n;
}, r6, HN = /* @__PURE__ */ function(e) {
  qh(t, e);
  function t(r) {
    var i;
    return i = e.call(this, r) || this, i.enqueueSnackbar = function(s, a) {
      if (a === void 0 && (a = {}), s == null)
        throw new Error("enqueueSnackbar called with invalid argument");
      var l = _5(s) ? s : a, c = _5(s) ? s.message : s, u = l.key, f = l.preventDuplicate, g = Sc(l, ["key", "preventDuplicate"]), h = Cu(u), y = h ? u : (/* @__PURE__ */ new Date()).getTime() + Math.random(), v = kN(g, i.props), m = zn({
        id: y
      }, g, {
        message: c,
        open: !0,
        entered: !1,
        requestClose: !1,
        persist: v("persist"),
        action: v("action"),
        content: v("content"),
        variant: v("variant"),
        anchorOrigin: v("anchorOrigin"),
        disableWindowBlurListener: v("disableWindowBlurListener"),
        autoHideDuration: v("autoHideDuration"),
        hideIconVariant: v("hideIconVariant"),
        TransitionComponent: v("TransitionComponent"),
        transitionDuration: v("transitionDuration"),
        TransitionProps: v("TransitionProps", !0),
        iconVariant: v("iconVariant", !0),
        style: v("style", !0),
        SnackbarProps: v("SnackbarProps", !0),
        className: xe(i.props.className, g.className)
      });
      return m.persist && (m.autoHideDuration = void 0), i.setState(function(b) {
        if (f === void 0 && i.props.preventDuplicate || f) {
          var C = function(T) {
            return h ? T.id === y : T.message === c;
          }, E = b.queue.findIndex(C) > -1, S = b.snacks.findIndex(C) > -1;
          if (E || S)
            return b;
        }
        return i.handleDisplaySnack(zn({}, b, {
          queue: [].concat(b.queue, [m])
        }));
      }), y;
    }, i.handleDisplaySnack = function(s) {
      var a = s.snacks;
      return a.length >= i.maxSnack ? i.handleDismissOldest(s) : i.processQueue(s);
    }, i.processQueue = function(s) {
      var a = s.queue, l = s.snacks;
      return a.length > 0 ? zn({}, s, {
        snacks: [].concat(l, [a[0]]),
        queue: a.slice(1, a.length)
      }) : s;
    }, i.handleDismissOldest = function(s) {
      if (s.snacks.some(function(f) {
        return !f.open || f.requestClose;
      }))
        return s;
      var a = !1, l = !1, c = s.snacks.reduce(function(f, g) {
        return f + (g.open && g.persist ? 1 : 0);
      }, 0);
      c === i.maxSnack && (process.env.NODE_ENV !== "production" && zN("NO_PERSIST_ALL"), l = !0);
      var u = s.snacks.map(function(f) {
        return !a && (!f.persist || l) ? (a = !0, f.entered ? (f.onClose && f.onClose(null, "maxsnack", f.id), i.props.onClose && i.props.onClose(null, "maxsnack", f.id), zn({}, f, {
          open: !1
        })) : zn({}, f, {
          requestClose: !0
        })) : zn({}, f);
      });
      return zn({}, s, {
        snacks: u
      });
    }, i.handleEnteredSnack = function(s, a, l) {
      if (!Cu(l))
        throw new Error("handleEnteredSnack Cannot be called with undefined key");
      i.setState(function(c) {
        var u = c.snacks;
        return {
          snacks: u.map(function(f) {
            return f.id === l ? zn({}, f, {
              entered: !0
            }) : zn({}, f);
          })
        };
      });
    }, i.handleCloseSnack = function(s, a, l) {
      i.props.onClose && i.props.onClose(s, a, l);
      var c = l === void 0;
      i.setState(function(u) {
        var f = u.snacks, g = u.queue;
        return {
          snacks: f.map(function(h) {
            return !c && h.id !== l ? zn({}, h) : h.entered ? zn({}, h, {
              open: !1
            }) : zn({}, h, {
              requestClose: !0
            });
          }),
          queue: g.filter(function(h) {
            return h.id !== l;
          })
        };
      });
    }, i.closeSnackbar = function(s) {
      var a = i.state.snacks.find(function(l) {
        return l.id === s;
      });
      Cu(s) && a && a.onClose && a.onClose(null, "instructed", s), i.handleCloseSnack(null, "instructed", s);
    }, i.handleExitedSnack = function(s, a) {
      if (!Cu(a))
        throw new Error("handleExitedSnack Cannot be called with undefined key");
      i.setState(function(l) {
        var c = i.processQueue(zn({}, l, {
          snacks: l.snacks.filter(function(u) {
            return u.id !== a;
          })
        }));
        return c.queue.length === 0 ? c : i.handleDismissOldest(c);
      });
    }, r6 = i.enqueueSnackbar, i.closeSnackbar, i.state = {
      snacks: [],
      queue: [],
      contextValue: {
        enqueueSnackbar: i.enqueueSnackbar.bind(I5(i)),
        closeSnackbar: i.closeSnackbar.bind(I5(i))
      }
    }, i;
  }
  var n = t.prototype;
  return n.render = function() {
    var i = this, s = this.state.contextValue, a = this.props, l = a.domRoot, c = a.children, u = a.dense, f = u === void 0 ? !1 : u, g = a.Components, h = g === void 0 ? {} : g, y = a.classes, v = this.state.snacks.reduce(function(b, C) {
      var E, S = Yf(C.anchorOrigin), k = b[S] || [];
      return zn({}, b, (E = {}, E[S] = [].concat(k, [C]), E));
    }, {}), m = Object.keys(v).map(function(b) {
      var C = v[b], E = C[0];
      return He.createElement(NN, {
        key: b,
        dense: f,
        anchorOrigin: E.anchorOrigin,
        classes: y
      }, C.map(function(S) {
        return He.createElement(LN, {
          key: S.id,
          snack: S,
          classes: y,
          Component: h[S.variant],
          onClose: i.handleCloseSnack,
          onEnter: i.props.onEnter,
          onExit: i.props.onExit,
          onExited: $l([i.handleExitedSnack, i.props.onExited], S.id),
          onEntered: $l([i.handleEnteredSnack, i.props.onEntered], S.id)
        });
      }));
    });
    return He.createElement(Kh.Provider, {
      value: s
    }, c, l ? B6(m, l) : m);
  }, Zh(t, [{
    key: "maxSnack",
    get: function() {
      return this.props.maxSnack || js.maxSnack;
    }
  }]), t;
}($6), uz = function() {
  return V6(Kh);
};
const ml = Ns(
  (e, t) => {
    const n = He.useMemo(
      () => e.onClose ? () => e.onClose(e.id) : null,
      [e.onClose, e.id]
    );
    return /* @__PURE__ */ p.jsx(
      z4,
      {
        ref: t,
        severity: ["error", "info", "success", "warning"].includes(e.variant) ? e.variant : "success",
        variant: "standard",
        onClose: n,
        children: e.message
      },
      e.id
    );
  }
), WN = {
  root: {
    '& [class*="MuiCollapse-wrapper"]': {
      justifyContent: "flex-end"
    }
  }
}, dz = (e) => /* @__PURE__ */ p.jsx(
  HN,
  {
    maxSnack: e.maxSnack,
    anchorOrigin: e.anchorOrigin,
    classes: {
      containerRoot: WN.root
    },
    Components: {
      default: ml,
      success: ml,
      error: ml,
      info: ml,
      warning: ml
    },
    children: e.children
  }
), GN = (e) => ({
  "&.dialog-component .dialog-component-layout": {
    borderRadius: e.shape.borderRadius + "px"
  }
}), pz = (e) => /* @__PURE__ */ p.jsx(
  Gp,
  {
    ...e,
    sx: GN,
    classes: {
      root: "dialog-component",
      paper: "dialog-component-layout"
    }
  }
);
function i6(e) {
  return Kn;
}
function UN(e) {
  return uo("MuiSimpleTreeView", e);
}
po("MuiSimpleTreeView", ["root"]);
const YN = (e, t) => {
  const n = d.useRef({}), [r, i] = d.useState(() => {
    const a = {};
    return e.forEach((l) => {
      l.models && Object.entries(l.models).forEach(([c, u]) => {
        n.current[c] = {
          isControlled: t[c] !== void 0,
          getDefaultValue: u.getDefaultValue
        }, a[c] = u.getDefaultValue(t);
      });
    }), a;
  }), s = Object.fromEntries(Object.entries(n.current).map(([a, l]) => {
    const c = t[a] ?? r[a];
    return [a, {
      value: c,
      setControlledValue: (u) => {
        l.isControlled || i((f) => Q({}, f, {
          [a]: u
        }));
      }
    }];
  }));
  return process.env.NODE_ENV !== "production" && Object.entries(n.current).forEach(([a, l]) => {
    const c = t[a], u = l.getDefaultValue(t);
    d.useEffect(() => {
      l.isControlled !== (c !== void 0) && console.error([`MUI X: A component is changing the ${l.isControlled ? "" : "un"}controlled ${a} state of TreeView to be ${l.isControlled ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${a} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [c]);
    const {
      current: f
    } = d.useRef(u);
    d.useEffect(() => {
      !l.isControlled && f !== u && console.error([`MUI X: A component is changing the default ${a} state of an uncontrolled TreeView after being initialized. To suppress this warning opt to use a controlled TreeView.`].join(`
`));
    }, [JSON.stringify(u)]);
  }), s;
};
class ZN {
  constructor() {
    this.maxListeners = 20, this.warnOnce = !1, this.events = {};
  }
  on(t, n, r = {}) {
    let i = this.events[t];
    if (i || (i = {
      highPriority: /* @__PURE__ */ new Map(),
      regular: /* @__PURE__ */ new Map()
    }, this.events[t] = i), r.isFirst ? i.highPriority.set(n, !0) : i.regular.set(n, !0), process.env.NODE_ENV !== "production") {
      const s = i.highPriority.size + i.regular.size;
      s > this.maxListeners && !this.warnOnce && (this.warnOnce = !0, console.warn([`Possible EventEmitter memory leak detected. ${s} ${t} listeners added.`].join(`
`)));
    }
  }
  removeListener(t, n) {
    this.events[t] && (this.events[t].regular.delete(n), this.events[t].highPriority.delete(n));
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(t, ...n) {
    const r = this.events[t];
    if (!r)
      return;
    const i = Array.from(r.highPriority.keys()), s = Array.from(r.regular.keys());
    for (let a = i.length - 1; a >= 0; a -= 1) {
      const l = i[a];
      r.highPriority.has(l) && l.apply(this, n);
    }
    for (let a = 0; a < s.length; a += 1) {
      const l = s[a];
      r.regular.has(l) && l.apply(this, n);
    }
  }
  once(t, n) {
    const r = this;
    this.on(t, function i(...s) {
      r.removeListener(t, i), n.apply(r, s);
    });
  }
}
const qN = (e) => e.isPropagationStopped !== void 0, s6 = () => {
  const [e] = d.useState(() => new ZN()), t = d.useCallback((...r) => {
    const [i, s, a = {}] = r;
    a.defaultMuiPrevented = !1, !(qN(a) && a.isPropagationStopped()) && e.emit(i, s, a);
  }, [e]), n = d.useCallback((r, i) => (e.on(r, i), () => {
    e.removeListener(r, i);
  }), [e]);
  return {
    instance: {
      $$publishEvent: t,
      $$subscribeEvent: n
    }
  };
};
s6.params = {};
const a6 = ({
  plugins: e
}) => {
  const t = new Set(e);
  return {
    instance: {
      getAvailablePlugins: () => t
    }
  };
};
a6.params = {};
let z5 = 0;
const KN = () => (z5 += 1, `mui-tree-view-${z5}`), o1 = ({
  id: e,
  treeId: t = "",
  itemId: n
}) => e ?? `${t}-${n}`, qf = ({
  params: e,
  state: t,
  setState: n
}) => {
  d.useEffect(() => {
    n((i) => i.id.treeId === e.id && i.id.treeId !== void 0 ? i : Q({}, i, {
      id: Q({}, i.id, {
        treeId: e.id ?? KN()
      })
    }));
  }, [n, e.id]);
  const r = e.id ?? t.id.treeId;
  return {
    getRootProps: () => ({
      id: r
    }),
    contextValue: {
      treeId: r
    }
  };
};
qf.params = {
  id: !0
};
qf.getInitialState = ({
  id: e
}) => ({
  id: {
    treeId: e ?? void 0
  }
});
const XN = [s6, a6, qf], QN = ["slots", "slotProps", "apiRef", "experimentalFeatures"], JN = (e) => {
  let {
    props: {
      slots: t,
      slotProps: n,
      apiRef: r,
      experimentalFeatures: i
    },
    plugins: s
  } = e, a = Zt(e.props, QN);
  const l = {};
  s.forEach((h) => {
    Object.assign(l, h.params);
  });
  const c = {}, u = {};
  Object.keys(a).forEach((h) => {
    const y = a[h];
    l[h] ? c[h] = y : u[h] = y;
  });
  const f = i ?? {}, g = s.reduce((h, y) => y.getDefaultizedParams ? y.getDefaultizedParams({
    params: h,
    experimentalFeatures: f
  }) : h, c);
  return {
    apiRef: r,
    forwardedProps: u,
    pluginParams: g,
    slots: t ?? {},
    slotProps: n ?? {},
    experimentalFeatures: f
  };
}, eB = ({
  plugins: e,
  instance: t,
  publicAPI: n,
  rootRef: r
}) => ({
  runItemPlugins: (l) => {
    let c = null, u = null;
    const f = [], g = {};
    e.forEach((v) => {
      if (!v.itemPlugin)
        return;
      const m = v.itemPlugin({
        props: l,
        rootRef: c,
        contentRef: u
      });
      m != null && m.rootRef && (c = m.rootRef), m != null && m.contentRef && (u = m.contentRef), m != null && m.propsEnhancers && (f.push(m.propsEnhancers), Object.keys(m.propsEnhancers).forEach((b) => {
        g[b] = !0;
      }));
    });
    const h = (v) => (m) => {
      const b = {};
      return f.forEach((C) => {
        const E = C[v];
        E != null && Object.assign(b, E(m));
      }), b;
    }, y = Object.fromEntries(Object.keys(g).map((v) => [v, h(v)]));
    return {
      contentRef: u,
      rootRef: c,
      propsEnhancers: y
    };
  },
  wrapItem: ({
    itemId: l,
    children: c
  }) => {
    let u = c;
    for (let f = e.length - 1; f >= 0; f -= 1) {
      const g = e[f];
      g.wrapItem && (u = g.wrapItem({
        itemId: l,
        children: u,
        instance: t
      }));
    }
    return u;
  },
  wrapRoot: ({
    children: l
  }) => {
    let c = l;
    for (let u = e.length - 1; u >= 0; u -= 1) {
      const f = e[u];
      f.wrapRoot && (c = f.wrapRoot({
        children: c,
        instance: t
      }));
    }
    return c;
  },
  instance: t,
  rootRef: r,
  publicAPI: n
});
function tB(e) {
  const t = d.useRef({});
  return e ? (e.current == null && (e.current = {}), e.current) : t.current;
}
const nB = ({
  plugins: e,
  rootRef: t,
  props: n
}) => {
  const r = [...XN, ...e], {
    pluginParams: i,
    forwardedProps: s,
    apiRef: a,
    experimentalFeatures: l,
    slots: c,
    slotProps: u
  } = JN({
    plugins: r,
    props: n
  }), f = YN(r, i), h = d.useRef({}).current, y = tB(a), v = d.useRef(null), m = Vo(v, t), b = eB({
    plugins: r,
    instance: h,
    publicAPI: y,
    rootRef: v
  }), [C, E] = d.useState(() => {
    const P = {};
    return r.forEach((F) => {
      F.getInitialState && Object.assign(P, F.getInitialState(i));
    }), P;
  }), S = [], k = (P) => {
    const F = P({
      instance: h,
      params: i,
      slots: c,
      slotProps: u,
      experimentalFeatures: l,
      state: C,
      setState: E,
      rootRef: v,
      models: f,
      plugins: r
    });
    F.getRootProps && S.push(F.getRootProps), F.publicAPI && Object.assign(y, F.publicAPI), F.instance && Object.assign(h, F.instance), F.contextValue && Object.assign(b, F.contextValue);
  };
  return r.forEach(k), {
    getRootProps: (P = {}) => {
      const F = Q({
        role: "tree"
      }, s, P, {
        ref: m
      });
      return S.forEach((j) => {
        Object.assign(F, j(P));
      }), F;
    },
    rootRef: m,
    contextValue: b,
    instance: h
  };
}, Kf = /* @__PURE__ */ d.createContext(null);
process.env.NODE_ENV !== "production" && (Kf.displayName = "TreeViewContext");
function oB(e) {
  const {
    value: t,
    children: n
  } = e;
  return /* @__PURE__ */ p.jsx(Kf.Provider, {
    value: t,
    children: t.wrapRoot({
      children: n,
      instance: t.instance
    })
  });
}
const Fa = () => {
  const e = d.useContext(Kf);
  if (e == null)
    throw new Error(["MUI X: Could not find the Tree View context.", "It looks like you rendered your component outside of a SimpleTreeView or RichTreeView parent component.", "This can also happen if you are bundling multiple versions of the Tree View."].join(`
`));
  return e;
}, l6 = (e, t, n) => {
  e.$$publishEvent(t, n);
}, Ps = "__TREE_VIEW_ROOT_PARENT_ID__", c6 = (e) => {
  const t = {};
  return e.forEach((n, r) => {
    t[n] = r;
  }), t;
}, Pa = /* @__PURE__ */ d.createContext(() => -1);
process.env.NODE_ENV !== "production" && (Pa.displayName = "TreeViewItemDepthContext");
const rB = ["children"], u6 = ({
  items: e,
  isItemDisabled: t,
  getItemLabel: n,
  getItemId: r
}) => {
  const i = {}, s = {}, a = {
    [Ps]: []
  }, l = (u, f, g) => {
    var m, b;
    const h = r ? r(u) : u.id;
    if (h == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", "An item was provided without id in the `items` prop:", JSON.stringify(u)].join(`
`));
    if (i[h] != null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", `Two items were provided with the same id in the \`items\` prop: "${h}"`].join(`
`));
    const y = n ? n(u) : u.label;
    if (y == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "Alternatively, you can use the `getItemLabel` prop to specify a custom label for each item.", "An item was provided without label in the `items` prop:", JSON.stringify(u)].join(`
`));
    i[h] = {
      id: h,
      label: y,
      parentId: g,
      idAttribute: void 0,
      expandable: !!((m = u.children) != null && m.length),
      disabled: t ? t(u) : !1,
      depth: f
    }, s[h] = u;
    const v = g ?? Ps;
    a[v] || (a[v] = []), a[v].push(h), (b = u.children) == null || b.forEach((C) => l(C, f + 1, h));
  };
  e.forEach((u) => l(u, 0, null));
  const c = {};
  return Object.keys(a).forEach((u) => {
    c[u] = c6(a[u]);
  }), {
    itemMetaMap: i,
    itemMap: s,
    itemOrderedChildrenIds: a,
    itemChildrenIndexes: c
  };
}, Rc = ({
  instance: e,
  params: t,
  state: n,
  setState: r,
  experimentalFeatures: i
}) => {
  const s = d.useCallback((C) => n.items.itemMetaMap[C], [n.items.itemMetaMap]), a = d.useCallback((C) => n.items.itemMap[C], [n.items.itemMap]), l = d.useCallback(() => {
    const C = (E) => {
      const S = n.items.itemMap[E], k = Zt(S, rB), T = n.items.itemOrderedChildrenIds[E];
      return T && (k.children = T.map(C)), k;
    };
    return n.items.itemOrderedChildrenIds[Ps].map(C);
  }, [n.items.itemMap, n.items.itemOrderedChildrenIds]), c = d.useCallback((C) => {
    if (C == null)
      return !1;
    let E = e.getItemMeta(C);
    if (!E)
      return !1;
    if (E.disabled)
      return !0;
    for (; E.parentId != null; )
      if (E = e.getItemMeta(E.parentId), E.disabled)
        return !0;
    return !1;
  }, [e]), u = d.useCallback((C) => {
    const E = e.getItemMeta(C).parentId ?? Ps;
    return n.items.itemChildrenIndexes[E][C];
  }, [e, n.items.itemChildrenIndexes]), f = d.useCallback((C) => n.items.itemOrderedChildrenIds[C ?? Ps] ?? [], [n.items.itemOrderedChildrenIds]), g = (C) => {
    const E = e.getItemMeta(C);
    return E == null ? null : document.getElementById(o1({
      treeId: n.id.treeId,
      itemId: C,
      id: E.idAttribute
    }));
  }, h = (C) => t.disabledItemsFocusable ? !0 : !e.isItemDisabled(C), y = d.useRef(!1), v = d.useCallback(() => {
    y.current = !0;
  }, []), m = d.useCallback(() => y.current, []);
  return d.useEffect(() => {
    e.areItemUpdatesPrevented() || r((C) => {
      const E = u6({
        items: t.items,
        isItemDisabled: t.isItemDisabled,
        getItemId: t.getItemId,
        getItemLabel: t.getItemLabel
      });
      return Object.values(C.items.itemMetaMap).forEach((S) => {
        E.itemMetaMap[S.id] || l6(e, "removeItem", {
          id: S.id
        });
      }), Q({}, C, {
        items: E
      });
    });
  }, [e, r, t.items, t.isItemDisabled, t.getItemId, t.getItemLabel]), {
    getRootProps: () => ({
      style: {
        "--TreeView-itemChildrenIndentation": typeof t.itemChildrenIndentation == "number" ? `${t.itemChildrenIndentation}px` : t.itemChildrenIndentation
      }
    }),
    publicAPI: {
      getItem: a,
      getItemDOMElement: g,
      getItemTree: l,
      getItemOrderedChildrenIds: f
    },
    instance: {
      getItemMeta: s,
      getItem: a,
      getItemTree: l,
      getItemsToRender: () => {
        const C = (E) => {
          var k;
          const S = n.items.itemMetaMap[E];
          return {
            label: S.label,
            itemId: S.id,
            id: S.idAttribute,
            children: (k = n.items.itemOrderedChildrenIds[E]) == null ? void 0 : k.map(C)
          };
        };
        return n.items.itemOrderedChildrenIds[Ps].map(C);
      },
      getItemIndex: u,
      getItemDOMElement: g,
      getItemOrderedChildrenIds: f,
      isItemDisabled: c,
      isItemNavigable: h,
      preventItemUpdates: v,
      areItemUpdatesPrevented: m
    },
    contextValue: {
      items: {
        onItemClick: t.onItemClick,
        disabledItemsFocusable: t.disabledItemsFocusable,
        indentationAtItemLevel: i.indentationAtItemLevel ?? !1
      }
    }
  };
};
Rc.getInitialState = (e) => ({
  items: u6({
    items: e.items,
    isItemDisabled: e.isItemDisabled,
    getItemId: e.getItemId,
    getItemLabel: e.getItemLabel
  })
});
Rc.getDefaultizedParams = ({
  params: e
}) => Q({}, e, {
  disabledItemsFocusable: e.disabledItemsFocusable ?? !1,
  itemChildrenIndentation: e.itemChildrenIndentation ?? "12px"
});
Rc.wrapRoot = ({
  children: e,
  instance: t
}) => /* @__PURE__ */ p.jsx(Pa.Provider, {
  value: (n) => {
    var r;
    return ((r = t.getItemMeta(n)) == null ? void 0 : r.depth) ?? 0;
  },
  children: e
});
Rc.params = {
  disabledItemsFocusable: !0,
  items: !0,
  isItemDisabled: !0,
  getItemLabel: !0,
  getItemId: !0,
  onItemClick: !0,
  itemChildrenIndentation: !0
};
const r1 = ({
  instance: e,
  params: t,
  models: n
}) => {
  const r = d.useMemo(() => {
    const g = /* @__PURE__ */ new Map();
    return n.expandedItems.value.forEach((h) => {
      g.set(h, !0);
    }), g;
  }, [n.expandedItems.value]), i = (g, h) => {
    var y;
    (y = t.onExpandedItemsChange) == null || y.call(t, g, h), n.expandedItems.setControlledValue(h);
  }, s = d.useCallback((g) => r.has(g), [r]), a = d.useCallback((g) => {
    var h;
    return !!((h = e.getItemMeta(g)) != null && h.expandable);
  }, [e]), l = yt((g, h) => {
    const y = e.isItemExpanded(h);
    e.setItemExpansion(g, h, !y);
  }), c = yt((g, h, y) => {
    if (e.isItemExpanded(h) === y)
      return;
    let m;
    y ? m = [h].concat(n.expandedItems.value) : m = n.expandedItems.value.filter((b) => b !== h), t.onItemExpansionToggle && t.onItemExpansionToggle(g, h, y), i(g, m);
  }), u = (g, h) => {
    const y = e.getItemMeta(h), m = e.getItemOrderedChildrenIds(y.parentId).filter((C) => e.isItemExpandable(C) && !e.isItemExpanded(C)), b = n.expandedItems.value.concat(m);
    m.length > 0 && (t.onItemExpansionToggle && m.forEach((C) => {
      t.onItemExpansionToggle(g, C, !0);
    }), i(g, b));
  }, f = d.useMemo(() => t.expansionTrigger ? t.expansionTrigger : e.isTreeViewEditable ? "iconContainer" : "content", [t.expansionTrigger, e.isTreeViewEditable]);
  return {
    publicAPI: {
      setItemExpansion: c
    },
    instance: {
      isItemExpanded: s,
      isItemExpandable: a,
      setItemExpansion: c,
      toggleItemExpansion: l,
      expandAllSiblings: u
    },
    contextValue: {
      expansion: {
        expansionTrigger: f
      }
    }
  };
};
r1.models = {
  expandedItems: {
    getDefaultValue: (e) => e.defaultExpandedItems
  }
};
const iB = [];
r1.getDefaultizedParams = ({
  params: e
}) => Q({}, e, {
  defaultExpandedItems: e.defaultExpandedItems ?? iB
});
r1.params = {
  expandedItems: !0,
  defaultExpandedItems: !0,
  onExpandedItemsChange: !0,
  onItemExpansionToggle: !0,
  expansionTrigger: !0
};
const d6 = (e, t) => {
  let n = t.length - 1;
  for (; n >= 0 && !e.isItemNavigable(t[n]); )
    n -= 1;
  if (n !== -1)
    return t[n];
}, p6 = (e, t) => {
  const n = e.getItemMeta(t), r = e.getItemOrderedChildrenIds(n.parentId), i = e.getItemIndex(t);
  if (i === 0)
    return n.parentId;
  let s = i - 1;
  for (; !e.isItemNavigable(r[s]) && s >= 0; )
    s -= 1;
  if (s === -1)
    return n.parentId == null ? null : p6(e, n.parentId);
  let a = r[s], l = d6(e, e.getItemOrderedChildrenIds(a));
  for (; e.isItemExpanded(a) && l != null; )
    a = l, l = e.getItemOrderedChildrenIds(a).find(e.isItemNavigable);
  return a;
}, Du = (e, t) => {
  if (e.isItemExpanded(t)) {
    const r = e.getItemOrderedChildrenIds(t).find(e.isItemNavigable);
    if (r != null)
      return r;
  }
  let n = e.getItemMeta(t);
  for (; n != null; ) {
    const r = e.getItemOrderedChildrenIds(n.parentId), i = e.getItemIndex(n.id);
    if (i < r.length - 1) {
      let s = i + 1;
      for (; !e.isItemNavigable(r[s]) && s < r.length - 1; )
        s += 1;
      if (e.isItemNavigable(r[s]))
        return r[s];
    }
    n = e.getItemMeta(n.parentId);
  }
  return null;
}, f6 = (e) => {
  let t = null;
  for (; t == null || e.isItemExpanded(t); ) {
    const n = e.getItemOrderedChildrenIds(t), r = d6(e, n);
    if (r == null)
      return t;
    t = r;
  }
  return t;
}, Ql = (e) => e.getItemOrderedChildrenIds(null).find(e.isItemNavigable), g6 = (e, t, n) => {
  if (t === n)
    return [t, n];
  const r = e.getItemMeta(t), i = e.getItemMeta(n);
  if (r.parentId === i.id || i.parentId === r.id)
    return i.parentId === r.id ? [r.id, i.id] : [i.id, r.id];
  const s = [r.id], a = [i.id];
  let l = r.parentId, c = i.parentId, u = a.indexOf(l) !== -1, f = s.indexOf(c) !== -1, g = !0, h = !0;
  for (; !f && !u; )
    g && (s.push(l), u = a.indexOf(l) !== -1, g = l !== null, !u && g && (l = e.getItemMeta(l).parentId)), h && !u && (a.push(c), f = s.indexOf(c) !== -1, h = c !== null, !f && h && (c = e.getItemMeta(c).parentId));
  const y = u ? l : c, v = e.getItemOrderedChildrenIds(y), m = s[s.indexOf(y) - 1], b = a[a.indexOf(y) - 1];
  return v.indexOf(m) < v.indexOf(b) ? [t, n] : [n, t];
}, sB = (e, t, n) => {
  const r = (c) => {
    if (e.isItemExpandable(c) && e.isItemExpanded(c))
      return e.getItemOrderedChildrenIds(c)[0];
    let u = e.getItemMeta(c);
    for (; u != null; ) {
      const f = e.getItemOrderedChildrenIds(u.parentId), g = e.getItemIndex(u.id);
      if (g < f.length - 1)
        return f[g + 1];
      u = e.getItemMeta(u.parentId);
    }
    throw new Error("Invalid range");
  }, [i, s] = g6(e, t, n), a = [i];
  let l = i;
  for (; l !== s; )
    l = r(l), e.isItemDisabled(l) || a.push(l);
  return a;
}, aB = (e) => {
  let t = Ql(e);
  const n = [];
  for (; t != null; )
    n.push(t), t = Du(e, t);
  return n;
}, up = (e, t) => t !== e.closest('*[role="treeitem"]'), ju = (e) => Array.isArray(e) ? e : e != null ? [e] : [], v0 = (e) => {
  const t = {};
  return e.forEach((n) => {
    t[n] = !0;
  }), t;
}, i1 = ({
  instance: e,
  params: t,
  models: n
}) => {
  const r = d.useRef(null), i = d.useRef({}), s = d.useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    return Array.isArray(n.selectedItems.value) ? n.selectedItems.value.forEach((b) => {
      m.set(b, !0);
    }) : n.selectedItems.value != null && m.set(n.selectedItems.value, !0), m;
  }, [n.selectedItems.value]), a = (m, b) => {
    if (t.onItemSelectionToggle)
      if (t.multiSelect) {
        const C = b.filter((S) => !e.isItemSelected(S)), E = n.selectedItems.value.filter((S) => !b.includes(S));
        C.forEach((S) => {
          t.onItemSelectionToggle(m, S, !0);
        }), E.forEach((S) => {
          t.onItemSelectionToggle(m, S, !1);
        });
      } else b !== n.selectedItems.value && (n.selectedItems.value != null && t.onItemSelectionToggle(m, n.selectedItems.value, !1), b != null && t.onItemSelectionToggle(m, b, !0));
    t.onSelectedItemsChange && t.onSelectedItemsChange(m, b), n.selectedItems.setControlledValue(b);
  }, l = (m) => s.has(m), c = ({
    event: m,
    itemId: b,
    keepExistingSelection: C = !1,
    shouldBeSelected: E
  }) => {
    if (t.disableSelection)
      return;
    let S;
    if (C) {
      const k = ju(n.selectedItems.value), T = e.isItemSelected(b);
      T && (E === !1 || E == null) ? S = k.filter((P) => P !== b) : !T && (E === !0 || E == null) ? S = [b].concat(k) : S = k;
    } else
      E === !1 || E == null && e.isItemSelected(b) ? S = t.multiSelect ? [] : null : S = t.multiSelect ? [b] : b;
    a(m, S), r.current = b, i.current = {};
  }, u = (m, [b, C]) => {
    if (t.disableSelection || !t.multiSelect)
      return;
    let E = ju(n.selectedItems.value).slice();
    Object.keys(i.current).length > 0 && (E = E.filter((P) => !i.current[P]));
    const S = v0(E), k = sB(e, b, C), T = k.filter((P) => !S[P]);
    E = E.concat(T), a(m, E), i.current = v0(k);
  };
  return {
    getRootProps: () => ({
      "aria-multiselectable": t.multiSelect
    }),
    publicAPI: {
      selectItem: c
    },
    instance: {
      isItemSelected: l,
      selectItem: c,
      selectAllNavigableItems: (m) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        const b = aB(e);
        a(m, b), i.current = v0(b);
      },
      expandSelectionRange: (m, b) => {
        if (r.current != null) {
          const [C, E] = g6(e, b, r.current);
          u(m, [C, E]);
        }
      },
      selectRangeFromStartToItem: (m, b) => {
        u(m, [Ql(e), b]);
      },
      selectRangeFromItemToEnd: (m, b) => {
        u(m, [b, f6(e)]);
      },
      selectItemFromArrowNavigation: (m, b, C) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        let E = ju(n.selectedItems.value).slice();
        Object.keys(i.current).length === 0 ? (E.push(C), i.current = {
          [b]: !0,
          [C]: !0
        }) : (i.current[b] || (i.current = {}), i.current[C] ? (E = E.filter((S) => S !== b), delete i.current[b]) : (E.push(C), i.current[C] = !0)), a(m, E);
      }
    },
    contextValue: {
      selection: {
        multiSelect: t.multiSelect,
        checkboxSelection: t.checkboxSelection,
        disableSelection: t.disableSelection
      }
    }
  };
};
i1.models = {
  selectedItems: {
    getDefaultValue: (e) => e.defaultSelectedItems
  }
};
const lB = [];
i1.getDefaultizedParams = ({
  params: e
}) => Q({}, e, {
  disableSelection: e.disableSelection ?? !1,
  multiSelect: e.multiSelect ?? !1,
  checkboxSelection: e.checkboxSelection ?? !1,
  defaultSelectedItems: e.defaultSelectedItems ?? (e.multiSelect ? lB : null)
});
i1.params = {
  disableSelection: !0,
  multiSelect: !0,
  checkboxSelection: !0,
  defaultSelectedItems: !0,
  selectedItems: !0,
  onSelectedItemsChange: !0,
  onItemSelectionToggle: !0
};
const H5 = 1e3;
class cB {
  constructor(t = H5) {
    this.timeouts = /* @__PURE__ */ new Map(), this.cleanupTimeout = H5, this.cleanupTimeout = t;
  }
  register(t, n, r) {
    this.timeouts || (this.timeouts = /* @__PURE__ */ new Map());
    const i = setTimeout(() => {
      typeof n == "function" && n(), this.timeouts.delete(r.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(r.cleanupToken, i);
  }
  unregister(t) {
    const n = this.timeouts.get(t.cleanupToken);
    n && (this.timeouts.delete(t.cleanupToken), clearTimeout(n));
  }
  reset() {
    this.timeouts && (this.timeouts.forEach((t, n) => {
      this.unregister({
        cleanupToken: n
      });
    }), this.timeouts = void 0);
  }
}
class uB {
  constructor() {
    this.registry = new FinalizationRegistry((t) => {
      typeof t == "function" && t();
    });
  }
  register(t, n, r) {
    this.registry.register(t, n, r);
  }
  unregister(t) {
    this.registry.unregister(t);
  }
  // eslint-disable-next-line class-methods-use-this
  reset() {
  }
}
class dB {
}
function pB(e) {
  let t = 0;
  return function(r, i, s) {
    e.registry === null && (e.registry = typeof FinalizationRegistry < "u" ? new uB() : new cB());
    const [a] = d.useState(new dB()), l = d.useRef(null), c = d.useRef(void 0);
    c.current = s;
    const u = d.useRef(null);
    if (!l.current && c.current) {
      const f = (g, h) => {
        var y;
        h.defaultMuiPrevented || (y = c.current) == null || y.call(c, g, h);
      };
      l.current = r.$$subscribeEvent(i, f), t += 1, u.current = {
        cleanupToken: t
      }, e.registry.register(
        a,
        // The callback below will be called once this reference stops being retained
        () => {
          var g;
          (g = l.current) == null || g.call(l), l.current = null, u.current = null;
        },
        u.current
      );
    } else !c.current && l.current && (l.current(), l.current = null, u.current && (e.registry.unregister(u.current), u.current = null));
    d.useEffect(() => {
      if (!l.current && c.current) {
        const f = (g, h) => {
          var y;
          h.defaultMuiPrevented || (y = c.current) == null || y.call(c, g, h);
        };
        l.current = r.$$subscribeEvent(i, f);
      }
      return u.current && e.registry && (e.registry.unregister(u.current), u.current = null), () => {
        var f;
        (f = l.current) == null || f.call(l), l.current = null;
      };
    }, [r, i]);
  };
}
const fB = {
  registry: null
}, gB = pB(fB), m6 = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? m6(t.shadowRoot) : t : null;
};
function mB(e) {
  return e.replace(/["\\]/g, "\\$&");
}
const hB = (e, t) => {
  let n = ju(t).find((r) => {
    if (!e.isItemNavigable(r))
      return !1;
    const i = e.getItemMeta(r);
    return i && (i.parentId == null || e.isItemExpanded(i.parentId));
  });
  return n == null && (n = Ql(e)), n;
}, Xf = ({
  instance: e,
  params: t,
  state: n,
  setState: r,
  models: i,
  rootRef: s
}) => {
  const a = hB(e, i.selectedItems.value), l = yt((b) => {
    const C = typeof b == "function" ? b(n.focusedItemId) : b;
    n.focusedItemId !== C && r((E) => Q({}, E, {
      focusedItemId: C
    }));
  }), c = d.useCallback(() => !!s.current && s.current.contains(m6(ku(s.current))), [s]), u = d.useCallback((b) => n.focusedItemId === b && c(), [n.focusedItemId, c]), f = (b) => {
    const C = e.getItemMeta(b);
    return C && (C.parentId == null || e.isItemExpanded(C.parentId));
  }, g = (b, C) => {
    const E = e.getItemDOMElement(C);
    E && E.focus(), l(C), t.onItemFocus && t.onItemFocus(b, C);
  }, h = yt((b, C) => {
    f(C) && g(b, C);
  }), y = yt(() => {
    if (n.focusedItemId == null)
      return;
    if (e.getItemMeta(n.focusedItemId)) {
      const C = e.getItemDOMElement(n.focusedItemId);
      C && C.blur();
    }
    l(null);
  }), v = (b) => b === a;
  gB(e, "removeItem", ({
    id: b
  }) => {
    n.focusedItemId === b && g(null, a);
  });
  const m = (b) => (C) => {
    var E;
    (E = b.onFocus) == null || E.call(b, C), !C.defaultMuiPrevented && C.target === C.currentTarget && g(C, a);
  };
  return {
    getRootProps: (b) => ({
      onFocus: m(b)
    }),
    publicAPI: {
      focusItem: h
    },
    instance: {
      isItemFocused: u,
      canItemBeTabbed: v,
      focusItem: h,
      removeFocusedItem: y
    }
  };
};
Xf.getInitialState = () => ({
  focusedItemId: null
});
Xf.params = {
  onItemFocus: !0
};
const Fu = (e, t) => e.getAvailablePlugins().has(t), vB = ({
  props: e
}) => {
  const {
    instance: t
  } = Fa(), {
    label: n,
    itemId: r
  } = e, [i, s] = d.useState(n), a = t.isItemBeingEdited(r);
  return d.useEffect(() => {
    a || s(n);
  }, [a, n]), {
    propsEnhancers: {
      labelInput: ({
        externalEventHandlers: l,
        interactions: c
      }) => t.isItemEditable(r) ? {
        value: i ?? "",
        "data-element": "labelInput",
        onChange: (y) => {
          var v;
          (v = l.onChange) == null || v.call(l, y), s(y.target.value);
        },
        onKeyDown: (y) => {
          var m;
          if ((m = l.onKeyDown) == null || m.call(l, y), y.defaultMuiPrevented)
            return;
          const v = y.target;
          y.key === "Enter" && v.value ? c.handleSaveItemLabel(y, v.value) : y.key === "Escape" && c.handleCancelItemLabelEditing(y);
        },
        onBlur: (y) => {
          var v;
          (v = l.onBlur) == null || v.call(l, y), !y.defaultMuiPrevented && y.target.value && c.handleSaveItemLabel(y, y.target.value);
        },
        autoFocus: !0,
        type: "text"
      } : {}
    }
  };
}, ts = ({
  instance: e,
  state: t,
  setState: n,
  params: r
}) => {
  const i = d.useRef(t.editedItemId), s = (g) => i.current === g, a = (g) => {
    n((h) => Q({}, h, {
      editedItemId: g
    })), i.current = g;
  }, l = (g) => g === t.editedItemId, c = !!r.isItemEditable, u = (g) => {
    if (g == null || !c)
      return !1;
    const h = e.getItem(g);
    return h ? typeof r.isItemEditable == "function" ? r.isItemEditable(h) : !!r.isItemEditable : !1;
  }, f = (g, h) => {
    if (!h)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "The label of an item cannot be empty.", g].join(`
`));
    n((y) => {
      const v = y.items.itemMetaMap[g];
      return v.label !== h ? Q({}, y, {
        items: Q({}, y.items, {
          itemMetaMap: Q({}, y.items.itemMetaMap, {
            [g]: Q({}, v, {
              label: h
            })
          })
        })
      }) : y;
    }), r.onItemLabelChange && r.onItemLabelChange(g, h);
  };
  return {
    instance: {
      setEditedItemId: a,
      isItemBeingEdited: l,
      updateItemLabel: f,
      isItemEditable: u,
      isTreeViewEditable: c,
      isItemBeingEditedRef: s
    },
    publicAPI: {
      updateItemLabel: f
    }
  };
};
ts.itemPlugin = vB;
ts.getDefaultizedParams = ({
  params: e,
  experimentalFeatures: t
}) => {
  const n = t == null ? void 0 : t.labelEditing;
  return process.env.NODE_ENV !== "production" && e.isItemEditable && !n && Yl(["MUI X: The label editing feature requires the `labelEditing` experimental feature to be enabled.", "You can do it by passing `experimentalFeatures={{ labelEditing: true}}` to the Rich Tree View Pro component.", "Check the documentation for more details: https://mui.com/x/react-tree-view/rich-tree-view/editing/"]), Q({}, e, {
    isItemEditable: n ? e.isItemEditable ?? !1 : !1
  });
};
ts.getInitialState = () => ({
  editedItemId: null
});
ts.params = {
  onItemLabelChange: !0,
  isItemEditable: !0
};
function yB(e) {
  return !!e && e.length === 1 && !!e.match(/\S/);
}
const h6 = ({
  instance: e,
  params: t,
  state: n
}) => {
  const r = Io(), i = d.useRef({}), s = yt((f) => {
    i.current = f(i.current);
  });
  d.useEffect(() => {
    if (e.areItemUpdatesPrevented())
      return;
    const f = {}, g = (h) => {
      f[h.id] = h.label.substring(0, 1).toLowerCase();
    };
    Object.values(n.items.itemMetaMap).forEach(g), i.current = f;
  }, [n.items.itemMetaMap, t.getItemId, e]);
  const a = (f, g) => {
    const h = g.toLowerCase(), y = (C) => {
      const E = Du(e, C);
      return E === null ? Ql(e) : E;
    };
    let v = null, m = y(f);
    const b = {};
    for (; v == null && !b[m]; )
      i.current[m] === h ? v = m : (b[m] = !0, m = y(m));
    return v;
  }, l = (f) => !t.disableSelection && !e.isItemDisabled(f), c = (f) => !e.isItemDisabled(f) && e.isItemExpandable(f);
  return {
    instance: {
      updateFirstCharMap: s,
      handleItemKeyDown: (f, g) => {
        if (f.defaultMuiPrevented || f.altKey || up(f.target, f.currentTarget))
          return;
        const h = f.ctrlKey || f.metaKey, y = f.key;
        switch (!0) {
          case (y === " " && l(g)): {
            f.preventDefault(), t.multiSelect && f.shiftKey ? e.expandSelectionRange(f, g) : e.selectItem({
              event: f,
              itemId: g,
              keepExistingSelection: t.multiSelect,
              shouldBeSelected: t.multiSelect ? void 0 : !0
            });
            break;
          }
          case y === "Enter": {
            Fu(e, ts) && e.isItemEditable(g) && !e.isItemBeingEdited(g) ? e.setEditedItemId(g) : c(g) ? (e.toggleItemExpansion(f, g), f.preventDefault()) : l(g) && (t.multiSelect ? (f.preventDefault(), e.selectItem({
              event: f,
              itemId: g,
              keepExistingSelection: !0
            })) : e.isItemSelected(g) || (e.selectItem({
              event: f,
              itemId: g
            }), f.preventDefault()));
            break;
          }
          case y === "ArrowDown": {
            const v = Du(e, g);
            v && (f.preventDefault(), e.focusItem(f, v), t.multiSelect && f.shiftKey && l(v) && e.selectItemFromArrowNavigation(f, g, v));
            break;
          }
          case y === "ArrowUp": {
            const v = p6(e, g);
            v && (f.preventDefault(), e.focusItem(f, v), t.multiSelect && f.shiftKey && l(v) && e.selectItemFromArrowNavigation(f, g, v));
            break;
          }
          case (y === "ArrowRight" && !r || y === "ArrowLeft" && r): {
            if (h)
              return;
            if (e.isItemExpanded(g)) {
              const v = Du(e, g);
              v && (e.focusItem(f, v), f.preventDefault());
            } else c(g) && (e.toggleItemExpansion(f, g), f.preventDefault());
            break;
          }
          case (y === "ArrowLeft" && !r || y === "ArrowRight" && r): {
            if (h)
              return;
            if (c(g) && e.isItemExpanded(g))
              e.toggleItemExpansion(f, g), f.preventDefault();
            else {
              const v = e.getItemMeta(g).parentId;
              v && (e.focusItem(f, v), f.preventDefault());
            }
            break;
          }
          case y === "Home": {
            l(g) && t.multiSelect && h && f.shiftKey ? e.selectRangeFromStartToItem(f, g) : e.focusItem(f, Ql(e)), f.preventDefault();
            break;
          }
          case y === "End": {
            l(g) && t.multiSelect && h && f.shiftKey ? e.selectRangeFromItemToEnd(f, g) : e.focusItem(f, f6(e)), f.preventDefault();
            break;
          }
          case y === "*": {
            e.expandAllSiblings(f, g), f.preventDefault();
            break;
          }
          case (String.fromCharCode(f.keyCode) === "A" && h && t.multiSelect && !t.disableSelection): {
            e.selectAllNavigableItems(f), f.preventDefault();
            break;
          }
          case (!h && !f.shiftKey && yB(y)): {
            const v = a(g, y);
            v != null && (e.focusItem(f, v), f.preventDefault());
            break;
          }
        }
      }
    }
  };
};
h6.params = {};
const v6 = ({
  slots: e,
  slotProps: t
}) => ({
  contextValue: {
    icons: {
      slots: {
        collapseIcon: e.collapseIcon,
        expandIcon: e.expandIcon,
        endIcon: e.endIcon
      },
      slotProps: {
        collapseIcon: t.collapseIcon,
        expandIcon: t.expandIcon,
        endIcon: t.endIcon
      }
    }
  }
});
v6.params = {};
const Qf = /* @__PURE__ */ d.createContext(null);
process.env.NODE_ENV !== "production" && (Qf.displayName = "TreeViewChildrenItemContext");
function Jf(e) {
  const {
    children: t,
    itemId: n = null
  } = e, {
    instance: r,
    treeId: i,
    rootRef: s
  } = Fa(), a = d.useRef(/* @__PURE__ */ new Map());
  d.useEffect(() => {
    if (!s.current)
      return;
    let c = null;
    if (n == null)
      c = s.current.id;
    else {
      const v = r.getItemMeta(n);
      v !== void 0 && (c = o1({
        itemId: n,
        treeId: i,
        id: v.idAttribute
      }));
    }
    if (c == null)
      return;
    const u = r.getItemOrderedChildrenIds(n ?? null) ?? [], f = mB(c), g = s.current.querySelectorAll(`${n == null ? "" : `*[id="${f}"] `}[role="treeitem"]:not(*[id="${f}"] [role="treeitem"] [role="treeitem"])`), h = Array.from(g).map((v) => a.current.get(v.id));
    (h.length !== u.length || h.some((v, m) => v !== u[m])) && r.setJSXItemsOrderedChildrenIds(n ?? null, h);
  });
  const l = d.useMemo(() => ({
    registerChild: (c, u) => a.current.set(c, u),
    unregisterChild: (c) => a.current.delete(c),
    parentId: n
  }), [n]);
  return /* @__PURE__ */ p.jsx(Qf.Provider, {
    value: l,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Jf.propTypes = {
  children: o.node,
  id: o.string
});
const Tc = ({
  instance: e,
  setState: t
}) => {
  e.preventItemUpdates();
  const n = yt((s) => (t((a) => {
    if (a.items.itemMetaMap[s.id] != null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", `Two items were provided with the same id in the \`items\` prop: "${s.id}"`].join(`
`));
    return Q({}, a, {
      items: Q({}, a.items, {
        itemMetaMap: Q({}, a.items.itemMetaMap, {
          [s.id]: s
        }),
        // For Simple Tree View, we don't have a proper `item` object, so we create a very basic one.
        itemMap: Q({}, a.items.itemMap, {
          [s.id]: {
            id: s.id,
            label: s.label
          }
        })
      })
    });
  }), () => {
    t((a) => {
      const l = Q({}, a.items.itemMetaMap), c = Q({}, a.items.itemMap);
      return delete l[s.id], delete c[s.id], Q({}, a, {
        items: Q({}, a.items, {
          itemMetaMap: l,
          itemMap: c
        })
      });
    }), l6(e, "removeItem", {
      id: s.id
    });
  })), r = (s, a) => {
    const l = s ?? Ps;
    t((c) => Q({}, c, {
      items: Q({}, c.items, {
        itemOrderedChildrenIds: Q({}, c.items.itemOrderedChildrenIds, {
          [l]: a
        }),
        itemChildrenIndexes: Q({}, c.items.itemChildrenIndexes, {
          [l]: c6(a)
        })
      })
    }));
  }, i = yt((s, a) => (e.updateFirstCharMap((l) => (l[s] = a, l)), () => {
    e.updateFirstCharMap((l) => {
      const c = Q({}, l);
      return delete c[s], c;
    });
  }));
  return {
    instance: {
      insertJSXItem: n,
      setJSXItemsOrderedChildrenIds: r,
      mapFirstCharFromJSX: i
    }
  };
}, y6 = (e) => Array.isArray(e) ? e.length > 0 && e.some(y6) : !!e, bB = ({
  props: e,
  rootRef: t,
  contentRef: n
}) => {
  const {
    instance: r,
    treeId: i
  } = Fa(), {
    children: s,
    disabled: a = !1,
    label: l,
    itemId: c,
    id: u
  } = e, f = d.useContext(Qf);
  if (f == null)
    throw new Error(["MUI X: Could not find the Tree View Children Item context.", "It looks like you rendered your component outside of a SimpleTreeView parent component.", "This can also happen if you are bundling multiple versions of the Tree View."].join(`
`));
  const {
    registerChild: g,
    unregisterChild: h,
    parentId: y
  } = f, v = y6(s), m = d.useRef(null), b = Vo(m, n);
  return ni(() => {
    const C = o1({
      itemId: c,
      treeId: i,
      id: u
    });
    return g(C, c), () => {
      h(C);
    };
  }, [g, h, c, u, i]), d.useEffect(() => r.insertJSXItem({
    id: c,
    idAttribute: u,
    parentId: y,
    expandable: v,
    disabled: a
  }), [r, y, c, v, a, u]), d.useEffect(() => {
    var C;
    if (l)
      return r.mapFirstCharFromJSX(c, (((C = m.current) == null ? void 0 : C.textContent) ?? "").substring(0, 1).toLowerCase());
  }, [r, c, l]), {
    contentRef: b,
    rootRef: t
  };
};
Tc.itemPlugin = bB;
Tc.wrapItem = ({
  children: e,
  itemId: t
}) => {
  const n = d.useContext(Pa);
  return /* @__PURE__ */ p.jsx(Jf, {
    itemId: t,
    children: /* @__PURE__ */ p.jsx(Pa.Provider, {
      value: n + 1,
      children: e
    })
  });
};
Tc.wrapRoot = ({
  children: e
}) => /* @__PURE__ */ p.jsx(Jf, {
  children: /* @__PURE__ */ p.jsx(Pa.Provider, {
    value: 0,
    children: e
  })
});
Tc.params = {};
const CB = [Rc, r1, i1, Xf, h6, v6, Tc], xB = i6(), wB = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"]
  }, UN, t);
}, SB = Z("ul", {
  name: "MuiSimpleTreeView",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  margin: 0,
  listStyle: "none",
  outline: 0,
  position: "relative"
}), EB = [], b6 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = xB({
    props: t,
    name: "MuiSimpleTreeView"
  }), i = r;
  process.env.NODE_ENV !== "production" && r.items != null && Yl(["MUI X: The Simple Tree View component does not support the `items` prop.", "If you want to add items, you need to pass them as JSX children.", "Check the documentation for more details: https://mui.com/x/react-tree-view/simple-tree-view/items/."]);
  const {
    getRootProps: s,
    contextValue: a
  } = nB({
    plugins: CB,
    rootRef: n,
    props: Q({}, r, {
      items: EB
    })
  }), {
    slots: l,
    slotProps: c
  } = r, u = wB(r), f = (l == null ? void 0 : l.root) ?? SB, g = kn({
    elementType: f,
    externalSlotProps: c == null ? void 0 : c.root,
    className: u.root,
    getSlotProps: s,
    ownerState: i
  });
  return /* @__PURE__ */ p.jsx(oB, {
    value: a,
    children: /* @__PURE__ */ p.jsx(f, Q({}, g))
  });
});
process.env.NODE_ENV !== "production" && (b6.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The ref object that allows Tree View manipulation. Can be instantiated with `useTreeViewApiRef()`.
   */
  apiRef: o.shape({
    current: o.shape({
      focusItem: o.func.isRequired,
      getItem: o.func.isRequired,
      getItemDOMElement: o.func.isRequired,
      getItemOrderedChildrenIds: o.func.isRequired,
      getItemTree: o.func.isRequired,
      selectItem: o.func.isRequired,
      setItemExpansion: o.func.isRequired
    })
  }),
  /**
   * If `true`, the Tree View renders a checkbox at the left of its label that allows selecting it.
   * @default false
   */
  checkboxSelection: o.bool,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  /**
   * Expanded item ids.
   * Used when the item's expansion is not controlled.
   * @default []
   */
  defaultExpandedItems: o.arrayOf(o.string),
  /**
   * Selected item ids. (Uncontrolled)
   * When `multiSelect` is true this takes an array of strings; when false (default) a string.
   * @default []
   */
  defaultSelectedItems: o.any,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: o.bool,
  /**
   * If `true` selection is disabled.
   * @default false
   */
  disableSelection: o.bool,
  /**
   * Expanded item ids.
   * Used when the item's expansion is controlled.
   */
  expandedItems: o.arrayOf(o.string),
  /**
   * The slot that triggers the item's expansion when clicked.
   * @default 'content'
   */
  expansionTrigger: o.oneOf(["content", "iconContainer"]),
  /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`,
   * the feature will be fully disabled and any property / method call will not have any effect.
   */
  experimentalFeatures: o.shape({
    indentationAtItemLevel: o.bool
  }),
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: o.string,
  /**
   * Horizontal indentation between an item and its children.
   * Examples: 24, "24px", "2rem", "2em".
   * @default 12px
   */
  itemChildrenIndentation: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, `ctrl` and `shift` will trigger multiselect.
   * @default false
   */
  multiSelect: o.bool,
  /**
   * Callback fired when Tree Items are expanded/collapsed.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {array} itemIds The ids of the expanded items.
   */
  onExpandedItemsChange: o.func,
  /**
   * Callback fired when the `content` slot of a given Tree Item is clicked.
   * @param {React.MouseEvent} event The DOM event that triggered the change.
   * @param {string} itemId The id of the focused item.
   */
  onItemClick: o.func,
  /**
   * Callback fired when a Tree Item is expanded or collapsed.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {array} itemId The itemId of the modified item.
   * @param {array} isExpanded `true` if the item has just been expanded, `false` if it has just been collapsed.
   */
  onItemExpansionToggle: o.func,
  /**
   * Callback fired when a given Tree Item is focused.
   * @param {React.SyntheticEvent | null} event The DOM event that triggered the change. **Warning**: This is a generic event not a focus event.
   * @param {string} itemId The id of the focused item.
   */
  onItemFocus: o.func,
  /**
   * Callback fired when a Tree Item is selected or deselected.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {array} itemId The itemId of the modified item.
   * @param {array} isSelected `true` if the item has just been selected, `false` if it has just been deselected.
   */
  onItemSelectionToggle: o.func,
  /**
   * Callback fired when Tree Items are selected/deselected.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {string[] | string} itemIds The ids of the selected items.
   * When `multiSelect` is `true`, this is an array of strings; when false (default) a string.
   */
  onSelectedItemsChange: o.func,
  /**
   * Selected item ids. (Controlled)
   * When `multiSelect` is true this takes an array of strings; when false (default) a string.
   */
  selectedItems: o.any,
  /**
   * The props used for each component slot.
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function C6(e) {
  const {
    instance: t,
    items: {
      onItemClick: n
    },
    selection: {
      multiSelect: r,
      checkboxSelection: i,
      disableSelection: s
    },
    expansion: {
      expansionTrigger: a
    }
  } = Fa(), l = t.isItemExpandable(e), c = t.isItemExpanded(e), u = t.isItemFocused(e), f = t.isItemSelected(e), g = t.isItemDisabled(e), h = t != null && t.isItemBeingEdited ? t == null ? void 0 : t.isItemBeingEdited(e) : !1, y = t.isItemEditable ? t.isItemEditable(e) : !1, v = (T) => {
    if (!g) {
      u || t.focusItem(T, e);
      const P = r && (T.shiftKey || T.ctrlKey || T.metaKey);
      l && !(P && t.isItemExpanded(e)) && t.toggleItemExpansion(T, e);
    }
  }, m = (T) => {
    g || (!u && !h && t.focusItem(T, e), r && (T.shiftKey || T.ctrlKey || T.metaKey) ? T.shiftKey ? t.expandSelectionRange(T, e) : t.selectItem({
      event: T,
      itemId: e,
      keepExistingSelection: !0
    }) : t.selectItem({
      event: T,
      itemId: e,
      shouldBeSelected: !0
    }));
  }, b = (T) => {
    if (s || g)
      return;
    const P = T.nativeEvent.shiftKey;
    r && P ? t.expandSelectionRange(T, e) : t.selectItem({
      event: T,
      itemId: e,
      keepExistingSelection: r,
      shouldBeSelected: T.target.checked
    });
  }, C = (T) => {
    (T.shiftKey || T.ctrlKey || T.metaKey || g) && T.preventDefault();
  }, E = () => {
    Fu(t, ts) && t.isItemEditable(e) && (t.isItemBeingEdited(e) ? t.setEditedItemId(null) : t.setEditedItemId(e));
  };
  return {
    disabled: g,
    expanded: c,
    selected: f,
    focused: u,
    editable: y,
    editing: h,
    disableSelection: s,
    checkboxSelection: i,
    handleExpansion: v,
    handleSelection: m,
    handleCheckboxSelection: b,
    handleContentClick: n,
    preventSelection: C,
    expansionTrigger: a,
    toggleItemEditing: E,
    handleSaveItemLabel: (T, P) => {
      Fu(t, ts) && t.isItemBeingEditedRef(e) && (t.updateItemLabel(e, P), E(), t.focusItem(T, e));
    },
    handleCancelItemLabelEditing: (T) => {
      Fu(t, ts) && t.isItemBeingEditedRef(e) && (E(), t.focusItem(T, e));
    }
  };
}
const RB = Z("div", {
  name: "MuiTreeItem2DragAndDropOverlay",
  slot: "Root",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Is(e) && e !== "action"
})(({
  theme: e
}) => ({
  position: "absolute",
  left: 0,
  display: "flex",
  top: 0,
  bottom: 0,
  right: 0,
  pointerEvents: "none",
  variants: [{
    props: {
      action: "make-child"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderRadius: e.shape.borderRadius,
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.darkChannel} / ${e.vars.palette.action.focusOpacity})` : At(e.palette.primary.dark, e.palette.action.focusOpacity)
    }
  }, {
    props: {
      action: "reorder-above"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderTop: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }, {
    props: {
      action: "reorder-below"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderBottom: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }, {
    props: {
      action: "move-to-parent"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * calc(var(--TreeView-itemDepth) - 1))",
      borderBottom: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }]
}));
function x6(e) {
  return e.action == null ? null : /* @__PURE__ */ p.jsx(RB, Q({}, e));
}
process.env.NODE_ENV !== "production" && (x6.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  action: o.oneOf(["make-child", "move-to-parent", "reorder-above", "reorder-below"]),
  style: o.object
});
const TB = Z("input", {
  name: "MuiTreeItem2",
  slot: "LabelInput",
  overridesResolver: (e, t) => t.labelInput
})(({
  theme: e
}) => Q({}, e.typography.body1, {
  width: "100%",
  backgroundColor: e.palette.background.paper,
  borderRadius: e.shape.borderRadius,
  border: "none",
  padding: "0 2px",
  boxSizing: "border-box",
  "&:focus": {
    outline: `1px solid ${e.palette.primary.main}`
  }
})), MB = ["classes", "className", "displayIcon", "expansionIcon", "icon", "label", "itemId", "onClick", "onMouseDown", "dragAndDropOverlayProps", "labelInputProps"], e2 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    classes: r,
    className: i,
    displayIcon: s,
    expansionIcon: a,
    icon: l,
    label: c,
    itemId: u,
    onClick: f,
    onMouseDown: g,
    dragAndDropOverlayProps: h,
    labelInputProps: y
  } = t, v = Zt(t, MB), {
    disabled: m,
    expanded: b,
    selected: C,
    focused: E,
    editing: S,
    editable: k,
    disableSelection: T,
    checkboxSelection: P,
    handleExpansion: F,
    handleSelection: j,
    handleCheckboxSelection: L,
    handleContentClick: R,
    preventSelection: V,
    expansionTrigger: B,
    toggleItemEditing: W
  } = C6(u), z = l || a || s, G = d.useRef(null), H = (re) => {
    V(re), g && g(re);
  }, ie = (re) => {
    var A;
    R == null || R(re, u), !((A = G.current) != null && A.contains(re.target)) && (B === "content" && F(re), P || j(re), f && f(re));
  }, ce = (re) => {
    re.defaultMuiPrevented || W();
  };
  return (
    /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Key event is handled by the TreeView */
    /* @__PURE__ */ p.jsxs("div", Q({}, v, {
      className: xe(r.root, i, b && r.expanded, C && r.selected, E && r.focused, m && r.disabled, S && r.editing, k && r.editable),
      onClick: ie,
      onMouseDown: H,
      ref: n,
      children: [/* @__PURE__ */ p.jsx("div", {
        className: r.iconContainer,
        children: z
      }), P && /* @__PURE__ */ p.jsx(Hp, {
        className: r.checkbox,
        checked: C,
        onChange: L,
        disabled: m || T,
        ref: G,
        tabIndex: -1
      }), S ? /* @__PURE__ */ p.jsx(TB, Q({}, y, {
        className: r.labelInput
      })) : /* @__PURE__ */ p.jsx("div", Q({
        className: r.label
      }, k && {
        onDoubleClick: ce
      }, {
        children: c
      })), h && /* @__PURE__ */ p.jsx(x6, Q({}, h))]
    }))
  );
});
process.env.NODE_ENV !== "production" && (e2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object.isRequired,
  className: o.string,
  /**
   * The icon to display next to the Tree Item's label. Either a parent or end icon.
   */
  displayIcon: o.node,
  dragAndDropOverlayProps: o.shape({
    action: o.oneOf(["make-child", "move-to-parent", "reorder-above", "reorder-below"]),
    style: o.object
  }),
  /**
   * The icon to display next to the Tree Item's label. Either an expansion or collapse icon.
   */
  expansionIcon: o.node,
  /**
   * The icon to display next to the Tree Item's label.
   */
  icon: o.node,
  /**
   * The id of the item.
   */
  itemId: o.string.isRequired,
  /**
   * The Tree Item label.
   */
  label: o.node,
  labelInputProps: o.shape({
    autoFocus: o.oneOf([!0]),
    "data-element": o.oneOf(["labelInput"]),
    onBlur: o.func,
    onChange: o.func,
    onKeyDown: o.func,
    type: o.oneOf(["text"]),
    value: o.string
  })
});
function kB(e) {
  return uo("MuiTreeItem", e);
}
const bi = po("MuiTreeItem", ["root", "groupTransition", "content", "expanded", "selected", "focused", "disabled", "iconContainer", "label", "checkbox", "labelInput", "editable", "editing", "dragAndDropOverlay"]), PB = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "TreeViewExpandIcon"), IB = jn(/* @__PURE__ */ p.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "TreeViewCollapseIcon");
function w6(e) {
  const {
    children: t,
    itemId: n
  } = e, {
    wrapItem: r,
    instance: i
  } = Fa();
  return r({
    children: t,
    itemId: n,
    instance: i
  });
}
w6.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: o.node,
  itemId: o.string.isRequired
};
const OB = ["children", "className", "slots", "slotProps", "ContentComponent", "ContentProps", "itemId", "id", "label", "onClick", "onMouseDown", "onFocus", "onBlur", "onKeyDown"], DB = ["ownerState"], jB = ["ownerState"], FB = ["ownerState"], VB = i6(), $B = (e) => {
  const {
    classes: t
  } = e;
  return co({
    root: ["root"],
    content: ["content"],
    expanded: ["expanded"],
    selected: ["selected"],
    focused: ["focused"],
    disabled: ["disabled"],
    iconContainer: ["iconContainer"],
    checkbox: ["checkbox"],
    label: ["label"],
    labelInput: ["labelInput"],
    editing: ["editing"],
    editable: ["editable"],
    groupTransition: ["groupTransition"]
  }, kB, t);
}, LB = Z("li", {
  name: "MuiTreeItem",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  outline: 0
}), AB = Z(e2, {
  name: "MuiTreeItem",
  slot: "Content",
  overridesResolver: (e, t) => [t.content, t.iconContainer && {
    [`& .${bi.iconContainer}`]: t.iconContainer
  }, t.label && {
    [`& .${bi.label}`]: t.label
  }],
  shouldForwardProp: (e) => Is(e) && e !== "indentationAtItemLevel"
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 1),
  borderRadius: e.shape.borderRadius,
  width: "100%",
  boxSizing: "border-box",
  // prevent width + padding to overflow
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${bi.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity,
    backgroundColor: "transparent"
  },
  [`&.${bi.focused}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${bi.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : At(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : At(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : At(e.palette.primary.main, e.palette.action.selectedOpacity)
      }
    },
    [`&.${bi.focused}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : At(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`& .${bi.iconContainer}`]: {
    width: 16,
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    "& svg": {
      fontSize: 18
    }
  },
  [`& .${bi.label}`]: Q({
    width: "100%",
    boxSizing: "border-box",
    // prevent width + padding to overflow
    // fixes overflow - see https://github.com/mui/material-ui/issues/27372
    minWidth: 0,
    position: "relative"
  }, e.typography.body1),
  [`& .${bi.checkbox}`]: {
    padding: 0
  },
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: `calc(${e.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`
    }
  }]
})), NB = Z(Bu, {
  name: "MuiTreeItem",
  slot: "GroupTransition",
  overridesResolver: (e, t) => t.groupTransition,
  shouldForwardProp: (e) => Is(e) && e !== "indentationAtItemLevel"
})({
  margin: 0,
  padding: 0,
  paddingLeft: "var(--TreeView-itemChildrenIndentation)",
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: 0
    }
  }]
}), S6 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  var $t, nn, Nt, cn;
  const {
    icons: r,
    runItemPlugins: i,
    items: {
      disabledItemsFocusable: s,
      indentationAtItemLevel: a
    },
    selection: {
      disableSelection: l
    },
    expansion: {
      expansionTrigger: c
    },
    treeId: u,
    instance: f
  } = Fa(), g = d.useContext(Pa), h = VB({
    props: t,
    name: "MuiTreeItem"
  }), {
    children: y,
    className: v,
    slots: m,
    slotProps: b,
    ContentComponent: C = e2,
    ContentProps: E,
    itemId: S,
    id: k,
    label: T,
    onClick: P,
    onMouseDown: F,
    onBlur: j,
    onKeyDown: L
  } = h, R = Zt(h, OB), {
    expanded: V,
    focused: B,
    selected: W,
    disabled: z,
    editing: G,
    handleExpansion: H,
    handleCancelItemLabelEditing: ie,
    handleSaveItemLabel: ce
  } = C6(S);
  process.env.NODE_ENV !== "production" && (h.ContentComponent && Yl(["MUI X: The ContentComponent prop of the TreeItem component is deprecated and will be removed in the next major release.", "You can use the new TreeItem2 component or the new useTreeItem2 hook to customize the rendering of the content.", "For more detail, see https://mui.com/x/react-tree-view/tree-item-customization/."]), h.ContentProps && Yl(["MUI X: The ContentProps prop of the TreeItem component is deprecated and will be removed in the next major release.", "You can use the new TreeItem2 component or the new useTreeItem2 hook to customize the rendering of the content.", "For more detail, see https://mui.com/x/react-tree-view/tree-item-customization/."]));
  const {
    contentRef: re,
    rootRef: A,
    propsEnhancers: Y
  } = i(h), pe = d.useRef(null), Ce = d.useRef(null), fe = Vo(n, A, pe), ee = Vo(E == null ? void 0 : E.ref, re, Ce), te = {
    expandIcon: (m == null ? void 0 : m.expandIcon) ?? r.slots.expandIcon ?? PB,
    collapseIcon: (m == null ? void 0 : m.collapseIcon) ?? r.slots.collapseIcon ?? IB,
    endIcon: (m == null ? void 0 : m.endIcon) ?? r.slots.endIcon,
    icon: m == null ? void 0 : m.icon,
    groupTransition: m == null ? void 0 : m.groupTransition
  }, ue = (Lt) => Array.isArray(Lt) ? Lt.length > 0 && Lt.some(ue) : !!Lt, K = ue(y), oe = Q({}, h, {
    expanded: V,
    focused: B,
    selected: W,
    disabled: z,
    indentationAtItemLevel: a
  }), de = $B(oe), ve = te.groupTransition ?? void 0, J = kn({
    elementType: ve,
    ownerState: {},
    externalSlotProps: b == null ? void 0 : b.groupTransition,
    additionalProps: Q({
      unmountOnExit: !0,
      in: V,
      component: "ul",
      role: "group"
    }, a ? {
      indentationAtItemLevel: !0
    } : {}),
    className: de.groupTransition
  }), se = (Lt) => {
    c === "iconContainer" && H(Lt);
  }, ge = V ? te.collapseIcon : te.expandIcon, Se = kn({
    elementType: ge,
    ownerState: {},
    externalSlotProps: (Lt) => V ? Q({}, wi(r.slotProps.collapseIcon, Lt), wi(b == null ? void 0 : b.collapseIcon, Lt)) : Q({}, wi(r.slotProps.expandIcon, Lt), wi(b == null ? void 0 : b.expandIcon, Lt)),
    additionalProps: {
      onClick: se
    }
  }), we = Zt(Se, DB), me = K && ge ? /* @__PURE__ */ p.jsx(ge, Q({}, we)) : null, ye = K ? void 0 : te.endIcon, Ie = kn({
    elementType: ye,
    ownerState: {},
    externalSlotProps: (Lt) => K ? {} : Q({}, wi(r.slotProps.endIcon, Lt), wi(b == null ? void 0 : b.endIcon, Lt))
  }), je = Zt(Ie, jB), Te = ye ? /* @__PURE__ */ p.jsx(ye, Q({}, je)) : null, Fe = te.icon, gt = kn({
    elementType: Fe,
    ownerState: {},
    externalSlotProps: b == null ? void 0 : b.icon
  }), Dt = Zt(gt, FB), ke = Fe ? /* @__PURE__ */ p.jsx(Fe, Q({}, Dt)) : null;
  let Ne;
  W ? Ne = !0 : l || z ? Ne = void 0 : Ne = !1;
  function We(Lt) {
    !B && (!z || s) && Lt.currentTarget === Lt.target && f.focusItem(Lt, S);
  }
  function Ge(Lt) {
    var jt, un, On, Un;
    j == null || j(Lt), !(G || // we can exit the editing state by clicking outside the input (within the Tree Item) or by pressing Enter or Escape -> we don't want to remove the focused item from the state in these cases
    // we can also exit the editing state by clicking on the root itself -> want to remove the focused item from the state in this case
    Lt.relatedTarget && up(Lt.relatedTarget, pe.current) && (Lt.target && ((un = (jt = Lt.target) == null ? void 0 : jt.dataset) == null ? void 0 : un.element) === "labelInput" && up(Lt.target, pe.current) || ((Un = (On = Lt.relatedTarget) == null ? void 0 : On.dataset) == null ? void 0 : Un.element) === "labelInput")) && f.removeFocusedItem();
  }
  const Qe = (Lt) => {
    var jt, un;
    L == null || L(Lt), ((un = (jt = Lt.target) == null ? void 0 : jt.dataset) == null ? void 0 : un.element) !== "labelInput" && f.handleItemKeyDown(Lt, S);
  }, Ve = o1({
    itemId: S,
    treeId: u,
    id: k
  }), Ke = f.canItemBeTabbed(S) ? 0 : -1, bt = {
    rootRefObject: pe,
    contentRefObject: Ce,
    interactions: {
      handleSaveItemLabel: ce,
      handleCancelItemLabelEditing: ie
    }
  }, vt = (($t = Y.root) == null ? void 0 : $t.call(Y, Q({}, bt, {
    externalEventHandlers: U0(R)
  }))) ?? {}, tn = ((nn = Y.content) == null ? void 0 : nn.call(Y, Q({}, bt, {
    externalEventHandlers: U0(E)
  }))) ?? {}, hn = ((Nt = Y.dragAndDropOverlay) == null ? void 0 : Nt.call(Y, Q({}, bt, {
    externalEventHandlers: {}
  }))) ?? {}, Je = ((cn = Y.labelInput) == null ? void 0 : cn.call(Y, Q({}, bt, {
    externalEventHandlers: {}
  }))) ?? {};
  return /* @__PURE__ */ p.jsx(w6, {
    itemId: S,
    children: /* @__PURE__ */ p.jsxs(LB, Q({
      className: xe(de.root, v),
      role: "treeitem",
      "aria-expanded": K ? V : void 0,
      "aria-selected": Ne,
      "aria-disabled": z || void 0,
      id: Ve,
      tabIndex: Ke
    }, R, {
      ownerState: oe,
      onFocus: We,
      onBlur: Ge,
      onKeyDown: Qe,
      ref: fe,
      style: a ? Q({}, R.style, {
        "--TreeView-itemDepth": typeof g == "function" ? g(S) : g
      }) : R.style
    }, vt, {
      children: [/* @__PURE__ */ p.jsx(AB, Q({
        as: C,
        classes: {
          root: de.content,
          expanded: de.expanded,
          selected: de.selected,
          focused: de.focused,
          disabled: de.disabled,
          editable: de.editable,
          editing: de.editing,
          iconContainer: de.iconContainer,
          label: de.label,
          labelInput: de.labelInput,
          checkbox: de.checkbox
        },
        label: T,
        itemId: S,
        onClick: P,
        onMouseDown: F,
        icon: ke,
        expansionIcon: me,
        displayIcon: Te,
        ownerState: oe
      }, E, tn, hn.action == null ? {} : {
        dragAndDropOverlayProps: hn
      }, Je.value == null ? {} : {
        labelInputProps: Je
      }, {
        ref: ee
      })), y && /* @__PURE__ */ p.jsx(NB, Q({
        as: ve
      }, J, {
        children: y
      }))]
    }))
  });
});
process.env.NODE_ENV !== "production" && (S6.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  /**
   * The component used to render the content of the item.
   * @deprecated Consider using the `<TreeItem2 />` component or the `useTreeItem2` hook instead. For more details, see https://mui.com/x/react-tree-view/tree-item-customization/.
   * @default TreeItemContent
   */
  ContentComponent: SR,
  /**
   * Props applied to ContentComponent.
   * @deprecated Consider using the `<TreeItem2 />` component or the `useTreeItem2` hook instead. For more details, see https://mui.com/x/react-tree-view/tree-item-customization/.
   */
  ContentProps: o.object,
  /**
   * If `true`, the item is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * The id of the item.
   */
  itemId: o.string.isRequired,
  /**
   * The Tree Item label.
   */
  label: o.node,
  /**
   * This prop isn't supported.
   * Use the `onItemFocus` callback on the tree if you need to monitor a item's focus.
   */
  onFocus: kR,
  /**
   * Callback fired when a key of the keyboard is pressed on the item.
   */
  onKeyDown: o.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const fz = Jl((e) => {
  const { onNodeToggle: t, onNodeSelect: n, selected: r, expanded: i, id: s, children: a } = e;
  return /* @__PURE__ */ p.jsx(
    b6,
    {
      id: s,
      expandedItems: i,
      selectedItems: r,
      onExpandedItemsChange: t,
      onSelectedItemsChange: n,
      children: a
    }
  );
}), BB = yo(S6)``, gz = Jl((e) => /* @__PURE__ */ p.jsx(
  BB,
  {
    classes: {
      root: "treeItem-container",
      selected: "treeItem-selected",
      expanded: "treeItem-expanded",
      group: "treeItem-group",
      content: "treeItem-content",
      iconContainer: "treeItem-icon-container",
      label: "treeItem-label"
    },
    ...e
  }
)), mz = (e) => {
  const { total: t, onChange: n, page: r } = e;
  return /* @__PURE__ */ p.jsx(bg, { count: t, onChange: n, page: r });
}, _B = Z(An, {
  shouldForwardProp: (e) => e !== "width"
})((e) => ({
  position: "absolute",
  top: "0",
  right: "0",
  width: e.width ? e.width : "75vw",
  height: "100vh",
  maxWidth: "100%",
  overflowY: "auto",
  backgroundColor: e.theme.palette.backgroundColor.dark,
  [e.theme.breakpoints.down("md")]: {
    width: "100%"
  }
})), zB = Z("div")(
  (e) => `
  display: flex;
  align-items: center;
  padding: 16px;
  justify-content: space-between;
  white-space: pre-wrap;
  background-color: #ffffff;
  border-bottom: 1px solid var(--border-color-light, lightgrey);
  box-shadow: ${e.theme.customShadows[3]};
  

  .modal-title {
    /* margin-top: 12px; */
    font-weight: 300;
    font-size: 24px;
    line-height: 26px;
    color: var(--text-header, grey);
  }
`
), hz = Z("button")`
  display: block;
  width: 28px;
  height: 28px;
  padding: 6px;
  position: relative;
  align-items: center;
  cursor: pointer;
  border: none;
  background: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  &:hover {
    opacity: 1;
    background-color: ${(e) => {
  var t;
  return Jn(0.9, ((t = e.theme.palette) == null ? void 0 : t.secondary.main) || "#55719d");
}};
  }
  &:before,
  &:after {
    position: absolute;
    left: 13px;
    top: 5px;
    content: '';
    height: 18px;
    width: ${(e) => (e.error, 2)}px;
    background-color: ${(e) => {
  var t;
  return e.error ? (t = e.theme.palette) == null ? void 0 : t.error.main : "#3b3b3b";
}};
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;
Z("div")`
  font-family: sans-serif;
  position: fixed;
  width: 100vw;
  height: 100vh;
  right: 0;
  top: 0;
  z-index: 10;
  background: rgb(0, 0, 0, 20%);
  overflow-y: hidden;
`;
Z("div")`
  transition: width 0ms ease-in;
  transition-delay: 0ms;
  overflow-x: hidden;
  white-space: nowrap;
  height: 100%;
  background: #f1f3f8;
  width: ${({ width: e }) => e};
  max-width: calc(100vw - 54px);
`;
const vz = Z("div")`
  position: absolute;
  width: 24px;
  height: calc(100vh - 42px);
  left: -14px;
  top: 0;
  visibility: hidden;
  :before {
    content: '';
    display: block;
    /* height: 100vh; */
    position: absolute;
    left: 12px;
    top: 0;
    background-color: ${Kr(0.2)("#d8e1ef")};
    width: 2px;
    transition: height 300ms ease-in;
    transition-delay: 100ms;
  }
  :hover {
    &:before {
      height: 100vh;
    }
  }
`, yz = Z("div")`
  visibility: hidden;
  position: absolute;
  background-color: #ffffff;
  width: 23px;
  height: 23px;
  top: 150px;
  left: 1px;
  border-radius: 50%;
  border: 1px solid
    ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.borderColor.main;
}};
  cursor: pointer;
  text-align: center;
  z-index: 2;
  & > div {
    border-color: ${Kr(0.2)("#d8e1ef")};
  }
`;
Z("div")`
  border: solid #8e97a7;
  border-width: 0 2px 2px 0;
  display: inline-block;
  top: 2px;
  right: 4px;
  height: 8px;
  min-width: 8px;
  position: relative;
  transform: rotate(-135deg);

  &.down {
    top: -2px;
    transform: rotate(45deg);
  }
  &.right {
    transform: rotate(-45deg);
    left: -2px;
  }
  &.left {
    transform: rotate(135deg);
    left: 2px;
  }
`;
const bz = (e) => /* @__PURE__ */ p.jsx(HB, { ...e }), HB = (e) => {
  const t = e.open ? e.width || window.innerWidth - 250 + "px" : 0;
  return e.open && /* @__PURE__ */ p.jsx(
    Id,
    {
      disableAutoFocus: !0,
      disablePortal: !0,
      open: e.open,
      onClose: e.onClose,
      slotProps: {
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.35)"
          }
        }
      },
      children: /* @__PURE__ */ p.jsx(Fi, { in: e.open, timeout: 300, children: /* @__PURE__ */ p.jsx(_B, { width: t, className: "modal-window-container", children: e.children }) })
    }
  );
}, Cz = (e) => /* @__PURE__ */ p.jsxs(zB, { children: [
  /* @__PURE__ */ p.jsx("div", { className: "modal-title", children: e.children }),
  e.onClose && /* @__PURE__ */ p.jsx(
    Si,
    {
      onClick: e.onClose,
      name: "closeModal",
      sx: { minWidth: 0, p: 0.5 },
      children: /* @__PURE__ */ p.jsx(qn, { iconName: "deactivate" })
    }
  )
] }), WB = Z("div", {
  shouldForwardProp: (e) => e !== "isDark" && e !== "minHeight" && e !== "outlined" && e !== "elevated"
})`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme: e, isDark: t }) => t ? e.palette.backgroundColor.dark + "d4" : "#fff"};
  border-radius: ${(e) => {
  var t;
  return ((t = e.theme.shape) == null ? void 0 : t.borderRadius) || 0;
}}px;
  box-shadow: ${({ theme: e, elevated: t }) => t ? e.customShadows[3] : "none"};
  border: ${({ outlined: e, theme: t }) => e ? "1px solid " + t.palette.borderColor.main : "none"};
  flex: 1;
  max-width: 100%;
  box-sizing: border-box;
  min-height: ${(e) => typeof (e == null ? void 0 : e.minHeight) == "string" ? e == null ? void 0 : e.minHeight : (e == null ? void 0 : e.minHeight) + "px"};
`, GB = Z("div", {
  shouldForwardProp: (e) => e !== "size" && e !== "isDark" && e !== "collapsible"
})`
  background-color: ${({ theme: e, isDark: t }) => t ? e.palette.backgroundColor.dark + "d4" : "#fff"};
  border-radius: 5px;
  padding: ${({ size: e, collapsible: t }) => e === "normal" && t ? "12px 8px 12px 16px" : "12px 16px"};
  &.content-hidden {
    display: none;
  }
  &.no-gaps {
    padding-left: 0;
    padding-right: 0;
  }
`, E6 = Z("div", {
  shouldForwardProp: (e) => e !== "unstyled"
})`
  white-space: nowrap;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  min-width: 0;
  /* max-width: calc(100% - 24px); */
  .collapsible-content-block__title-text {
    flex-grow: 1;
    min-width: 0;
    overflow: hidden;
  }
  .collapsible-content-block__actions {
    display: flex;
    flex-shrink: 0;
  }
  /* &:hover div:not(button) {
    text-decoration:  'none' )};
  } */
  font-weight: 700;
`, UB = Z("div")`
  /* padding: 24px; */
`, R6 = (e) => {
  const {
    children: t,
    className: n = "",
    isDark: r = !1,
    minHeight: i,
    elevated: s,
    outlined: a = !1
  } = e;
  return /* @__PURE__ */ p.jsx(
    WB,
    {
      className: n + " content-block",
      isDark: r,
      minHeight: i,
      elevated: s,
      outlined: a,
      children: t
    }
  );
}, YB = Z("div")`
  /* opacity: 0.4; */
  display: inline-block;
  margin-right: 8px;
  margin-top: 4px;
`, ZB = Z("div")`
  font-weight: 700;
  font-size: 16px;
`, qB = Z("div")`
  height: 42px;
  min-height: 42px;
  /* background-color: ${({ theme: e }) => e.palette.backgroundColor.main}; */
  color: ${({ theme: e }) => e.palette.primary.main};
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  align-items: center;
  border-bottom: 1px solid #d0d7de;
  border-top-left-radius: ${(e) => {
  var t;
  return ((t = e.theme.shape) == null ? void 0 : t.borderRadius) || 0;
}}px;
  border-top-right-radius: ${(e) => {
  var t;
  return ((t = e.theme.shape) == null ? void 0 : t.borderRadius) || 0;
}}px;

  /* button,
  svg {
    color: #fff;
  } */
`, xz = (e) => {
  const { title: t, startIcon: n, size: r = "normal" } = e;
  return /* @__PURE__ */ p.jsxs(qB, { className: "content-block__title", children: [
    /* @__PURE__ */ p.jsxs(Tn, { display: "flex", item: !0, alignItems: "center", children: [
      n && /* @__PURE__ */ p.jsx(YB, { children: n }),
      t && /* @__PURE__ */ p.jsx(
        ZB,
        {
          className: "content-block__title-text",
          sx: {
            fontSize: r === "dense" ? "14px" : "16px"
          },
          children: t
        }
      )
    ] }),
    e.children
  ] });
}, T6 = Z("div", {
  shouldForwardProp: (e) => e !== "size" && e !== "outlined" && e !== "collapsible"
})`
  display: flex;
  align-items: center;
  cursor: ${({ collapsible: e }) => e ? "pointer" : "default"};
  background-color: ${({ theme: e, outlined: t }) => {
  var n;
  return t ? (n = e.palette) == null ? void 0 : n.backgroundColor.light : "transparent";
}};
  padding: ${({ size: e, collapsible: t }) => e === "normal" && t ? "0 8px 0 16px" : "0px 16px"};
  line-height: ${({ size: e }) => e === "normal" ? "46px" : "40px"};
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.textColor.header;
}};
  border-radius: ${({ theme: e }) => e.shape.borderRadius}px;

  width: 100%;
  box-sizing: border-box;
  position: relative;
  .collapsible-content-block__title-text {
    font-size: 14px;
    font-weight: 700;
  }
  &.no-gaps {
    padding-left: 0;
    padding-right: 0;
    &.content-visible::after {
      left: 0;
      width: 100%;
    }
  }
  &.content-visible {
    border-bottom: ${({ theme: e, outlined: t }) => {
  var n;
  return t ? "1px solid" + ((n = e.palette) == null ? void 0 : n.borderColor.main) : "none";
}};

    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    &::after {
      content: '';
      display: block;
      left: 16px;
      bottom: 0;
      position: absolute;
      width: calc(100% - 32px);
      border-bottom: 1px solid
        ${({ theme: e, outlined: t }) => {
  var n;
  return t ? "transparent" : ((n = e.palette) == null ? void 0 : n.borderColor.main) + 80;
}};
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
`, wz = (e) => {
  const {
    title: t = "",
    children: n,
    className: r,
    defaultState: i = !0,
    size: s = "normal",
    isDark: a = !1,
    collapsible: l = !1,
    actions: c,
    keepMounted: u = !1,
    unstyled: f,
    outlined: g = !1,
    elevated: h,
    noGaps: y = !1
  } = e, [v, m] = So(i), b = () => {
    m((C) => !C);
  };
  return /* @__PURE__ */ p.jsxs(
    R6,
    {
      className: xe(
        r,
        l ? "collapsible-block" : "plain-block"
      ),
      isDark: a,
      outlined: g,
      elevated: h,
      children: [
        (l || t) && /* @__PURE__ */ p.jsxs(
          T6,
          {
            onClick: l ? b : void 0,
            size: s,
            className: xe(
              "collapsible-content-block__title",
              v ? "content-visible" : "",
              y ? "no-gaps" : ""
            ),
            outlined: g,
            collapsible: l,
            children: [
              l && /* @__PURE__ */ p.jsx(
                qn,
                {
                  iconName: v ? "collapse" : "add",
                  sx: {
                    fontSize: 13,
                    pr: 1.25,
                    color: "primary.main"
                  }
                }
              ),
              /* @__PURE__ */ p.jsxs(E6, { unstyled: f, children: [
                /* @__PURE__ */ p.jsx("div", { className: "collapsible-content-block__title-text", children: t }),
                /* @__PURE__ */ p.jsx("div", { className: "collapsible-content-block__actions", children: c })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ p.jsx(UB, { className: "collapsible-block__content", children: (v || u) && /* @__PURE__ */ p.jsx(
          GB,
          {
            size: s,
            className: xe(
              "collapsible-block__content-container",
              l ? "" : "plain-block",
              v ? "" : "content-hidden",
              y ? "no-gaps" : ""
            ),
            isDark: a,
            collapsible: l,
            children: n
          }
        ) })
      ]
    }
  );
}, KB = Z(R6)`
  /* border: 1px solid
    ${(e) => {
  var t;
  return ((t = e.theme.palette) == null ? void 0 : t.borderColor.main) || "#e4e4e4";
}}; */
`, XB = Z(T6)`
  background-color: ${({ theme: e }) => {
  var t;
  return Jn(0.3, (t = e.palette) == null ? void 0 : t.secondary.main);
}};
  justify-content: space-between;
`, QB = Z(E6)`
  &:hover {
    text-decoration: none;
  }
`, JB = Z("div")`
  border: solid #8e97a7;
  border-width: 0 2px 2px 0;
  display: inline-block;
  top: 2px;
  right: 4px;
  height: 8px;
  min-width: 8px;
  position: relative;
  transform: rotate(-135deg);

  &.down {
    top: -2px;
    transform: rotate(45deg);
  }
  &.right {
    transform: rotate(-45deg);
    left: -2px;
  }
  &.left {
    transform: rotate(135deg);
    left: 2px;
  }
`, Sz = (e) => {
  const {
    title: t = "",
    className: n = "",
    collapsible: r = !1,
    visible: i = !0,
    onAction: s,
    children: a
  } = e, [l, c] = So(i), u = ns(
    (f) => {
      f.preventDefault(), c((g) => !g), s == null || s();
    },
    [s]
  );
  return /* @__PURE__ */ p.jsxs(
    KB,
    {
      className: xe(n, "collapsible-block-panel"),
      children: [
        r && /* @__PURE__ */ p.jsxs(
          XB,
          {
            onClick: u,
            className: xe("content-block__heading", {
              collapsed: !l,
              "content-visible": l
            }),
            children: [
              /* @__PURE__ */ p.jsx(QB, { className: "content-block__title", children: t }),
              /* @__PURE__ */ p.jsx(
                JB,
                {
                  className: xe("content-block__collapse-icon", { down: !l })
                }
              )
            ]
          }
        ),
        l && a
      ]
    }
  );
}, Ez = Z(Qp)`
  .MuiPaper-root {
    box-shadow: ${({ theme: e }) => e.customShadows[0]};
    /* box-shadow: none; */
    background-color: transparent;
    margin-left: 16px;
    margin-top: 10px;
    font-family: sans-serif;
  }
`, Rz = Z("div")`
  margin: 0;
  background-color: #ffffff;
  border: 1px solid ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.borderColor.light;
}};
  z-index: 1;
  border-radius: ${({ theme: e }) => e.shape.borderRadius}px;
`;
function e_(e) {
  switch (e) {
    case Xo.COHORT:
    case Xo.DATACUT:
      return "teal";
    case Xo.COHORT_CHARACTERIZATION:
      return "peach";
    case Xo.PATHWAY:
      return "red";
    case Xo.ESTIMATION:
    case Xo.TIME_TO_EVENT:
      return "blue";
    case Xo.INCIDENCE_RATE:
    case Xo.COST:
      return "green";
    case Xo.PREDICTION:
    case Xo.CUSTOM:
      return "grey";
    case Xo.STRATEGUS:
      return "marsh";
    case Xo.SIMPLE_COUNTS_CHARACTERIZATION:
    case Xo.BULK_COHORT_COUNTS:
      return "purple";
    case Xo.FEASIBILITY:
    default:
      return "grey";
  }
}
const Tz = ({
  value: e,
  renderValue: t,
  cell: n,
  size: r = 26
}) => {
  const i = e || (t == null ? void 0 : t()), s = H6[i], a = A6(), l = e_(i), c = (r - r * 0.6) / 2, u = r * 0.6;
  return /* @__PURE__ */ p.jsx(_r, { title: s == null ? void 0 : s.name, arrow: !0, color: "primary", placement: "top", children: /* @__PURE__ */ p.jsx(
    ko,
    {
      sx: {
        display: n ? "block" : "inline-block",
        backgroundColor: a.analysesColors[l].light,
        padding: c + "px",
        width: r,
        height: r,
        borderRadius: "50%",
        boxSizing: "border-box",
        m: n ? -0.5 : 0
      },
      children: /* @__PURE__ */ p.jsx(
        z$,
        {
          iconName: s == null ? void 0 : s.icon,
          sx: {
            color: a.analysesColors[l].main,
            fontSize: u + "px"
          },
          className: "icon-analysis"
        }
      )
    }
  ) });
}, t_ = Z(An, {
  shouldForwardProp: (e) => e !== "color" && e !== "dense" && e !== "disabled" && e !== "inverted"
})(({ theme: e, color: t = "info", dense: n, disabled: r, inverted: i }) => ({
  backgroundColor: i ? Jn(0.6, "#ffffff") : Jn(
    t === "info" ? 0.85 : 0.2,
    r ? e.palette.grey[400] : e.palette[t].main
  ),
  borderRadius: "2px",
  color: function() {
    return r ? e.palette.grey[400] : i ? "#ffffff" : t === "info" ? e.palette.textColor.primary : "#ffffff";
  }(),
  fontSize: n ? 11 : 12,
  padding: n ? "2px 5px" : "3px 6px",
  display: "inline-flex",
  height: n ? 17 : 19,
  lineHeight: "14px",
  boxSizing: "border-box",
  fontWeight: 400
})), n_ = Ns(
  ({
    onClick: e,
    color: t,
    iconName: n,
    tooltipText: r = "",
    disabled: i,
    name: s,
    noCollapse: a,
    noExpand: l,
    title: c,
    loading: u,
    size: f = "medium",
    count: g
  }, h) => {
    const y = f === "small" ? 24 : 30, v = f === "small" ? 12 : 16;
    return /* @__PURE__ */ p.jsx(_r, { title: r, children: /* @__PURE__ */ p.jsx(An, { sx: { display: "flex" }, ref: h, children: /* @__PURE__ */ p.jsxs(
      Ar,
      {
        sx: (m) => {
          var b, C, E;
          return {
            height: y,
            borderRadius: 1,
            fontSize: 12,
            px: 1,
            border: "1px solid " + m.palette.borderColor.main,
            boxSizing: "border-box",
            color: (b = m.palette.primary) == null ? void 0 : b.main,
            bgcolor: "#ffffff",
            width: {
              xl: l ? g != null ? y + ((C = String(g)) == null ? void 0 : C.length) * 9.5 + 20 : y : "auto",
              xs: a ? "auto" : g != null ? y + ((E = String(g)) == null ? void 0 : E.length) * 9.5 + 20 : y
            },
            "&:hover": {
              ".text": {
                color: "white"
              },
              bgcolor: m.palette.info.light,
              border: "1px solid " + m.palette.info.light,
              color: "white",
              svg: {
                color: "white",
                opacity: 1
              }
            }
          };
        },
        disabled: i,
        onClick: e,
        name: s,
        children: [
          u ? /* @__PURE__ */ p.jsx(Vd, { size: 16 }) : /* @__PURE__ */ p.jsx(
            qn,
            {
              iconName: n,
              sx: (m) => {
                var b;
                return {
                  fontSize: v,
                  color: i ? "#22304F" : (b = m.palette[t]) == null ? void 0 : b.main,
                  opacity: i ? 0.3 : 0.7
                };
              }
            }
          ),
          /* @__PURE__ */ p.jsx(
            vo,
            {
              fontWeight: "bold",
              ml: 1,
              sx: (m) => {
                var b;
                return {
                  color: (b = m.palette.primary) == null ? void 0 : b.main,
                  fontSize: 12,
                  display: {
                    xs: a ? "inline" : "none",
                    xl: l ? "none" : "inline"
                  }
                };
              },
              component: "span",
              className: "text",
              children: c
            }
          ),
          g != null && /* @__PURE__ */ p.jsx(t_, { dense: !0, sx: { ml: 1 }, disabled: i, children: g })
        ]
      }
    ) }) });
  }
), Mz = ({
  onClick: e,
  color: t,
  iconName: n,
  tooltipText: r = "",
  disabled: i,
  name: s,
  noCollapse: a,
  noExpand: l,
  title: c,
  loading: u,
  size: f = "medium"
}) => {
  const g = f === "small" ? 24 : 30, h = f === "small" ? 12 : 16;
  return /* @__PURE__ */ p.jsx(_r, { title: r, children: /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsxs(
    Gs,
    {
      color: t,
      variant: "contained",
      sx: {
        height: g,
        borderRadius: 1,
        fontSize: 12,
        px: 1,
        minWidth: 30,
        boxSizing: "border-box",
        width: {
          xl: l ? g : "auto",
          xs: a ? "auto" : g
        },
        "&:hover": {
          ".text": {
            color: "white"
          }
        }
      },
      disabled: i,
      onClick: e,
      name: s,
      children: [
        u ? /* @__PURE__ */ p.jsx(Vd, { size: 16 }) : /* @__PURE__ */ p.jsx(
          qn,
          {
            iconName: n,
            sx: {
              fontSize: h,
              opacity: 0.7,
              ...i && {
                color: "#22304F",
                opacity: 0.3
              }
            }
          }
        ),
        /* @__PURE__ */ p.jsx(
          vo,
          {
            fontWeight: "bold",
            ml: 1,
            sx: {
              fontSize: 12,
              display: {
                xs: a ? "inline" : "none",
                xl: l ? "none" : "inline"
              }
            },
            component: "span",
            className: "text",
            children: c
          }
        )
      ]
    }
  ) }) });
}, kz = (e) => {
  const {
    children: t,
    title: n = "",
    size: r = "medium",
    disabled: i = !1,
    options: s,
    placement: a,
    onItemClick: l,
    color: c = "primary",
    closeOnSelect: u = !1,
    name: f,
    tooltipPlacement: g,
    iconComponent: h,
    iconName: y,
    tooltipText: v,
    noExpand: m,
    noCollapse: b,
    count: C
  } = e, [E, S] = He.useState(!1), k = He.useRef(null), T = (L) => {
    L.stopPropagation(), S((R) => !R);
  }, P = (L) => {
    L && k.current && k.current.contains(L.target) || S(!1);
  };
  function F(L) {
    L.stopPropagation(), L.key === "Tab" && (L.preventDefault(), S(!1));
  }
  const j = He.useRef(E);
  return He.useEffect(() => {
    j.current === !0 && E === !1 && k.current.focus(), j.current = E;
  }, [E]), /* @__PURE__ */ p.jsxs(He.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      n_,
      {
        disabled: i,
        onClick: T,
        color: c,
        ref: k,
        iconName: y,
        size: r,
        name: f,
        title: n,
        tooltipText: v,
        noExpand: m,
        noCollapse: b,
        count: C
      }
    ),
    /* @__PURE__ */ p.jsx(
      us,
      {
        open: E,
        anchorEl: k.current,
        transition: !0,
        sx: { zIndex: 2e3 },
        placement: a || "bottom",
        disablePortal: e.disablePortal ?? !0,
        modifiers: [
          {
            name: "flip",
            enabled: !1
          },
          {
            name: "preventOverflow",
            ...e.preventOverflow ? {
              enabled: !0,
              options: {
                altAxis: !0,
                altBoundary: !0,
                tether: !0,
                rootBoundary: "document",
                padding: 8
              }
            } : { enabled: !1 }
          }
        ],
        children: ({ TransitionProps: L }) => /* @__PURE__ */ p.jsx(ss, { ...L, children: /* @__PURE__ */ p.jsx(li, { sx: dh, children: /* @__PURE__ */ p.jsx(Ta, { onClickAway: P, children: /* @__PURE__ */ p.jsx(
          Fd,
          {
            autoFocusItem: E,
            id: "menu-list-grow",
            onKeyDown: F,
            sx: ch,
            className: "drop-down-menu",
            children: t || (s == null ? void 0 : s.map((R) => /* @__PURE__ */ p.jsx(
              wc,
              {
                text: R.message || "",
                placement: g || "auto",
                children: /* @__PURE__ */ p.jsxs("div", { children: [
                  /* @__PURE__ */ p.jsxs(
                    xr,
                    {
                      className: "menu-item-" + R.name,
                      onClick: (V) => {
                        V.stopPropagation(), l && l(R), u && P();
                      },
                      sx: uh(!!h),
                      disabled: R == null ? void 0 : R.disabled,
                      selected: R.name === n,
                      children: [
                        /* @__PURE__ */ p.jsx(p.Fragment, { children: h && /* @__PURE__ */ p.jsx(ph, { children: /* @__PURE__ */ p.jsx(h, { value: R.id }) }) }),
                        R.component || R.name
                      ]
                    },
                    R.name
                  ),
                  R.endGroup && /* @__PURE__ */ p.jsx(fh, {})
                ] })
              }
            )))
          }
        ) }) }) })
      }
    )
  ] });
}, t2 = Z(dc, {
  shouldForwardProp: (e) => e != "active" && e != "color" && e !== "size" && e !== "disabled" && e !== "disableInactiveHover"
})(({ active: e, theme: t, size: n, color: r, disabled: i, disableInactiveHover: s }) => {
  var a;
  return {
    "&.input-root": {
      input: {
        lineHeight: { small: "20px", medium: "24px", large: "28px" }[n],
        color: r || t.palette.textColor.secondary,
        textOverflow: "ellipsis"
      },
      textarea: {
        color: r || t.palette.textColor.secondary,
        lineHeight: { small: "20px", medium: "24px", large: "28px" }[n]
      },
      ".select-root, input, textarea": {
        padding: "0"
      },
      ".select-icon": {
        right: 0
      },
      ...e ? {
        border: "1px solid " + t.palette.secondary.main,
        backgroundColor: "#fff",
        "&:hover": {
          border: "1px solid " + Kr(0.1, t.palette.secondary.main),
          backgroundColor: "#fff"
        }
      } : {
        border: "1px solid transparent",
        "&:hover": {
          backgroundColor: !i && !s ? (a = t.palette.backgroundColor) == null ? void 0 : a.dark : "transparent"
        }
      },
      "&.Mui-disabled, &.Mui-disabled input": {
        color: r || t.palette.textColor.secondary,
        WebkitTextFillColor: "unset"
      },
      ".end-adornment": {
        visibility: e ? "visible" : "hidden",
        ".MuiButtonBase-root": {
          color: Kr(0.2, t.palette.secondary.main)
        }
      },
      "&:hover .end-adornment": {
        visibility: i ? "hidden" : "visible"
      },
      transition: "background-color 300ms",
      fontSize: { small: 14, medium: 20, large: 24 }[n],
      lineHeight: { small: "20px", medium: "24px", large: "28px" }[n],
      fontWeight: { small: 400, medium: 300, large: 300 }[n],
      borderRadius: "4px",
      padding: "4px 8px",
      // width: '100%',
      boxSizing: "border-box",
      height: "auto"
    }
  };
}), o_ = Z("form")({
  position: "relative",
  ".editable-component-actions": {
    position: "absolute",
    right: 0,
    bottom: "calc(-30px - 4px)",
    display: "inline-flex",
    width: "auto",
    zIndex: 2
  }
}), r_ = ({
  onSubmit: e,
  onCancel: t,
  disableSubmit: n,
  isSubmitting: r = !1,
  submitErrorMessage: i = ""
}) => /* @__PURE__ */ p.jsxs(Tn, { className: "editable-component-actions", container: !0, children: [
  /* @__PURE__ */ p.jsx(
    _r,
    {
      title: !r && n && i ? i : "",
      children: /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx(
        Si,
        {
          name: "editable-component-save",
          sx: (s) => ({
            minWidth: 0,
            p: 0,
            backgroundColor: "#ffffff",
            height: 30,
            width: 30
          }),
          color: "inherit",
          variant: "outlined",
          onClick: e,
          disabled: n || r,
          children: r ? /* @__PURE__ */ p.jsx(zs, { size: 16, color: "success" }) : /* @__PURE__ */ p.jsx(
            qn,
            {
              iconName: "check",
              color: n ? "disabled" : "success"
            }
          )
        }
      ) })
    }
  ),
  /* @__PURE__ */ p.jsx(
    Si,
    {
      name: "editable-component-cancel",
      sx: (s) => ({
        minWidth: 0,
        p: 0,
        backgroundColor: "#ffffff",
        height: 30,
        width: 30,
        ml: 0.5
      }),
      color: "inherit",
      variant: "outlined",
      onClick: t,
      disabled: r,
      children: /* @__PURE__ */ p.jsx(qn, { iconName: "deactivate", color: "error", sx: { fontSize: 16 } })
    }
  )
] }), M6 = ({
  children: e,
  onCancel: t,
  onSubmit: n,
  active: r,
  showActions: i = !1,
  disabled: s = !1,
  disableSubmit: a = !1,
  isSubmitting: l = !1,
  submitErrorMessage: c,
  multiline: u = !1,
  submitOnClickOutside: f = !1
}) => {
  const g = (h) => {
    l || (h.key === "Escape" && (t == null || t()), h.key === "Enter" && (u || h == null || h.preventDefault(), !h.ctrKey && !h.metaKey && !h.shiftKey && !a && (a ? r6({
      message: c,
      variant: "error"
    }) : n == null || n())));
  };
  return /* @__PURE__ */ p.jsx(
    Ta,
    {
      onClickAway: () => {
        l || r && (f && !a ? n() : t());
      },
      mouseEvent: "onMouseDown",
      disableReactTree: s,
      children: /* @__PURE__ */ p.jsxs(o_, { onKeyDown: g, children: [
        e,
        r && !s && i && /* @__PURE__ */ p.jsx(
          r_,
          {
            onCancel: t,
            onSubmit: n,
            submitErrorMessage: c,
            disableSubmit: a,
            isSubmitting: l
          }
        )
      ] })
    }
  );
}, i_ = d.forwardRef(
  ({
    value: e,
    type: t = "text",
    onCancel: n,
    onSubmit: r,
    size: i = "small",
    placeholder: s,
    disabled: a,
    color: l,
    submitOnClickOutside: c = !1,
    activateOnClick: u = !0,
    disableInactiveHover: f = !1,
    showActions: g = !0,
    onValueChange: h,
    ...y
  }, v) => {
    const [m, b] = d.useState(null), [C, E] = d.useState(!1), [S, k] = d.useState(!1), T = async (j) => {
      if (!S) {
        k(!0);
        try {
          await (r == null ? void 0 : r(m)) !== !1 && E(!1);
        } finally {
          k(!1);
        }
      }
    }, P = (j) => {
      S || (n == null || n(), E(!1), b(e));
    };
    d.useImperativeHandle(
      v,
      () => ({
        activate: () => {
          a || E(!0);
        },
        deactivate: () => {
          E(!1);
        }
      }),
      [a]
    ), d.useEffect(() => {
      b(e);
    }, [e]);
    const F = y.required && !m;
    return /* @__PURE__ */ p.jsx(
      M6,
      {
        onSubmit: T,
        onCancel: P,
        active: C,
        showActions: g,
        disabled: a,
        disableSubmit: F || m === e,
        isSubmitting: S,
        submitOnClickOutside: c,
        submitErrorMessage: F ? "You cannot save empty value" : m === e ? "" : "You cannot save fields",
        multiline: y.multiline,
        children: /* @__PURE__ */ p.jsx(
          t2,
          {
            ...y,
            onClick: a ? void 0 : (j) => {
              j.stopPropagation(), u && E(!0);
            },
            value: m || "",
            onChange: (j) => {
              j.stopPropagation();
              const L = j.target.value;
              b(L), h == null || h(L);
            },
            active: C,
            color: l,
            disableInactiveHover: f,
            readOnly: !C,
            disabled: a,
            margin: "none",
            placeholder: s || "...",
            size: i,
            inputProps: {
              type: t,
              ...y.inputProps
            },
            classes: {
              root: "input-root",
              focused: "input-focused",
              // input: "input-small",
              /** Styles applied to the input element if `size="small"`. */
              inputSizeSmall: "input-small",
              /** Styles applied to the input element if `multiline={true}`. */
              inputMultiline: "input-multiline",
              /** Styles applied to the input element if `type="search"`. */
              inputTypeSearch: "input-search"
            }
          }
        )
      }
    );
  }
);
i_.displayName = "EditableInput";
const Pz = ({
  value: e,
  onCancel: t,
  onSubmit: n,
  size: r = "small",
  placeholder: i = "...",
  options: s,
  native: a = !1,
  ...l
}) => {
  const [c, u] = d.useState(!1), f = () => {
    t == null || t(), u(!1);
  };
  return /* @__PURE__ */ p.jsxs(
    fc,
    {
      ...l,
      variant: l.variant,
      onOpen: l.disabled ? void 0 : (g) => {
        u(!0);
      },
      value: e,
      onChange: (g) => {
        n == null || n(g.target.value);
      },
      onClose: () => {
        f();
      },
      margin: "none",
      classes: {
        select: "select-root select-" + r,
        nativeInput: "select-root",
        icon: "select-icon"
      },
      input: /* @__PURE__ */ p.jsx(
        t2,
        {
          active: c,
          size: r,
          placeholder: i,
          disabled: l.disabled,
          classes: {
            root: "input-root",
            focused: "input-focused",
            inputSizeSmall: "input-small",
            inputMultiline: "input-multiline",
            inputTypeSearch: "input-search"
          }
        }
      ),
      children: [
        i && (a ? /* @__PURE__ */ p.jsx("option", { value: "", disabled: !0, children: i }, "placeholder") : /* @__PURE__ */ p.jsx(Yu, { value: "", disabled: !0, className: r, children: i }, "placeholder")),
        s && !!s.length && s.map(
          (g) => a ? /* @__PURE__ */ p.jsx("option", { value: g.value, children: g.name }, g.name) : /* @__PURE__ */ p.jsxs(Yu, { value: g.value, className: r, children: [
            g.name,
            " ",
            g.tag != null ? `(${g.tag})` : ""
          ] }, g.name)
        )
      ]
    }
  );
}, Iz = ({
  value: e,
  onCancel: t,
  onSubmit: n,
  size: r = "small",
  placeholder: i = "...",
  options: s,
  ...a
}) => {
  const [l, c] = d.useState(!1);
  return /* @__PURE__ */ p.jsx(
    Lp,
    {
      ...a,
      value: e || null,
      options: s || [],
      onOpen: () => {
        c(!0);
      },
      onClose: () => {
        c(!1);
      },
      onChange: (u, f) => {
        n == null || n(f), !a.disableCloseOnSelect && c(!1);
      },
      size: r,
      classes: {
        root: "autocomplete-root",
        endAdornment: "end-adornment"
      },
      sx: [
        {
          "&.autocomplete-root .input-root": {
            paddingRight: "4px"
          },
          "&.autocomplete-root .input-root.Mui-disabled": {
            input: {
              color: a.color
            }
          }
        },
        ...Array.isArray(a.sx) ? a.sx : [a.sx]
      ],
      renderInput: (u) => {
        const { InputLabelProps: f, InputProps: g, ...h } = u;
        return /* @__PURE__ */ p.jsx(
          t2,
          {
            ...u.InputProps,
            ...h,
            active: l,
            placeholder: i,
            disabled: h.disabled,
            classes: {
              root: "input-root",
              focused: "input-focused",
              inputSizeSmall: "input-small",
              inputMultiline: "input-multiline",
              inputTypeSearch: "input-search"
            }
          }
        );
      }
    }
  );
}, s_ = Z(Gp)({
  [`& .${Il.container}`]: {
    outline: 0
  },
  [`& .${Il.paper}`]: {
    outline: 0,
    minWidth: Bd
  }
}), a_ = Z(ig)({
  "&:first-of-type": {
    padding: 0
  }
});
function l_(e) {
  const {
    children: t,
    onDismiss: n,
    open: r,
    slots: i,
    slotProps: s
  } = e, a = (i == null ? void 0 : i.dialog) ?? s_, l = (i == null ? void 0 : i.mobileTransition) ?? Fi;
  return /* @__PURE__ */ p.jsx(a, Q({
    open: r,
    onClose: n
  }, s == null ? void 0 : s.dialog, {
    TransitionComponent: l,
    TransitionProps: s == null ? void 0 : s.mobileTransition,
    PaperComponent: i == null ? void 0 : i.mobilePaper,
    PaperProps: s == null ? void 0 : s.mobilePaper,
    children: /* @__PURE__ */ p.jsx(a_, {
      children: t
    })
  }));
}
const c_ = ["props", "getOpenDialogAriaText"], u_ = (e) => {
  var Y;
  let {
    props: t,
    getOpenDialogAriaText: n
  } = e, r = Zt(e, c_);
  const {
    slots: i,
    slotProps: s,
    className: a,
    sx: l,
    format: c,
    formatDensity: u,
    enableAccessibleFieldDOMStructure: f,
    selectedSections: g,
    onSelectedSectionsChange: h,
    timezone: y,
    name: v,
    label: m,
    inputRef: b,
    readOnly: C,
    disabled: E,
    localeText: S
  } = t, k = d.useRef(null), T = mc(), P = ((Y = s == null ? void 0 : s.toolbar) == null ? void 0 : Y.hidden) ?? !1, {
    open: F,
    actions: j,
    layoutProps: L,
    renderCurrentView: R,
    fieldProps: V,
    contextValue: B
  } = qg(Q({}, r, {
    props: t,
    fieldRef: k,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), W = i.field, z = kn({
    elementType: W,
    externalSlotProps: s == null ? void 0 : s.field,
    additionalProps: Q({}, V, P && {
      id: T
    }, !(E || C) && {
      onClick: j.onOpen,
      onKeyDown: kT(j.onOpen)
    }, {
      readOnly: C ?? !0,
      disabled: E,
      className: a,
      sx: l,
      format: c,
      formatDensity: u,
      enableAccessibleFieldDOMStructure: f,
      selectedSections: g,
      onSelectedSectionsChange: h,
      timezone: y,
      label: m,
      name: v
    }, b ? {
      inputRef: b
    } : {}),
    ownerState: t
  });
  z.inputProps = Q({}, z.inputProps, {
    "aria-label": n(V.value)
  });
  const G = Q({
    textField: i.textField
  }, z.slots), H = i.layout ?? ff;
  let ie = T;
  P && (m ? ie = `${T}-label` : ie = void 0);
  const ce = Q({}, s, {
    toolbar: Q({}, s == null ? void 0 : s.toolbar, {
      titleId: T
    }),
    mobilePaper: Q({
      "aria-labelledby": ie
    }, s == null ? void 0 : s.mobilePaper)
  }), re = Vo(k, z.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ p.jsxs(Jg, {
      contextValue: B,
      localeText: S,
      children: [/* @__PURE__ */ p.jsx(W, Q({}, z, {
        slots: G,
        slotProps: ce,
        unstableFieldRef: re
      })), /* @__PURE__ */ p.jsx(l_, Q({}, j, {
        open: F,
        slots: i,
        slotProps: ce,
        children: /* @__PURE__ */ p.jsx(H, Q({}, L, ce == null ? void 0 : ce.layout, {
          slots: i,
          slotProps: ce,
          children: R()
        }))
      }))]
    })
  };
}, k6 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  var u, f;
  const r = Li(), i = no(), s = Hg(t, "MuiMobileDatePicker"), a = Q({
    day: ha,
    month: ha,
    year: ha
  }, s.viewRenderers), l = Q({}, s, {
    viewRenderers: a,
    format: sf(i, s, !1),
    slots: Q({
      field: yf
    }, s.slots),
    slotProps: Q({}, s.slotProps, {
      field: (g) => {
        var h;
        return Q({}, wi((h = s.slotProps) == null ? void 0 : h.field, g), Gg(s), {
          ref: n
        });
      },
      toolbar: Q({
        hidden: !1
      }, (u = s.slotProps) == null ? void 0 : u.toolbar)
    })
  }), {
    renderPicker: c
  } = u_({
    props: l,
    valueManager: oi,
    valueType: "date",
    getOpenDialogAriaText: Bg({
      utils: i,
      formatKey: "fullDate",
      contextTranslation: r.openDatePickerDialogue,
      propsTranslation: (f = l.localeText) == null ? void 0 : f.openDatePickerDialogue
    }),
    validator: vc
  });
  return c();
});
k6.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: o.bool,
  className: o.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: o.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: o.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: o.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: o.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: o.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: o.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: o.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $i,
  /**
   * The label content.
   */
  label: o.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: o.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: o.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: o.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: o.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: o.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: o.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: o.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: o.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: o.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: o.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: o.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: o.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: o.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: o.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: o.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: o.oneOf(["landscape", "portrait"]),
  readOnly: o.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: o.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: o.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: o.oneOfType([o.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), o.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: o.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: o.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: o.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: o.shape({
    day: o.func,
    month: o.func,
    year: o.func
  }),
  /**
   * Available views.
   */
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: o.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: o.oneOf([3, 4])
};
const d_ = ["desktopModeMediaQuery"], P6 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = Kn({
    props: t,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: i = PT
  } = r, s = Zt(r, d_);
  return lg(i, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ p.jsx(bf, Q({
    ref: n
  }, s)) : /* @__PURE__ */ p.jsx(k6, Q({
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (P6.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: o.bool,
  className: o.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: o.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: o.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: o.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: o.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: o.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: o.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: o.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: o.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $i,
  /**
   * The label content.
   */
  label: o.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: o.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: o.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: o.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: o.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: o.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: o.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: o.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: o.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: o.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: o.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: o.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: o.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: o.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: o.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: o.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: o.oneOf(["landscape", "portrait"]),
  readOnly: o.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: o.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: o.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: o.oneOfType([o.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), o.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: o.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: o.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: o.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: o.shape({
    day: o.func,
    month: o.func,
    year: o.func
  }),
  /**
   * Available views.
   */
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: o.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: o.oneOf([3, 4])
});
const Oz = ({
  disabled: e,
  submitErrorMessage: t,
  ...n
}) => {
  const [r, i] = He.useState(null), [s, a] = He.useState(!1), [l, c] = He.useState(null), u = No(() => navigator.language, [navigator.language]), f = {
    ...n.format ? {
      inputFormat: n.format
    } : {}
  }, g = l && !r ? r === n.value ? "Nothing to save" : n.label + " cannot be empty" : t;
  return Rn(() => {
    i(n.value);
  }, [n.value]), /* @__PURE__ */ p.jsx(
    M6,
    {
      onSubmit: function() {
        var h;
        (h = n.onSubmit) == null || h.call(n, r), a(!1);
      },
      onCancel: function() {
        a(!1), i(n.value);
      },
      disableSubmit: l,
      submitErrorMessage: g,
      active: s,
      showActions: !0,
      children: /* @__PURE__ */ p.jsx(
        ko,
        {
          onClick: () => a(!0),
          sx: { pointerEvents: e ? "none" : "auto" },
          children: /* @__PURE__ */ p.jsx(
            Ld,
            {
              dateAdapter: lh,
              adapterLocale: u,
              children: /* @__PURE__ */ p.jsx(
                P6,
                {
                  label: void 0,
                  value: r != null ? ct(r) : null,
                  minDate: n.minDate,
                  maxDate: n.maxDate,
                  onChange: (h, y) => {
                    i(h.toISOString()), c((y == null ? void 0 : y.validationError) || null);
                  },
                  disableFuture: n.disableFuture,
                  disablePast: n.disablePast,
                  slotProps: {
                    textField: {
                      placeholder: e ? "..." : "MM / DD / YYYY"
                    }
                  },
                  sx: (h) => {
                    var y;
                    return {
                      width: e ? "100px" : "134px",
                      boxSizing: "border-box",
                      "&:hover": {
                        backgroundColor: s ? "#ffffff" : "backgroundColor.dark",
                        borderRadius: "4px",
                        ".MuiSvgIcon-root": {
                          visibility: "visible"
                        },
                        ".MuiOutlinedInput-notchedOutline": {
                          border: "1px solid transparent"
                        }
                      },
                      ".Mui-error.MuiInputBase-root .MuiOutlinedInput-notchedOutline": {
                        borderColor: h.palette.error.main
                      },
                      ".MuiInputBase-root": {
                        paddingRight: e ? 0 : "10px",
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: s ? Kr(0.1, h.palette.secondary.main) : "transparent"
                        },
                        ".MuiOutlinedInput-notchedOutline": {
                          ...s ? {
                            border: "1px solid " + h.palette.secondary.main,
                            "&:hover": {
                              border: "1px solid " + Kr(0.1, h.palette.secondary.main)
                            }
                          } : {
                            border: "1px solid transparent",
                            "&:hover": {
                              backgroundColor: (y = h.palette.backgroundColor) == null ? void 0 : y.dark
                            }
                          }
                        }
                      },
                      ".MuiInputAdornment-root": { width: e ? 0 : 16 },
                      ".MuiInputBase-input": {
                        padding: "4px 0 4px 8px",
                        fontSize: 13,
                        lineHeight: "28px",
                        color: "textColor.secondary",
                        height: 22
                      },
                      ".MuiButtonBase-root": {
                        p: 0
                      },
                      ".MuiSvgIcon-root": {
                        visibility: e ? "hidden" : "visible",
                        fontSize: 16,
                        color: Kr(0.2, h.palette.secondary.main),
                        opacity: s ? 1 : 0.6
                      }
                    };
                  },
                  ...f
                }
              )
            }
          )
        }
      )
    }
  );
}, y0 = (e, t) => ({
  background: e.palette.backgroundColor.disabled,
  border: t ? "none" : "1px solid",
  borderColor: e.palette.backgroundColor.disabled,
  color: e.palette.borderColor.main,
  svg: { color: e.palette.borderColor.main },
  span: { color: e.palette.borderColor.main }
}), p_ = (e) => ({
  MuiButton: {
    styleOverrides: {
      root: {
        "&.MuiButton-outlined.Mui-disabled": y0(e),
        "&.MuiButton-contained.Mui-disabled": y0(e, !0),
        ".MuiButton-iconSizeSmall .MuiSvgIcon-root": { fontSize: 14 },
        ".MuiButton-iconSizeMedium .MuiSvgIcon-root": { fontSize: 14 },
        // info
        "&.MuiButton-containedInfo:hover, &.MuiButton-outlinedInfo:hover": {
          backgroundColor: Gr(0.12, e.palette.info.main)
        },
        "&.MuiButton-outlinedInfo:hover": {
          borderColor: Gr(0.12, e.palette.info.main),
          color: "#ffffff"
        },
        // error
        "&.MuiButton-containedError:hover, &.MuiButton-outlinedError:hover": {
          backgroundColor: Gr(0.12, e.palette.error.main)
        },
        "&.MuiButton-outlinedError:hover": {
          borderColor: Gr(0.12, e.palette.error.main),
          color: "#ffffff"
        },
        // success
        "&.MuiButton-containedSuccess:hover, &.MuiButton-outlinedSuccess:hover": {
          backgroundColor: Gr(0.12, e.palette.success.main),
          color: "#ffffff"
        },
        "&.MuiButton-outlinedSuccess:hover": {
          borderColor: Gr(0.12, e.palette.success.main),
          color: "#ffffff"
        },
        // warning
        "&.MuiButton-containedWarning:hover, &.MuiButton-outlinedWarning:hover": {
          backgroundColor: Gr(0.12, e.palette.warning.main),
          color: "#ffffff"
        },
        "&.MuiButton-outlinedWarning:hover": {
          borderColor: Gr(0.12, e.palette.warning.main),
          color: "#ffffff"
        },
        // primary
        "&.MuiButton-containedPrimary:hover, &.MuiButton-outlinedPrimary:hover": {
          backgroundColor: Gr(0.12, e.palette.info.main),
          color: "#ffffff"
        },
        "&.MuiButton-outlinedPrimary:hover": {
          borderColor: Gr(0.12, e.palette.info.main),
          color: "#ffffff"
        },
        // other
        "&.MuiButton-outlined": {
          background: "#ffffff",
          borderColor: e.palette.borderColor.main
        },
        "& .MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall": {
          fontSize: 9
        },
        svg: { opacity: 1 },
        textTransform: "none",
        fontWeight: "bold",
        boxShadow: "none",
        "&:hover, &:active": {
          boxShadow: "none"
        }
      },
      sizeSmall: { height: 24 },
      sizeMedium: { height: 30 },
      sizeLarge: { height: 48 }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        "&.Mui-disabled": y0(e),
        svg: { opacity: 1 }
      }
    }
  }
}), f_ = () => ({
  MuiPaper: {
    styleOverrides: {
      elevation1: { boxShadow: "0 3px 13px 0 rgba(0,0,0,0.16)" },
      elevation2: {
        boxShadow: "0px 7px 13px -7px rgb(0 0 0 / 16%)"
      },
      elevation3: {
        boxShadow: "0px 4px 2px 0px rgba(0, 0, 0, 0.13)"
      }
    }
  }
}), g_ = (e) => ({
  allVariants: {
    color: e.palette.textColor.header,
    fontSize: "14px"
  },
  body2: {
    color: e.palette.textColor.secondary,
    fontSize: "14px",
    fontWeight: 400
  },
  h1: {
    color: e.palette.textColor.header,
    fontSize: "24px"
  },
  h2: {
    color: e.palette.textColor.header,
    fontSize: "18px",
    fontWeight: 700
  },
  h3: {
    color: e.palette.textColor.header,
    fontSize: "16px",
    fontWeight: 700
  },
  subtitle1: {
    color: e.palette.textColor.label,
    fontSize: "12px",
    fontWeight: 700
  },
  subtitle2: {
    color: e.palette.textColor.secondary,
    fontSize: "12px",
    fontWeight: 400
  }
}), m_ = (e) => ({
  // TDOD replace all tooltips
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        borderRadius: "3px",
        fontSize: "0.8rem",
        backgroundColor: Jn(0.2, e.palette.primary.main),
        fontWeight: 400,
        padding: "5px 10px"
      },
      arrow: {
        color: Jn(0.2, e.palette.primary.main)
      }
    }
  }
}), W5 = {
  teal: { main: "#74D5C9", light: "#DBFAFC" },
  marsh: { main: "#88A78E", light: "#E8F2EA" },
  blue: { main: "#66AEED", light: "#EDF2FF" },
  purple: { main: "#A49EE7", light: "#EDECFF" },
  grey: { main: "#91A4CC", light: "#ECEFF6" },
  green: { main: "#70D48C", light: "#E6F4E2" },
  peach: { main: "#FFA082", light: "#FFF0EB" },
  red: { main: "#FF7575", light: "#FFEDED" }
}, G5 = "#212121", h_ = "#20314F", v_ = "#474850", y_ = "#798395", U5 = "#c3cad2", Dz = (e) => {
  var n;
  let t = Bl({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1400
      }
    },
    palette: {
      backgroundColor: {
        white: "#ffffff",
        main: "#F7F8FA",
        dark: "#EBEEF4",
        light: "#F8F9FB",
        header: "#4A5360",
        icon: "#B9E1EA80",
        disabled: "#E1E5EA",
        ...(e == null ? void 0 : e.backgroundColor) ?? {}
      },
      primary: {
        main: "#21304f",
        contrastText: "#ffffff",
        ...(e == null ? void 0 : e.primary) ?? {}
      },
      secondary: {
        main: "#CEDAEB",
        contrastText: "#ffffff",
        ...(e == null ? void 0 : e.secondary) ?? {}
      },
      success: {
        main: "#8FCA54",
        contrastText: "#ffffff",
        ...(e == null ? void 0 : e.success) ?? {}
      },
      error: {
        main: "#D94221",
        contrastText: "#ffffff",
        ...(e == null ? void 0 : e.error) ?? {}
      },
      warning: {
        main: "#ff9800",
        contrastText: "#ffffff",
        ...(e == null ? void 0 : e.warning) ?? {}
      },
      info: {
        light: "#51A4ED",
        main: "#2183D9",
        contrastText: "#ffffff",
        ...(e == null ? void 0 : e.info) ?? {}
      },
      analysesColors: W5,
      textColor: {
        primary: G5,
        // dark blue
        secondary: v_,
        // grey - text
        label: y_,
        // light grey - text
        header: h_,
        // blue
        ...(e == null ? void 0 : e.textColor) ?? {}
      },
      borderColor: {
        main: U5,
        light: "#f1f3f7",
        ...(e == null ? void 0 : e.borderColor) ?? {}
      },
      divider: ((n = e == null ? void 0 : e.borderColor) == null ? void 0 : n.main) ?? U5,
      black: { main: "#202020", light: "#A0A8BA" },
      purple: { main: "#A167FF", light: "#E8DBFC" },
      teal: { main: "#57BBC3", light: "#D3F1F3" },
      green: { main: "#70D48C", light: "#E6F4E2" },
      blue: { main: "#51A4ED", contrastText: "#ffffff", light: "#DCEDFF" },
      darkGrey: { main: "#616161", contrastText: "#ffffff" }
    },
    analysesColors: W5,
    customShadows: [
      "0 3px 13px 0 rgba(0,0,0,0.16)",
      "0px 7px 13px -7px rgb(0 0 0 / 16%)",
      "0 2px 4px 0 rgba(0,0,0,0.1)",
      "0px 4px 2px 0px rgba(0, 0, 0, 0.13)"
    ],
    shape: { borderRadius: 4 },
    typography: {
      color: G5,
      fontFamily: [
        "Roboto",
        '"Helvetica Neue"',
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"'
      ].join(",")
    }
  });
  return t = Bl(t, {
    components: {
      ...p_(t),
      ...f_(),
      ...m_(t)
    },
    typography: {
      ...g_(t)
    }
  }), t;
}, jz = ({
  size: e = 45,
  image: t
}) => t ? /* @__PURE__ */ p.jsx(
  An,
  {
    width: e,
    height: e,
    sx: {
      backgroundImage: `url(${t})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      display: "block"
    }
  }
) : /* @__PURE__ */ p.jsx(p.Fragment, {}), Fz = [
  { skipVectorSearch: !0, vectorSearchResultLimit: 5 },
  { skipVectorSearch: !1, vectorSearchResultLimit: 5 },
  { skipVectorSearch: !1, vectorSearchResultLimit: 10 },
  { skipVectorSearch: !1, vectorSearchResultLimit: 15 }
], hl = {
  active: "#11AAE8",
  neutral: "#8A8F98",
  labels: "#676E79"
}, b_ = [
  "Concept name candidates from the prompt, that have an exact match in vocabulary - are NOT evaluated by LLM",
  "Concept name candidates from the prompt, that have an exact match in vocabulary - are evaluated by LLM and semantic vector search is limited to 5 close concepts.",
  "Concept name candidates from the prompt, that have an exact match in vocabulary - are evaluated by LLM and semantic vector search is limited to 10 close concepts.",
  "Concept name candidates from the prompt, that have an exact match in vocabulary - are evaluated by LLM and semantic vector search is limited to 15 close concepts."
], C_ = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, -10]
      }
    },
    {
      name: "flip",
      enabled: !1
    },
    {
      name: "preventOverflow",
      options: {
        altAxis: !1
      }
    },
    {
      name: "computeStyles",
      options: {
        adaptive: !1,
        roundOffsets: !1
      }
    }
  ]
}, Vz = ({
  value: e,
  onChange: t,
  min: n = 0,
  max: r = 3,
  exactLabel: i = "Exact",
  broadLabel: s = "Broad",
  disabled: a = !1
}) => {
  const l = Array.from({ length: r - n + 1 }, (y, v) => ({
    value: n + v
  })), c = r - n, [u, f] = He.useState(null), g = He.useCallback(() => {
    f(null);
  }, []), h = He.useCallback(
    (y) => {
      if (a) {
        f(null);
        return;
      }
      const v = y.currentTarget.getBoundingClientRect(), m = y.clientX - v.left, b = y.clientY - v.top, C = v.height / 2, E = 14, S = 14;
      let k = null, T = Number.POSITIVE_INFINITY;
      l.forEach((P) => {
        const F = c === 0 ? 0 : (P.value - n) / c * v.width, j = Math.abs(m - F), L = Math.abs(b - C);
        if (j <= E && L <= S) {
          const R = j + L;
          R < T && (T = R, k = P.value);
        }
      }), f((P) => P === k ? P : k);
    },
    [a, l, n, c]
  );
  return /* @__PURE__ */ p.jsxs(Tn, { container: !0, children: [
    /* @__PURE__ */ p.jsx(Tn, { item: !0, xs: 12, px: 1, children: /* @__PURE__ */ p.jsxs(
      An,
      {
        sx: { position: "relative" },
        onPointerMove: h,
        onPointerLeave: g,
        children: [
          /* @__PURE__ */ p.jsx(
            Ig,
            {
              min: n,
              max: r,
              step: 1,
              track: !1,
              marks: l,
              disabled: a,
              value: e,
              onChange: (y, v) => t(Array.isArray(v) ? v[0] : v),
              sx: {
                p: 0,
                height: 3,
                "& .MuiSlider-rail": {
                  opacity: 1,
                  height: 3,
                  backgroundColor: hl.neutral
                },
                "& .MuiSlider-track": {
                  border: "none",
                  backgroundColor: "transparent"
                },
                "& .MuiSlider-thumb": {
                  width: 16,
                  height: 16,
                  backgroundColor: hl.active,
                  boxShadow: "none",
                  "&:hover, &.Mui-focusVisible, &.Mui-active": {
                    boxShadow: "0 0 0 6px rgba(17, 170, 232, 0.18)"
                  }
                },
                "& .MuiSlider-mark": {
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: hl.neutral,
                  opacity: 1,
                  top: "50%",
                  transform: "translate(-50%, -50%)"
                },
                "& .MuiSlider-markActive": {
                  backgroundColor: hl.active
                }
              }
            }
          ),
          /* @__PURE__ */ p.jsx(
            An,
            {
              sx: {
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                pointerEvents: "none"
              },
              children: l.map((y) => {
                const v = b_[y.value] || "", m = c === 0 ? 0 : (y.value - n) / c * 100;
                return /* @__PURE__ */ p.jsx(
                  An,
                  {
                    sx: {
                      position: "absolute",
                      left: `${m}%`,
                      top: "50%",
                      width: 1,
                      height: 1,
                      transform: "translate(-50%, -50%)",
                      zIndex: 3
                    },
                    children: /* @__PURE__ */ p.jsx(
                      wc,
                      {
                        text: v,
                        placement: "top",
                        controlled: !0,
                        show: u === y.value,
                        disableInteractive: !0,
                        popperProps: C_,
                        children: /* @__PURE__ */ p.jsx(
                          An,
                          {
                            component: "span",
                            sx: {
                              display: "inline-flex",
                              width: 1,
                              height: 1,
                              pointerEvents: "none"
                            }
                          }
                        )
                      }
                    )
                  },
                  y.value
                );
              })
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ p.jsxs(
      Tn,
      {
        item: !0,
        xs: 12,
        display: "flex",
        justifyContent: "space-between",
        sx: {
          mt: 1,
          color: hl.labels
        },
        children: [
          /* @__PURE__ */ p.jsx(vo, { variant: "caption", children: i }),
          /* @__PURE__ */ p.jsx(vo, { variant: "caption", children: s })
        ]
      }
    )
  ] });
};
export {
  $_ as AISpinner,
  z4 as Alert,
  Tz as AnalysisIcon,
  z$ as AnalysisIcons,
  NV as ArrowContainer,
  Ph as Autocomplete,
  cz as AutocompleteInput,
  Jb as Avatar,
  Np as Badge,
  mz as BasicPagination,
  R6 as Block,
  xz as BlockTitle,
  An as Box,
  A_ as Breadcrumbs,
  Gs as Button,
  lz as ButtonGroup,
  ii as Checkbox,
  B_ as CheckboxCell,
  HA as CheckboxWithOptions,
  Wh as CheckboxWithOptionsBase,
  Ia as Chip,
  Ta as ClickAwayListener,
  hz as CloseButton,
  Sz as CollapsiblePanel,
  nz as ComparisonIcon,
  _V as Container,
  wz as ContentBlock,
  iN as ControlledTable,
  t_ as Count,
  tz as CriteriaIcon,
  tp as DatePicker,
  Z_ as DateRangeContainer,
  pz as Dialog,
  rg as DialogActions,
  ig as DialogContent,
  Tx as DialogContentText,
  Px as DialogTitle,
  Gl as Divider,
  gh as DropDownMenu,
  Iz as EditableAutocomplete,
  Oz as EditableDatePicker,
  i_ as EditableInput,
  Pz as EditableSelect,
  M6 as EditableWrapper,
  mh as EmptyTableStub,
  rd as FILTERS_WIDTH,
  Q_ as FavoriteIcon,
  cN as FilterPanel,
  Tn as Grid,
  yz as HideButton,
  vz as HideButtonContainer,
  SL as HierarchyIcons,
  qn as Icon,
  n_ as IconActionButton,
  Mz as IconActionButtonFilled,
  kz as IconActionDropdown,
  Ar as IconButton,
  of as Input,
  __ as InputCell,
  Th as InputFilter,
  Bw as ListItemIcon,
  Ww as ListItemText,
  zV as LoaderContainer,
  L_ as LoaderProgress,
  jz as LogoBox,
  X_ as MainMenuIcon,
  Jp as Menu,
  xr as MenuItem,
  Fd as MenuList,
  bz as Modal,
  Cz as ModalTitle,
  _r as MuiTooltip,
  az as NewTable,
  xh as NoDataText,
  dz as NotificationsProvider,
  Mh as OutlinedChip,
  $V as Pagination,
  li as Paper,
  ez as Placeholder,
  Ez as Popover,
  Rz as PopoverContent,
  Hl as Portal,
  od as ROW_COLLAPSE_COLUMN,
  nd as ROW_SELECT_COLUMN,
  DL as Radio,
  JS as Rating,
  Fz as SEARCH_PRECISION_OPTIONS,
  Vz as SearchPrecision,
  Fg as Select,
  sz as SelectAllHeaderCell,
  K_ as SeverityIcons,
  Ca as Skeleton,
  Ig as Slider,
  Vd as Spinner,
  Eh as StatusTag,
  rz as StudyStatusTag,
  J$ as StudyStatuses,
  LV as StyledTable,
  HV as StyledTableCell,
  IL as Switch,
  ZE as Tab,
  N_ as Table,
  BV as TableActions,
  WV as TableCell,
  E5 as TableContainer,
  AV as TableHeadRow,
  S5 as TableRow,
  Sh as TableSkeleton,
  dR as Tabs,
  G_ as TextRow,
  V_ as Textarea,
  F_ as ThemeProvider,
  z_ as TileContainer,
  W_ as TileName,
  H_ as TileRow,
  q_ as TileView,
  wc as Tooltip,
  oz as Torch,
  gz as TreeItem,
  fz as TreeView,
  vo as Typography,
  sN as UncontrolledTable,
  U_ as UserLink,
  Y_ as UserLinkContainer,
  J_ as WelcomePageIcon,
  _$ as analysisIcons,
  WA as arrIncludesSomeEqual,
  kL as comparisonIcons,
  iz as convertColumns,
  Dz as createAppTheme,
  vL as criteriaIcons,
  Az as darken,
  m$ as favoriteIcon,
  Ma as flexRender,
  UA as generateFilters,
  GA as greaterThanZero,
  wL as hierarchyIcons,
  OV as icons,
  Nz as lighten,
  p$ as mainMenuIcons,
  U$ as placeholders,
  Bz as setLightness,
  Q$ as statusesIcons,
  Z as styled,
  so as tooltipClasses,
  _z as transparentize,
  YA as useMergedRef,
  uz as useNotifications,
  to as useTheme,
  GV as useWindowSize,
  T$ as welcomePageIcons
};
//# sourceMappingURL=components.js.map
